import * as React from 'react';
import React__default, { createContext, useContext, useEffect, useState, Component } from 'react';
import { Header as Header$1, Icons, BaseButton, BUTTON_TYPE, SIZE, ActionMenu, FilterChips as FilterChips$1, Selector, TableControls as TableControls$1, SEARCH_TAG_TYPES, ViewSwitch, FilterSection as FilterSection$1, MultiSelectInput as MultiSelectInput$1, RightPanel as RightPanel$1, FILTER_TAG_TYPES } from 'prefab';
import 'antd/lib/date-picker/style';
import _DatePicker from 'antd/lib/date-picker';
import 'antd/lib/select/style';
import _Select from 'antd/lib/select';
import 'antd/lib/input/style';
import _Input from 'antd/lib/input';
import classNames from 'classnames';
import I18n from 'i18n-js';
import _$1, { isNumber as isNumber$1, isEmpty, sum, every, find, map as map$1, groupBy, forEach as forEach$1, keys, lowerCase, isArray as isArray$2 } from 'lodash';
import 'antd/lib/message/style';
import _message from 'antd/lib/message';
import { TablePagination as TablePagination$1, Table } from 'workbench';
import ReactTooltip from 'react-tooltip';
import 'antd/lib/button/style';
import _Button from 'antd/lib/button';
import 'antd/lib/table/style';
import _Table from 'antd/lib/table';
import 'antd/lib/modal/style';
import _Modal from 'antd/lib/modal';
import 'antd/lib/dropdown/style';
import _Dropdown from 'antd/lib/dropdown';
import 'antd/lib/menu/style';
import _Menu from 'antd/lib/menu';
import 'antd/lib/spin/style';
import _Spin from 'antd/lib/spin';
import momentTZ from 'moment-timezone';
import 'antd/lib/row/style';
import _Row from 'antd/lib/row';
import 'antd/lib/col/style';
import _Col from 'antd/lib/col';
import 'antd/lib/checkbox/style';
import _Checkbox from 'antd/lib/checkbox';
import 'antd/lib/breadcrumb/style';
import _Breadcrumb from 'antd/lib/breadcrumb';
import 'antd/lib/progress/style';
import _Progress from 'antd/lib/progress';
import { create as create$1, addDependencies, divideDependencies, bignumberDependencies, multiplyDependencies } from 'mathjs';
import Cookies from 'universal-cookie';
import validator from 'validator';
import 'antd/lib/tag/style';
import _Tag from 'antd/lib/tag';
import isEmpty$1 from 'lodash/isEmpty';

var PrimaryButton = function PrimaryButton(props) {
  return /*#__PURE__*/React__default.createElement("button", {
    className: props.disabled ? 'btn-default primary-btn disabled' : 'btn-default primary-btn',
    onClick: !props.disabled && props.callbackAction,
    style: props.style
  }, props.btnName);
};

PrimaryButton.defaultProps = {
  disabled: false,
  callbackAction: function callbackAction() {}
};

function SecondaryButton(props) {
  var style = props.style,
      callbackAction = props.callbackAction,
      btnName = props.btnName;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "btn-default secondary-btn",
    onClick: callbackAction,
    style: style || {}
  }, btnName);
}

SecondaryButton.defaultProps = {
  style: {}
};

var IconButton = function IconButton(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "icon-button",
    onClick: props.callbackAction
  }, props.icon);
};

IconButton.defaultProps = {
  icon: 'close',
  callbackAction: function callbackAction() {}
};

var DeleteButton = function DeleteButton(props) {
  return /*#__PURE__*/React__default.createElement("button", {
    className: props.disabled ? 'btn-default delete-btn disabled' : 'btn-default delete-btn',
    onClick: !props.disabled && props.clickEvent
  }, props.text);
};

DeleteButton.defaultProps = {
  disabled: false,
  clickEvent: function clickEvent() {}
};

var SVG$p = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M4.5596,18.7675 C5.38847443,18.7675 6.0596,19.4390894 6.0596,20.2675 L6.0596,21.5175 C6.0596,21.7936424 5.83574237,22.0175 5.5596,22.0175 L2.5596,22.0175 C2.28345763,22.0175 2.0596,21.7936424 2.0596,21.5175 L2.0596,20.2685 C2.0596,19.4393576 2.73145763,18.7675 3.5606,18.7675 L4.5596,18.7675 Z M9.7617,18.7675 C10.5905744,18.7675 11.2617,19.4390894 11.2617,20.2675 L11.2617,21.5175 C11.2617,21.7936424 11.0378424,22.0175 10.7617,22.0175 L7.7617,22.0175 C7.48555763,22.0175 7.2617,21.7936424 7.2617,21.5175 L7.2617,20.2685 C7.2617,19.4393576 7.93355763,18.7675 8.7627,18.7675 L9.7617,18.7675 Z M15.2383,18.7675 C16.0664424,18.7675 16.7383,19.4393576 16.7383,20.2675 L16.7383,21.5175 C16.7383,21.7936424 16.5144424,22.0175 16.2383,22.0175 L13.2383,22.0175 C12.9621576,22.0175 12.7383,21.7936424 12.7383,21.5175 L12.7383,20.2685 C12.7383,19.4393576 13.4101576,18.7675 14.2393,18.7675 L15.2383,18.7675 Z M20.4404,18.7675 C21.2692744,18.7675 21.9404,19.4390894 21.9404,20.2675 L21.9404,21.5175 C21.9404,21.7936424 21.7165424,22.0175 21.4404,22.0175 L18.4404,22.0175 C18.1642576,22.0175 17.9404,21.7936424 17.9404,21.5175 L17.9404,20.2685 C17.9404,19.4393576 18.6122576,18.7675 19.4414,18.7675 L20.4404,18.7675 Z M4.5596,19.7675 L3.5606,19.7675 C3.28374237,19.7675 3.0596,19.9916424 3.0596,20.2685 L3.0596,21.0175 L5.0596,21.0175 L5.0596,20.2675 C5.0596,19.9912195 4.83603497,19.7675 4.5596,19.7675 Z M9.7617,19.7675 L8.7627,19.7675 C8.48584237,19.7675 8.2617,19.9916424 8.2617,20.2685 L8.2617,21.0175 L10.2617,21.0175 L10.2617,20.2675 C10.2617,19.9912195 10.038135,19.7675 9.7617,19.7675 Z M15.2383,19.7675 L14.2393,19.7675 C13.9624424,19.7675 13.7383,19.9916424 13.7383,20.2685 L13.7383,21.0175 L15.7383,21.0175 L15.7383,20.2675 C15.7383,19.9916424 15.5141576,19.7675 15.2383,19.7675 Z M20.4404,19.7675 L19.4414,19.7675 C19.1645424,19.7675 18.9404,19.9916424 18.9404,20.2685 L18.9404,21.0175 L20.9404,21.0175 L20.9404,20.2675 C20.9404,19.9912195 20.716835,19.7675 20.4404,19.7675 Z M7.4111,13.994 C8.23951062,13.994 8.9111,14.6651256 8.9111,15.494 L8.9111,16.744 C8.9111,17.0201424 8.68724237,17.244 8.4111,17.244 L5.4111,17.244 C5.13495763,17.244 4.9111,17.0201424 4.9111,16.744 L4.9111,15.495 C4.9111,14.665821 5.58199373,13.994 6.4111,13.994 L7.4111,13.994 Z M12.5,13.994 C13.3291424,13.994 14,14.6648576 14,15.494 L14,16.744 C14,17.0201424 13.7761424,17.244 13.5,17.244 L10.5,17.244 C10.2238576,17.244 10,17.0201424 10,16.744 L10,15.495 C10,14.6658576 10.6718576,13.994 11.501,13.994 L12.5,13.994 Z M17.5889,13.994 C18.4180424,13.994 19.0889,14.6648576 19.0889,15.494 L19.0889,16.744 C19.0889,17.0201424 18.8650424,17.244 18.5889,17.244 L15.5889,17.244 C15.3127576,17.244 15.0889,17.0201424 15.0889,16.744 L15.0889,15.495 C15.0889,14.6658576 15.7607576,13.994 16.5899,13.994 L17.5889,13.994 Z M7.4111,14.994 L6.4111,14.994 C6.13458791,14.994 5.9111,15.2177968 5.9111,15.495 L5.9111,16.244 L7.9111,16.244 L7.9111,15.494 C7.9111,15.217565 7.68738046,14.994 7.4111,14.994 Z M12.5,14.994 L11.501,14.994 C11.2241424,14.994 11,15.2181424 11,15.495 L11,16.244 L13,16.244 L13,15.494 C13,15.2171424 12.7768576,14.994 12.5,14.994 Z M17.5889,14.994 L16.5899,14.994 C16.3130424,14.994 16.0889,15.2181424 16.0889,15.495 L16.0889,16.244 L18.0889,16.244 L18.0889,15.494 C18.0889,15.2171424 17.8657576,14.994 17.5889,14.994 Z M20.5,2 C21.3291424,2 22,2.67085763 22,3.5 L22,11.452 C22,12.2811424 21.3291424,12.952 20.5,12.952 L3.5,12.952 C2.67085763,12.952 2,12.2811424 2,11.452 L2,3.5 C2,2.67085763 2.67085763,2 3.5,2 L20.5,2 Z M20.5,3 L3.5,3 C3.22314237,3 3,3.22314237 3,3.5 L3,11.452 C3,11.7288576 3.22314237,11.952 3.5,11.952 L20.5,11.952 C20.7768576,11.952 21,11.7288576 21,11.452 L21,3.5 C21,3.22314237 20.7768576,3 20.5,3 Z"
  })));
};

var SVG$o = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M19,5 C20.1045695,5 21,5.8954305 21,7 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,7 C3,5.8954305 3.8954305,5 5,5 L19,5 Z M19,6 L5,6 C4.44771525,6 4,6.44771525 4,7 L4,17 C4,17.5522847 4.44771525,18 5,18 L19,18 C19.5522847,18 20,17.5522847 20,17 L20,7 C20,6.44771525 19.5522847,6 19,6 Z M10.7649995,9.07680032 L14.7649995,11.5768003 C15.0783335,11.7726341 15.0783335,12.2289649 14.7649995,12.4247986 L10.7649995,14.9247986 C10.4319755,15.1329386 10,14.8935172 10,14.5007995 L10,9.50079947 C10,9.1080817 10.4319755,8.86866032 10.7649995,9.07680032 Z M11,10.4029233 L11,13.5986757 L13.5566019,12.0007995 L11,10.4029233 Z"
  })));
};

var SVG$n = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 18 18' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "QW-Distributor-Redesign",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Add-to-New-List",
    transform: "translate(-314.000000, -96.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "label-input-copy",
    transform: "translate(21.000000, 69.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "label-input"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "input",
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "input/text-icon/large"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon",
    transform: "translate(290.000000, 4.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/gray/date-range"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4,7 C4,6.28991961 4.28991961,6 5,6 L6,6 C6.23669346,6 6.42857143,5.52240775 6.42857143,5.28571429 C6.42857143,5.04902082 6.23669346,5 6,5 L5,5 C3.81653268,5 3,5.81653268 3,7 L3,19 C3,20.1834673 3.81653268,21 5,21 L19,21 C20.1834673,21 21,20.1834673 21,19 L21,7 C21,5.81653268 20.1834673,5 19,5 L17.5714286,5 C17.3347351,5 17.1428571,5.04902082 17.1428571,5.28571429 C17.1428571,5.52240775 17.3347351,6 17.5714286,6 L19,6 C19.7100804,6 20,6.28991961 20,7 L20,9 L4,9 L4,7 Z M20,10 L20,19 C20,19.7100804 19.7100804,20 19,20 L5,20.0528571 C4.28991961,20.0528571 4,19.7100804 4,19 L4,10 L20,10 Z",
    id: "Shape",
    fill: "#8794A3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18,6 C18.2366935,6 18,5.66526489 18,5.42857143 C18,5.19187796 17.808122,5 17.5714286,5 L5.42857143,5 C5.19187796,5 5,5.19187796 5,5.42857143 C5,5.66526489 5.19187796,6 5.42857143,6 L18,6 Z",
    id: "Shape",
    fill: "#8794A3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8,6.56756757 L8,3.43243243 C8,3.19360659 7.77614237,3 7.5,3 C7.22385763,3 7,3.19360659 7,3.43243243 L7,6.56756757 C7,6.80639341 7.22385763,7 7.5,7 C7.77614237,7 8,6.80639341 8,6.56756757 Z",
    id: "Shape",
    fill: "#8794A3"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17,6.56756757 L17,3.43243243 C17,3.19360659 16.7761424,3 16.5,3 C16.2238576,3 16,3.19360659 16,3.43243243 L16,6.56756757 C16,6.80639341 16.2238576,7 16.5,7 C16.7761424,7 17,6.80639341 17,6.56756757 Z",
    id: "Shape",
    fill: "#8794A3"
  }))))))))));
};

var SVG$m = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '')
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/selected-circle-copy",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/selected-circle"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("circle", {
    id: "Oval-3",
    fill: "#17304D",
    cx: "12",
    cy: "12",
    r: "6"
  }))));
};

var SVG$l = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/partial-circle-copy",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/partial-circle"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12,6 C15.3137085,6 18,8.6862915 18,12 C18,15.2383969 15.4344251,17.8775718 12.2249383,17.9958615 L12,18 L11.7750617,17.9958615 C8.56557489,17.8775718 6,15.2383969 6,12 C6,8.6862915 8.6862915,6 12,6 L12,6 Z M12,7.2 L12,16.8 L12,16.8 C14.6509668,16.8 16.8,14.6509668 16.8,12 C16.8,9.3490332 14.6509668,7.2 12,7.2 Z",
    id: "Combined-Shape",
    fill: "#17304D"
  }))));
};

var SVG$k = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/unselected-circle-copy",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/unselected-circle"
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12,16.8 C14.6509668,16.8 16.8,14.6509668 16.8,12 C16.8,9.3490332 14.6509668,7.2 12,7.2 C9.3490332,7.2 7.2,9.3490332 7.2,12 C7.2,14.6509668 9.3490332,16.8 12,16.8 Z M12,18 C8.6862915,18 6,15.3137085 6,12 C6,8.6862915 8.6862915,6 12,6 C15.3137085,6 18,8.6862915 18,12 C18,15.3137085 15.3137085,18 12,18 Z",
    id: "Oval-3",
    fill: "#17304D",
    "fill-rule": "nonzero"
  }))));
};

var SVG$j = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/black/error",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.9820144,13.971223 L13.3705036,6 L10.6079137,6 L11.0179856,13.971223 L12.9820144,13.971223 Z M12.0107914,18.611223 C12.8309353,18.611223 13.5,17.9205755 13.5,17.1004317 C13.5,16.3018705 12.8309353,15.611223 12.0107914,15.611223 C11.1906475,15.611223 10.5,16.3018705 10.5,17.1004317 C10.5,17.9205755 11.1906475,18.611223 12.0107914,18.611223 Z",
    id: "!",
    fill: "#17304D",
    "fill-rule": "nonzero"
  }))));
};

var SVG$i = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/primary/edit",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle-53",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.0519038,4.15 C15.6794629,4.15 15.3302168,4.29486575 15.0657511,4.55868669 L5.05197798,14.5727364 C4.98324829,14.6414632 4.93769074,14.7294185 4.9215385,14.824474 L4.15664822,19.3030058 C4.13116097,19.4527371 4.17985388,19.6056523 4.2875827,19.713112 C4.37507815,19.8008665 4.49433719,19.85 4.61824813,19.85 C4.6448076,19.85 4.6712854,19.8477992 4.69699264,19.8433851 L9.17551637,19.0793221 C9.27177766,19.062477 9.36016341,19.0168405 9.42822572,18.9487811 L19.442376,8.93505434 C19.9858849,8.39188437 19.9858849,7.50635631 19.4423297,6.96250806 L17.0388879,4.55846759 C16.7747968,4.29502103 16.4245629,4.15 16.0519038,4.15 Z M9.27908803,17.5615114 L6.43896529,14.7211587 L13.8674633,7.29332487 L16.7079361,10.1333275 L9.27908803,17.5615114 Z M5.84419535,15.8742425 L8.12665563,18.1566062 L5.37440061,18.6267311 L5.84419535,15.8742425 Z M18.6742827,8.16741418 L17.5820624,9.25958825 L14.7415896,6.41923557 L15.8338098,5.32671144 C15.9125757,5.24794889 16.0046443,5.23639705 16.0519038,5.23639705 C16.1002136,5.23639705 16.1922821,5.24829895 16.270698,5.32671144 L18.6742827,7.72984444 C18.7947069,7.85026364 18.7947069,8.04664493 18.6742827,8.16741418 Z",
    id: "Shape",
    fill: "#084782"
  }))));
};

var SVG$h = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    d: "M16.0519038,4.15 C15.6794629,4.15 15.3302168,4.29486575 15.0657511,4.55868669 L5.05197798,14.5727364 C4.98324829,14.6414632 4.93769074,14.7294185 4.9215385,14.824474 L4.15664822,19.3030058 C4.13116097,19.4527371 4.17985388,19.6056523 4.2875827,19.713112 C4.37507815,19.8008665 4.49433719,19.85 4.61824813,19.85 C4.6448076,19.85 4.6712854,19.8477992 4.69699264,19.8433851 L9.17551637,19.0793221 C9.27177766,19.062477 9.36016341,19.0168405 9.42822572,18.9487811 L19.442376,8.93505434 C19.9858849,8.39188437 19.9858849,7.50635631 19.4423297,6.96250806 L17.0388879,4.55846759 C16.7747968,4.29502103 16.4245629,4.15 16.0519038,4.15 Z M9.27908803,17.5615114 L6.43896529,14.7211587 L13.8674633,7.29332487 L16.7079361,10.1333275 L9.27908803,17.5615114 Z M5.84419535,15.8742425 L8.12665563,18.1566062 L5.37440061,18.6267311 L5.84419535,15.8742425 Z M18.6742827,8.16741418 L17.5820624,9.25958825 L14.7415896,6.41923557 L15.8338098,5.32671144 C15.9125757,5.24794889 16.0046443,5.23639705 16.0519038,5.23639705 C16.1002136,5.23639705 16.1922821,5.24829895 16.270698,5.32671144 L18.6742827,7.72984444 C18.7947069,7.85026364 18.7947069,8.04664493 18.6742827,8.16741418 Z"
  })));
};

var SVG$g = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 11' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "#084782"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M4.79289322 10.5L2 10.5C1.72385763 10.5 1.5 10.2761424 1.5 10L1.5 6C1.5 5.72385763 1.72385763 5.5 2 5.5L4.79289322 5.5 7.64644661 2.64644661C7.96142904 2.33146418 8.5 2.55454757 8.5 3L8.5 13C8.5 13.4454524 7.96142904 13.6685358 7.64644661 13.3535534L4.79289322 10.5zM2.5 9.5L5 9.5C5.13260824 9.5 5.2597852 9.55267842 5.35355339 9.64644661L7.5 11.7928932 7.5 4.20710678 5.35355339 6.35355339C5.2597852 6.44732158 5.13260824 6.5 5 6.5L2.5 6.5 2.5 9.5zM11.6464466 4.35355339C14.1178511 6.82495791 14.1178511 9.17504209 11.6464466 11.6464466 11.4511845 11.8417088 11.4511845 12.1582912 11.6464466 12.3535534 11.8417088 12.5488155 12.1582912 12.5488155 12.3535534 12.3535534 15.2154822 9.49162458 15.2154822 6.50837542 12.3535534 3.64644661 12.1582912 3.45118446 11.8417088 3.45118446 11.6464466 3.64644661 11.4511845 3.84170876 11.4511845 4.15829124 11.6464466 4.35355339z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.64644661,6.35355339 C10.7845178,7.49162458 10.7845178,8.50837542 9.64644661,9.64644661 C9.45118446,9.84170876 9.45118446,10.1582912 9.64644661,10.3535534 C9.84170876,10.5488155 10.1582912,10.5488155 10.3535534,10.3535534 C11.8821489,8.82495791 11.8821489,7.17504209 10.3535534,5.64644661 C10.1582912,5.45118446 9.84170876,5.45118446 9.64644661,5.64644661 C9.45118446,5.84170876 9.45118446,6.15829124 9.64644661,6.35355339 Z"
  })));
};

var SVG$f = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 11' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "evenodd",
    d: "M1.3298479,10.2257209 C1.7553261,10.5502381 2.3106112,10.75216 3.0245492,10.75216 C4.32261829,10.75216 4.88511489,10.067068 4.88511489,9.26659205 C4.88511489,8.22092528 3.94040906,7.97573446 3.14714462,7.7738126 C2.57743652,7.6295827 2.08705486,7.50698729 2.08705486,7.13198955 C2.08705486,6.7714148 2.40436064,6.53343547 2.97406874,6.53343547 C3.34185498,6.53343547 3.74569869,6.6416079 4.09185045,6.87237573 C4.14954241,6.9156447 4.22886885,6.94449068 4.31540679,6.94449068 C4.53175164,6.94449068 4.71203901,6.76420331 4.71203901,6.54785846 C4.71203901,6.41084006 4.63992406,6.28824464 4.53175164,6.22334119 C4.06300447,5.9276699 3.60868029,5.78344 3.04618369,5.78344 C1.92119048,5.78344 1.22167547,6.39641707 1.22167547,7.18968151 C1.22167547,8.20650229 2.14474682,8.43727013 2.93079977,8.63198049 C3.51493086,8.78342189 4.026947,8.9132288 4.026947,9.34591849 C4.026947,9.66322427 3.75291019,10.0021645 3.06060668,10.0021645 C2.55580203,10.0021645 2.14474682,9.82908865 1.81301806,9.58389782 C1.7481146,9.53341736 1.66157666,9.50457138 1.56782723,9.50457138 C1.35148238,9.50457138 1.17119501,9.68485875 1.17119501,9.90841509 C1.17119501,10.038222 1.23609846,10.1536059 1.3298479,10.2257209 Z M5.66395634,8.7689989 C5.66395634,9.95168406 6.34904836,10.75216 7.74807837,10.75216 C9.13989689,10.75216 9.82498891,9.95889556 9.82498891,8.7617874 L9.82498891,6.23776418 C9.82498891,6.00699634 9.63749004,5.81228598 9.39951071,5.81228598 C9.16153138,5.81228598 8.97403251,6.00699634 8.97403251,6.23776418 L8.97403251,8.74015292 C8.97403251,9.50457138 8.54855431,10.0021645 7.74807837,10.0021645 C6.94039094,10.0021645 6.51491274,9.50457138 6.51491274,8.74015292 L6.51491274,6.23776418 C6.51491274,6.00699634 6.32741388,5.81228598 6.08943454,5.81228598 C5.85145521,5.81228598 5.66395634,6.00699634 5.66395634,6.23776418 L5.66395634,8.7689989 Z M11.2961339,10.6656221 C11.0076741,10.6656221 10.8490212,10.5069692 10.8490212,10.2185094 L10.8490212,6.30266763 C10.8490212,6.01420784 11.0076741,5.85555495 11.2961339,5.85555495 L13.2143915,5.85555495 C14.0941939,5.85555495 14.5845756,6.40362856 14.5845756,7.08150909 C14.5845756,7.68727466 14.1951548,8.09111837 13.7480421,8.18486781 C14.2600583,8.26419425 14.678325,8.77621039 14.678325,9.36755298 C14.678325,10.110337 14.1807318,10.6656221 13.279295,10.6656221 L11.2961339,10.6656221 Z M11.6927661,7.84592755 L13.0413156,7.84592755 C13.4740053,7.84592755 13.7191962,7.58631373 13.7191962,7.22573898 C13.7191962,6.86516424 13.4740053,6.59833893 13.0413156,6.59833893 L11.6927661,6.59833893 L11.6927661,7.84592755 Z M11.6927661,9.92283808 L13.0773731,9.92283808 C13.5389088,9.92283808 13.8129456,9.67043576 13.8129456,9.25216906 C13.8129456,8.89159431 13.5605433,8.58871152 13.0773731,8.58871152 L11.6927661,8.58871152 L11.6927661,9.92283808 Z"
  }));
};

var SVG$e = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 11' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "evenodd",
    d: "M5.58132927,10.79035 C6.42028579,10.79035 6.98735825,10.4718572 7.3990684,10.0213065 C7.46898144,9.95139348 7.50782202,9.84263986 7.50782202,9.73388623 C7.50782202,9.50084275 7.31361912,9.30663986 7.08057564,9.30663986 C6.94851767,9.30663986 6.83976405,9.36878478 6.76208289,9.45423406 C6.4746626,9.78049493 6.06295246,9.98246594 5.58132927,9.98246594 C4.59477854,9.98246594 3.83350318,9.19788623 3.83350318,8.11035 C3.83350318,7.02281377 4.59477854,6.23823406 5.58132927,6.23823406 C6.06295246,6.23823406 6.4746626,6.44797319 6.75431477,6.76646594 C6.83199593,6.85968333 6.94851767,6.91406014 7.08057564,6.91406014 C7.31361912,6.91406014 7.50782202,6.71985725 7.50782202,6.48681377 C7.50782202,6.37806014 7.46898144,6.26930652 7.3990684,6.19939348 C6.98735825,5.74884275 6.41251767,5.43035 5.58132927,5.43035 C4.08985101,5.43035 2.90132927,6.51788623 2.90132927,8.11035 C2.90132927,9.70281377 4.08985101,10.79035 5.58132927,10.79035 Z M10.974128,10.79035 C11.8130845,10.79035 12.380157,10.4718572 12.7918671,10.0213065 C12.8617802,9.95139348 12.9006207,9.84263986 12.9006207,9.73388623 C12.9006207,9.50084275 12.7064178,9.30663986 12.4733744,9.30663986 C12.3413164,9.30663986 12.2325628,9.36878478 12.1548816,9.45423406 C11.8674613,9.78049493 11.4557512,9.98246594 10.974128,9.98246594 C9.98757726,9.98246594 9.22630189,9.19788623 9.22630189,8.11035 C9.22630189,7.02281377 9.98757726,6.23823406 10.974128,6.23823406 C11.4557512,6.23823406 11.8674613,6.44797319 12.1471135,6.76646594 C12.2247946,6.85968333 12.3413164,6.91406014 12.4733744,6.91406014 C12.7064178,6.91406014 12.9006207,6.71985725 12.9006207,6.48681377 C12.9006207,6.37806014 12.8617802,6.26930652 12.7918671,6.19939348 C12.380157,5.74884275 11.8053164,5.43035 10.974128,5.43035 C9.48264972,5.43035 8.29412798,6.51788623 8.29412798,8.11035 C8.29412798,9.70281377 9.48264972,10.79035 10.974128,10.79035 Z"
  }));
};

var SVG$d = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 11' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "8.04",
    cy: "5.695",
    r: "4.02",
    stroke: "#084782",
    strokeLinecap: "square"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M3.18966074,11.2701443 L4.67152697,11.0088513 C4.94347413,10.9608997 5.20280332,11.1424839 5.25075494,11.4144311 L5.50415279,12.8515217 L7.32906953,10.2008919 L4.9059371,8.71673068 L3.18966074,11.2701443 Z M2.20589031,12.4590362 C1.77171993,12.5355921 1.45815737,12.0536048 1.70409421,11.6877089 L4.34337905,7.76107686 C4.67152697,7.76107686 8.61437233,10.0974553 8.45183185,10.3335398 L5.63555984,14.4240796 C5.38187026,14.7925551 4.80900788,14.6679295 4.73132431,14.2273641 L4.35277128,12.0804831 L2.20589031,12.4590362 Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M8.71643142,10.0040524 L10.5204501,12.6243285 L10.7738479,11.1872379 C10.8217996,10.9152907 11.0811288,10.7337065 11.3530759,10.7816581 L12.8262565,11.0414196 L11.2271077,8.6896535 L8.71643142,10.0040524 Z M11.2932786,14.0001709 C11.215595,14.4407363 10.6427326,14.5653619 10.3890431,14.1968864 L7.57277104,10.1063467 C7.40264196,9.85923993 11.2932786,8 11.8034678,7.75885146 L14.3190042,11.4582904 C14.5676276,11.8239249 14.2541515,12.3086226 13.8187126,12.231843 L11.6718316,11.8532899 L11.2932786,14.0001709 Z"
  })));
};

var SVG$c = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Booking-History---Internal",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1138.000000, -81.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "page-header/booking-history",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/primary/search",
    transform: "translate(1135.000000, 18.000000)"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13.5839466,14.2910534 L19.5839466,20.2910534 C19.7792088,20.4863155 20.0957912,20.4863155 20.2910534,20.2910534 C20.4863155,20.0957912 20.4863155,19.7792088 20.2910534,19.5839466 L14.2910534,13.5839466 C14.0957912,13.3886845 13.7792088,13.3886845 13.5839466,13.5839466 C13.3886845,13.7792088 13.3886845,14.0957912 13.5839466,14.2910534 Z",
    id: "Stroke-55",
    fill: "#084782",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16,9.5 C16,13.0891424 13.0891424,16 9.5,16 C5.91085763,16 3,13.0891424 3,9.5 C3,5.91085763 5.91085763,3 9.5,3 C13.0891424,3 16,5.91085763 16,9.5 Z M15,9.5 C15,6.46314237 12.5368576,4 9.5,4 C6.46314237,4 4,6.46314237 4,9.5 C4,12.5368576 6.46314237,15 9.5,15 C12.5368576,15 15,12.5368576 15,9.5 Z",
    id: "Stroke-56",
    fill: "#084782",
    fillRule: "nonzero"
  }))))));
};

var SVG$b = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon centered-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("g", {
    fill: "#084782",
    fillRule: "nonzero",
    transform: "translate(8 4)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M3.64644661,9.14644661 L6.64644661,6.14644661 C6.84170876,5.95118446 7.15829124,5.95118446 7.35355339,6.14644661 C7.54881554,6.34170876 7.54881554,6.65829124 7.35355339,6.85355339 L4.35355339,9.85355339 C4.15829124,10.0488155 3.84170876,10.0488155 3.64644661,9.85355339 C3.45118446,9.65829124 3.45118446,9.34170876 3.64644661,9.14644661 Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.64644661,9.85355339 L0.646446609,6.85355339 C0.451184464,6.65829124 0.451184464,6.34170876 0.646446609,6.14644661 C0.841708755,5.95118446 1.15829124,5.95118446 1.35355339,6.14644661 L4.35355339,9.14644661 C4.54881554,9.34170876 4.54881554,9.65829124 4.35355339,9.85355339 C4.15829124,10.0488155 3.84170876,10.0488155 3.64644661,9.85355339 Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.5,8.41666667 L3.5,0.583333333 C3.5,0.261167229 3.72385763,0 4,0 C4.27614237,0 4.5,0.261167229 4.5,0.583333333 L4.5,8.41666667 C4.5,8.73883277 4.27614237,9 4,9 C3.72385763,9 3.5,8.73883277 3.5,8.41666667 Z"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: "#084782",
    fillRule: "nonzero",
    d: "M21,12.5 C21,17.7352012 21.1953793,17.4942922 17.0338715,17.4999598 L12.4953045,17.5 C12.4249533,17.5 12.3548402,17.4981793 12.2850072,17.4945512 C12.1598862,17.4981569 12.0850248,17.5 12.0099226,17.5 L7.49007744,17.5 C2.27658101,17.5 2.50417517,17.7199366 2.5041397,12.6986005 C2.50346009,12.625917 2.50346009,12.625917 2.50179258,12.57656 C2.50035572,12.5327327 2.50035572,12.5327327 2.5,12.5 C2.5,12.2238576 2.27614237,12 2,12 C1.72385763,12 1.5,12.2238576 1.5,12.5 C1.50067918,12.5604825 1.50067918,12.5604825 1.50234703,12.6098554 C1.50378387,12.6536783 1.50378387,12.6536783 1.50413961,12.6863798 C1.50417913,18.2800272 1.73181074,18.5 7.49007744,18.5 L12.0099226,18.5 C12.1014337,18.5 12.1926995,18.497753 12.2836644,18.4932723 C12.3202335,18.4977301 12.4076472,18.5 12.4953045,18.5 L17.0046955,18.5 C21.7996831,18.4934702 22,18.246473 22,12.5 C22,12.2238576 21.7761424,12 21.5,12 C21.2238576,12 21,12.2238576 21,12.5 Z"
  })));
};

var SVG$a = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon centered-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("polyline", {
    stroke: "#084782",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "3 7 12 13 21 7"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: "19",
    height: "12",
    x: "2.5",
    y: "6",
    stroke: "#084782",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    rx: "1"
  })));
};

var SVG$9 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '32' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon centered-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "50",
    cy: "50",
    fill: "none",
    ngattrstroke: "{{config.color}}",
    ngattrstrokewidth: "{{config.width}}",
    ngattrr: "{{config.radius}}",
    ngattrstrokedasharray: "{{config.dasharray}}",
    stroke: "#084782",
    strokeWidth: "2",
    r: "24",
    strokeDasharray: "70.68583470577033 25.561944901923447",
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React__default.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    dur: "1.5s",
    begin: "0s",
    repeatCount: "indefinite"
  })));
};

var SVG$8 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '')
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/square-empty",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.2857143,6 C17.2324881,6 18,6.76751186 18,7.71428571 L18,16.2857143 C18,17.2324881 17.2324881,18 16.2857143,18 L7.71428571,18 C6.76751186,18 6,17.2324881 6,16.2857143 L6,7.71428571 C6,6.76751186 6.76751186,6 7.71428571,6 L16.2857143,6 Z M16.2857143,7.28571429 L7.71428571,7.28571429 C7.50389152,7.28571429 7.32890711,7.43732157 7.29261915,7.63724946 L7.28571429,7.71428571 L7.28571429,16.2857143 C7.28571429,16.4961085 7.43732157,16.6710929 7.63724946,16.7073809 L7.71428571,16.7142857 L16.2857143,16.7142857 C16.4961085,16.7142857 16.6710929,16.5626784 16.7073809,16.3627505 L16.7142857,16.2857143 L16.7142857,7.71428571 C16.7142857,7.50389152 16.5626784,7.32890711 16.3627505,7.29261915 L16.2857143,7.28571429 Z",
    id: "Combined-Shape",
    fill: "#17304D",
    "fill-rule": "nonzero"
  }))));
};

var SVG$7 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '')
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/square-half-filled",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.71428571,18 C6.76751186,18 6,17.2324881 6,16.2857143 L6,7.71428571 C6,6.76751186 6.76751186,6 7.71428571,6 L16.2857143,6 C17.2324881,6 18,6.76751186 18,7.71428571 L18,16.2857143 C18,17.2324881 17.2324881,18 16.2857143,18 L7.71428571,18 Z M16.2857143,7.28571429 L12,7.285 L12,16.714 L16.2857143,16.7142857 C16.4961085,16.7142857 16.6710929,16.5626784 16.7073809,16.3627505 L16.7142857,16.2857143 L16.7142857,7.71428571 C16.7142857,7.50389152 16.5626784,7.32890711 16.3627505,7.29261915 L16.2857143,7.28571429 Z",
    id: "Combined-Shape",
    fill: "#17304D",
    "fill-rule": "nonzero"
  }))));
};

var SVG$6 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || '')
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/16px/black/square-filled",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("rect", {
    id: "Rectangle",
    fill: "#17304D",
    "fill-rule": "nonzero",
    x: "6",
    y: "6",
    width: "12",
    height: "12",
    rx: "1.71428571"
  }))));
};

var SVG$5 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/black/chevron-down",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.56568542,9.43431458 L12.5656854,14.4343146 C13.3199327,15.1885618 12.1885618,16.3199327 11.4343146,15.5656854 L6.43431458,10.5656854 C5.68006734,9.81143819 6.81143819,8.68006734 7.56568542,9.43431458 Z",
    id: "Line-2-Copy",
    fill: "#17304D",
    "fill-rule": "nonzero"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.4343146,9.43431458 L11.4343146,14.4343146 C10.6800673,15.1885618 11.8114382,16.3199327 12.5656854,15.5656854 L17.5656854,10.5656854 C18.3199327,9.81143819 17.1885618,8.68006734 16.4343146,9.43431458 Z",
    id: "Line-2-Copy-2",
    fill: "#17304D",
    "fill-rule": "nonzero"
  }))));
};

var SVG$4 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/black/chevron-right",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) "
  }, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.56568542,9.43431458 L12.5656854,14.4343146 C13.3199327,15.1885618 12.1885618,16.3199327 11.4343146,15.5656854 L6.43431458,10.5656854 C5.68006734,9.81143819 6.81143819,8.68006734 7.56568542,9.43431458 Z",
    id: "Line-2-Copy",
    fill: "#17304D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.4343146,9.43431458 L11.4343146,14.4343146 C10.6800673,15.1885618 11.8114382,16.3199327 12.5656854,15.5656854 L17.5656854,10.5656854 C18.3199327,9.81143819 17.1885618,8.68006734 16.4343146,9.43431458 Z",
    id: "Line-2-Copy-2",
    fill: "#17304D",
    fillRule: "nonzero"
  }))));
};

var SVG$3 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M15.3801 7.5637L10.3801 12.5637C9.62586 13.3179 8.49449 12.1866 9.24874 11.4323L14.2487 6.43233C15.003 5.67808 16.1344 6.80945 15.3801 7.5637Z",
    fill: "#17304D"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.3801 16.4323L10.3801 11.4323C9.62586 10.6781 8.49449 11.8095 9.24874 12.5637L14.2487 17.5637C15.003 18.3179 16.1344 17.1866 15.3801 16.4323Z",
    fill: "#17304D"
  }));
};

var SVG$2 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "icon/24px/black/info",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "bounds",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12,19.1111111 C15.9273582,19.1111111 19.1111111,15.9273582 19.1111111,12 C19.1111111,8.07264178 15.9273582,4.88888889 12,4.88888889 C8.07264178,4.88888889 4.88888889,8.07264178 4.88888889,12 C4.88888889,15.9273582 8.07264178,19.1111111 12,19.1111111 Z M12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 Z",
    id: "Combined-Shape",
    fill: "#17304D",
    "fill-rule": "nonzero"
  })), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.75,13.25 L12.75,8.75 C12.75,8.33578644 12.4142136,8 12,8 C11.5857864,8 11.25,8.33578644 11.25,8.75 L11.25,13.25 C11.25,13.6642136 11.5857864,14 12,14 C12.4142136,14 12.75,13.6642136 12.75,13.25 Z M12.0071942,17 C12.5539568,17 13,16.5395683 13,15.9928058 C13,15.4604317 12.5539568,15 12.0071942,15 C11.4604317,15 11,15.4604317 11,15.9928058 C11,16.5395683 11.4604317,17 12.0071942,17 Z",
    id: "!",
    fill: "#17304D",
    "fill-rule": "nonzero",
    transform: "translate(12.000000, 12.500000) rotate(-180.000000) translate(-12.000000, -12.500000) "
  })));
};

var SVG$1 = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#000000",
    "fill-rule": "nonzero",
    d: "M9.94899505,11.8610422 L9.94899505,17.3002481 C9.94899505,17.4193548 10.0289088,17.5781638 10.1487794,17.617866 L13.465199,19.9205955 C13.5451127,19.9602978 13.5850696,20 13.6649833,20 C13.744897,20 13.7848539,20 13.8647676,19.9602978 C13.9846382,19.8808933 14.0645519,19.7617866 14.0645519,19.6029777 L14.0645519,11.8610422 L19.8582971,5.34987593 C20.0181245,5.0719603 20.0580814,4.7146402 19.8982539,4.43672457 C19.7384265,4.15880893 19.4587284,4 19.0991167,4 L4.91443032,4 C4.59477541,4 4.27512051,4.15880893 4.11529306,4.43672457 C3.95546561,4.7146402 3.95546561,5.0719603 4.15524992,5.34987593 L9.94899505,11.8610422 Z M4.83451659,4.8337469 C4.83451659,4.79404467 4.87447346,4.79404467 4.91443032,4.79404467 L19.1390735,4.79404467 C19.1790304,4.79404467 19.2189873,4.8337469 19.2189873,4.8337469 C19.2189873,4.87344913 19.2589441,4.87344913 19.2189873,4.91315136 L13.3852853,11.5037221 C13.3453284,11.5831266 13.3053715,11.662531 13.3053715,11.7419355 L13.3053715,18.8486352 L10.7880892,17.101737 L10.7880892,11.7419355 C10.7880892,11.662531 10.7481323,11.5831266 10.7081754,11.5037221 L4.83451659,4.9528536 C4.83451659,4.91315136 4.83451659,4.87344913 4.83451659,4.8337469 Z"
  })));
};

var SVG = function SVG(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
      _ref.fill;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color;
      _ref.viewBox;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: size,
    style: style,
    height: size,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    className: "app-svg-icon ".concat(color || ''),
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M129.325047,200.918899 L168.394797,363.987712 L168.77614,365.431247 C173.311105,381.115626 189.078389,390.799754 205.114474,387.758172 L206.618309,387.435536 L208.287851,386.987166 C216.547663,384.525928 223.453543,378.803306 227.406318,371.14447 L228.157024,369.587279 L251.352823,317.922665 L277.174715,372.579552 L277.863996,373.953029 C285.524579,388.349786 302.923557,394.584178 317.984177,388.32887 L319.388891,387.705712 L320.948141,386.915891 C327.591249,383.317617 332.733164,377.46226 335.442953,370.409919 L336.024691,368.76169 L372.513904,255.51361 L459.724336,255.51361 L435.822495,395.953598 C430.057929,429.81959 400.711755,454.592647 366.358653,454.592647 L102.462973,454.592647 C63.5473474,454.592647 32,423.045299 32,384.129674 C32,380.167284 32.3342284,376.211955 32.9991307,372.30575 L62.1651986,200.925945 L129.325047,200.918899 Z M409.537027,60 C448.452653,60 480,91.5473474 480,130.462973 C480,134.425362 479.665772,138.380692 479.000869,142.286897 L468.116477,206.189529 L369.954758,206.191366 L368.153761,206.226517 C349.613421,206.951041 333.324214,218.815679 326.947593,236.240026 L326.361703,237.943421 L302.741469,311.221636 L279.617157,262.275462 L278.831334,260.72365 C275.801417,255.126602 271.155666,250.569781 265.501108,247.648597 L263.9344,246.89291 L262.517906,246.297015 C247.339211,240.33393 230.063966,246.903402 222.683038,261.445516 L222.02043,262.832057 L204.318789,302.244654 L176.646381,186.731466 L176.204077,185.028921 C170.847388,165.913398 153.74901,152.414803 133.916233,151.637304 L132.105971,151.601864 L70.5643849,151.601864 L76.1775053,118.639049 C81.9420715,84.7730569 111.288245,60 145.641347,60 L409.537027,60 Z",
    id: "Combined-Shape",
    fill: "#084782",
    "fill-rule": "nonzero"
  })));
};

var Icon$4 = function Icon(props) {
  switch (props.name) {
    case 'theatre':
      return /*#__PURE__*/React__default.createElement(SVG$p, props);

    case 'movie':
      return /*#__PURE__*/React__default.createElement(SVG$o, props);

    case 'search':
      return /*#__PURE__*/React__default.createElement(SVG$c, props);

    case 'calendar':
      return /*#__PURE__*/React__default.createElement(SVG$n, props);

    case 'SelectedFull':
      return /*#__PURE__*/React__default.createElement(SVG$m, props);

    case 'SelectedEmpty':
      return /*#__PURE__*/React__default.createElement(SVG$k, props);

    case 'AssestError':
      return /*#__PURE__*/React__default.createElement(SVG$j, props);

    case 'SelectedPartial':
      return /*#__PURE__*/React__default.createElement(SVG$l, props);

    case 'ListEdit':
      return /*#__PURE__*/React__default.createElement(SVG$i, props);

    case 'edit':
      return /*#__PURE__*/React__default.createElement(SVG$h, props);

    case 'audio':
      return /*#__PURE__*/React__default.createElement(SVG$g, props);

    case 'subtitle':
      return /*#__PURE__*/React__default.createElement(SVG$f, props);

    case 'captions':
      return /*#__PURE__*/React__default.createElement(SVG$e, props);

    case 'certifications':
      return /*#__PURE__*/React__default.createElement(SVG$d, props);

    case 'search':
      return /*#__PURE__*/React__default.createElement(SVG$c, props);

    case 'download':
      return /*#__PURE__*/React__default.createElement(SVG$b, props);

    case 'email':
      return /*#__PURE__*/React__default.createElement(SVG$a, props);

    case 'loading':
      return /*#__PURE__*/React__default.createElement(SVG$9, props);

    case 'SquareEmpty':
      return /*#__PURE__*/React__default.createElement(SVG$8, props);

    case 'SquareHalfFilled':
      return /*#__PURE__*/React__default.createElement(SVG$7, props);

    case 'SquareFilled':
      return /*#__PURE__*/React__default.createElement(SVG$6, props);

    case 'ChevronDown':
      return /*#__PURE__*/React__default.createElement(SVG$5, props);

    case 'ChevronRight':
      return /*#__PURE__*/React__default.createElement(SVG$4, props);

    case 'ChevronLeft':
      return /*#__PURE__*/React__default.createElement(SVG$3, props);

    case 'InfoCircle':
      return /*#__PURE__*/React__default.createElement(SVG$2, props);

    case 'Filter':
      return /*#__PURE__*/React__default.createElement(SVG$1, props);

    case 'WireTap':
      return /*#__PURE__*/React__default.createElement(SVG, props);

    default:
      return /*#__PURE__*/React__default.createElement("div", null);
  }
};

var AppIcon = function AppIcon(_ref) {
  var color = _ref.color,
      name = _ref.name,
      size = _ref.size,
      style = _ref.style;
  return /*#__PURE__*/React__default.createElement(Icon$4, {
    name: name,
    size: size,
    color: color,
    style: style
  });
};

AppIcon.defaultProps = {
  name: 'theatre',
  size: 24,
  color: '',
  style: {}
};

var SelectButton = function SelectButton(_ref) {
  var clickEvent = _ref.clickEvent,
      text = _ref.text,
      type = _ref.type;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "button-primary select-button",
    onClick: clickEvent && clickEvent
  }, type && /*#__PURE__*/React__default.createElement("span", {
    className: "icon-style"
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    name: type,
    color: "white",
    size: 18
  })), text && /*#__PURE__*/React__default.createElement("span", {
    className: "button-text-style"
  }, text));
};

SelectButton.defaultProps = {
  clickEvent: function clickEvent() {},
  type: 'theatre',
  text: ''
};

var PageHeading = function PageHeading(props) {
  return /*#__PURE__*/React__default.createElement("h2", {
    className: "page-heading ".concat(props.noCapitalize ? "" : "capitalize")
  }, props.content);
};

var SectionHeading = function SectionHeading(props) {
  return /*#__PURE__*/React__default.createElement("h4", {
    className: props.size ? "section-heading ".concat(props.size) : 'section-heading'
  }, props.content);
};

SectionHeading.defaultProps = {
  size: 'default'
};

var WarnHeading = function WarnHeading(props) {
  return /*#__PURE__*/React__default.createElement("h5", {
    className: "warn-heading"
  }, props.content);
};

var TheatreName = function TheatreName(props) {
  return /*#__PURE__*/React__default.createElement("h2", {
    className: "theatre-name ".concat(props.capitalize ? "capitalize" : "")
  }, props.name);
};

var Header = function Header(props) {
  return /*#__PURE__*/React__default.createElement(Header$1, props);
};

var InputLabel = function InputLabel(props) {
  return /*#__PURE__*/React__default.createElement("label", {
    className: "input-label"
  }, props.content);
};

var HelpText = function HelpText(props) {
  return /*#__PURE__*/React__default.createElement("p", {
    className: props.isErrorMessage ? 'help-txt error-txt' : 'help-txt'
  }, props.content, ' ', /*#__PURE__*/React__default.createElement("span", {
    className: "bold-txt"
  }, props.boldcontent));
};

var TheatreAddress = function TheatreAddress(props) {
  return /*#__PURE__*/React__default.createElement("p", {
    className: "theatre-address"
  }, props.address);
};

var TheatrePrice = function TheatrePrice(props) {
  return /*#__PURE__*/React__default.createElement("p", {
    className: "theatre-price"
  }, "USD", props.price ? props.price : '');
};

var Title = function Title(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return props.clickEvent && props.clickEvent();
    },
    className: "qw-title-text".concat(props.clickEvent ? ' qw-text-cursor' : '')
  }, text && text);
};

var Description = function Description(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return props.clickEvent && props.clickEvent();
    },
    className: "qw-description-text".concat(props.clickEvent ? ' qw-text-cursor' : '')
  }, text && text);
};

var Label = function Label(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return props.clickEvent && props.clickEvent();
    },
    className: "qw-label-text".concat(props.clickEvent ? ' qw-text-cursor' : '')
  }, text && text);
};

var SelectText = function SelectText(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: props.clickEvent && props.clickEvent,
    className: "qw-select-text".concat(props.clickEvent ? ' qw-text-cursor' : '')
  }, text && text);
};

var HeaderText = function HeaderText(props) {
  var text = props.text;
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick() {
      return props.clickEvent && props.clickEvent();
    },
    className: "qw-header-text".concat(props.clickEvent ? ' qw-text-cursor' : '')
  }, text && text);
};

var TheatreId = function TheatreId(props) {
  return props.domain && props.id ? /*#__PURE__*/React__default.createElement("p", {
    className: "theatre-id"
  }, props.domain.toUpperCase(), ": ", props.id) : props.id ? /*#__PURE__*/React__default.createElement("p", {
    className: "theatre-id"
  }, "Theatre ID: ", props.id) : null;
};

var DefaultDatePicker = function DefaultDatePicker(_ref) {
  var size = _ref.size,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      disabledDate = _ref.disabledDate,
      format = _ref.format,
      value = _ref.value;
  return /*#__PURE__*/React__default.createElement(_DatePicker, {
    className: 'date-picker',
    size: size,
    onChange: onChange,
    disabledDate: disabledDate,
    format: format,
    value: value,
    placeholder: placeholder
  });
};

DefaultDatePicker.defaultProps = {
  size: 'default',
  disabledDate: function disabledDate() {
    return false;
  }
};

var DefaultRangePicker = function DefaultRangePicker(_ref) {
  var size = _ref.size,
      placeholder = _ref.placeholder,
      disabledDate = _ref.disabledDate,
      format = _ref.format,
      value = _ref.value,
      onChange = _ref.onChange,
      showTime = _ref.showTime,
      disabled = _ref.disabled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'range-picker'
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: 'label'
  }, "From"), /*#__PURE__*/React__default.createElement(_DatePicker, {
    showTime: showTime && showTime[0],
    size: size,
    onChange: onChange && onChange[0],
    disabled: disabled,
    disabledDate: disabledDate,
    format: format,
    value: value && value[0],
    placeholder: placeholder && placeholder[0]
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: 'label'
  }, "To"), /*#__PURE__*/React__default.createElement(_DatePicker, {
    showTime: showTime && showTime[1],
    size: size,
    onChange: onChange && onChange[1],
    disabled: disabled,
    disabledDate: disabledDate,
    format: format,
    value: value && value[1],
    placeholder: placeholder && placeholder[1]
  })));
};

DefaultRangePicker.defaultProps = {
  size: 'default',
  disabledDate: function disabledDate() {
    return false;
  }
};

var TabItem = function TabItem(props) {
  var name = props.name,
      item = props.item,
      onChange = props.onChange,
      selectedTab = props.selectedTab;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tab-bar-chip".concat(item && selectedTab == item.type ? ' tab-border-bottom' : ''),
    onClick: function onClick() {
      return onChange && onChange(item);
    }
  }, name);
};

var Checkbox = function Checkbox(props) {
  var onCheck = props.onCheck,
      value = props.value;

  if (value) {
    return /*#__PURE__*/React__default.createElement("span", {
      className: "",
      onClick: function onClick() {
        return onCheck && onCheck();
      }
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "SelectedFull"
    }));
  }

  return /*#__PURE__*/React__default.createElement("span", {
    className: "",
    onClick: function onClick() {
      return onCheck && onCheck();
    }
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    name: "SelectedEmpty"
  }));
};

Checkbox.defaultProps = {
  value: true,
  onCheck: function onCheck() {}
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var _excluded$3 = ["list", "placeholder", "onSelectDropDown", "optionType", "width", "value", "defaultValue", "size"];

function _createSuper$I(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$I(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$I() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Option$2 = _Select.Option;

var DropDown = /*#__PURE__*/function (_React$Component) {
  _inherits(DropDown, _React$Component);

  var _super = _createSuper$I(DropDown);

  function DropDown() {
    _classCallCheck(this, DropDown);

    return _super.apply(this, arguments);
  }

  _createClass(DropDown, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          list = _this$props.list,
          placeholder = _this$props.placeholder,
          onSelectDropDown = _this$props.onSelectDropDown;
          _this$props.optionType;
          var width = _this$props.width,
          value = _this$props.value,
          defaultValue = _this$props.defaultValue,
          size = _this$props.size,
          otherProps = _objectWithoutProperties(_this$props, _excluded$3);

      function onselect(i) {
        if (onSelectDropDown) {
          onSelectDropDown(i);
        }
      }

      return /*#__PURE__*/React__default.createElement(_Select, _extends({
        defaultValue: defaultValue,
        value: value === '' ? undefined : value,
        placeholder: placeholder && placeholder,
        style: {
          width: width || '100%'
        },
        onSelect: function onSelect(i) {
          return onselect(i);
        },
        size: size
      }, otherProps), list && list.map(function (item) {
        return /*#__PURE__*/React__default.createElement(Option$2, {
          value: item.type,
          onChange: function onChange() {
            return _this.props.onChange && _this.props.onChange();
          }
        }, item.name);
      }));
    }
  }]);

  return DropDown;
}(React__default.Component);
DropDown.defaultProps = {
  onCheck: function onCheck() {},
  width: '20%',
  size: 'default'
};

var IconContext = /*#__PURE__*/createContext({});

// This icon file is generated automatically.
var AccountBookFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 018.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z" } }] }, "name": "account-book", "theme": "filled" };

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */
function bound01(n, max) {
    if (isOnePointZero(n)) {
        n = '100%';
    }
    var isPercent = isPercentage(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) {
        n = parseInt(String(n * max), 10) / 100;
    }
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
        return 1;
    }
    // Convert into [0, 1] range if it isn't already
    if (max === 360) {
        // If n is a hue given in degrees,
        // wrap around out-of-range values into [0, 360] range
        // then convert into [0, 1].
        n = (n < 0 ? (n % max) + max : n % max) / parseFloat(String(max));
    }
    else {
        // If n not a hue given in degrees
        // Convert into [0, 1] range if it isn't already.
        n = (n % max) / parseFloat(String(max));
    }
    return n;
}
/**
 * Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
 * <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
 * @hidden
 */
function isOnePointZero(n) {
    return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
/**
 * Check to see if string passed in is a percentage
 * @hidden
 */
function isPercentage(n) {
    return typeof n === 'string' && n.indexOf('%') !== -1;
}
/**
 * Return a valid alpha value [0,1] with all invalid values being set to 1
 * @hidden
 */
function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }
    return a;
}
/**
 * Replace a decimal with it's percentage value
 * @hidden
 */
function convertToPercentage(n) {
    if (n <= 1) {
        return Number(n) * 100 + "%";
    }
    return n;
}
/**
 * Force a hex value to have 2 characters
 * @hidden
 */
function pad2(c) {
    return c.length === 1 ? '0' + c : String(c);
}

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
/**
 * Handle bounds / percentage checking to conform to CSS color spec
 * <http://www.w3.org/TR/css3-color/>
 * *Assumes:* r, g, b in [0, 255] or [0, 1]
 * *Returns:* { r, g, b } in [0, 255]
 */
function rgbToRgb(r, g, b) {
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255,
    };
}
function hue2rgb(p, q, t) {
    if (t < 0) {
        t += 1;
    }
    if (t > 1) {
        t -= 1;
    }
    if (t < 1 / 6) {
        return p + (q - p) * (6 * t);
    }
    if (t < 1 / 2) {
        return q;
    }
    if (t < 2 / 3) {
        return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
}
/**
 * Converts an HSL color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */
function hslToRgb(h, s, l) {
    var r;
    var g;
    var b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return { r: r * 255, g: g * 255, b: b * 255 };
}
/**
 * Converts an RGB color value to HSV
 *
 * *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
 * *Returns:* { h, s, v } in [0,1]
 */
function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) {
        h = 0; // achromatic
    }
    else {
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}
/**
 * Converts an HSV color value to RGB.
 *
 * *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
 * *Returns:* { r, g, b } in the set [0, 255]
 */
function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [v, q, p, p, t, v][mod];
    var g = [t, v, v, q, p, p][mod];
    var b = [p, p, t, v, v, q][mod];
    return { r: r * 255, g: g * 255, b: b * 255 };
}
/**
 * Converts an RGB color to hex
 *
 * Assumes r, g, and b are contained in the set [0, 255]
 * Returns a 3 or 6 character hex
 */
function rgbToHex(r, g, b, allow3Char) {
    var hex = [
        pad2(Math.round(r).toString(16)),
        pad2(Math.round(g).toString(16)),
        pad2(Math.round(b).toString(16)),
    ];
    // Return a 3 character hex if possible
    if (allow3Char &&
        hex[0].startsWith(hex[0].charAt(1)) &&
        hex[1].startsWith(hex[1].charAt(1)) &&
        hex[2].startsWith(hex[2].charAt(1))) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join('');
}
/** Converts a hex value to a decimal */
function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
}
/** Parse a base-16 hex value into a base-10 integer */
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */
var names = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    goldenrod: '#daa520',
    gold: '#ffd700',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavenderblush: '#fff0f5',
    lavender: '#e6e6fa',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32',
};

/**
 * Given a string or object, convert that input to RGB
 *
 * Possible string inputs:
 * ```
 * "red"
 * "#f00" or "f00"
 * "#ff0000" or "ff0000"
 * "#ff000000" or "ff000000"
 * "rgb 255 0 0" or "rgb (255, 0, 0)"
 * "rgb 1.0 0 0" or "rgb (1, 0, 0)"
 * "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
 * "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
 * "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
 * "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
 * "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
 * ```
 */
function inputToRGB(color) {
    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === 'string') {
        color = stringInputToObject(color);
    }
    if (typeof color === 'object') {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = 'hsv';
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = 'hsl';
        }
        if (Object.prototype.hasOwnProperty.call(color, 'a')) {
            a = color.a;
        }
    }
    a = boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a,
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var CSS_INTEGER = '[-\\+]?\\d+%?';
// <http://www.w3.org/TR/css3-values/#number-value>
var CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
var matchers = {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp('rgb' + PERMISSIVE_MATCH3),
    rgba: new RegExp('rgba' + PERMISSIVE_MATCH4),
    hsl: new RegExp('hsl' + PERMISSIVE_MATCH3),
    hsla: new RegExp('hsla' + PERMISSIVE_MATCH4),
    hsv: new RegExp('hsv' + PERMISSIVE_MATCH3),
    hsva: new RegExp('hsva' + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
};
/**
 * Permissive string parsing.  Take in a number of formats, and output an object
 * based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
 */
function stringInputToObject(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) {
        return false;
    }
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color === 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: 'name' };
    }
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = matchers.rgb.exec(color);
    if (match) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    match = matchers.rgba.exec(color);
    if (match) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    match = matchers.hsl.exec(color);
    if (match) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    match = matchers.hsla.exec(color);
    if (match) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    match = matchers.hsv.exec(color);
    if (match) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    match = matchers.hsva.exec(color);
    if (match) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    match = matchers.hex8.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? 'name' : 'hex8',
        };
    }
    match = matchers.hex6.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? 'name' : 'hex',
        };
    }
    match = matchers.hex4.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1] + match[1]),
            g: parseIntFromHex(match[2] + match[2]),
            b: parseIntFromHex(match[3] + match[3]),
            a: convertHexToDecimal(match[4] + match[4]),
            format: named ? 'name' : 'hex8',
        };
    }
    match = matchers.hex3.exec(color);
    if (match) {
        return {
            r: parseIntFromHex(match[1] + match[1]),
            g: parseIntFromHex(match[2] + match[2]),
            b: parseIntFromHex(match[3] + match[3]),
            format: named ? 'name' : 'hex',
        };
    }
    return false;
}
/**
 * Check to see if it looks like a CSS unit
 * (see `matchers` above for definition).
 */
function isValidCSSUnit(color) {
    return Boolean(matchers.CSS_UNIT.exec(String(color)));
}

var hueStep = 2; // 色相阶梯

var saturationStep = 0.16; // 饱和度阶梯，浅色部分

var saturationStep2 = 0.05; // 饱和度阶梯，深色部分

var brightnessStep1 = 0.05; // 亮度阶梯，浅色部分

var brightnessStep2 = 0.15; // 亮度阶梯，深色部分

var lightColorCount = 5; // 浅色数量，主色上

var darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表

var darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}]; // Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`

function toHsv(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;
  var hsv = rgbToHsv(r, g, b);
  return {
    h: hsv.h * 360,
    s: hsv.s,
    v: hsv.v
  };
} // Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`


function toHex(_ref2) {
  var r = _ref2.r,
      g = _ref2.g,
      b = _ref2.b;
  return "#".concat(rgbToHex(r, g, b, false));
} // Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.


function mix(rgb1, rgb2, amount) {
  var p = amount / 100;
  var rgb = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b
  };
  return rgb;
}

function getHue(hsv, i, light) {
  var hue; // 根据色相不同，色相转向不同

  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }

  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }

  return hue;
}

function getSaturation(hsv, i, light) {
  // grey color don't change saturation
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }

  var saturation;

  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  } // 边界值修正


  if (saturation > 1) {
    saturation = 1;
  } // 第一格的 s 限制在 0.06-0.1 之间


  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }

  if (saturation < 0.06) {
    saturation = 0.06;
  }

  return Number(saturation.toFixed(2));
}

function getValue(hsv, i, light) {
  var value;

  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }

  if (value > 1) {
    value = 1;
  }

  return Number(value.toFixed(2));
}

function generate$1(color) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var patterns = [];
  var pColor = inputToRGB(color);

  for (var i = lightColorCount; i > 0; i -= 1) {
    var hsv = toHsv(pColor);
    var colorString = toHex(inputToRGB({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue(hsv, i, true)
    }));
    patterns.push(colorString);
  }

  patterns.push(toHex(pColor));

  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = toHsv(pColor);

    var _colorString = toHex(inputToRGB({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue(_hsv, _i)
    }));

    patterns.push(_colorString);
  } // dark theme patterns


  if (opts.theme === 'dark') {
    return darkColorMap.map(function (_ref3) {
      var index = _ref3.index,
          opacity = _ref3.opacity;
      var darkColorString = toHex(mix(inputToRGB(opts.backgroundColor || '#141414'), inputToRGB(patterns[index]), opacity * 100));
      return darkColorString;
    });
  }

  return patterns;
}

var presetPrimaryColors = {
  red: '#F5222D',
  volcano: '#FA541C',
  orange: '#FA8C16',
  gold: '#FAAD14',
  yellow: '#FADB14',
  lime: '#A0D911',
  green: '#52C41A',
  cyan: '#13C2C2',
  blue: '#1890FF',
  geekblue: '#2F54EB',
  purple: '#722ED1',
  magenta: '#EB2F96',
  grey: '#666666'
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function (key) {
  presetPalettes[key] = generate$1(presetPrimaryColors[key]);
  presetPalettes[key].primary = presetPalettes[key][5]; // dark presetPalettes

  presetDarkPalettes[key] = generate$1(presetPrimaryColors[key], {
    theme: 'dark',
    backgroundColor: '#141414'
  });
  presetDarkPalettes[key].primary = presetDarkPalettes[key][5];
});
presetPalettes.red;
presetPalettes.volcano;
presetPalettes.gold;
presetPalettes.orange;
presetPalettes.yellow;
presetPalettes.lime;
presetPalettes.green;
presetPalettes.cyan;
presetPalettes.blue;
presetPalettes.geekblue;
presetPalettes.purple;
presetPalettes.magenta;
presetPalettes.grey;

/* eslint-disable no-console */
var warned$1 = {};
function warning$3(valid, message) {
  // Support uglify
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    console.error("Warning: ".concat(message));
  }
}
function call$1(method, valid, message) {
  if (!valid && !warned$1[message]) {
    method(false, message);
    warned$1[message] = true;
  }
}
function warningOnce$1(valid, message) {
  call$1(warning$3, valid, message);
}
/* eslint-enable */

function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

var MARK_KEY = "rc-util-key";

function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }

  var head = document.querySelector('head');
  return head || document.body;
}

function injectCSS(css) {
  var _option$csp;

  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!canUseDom()) {
    return null;
  }

  var styleNode = document.createElement('style');

  if ((_option$csp = option.csp) === null || _option$csp === void 0 ? void 0 : _option$csp.nonce) {
    var _option$csp2;

    styleNode.nonce = (_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce;
  }

  styleNode.innerHTML = css;
  var container = getContainer(option);
  var firstChild = container.firstChild;

  if (option.prepend && container.prepend) {
    // Use `prepend` first
    container.prepend(styleNode);
  } else if (option.prepend && firstChild) {
    // Fallback to `insertBefore` like IE not support `prepend`
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }

  return styleNode;
}
var containerCache = new Map();
function updateCSS(css, key) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var container = getContainer(option); // Get real parent

  if (!containerCache.has(container)) {
    var placeholderStyle = injectCSS('', option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    parentNode.removeChild(placeholderStyle);
  }

  var existNode = Array.from(containerCache.get(container).children).find(function (node) {
    return node.tagName === 'STYLE' && node[MARK_KEY] === key;
  });

  if (existNode) {
    var _option$csp3, _option$csp4;

    if (((_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce) && existNode.nonce !== ((_option$csp4 = option.csp) === null || _option$csp4 === void 0 ? void 0 : _option$csp4.nonce)) {
      var _option$csp5;

      existNode.nonce = (_option$csp5 = option.csp) === null || _option$csp5 === void 0 ? void 0 : _option$csp5.nonce;
    }

    if (existNode.innerHTML !== css) {
      existNode.innerHTML = css;
    }

    return existNode;
  }

  var newNode = injectCSS(css, option);
  newNode[MARK_KEY] = key;
  return newNode;
}

function warning$2(valid, message) {
  warningOnce$1(valid, "[@ant-design/icons] ".concat(message));
}
function isIconDefinition(target) {
  return _typeof(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (_typeof(target.icon) === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];

    switch (key) {
      case 'class':
        acc.className = val;
        delete acc.class;
        break;

      default:
        acc[key] = val;
    }

    return acc;
  }, {});
}
function generate(node, key, rootProps) {
  if (!rootProps) {
    return /*#__PURE__*/React__default.createElement(node.tag, _objectSpread2({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
  }

  return /*#__PURE__*/React__default.createElement(node.tag, _objectSpread2(_objectSpread2({
    key: key
  }, normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function (child, index) {
    return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
  }));
}
function getSecondaryColor(primaryColor) {
  // choose the second color
  return generate$1(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }

  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
} // These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4

var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  'aria-hidden': 'true',
  focusable: 'false'
};
var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var useInsertStyles = function useInsertStyles() {
  var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iconStyles;

  var _useContext = useContext(IconContext),
      csp = _useContext.csp;

  useEffect(function () {
    updateCSS(styleStr, '@ant-design-icons', {
      prepend: true,
      csp: csp
    });
  }, []);
};

var twoToneColorPalette = {
  primaryColor: '#333',
  secondaryColor: '#E6E6E6',
  calculated: false
};

function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}

function getTwoToneColors() {
  return _objectSpread2({}, twoToneColorPalette);
}

var IconBase = function IconBase(props) {
  var icon = props.icon,
      className = props.className,
      onClick = props.onClick,
      style = props.style,
      primaryColor = props.primaryColor,
      secondaryColor = props.secondaryColor,
      restProps = _objectWithoutProperties(props, ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"]);

  var colors = twoToneColorPalette;

  if (primaryColor) {
    colors = {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }

  useInsertStyles();
  warning$2(isIconDefinition(icon), "icon should be icon definiton, but got ".concat(icon));

  if (!isIconDefinition(icon)) {
    return null;
  }

  var target = icon;

  if (target && typeof target.icon === 'function') {
    target = _objectSpread2(_objectSpread2({}, target), {}, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }

  return generate(target.icon, "svg-".concat(target.name), _objectSpread2({
    className: className,
    onClick: onClick,
    style: style,
    'data-icon': target.name,
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true'
  }, restProps));
};

IconBase.displayName = 'IconReact';
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;

function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return IconBase.setTwoToneColors({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  });
}
function getTwoToneColor() {
  var colors = IconBase.getTwoToneColors();

  if (!colors.calculated) {
    return colors.primaryColor;
  }

  return [colors.primaryColor, colors.secondaryColor];
}

// should move it to antd main repo?

setTwoToneColor('#1890ff');
var Icon$3 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var className = props.className,
      icon = props.icon,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      twoToneColor = props.twoToneColor,
      restProps = _objectWithoutProperties(props, ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"]);

  var _React$useContext = React.useContext(IconContext),
      _React$useContext$pre = _React$useContext.prefixCls,
      prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre;

  var classString = classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), _defineProperty(_classNames, "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), _classNames), className);
  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return /*#__PURE__*/React.createElement("span", Object.assign({
    role: "img",
    "aria-label": icon.name
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), /*#__PURE__*/React.createElement(IconBase, {
    icon: icon,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    style: svgStyle
  }));
});
Icon$3.displayName = 'AntdIcon';
Icon$3.getTwoToneColor = getTwoToneColor;
Icon$3.setTwoToneColor = setTwoToneColor;

// GENERATE BY ./scripts/generate.ts

var AccountBookFilled = function AccountBookFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookFilled$2
  }));
};

AccountBookFilled.displayName = 'AccountBookFilled';
var AccountBookFilled$1 = /*#__PURE__*/React.forwardRef(AccountBookFilled);

// This icon file is generated automatically.
var AccountBookOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 00-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z" } }] }, "name": "account-book", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AccountBookOutlined = function AccountBookOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookOutlined$2
  }));
};

AccountBookOutlined.displayName = 'AccountBookOutlined';
var AccountBookOutlined$1 = /*#__PURE__*/React.forwardRef(AccountBookOutlined);

// This icon file is generated automatically.
var AccountBookTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 017.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 00-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z", "fill": primaryColor } }] }; }, "name": "account-book", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var AccountBookTwoTone = function AccountBookTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookTwoTone$2
  }));
};

AccountBookTwoTone.displayName = 'AccountBookTwoTone';
var AccountBookTwoTone$1 = /*#__PURE__*/React.forwardRef(AccountBookTwoTone);

// This icon file is generated automatically.
var AimOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z" } }, { "tag": "path", "attrs": { "d": "M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8A118.57 118.57 0 00512 392z" } }] }, "name": "aim", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AimOutlined = function AimOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AimOutlined$2
  }));
};

AimOutlined.displayName = 'AimOutlined';
var AimOutlined$1 = /*#__PURE__*/React.forwardRef(AimOutlined);

// This icon file is generated automatically.
var AlertFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 244c176.18 0 319 142.82 319 319v233a32 32 0 01-32 32H225a32 32 0 01-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 018 8v96a8 8 0 01-8 8h-56a8 8 0 01-8-8V76a8 8 0 018-8zM177.25 191.66a8 8 0 0111.32 0l67.88 67.88a8 8 0 010 11.31l-39.6 39.6a8 8 0 01-11.31 0l-67.88-67.88a8 8 0 010-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 010 11.3l-67.88 67.9a8 8 0 01-11.32 0l-39.6-39.6a8 8 0 010-11.32l67.89-67.88a8 8 0 0111.31 0zM192 892h640a32 32 0 0132 32v24a8 8 0 01-8 8H168a8 8 0 01-8-8v-24a32 32 0 0132-32zm148-317v253h64V575h-64z" } }] }, "name": "alert", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AlertFilled = function AlertFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AlertFilled$2
  }));
};

AlertFilled.displayName = 'AlertFilled';
var AlertFilled$1 = /*#__PURE__*/React.forwardRef(AlertFilled);

// This icon file is generated automatically.
var AlertOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 00-11.3 0l-39.6 39.6a8.03 8.03 0 000 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 00-11.3 0l-67.9 67.9a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z" } }] }, "name": "alert", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlertOutlined = function AlertOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AlertOutlined$2
  }));
};

AlertOutlined.displayName = 'AlertOutlined';
var AlertOutlined$1 = /*#__PURE__*/React.forwardRef(AlertOutlined);

// This icon file is generated automatically.
var AlertTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 00-11.3 0l-39.6 39.6a8.03 8.03 0 000 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 00-11.3 0l-67.9 67.9a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z", "fill": primaryColor } }] }; }, "name": "alert", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var AlertTwoTone = function AlertTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AlertTwoTone$2
  }));
};

AlertTwoTone.displayName = 'AlertTwoTone';
var AlertTwoTone$1 = /*#__PURE__*/React.forwardRef(AlertTwoTone);

// This icon file is generated automatically.
var AlibabaOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z" } }] }, "name": "alibaba", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlibabaOutlined = function AlibabaOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AlibabaOutlined$2
  }));
};

AlibabaOutlined.displayName = 'AlibabaOutlined';
var AlibabaOutlined$1 = /*#__PURE__*/React.forwardRef(AlibabaOutlined);

// This icon file is generated automatically.
var AlignCenterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "align-center", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlignCenterOutlined = function AlignCenterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AlignCenterOutlined$2
  }));
};

AlignCenterOutlined.displayName = 'AlignCenterOutlined';
var AlignCenterOutlined$1 = /*#__PURE__*/React.forwardRef(AlignCenterOutlined);

// This icon file is generated automatically.
var AlignLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "align-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlignLeftOutlined = function AlignLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AlignLeftOutlined$2
  }));
};

AlignLeftOutlined.displayName = 'AlignLeftOutlined';
var AlignLeftOutlined$1 = /*#__PURE__*/React.forwardRef(AlignLeftOutlined);

// This icon file is generated automatically.
var AlignRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "align-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlignRightOutlined = function AlignRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AlignRightOutlined$2
  }));
};

AlignRightOutlined.displayName = 'AlignRightOutlined';
var AlignRightOutlined$1 = /*#__PURE__*/React.forwardRef(AlignRightOutlined);

// This icon file is generated automatically.
var AlipayCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 00960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z" } }] }, "name": "alipay-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AlipayCircleFilled = function AlipayCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AlipayCircleFilled$2
  }));
};

AlipayCircleFilled.displayName = 'AlipayCircleFilled';
var AlipayCircleFilled$1 = /*#__PURE__*/React.forwardRef(AlipayCircleFilled);

// This icon file is generated automatically.
var AlipayCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 00960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z" } }] }, "name": "alipay-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlipayCircleOutlined = function AlipayCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AlipayCircleOutlined$2
  }));
};

AlipayCircleOutlined.displayName = 'AlipayCircleOutlined';
var AlipayCircleOutlined$1 = /*#__PURE__*/React.forwardRef(AlipayCircleOutlined);

// This icon file is generated automatically.
var AlipayOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 01-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z" } }] }, "name": "alipay", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AlipayOutlined = function AlipayOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AlipayOutlined$2
  }));
};

AlipayOutlined.displayName = 'AlipayOutlined';
var AlipayOutlined$1 = /*#__PURE__*/React.forwardRef(AlipayOutlined);

// This icon file is generated automatically.
var AlipaySquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z" } }] }, "name": "alipay-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AlipaySquareFilled = function AlipaySquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AlipaySquareFilled$2
  }));
};

AlipaySquareFilled.displayName = 'AlipaySquareFilled';
var AlipaySquareFilled$1 = /*#__PURE__*/React.forwardRef(AlipaySquareFilled);

// This icon file is generated automatically.
var AliwangwangFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 00-120.5-81.2A375.65 375.65 0 00519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 00-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0029.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z" } }] }, "name": "aliwangwang", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AliwangwangFilled = function AliwangwangFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AliwangwangFilled$2
  }));
};

AliwangwangFilled.displayName = 'AliwangwangFilled';
var AliwangwangFilled$1 = /*#__PURE__*/React.forwardRef(AliwangwangFilled);

// This icon file is generated automatically.
var AliwangwangOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 00-120.5-81.2A375.65 375.65 0 00519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 00-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0029.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 01-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 01-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 01217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z" } }] }, "name": "aliwangwang", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AliwangwangOutlined = function AliwangwangOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AliwangwangOutlined$2
  }));
};

AliwangwangOutlined.displayName = 'AliwangwangOutlined';
var AliwangwangOutlined$1 = /*#__PURE__*/React.forwardRef(AliwangwangOutlined);

// This icon file is generated automatically.
var AliyunOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0132.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 01-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 01-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z" } }] }, "name": "aliyun", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AliyunOutlined = function AliyunOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AliyunOutlined$2
  }));
};

AliyunOutlined.displayName = 'AliyunOutlined';
var AliyunOutlined$1 = /*#__PURE__*/React.forwardRef(AliyunOutlined);

// This icon file is generated automatically.
var AmazonCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 00-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0125.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 017.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 01-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z" } }] }, "name": "amazon-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AmazonCircleFilled = function AmazonCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AmazonCircleFilled$2
  }));
};

AmazonCircleFilled.displayName = 'AmazonCircleFilled';
var AmazonCircleFilled$1 = /*#__PURE__*/React.forwardRef(AmazonCircleFilled);

// This icon file is generated automatically.
var AmazonOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 00-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z" } }] }, "name": "amazon", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AmazonOutlined = function AmazonOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AmazonOutlined$2
  }));
};

AmazonOutlined.displayName = 'AmazonOutlined';
var AmazonOutlined$1 = /*#__PURE__*/React.forwardRef(AmazonOutlined);

// This icon file is generated automatically.
var AmazonSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 00-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0125.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 017.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 01-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z" } }] }, "name": "amazon-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AmazonSquareFilled = function AmazonSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AmazonSquareFilled$2
  }));
};

AmazonSquareFilled.displayName = 'AmazonSquareFilled';
var AmazonSquareFilled$1 = /*#__PURE__*/React.forwardRef(AmazonSquareFilled);

// This icon file is generated automatically.
var AndroidFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm208.4 0a26.9 26.9 0 1126.9-26.9 26.97 26.97 0 01-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z" } }] }, "name": "android", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AndroidFilled = function AndroidFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AndroidFilled$2
  }));
};

AndroidFilled.displayName = 'AndroidFilled';
var AndroidFilled$1 = /*#__PURE__*/React.forwardRef(AndroidFilled);

// This icon file is generated automatically.
var AndroidOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z" } }] }, "name": "android", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AndroidOutlined = function AndroidOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AndroidOutlined$2
  }));
};

AndroidOutlined.displayName = 'AndroidOutlined';
var AndroidOutlined$1 = /*#__PURE__*/React.forwardRef(AndroidOutlined);

// This icon file is generated automatically.
var AntCloudOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0122.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 01-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1096 0 48 48 0 10-96 0zm-65.7 61.3a24 24 0 1048 0 24 24 0 10-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z" } }] }, "name": "ant-cloud", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AntCloudOutlined = function AntCloudOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AntCloudOutlined$2
  }));
};

AntCloudOutlined.displayName = 'AntCloudOutlined';
var AntCloudOutlined$1 = /*#__PURE__*/React.forwardRef(AntCloudOutlined);

// This icon file is generated automatically.
var AntDesignOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 000 76.4L474.6 944a54.14 54.14 0 0076.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 00-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 10212.6 0 106.3 106.2 0 10-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 000 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 000 68.6 48.7 48.7 0 0068.7 0l121.8-121.7a53.93 53.93 0 00-.1-76.4z" } }] }, "name": "ant-design", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AntDesignOutlined = function AntDesignOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AntDesignOutlined$2
  }));
};

AntDesignOutlined.displayName = 'AntDesignOutlined';
var AntDesignOutlined$1 = /*#__PURE__*/React.forwardRef(AntDesignOutlined);

// This icon file is generated automatically.
var ApartmentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z" } }] }, "name": "apartment", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ApartmentOutlined = function ApartmentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ApartmentOutlined$2
  }));
};

ApartmentOutlined.displayName = 'ApartmentOutlined';
var ApartmentOutlined$1 = /*#__PURE__*/React.forwardRef(ApartmentOutlined);

// This icon file is generated automatically.
var ApiFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z" } }] }, "name": "api", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ApiFilled = function ApiFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ApiFilled$2
  }));
};

ApiFilled.displayName = 'ApiFilled';
var ApiFilled$1 = /*#__PURE__*/React.forwardRef(ApiFilled);

// This icon file is generated automatically.
var ApiOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 01-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 01-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z" } }] }, "name": "api", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ApiOutlined = function ApiOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ApiOutlined$2
  }));
};

ApiOutlined.displayName = 'ApiOutlined';
var ApiOutlined$1 = /*#__PURE__*/React.forwardRef(ApiOutlined);

// This icon file is generated automatically.
var ApiTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M578.9 546.7a8.03 8.03 0 00-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 00-11.3 0L363 475.3l-43-43a7.85 7.85 0 00-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 00-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 000 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 01-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 00-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 000 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z", "fill": primaryColor } }] }; }, "name": "api", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ApiTwoTone = function ApiTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ApiTwoTone$2
  }));
};

ApiTwoTone.displayName = 'ApiTwoTone';
var ApiTwoTone$1 = /*#__PURE__*/React.forwardRef(ApiTwoTone);

// This icon file is generated automatically.
var AppleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z" } }] }, "name": "apple", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AppleFilled = function AppleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AppleFilled$2
  }));
};

AppleFilled.displayName = 'AppleFilled';
var AppleFilled$1 = /*#__PURE__*/React.forwardRef(AppleFilled);

// This icon file is generated automatically.
var AppleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z" } }] }, "name": "apple", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AppleOutlined = function AppleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AppleOutlined$2
  }));
};

AppleOutlined.displayName = 'AppleOutlined';
var AppleOutlined$1 = /*#__PURE__*/React.forwardRef(AppleOutlined);

// This icon file is generated automatically.
var AppstoreAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zm52 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200zM424 712H296V584c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v128H104c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128v128c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V776h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "appstore-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AppstoreAddOutlined = function AppstoreAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreAddOutlined$2
  }));
};

AppstoreAddOutlined.displayName = 'AppstoreAddOutlined';
var AppstoreAddOutlined$1 = /*#__PURE__*/React.forwardRef(AppstoreAddOutlined);

// This icon file is generated automatically.
var AppstoreFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z" } }] }, "name": "appstore", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AppstoreFilled = function AppstoreFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreFilled$2
  }));
};

AppstoreFilled.displayName = 'AppstoreFilled';
var AppstoreFilled$1 = /*#__PURE__*/React.forwardRef(AppstoreFilled);

// This icon file is generated automatically.
var AppstoreOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z" } }] }, "name": "appstore", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AppstoreOutlined = function AppstoreOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreOutlined$2
  }));
};

AppstoreOutlined.displayName = 'AppstoreOutlined';
var AppstoreOutlined$1 = /*#__PURE__*/React.forwardRef(AppstoreOutlined);

// This icon file is generated automatically.
var AppstoreTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z", "fill": secondaryColor } }] }; }, "name": "appstore", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var AppstoreTwoTone = function AppstoreTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreTwoTone$2
  }));
};

AppstoreTwoTone.displayName = 'AppstoreTwoTone';
var AppstoreTwoTone$1 = /*#__PURE__*/React.forwardRef(AppstoreTwoTone);

// This icon file is generated automatically.
var AreaChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 00-11.3 0l-189 189.6a7.87 7.87 0 00-2.3 5.6V720c0 4.4 3.6 8 8 8z" } }] }, "name": "area-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AreaChartOutlined = function AreaChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AreaChartOutlined$2
  }));
};

AreaChartOutlined.displayName = 'AreaChartOutlined';
var AreaChartOutlined$1 = /*#__PURE__*/React.forwardRef(AreaChartOutlined);

// This icon file is generated automatically.
var ArrowDownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z" } }] }, "name": "arrow-down", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowDownOutlined = function ArrowDownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ArrowDownOutlined$2
  }));
};

ArrowDownOutlined.displayName = 'ArrowDownOutlined';
var ArrowDownOutlined$1 = /*#__PURE__*/React.forwardRef(ArrowDownOutlined);

// This icon file is generated automatically.
var ArrowLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "arrow-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowLeftOutlined = function ArrowLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ArrowLeftOutlined$2
  }));
};

ArrowLeftOutlined.displayName = 'ArrowLeftOutlined';
var ArrowLeftOutlined$1 = /*#__PURE__*/React.forwardRef(ArrowLeftOutlined);

// This icon file is generated automatically.
var ArrowRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z" } }] }, "name": "arrow-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowRightOutlined = function ArrowRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ArrowRightOutlined$2
  }));
};

ArrowRightOutlined.displayName = 'ArrowRightOutlined';
var ArrowRightOutlined$1 = /*#__PURE__*/React.forwardRef(ArrowRightOutlined);

// This icon file is generated automatically.
var ArrowUpOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 545.5L536.1 163a31.96 31.96 0 00-48.3 0L156 545.5a7.97 7.97 0 006 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z" } }] }, "name": "arrow-up", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowUpOutlined = function ArrowUpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ArrowUpOutlined$2
  }));
};

ArrowUpOutlined.displayName = 'ArrowUpOutlined';
var ArrowUpOutlined$1 = /*#__PURE__*/React.forwardRef(ArrowUpOutlined);

// This icon file is generated automatically.
var ArrowsAltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L863.9 169a7.9 7.9 0 00-8.9-8.9zM416.6 562.3a8.03 8.03 0 00-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z" } }] }, "name": "arrows-alt", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ArrowsAltOutlined = function ArrowsAltOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ArrowsAltOutlined$2
  }));
};

ArrowsAltOutlined.displayName = 'ArrowsAltOutlined';
var ArrowsAltOutlined$1 = /*#__PURE__*/React.forwardRef(ArrowsAltOutlined);

// This icon file is generated automatically.
var AudioFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z" } }] }, "name": "audio", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var AudioFilled = function AudioFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AudioFilled$2
  }));
};

AudioFilled.displayName = 'AudioFilled';
var AudioFilled$1 = /*#__PURE__*/React.forwardRef(AudioFilled);

// This icon file is generated automatically.
var AudioMutedOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M682 455V311l-76 76v68c-.1 50.7-42 92.1-94 92a95.8 95.8 0 01-52-15l-54 55c29.1 22.4 65.9 36 106 36 93.8 0 170-75.1 170-168z" } }, { "tag": "path", "attrs": { "d": "M833 446h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254-63 0-120.7-23-165-61l-54 54a334.01 334.01 0 00179 81v102H326c-13.9 0-24.9 14.3-25 32v36c.1 4.4 2.9 8 6 8h408c3.2 0 6-3.6 6-8v-36c0-17.7-11-32-25-32H547V782c165.3-17.9 294-157.9 294-328 0-4.4-3.6-8-8-8zm13.1-377.7l-43.5-41.9a8 8 0 00-11.2.1l-129 129C634.3 101.2 577 64 511 64c-93.9 0-170 75.3-170 168v224c0 6.7.4 13.3 1.2 19.8l-68 68A252.33 252.33 0 01258 454c-.2-4.4-3.8-8-8-8h-60c-4.4 0-8 3.6-8 8 0 53 12.5 103 34.6 147.4l-137 137a8.03 8.03 0 000 11.3l42.7 42.7c3.1 3.1 8.2 3.1 11.3 0L846.2 79.8l.1-.1c3.1-3.2 3-8.3-.2-11.4zM417 401V232c0-50.6 41.9-92 94-92 46 0 84.1 32.3 92.3 74.7L417 401z" } }] }, "name": "audio-muted", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AudioMutedOutlined = function AudioMutedOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AudioMutedOutlined$2
  }));
};

AudioMutedOutlined.displayName = 'AudioMutedOutlined';
var AudioMutedOutlined$1 = /*#__PURE__*/React.forwardRef(AudioMutedOutlined);

// This icon file is generated automatically.
var AudioOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z" } }] }, "name": "audio", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AudioOutlined = function AudioOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AudioOutlined$2
  }));
};

AudioOutlined.displayName = 'AudioOutlined';
var AudioOutlined$1 = /*#__PURE__*/React.forwardRef(AudioOutlined);

// This icon file is generated automatically.
var AudioTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z", "fill": primaryColor } }] }; }, "name": "audio", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var AudioTwoTone = function AudioTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AudioTwoTone$2
  }));
};

AudioTwoTone.displayName = 'AudioTwoTone';
var AudioTwoTone$1 = /*#__PURE__*/React.forwardRef(AudioTwoTone);

// This icon file is generated automatically.
var AuditOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z" } }] }, "name": "audit", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var AuditOutlined = function AuditOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: AuditOutlined$2
  }));
};

AuditOutlined.displayName = 'AuditOutlined';
var AuditOutlined$1 = /*#__PURE__*/React.forwardRef(AuditOutlined);

// This icon file is generated automatically.
var BackwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 00-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z" } }] }, "name": "backward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BackwardFilled = function BackwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BackwardFilled$2
  }));
};

BackwardFilled.displayName = 'BackwardFilled';
var BackwardFilled$1 = /*#__PURE__*/React.forwardRef(BackwardFilled);

// This icon file is generated automatically.
var BackwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 00-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z" } }] }, "name": "backward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BackwardOutlined = function BackwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BackwardOutlined$2
  }));
};

BackwardOutlined.displayName = 'BackwardOutlined';
var BackwardOutlined$1 = /*#__PURE__*/React.forwardRef(BackwardOutlined);

// This icon file is generated automatically.
var BankFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z" } }] }, "name": "bank", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BankFilled = function BankFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BankFilled$2
  }));
};

BankFilled.displayName = 'BankFilled';
var BankFilled$1 = /*#__PURE__*/React.forwardRef(BankFilled);

// This icon file is generated automatically.
var BankOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z" } }] }, "name": "bank", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BankOutlined = function BankOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BankOutlined$2
  }));
};

BankOutlined.displayName = 'BankOutlined';
var BankOutlined$1 = /*#__PURE__*/React.forwardRef(BankOutlined);

// This icon file is generated automatically.
var BankTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M240.9 393.9h542.2L512 196.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 00-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z", "fill": primaryColor } }] }; }, "name": "bank", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BankTwoTone = function BankTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BankTwoTone$2
  }));
};

BankTwoTone.displayName = 'BankTwoTone';
var BankTwoTone$1 = /*#__PURE__*/React.forwardRef(BankTwoTone);

// This icon file is generated automatically.
var BarChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z" } }] }, "name": "bar-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BarChartOutlined = function BarChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BarChartOutlined$2
  }));
};

BarChartOutlined.displayName = 'BarChartOutlined';
var BarChartOutlined$1 = /*#__PURE__*/React.forwardRef(BarChartOutlined);

// This icon file is generated automatically.
var BarcodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "barcode", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BarcodeOutlined = function BarcodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BarcodeOutlined$2
  }));
};

BarcodeOutlined.displayName = 'BarcodeOutlined';
var BarcodeOutlined$1 = /*#__PURE__*/React.forwardRef(BarcodeOutlined);

// This icon file is generated automatically.
var BarsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "bars", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BarsOutlined = function BarsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BarsOutlined$2
  }));
};

BarsOutlined.displayName = 'BarsOutlined';
var BarsOutlined$1 = /*#__PURE__*/React.forwardRef(BarsOutlined);

// This icon file is generated automatically.
var BehanceCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0017.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z" } }] }, "name": "behance-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BehanceCircleFilled = function BehanceCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BehanceCircleFilled$2
  }));
};

BehanceCircleFilled.displayName = 'BehanceCircleFilled';
var BehanceCircleFilled$1 = /*#__PURE__*/React.forwardRef(BehanceCircleFilled);

// This icon file is generated automatically.
var BehanceOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z" } }] }, "name": "behance", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BehanceOutlined = function BehanceOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BehanceOutlined$2
  }));
};

BehanceOutlined.displayName = 'BehanceOutlined';
var BehanceOutlined$1 = /*#__PURE__*/React.forwardRef(BehanceOutlined);

// This icon file is generated automatically.
var BehanceSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z" } }] }, "name": "behance-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BehanceSquareFilled = function BehanceSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BehanceSquareFilled$2
  }));
};

BehanceSquareFilled.displayName = 'BehanceSquareFilled';
var BehanceSquareFilled$1 = /*#__PURE__*/React.forwardRef(BehanceSquareFilled);

// This icon file is generated automatically.
var BehanceSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 01-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 01-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 01-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0138.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 00-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 00-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z" } }] }, "name": "behance-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BehanceSquareOutlined = function BehanceSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BehanceSquareOutlined$2
  }));
};

BehanceSquareOutlined.displayName = 'BehanceSquareOutlined';
var BehanceSquareOutlined$1 = /*#__PURE__*/React.forwardRef(BehanceSquareOutlined);

// This icon file is generated automatically.
var BellFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z" } }] }, "name": "bell", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BellFilled = function BellFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BellFilled$2
  }));
};

BellFilled.displayName = 'BellFilled';
var BellFilled$1 = /*#__PURE__*/React.forwardRef(BellFilled);

// This icon file is generated automatically.
var BellOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z" } }] }, "name": "bell", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BellOutlined = function BellOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BellOutlined$2
  }));
};

BellOutlined.displayName = 'BellOutlined';
var BellOutlined$1 = /*#__PURE__*/React.forwardRef(BellOutlined);

// This icon file is generated automatically.
var BellTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z", "fill": primaryColor } }] }; }, "name": "bell", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BellTwoTone = function BellTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BellTwoTone$2
  }));
};

BellTwoTone.displayName = 'BellTwoTone';
var BellTwoTone$1 = /*#__PURE__*/React.forwardRef(BellTwoTone);

// This icon file is generated automatically.
var BgColorsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 00-12.8 0l-48 48a9.11 9.11 0 000 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z" } }] }, "name": "bg-colors", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BgColorsOutlined = function BgColorsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BgColorsOutlined$2
  }));
};

BgColorsOutlined.displayName = 'BgColorsOutlined';
var BgColorsOutlined$1 = /*#__PURE__*/React.forwardRef(BgColorsOutlined);

// This icon file is generated automatically.
var BlockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z" } }] }, "name": "block", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BlockOutlined = function BlockOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BlockOutlined$2
  }));
};

BlockOutlined.displayName = 'BlockOutlined';
var BlockOutlined$1 = /*#__PURE__*/React.forwardRef(BlockOutlined);

// This icon file is generated automatically.
var BoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z" } }] }, "name": "bold", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BoldOutlined = function BoldOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BoldOutlined$2
  }));
};

BoldOutlined.displayName = 'BoldOutlined';
var BoldOutlined$1 = /*#__PURE__*/React.forwardRef(BoldOutlined);

// This icon file is generated automatically.
var BookFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z" } }] }, "name": "book", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BookFilled = function BookFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BookFilled$2
  }));
};

BookFilled.displayName = 'BookFilled';
var BookFilled$1 = /*#__PURE__*/React.forwardRef(BookFilled);

// This icon file is generated automatically.
var BookOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z" } }] }, "name": "book", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BookOutlined = function BookOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BookOutlined$2
  }));
};

BookOutlined.displayName = 'BookOutlined';
var BookOutlined$1 = /*#__PURE__*/React.forwardRef(BookOutlined);

// This icon file is generated automatically.
var BookTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M668 345.9V136h-96v211.4l49.5-35.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 01-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z", "fill": secondaryColor } }] }; }, "name": "book", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BookTwoTone = function BookTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BookTwoTone$2
  }));
};

BookTwoTone.displayName = 'BookTwoTone';
var BookTwoTone$1 = /*#__PURE__*/React.forwardRef(BookTwoTone);

// This icon file is generated automatically.
var BorderBottomOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "border-bottom", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderBottomOutlined = function BorderBottomOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BorderBottomOutlined$2
  }));
};

BorderBottomOutlined.displayName = 'BorderBottomOutlined';
var BorderBottomOutlined$1 = /*#__PURE__*/React.forwardRef(BorderBottomOutlined);

// This icon file is generated automatically.
var BorderHorizontalOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-horizontal", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderHorizontalOutlined = function BorderHorizontalOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BorderHorizontalOutlined$2
  }));
};

BorderHorizontalOutlined.displayName = 'BorderHorizontalOutlined';
var BorderHorizontalOutlined$1 = /*#__PURE__*/React.forwardRef(BorderHorizontalOutlined);

// This icon file is generated automatically.
var BorderInnerOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-inner", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderInnerOutlined = function BorderInnerOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BorderInnerOutlined$2
  }));
};

BorderInnerOutlined.displayName = 'BorderInnerOutlined';
var BorderInnerOutlined$1 = /*#__PURE__*/React.forwardRef(BorderInnerOutlined);

// This icon file is generated automatically.
var BorderLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderLeftOutlined = function BorderLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BorderLeftOutlined$2
  }));
};

BorderLeftOutlined.displayName = 'BorderLeftOutlined';
var BorderLeftOutlined$1 = /*#__PURE__*/React.forwardRef(BorderLeftOutlined);

// This icon file is generated automatically.
var BorderOuterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "border-outer", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderOuterOutlined = function BorderOuterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BorderOuterOutlined$2
  }));
};

BorderOuterOutlined.displayName = 'BorderOuterOutlined';
var BorderOuterOutlined$1 = /*#__PURE__*/React.forwardRef(BorderOuterOutlined);

// This icon file is generated automatically.
var BorderOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "border", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderOutlined = function BorderOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BorderOutlined$2
  }));
};

BorderOutlined.displayName = 'BorderOutlined';
var BorderOutlined$1 = /*#__PURE__*/React.forwardRef(BorderOutlined);

// This icon file is generated automatically.
var BorderRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderRightOutlined = function BorderRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BorderRightOutlined$2
  }));
};

BorderRightOutlined.displayName = 'BorderRightOutlined';
var BorderRightOutlined$1 = /*#__PURE__*/React.forwardRef(BorderRightOutlined);

// This icon file is generated automatically.
var BorderTopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-top", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderTopOutlined = function BorderTopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BorderTopOutlined$2
  }));
};

BorderTopOutlined.displayName = 'BorderTopOutlined';
var BorderTopOutlined$1 = /*#__PURE__*/React.forwardRef(BorderTopOutlined);

// This icon file is generated automatically.
var BorderVerticleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "border-verticle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderVerticleOutlined = function BorderVerticleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BorderVerticleOutlined$2
  }));
};

BorderVerticleOutlined.displayName = 'BorderVerticleOutlined';
var BorderVerticleOutlined$1 = /*#__PURE__*/React.forwardRef(BorderVerticleOutlined);

// This icon file is generated automatically.
var BorderlessTableOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M117 368h231v64H117zm559 0h241v64H676zm-264 0h200v64H412zm0 224h200v64H412zm264 0h241v64H676zm-559 0h231v64H117zm295-160V179h-64v666h64V592zm264-64V179h-64v666h64V432z" } }] }, "name": "borderless-table", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BorderlessTableOutlined = function BorderlessTableOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BorderlessTableOutlined$2
  }));
};

BorderlessTableOutlined.displayName = 'BorderlessTableOutlined';
var BorderlessTableOutlined$1 = /*#__PURE__*/React.forwardRef(BorderlessTableOutlined);

// This icon file is generated automatically.
var BoxPlotFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z" } }] }, "name": "box-plot", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BoxPlotFilled = function BoxPlotFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotFilled$2
  }));
};

BoxPlotFilled.displayName = 'BoxPlotFilled';
var BoxPlotFilled$1 = /*#__PURE__*/React.forwardRef(BoxPlotFilled);

// This icon file is generated automatically.
var BoxPlotOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z" } }] }, "name": "box-plot", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BoxPlotOutlined = function BoxPlotOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotOutlined$2
  }));
};

BoxPlotOutlined.displayName = 'BoxPlotOutlined';
var BoxPlotOutlined$1 = /*#__PURE__*/React.forwardRef(BoxPlotOutlined);

// This icon file is generated automatically.
var BoxPlotTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 368h88v288h-88zm152 0h280v288H448z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z", "fill": primaryColor } }] }; }, "name": "box-plot", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BoxPlotTwoTone = function BoxPlotTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotTwoTone$2
  }));
};

BoxPlotTwoTone.displayName = 'BoxPlotTwoTone';
var BoxPlotTwoTone$1 = /*#__PURE__*/React.forwardRef(BoxPlotTwoTone);

// This icon file is generated automatically.
var BranchesOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0034.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm96 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm408-491a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "branches", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BranchesOutlined = function BranchesOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BranchesOutlined$2
  }));
};

BranchesOutlined.displayName = 'BranchesOutlined';
var BranchesOutlined$1 = /*#__PURE__*/React.forwardRef(BranchesOutlined);

// This icon file is generated automatically.
var BugFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 00-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 00-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 01-63 63H232a63 63 0 01-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0022.7 49c24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5a281.38 281.38 0 00123.2-149.5A120.4 120.4 0 01836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "bug", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BugFilled = function BugFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BugFilled$2
  }));
};

BugFilled.displayName = 'BugFilled';
var BugFilled$1 = /*#__PURE__*/React.forwardRef(BugFilled);

// This icon file is generated automatically.
var BugOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 00-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 00-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 01-63 63H232a63 63 0 01-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0022.7 49c24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2a281.38 281.38 0 00123.2-149.5A120 120 0 01836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3A202.75 202.75 0 01308 680V412h408v268z" } }] }, "name": "bug", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BugOutlined = function BugOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BugOutlined$2
  }));
};

BugOutlined.displayName = 'BugOutlined';
var BugOutlined$1 = /*#__PURE__*/React.forwardRef(BugOutlined);

// This icon file is generated automatically.
var BugTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0073.3 73.3A202.68 202.68 0 00512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0073.3-73.3A202.68 202.68 0 00716 680V412H308zm484 172v96c0 6.5-.22 12.95-.66 19.35C859.94 728.64 908 796.7 908 876a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-44.24-23.94-82.89-59.57-103.7a278.63 278.63 0 01-22.66 49.02 281.39 281.39 0 01-100.45 100.45C611.84 946.07 563.55 960 512 960s-99.84-13.93-141.32-38.23a281.39 281.39 0 01-100.45-100.45 278.63 278.63 0 01-22.66-49.02A119.95 119.95 0 00188 876a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-79.3 48.07-147.36 116.66-176.65A284.12 284.12 0 01232 680v-96H84a8 8 0 01-8-8v-56a8 8 0 018-8h148V412c-76.77 0-139-62.23-139-139a8 8 0 018-8h60a8 8 0 018 8 63 63 0 0063 63h560a63 63 0 0063-63 8 8 0 018-8h60a8 8 0 018 8c0 76.77-62.23 139-139 139v100h148a8 8 0 018 8v56a8 8 0 01-8 8H792zM368 272a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-40.04 8.78-76.75 25.9-108.07a184.57 184.57 0 0174.03-74.03C427.25 72.78 463.96 64 504 64h16c40.04 0 76.75 8.78 108.07 25.9a184.57 184.57 0 0174.03 74.03C719.22 195.25 728 231.96 728 272a8 8 0 01-8 8h-56a8 8 0 01-8-8c0-28.33-5.94-53.15-17.08-73.53a112.56 112.56 0 00-45.39-45.4C573.15 141.95 548.33 136 520 136h-16c-28.33 0-53.15 5.94-73.53 17.08a112.56 112.56 0 00-45.4 45.39C373.95 218.85 368 243.67 368 272z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0073.3 73.3A202.68 202.68 0 00512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0073.3-73.3A202.68 202.68 0 00716 680V412H308z", "fill": secondaryColor } }] }; }, "name": "bug", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BugTwoTone = function BugTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BugTwoTone$2
  }));
};

BugTwoTone.displayName = 'BugTwoTone';
var BugTwoTone$1 = /*#__PURE__*/React.forwardRef(BugTwoTone);

// This icon file is generated automatically.
var BuildFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z" } }] }, "name": "build", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BuildFilled = function BuildFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BuildFilled$2
  }));
};

BuildFilled.displayName = 'BuildFilled';
var BuildFilled$1 = /*#__PURE__*/React.forwardRef(BuildFilled);

// This icon file is generated automatically.
var BuildOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z" } }] }, "name": "build", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BuildOutlined = function BuildOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BuildOutlined$2
  }));
};

BuildOutlined.displayName = 'BuildOutlined';
var BuildOutlined$1 = /*#__PURE__*/React.forwardRef(BuildOutlined);

// This icon file is generated automatically.
var BuildTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M144 546h200v200H144zm268-268h200v200H412z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z", "fill": primaryColor } }] }; }, "name": "build", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BuildTwoTone = function BuildTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BuildTwoTone$2
  }));
};

BuildTwoTone.displayName = 'BuildTwoTone';
var BuildTwoTone$1 = /*#__PURE__*/React.forwardRef(BuildTwoTone);

// This icon file is generated automatically.
var BulbFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z" } }] }, "name": "bulb", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var BulbFilled = function BulbFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BulbFilled$2
  }));
};

BulbFilled.displayName = 'BulbFilled';
var BulbFilled$1 = /*#__PURE__*/React.forwardRef(BulbFilled);

// This icon file is generated automatically.
var BulbOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z" } }] }, "name": "bulb", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var BulbOutlined = function BulbOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BulbOutlined$2
  }));
};

BulbOutlined.displayName = 'BulbOutlined';
var BulbOutlined$1 = /*#__PURE__*/React.forwardRef(BulbOutlined);

// This icon file is generated automatically.
var BulbTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z", "fill": primaryColor } }] }; }, "name": "bulb", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var BulbTwoTone = function BulbTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: BulbTwoTone$2
  }));
};

BulbTwoTone.displayName = 'BulbTwoTone';
var BulbTwoTone$1 = /*#__PURE__*/React.forwardRef(BulbTwoTone);

// This icon file is generated automatically.
var CalculatorFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 01-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z" } }] }, "name": "calculator", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CalculatorFilled = function CalculatorFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorFilled$2
  }));
};

CalculatorFilled.displayName = 'CalculatorFilled';
var CalculatorFilled$1 = /*#__PURE__*/React.forwardRef(CalculatorFilled);

// This icon file is generated automatically.
var CalculatorOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 00-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z" } }] }, "name": "calculator", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CalculatorOutlined = function CalculatorOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorOutlined$2
  }));
};

CalculatorOutlined.displayName = 'CalculatorOutlined';
var CalculatorOutlined$1 = /*#__PURE__*/React.forwardRef(CalculatorOutlined);

// This icon file is generated automatically.
var CalculatorTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 01-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 00-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z", "fill": primaryColor } }] }; }, "name": "calculator", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CalculatorTwoTone = function CalculatorTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorTwoTone$2
  }));
};

CalculatorTwoTone.displayName = 'CalculatorTwoTone';
var CalculatorTwoTone$1 = /*#__PURE__*/React.forwardRef(CalculatorTwoTone);

// This icon file is generated automatically.
var CalendarFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z" } }] }, "name": "calendar", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CalendarFilled = function CalendarFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CalendarFilled$2
  }));
};

CalendarFilled.displayName = 'CalendarFilled';
var CalendarFilled$1 = /*#__PURE__*/React.forwardRef(CalendarFilled);

// This icon file is generated automatically.
var CalendarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, "name": "calendar", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CalendarOutlined = function CalendarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CalendarOutlined$2
  }));
};

CalendarOutlined.displayName = 'CalendarOutlined';
var CalendarOutlined$1 = /*#__PURE__*/React.forwardRef(CalendarOutlined);

// This icon file is generated automatically.
var CalendarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z", "fill": primaryColor } }] }; }, "name": "calendar", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CalendarTwoTone = function CalendarTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CalendarTwoTone$2
  }));
};

CalendarTwoTone.displayName = 'CalendarTwoTone';
var CalendarTwoTone$1 = /*#__PURE__*/React.forwardRef(CalendarTwoTone);

// This icon file is generated automatically.
var CameraFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 260H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 10192 0 96 96 0 10-192 0z" } }] }, "name": "camera", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CameraFilled = function CameraFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CameraFilled$2
  }));
};

CameraFilled.displayName = 'CameraFilled';
var CameraFilled$1 = /*#__PURE__*/React.forwardRef(CameraFilled);

// This icon file is generated automatically.
var CameraOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z" } }] }, "name": "camera", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CameraOutlined = function CameraOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CameraOutlined$2
  }));
};

CameraOutlined.displayName = 'CameraOutlined';
var CameraOutlined$1 = /*#__PURE__*/React.forwardRef(CameraOutlined);

// This icon file is generated automatically.
var CameraTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z", "fill": primaryColor } }] }; }, "name": "camera", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CameraTwoTone = function CameraTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CameraTwoTone$2
  }));
};

CameraTwoTone.displayName = 'CameraTwoTone';
var CameraTwoTone$1 = /*#__PURE__*/React.forwardRef(CameraTwoTone);

// This icon file is generated automatically.
var CarFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M959 413.4L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z" } }] }, "name": "car", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CarFilled = function CarFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CarFilled$2
  }));
};

CarFilled.displayName = 'CarFilled';
var CarFilled$1 = /*#__PURE__*/React.forwardRef(CarFilled);

// This icon file is generated automatically.
var CarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1080 0 40 40 0 10-80 0zm239-167.6L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "car", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CarOutlined = function CarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CarOutlined$2
  }));
};

CarOutlined.displayName = 'CarOutlined';
var CarOutlined$1 = /*#__PURE__*/React.forwardRef(CarOutlined);

// This icon file is generated automatically.
var CarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M720 581a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M959 413.4L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M224 581a40 40 0 1080 0 40 40 0 10-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "car", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CarTwoTone = function CarTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CarTwoTone$2
  }));
};

CarTwoTone.displayName = 'CarTwoTone';
var CarTwoTone$1 = /*#__PURE__*/React.forwardRef(CarTwoTone);

// This icon file is generated automatically.
var CaretDownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CaretDownFilled = function CaretDownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CaretDownFilled$2
  }));
};

CaretDownFilled.displayName = 'CaretDownFilled';
var CaretDownFilled$1 = /*#__PURE__*/React.forwardRef(CaretDownFilled);

// This icon file is generated automatically.
var CaretDownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, "name": "caret-down", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CaretDownOutlined = function CaretDownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CaretDownOutlined$2
  }));
};

CaretDownOutlined.displayName = 'CaretDownOutlined';
var CaretDownOutlined$1 = /*#__PURE__*/React.forwardRef(CaretDownOutlined);

// This icon file is generated automatically.
var CaretLeftFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" } }] }, "name": "caret-left", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CaretLeftFilled = function CaretLeftFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CaretLeftFilled$2
  }));
};

CaretLeftFilled.displayName = 'CaretLeftFilled';
var CaretLeftFilled$1 = /*#__PURE__*/React.forwardRef(CaretLeftFilled);

// This icon file is generated automatically.
var CaretLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" } }] }, "name": "caret-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CaretLeftOutlined = function CaretLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CaretLeftOutlined$2
  }));
};

CaretLeftOutlined.displayName = 'CaretLeftOutlined';
var CaretLeftOutlined$1 = /*#__PURE__*/React.forwardRef(CaretLeftOutlined);

// This icon file is generated automatically.
var CaretRightFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z" } }] }, "name": "caret-right", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CaretRightFilled = function CaretRightFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CaretRightFilled$2
  }));
};

CaretRightFilled.displayName = 'CaretRightFilled';
var CaretRightFilled$1 = /*#__PURE__*/React.forwardRef(CaretRightFilled);

// This icon file is generated automatically.
var CaretRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z" } }] }, "name": "caret-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CaretRightOutlined = function CaretRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CaretRightOutlined$2
  }));
};

CaretRightOutlined.displayName = 'CaretRightOutlined';
var CaretRightOutlined$1 = /*#__PURE__*/React.forwardRef(CaretRightOutlined);

// This icon file is generated automatically.
var CaretUpFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, "name": "caret-up", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CaretUpFilled = function CaretUpFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CaretUpFilled$2
  }));
};

CaretUpFilled.displayName = 'CaretUpFilled';
var CaretUpFilled$1 = /*#__PURE__*/React.forwardRef(CaretUpFilled);

// This icon file is generated automatically.
var CaretUpOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, "name": "caret-up", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CaretUpOutlined = function CaretUpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CaretUpOutlined$2
  }));
};

CaretUpOutlined.displayName = 'CaretUpOutlined';
var CaretUpOutlined$1 = /*#__PURE__*/React.forwardRef(CaretUpOutlined);

// This icon file is generated automatically.
var CarryOutFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z" } }] }, "name": "carry-out", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CarryOutFilled = function CarryOutFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CarryOutFilled$2
  }));
};

CarryOutFilled.displayName = 'CarryOutFilled';
var CarryOutFilled$1 = /*#__PURE__*/React.forwardRef(CarryOutFilled);

// This icon file is generated automatically.
var CarryOutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z" } }] }, "name": "carry-out", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CarryOutOutlined = function CarryOutOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CarryOutOutlined$2
  }));
};

CarryOutOutlined.displayName = 'CarryOutOutlined';
var CarryOutOutlined$1 = /*#__PURE__*/React.forwardRef(CarryOutOutlined);

// This icon file is generated automatically.
var CarryOutTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z", "fill": primaryColor } }] }; }, "name": "carry-out", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CarryOutTwoTone = function CarryOutTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CarryOutTwoTone$2
  }));
};

CarryOutTwoTone.displayName = 'CarryOutTwoTone';
var CarryOutTwoTone$1 = /*#__PURE__*/React.forwardRef(CarryOutTwoTone);

// This icon file is generated automatically.
var CheckCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CheckCircleFilled = function CheckCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleFilled$2
  }));
};

CheckCircleFilled.displayName = 'CheckCircleFilled';
var CheckCircleFilled$1 = /*#__PURE__*/React.forwardRef(CheckCircleFilled);

// This icon file is generated automatically.
var CheckCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "check-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleOutlined$2
  }));
};

CheckCircleOutlined.displayName = 'CheckCircleOutlined';
var CheckCircleOutlined$1 = /*#__PURE__*/React.forwardRef(CheckCircleOutlined);

// This icon file is generated automatically.
var CheckCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z", "fill": primaryColor } }] }; }, "name": "check-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CheckCircleTwoTone = function CheckCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleTwoTone$2
  }));
};

CheckCircleTwoTone.displayName = 'CheckCircleTwoTone';
var CheckCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(CheckCircleTwoTone);

// This icon file is generated automatically.
var CheckOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CheckOutlined = function CheckOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CheckOutlined$2
  }));
};

CheckOutlined.displayName = 'CheckOutlined';
var CheckOutlined$1 = /*#__PURE__*/React.forwardRef(CheckOutlined);

// This icon file is generated automatically.
var CheckSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 01-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CheckSquareFilled = function CheckSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareFilled$2
  }));
};

CheckSquareFilled.displayName = 'CheckSquareFilled';
var CheckSquareFilled$1 = /*#__PURE__*/React.forwardRef(CheckSquareFilled);

// This icon file is generated automatically.
var CheckSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.1 657.7a31.8 31.8 0 0051.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "check-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CheckSquareOutlined = function CheckSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareOutlined$2
  }));
};

CheckSquareOutlined.displayName = 'CheckSquareOutlined';
var CheckSquareOutlined$1 = /*#__PURE__*/React.forwardRef(CheckSquareOutlined);

// This icon file is generated automatically.
var CheckSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 01-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M432.2 657.7a31.8 31.8 0 0051.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z", "fill": primaryColor } }] }; }, "name": "check-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CheckSquareTwoTone = function CheckSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareTwoTone$2
  }));
};

CheckSquareTwoTone.displayName = 'CheckSquareTwoTone';
var CheckSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(CheckSquareTwoTone);

// This icon file is generated automatically.
var ChromeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0096 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z" } }] }, "name": "chrome", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ChromeFilled = function ChromeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ChromeFilled$2
  }));
};

ChromeFilled.displayName = 'ChromeFilled';
var ChromeFilled$1 = /*#__PURE__*/React.forwardRef(ChromeFilled);

// This icon file is generated automatically.
var ChromeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z" } }] }, "name": "chrome", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ChromeOutlined = function ChromeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ChromeOutlined$2
  }));
};

ChromeOutlined.displayName = 'ChromeOutlined';
var ChromeOutlined$1 = /*#__PURE__*/React.forwardRef(ChromeOutlined);

// This icon file is generated automatically.
var CiCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z" } }] }, "name": "ci-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CiCircleFilled = function CiCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleFilled$2
  }));
};

CiCircleFilled.displayName = 'CiCircleFilled';
var CiCircleFilled$1 = /*#__PURE__*/React.forwardRef(CiCircleFilled);

// This icon file is generated automatically.
var CiCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z" } }] }, "name": "ci-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CiCircleOutlined = function CiCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleOutlined$2
  }));
};

CiCircleOutlined.displayName = 'CiCircleOutlined';
var CiCircleOutlined$1 = /*#__PURE__*/React.forwardRef(CiCircleOutlined);

// This icon file is generated automatically.
var CiCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z", "fill": primaryColor } }] }; }, "name": "ci-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CiCircleTwoTone = function CiCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleTwoTone$2
  }));
};

CiCircleTwoTone.displayName = 'CiCircleTwoTone';
var CiCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(CiCircleTwoTone);

// This icon file is generated automatically.
var CiOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z" } }] }, "name": "ci", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CiOutlined = function CiOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CiOutlined$2
  }));
};

CiOutlined.displayName = 'CiOutlined';
var CiOutlined$1 = /*#__PURE__*/React.forwardRef(CiOutlined);

// This icon file is generated automatically.
var CiTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z", "fill": primaryColor } }] }; }, "name": "ci", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CiTwoTone = function CiTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CiTwoTone$2
  }));
};

CiTwoTone.displayName = 'CiTwoTone';
var CiTwoTone$1 = /*#__PURE__*/React.forwardRef(CiTwoTone);

// This icon file is generated automatically.
var ClearOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M899.1 869.6l-53-305.6H864c14.4 0 26-11.6 26-26V346c0-14.4-11.6-26-26-26H618V138c0-14.4-11.6-26-26-26H432c-14.4 0-26 11.6-26 26v182H160c-14.4 0-26 11.6-26 26v192c0 14.4 11.6 26 26 26h17.9l-53 305.6a25.95 25.95 0 0025.6 30.4h723c1.5 0 3-.1 4.4-.4a25.88 25.88 0 0021.2-30zM204 390h272V182h72v208h272v104H204V390zm468 440V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H416V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H202.8l45.1-260H776l45.1 260H672z" } }] }, "name": "clear", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ClearOutlined = function ClearOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ClearOutlined$2
  }));
};

ClearOutlined.displayName = 'ClearOutlined';
var ClearOutlined$1 = /*#__PURE__*/React.forwardRef(ClearOutlined);

// This icon file is generated automatically.
var ClockCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 01-11.2 1.7L483.3 569.8a7.92 7.92 0 01-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z" } }] }, "name": "clock-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ClockCircleFilled = function ClockCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleFilled$2
  }));
};

ClockCircleFilled.displayName = 'ClockCircleFilled';
var ClockCircleFilled$1 = /*#__PURE__*/React.forwardRef(ClockCircleFilled);

// This icon file is generated automatically.
var ClockCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, "name": "clock-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleOutlined$2
  }));
};

ClockCircleOutlined.displayName = 'ClockCircleOutlined';
var ClockCircleOutlined$1 = /*#__PURE__*/React.forwardRef(ClockCircleOutlined);

// This icon file is generated automatically.
var ClockCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 01-11.2 1.7L483.3 569.8a7.92 7.92 0 01-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z", "fill": primaryColor } }] }; }, "name": "clock-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ClockCircleTwoTone = function ClockCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleTwoTone$2
  }));
};

ClockCircleTwoTone.displayName = 'ClockCircleTwoTone';
var ClockCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(ClockCircleTwoTone);

// This icon file is generated automatically.
var CloseCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" } }] }, "name": "close-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CloseCircleFilled = function CloseCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleFilled$2
  }));
};

CloseCircleFilled.displayName = 'CloseCircleFilled';
var CloseCircleFilled$1 = /*#__PURE__*/React.forwardRef(CloseCircleFilled);

// This icon file is generated automatically.
var CloseCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z" } }, { "tag": "path", "attrs": { "d": "M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "close-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleOutlined$2
  }));
};

CloseCircleOutlined.displayName = 'CloseCircleOutlined';
var CloseCircleOutlined$1 = /*#__PURE__*/React.forwardRef(CloseCircleOutlined);

// This icon file is generated automatically.
var CloseCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 01-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z", "fill": primaryColor } }] }; }, "name": "close-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CloseCircleTwoTone = function CloseCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleTwoTone$2
  }));
};

CloseCircleTwoTone.displayName = 'CloseCircleTwoTone';
var CloseCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(CloseCircleTwoTone);

// This icon file is generated automatically.
var CloseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" } }] }, "name": "close", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloseOutlined = function CloseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloseOutlined$2
  }));
};

CloseOutlined.displayName = 'CloseOutlined';
var CloseOutlined$1 = /*#__PURE__*/React.forwardRef(CloseOutlined);

// This icon file is generated automatically.
var CloseSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM676.1 657.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1A7.95 7.95 0 01354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9z" } }] }, "name": "close-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CloseSquareFilled = function CloseSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareFilled$2
  }));
};

CloseSquareFilled.displayName = 'CloseSquareFilled';
var CloseSquareFilled$1 = /*#__PURE__*/React.forwardRef(CloseSquareFilled);

// This icon file is generated automatically.
var CloseSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M354 671h58.9c4.7 0 9.2-2.1 12.3-5.7L512 561.8l86.8 103.5c3 3.6 7.5 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.4-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.7 0-9.2 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3-3.6-7.5-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 00354 671z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "close-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloseSquareOutlined = function CloseSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareOutlined$2
  }));
};

CloseSquareOutlined.displayName = 'CloseSquareOutlined';
var CloseSquareOutlined$1 = /*#__PURE__*/React.forwardRef(CloseSquareOutlined);

// This icon file is generated automatically.
var CloseSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 01354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 00354 671z", "fill": primaryColor } }] }; }, "name": "close-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CloseSquareTwoTone = function CloseSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareTwoTone$2
  }));
};

CloseSquareTwoTone.displayName = 'CloseSquareTwoTone';
var CloseSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(CloseSquareTwoTone);

// This icon file is generated automatically.
var CloudDownloadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z" } }, { "tag": "path", "attrs": { "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z" } }] }, "name": "cloud-download", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloudDownloadOutlined = function CloudDownloadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloudDownloadOutlined$2
  }));
};

CloudDownloadOutlined.displayName = 'CloudDownloadOutlined';
var CloudDownloadOutlined$1 = /*#__PURE__*/React.forwardRef(CloudDownloadOutlined);

// This icon file is generated automatically.
var CloudFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z" } }] }, "name": "cloud", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CloudFilled = function CloudFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloudFilled$2
  }));
};

CloudFilled.displayName = 'CloudFilled';
var CloudFilled$1 = /*#__PURE__*/React.forwardRef(CloudFilled);

// This icon file is generated automatically.
var CloudOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 01-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 01140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0166.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z" } }] }, "name": "cloud", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloudOutlined = function CloudOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloudOutlined$2
  }));
};

CloudOutlined.displayName = 'CloudOutlined';
var CloudOutlined$1 = /*#__PURE__*/React.forwardRef(CloudOutlined);

// This icon file is generated automatically.
var CloudServerOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z" } }, { "tag": "path", "attrs": { "d": "M424 748a32 32 0 1064 0 32 32 0 10-64 0zm0-178a32 32 0 1064 0 32 32 0 10-64 0z" } }, { "tag": "path", "attrs": { "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z" } }] }, "name": "cloud-server", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloudServerOutlined = function CloudServerOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloudServerOutlined$2
  }));
};

CloudServerOutlined.displayName = 'CloudServerOutlined';
var CloudServerOutlined$1 = /*#__PURE__*/React.forwardRef(CloudServerOutlined);

// This icon file is generated automatically.
var CloudSyncOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z" } }, { "tag": "path", "attrs": { "d": "M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 003 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 00-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z" } }] }, "name": "cloud-sync", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloudSyncOutlined = function CloudSyncOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloudSyncOutlined$2
  }));
};

CloudSyncOutlined.displayName = 'CloudSyncOutlined';
var CloudSyncOutlined$1 = /*#__PURE__*/React.forwardRef(CloudSyncOutlined);

// This icon file is generated automatically.
var CloudTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 00-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 00-52.4 49.9 240.47 240.47 0 00-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 00-66.1 43.7A123.1 123.1 0 00140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 00884 612c0-56.2-37.8-105.5-92.1-120z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 01-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 01140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0166.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z", "fill": primaryColor } }] }; }, "name": "cloud", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CloudTwoTone = function CloudTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloudTwoTone$2
  }));
};

CloudTwoTone.displayName = 'CloudTwoTone';
var CloudTwoTone$1 = /*#__PURE__*/React.forwardRef(CloudTwoTone);

// This icon file is generated automatically.
var CloudUploadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M518.3 459a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z" } }, { "tag": "path", "attrs": { "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z" } }] }, "name": "cloud-upload", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CloudUploadOutlined = function CloudUploadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CloudUploadOutlined$2
  }));
};

CloudUploadOutlined.displayName = 'CloudUploadOutlined';
var CloudUploadOutlined$1 = /*#__PURE__*/React.forwardRef(CloudUploadOutlined);

// This icon file is generated automatically.
var ClusterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "cluster", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ClusterOutlined = function ClusterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ClusterOutlined$2
  }));
};

ClusterOutlined.displayName = 'ClusterOutlined';
var ClusterOutlined$1 = /*#__PURE__*/React.forwardRef(ClusterOutlined);

// This icon file is generated automatically.
var CodeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 01-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z" } }] }, "name": "code", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CodeFilled = function CodeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CodeFilled$2
  }));
};

CodeFilled.displayName = 'CodeFilled';
var CodeFilled$1 = /*#__PURE__*/React.forwardRef(CodeFilled);

// This icon file is generated automatically.
var CodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "code", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CodeOutlined = function CodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CodeOutlined$2
  }));
};

CodeOutlined.displayName = 'CodeOutlined';
var CodeOutlined$1 = /*#__PURE__*/React.forwardRef(CodeOutlined);

// This icon file is generated automatically.
var CodeSandboxCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z" } }] }, "name": "code-sandbox-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CodeSandboxCircleFilled = function CodeSandboxCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxCircleFilled$2
  }));
};

CodeSandboxCircleFilled.displayName = 'CodeSandboxCircleFilled';
var CodeSandboxCircleFilled$1 = /*#__PURE__*/React.forwardRef(CodeSandboxCircleFilled);

// This icon file is generated automatically.
var CodeSandboxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z" } }] }, "name": "code-sandbox", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CodeSandboxOutlined = function CodeSandboxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxOutlined$2
  }));
};

CodeSandboxOutlined.displayName = 'CodeSandboxOutlined';
var CodeSandboxOutlined$1 = /*#__PURE__*/React.forwardRef(CodeSandboxOutlined);

// This icon file is generated automatically.
var CodeSandboxSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z" } }] }, "name": "code-sandbox-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CodeSandboxSquareFilled = function CodeSandboxSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxSquareFilled$2
  }));
};

CodeSandboxSquareFilled.displayName = 'CodeSandboxSquareFilled';
var CodeSandboxSquareFilled$1 = /*#__PURE__*/React.forwardRef(CodeSandboxSquareFilled);

// This icon file is generated automatically.
var CodeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 01-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z", "fill": primaryColor } }] }; }, "name": "code", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CodeTwoTone = function CodeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CodeTwoTone$2
  }));
};

CodeTwoTone.displayName = 'CodeTwoTone';
var CodeTwoTone$1 = /*#__PURE__*/React.forwardRef(CodeTwoTone);

// This icon file is generated automatically.
var CodepenCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z" } }] }, "name": "codepen-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CodepenCircleFilled = function CodepenCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CodepenCircleFilled$2
  }));
};

CodepenCircleFilled.displayName = 'CodepenCircleFilled';
var CodepenCircleFilled$1 = /*#__PURE__*/React.forwardRef(CodepenCircleFilled);

// This icon file is generated automatically.
var CodepenCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z" } }] }, "name": "codepen-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CodepenCircleOutlined = function CodepenCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CodepenCircleOutlined$2
  }));
};

CodepenCircleOutlined.displayName = 'CodepenCircleOutlined';
var CodepenCircleOutlined$1 = /*#__PURE__*/React.forwardRef(CodepenCircleOutlined);

// This icon file is generated automatically.
var CodepenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 00-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z" } }] }, "name": "codepen", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CodepenOutlined = function CodepenOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CodepenOutlined$2
  }));
};

CodepenOutlined.displayName = 'CodepenOutlined';
var CodepenOutlined$1 = /*#__PURE__*/React.forwardRef(CodepenOutlined);

// This icon file is generated automatically.
var CodepenSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 01-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 01-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 01.8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z" } }] }, "name": "codepen-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CodepenSquareFilled = function CodepenSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CodepenSquareFilled$2
  }));
};

CodepenSquareFilled.displayName = 'CodepenSquareFilled';
var CodepenSquareFilled$1 = /*#__PURE__*/React.forwardRef(CodepenSquareFilled);

// This icon file is generated automatically.
var CoffeeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z" } }] }, "name": "coffee", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CoffeeOutlined = function CoffeeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CoffeeOutlined$2
  }));
};

CoffeeOutlined.displayName = 'CoffeeOutlined';
var CoffeeOutlined$1 = /*#__PURE__*/React.forwardRef(CoffeeOutlined);

// This icon file is generated automatically.
var ColumnHeightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 00-11.3 0L403.6 366.3a7.23 7.23 0 005.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z" } }] }, "name": "column-height", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ColumnHeightOutlined = function ColumnHeightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ColumnHeightOutlined$2
  }));
};

ColumnHeightOutlined.displayName = 'ColumnHeightOutlined';
var ColumnHeightOutlined$1 = /*#__PURE__*/React.forwardRef(ColumnHeightOutlined);

// This icon file is generated automatically.
var ColumnWidthOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 00-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z" } }] }, "name": "column-width", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ColumnWidthOutlined = function ColumnWidthOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ColumnWidthOutlined$2
  }));
};

ColumnWidthOutlined.displayName = 'ColumnWidthOutlined';
var ColumnWidthOutlined$1 = /*#__PURE__*/React.forwardRef(ColumnWidthOutlined);

// This icon file is generated automatically.
var CommentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M573 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40zm-280 0c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z" } }, { "tag": "path", "attrs": { "d": "M894 345a343.92 343.92 0 00-189-130v.1c-17.1-19-36.4-36.5-58-52.1-163.7-119-393.5-82.7-513 81-96.3 133-92.2 311.9 6 439l.8 132.6c0 3.2.5 6.4 1.5 9.4a31.95 31.95 0 0040.1 20.9L309 806c33.5 11.9 68.1 18.7 102.5 20.6l-.5.4c89.1 64.9 205.9 84.4 313 49l127.1 41.4c3.2 1 6.5 1.6 9.9 1.6 17.7 0 32-14.3 32-32V753c88.1-119.6 90.4-284.9 1-408zM323 735l-12-5-99 31-1-104-8-9c-84.6-103.2-90.2-251.9-11-361 96.4-132.2 281.2-161.4 413-66 132.2 96.1 161.5 280.6 66 412-80.1 109.9-223.5 150.5-348 102zm505-17l-8 10 1 104-98-33-12 5c-56 20.8-115.7 22.5-171 7l-.2-.1A367.31 367.31 0 00729 676c76.4-105.3 88.8-237.6 44.4-350.4l.6.4c23 16.5 44.1 37.1 62 62 72.6 99.6 68.5 235.2-8 330z" } }, { "tag": "path", "attrs": { "d": "M433 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z" } }] }, "name": "comment", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CommentOutlined = function CommentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CommentOutlined$2
  }));
};

CommentOutlined.displayName = 'CommentOutlined';
var CommentOutlined$1 = /*#__PURE__*/React.forwardRef(CommentOutlined);

// This icon file is generated automatically.
var CompassFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z" } }] }, "name": "compass", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CompassFilled = function CompassFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CompassFilled$2
  }));
};

CompassFilled.displayName = 'CompassFilled';
var CompassFilled$1 = /*#__PURE__*/React.forwardRef(CompassFilled);

// This icon file is generated automatically.
var CompassOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 00-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 00-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z" } }] }, "name": "compass", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CompassOutlined = function CompassOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CompassOutlined$2
  }));
};

CompassOutlined.displayName = 'CompassOutlined';
var CompassOutlined$1 = /*#__PURE__*/React.forwardRef(CompassOutlined);

// This icon file is generated automatically.
var CompassTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }] }; }, "name": "compass", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CompassTwoTone = function CompassTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CompassTwoTone$2
  }));
};

CompassTwoTone.displayName = 'CompassTwoTone';
var CompassTwoTone$1 = /*#__PURE__*/React.forwardRef(CompassTwoTone);

// This icon file is generated automatically.
var CompressOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M326 664H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V696c0-17.7-14.3-32-32-32zm16-576h-48c-8.8 0-16 7.2-16 16v176H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V104c0-8.8-7.2-16-16-16zm578 576H698c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V744h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm0-384H746V104c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16z" } }] }, "name": "compress", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CompressOutlined = function CompressOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CompressOutlined$2
  }));
};

CompressOutlined.displayName = 'CompressOutlined';
var CompressOutlined$1 = /*#__PURE__*/React.forwardRef(CompressOutlined);

// This icon file is generated automatically.
var ConsoleSqlOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M301.3 496.7c-23.8 0-40.2-10.5-41.6-26.9H205c.9 43.4 36.9 70.3 93.9 70.3 59.1 0 95-28.4 95-75.5 0-35.8-20-55.9-64.5-64.5l-29.1-5.6c-23.8-4.7-33.8-11.9-33.8-24.2 0-15 13.3-24.5 33.4-24.5 20.1 0 35.3 11.1 36.6 27h53c-.9-41.7-37.5-70.3-90.3-70.3-54.4 0-89.7 28.9-89.7 73 0 35.5 21.2 58 62.5 65.8l29.7 5.9c25.8 5.2 35.6 11.9 35.6 24.4.1 14.7-14.5 25.1-36 25.1z" } }, { "tag": "path", "attrs": { "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z" } }, { "tag": "path", "attrs": { "d": "M828.5 486.7h-95.8V308.5h-57.4V534h153.2zm-298.6 53.4c14.1 0 27.2-2 39.1-5.8l13.3 20.3h53.3L607.9 511c21.1-20 33-51.1 33-89.8 0-73.3-43.3-118.8-110.9-118.8s-111.2 45.3-111.2 118.8c-.1 73.7 43 118.9 111.1 118.9zm0-190c31.6 0 52.7 27.7 52.7 71.1 0 16.7-3.6 30.6-10 40.5l-5.2-6.9h-48.8L542 491c-3.9.9-8 1.4-12.2 1.4-31.7 0-52.8-27.5-52.8-71.2.1-43.6 21.2-71.1 52.9-71.1z" } }] }, "name": "console-sql", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ConsoleSqlOutlined = function ConsoleSqlOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ConsoleSqlOutlined$2
  }));
};

ConsoleSqlOutlined.displayName = 'ConsoleSqlOutlined';
var ConsoleSqlOutlined$1 = /*#__PURE__*/React.forwardRef(ConsoleSqlOutlined);

// This icon file is generated automatically.
var ContactsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 01-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 01-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z" } }] }, "name": "contacts", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ContactsFilled = function ContactsFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ContactsFilled$2
  }));
};

ContactsFilled.displayName = 'ContactsFilled';
var ContactsFilled$1 = /*#__PURE__*/React.forwardRef(ContactsFilled);

// This icon file is generated automatically.
var ContactsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M594.3 601.5a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1 8 8 0 008 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z" } }] }, "name": "contacts", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ContactsOutlined = function ContactsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ContactsOutlined$2
  }));
};

ContactsOutlined.displayName = 'ContactsOutlined';
var ContactsOutlined$1 = /*#__PURE__*/React.forwardRef(ContactsOutlined);

// This icon file is generated automatically.
var ContactsTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M460.3 526a51.7 52 0 10103.4 0 51.7 52 0 10-103.4 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 01-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 01-8 8.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M594.3 601.5a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1 8 8 0 008 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z", "fill": primaryColor } }] }; }, "name": "contacts", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ContactsTwoTone = function ContactsTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ContactsTwoTone$2
  }));
};

ContactsTwoTone.displayName = 'ContactsTwoTone';
var ContactsTwoTone$1 = /*#__PURE__*/React.forwardRef(ContactsTwoTone);

// This icon file is generated automatically.
var ContainerFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 01-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z" } }] }, "name": "container", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ContainerFilled = function ContainerFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ContainerFilled$2
  }));
};

ContainerFilled.displayName = 'ContainerFilled';
var ContainerFilled$1 = /*#__PURE__*/React.forwardRef(ContainerFilled);

// This icon file is generated automatically.
var ContainerOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] }, "name": "container", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ContainerOutlined = function ContainerOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ContainerOutlined$2
  }));
};

ContainerOutlined.displayName = 'ContainerOutlined';
var ContainerOutlined$1 = /*#__PURE__*/React.forwardRef(ContainerOutlined);

// This icon file is generated automatically.
var ContainerTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 01-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "container", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ContainerTwoTone = function ContainerTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ContainerTwoTone$2
  }));
};

ContainerTwoTone.displayName = 'ContainerTwoTone';
var ContainerTwoTone$1 = /*#__PURE__*/React.forwardRef(ContainerTwoTone);

// This icon file is generated automatically.
var ControlFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1072 0 36 36 0 10-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 00-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z" } }] }, "name": "control", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ControlFilled = function ControlFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ControlFilled$2
  }));
};

ControlFilled.displayName = 'ControlFilled';
var ControlFilled$1 = /*#__PURE__*/React.forwardRef(ControlFilled);

// This icon file is generated automatically.
var ControlOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 015.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 015.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z" } }] }, "name": "control", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ControlOutlined = function ControlOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ControlOutlined$2
  }));
};

ControlOutlined.displayName = 'ControlOutlined';
var ControlOutlined$1 = /*#__PURE__*/React.forwardRef(ControlOutlined);

// This icon file is generated automatically.
var ControlTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M616 440a36 36 0 1072 0 36 36 0 10-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 00-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 01408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z", "fill": primaryColor } }] }; }, "name": "control", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ControlTwoTone = function ControlTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ControlTwoTone$2
  }));
};

ControlTwoTone.displayName = 'ControlTwoTone';
var ControlTwoTone$1 = /*#__PURE__*/React.forwardRef(ControlTwoTone);

// This icon file is generated automatically.
var CopyFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z" } }] }, "name": "copy", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CopyFilled = function CopyFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CopyFilled$2
  }));
};

CopyFilled.displayName = 'CopyFilled';
var CopyFilled$1 = /*#__PURE__*/React.forwardRef(CopyFilled);

// This icon file is generated automatically.
var CopyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, "name": "copy", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CopyOutlined = function CopyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CopyOutlined$2
  }));
};

CopyOutlined.displayName = 'CopyOutlined';
var CopyOutlined$1 = /*#__PURE__*/React.forwardRef(CopyOutlined);

// This icon file is generated automatically.
var CopyTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z", "fill": primaryColor } }] }; }, "name": "copy", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CopyTwoTone = function CopyTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CopyTwoTone$2
  }));
};

CopyTwoTone.displayName = 'CopyTwoTone';
var CopyTwoTone$1 = /*#__PURE__*/React.forwardRef(CopyTwoTone);

// This icon file is generated automatically.
var CopyrightCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z" } }] }, "name": "copyright-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CopyrightCircleFilled = function CopyrightCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleFilled$2
  }));
};

CopyrightCircleFilled.displayName = 'CopyrightCircleFilled';
var CopyrightCircleFilled$1 = /*#__PURE__*/React.forwardRef(CopyrightCircleFilled);

// This icon file is generated automatically.
var CopyrightCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z" } }] }, "name": "copyright-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CopyrightCircleOutlined = function CopyrightCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleOutlined$2
  }));
};

CopyrightCircleOutlined.displayName = 'CopyrightCircleOutlined';
var CopyrightCircleOutlined$1 = /*#__PURE__*/React.forwardRef(CopyrightCircleOutlined);

// This icon file is generated automatically.
var CopyrightCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z", "fill": primaryColor } }] }; }, "name": "copyright-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CopyrightCircleTwoTone = function CopyrightCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleTwoTone$2
  }));
};

CopyrightCircleTwoTone.displayName = 'CopyrightCircleTwoTone';
var CopyrightCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(CopyrightCircleTwoTone);

// This icon file is generated automatically.
var CopyrightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z" } }] }, "name": "copyright", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CopyrightOutlined = function CopyrightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightOutlined$2
  }));
};

CopyrightOutlined.displayName = 'CopyrightOutlined';
var CopyrightOutlined$1 = /*#__PURE__*/React.forwardRef(CopyrightOutlined);

// This icon file is generated automatically.
var CopyrightTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z", "fill": primaryColor } }] }; }, "name": "copyright", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CopyrightTwoTone = function CopyrightTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightTwoTone$2
  }));
};

CopyrightTwoTone.displayName = 'CopyrightTwoTone';
var CopyrightTwoTone$1 = /*#__PURE__*/React.forwardRef(CopyrightTwoTone);

// This icon file is generated automatically.
var CreditCardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z" } }] }, "name": "credit-card", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CreditCardFilled = function CreditCardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardFilled$2
  }));
};

CreditCardFilled.displayName = 'CreditCardFilled';
var CreditCardFilled$1 = /*#__PURE__*/React.forwardRef(CreditCardFilled);

// This icon file is generated automatically.
var CreditCardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z" } }] }, "name": "credit-card", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CreditCardOutlined = function CreditCardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardOutlined$2
  }));
};

CreditCardOutlined.displayName = 'CreditCardOutlined';
var CreditCardOutlined$1 = /*#__PURE__*/React.forwardRef(CreditCardOutlined);

// This icon file is generated automatically.
var CreditCardTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z", "fill": primaryColor } }] }; }, "name": "credit-card", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CreditCardTwoTone = function CreditCardTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CreditCardTwoTone$2
  }));
};

CreditCardTwoTone.displayName = 'CreditCardTwoTone';
var CreditCardTwoTone$1 = /*#__PURE__*/React.forwardRef(CreditCardTwoTone);

// This icon file is generated automatically.
var CrownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z" } }] }, "name": "crown", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CrownFilled = function CrownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CrownFilled$2
  }));
};

CrownFilled.displayName = 'CrownFilled';
var CrownFilled$1 = /*#__PURE__*/React.forwardRef(CrownFilled);

// This icon file is generated automatically.
var CrownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z" } }] }, "name": "crown", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CrownOutlined = function CrownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CrownOutlined$2
  }));
};

CrownOutlined.displayName = 'CrownOutlined';
var CrownOutlined$1 = /*#__PURE__*/React.forwardRef(CrownOutlined);

// This icon file is generated automatically.
var CrownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 00-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z", "fill": primaryColor } }] }; }, "name": "crown", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CrownTwoTone = function CrownTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CrownTwoTone$2
  }));
};

CrownTwoTone.displayName = 'CrownTwoTone';
var CrownTwoTone$1 = /*#__PURE__*/React.forwardRef(CrownTwoTone);

// This icon file is generated automatically.
var CustomerServiceFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z" } }] }, "name": "customer-service", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var CustomerServiceFilled = function CustomerServiceFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceFilled$2
  }));
};

CustomerServiceFilled.displayName = 'CustomerServiceFilled';
var CustomerServiceFilled$1 = /*#__PURE__*/React.forwardRef(CustomerServiceFilled);

// This icon file is generated automatically.
var CustomerServiceOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z" } }] }, "name": "customer-service", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var CustomerServiceOutlined = function CustomerServiceOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceOutlined$2
  }));
};

CustomerServiceOutlined.displayName = 'CustomerServiceOutlined';
var CustomerServiceOutlined$1 = /*#__PURE__*/React.forwardRef(CustomerServiceOutlined);

// This icon file is generated automatically.
var CustomerServiceTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 632h128v192H696zm-496 0h128v192H200z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z", "fill": primaryColor } }] }; }, "name": "customer-service", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var CustomerServiceTwoTone = function CustomerServiceTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceTwoTone$2
  }));
};

CustomerServiceTwoTone.displayName = 'CustomerServiceTwoTone';
var CustomerServiceTwoTone$1 = /*#__PURE__*/React.forwardRef(CustomerServiceTwoTone);

// This icon file is generated automatically.
var DashOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z" } }] }, "name": "dash", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DashOutlined = function DashOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DashOutlined$2
  }));
};

DashOutlined.displayName = 'DashOutlined';
var DashOutlined$1 = /*#__PURE__*/React.forwardRef(DashOutlined);

// This icon file is generated automatically.
var DashboardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 01-11.3 0L261.7 352a8.03 8.03 0 010-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 01-79.2 0 55.95 55.95 0 010-79.2 55.87 55.87 0 0154.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 010-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 01-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z" } }] }, "name": "dashboard", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DashboardFilled = function DashboardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DashboardFilled$2
  }));
};

DashboardFilled.displayName = 'DashboardFilled';
var DashboardFilled$1 = /*#__PURE__*/React.forwardRef(DashboardFilled);

// This icon file is generated automatically.
var DashboardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 01140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 00-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 000 79.2 55.95 55.95 0 0079.2 0 55.87 55.87 0 0014.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 00-11.3 0l-56.6 56.6a8.03 8.03 0 000 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 00-11.3 0l-31.1 31.1a8.03 8.03 0 000 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z" } }] }, "name": "dashboard", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DashboardOutlined = function DashboardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DashboardOutlined$2
  }));
};

DashboardOutlined.displayName = 'DashboardOutlined';
var DashboardOutlined$1 = /*#__PURE__*/React.forwardRef(DashboardOutlined);

// This icon file is generated automatically.
var DashboardTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 00884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 01-11.3 0l-56.6-56.6a8.03 8.03 0 010-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 01-79.2 0 55.95 55.95 0 010-79.2 55.87 55.87 0 0154.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 010-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 01-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M623.5 421.5a8.03 8.03 0 00-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 000 79.2 55.95 55.95 0 0079.2 0 55.87 55.87 0 0014.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 01140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M762.7 340.8l-31.1-31.1a8.03 8.03 0 00-11.3 0l-56.6 56.6a8.03 8.03 0 000 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 00-11.3 0l-31.1 31.1a8.03 8.03 0 000 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "dashboard", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DashboardTwoTone = function DashboardTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DashboardTwoTone$2
  }));
};

DashboardTwoTone.displayName = 'DashboardTwoTone';
var DashboardTwoTone$1 = /*#__PURE__*/React.forwardRef(DashboardTwoTone);

// This icon file is generated automatically.
var DatabaseFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z" } }] }, "name": "database", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DatabaseFilled = function DatabaseFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseFilled$2
  }));
};

DatabaseFilled.displayName = 'DatabaseFilled';
var DatabaseFilled$1 = /*#__PURE__*/React.forwardRef(DatabaseFilled);

// This icon file is generated automatically.
var DatabaseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "database", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DatabaseOutlined = function DatabaseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseOutlined$2
  }));
};

DatabaseOutlined.displayName = 'DatabaseOutlined';
var DatabaseOutlined$1 = /*#__PURE__*/React.forwardRef(DatabaseOutlined);

// This icon file is generated automatically.
var DatabaseTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 512a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0zm0-544a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z", "fill": primaryColor } }] }; }, "name": "database", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DatabaseTwoTone = function DatabaseTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseTwoTone$2
  }));
};

DatabaseTwoTone.displayName = 'DatabaseTwoTone';
var DatabaseTwoTone$1 = /*#__PURE__*/React.forwardRef(DatabaseTwoTone);

// This icon file is generated automatically.
var DeleteColumnOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M651.1 641.9a7.84 7.84 0 00-5.1-1.9h-54.7c-2.4 0-4.6 1.1-6.1 2.9L512 730.7l-73.1-87.8a8.1 8.1 0 00-6.1-2.9H378c-1.9 0-3.7.7-5.1 1.9a7.97 7.97 0 00-1 11.3L474.2 776 371.8 898.9a8.06 8.06 0 006.1 13.2h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8a8.1 8.1 0 006.1 2.9h55c1.9 0 3.7-.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L549.8 776l102.4-122.9c2.8-3.4 2.3-8.4-1.1-11.2zM472 544h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8zM350 386H184V136c0-3.3-2.7-6-6-6h-60c-3.3 0-6 2.7-6 6v292c0 16.6 13.4 30 30 30h208c3.3 0 6-2.7 6-6v-60c0-3.3-2.7-6-6-6zm556-256h-60c-3.3 0-6 2.7-6 6v250H674c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h208c16.6 0 30-13.4 30-30V136c0-3.3-2.7-6-6-6z" } }] }, "name": "delete-column", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DeleteColumnOutlined = function DeleteColumnOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DeleteColumnOutlined$2
  }));
};

DeleteColumnOutlined.displayName = 'DeleteColumnOutlined';
var DeleteColumnOutlined$1 = /*#__PURE__*/React.forwardRef(DeleteColumnOutlined);

// This icon file is generated automatically.
var DeleteFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z" } }] }, "name": "delete", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DeleteFilled = function DeleteFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DeleteFilled$2
  }));
};

DeleteFilled.displayName = 'DeleteFilled';
var DeleteFilled$1 = /*#__PURE__*/React.forwardRef(DeleteFilled);

// This icon file is generated automatically.
var DeleteOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, "name": "delete", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DeleteOutlined = function DeleteOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DeleteOutlined$2
  }));
};

DeleteOutlined.displayName = 'DeleteOutlined';
var DeleteOutlined$1 = /*#__PURE__*/React.forwardRef(DeleteOutlined);

// This icon file is generated automatically.
var DeleteRowOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M819.8 512l102.4-122.9a8.06 8.06 0 00-6.1-13.2h-54.7c-2.4 0-4.6 1.1-6.1 2.9L782 466.7l-73.1-87.8a8.1 8.1 0 00-6.1-2.9H648c-1.9 0-3.7.7-5.1 1.9a7.97 7.97 0 00-1 11.3L744.2 512 641.8 634.9a8.06 8.06 0 006.1 13.2h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8a8.1 8.1 0 006.1 2.9h55c1.9 0 3.7-.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L819.8 512zM536 464H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h416c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-84 204h-60c-3.3 0-6 2.7-6 6v166H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h292c16.6 0 30-13.4 30-30V674c0-3.3-2.7-6-6-6zM136 184h250v166c0 3.3 2.7 6 6 6h60c3.3 0 6-2.7 6-6V142c0-16.6-13.4-30-30-30H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6z" } }] }, "name": "delete-row", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DeleteRowOutlined = function DeleteRowOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DeleteRowOutlined$2
  }));
};

DeleteRowOutlined.displayName = 'DeleteRowOutlined';
var DeleteRowOutlined$1 = /*#__PURE__*/React.forwardRef(DeleteRowOutlined);

// This icon file is generated automatically.
var DeleteTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M292.7 840h438.6l24.2-512h-487z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z", "fill": primaryColor } }] }; }, "name": "delete", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DeleteTwoTone = function DeleteTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DeleteTwoTone$2
  }));
};

DeleteTwoTone.displayName = 'DeleteTwoTone';
var DeleteTwoTone$1 = /*#__PURE__*/React.forwardRef(DeleteTwoTone);

// This icon file is generated automatically.
var DeliveredProcedureOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M632 698.3l141.9-112a8 8 0 000-12.6L632 461.7c-5.3-4.2-13-.4-13 6.3v76H295c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v76c0 6.7 7.8 10.4 13 6.3zm261.3-405L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v278c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V422c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-83.5c0-17-6.7-33.2-18.7-45.2zM640 288H384V184h256v104zm264 436h-56c-4.4 0-8 3.6-8 8v108H184V732c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v148c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V732c0-4.4-3.6-8-8-8z" } }] }, "name": "delivered-procedure", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DeliveredProcedureOutlined = function DeliveredProcedureOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DeliveredProcedureOutlined$2
  }));
};

DeliveredProcedureOutlined.displayName = 'DeliveredProcedureOutlined';
var DeliveredProcedureOutlined$1 = /*#__PURE__*/React.forwardRef(DeliveredProcedureOutlined);

// This icon file is generated automatically.
var DeploymentUnitOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 01-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0165.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z" } }] }, "name": "deployment-unit", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DeploymentUnitOutlined = function DeploymentUnitOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DeploymentUnitOutlined$2
  }));
};

DeploymentUnitOutlined.displayName = 'DeploymentUnitOutlined';
var DeploymentUnitOutlined$1 = /*#__PURE__*/React.forwardRef(DeploymentUnitOutlined);

// This icon file is generated automatically.
var DesktopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z" } }] }, "name": "desktop", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DesktopOutlined = function DesktopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DesktopOutlined$2
  }));
};

DesktopOutlined.displayName = 'DesktopOutlined';
var DesktopOutlined$1 = /*#__PURE__*/React.forwardRef(DesktopOutlined);

// This icon file is generated automatically.
var DiffFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z" } }] }, "name": "diff", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DiffFilled = function DiffFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DiffFilled$2
  }));
};

DiffFilled.displayName = 'DiffFilled';
var DiffFilled$1 = /*#__PURE__*/React.forwardRef(DiffFilled);

// This icon file is generated automatically.
var DiffOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z" } }] }, "name": "diff", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DiffOutlined = function DiffOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DiffOutlined$2
  }));
};

DiffOutlined.displayName = 'DiffOutlined';
var DiffOutlined$1 = /*#__PURE__*/React.forwardRef(DiffOutlined);

// This icon file is generated automatically.
var DiffTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z", "fill": primaryColor } }] }; }, "name": "diff", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DiffTwoTone = function DiffTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DiffTwoTone$2
  }));
};

DiffTwoTone.displayName = 'DiffTwoTone';
var DiffTwoTone$1 = /*#__PURE__*/React.forwardRef(DiffTwoTone);

// This icon file is generated automatically.
var DingdingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z" } }] }, "name": "dingding", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DingdingOutlined = function DingdingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DingdingOutlined$2
  }));
};

DingdingOutlined.displayName = 'DingdingOutlined';
var DingdingOutlined$1 = /*#__PURE__*/React.forwardRef(DingdingOutlined);

// This icon file is generated automatically.
var DingtalkCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z" } }] }, "name": "dingtalk-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DingtalkCircleFilled = function DingtalkCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkCircleFilled$2
  }));
};

DingtalkCircleFilled.displayName = 'DingtalkCircleFilled';
var DingtalkCircleFilled$1 = /*#__PURE__*/React.forwardRef(DingtalkCircleFilled);

// This icon file is generated automatically.
var DingtalkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z" } }] }, "name": "dingtalk", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DingtalkOutlined = function DingtalkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkOutlined$2
  }));
};

DingtalkOutlined.displayName = 'DingtalkOutlined';
var DingtalkOutlined$1 = /*#__PURE__*/React.forwardRef(DingtalkOutlined);

// This icon file is generated automatically.
var DingtalkSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z" } }] }, "name": "dingtalk-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DingtalkSquareFilled = function DingtalkSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkSquareFilled$2
  }));
};

DingtalkSquareFilled.displayName = 'DingtalkSquareFilled';
var DingtalkSquareFilled$1 = /*#__PURE__*/React.forwardRef(DingtalkSquareFilled);

// This icon file is generated automatically.
var DisconnectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 00-11.3 0L209.4 249a8.03 8.03 0 000 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z" } }] }, "name": "disconnect", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DisconnectOutlined = function DisconnectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DisconnectOutlined$2
  }));
};

DisconnectOutlined.displayName = 'DisconnectOutlined';
var DisconnectOutlined$1 = /*#__PURE__*/React.forwardRef(DisconnectOutlined);

// This icon file is generated automatically.
var DislikeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z" } }] }, "name": "dislike", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DislikeFilled = function DislikeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DislikeFilled$2
  }));
};

DislikeFilled.displayName = 'DislikeFilled';
var DislikeFilled$1 = /*#__PURE__*/React.forwardRef(DislikeFilled);

// This icon file is generated automatically.
var DislikeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 01-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0133.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0119.6 43c0 19.1-11 37.5-28.8 48.4z" } }] }, "name": "dislike", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DislikeOutlined = function DislikeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DislikeOutlined$2
  }));
};

DislikeOutlined.displayName = 'DislikeOutlined';
var DislikeOutlined$1 = /*#__PURE__*/React.forwardRef(DislikeOutlined);

// This icon file is generated automatically.
var DislikeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 006.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 006.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 006.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0042.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 00-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 01-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0133.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0119.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0119.6 43c0 19.1-11 37.5-28.8 48.4z", "fill": primaryColor } }] }; }, "name": "dislike", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DislikeTwoTone = function DislikeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DislikeTwoTone$2
  }));
};

DislikeTwoTone.displayName = 'DislikeTwoTone';
var DislikeTwoTone$1 = /*#__PURE__*/React.forwardRef(DislikeTwoTone);

// This icon file is generated automatically.
var DollarCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z" } }] }, "name": "dollar-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DollarCircleFilled = function DollarCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleFilled$2
  }));
};

DollarCircleFilled.displayName = 'DollarCircleFilled';
var DollarCircleFilled$1 = /*#__PURE__*/React.forwardRef(DollarCircleFilled);

// This icon file is generated automatically.
var DollarCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z" } }] }, "name": "dollar-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DollarCircleOutlined = function DollarCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleOutlined$2
  }));
};

DollarCircleOutlined.displayName = 'DollarCircleOutlined';
var DollarCircleOutlined$1 = /*#__PURE__*/React.forwardRef(DollarCircleOutlined);

// This icon file is generated automatically.
var DollarCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 01-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z", "fill": primaryColor } }] }; }, "name": "dollar-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DollarCircleTwoTone = function DollarCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleTwoTone$2
  }));
};

DollarCircleTwoTone.displayName = 'DollarCircleTwoTone';
var DollarCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(DollarCircleTwoTone);

// This icon file is generated automatically.
var DollarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z" } }] }, "name": "dollar", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DollarOutlined = function DollarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DollarOutlined$2
  }));
};

DollarOutlined.displayName = 'DollarOutlined';
var DollarOutlined$1 = /*#__PURE__*/React.forwardRef(DollarOutlined);

// This icon file is generated automatically.
var DollarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 01-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z", "fill": primaryColor } }] }; }, "name": "dollar", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DollarTwoTone = function DollarTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DollarTwoTone$2
  }));
};

DollarTwoTone.displayName = 'DollarTwoTone';
var DollarTwoTone$1 = /*#__PURE__*/React.forwardRef(DollarTwoTone);

// This icon file is generated automatically.
var DotChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "dot-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DotChartOutlined = function DotChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DotChartOutlined$2
  }));
};

DotChartOutlined.displayName = 'DotChartOutlined';
var DotChartOutlined$1 = /*#__PURE__*/React.forwardRef(DotChartOutlined);

// This icon file is generated automatically.
var DoubleLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, "name": "double-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DoubleLeftOutlined$2
  }));
};

DoubleLeftOutlined.displayName = 'DoubleLeftOutlined';
var DoubleLeftOutlined$1 = /*#__PURE__*/React.forwardRef(DoubleLeftOutlined);

// This icon file is generated automatically.
var DoubleRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, "name": "double-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DoubleRightOutlined$2
  }));
};

DoubleRightOutlined.displayName = 'DoubleRightOutlined';
var DoubleRightOutlined$1 = /*#__PURE__*/React.forwardRef(DoubleRightOutlined);

// This icon file is generated automatically.
var DownCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "down-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DownCircleFilled = function DownCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DownCircleFilled$2
  }));
};

DownCircleFilled.displayName = 'DownCircleFilled';
var DownCircleFilled$1 = /*#__PURE__*/React.forwardRef(DownCircleFilled);

// This icon file is generated automatically.
var DownCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "down-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DownCircleOutlined = function DownCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DownCircleOutlined$2
  }));
};

DownCircleOutlined.displayName = 'DownCircleOutlined';
var DownCircleOutlined$1 = /*#__PURE__*/React.forwardRef(DownCircleOutlined);

// This icon file is generated automatically.
var DownCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z", "fill": primaryColor } }] }; }, "name": "down-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DownCircleTwoTone = function DownCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DownCircleTwoTone$2
  }));
};

DownCircleTwoTone.displayName = 'DownCircleTwoTone';
var DownCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(DownCircleTwoTone);

// This icon file is generated automatically.
var DownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DownOutlined = function DownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DownOutlined$2
  }));
};

DownOutlined.displayName = 'DownOutlined';
var DownOutlined$1 = /*#__PURE__*/React.forwardRef(DownOutlined);

// This icon file is generated automatically.
var DownSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "down-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DownSquareFilled = function DownSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DownSquareFilled$2
  }));
};

DownSquareFilled.displayName = 'DownSquareFilled';
var DownSquareFilled$1 = /*#__PURE__*/React.forwardRef(DownSquareFilled);

// This icon file is generated automatically.
var DownSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "down-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DownSquareOutlined = function DownSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DownSquareOutlined$2
  }));
};

DownSquareOutlined.displayName = 'DownSquareOutlined';
var DownSquareOutlined$1 = /*#__PURE__*/React.forwardRef(DownSquareOutlined);

// This icon file is generated automatically.
var DownSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 01-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z", "fill": primaryColor } }] }; }, "name": "down-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var DownSquareTwoTone = function DownSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DownSquareTwoTone$2
  }));
};

DownSquareTwoTone.displayName = 'DownSquareTwoTone';
var DownSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(DownSquareTwoTone);

// This icon file is generated automatically.
var DownloadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "download", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DownloadOutlined = function DownloadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DownloadOutlined$2
  }));
};

DownloadOutlined.displayName = 'DownloadOutlined';
var DownloadOutlined$1 = /*#__PURE__*/React.forwardRef(DownloadOutlined);

// This icon file is generated automatically.
var DragOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.3 506.3L781.7 405.6a7.23 7.23 0 00-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 00-11.3 0L405.6 242.3a7.23 7.23 0 005.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 00.1-11.4z" } }] }, "name": "drag", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DragOutlined = function DragOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DragOutlined$2
  }));
};

DragOutlined.displayName = 'DragOutlined';
var DragOutlined$1 = /*#__PURE__*/React.forwardRef(DragOutlined);

// This icon file is generated automatically.
var DribbbleCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M675.1 328.3a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z" } }] }, "name": "dribbble-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DribbbleCircleFilled = function DribbbleCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleCircleFilled$2
  }));
};

DribbbleCircleFilled.displayName = 'DribbbleCircleFilled';
var DribbbleCircleFilled$1 = /*#__PURE__*/React.forwardRef(DribbbleCircleFilled);

// This icon file is generated automatically.
var DribbbleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 01512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z" } }] }, "name": "dribbble", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DribbbleOutlined = function DribbbleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleOutlined$2
  }));
};

DribbbleOutlined.displayName = 'DribbbleOutlined';
var DribbbleOutlined$1 = /*#__PURE__*/React.forwardRef(DribbbleOutlined);

// This icon file is generated automatically.
var DribbbleSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z" } }] }, "name": "dribbble-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DribbbleSquareFilled = function DribbbleSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleSquareFilled$2
  }));
};

DribbbleSquareFilled.displayName = 'DribbbleSquareFilled';
var DribbbleSquareFilled$1 = /*#__PURE__*/React.forwardRef(DribbbleSquareFilled);

// This icon file is generated automatically.
var DribbbleSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 00-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z" } }] }, "name": "dribbble-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DribbbleSquareOutlined = function DribbbleSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleSquareOutlined$2
  }));
};

DribbbleSquareOutlined.displayName = 'DribbbleSquareOutlined';
var DribbbleSquareOutlined$1 = /*#__PURE__*/React.forwardRef(DribbbleSquareOutlined);

// This icon file is generated automatically.
var DropboxCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z" } }] }, "name": "dropbox-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DropboxCircleFilled = function DropboxCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DropboxCircleFilled$2
  }));
};

DropboxCircleFilled.displayName = 'DropboxCircleFilled';
var DropboxCircleFilled$1 = /*#__PURE__*/React.forwardRef(DropboxCircleFilled);

// This icon file is generated automatically.
var DropboxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z" } }] }, "name": "dropbox", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var DropboxOutlined = function DropboxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DropboxOutlined$2
  }));
};

DropboxOutlined.displayName = 'DropboxOutlined';
var DropboxOutlined$1 = /*#__PURE__*/React.forwardRef(DropboxOutlined);

// This icon file is generated automatically.
var DropboxSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z" } }] }, "name": "dropbox-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var DropboxSquareFilled = function DropboxSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: DropboxSquareFilled$2
  }));
};

DropboxSquareFilled.displayName = 'DropboxSquareFilled';
var DropboxSquareFilled$1 = /*#__PURE__*/React.forwardRef(DropboxSquareFilled);

// This icon file is generated automatically.
var EditFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z" } }] }, "name": "edit", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var EditFilled = function EditFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EditFilled$2
  }));
};

EditFilled.displayName = 'EditFilled';
var EditFilled$1 = /*#__PURE__*/React.forwardRef(EditFilled);

// This icon file is generated automatically.
var EditOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, "name": "edit", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EditOutlined = function EditOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EditOutlined$2
  }));
};

EditOutlined.displayName = 'EditOutlined';
var EditOutlined$1 = /*#__PURE__*/React.forwardRef(EditOutlined);

// This icon file is generated automatically.
var EditTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z", "fill": primaryColor } }] }; }, "name": "edit", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EditTwoTone = function EditTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EditTwoTone$2
  }));
};

EditTwoTone.displayName = 'EditTwoTone';
var EditTwoTone$1 = /*#__PURE__*/React.forwardRef(EditTwoTone);

// This icon file is generated automatically.
var EllipsisOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "ellipsis", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EllipsisOutlined = function EllipsisOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EllipsisOutlined$2
  }));
};

EllipsisOutlined.displayName = 'EllipsisOutlined';
var EllipsisOutlined$1 = /*#__PURE__*/React.forwardRef(EllipsisOutlined);

// This icon file is generated automatically.
var EnterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, "name": "enter", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EnterOutlined = function EnterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EnterOutlined$2
  }));
};

EnterOutlined.displayName = 'EnterOutlined';
var EnterOutlined$1 = /*#__PURE__*/React.forwardRef(EnterOutlined);

// This icon file is generated automatically.
var EnvironmentFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 00400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 00512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z" } }] }, "name": "environment", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var EnvironmentFilled = function EnvironmentFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentFilled$2
  }));
};

EnvironmentFilled.displayName = 'EnvironmentFilled';
var EnvironmentFilled$1 = /*#__PURE__*/React.forwardRef(EnvironmentFilled);

// This icon file is generated automatically.
var EnvironmentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z" } }] }, "name": "environment", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EnvironmentOutlined = function EnvironmentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentOutlined$2
  }));
};

EnvironmentOutlined.displayName = 'EnvironmentOutlined';
var EnvironmentOutlined$1 = /*#__PURE__*/React.forwardRef(EnvironmentOutlined);

// This icon file is generated automatically.
var EnvironmentTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z", "fill": primaryColor } }] }; }, "name": "environment", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EnvironmentTwoTone = function EnvironmentTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentTwoTone$2
  }));
};

EnvironmentTwoTone.displayName = 'EnvironmentTwoTone';
var EnvironmentTwoTone$1 = /*#__PURE__*/React.forwardRef(EnvironmentTwoTone);

// This icon file is generated automatically.
var EuroCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z" } }] }, "name": "euro-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var EuroCircleFilled = function EuroCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleFilled$2
  }));
};

EuroCircleFilled.displayName = 'EuroCircleFilled';
var EuroCircleFilled$1 = /*#__PURE__*/React.forwardRef(EuroCircleFilled);

// This icon file is generated automatically.
var EuroCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z" } }] }, "name": "euro-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EuroCircleOutlined = function EuroCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleOutlined$2
  }));
};

EuroCircleOutlined.displayName = 'EuroCircleOutlined';
var EuroCircleOutlined$1 = /*#__PURE__*/React.forwardRef(EuroCircleOutlined);

// This icon file is generated automatically.
var EuroCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 01-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z", "fill": primaryColor } }] }; }, "name": "euro-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EuroCircleTwoTone = function EuroCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleTwoTone$2
  }));
};

EuroCircleTwoTone.displayName = 'EuroCircleTwoTone';
var EuroCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(EuroCircleTwoTone);

// This icon file is generated automatically.
var EuroOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z" } }] }, "name": "euro", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EuroOutlined = function EuroOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EuroOutlined$2
  }));
};

EuroOutlined.displayName = 'EuroOutlined';
var EuroOutlined$1 = /*#__PURE__*/React.forwardRef(EuroOutlined);

// This icon file is generated automatically.
var EuroTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 01-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 009.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z", "fill": primaryColor } }] }; }, "name": "euro", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EuroTwoTone = function EuroTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EuroTwoTone$2
  }));
};

EuroTwoTone.displayName = 'EuroTwoTone';
var EuroTwoTone$1 = /*#__PURE__*/React.forwardRef(EuroTwoTone);

// This icon file is generated automatically.
var ExceptionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1064 0 32 32 0 10-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "exception", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExceptionOutlined = function ExceptionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ExceptionOutlined$2
  }));
};

ExceptionOutlined.displayName = 'ExceptionOutlined';
var ExceptionOutlined$1 = /*#__PURE__*/React.forwardRef(ExceptionOutlined);

// This icon file is generated automatically.
var ExclamationCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "exclamation-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationCircleFilled$2
  }));
};

ExclamationCircleFilled.displayName = 'ExclamationCircleFilled';
var ExclamationCircleFilled$1 = /*#__PURE__*/React.forwardRef(ExclamationCircleFilled);

// This icon file is generated automatically.
var ExclamationCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, "name": "exclamation-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationCircleOutlined$2
  }));
};

ExclamationCircleOutlined.displayName = 'ExclamationCircleOutlined';
var ExclamationCircleOutlined$1 = /*#__PURE__*/React.forwardRef(ExclamationCircleOutlined);

// This icon file is generated automatically.
var ExclamationCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "exclamation-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ExclamationCircleTwoTone = function ExclamationCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationCircleTwoTone$2
  }));
};

ExclamationCircleTwoTone.displayName = 'ExclamationCircleTwoTone';
var ExclamationCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(ExclamationCircleTwoTone);

// This icon file is generated automatically.
var ExclamationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448 804a64 64 0 10128 0 64 64 0 10-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z" } }] }, "name": "exclamation", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExclamationOutlined = function ExclamationOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ExclamationOutlined$2
  }));
};

ExclamationOutlined.displayName = 'ExclamationOutlined';
var ExclamationOutlined$1 = /*#__PURE__*/React.forwardRef(ExclamationOutlined);

// This icon file is generated automatically.
var ExpandAltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L863.9 169a7.9 7.9 0 00-8.9-8.9zM416.6 562.3a8.03 8.03 0 00-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z" } }] }, "name": "expand-alt", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExpandAltOutlined = function ExpandAltOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ExpandAltOutlined$2
  }));
};

ExpandAltOutlined.displayName = 'ExpandAltOutlined';
var ExpandAltOutlined$1 = /*#__PURE__*/React.forwardRef(ExpandAltOutlined);

// This icon file is generated automatically.
var ExpandOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M342 88H120c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V168h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm578 576h-48c-8.8 0-16 7.2-16 16v176H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V680c0-8.8-7.2-16-16-16zM342 856H168V680c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM904 88H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V120c0-17.7-14.3-32-32-32z" } }] }, "name": "expand", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExpandOutlined = function ExpandOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ExpandOutlined$2
  }));
};

ExpandOutlined.displayName = 'ExpandOutlined';
var ExpandOutlined$1 = /*#__PURE__*/React.forwardRef(ExpandOutlined);

// This icon file is generated automatically.
var ExperimentFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0094.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 01164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 01-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0036.6-82.5z" } }] }, "name": "experiment", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ExperimentFilled = function ExperimentFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentFilled$2
  }));
};

ExperimentFilled.displayName = 'ExperimentFilled';
var ExperimentFilled$1 = /*#__PURE__*/React.forwardRef(ExperimentFilled);

// This icon file is generated automatically.
var ExperimentOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 472a40 40 0 1080 0 40 40 0 10-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 01-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z" } }] }, "name": "experiment", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExperimentOutlined = function ExperimentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentOutlined$2
  }));
};

ExperimentOutlined.displayName = 'ExperimentOutlined';
var ExperimentOutlined$1 = /*#__PURE__*/React.forwardRef(ExperimentOutlined);

// This icon file is generated automatically.
var ExperimentTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 01552 512a40 40 0 01-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 01-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 01-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0040 39.4z", "fill": primaryColor } }] }; }, "name": "experiment", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ExperimentTwoTone = function ExperimentTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentTwoTone$2
  }));
};

ExperimentTwoTone.displayName = 'ExperimentTwoTone';
var ExperimentTwoTone$1 = /*#__PURE__*/React.forwardRef(ExperimentTwoTone);

// This icon file is generated automatically.
var ExportOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zm18.6-251.7L765 393.7c-5.3-4.2-13-.4-13 6.3v76H438c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 000-12.6z" } }] }, "name": "export", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ExportOutlined = function ExportOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ExportOutlined$2
  }));
};

ExportOutlined.displayName = 'ExportOutlined';
var ExportOutlined$1 = /*#__PURE__*/React.forwardRef(ExportOutlined);

// This icon file is generated automatically.
var EyeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M396 512a112 112 0 10224 0 112 112 0 10-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z" } }] }, "name": "eye", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var EyeFilled = function EyeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EyeFilled$2
  }));
};

EyeFilled.displayName = 'EyeFilled';
var EyeFilled$1 = /*#__PURE__*/React.forwardRef(EyeFilled);

// This icon file is generated automatically.
var EyeInvisibleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M508 624a112 112 0 00112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 00-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 000 11.31L155.25 889a8 8 0 0011.31 0l712.16-712.12a8 8 0 000-11.32zM332 512a176 176 0 01258.88-155.28l-48.62 48.62a112.08 112.08 0 00-140.92 140.92l-48.62 48.62A175.09 175.09 0 01332 512z" } }, { "tag": "path", "attrs": { "d": "M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 01445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5z" } }] }, "name": "eye-invisible", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var EyeInvisibleFilled = function EyeInvisibleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleFilled$2
  }));
};

EyeInvisibleFilled.displayName = 'EyeInvisibleFilled';
var EyeInvisibleFilled$1 = /*#__PURE__*/React.forwardRef(EyeInvisibleFilled);

// This icon file is generated automatically.
var EyeInvisibleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleOutlined$2
  }));
};

EyeInvisibleOutlined.displayName = 'EyeInvisibleOutlined';
var EyeInvisibleOutlined$1 = /*#__PURE__*/React.forwardRef(EyeInvisibleOutlined);

// This icon file is generated automatically.
var EyeInvisibleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M254.89 758.85l125.57-125.57a176 176 0 01248.82-248.82L757 256.72Q651.69 186.07 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q69.27 145.91 173.09 221.05zM942.2 486.2Q889.46 375.11 816.7 305L672.48 449.27a176.09 176.09 0 01-227.22 227.21L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zM878.63 165.56L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z", "fill": primaryColor } }] }; }, "name": "eye-invisible", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EyeInvisibleTwoTone = function EyeInvisibleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleTwoTone$2
  }));
};

EyeInvisibleTwoTone.displayName = 'EyeInvisibleTwoTone';
var EyeInvisibleTwoTone$1 = /*#__PURE__*/React.forwardRef(EyeInvisibleTwoTone);

// This icon file is generated automatically.
var EyeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EyeOutlined$2
  }));
};

EyeOutlined.displayName = 'EyeOutlined';
var EyeOutlined$1 = /*#__PURE__*/React.forwardRef(EyeOutlined);

// This icon file is generated automatically.
var EyeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M81.8 537.8a60.3 60.3 0 010-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z", "fill": primaryColor } }] }; }, "name": "eye", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var EyeTwoTone = function EyeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: EyeTwoTone$2
  }));
};

EyeTwoTone.displayName = 'EyeTwoTone';
var EyeTwoTone$1 = /*#__PURE__*/React.forwardRef(EyeTwoTone);

// This icon file is generated automatically.
var FacebookFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z" } }] }, "name": "facebook", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FacebookFilled = function FacebookFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FacebookFilled$2
  }));
};

FacebookFilled.displayName = 'FacebookFilled';
var FacebookFilled$1 = /*#__PURE__*/React.forwardRef(FacebookFilled);

// This icon file is generated automatically.
var FacebookOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z" } }] }, "name": "facebook", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FacebookOutlined = function FacebookOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FacebookOutlined$2
  }));
};

FacebookOutlined.displayName = 'FacebookOutlined';
var FacebookOutlined$1 = /*#__PURE__*/React.forwardRef(FacebookOutlined);

// This icon file is generated automatically.
var FallOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 00-11.3 0l-45 45.2a8.03 8.03 0 000 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 004.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z" } }] }, "name": "fall", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FallOutlined = function FallOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FallOutlined$2
  }));
};

FallOutlined.displayName = 'FallOutlined';
var FallOutlined$1 = /*#__PURE__*/React.forwardRef(FallOutlined);

// This icon file is generated automatically.
var FastBackwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-backward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FastBackwardFilled = function FastBackwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FastBackwardFilled$2
  }));
};

FastBackwardFilled.displayName = 'FastBackwardFilled';
var FastBackwardFilled$1 = /*#__PURE__*/React.forwardRef(FastBackwardFilled);

// This icon file is generated automatically.
var FastBackwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 000 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-backward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FastBackwardOutlined = function FastBackwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FastBackwardOutlined$2
  }));
};

FastBackwardOutlined.displayName = 'FastBackwardOutlined';
var FastBackwardOutlined$1 = /*#__PURE__*/React.forwardRef(FastBackwardOutlined);

// This icon file is generated automatically.
var FastForwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 000-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-forward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FastForwardFilled = function FastForwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FastForwardFilled$2
  }));
};

FastForwardFilled.displayName = 'FastForwardFilled';
var FastForwardFilled$1 = /*#__PURE__*/React.forwardRef(FastForwardFilled);

// This icon file is generated automatically.
var FastForwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 000-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z" } }] }, "name": "fast-forward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FastForwardOutlined = function FastForwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FastForwardOutlined$2
  }));
};

FastForwardOutlined.displayName = 'FastForwardOutlined';
var FastForwardOutlined$1 = /*#__PURE__*/React.forwardRef(FastForwardOutlined);

// This icon file is generated automatically.
var FieldBinaryOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M600 395.4h91V649h79V267c0-4.4-3.6-8-8-8h-48.2c-3.7 0-7 2.6-7.7 6.3-2.6 12.1-6.9 22.3-12.9 30.9a86.14 86.14 0 01-26.3 24.4c-10.3 6.2-22 10.5-35 12.9-10.4 1.9-21 3-32 3.1a8 8 0 00-7.9 8v42.8c0 4.4 3.6 8 8 8zM871 702H567c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM443.9 312.7c-16.1-19-34.4-32.4-55.2-40.4-21.3-8.2-44.1-12.3-68.4-12.3-23.9 0-46.4 4.1-67.7 12.3-20.8 8-39 21.4-54.8 40.3-15.9 19.1-28.7 44.7-38.3 77-9.6 32.5-14.5 73-14.5 121.5 0 49.9 4.9 91.4 14.5 124.4 9.6 32.8 22.4 58.7 38.3 77.7 15.8 18.9 34 32.3 54.8 40.3 21.3 8.2 43.8 12.3 67.7 12.3 24.4 0 47.2-4.1 68.4-12.3 20.8-8 39.2-21.4 55.2-40.4 16.1-19 29-44.9 38.6-77.7 9.6-33 14.5-74.5 14.5-124.4 0-48.4-4.9-88.9-14.5-121.5-9.5-32.1-22.4-57.7-38.6-76.8zm-29.5 251.7c-1 21.4-4.2 42-9.5 61.9-5.5 20.7-14.5 38.5-27 53.4-13.6 16.3-33.2 24.3-57.6 24.3-24 0-43.2-8.1-56.7-24.4-12.2-14.8-21.1-32.6-26.6-53.3-5.3-19.9-8.5-40.6-9.5-61.9-1-20.8-1.5-38.5-1.5-53.2 0-8.8.1-19.4.4-31.8.2-12.7 1.1-25.8 2.6-39.2 1.5-13.6 4-27.1 7.6-40.5 3.7-13.8 8.8-26.3 15.4-37.4 6.9-11.6 15.8-21.1 26.7-28.3 11.4-7.6 25.3-11.3 41.5-11.3 16.1 0 30.1 3.7 41.7 11.2a87.94 87.94 0 0127.4 28.2c6.9 11.2 12.1 23.8 15.6 37.7 3.3 13.2 5.8 26.6 7.5 40.1 1.8 13.5 2.8 26.6 3 39.4.2 12.4.4 23 .4 31.8.1 14.8-.4 32.5-1.4 53.3z" } }] }, "name": "field-binary", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FieldBinaryOutlined = function FieldBinaryOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FieldBinaryOutlined$2
  }));
};

FieldBinaryOutlined.displayName = 'FieldBinaryOutlined';
var FieldBinaryOutlined$1 = /*#__PURE__*/React.forwardRef(FieldBinaryOutlined);

// This icon file is generated automatically.
var FieldNumberOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M508 280h-63.3c-3.3 0-6 2.7-6 6v340.2H433L197.4 282.6c-1.1-1.6-3-2.6-4.9-2.6H126c-3.3 0-6 2.7-6 6v464c0 3.3 2.7 6 6 6h62.7c3.3 0 6-2.7 6-6V405.1h5.7l238.2 348.3c1.1 1.6 3 2.6 5 2.6H508c3.3 0 6-2.7 6-6V286c0-3.3-2.7-6-6-6zm378 413H582c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-152.2-63c52.9 0 95.2-17.2 126.2-51.7 29.4-32.9 44-75.8 44-128.8 0-53.1-14.6-96.5-44-129.3-30.9-34.8-73.2-52.2-126.2-52.2-53.7 0-95.9 17.5-126.3 52.8-29.2 33.1-43.4 75.9-43.4 128.7 0 52.4 14.3 95.2 43.5 128.3 30.6 34.7 73 52.2 126.2 52.2zm-71.5-263.7c16.9-20.6 40.3-30.9 71.4-30.9 31.5 0 54.8 9.6 71 29.1 16.4 20.3 24.9 48.6 24.9 84.9 0 36.3-8.4 64.1-24.8 83.9-16.5 19.4-40 29.2-71.1 29.2-31.2 0-55-10.3-71.4-30.4-16.3-20.1-24.5-47.3-24.5-82.6.1-35.8 8.2-63 24.5-83.2z" } }] }, "name": "field-number", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FieldNumberOutlined = function FieldNumberOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FieldNumberOutlined$2
  }));
};

FieldNumberOutlined.displayName = 'FieldNumberOutlined';
var FieldNumberOutlined$1 = /*#__PURE__*/React.forwardRef(FieldNumberOutlined);

// This icon file is generated automatically.
var FieldStringOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M875.6 515.9c2.1.8 4.4-.3 5.2-2.4.2-.4.2-.9.2-1.4v-58.3c0-1.8-1.1-3.3-2.8-3.8-6-1.8-17.2-3-27.2-3-32.9 0-61.7 16.7-73.5 41.2v-28.6c0-4.4-3.6-8-8-8H717c-4.4 0-8 3.6-8 8V729c0 4.4 3.6 8 8 8h54.8c4.4 0 8-3.6 8-8V572.7c0-36.2 26.1-60.2 65.1-60.2 10.4.1 26.6 1.8 30.7 3.4zm-537-40.5l-54.7-12.6c-61.2-14.2-87.7-34.8-87.7-70.7 0-44.6 39.1-73.5 96.9-73.5 52.8 0 91.4 26.5 99.9 68.9h70C455.9 311.6 387.6 259 293.4 259c-103.3 0-171 55.5-171 139 0 68.6 38.6 109.5 122.2 128.5l61.6 14.3c63.6 14.9 91.6 37.1 91.6 75.1 0 44.1-43.5 75.2-102.5 75.2-60.6 0-104.5-27.2-112.8-70.5H111c7.2 79.9 75.6 130.4 179.1 130.4C402.3 751 471 695.2 471 605.3c0-70.2-38.6-108.5-132.4-129.9zM841 729a36 36 0 1072 0 36 36 0 10-72 0zM653 457.8h-51.4V396c0-4.4-3.6-8-8-8h-54.7c-4.4 0-8 3.6-8 8v61.8H495c-4.4 0-8 3.6-8 8v42.3c0 4.4 3.6 8 8 8h35.9v147.5c0 56.2 27.4 79.4 93.1 79.4 11.7 0 23.6-1.2 33.8-3.1 1.9-.3 3.2-2 3.2-3.9v-49.3c0-2.2-1.8-4-4-4h-.4c-4.9.5-6.2.6-8.3.8-4.1.3-7.8.5-12.6.5-24.1 0-34.1-10.3-34.1-35.6V516.1H653c4.4 0 8-3.6 8-8v-42.3c0-4.4-3.6-8-8-8z" } }] }, "name": "field-string", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FieldStringOutlined = function FieldStringOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FieldStringOutlined$2
  }));
};

FieldStringOutlined.displayName = 'FieldStringOutlined';
var FieldStringOutlined$1 = /*#__PURE__*/React.forwardRef(FieldStringOutlined);

// This icon file is generated automatically.
var FieldTimeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c.1-6.2-5-11.2-11.1-11.2z" } }, { "tag": "path", "attrs": { "d": "M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7a321 321 0 01-44.5 55.7 317.17 317.17 0 01-101.3 68.3c-39.3 16.6-81 25-124 25-43.1 0-84.8-8.4-124-25-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124 0-43.1 8.4-84.7 25-124 16-37.9 39-72 68.3-101.3 29.3-29.3 63.4-52.3 101.3-68.3 39.2-16.6 81-25 124-25 43.1 0 84.8 8.4 124 25 37.9 16 72 39 101.3 68.3a321 321 0 0144.5 55.7c3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3-65.2-129.7-197.4-214-345-215.7-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8a9.18 9.18 0 00-8.2-13.3z" } }] }, "name": "field-time", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FieldTimeOutlined = function FieldTimeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FieldTimeOutlined$2
  }));
};

FieldTimeOutlined.displayName = 'FieldTimeOutlined';
var FieldTimeOutlined$1 = /*#__PURE__*/React.forwardRef(FieldTimeOutlined);

// This icon file is generated automatically.
var FileAddFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M480 580H372a8 8 0 00-8 8v48a8 8 0 008 8h108v108a8 8 0 008 8h48a8 8 0 008-8V644h108a8 8 0 008-8v-48a8 8 0 00-8-8H544V472a8 8 0 00-8-8h-48a8 8 0 00-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" } }] }, "name": "file-add", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileAddFilled = function FileAddFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileAddFilled$2
  }));
};

FileAddFilled.displayName = 'FileAddFilled';
var FileAddFilled$1 = /*#__PURE__*/React.forwardRef(FileAddFilled);

// This icon file is generated automatically.
var FileAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z" } }] }, "name": "file-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileAddOutlined = function FileAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileAddOutlined$2
  }));
};

FileAddOutlined.displayName = 'FileAddOutlined';
var FileAddOutlined$1 = /*#__PURE__*/React.forwardRef(FileAddOutlined);

// This icon file is generated automatically.
var FileAddTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z", "fill": primaryColor } }] }; }, "name": "file-add", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileAddTwoTone = function FileAddTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileAddTwoTone$2
  }));
};

FileAddTwoTone.displayName = 'FileAddTwoTone';
var FileAddTwoTone$1 = /*#__PURE__*/React.forwardRef(FileAddTwoTone);

// This icon file is generated automatically.
var FileDoneOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 00-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "file-done", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileDoneOutlined = function FileDoneOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileDoneOutlined$2
  }));
};

FileDoneOutlined.displayName = 'FileDoneOutlined';
var FileDoneOutlined$1 = /*#__PURE__*/React.forwardRef(FileDoneOutlined);

// This icon file is generated automatically.
var FileExcelFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 00-10.27-5.79h-38.44a12 12 0 00-6.4 1.85 12 12 0 00-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 00-1.84 6.39 12 12 0 0012 12h34.46a12 12 0 0010.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0010.23 5.72h37.48a12 12 0 006.48-1.9 12 12 0 003.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 001.9-6.5 12 12 0 00-12-12h-35.7a12 12 0 00-10.29 5.84z" } }] }, "name": "file-excel", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileExcelFilled = function FileExcelFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileExcelFilled$2
  }));
};

FileExcelFilled.displayName = 'FileExcelFilled';
var FileExcelFilled$1 = /*#__PURE__*/React.forwardRef(FileExcelFilled);

// This icon file is generated automatically.
var FileExcelOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0010.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 00-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z" } }] }, "name": "file-excel", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileExcelOutlined = function FileExcelOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileExcelOutlined$2
  }));
};

FileExcelOutlined.displayName = 'FileExcelOutlined';
var FileExcelOutlined$1 = /*#__PURE__*/React.forwardRef(FileExcelOutlined);

// This icon file is generated automatically.
var FileExcelTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm51.6 120h35.7a12.04 12.04 0 0110.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 01-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0010.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 00-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z", "fill": primaryColor } }] }; }, "name": "file-excel", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileExcelTwoTone = function FileExcelTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileExcelTwoTone$2
  }));
};

FileExcelTwoTone.displayName = 'FileExcelTwoTone';
var FileExcelTwoTone$1 = /*#__PURE__*/React.forwardRef(FileExcelTwoTone);

// This icon file is generated automatically.
var FileExclamationFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 100-80 40 40 0 000 80zm32-152V448a8 8 0 00-8-8h-48a8 8 0 00-8 8v184a8 8 0 008 8h48a8 8 0 008-8z" } }] }, "name": "file-exclamation", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileExclamationFilled = function FileExclamationFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationFilled$2
  }));
};

FileExclamationFilled.displayName = 'FileExclamationFilled';
var FileExclamationFilled$1 = /*#__PURE__*/React.forwardRef(FileExclamationFilled);

// This icon file is generated automatically.
var FileExclamationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM472 744a40 40 0 1080 0 40 40 0 10-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z" } }] }, "name": "file-exclamation", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileExclamationOutlined = function FileExclamationOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationOutlined$2
  }));
};

FileExclamationOutlined.displayName = 'FileExclamationOutlined';
var FileExclamationOutlined$1 = /*#__PURE__*/React.forwardRef(FileExclamationOutlined);

// This icon file is generated automatically.
var FileExclamationTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "file-exclamation", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileExclamationTwoTone = function FileExclamationTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationTwoTone$2
  }));
};

FileExclamationTwoTone.displayName = 'FileExclamationTwoTone';
var FileExclamationTwoTone$1 = /*#__PURE__*/React.forwardRef(FileExclamationTwoTone);

// This icon file is generated automatically.
var FileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" } }] }, "name": "file", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileFilled = function FileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileFilled$2
  }));
};

FileFilled.displayName = 'FileFilled';
var FileFilled$1 = /*#__PURE__*/React.forwardRef(FileFilled);

// This icon file is generated automatically.
var FileGifOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M551.5 490.5H521c-4.6 0-8.4 3.7-8.4 8.4V720c0 4.6 3.7 8.4 8.4 8.4h30.5c4.6 0 8.4-3.7 8.4-8.4V498.9c-.1-4.6-3.8-8.4-8.4-8.4zM477.3 600h-88.1c-4.6 0-8.4 3.7-8.4 8.4v23.8c0 4.6 3.7 8.4 8.4 8.4h47.6v.7c-.6 29.9-23 49.8-56.5 49.8-39.2 0-63.6-30.7-63.6-81.4 0-50.1 23.9-80.6 62.3-80.6 28.1 0 47.5 13.5 55.4 38.3l.9 2.8h49.2l-.7-4.6C475.9 515.9 434.7 484 379 484c-68.8 0-113 49.4-113 125.9 0 77.5 43.7 126.1 113.6 126.1 64.4 0 106-40.3 106-102.9v-24.8c0-4.6-3.7-8.3-8.3-8.3z" } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z" } }, { "tag": "path", "attrs": { "d": "M608.2 727.8h32.3c4.6 0 8.4-3.7 8.4-8.4v-84.8h87.8c4.6 0 8.4-3.7 8.4-8.4v-25.5c0-4.6-3.7-8.4-8.4-8.4h-87.8v-58.9h96.8c4.6 0 8.4-3.7 8.4-8.4v-26.8c0-4.6-3.7-8.4-8.4-8.4H608.2c-4.6 0-8.4 3.7-8.4 8.4v221.1c0 4.8 3.8 8.5 8.4 8.5z" } }] }, "name": "file-gif", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileGifOutlined = function FileGifOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileGifOutlined$2
  }));
};

FileGifOutlined.displayName = 'FileGifOutlined';
var FileGifOutlined$1 = /*#__PURE__*/React.forwardRef(FileGifOutlined);

// This icon file is generated automatically.
var FileImageFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0112.6 0l41.1 52.4 77.8-99.2a8 8 0 0112.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z" } }] }, "name": "file-image", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileImageFilled = function FileImageFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileImageFilled$2
  }));
};

FileImageFilled.displayName = 'FileImageFilled';
var FileImageFilled$1 = /*#__PURE__*/React.forwardRef(FileImageFilled);

// This icon file is generated automatically.
var FileImageOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-image", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileImageOutlined = function FileImageOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileImageOutlined$2
  }));
};

FileImageOutlined.displayName = 'FileImageOutlined';
var FileImageOutlined$1 = /*#__PURE__*/React.forwardRef(FileImageOutlined);

// This icon file is generated automatically.
var FileImageTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0112.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0112.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "file-image", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileImageTwoTone = function FileImageTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileImageTwoTone$2
  }));
};

FileImageTwoTone.displayName = 'FileImageTwoTone';
var FileImageTwoTone$1 = /*#__PURE__*/React.forwardRef(FileImageTwoTone);

// This icon file is generated automatically.
var FileJpgOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z" } }] }, "name": "file-jpg", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileJpgOutlined = function FileJpgOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileJpgOutlined$2
  }));
};

FileJpgOutlined.displayName = 'FileJpgOutlined';
var FileJpgOutlined$1 = /*#__PURE__*/React.forwardRef(FileJpgOutlined);

// This icon file is generated automatically.
var FileMarkdownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0014.62 9.5h24.06a16 16 0 0014.63-9.51l59.1-133.35V758a16 16 0 0016.01 16H641a16 16 0 0016-16V486a16 16 0 00-16-16h-34.75a16 16 0 00-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 00-14.67-9.61H383a16 16 0 00-16 16v272a16 16 0 0016 16h27.13a16 16 0 0016-16V600.93z" } }] }, "name": "file-markdown", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileMarkdownFilled = function FileMarkdownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownFilled$2
  }));
};

FileMarkdownFilled.displayName = 'FileMarkdownFilled';
var FileMarkdownFilled$1 = /*#__PURE__*/React.forwardRef(FileMarkdownFilled);

// This icon file is generated automatically.
var FileMarkdownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0011 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z" } }] }, "name": "file-markdown", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileMarkdownOutlined = function FileMarkdownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownOutlined$2
  }));
};

FileMarkdownOutlined.displayName = 'FileMarkdownOutlined';
var FileMarkdownOutlined$1 = /*#__PURE__*/React.forwardRef(FileMarkdownOutlined);

// This icon file is generated automatically.
var FileMarkdownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 01-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0011 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z", "fill": primaryColor } }] }; }, "name": "file-markdown", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileMarkdownTwoTone = function FileMarkdownTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownTwoTone$2
  }));
};

FileMarkdownTwoTone.displayName = 'FileMarkdownTwoTone';
var FileMarkdownTwoTone$1 = /*#__PURE__*/React.forwardRef(FileMarkdownTwoTone);

// This icon file is generated automatically.
var FileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileOutlined = function FileOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileOutlined$2
  }));
};

FileOutlined.displayName = 'FileOutlined';
var FileOutlined$1 = /*#__PURE__*/React.forwardRef(FileOutlined);

// This icon file is generated automatically.
var FilePdfFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 015.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 01-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 01-1.12-.15 2.07 2.07 0 01-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 01-1.36 6.31 6.7 6.7 0 01-2.17 1.28z" } }] }, "name": "file-pdf", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FilePdfFilled = function FilePdfFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FilePdfFilled$2
  }));
};

FilePdfFilled.displayName = 'FilePdfFilled';
var FilePdfFilled$1 = /*#__PURE__*/React.forwardRef(FilePdfFilled);

// This icon file is generated automatically.
var FilePdfOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-pdf", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FilePdfOutlined = function FilePdfOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FilePdfOutlined$2
  }));
};

FilePdfOutlined.displayName = 'FilePdfOutlined';
var FilePdfOutlined$1 = /*#__PURE__*/React.forwardRef(FilePdfOutlined);

// This icon file is generated automatically.
var FilePdfTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z", "fill": primaryColor } }] }; }, "name": "file-pdf", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FilePdfTwoTone = function FilePdfTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FilePdfTwoTone$2
  }));
};

FilePdfTwoTone.displayName = 'FilePdfTwoTone';
var FilePdfTwoTone$1 = /*#__PURE__*/React.forwardRef(FilePdfTwoTone);

// This icon file is generated automatically.
var FilePptFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 00-12 12v276a12 12 0 0012 12h32.53a12 12 0 0012-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z" } }] }, "name": "file-ppt", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FilePptFilled = function FilePptFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FilePptFilled$2
  }));
};

FilePptFilled.displayName = 'FilePptFilled';
var FilePptFilled$1 = /*#__PURE__*/React.forwardRef(FilePptFilled);

// This icon file is generated automatically.
var FilePptOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-ppt", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FilePptOutlined = function FilePptOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FilePptOutlined$2
  }));
};

FilePptOutlined.displayName = 'FilePptOutlined';
var FilePptOutlined$1 = /*#__PURE__*/React.forwardRef(FilePptOutlined);

// This icon file is generated automatically.
var FilePptTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z", "fill": primaryColor } }] }; }, "name": "file-ppt", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FilePptTwoTone = function FilePptTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FilePptTwoTone$2
  }));
};

FilePptTwoTone.displayName = 'FilePptTwoTone';
var FilePptTwoTone$1 = /*#__PURE__*/React.forwardRef(FilePptTwoTone);

// This icon file is generated automatically.
var FileProtectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M644.7 669.2a7.92 7.92 0 00-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 00-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z" } }] }, "name": "file-protect", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileProtectOutlined = function FileProtectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileProtectOutlined$2
  }));
};

FileProtectOutlined.displayName = 'FileProtectOutlined';
var FileProtectOutlined$1 = /*#__PURE__*/React.forwardRef(FileProtectOutlined);

// This icon file is generated automatically.
var FileSearchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 000-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "file-search", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileSearchOutlined = function FileSearchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileSearchOutlined$2
  }));
};

FileSearchOutlined.displayName = 'FileSearchOutlined';
var FileSearchOutlined$1 = /*#__PURE__*/React.forwardRef(FileSearchOutlined);

// This icon file is generated automatically.
var FileSyncOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 003 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 00-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 00-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0012.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z" } }] }, "name": "file-sync", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileSyncOutlined = function FileSyncOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileSyncOutlined$2
  }));
};

FileSyncOutlined.displayName = 'FileSyncOutlined';
var FileSyncOutlined$1 = /*#__PURE__*/React.forwardRef(FileSyncOutlined);

// This icon file is generated automatically.
var FileTextFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 00-8 8v48a8 8 0 008 8h384a8 8 0 008-8v-48a8 8 0 00-8-8H320zm0 136a8 8 0 00-8 8v48a8 8 0 008 8h184a8 8 0 008-8v-48a8 8 0 00-8-8H320z" } }] }, "name": "file-text", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileTextFilled = function FileTextFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileTextFilled$2
  }));
};

FileTextFilled.displayName = 'FileTextFilled';
var FileTextFilled$1 = /*#__PURE__*/React.forwardRef(FileTextFilled);

// This icon file is generated automatically.
var FileTextOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z" } }] }, "name": "file-text", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileTextOutlined = function FileTextOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileTextOutlined$2
  }));
};

FileTextOutlined.displayName = 'FileTextOutlined';
var FileTextOutlined$1 = /*#__PURE__*/React.forwardRef(FileTextOutlined);

// This icon file is generated automatically.
var FileTextTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "file-text", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileTextTwoTone = function FileTextTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileTextTwoTone$2
  }));
};

FileTextTwoTone.displayName = 'FileTextTwoTone';
var FileTextTwoTone$1 = /*#__PURE__*/React.forwardRef(FileTextTwoTone);

// This icon file is generated automatically.
var FileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }] }; }, "name": "file", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileTwoTone = function FileTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileTwoTone$2
  }));
};

FileTwoTone.displayName = 'FileTwoTone';
var FileTwoTone$1 = /*#__PURE__*/React.forwardRef(FileTwoTone);

// This icon file is generated automatically.
var FileUnknownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 100-64 32 32 0 000 64z" } }] }, "name": "file-unknown", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileUnknownFilled = function FileUnknownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownFilled$2
  }));
};

FileUnknownFilled.displayName = 'FileUnknownFilled';
var FileUnknownFilled$1 = /*#__PURE__*/React.forwardRef(FileUnknownFilled);

// This icon file is generated automatically.
var FileUnknownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1064 0 32 32 0 10-64 0z" } }] }, "name": "file-unknown", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileUnknownOutlined = function FileUnknownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownOutlined$2
  }));
};

FileUnknownOutlined.displayName = 'FileUnknownOutlined';
var FileUnknownOutlined$1 = /*#__PURE__*/React.forwardRef(FileUnknownOutlined);

// This icon file is generated automatically.
var FileUnknownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M480 744a32 32 0 1064 0 32 32 0 10-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z", "fill": primaryColor } }] }; }, "name": "file-unknown", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileUnknownTwoTone = function FileUnknownTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownTwoTone$2
  }));
};

FileUnknownTwoTone.displayName = 'FileUnknownTwoTone';
var FileUnknownTwoTone$1 = /*#__PURE__*/React.forwardRef(FileUnknownTwoTone);

// This icon file is generated automatically.
var FileWordFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0011.6 8.9h31.77a12 12 0 0011.6-8.88l74.37-276a12 12 0 00.4-3.12 12 12 0 00-12-12h-35.57a12 12 0 00-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 00528.1 472h-32.2a12 12 0 00-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 00-11.68-9.29h-35.39a12 12 0 00-3.11.41 12 12 0 00-8.47 14.7l74.17 276A12 12 0 00415.6 772h31.99a12 12 0 0011.59-8.9l52.81-197z" } }] }, "name": "file-word", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileWordFilled = function FileWordFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileWordFilled$2
  }));
};

FileWordFilled.displayName = 'FileWordFilled';
var FileWordFilled$1 = /*#__PURE__*/React.forwardRef(FileWordFilled);

// This icon file is generated automatically.
var FileWordOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 00-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 00-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z" } }] }, "name": "file-word", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileWordOutlined = function FileWordOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileWordOutlined$2
  }));
};

FileWordOutlined.displayName = 'FileWordOutlined';
var FileWordOutlined$1 = /*#__PURE__*/React.forwardRef(FileWordOutlined);

// This icon file is generated automatically.
var FileWordTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0111.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0111.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 00-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 00-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z", "fill": primaryColor } }] }; }, "name": "file-word", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileWordTwoTone = function FileWordTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileWordTwoTone$2
  }));
};

FileWordTwoTone.displayName = 'FileWordTwoTone';
var FileWordTwoTone$1 = /*#__PURE__*/React.forwardRef(FileWordTwoTone);

// This icon file is generated automatically.
var FileZipFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z" } }] }, "name": "file-zip", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FileZipFilled = function FileZipFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileZipFilled$2
  }));
};

FileZipFilled.displayName = 'FileZipFilled';
var FileZipFilled$1 = /*#__PURE__*/React.forwardRef(FileZipFilled);

// This icon file is generated automatically.
var FileZipOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0042 42h216v494z" } }] }, "name": "file-zip", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FileZipOutlined = function FileZipOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileZipOutlined$2
  }));
};

FileZipOutlined.displayName = 'FileZipOutlined';
var FileZipOutlined$1 = /*#__PURE__*/React.forwardRef(FileZipOutlined);

// This icon file is generated automatically.
var FileZipTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M344 630h32v2h-32z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 01-42-42z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0042 42h216v494z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z", "fill": primaryColor } }] }; }, "name": "file-zip", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FileZipTwoTone = function FileZipTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FileZipTwoTone$2
  }));
};

FileZipTwoTone.displayName = 'FileZipTwoTone';
var FileZipTwoTone$1 = /*#__PURE__*/React.forwardRef(FileZipTwoTone);

// This icon file is generated automatically.
var FilterFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, "name": "filter", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FilterFilled = function FilterFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FilterFilled$2
  }));
};

FilterFilled.displayName = 'FilterFilled';
var FilterFilled$1 = /*#__PURE__*/React.forwardRef(FilterFilled);

// This icon file is generated automatically.
var FilterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z" } }] }, "name": "filter", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FilterOutlined = function FilterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FilterOutlined$2
  }));
};

FilterOutlined.displayName = 'FilterOutlined';
var FilterOutlined$1 = /*#__PURE__*/React.forwardRef(FilterOutlined);

// This icon file is generated automatically.
var FilterTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z", "fill": primaryColor } }] }; }, "name": "filter", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FilterTwoTone = function FilterTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FilterTwoTone$2
  }));
};

FilterTwoTone.displayName = 'FilterTwoTone';
var FilterTwoTone$1 = /*#__PURE__*/React.forwardRef(FilterTwoTone);

// This icon file is generated automatically.
var FireFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9z" } }] }, "name": "fire", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FireFilled = function FireFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FireFilled$2
  }));
};

FireFilled.displayName = 'FireFilled';
var FireFilled$1 = /*#__PURE__*/React.forwardRef(FireFilled);

// This icon file is generated automatically.
var FireOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0058.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0012.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0024.4 59.8 73.36 73.36 0 0053.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z" } }] }, "name": "fire", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FireOutlined = function FireOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FireOutlined$2
  }));
};

FireOutlined.displayName = 'FireOutlined';
var FireOutlined$1 = /*#__PURE__*/React.forwardRef(FireOutlined);

// This icon file is generated automatically.
var FireTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 01-51 24.4 73.36 73.36 0 01-53.4-18.8 74.01 74.01 0 01-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 01-12.1 46.5 354.26 354.26 0 01-58.2 101 349.6 349.6 0 01-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 00-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M834.1 469.2A347.49 347.49 0 00751.2 354l-29.1-26.7a8.09 8.09 0 00-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 01-47.5 46.1 352.6 352.6 0 00-100.3 121.5A347.75 347.75 0 00160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0075.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 00760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0027.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0058.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0012.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0024.4 59.8 73.36 73.36 0 0053.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z", "fill": primaryColor } }] }; }, "name": "fire", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FireTwoTone = function FireTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FireTwoTone$2
  }));
};

FireTwoTone.displayName = 'FireTwoTone';
var FireTwoTone$1 = /*#__PURE__*/React.forwardRef(FireTwoTone);

// This icon file is generated automatically.
var FlagFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z" } }] }, "name": "flag", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FlagFilled = function FlagFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FlagFilled$2
  }));
};

FlagFilled.displayName = 'FlagFilled';
var FlagFilled$1 = /*#__PURE__*/React.forwardRef(FlagFilled);

// This icon file is generated automatically.
var FlagOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z" } }] }, "name": "flag", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FlagOutlined = function FlagOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FlagOutlined$2
  }));
};

FlagOutlined.displayName = 'FlagOutlined';
var FlagOutlined$1 = /*#__PURE__*/React.forwardRef(FlagOutlined);

// This icon file is generated automatically.
var FlagTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M184 232h368v336H184z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z", "fill": primaryColor } }] }; }, "name": "flag", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FlagTwoTone = function FlagTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FlagTwoTone$2
  }));
};

FlagTwoTone.displayName = 'FlagTwoTone';
var FlagTwoTone$1 = /*#__PURE__*/React.forwardRef(FlagTwoTone);

// This icon file is generated automatically.
var FolderAddFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z" } }] }, "name": "folder-add", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FolderAddFilled = function FolderAddFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddFilled$2
  }));
};

FolderAddFilled.displayName = 'FolderAddFilled';
var FolderAddFilled$1 = /*#__PURE__*/React.forwardRef(FolderAddFilled);

// This icon file is generated automatically.
var FolderAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FolderAddOutlined = function FolderAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddOutlined$2
  }));
};

FolderAddOutlined.displayName = 'FolderAddOutlined';
var FolderAddOutlined$1 = /*#__PURE__*/React.forwardRef(FolderAddOutlined);

// This icon file is generated automatically.
var FolderAddTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z", "fill": primaryColor } }] }; }, "name": "folder-add", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FolderAddTwoTone = function FolderAddTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddTwoTone$2
  }));
};

FolderAddTwoTone.displayName = 'FolderAddTwoTone';
var FolderAddTwoTone$1 = /*#__PURE__*/React.forwardRef(FolderAddTwoTone);

// This icon file is generated automatically.
var FolderFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z" } }] }, "name": "folder", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FolderFilled = function FolderFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FolderFilled$2
  }));
};

FolderFilled.displayName = 'FolderFilled';
var FolderFilled$1 = /*#__PURE__*/React.forwardRef(FolderFilled);

// This icon file is generated automatically.
var FolderOpenFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z" } }] }, "name": "folder-open", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FolderOpenFilled = function FolderOpenFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenFilled$2
  }));
};

FolderOpenFilled.displayName = 'FolderOpenFilled';
var FolderOpenFilled$1 = /*#__PURE__*/React.forwardRef(FolderOpenFilled);

// This icon file is generated automatically.
var FolderOpenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, "name": "folder-open", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenOutlined$2
  }));
};

FolderOpenOutlined.displayName = 'FolderOpenOutlined';
var FolderOpenOutlined$1 = /*#__PURE__*/React.forwardRef(FolderOpenOutlined);

// This icon file is generated automatically.
var FolderOpenTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M159 768h612.3l103.4-256H262.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z", "fill": primaryColor } }] }; }, "name": "folder-open", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FolderOpenTwoTone = function FolderOpenTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FolderOpenTwoTone$2
  }));
};

FolderOpenTwoTone.displayName = 'FolderOpenTwoTone';
var FolderOpenTwoTone$1 = /*#__PURE__*/React.forwardRef(FolderOpenTwoTone);

// This icon file is generated automatically.
var FolderOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FolderOutlined = function FolderOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FolderOutlined$2
  }));
};

FolderOutlined.displayName = 'FolderOutlined';
var FolderOutlined$1 = /*#__PURE__*/React.forwardRef(FolderOutlined);

// This icon file is generated automatically.
var FolderTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M372.5 256H184v512h656V370.4H492.1z", "fill": secondaryColor } }] }; }, "name": "folder", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FolderTwoTone = function FolderTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FolderTwoTone$2
  }));
};

FolderTwoTone.displayName = 'FolderTwoTone';
var FolderTwoTone$1 = /*#__PURE__*/React.forwardRef(FolderTwoTone);

// This icon file is generated automatically.
var FolderViewOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M309.1 554.3a42.92 42.92 0 000 36.4C353.3 684 421.6 732 512.5 732s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8.1-36.3l-.1-.1-.1-.1C671.7 461 603.4 413 512.5 413s-159.2 48.1-203.4 141.3zM512.5 477c62.1 0 107.4 30 141.1 95.5C620 638 574.6 668 512.5 668s-107.4-30-141.1-95.5c33.7-65.5 79-95.5 141.1-95.5z" } }, { "tag": "path", "attrs": { "d": "M457 573a56 56 0 10112 0 56 56 0 10-112 0z" } }, { "tag": "path", "attrs": { "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, "name": "folder-view", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FolderViewOutlined = function FolderViewOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FolderViewOutlined$2
  }));
};

FolderViewOutlined.displayName = 'FolderViewOutlined';
var FolderViewOutlined$1 = /*#__PURE__*/React.forwardRef(FolderViewOutlined);

// This icon file is generated automatically.
var FontColorsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 006-12.4L573.6 118.6a9.9 9.9 0 00-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z" } }] }, "name": "font-colors", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FontColorsOutlined = function FontColorsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FontColorsOutlined$2
  }));
};

FontColorsOutlined.displayName = 'FontColorsOutlined';
var FontColorsOutlined$1 = /*#__PURE__*/React.forwardRef(FontColorsOutlined);

// This icon file is generated automatically.
var FontSizeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z" } }] }, "name": "font-size", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FontSizeOutlined = function FontSizeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FontSizeOutlined$2
  }));
};

FontSizeOutlined.displayName = 'FontSizeOutlined';
var FontSizeOutlined$1 = /*#__PURE__*/React.forwardRef(FontSizeOutlined);

// This icon file is generated automatically.
var ForkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm336 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm192-552a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "fork", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ForkOutlined = function ForkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ForkOutlined$2
  }));
};

ForkOutlined.displayName = 'ForkOutlined';
var ForkOutlined$1 = /*#__PURE__*/React.forwardRef(ForkOutlined);

// This icon file is generated automatically.
var FormOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 00-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z" } }] }, "name": "form", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FormOutlined = function FormOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FormOutlined$2
  }));
};

FormOutlined.displayName = 'FormOutlined';
var FormOutlined$1 = /*#__PURE__*/React.forwardRef(FormOutlined);

// This icon file is generated automatically.
var FormatPainterFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 1.1.2 2.2.6 3.1-.4 1.6-.6 3.2-.6 4.9 0 46.4 37.6 84 84 84s84-37.6 84-84c0-1.7-.2-3.3-.6-4.9.4-1 .6-2 .6-3.1V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40z" } }] }, "name": "format-painter", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FormatPainterFilled = function FormatPainterFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FormatPainterFilled$2
  }));
};

FormatPainterFilled.displayName = 'FormatPainterFilled';
var FormatPainterFilled$1 = /*#__PURE__*/React.forwardRef(FormatPainterFilled);

// This icon file is generated automatically.
var FormatPainterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 .6.1 1.3.2 1.9A83.99 83.99 0 00457 960c46.4 0 84-37.6 84-84 0-2.1-.1-4.1-.2-6.1.1-.6.2-1.2.2-1.9V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40zM720 352H208V160h512v192zM477 876c0 11-9 20-20 20s-20-9-20-20V696h40v180z" } }] }, "name": "format-painter", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FormatPainterOutlined = function FormatPainterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FormatPainterOutlined$2
  }));
};

FormatPainterOutlined.displayName = 'FormatPainterOutlined';
var FormatPainterOutlined$1 = /*#__PURE__*/React.forwardRef(FormatPainterOutlined);

// This icon file is generated automatically.
var ForwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z" } }] }, "name": "forward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ForwardFilled = function ForwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ForwardFilled$2
  }));
};

ForwardFilled.displayName = 'ForwardFilled';
var ForwardFilled$1 = /*#__PURE__*/React.forwardRef(ForwardFilled);

// This icon file is generated automatically.
var ForwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z" } }] }, "name": "forward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ForwardOutlined = function ForwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ForwardOutlined$2
  }));
};

ForwardOutlined.displayName = 'ForwardOutlined';
var ForwardOutlined$1 = /*#__PURE__*/React.forwardRef(ForwardOutlined);

// This icon file is generated automatically.
var FrownFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 01-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 01-8 8.4zm24-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "frown", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FrownFilled = function FrownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FrownFilled$2
  }));
};

FrownFilled.displayName = 'FrownFilled';
var FrownFilled$1 = /*#__PURE__*/React.forwardRef(FrownFilled);

// This icon file is generated automatically.
var FrownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 008 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 008-8.4C667.6 600.3 597.5 533 512 533z" } }] }, "name": "frown", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FrownOutlined = function FrownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FrownOutlined$2
  }));
};

FrownOutlined.displayName = 'FrownOutlined';
var FrownOutlined$1 = /*#__PURE__*/React.forwardRef(FrownOutlined);

// This icon file is generated automatically.
var FrownTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 01-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 01-8 8.4zm24-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 008 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 008-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "frown", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FrownTwoTone = function FrownTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FrownTwoTone$2
  }));
};

FrownTwoTone.displayName = 'FrownTwoTone';
var FrownTwoTone$1 = /*#__PURE__*/React.forwardRef(FrownTwoTone);

// This icon file is generated automatically.
var FullscreenExitOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 000 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 00391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 00-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z" } }] }, "name": "fullscreen-exit", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FullscreenExitOutlined = function FullscreenExitOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FullscreenExitOutlined$2
  }));
};

FullscreenExitOutlined.displayName = 'FullscreenExitOutlined';
var FullscreenExitOutlined$1 = /*#__PURE__*/React.forwardRef(FullscreenExitOutlined);

// This icon file is generated automatically.
var FullscreenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M290 236.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0013.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 000 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 00-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z" } }] }, "name": "fullscreen", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FullscreenOutlined = function FullscreenOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FullscreenOutlined$2
  }));
};

FullscreenOutlined.displayName = 'FullscreenOutlined';
var FullscreenOutlined$1 = /*#__PURE__*/React.forwardRef(FullscreenOutlined);

// This icon file is generated automatically.
var FunctionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M841 370c3-3.3 2.7-8.3-.6-11.3a8.24 8.24 0 00-5.3-2.1h-72.6c-2.4 0-4.6 1-6.1 2.8L633.5 504.6a7.96 7.96 0 01-13.4-1.9l-63.5-141.3a7.9 7.9 0 00-7.3-4.7H380.7l.9-4.7 8-42.3c10.5-55.4 38-81.4 85.8-81.4 18.6 0 35.5 1.7 48.8 4.7l14.1-66.8c-22.6-4.7-35.2-6.1-54.9-6.1-103.3 0-156.4 44.3-175.9 147.3l-9.4 49.4h-97.6c-3.8 0-7.1 2.7-7.8 6.4L181.9 415a8.07 8.07 0 007.8 9.7H284l-89 429.9a8.07 8.07 0 007.8 9.7H269c3.8 0 7.1-2.7 7.8-6.4l89.7-433.1h135.8l68.2 139.1c1.4 2.9 1 6.4-1.2 8.8l-180.6 203c-2.9 3.3-2.6 8.4.7 11.3 1.5 1.3 3.4 2 5.3 2h72.7c2.4 0 4.6-1 6.1-2.8l123.7-146.7c2.8-3.4 7.9-3.8 11.3-1 .9.8 1.6 1.7 2.1 2.8L676.4 784c1.3 2.8 4.1 4.7 7.3 4.7h64.6a8.02 8.02 0 007.2-11.5l-95.2-198.9c-1.4-2.9-.9-6.4 1.3-8.8L841 370z" } }] }, "name": "function", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FunctionOutlined = function FunctionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FunctionOutlined$2
  }));
};

FunctionOutlined.displayName = 'FunctionOutlined';
var FunctionOutlined$1 = /*#__PURE__*/React.forwardRef(FunctionOutlined);

// This icon file is generated automatically.
var FundFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 01-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 01-11.3 0l-36.8-36.8a8.03 8.03 0 010-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z" } }] }, "name": "fund", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FundFilled = function FundFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FundFilled$2
  }));
};

FundFilled.displayName = 'FundFilled';
var FundFilled$1 = /*#__PURE__*/React.forwardRef(FundFilled);

// This icon file is generated automatically.
var FundOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L531 565 416.6 450.5a8.03 8.03 0 00-11.3 0l-214.9 215a8.03 8.03 0 000 11.3l36.7 36.9z" } }] }, "name": "fund", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FundOutlined = function FundOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FundOutlined$2
  }));
};

FundOutlined.displayName = 'FundOutlined';
var FundOutlined$1 = /*#__PURE__*/React.forwardRef(FundOutlined);

// This icon file is generated automatically.
var FundProjectionScreenOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M312.1 591.5c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L517 485.3l-86.1-86.2a8.03 8.03 0 00-11.3 0L275.3 543.4a8.03 8.03 0 000 11.3l36.8 36.8z" } }, { "tag": "path", "attrs": { "d": "M904 160H548V96c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H120c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h356.4v32L311.6 884.1a7.92 7.92 0 00-2.3 11l30.3 47.2v.1c2.4 3.7 7.4 4.7 11.1 2.3L512 838.9l161.3 105.8c3.7 2.4 8.7 1.4 11.1-2.3v-.1l30.3-47.2a8 8 0 00-2.3-11L548 776.3V744h356c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 512H160V232h704v440z" } }] }, "name": "fund-projection-screen", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FundProjectionScreenOutlined = function FundProjectionScreenOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FundProjectionScreenOutlined$2
  }));
};

FundProjectionScreenOutlined.displayName = 'FundProjectionScreenOutlined';
var FundProjectionScreenOutlined$1 = /*#__PURE__*/React.forwardRef(FundProjectionScreenOutlined);

// This icon file is generated automatically.
var FundTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 01-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 01-11.3 0l-36.7-36.9a8.03 8.03 0 010-11.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L533 561 418.6 446.5a8.03 8.03 0 00-11.3 0l-214.9 215a8.03 8.03 0 000 11.3l36.7 36.9z", "fill": primaryColor } }] }; }, "name": "fund", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FundTwoTone = function FundTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FundTwoTone$2
  }));
};

FundTwoTone.displayName = 'FundTwoTone';
var FundTwoTone$1 = /*#__PURE__*/React.forwardRef(FundTwoTone);

// This icon file is generated automatically.
var FundViewOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M956 686.5l-.1-.1-.1-.1C911.7 593 843.4 545 752.5 545s-159.2 48.1-203.4 141.3v.1a42.92 42.92 0 000 36.4C593.3 816 661.6 864 752.5 864s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8.1-36.2zM752.5 800c-62.1 0-107.4-30-141.1-95.5C645 639 690.4 609 752.5 609c62.1 0 107.4 30 141.1 95.5C860 770 814.6 800 752.5 800z" } }, { "tag": "path", "attrs": { "d": "M697 705a56 56 0 10112 0 56 56 0 10-112 0zM136 232h704v253h72V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h352v-72H136V232z" } }, { "tag": "path", "attrs": { "d": "M724.9 338.1l-36.8-36.8a8.03 8.03 0 00-11.3 0L493 485.3l-86.1-86.2a8.03 8.03 0 00-11.3 0L251.3 543.4a8.03 8.03 0 000 11.3l36.8 36.8c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.2-3.1 3.2-8.2 0-11.3z" } }] }, "name": "fund-view", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FundViewOutlined = function FundViewOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FundViewOutlined$2
  }));
};

FundViewOutlined.displayName = 'FundViewOutlined';
var FundViewOutlined$1 = /*#__PURE__*/React.forwardRef(FundViewOutlined);

// This icon file is generated automatically.
var FunnelPlotFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z" } }] }, "name": "funnel-plot", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var FunnelPlotFilled = function FunnelPlotFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotFilled$2
  }));
};

FunnelPlotFilled.displayName = 'FunnelPlotFilled';
var FunnelPlotFilled$1 = /*#__PURE__*/React.forwardRef(FunnelPlotFilled);

// This icon file is generated automatically.
var FunnelPlotOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z" } }] }, "name": "funnel-plot", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var FunnelPlotOutlined = function FunnelPlotOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotOutlined$2
  }));
};

FunnelPlotOutlined.displayName = 'FunnelPlotOutlined';
var FunnelPlotOutlined$1 = /*#__PURE__*/React.forwardRef(FunnelPlotOutlined);

// This icon file is generated automatically.
var FunnelPlotTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z", "fill": primaryColor } }] }; }, "name": "funnel-plot", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var FunnelPlotTwoTone = function FunnelPlotTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotTwoTone$2
  }));
};

FunnelPlotTwoTone.displayName = 'FunnelPlotTwoTone';
var FunnelPlotTwoTone$1 = /*#__PURE__*/React.forwardRef(FunnelPlotTwoTone);

// This icon file is generated automatically.
var GatewayOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z" } }] }, "name": "gateway", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GatewayOutlined = function GatewayOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GatewayOutlined$2
  }));
};

GatewayOutlined.displayName = 'GatewayOutlined';
var GatewayOutlined$1 = /*#__PURE__*/React.forwardRef(GatewayOutlined);

// This icon file is generated automatically.
var GifOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M944 299H692c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h59.2c4.4 0 8-3.6 8-8V549.9h168.2c4.4 0 8-3.6 8-8V495c0-4.4-3.6-8-8-8H759.2V364.2H944c4.4 0 8-3.6 8-8V307c0-4.4-3.6-8-8-8zm-356 1h-56c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V308c0-4.4-3.6-8-8-8zM452 500.9H290.5c-4.4 0-8 3.6-8 8v43.7c0 4.4 3.6 8 8 8h94.9l-.3 8.9c-1.2 58.8-45.6 98.5-110.9 98.5-76.2 0-123.9-59.7-123.9-156.7 0-95.8 46.8-155.2 121.5-155.2 54.8 0 93.1 26.9 108.5 75.4h76.2c-13.6-87.2-86-143.4-184.7-143.4C150 288 72 375.2 72 511.9 72 650.2 149.1 736 273 736c114.1 0 187-70.7 187-181.6v-45.5c0-4.4-3.6-8-8-8z" } }] }, "name": "gif", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GifOutlined = function GifOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GifOutlined$2
  }));
};

GifOutlined.displayName = 'GifOutlined';
var GifOutlined$1 = /*#__PURE__*/React.forwardRef(GifOutlined);

// This icon file is generated automatically.
var GiftFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z" } }] }, "name": "gift", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GiftFilled = function GiftFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GiftFilled$2
  }));
};

GiftFilled.displayName = 'GiftFilled';
var GiftFilled$1 = /*#__PURE__*/React.forwardRef(GiftFilled);

// This icon file is generated automatically.
var GiftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z" } }] }, "name": "gift", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GiftOutlined = function GiftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GiftOutlined$2
  }));
};

GiftOutlined.displayName = 'GiftOutlined';
var GiftOutlined$1 = /*#__PURE__*/React.forwardRef(GiftOutlined);

// This icon file is generated automatically.
var GiftTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z", "fill": primaryColor } }] }; }, "name": "gift", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var GiftTwoTone = function GiftTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GiftTwoTone$2
  }));
};

GiftTwoTone.displayName = 'GiftTwoTone';
var GiftTwoTone$1 = /*#__PURE__*/React.forwardRef(GiftTwoTone);

// This icon file is generated automatically.
var GithubFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" } }] }, "name": "github", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GithubFilled = function GithubFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GithubFilled$2
  }));
};

GithubFilled.displayName = 'GithubFilled';
var GithubFilled$1 = /*#__PURE__*/React.forwardRef(GithubFilled);

// This icon file is generated automatically.
var GithubOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" } }] }, "name": "github", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GithubOutlined = function GithubOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GithubOutlined$2
  }));
};

GithubOutlined.displayName = 'GithubOutlined';
var GithubOutlined$1 = /*#__PURE__*/React.forwardRef(GithubOutlined);

// This icon file is generated automatically.
var GitlabFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z" } }] }, "name": "gitlab", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GitlabFilled = function GitlabFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GitlabFilled$2
  }));
};

GitlabFilled.displayName = 'GitlabFilled';
var GitlabFilled$1 = /*#__PURE__*/React.forwardRef(GitlabFilled);

// This icon file is generated automatically.
var GitlabOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z" } }] }, "name": "gitlab", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GitlabOutlined = function GitlabOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GitlabOutlined$2
  }));
};

GitlabOutlined.displayName = 'GitlabOutlined';
var GitlabOutlined$1 = /*#__PURE__*/React.forwardRef(GitlabOutlined);

// This icon file is generated automatically.
var GlobalOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0010-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 003.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 00-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 01887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 01-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 01115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 01540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 00540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 01-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 00-81.5 55.9A373.86 373.86 0 01137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 01-107.6 69.2z" } }] }, "name": "global", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GlobalOutlined = function GlobalOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GlobalOutlined$2
  }));
};

GlobalOutlined.displayName = 'GlobalOutlined';
var GlobalOutlined$1 = /*#__PURE__*/React.forwardRef(GlobalOutlined);

// This icon file is generated automatically.
var GoldFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z" } }] }, "name": "gold", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GoldFilled = function GoldFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GoldFilled$2
  }));
};

GoldFilled.displayName = 'GoldFilled';
var GoldFilled$1 = /*#__PURE__*/React.forwardRef(GoldFilled);

// This icon file is generated automatically.
var GoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z" } }] }, "name": "gold", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GoldOutlined = function GoldOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GoldOutlined$2
  }));
};

GoldOutlined.displayName = 'GoldOutlined';
var GoldOutlined$1 = /*#__PURE__*/React.forwardRef(GoldOutlined);

// This icon file is generated automatically.
var GoldTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z", "fill": secondaryColor } }] }; }, "name": "gold", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var GoldTwoTone = function GoldTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GoldTwoTone$2
  }));
};

GoldTwoTone.displayName = 'GoldTwoTone';
var GoldTwoTone$1 = /*#__PURE__*/React.forwardRef(GoldTwoTone);

// This icon file is generated automatically.
var GoldenFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z" } }] }, "name": "golden", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GoldenFilled = function GoldenFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GoldenFilled$2
  }));
};

GoldenFilled.displayName = 'GoldenFilled';
var GoldenFilled$1 = /*#__PURE__*/React.forwardRef(GoldenFilled);

// This icon file is generated automatically.
var GoogleCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z" } }] }, "name": "google-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GoogleCircleFilled = function GoogleCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GoogleCircleFilled$2
  }));
};

GoogleCircleFilled.displayName = 'GoogleCircleFilled';
var GoogleCircleFilled$1 = /*#__PURE__*/React.forwardRef(GoogleCircleFilled);

// This icon file is generated automatically.
var GoogleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z" } }] }, "name": "google", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GoogleOutlined = function GoogleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GoogleOutlined$2
  }));
};

GoogleOutlined.displayName = 'GoogleOutlined';
var GoogleOutlined$1 = /*#__PURE__*/React.forwardRef(GoogleOutlined);

// This icon file is generated automatically.
var GooglePlusCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z" } }] }, "name": "google-plus-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GooglePlusCircleFilled = function GooglePlusCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusCircleFilled$2
  }));
};

GooglePlusCircleFilled.displayName = 'GooglePlusCircleFilled';
var GooglePlusCircleFilled$1 = /*#__PURE__*/React.forwardRef(GooglePlusCircleFilled);

// This icon file is generated automatically.
var GooglePlusOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z" } }] }, "name": "google-plus", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GooglePlusOutlined = function GooglePlusOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusOutlined$2
  }));
};

GooglePlusOutlined.displayName = 'GooglePlusOutlined';
var GooglePlusOutlined$1 = /*#__PURE__*/React.forwardRef(GooglePlusOutlined);

// This icon file is generated automatically.
var GooglePlusSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z" } }] }, "name": "google-plus-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GooglePlusSquareFilled = function GooglePlusSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusSquareFilled$2
  }));
};

GooglePlusSquareFilled.displayName = 'GooglePlusSquareFilled';
var GooglePlusSquareFilled$1 = /*#__PURE__*/React.forwardRef(GooglePlusSquareFilled);

// This icon file is generated automatically.
var GoogleSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 01272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z" } }] }, "name": "google-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var GoogleSquareFilled = function GoogleSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GoogleSquareFilled$2
  }));
};

GoogleSquareFilled.displayName = 'GoogleSquareFilled';
var GoogleSquareFilled$1 = /*#__PURE__*/React.forwardRef(GoogleSquareFilled);

// This icon file is generated automatically.
var GroupOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M912 820.1V203.9c28-9.9 48-36.6 48-67.9 0-39.8-32.2-72-72-72-31.3 0-58 20-67.9 48H203.9C194 84 167.3 64 136 64c-39.8 0-72 32.2-72 72 0 31.3 20 58 48 67.9v616.2C84 830 64 856.7 64 888c0 39.8 32.2 72 72 72 31.3 0 58-20 67.9-48h616.2c9.9 28 36.6 48 67.9 48 39.8 0 72-32.2 72-72 0-31.3-20-58-48-67.9zM888 112c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 912c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-752c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm704 680H184V184h656v656zm48 72c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z" } }, { "tag": "path", "attrs": { "d": "M288 474h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16zm56-136h336v64H344v-64zm-56 420h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16zm56-136h336v64H344v-64z" } }] }, "name": "group", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var GroupOutlined = function GroupOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: GroupOutlined$2
  }));
};

GroupOutlined.displayName = 'GroupOutlined';
var GroupOutlined$1 = /*#__PURE__*/React.forwardRef(GroupOutlined);

// This icon file is generated automatically.
var HddFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z" } }] }, "name": "hdd", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var HddFilled = function HddFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HddFilled$2
  }));
};

HddFilled.displayName = 'HddFilled';
var HddFilled$1 = /*#__PURE__*/React.forwardRef(HddFilled);

// This icon file is generated automatically.
var HddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "hdd", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HddOutlined = function HddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HddOutlined$2
  }));
};

HddOutlined.displayName = 'HddOutlined';
var HddOutlined$1 = /*#__PURE__*/React.forwardRef(HddOutlined);

// This icon file is generated automatically.
var HddTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "hdd", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var HddTwoTone = function HddTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HddTwoTone$2
  }));
};

HddTwoTone.displayName = 'HddTwoTone';
var HddTwoTone$1 = /*#__PURE__*/React.forwardRef(HddTwoTone);

// This icon file is generated automatically.
var HeartFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z" } }] }, "name": "heart", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var HeartFilled = function HeartFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HeartFilled$2
  }));
};

HeartFilled.displayName = 'HeartFilled';
var HeartFilled$1 = /*#__PURE__*/React.forwardRef(HeartFilled);

// This icon file is generated automatically.
var HeartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z" } }] }, "name": "heart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HeartOutlined = function HeartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HeartOutlined$2
  }));
};

HeartOutlined.displayName = 'HeartOutlined';
var HeartOutlined$1 = /*#__PURE__*/React.forwardRef(HeartOutlined);

// This icon file is generated automatically.
var HeartTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z", "fill": secondaryColor } }] }; }, "name": "heart", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var HeartTwoTone = function HeartTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HeartTwoTone$2
  }));
};

HeartTwoTone.displayName = 'HeartTwoTone';
var HeartTwoTone$1 = /*#__PURE__*/React.forwardRef(HeartTwoTone);

// This icon file is generated automatically.
var HeatMapOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z" } }] }, "name": "heat-map", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HeatMapOutlined = function HeatMapOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HeatMapOutlined$2
  }));
};

HeatMapOutlined.displayName = 'HeatMapOutlined';
var HeatMapOutlined$1 = /*#__PURE__*/React.forwardRef(HeatMapOutlined);

// This icon file is generated automatically.
var HighlightFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 00-11.2 0L353.3 393.4a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z" } }] }, "name": "highlight", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var HighlightFilled = function HighlightFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HighlightFilled$2
  }));
};

HighlightFilled.displayName = 'HighlightFilled';
var HighlightFilled$1 = /*#__PURE__*/React.forwardRef(HighlightFilled);

// This icon file is generated automatically.
var HighlightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 00-11.2 0L353.3 393.4a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z" } }] }, "name": "highlight", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HighlightOutlined = function HighlightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HighlightOutlined$2
  }));
};

HighlightOutlined.displayName = 'HighlightOutlined';
var HighlightOutlined$1 = /*#__PURE__*/React.forwardRef(HighlightOutlined);

// This icon file is generated automatically.
var HighlightTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M957.6 507.5L603.2 158.3a7.9 7.9 0 00-11.2 0L353.3 393.5a8.03 8.03 0 00-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 00-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0011.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0011.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z", "fill": primaryColor } }] }; }, "name": "highlight", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var HighlightTwoTone = function HighlightTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HighlightTwoTone$2
  }));
};

HighlightTwoTone.displayName = 'HighlightTwoTone';
var HighlightTwoTone$1 = /*#__PURE__*/React.forwardRef(HighlightTwoTone);

// This icon file is generated automatically.
var HistoryOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 003 14.1zm167.7 301.1l-56.7-19.5a8 8 0 00-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 01-112.5 75.9 352.18 352.18 0 01-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 01-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 01171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 01112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 01775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z" } }] }, "name": "history", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HistoryOutlined = function HistoryOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HistoryOutlined$2
  }));
};

HistoryOutlined.displayName = 'HistoryOutlined';
var HistoryOutlined$1 = /*#__PURE__*/React.forwardRef(HistoryOutlined);

// This icon file is generated automatically.
var HomeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M946.5 505L534.6 93.4a31.93 31.93 0 00-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z" } }] }, "name": "home", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var HomeFilled = function HomeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HomeFilled$2
  }));
};

HomeFilled.displayName = 'HomeFilled';
var HomeFilled$1 = /*#__PURE__*/React.forwardRef(HomeFilled);

// This icon file is generated automatically.
var HomeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z" } }] }, "name": "home", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HomeOutlined = function HomeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HomeOutlined$2
  }));
};

HomeOutlined.displayName = 'HomeOutlined';
var HomeOutlined$1 = /*#__PURE__*/React.forwardRef(HomeOutlined);

// This icon file is generated automatically.
var HomeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.6 63.6 0 00-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0018.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z", "fill": primaryColor } }] }; }, "name": "home", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var HomeTwoTone = function HomeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HomeTwoTone$2
  }));
};

HomeTwoTone.displayName = 'HomeTwoTone';
var HomeTwoTone$1 = /*#__PURE__*/React.forwardRef(HomeTwoTone);

// This icon file is generated automatically.
var HourglassFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z" } }] }, "name": "hourglass", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var HourglassFilled = function HourglassFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HourglassFilled$2
  }));
};

HourglassFilled.displayName = 'HourglassFilled';
var HourglassFilled$1 = /*#__PURE__*/React.forwardRef(HourglassFilled);

// This icon file is generated automatically.
var HourglassOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 01354 318V184h316v134z" } }] }, "name": "hourglass", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var HourglassOutlined = function HourglassOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HourglassOutlined$2
  }));
};

HourglassOutlined.displayName = 'HourglassOutlined';
var HourglassOutlined$1 = /*#__PURE__*/React.forwardRef(HourglassOutlined);

// This icon file is generated automatically.
var HourglassTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 00354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 00512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 01354 318V184h316v134z", "fill": primaryColor } }] }; }, "name": "hourglass", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var HourglassTwoTone = function HourglassTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: HourglassTwoTone$2
  }));
};

HourglassTwoTone.displayName = 'HourglassTwoTone';
var HourglassTwoTone$1 = /*#__PURE__*/React.forwardRef(HourglassTwoTone);

// This icon file is generated automatically.
var Html5Filled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z" } }] }, "name": "html5", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var Html5Filled = function Html5Filled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: Html5Filled$2
  }));
};

Html5Filled.displayName = 'Html5Filled';
var Html5Filled$1 = /*#__PURE__*/React.forwardRef(Html5Filled);

// This icon file is generated automatically.
var Html5Outlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z" } }] }, "name": "html5", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var Html5Outlined = function Html5Outlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: Html5Outlined$2
  }));
};

Html5Outlined.displayName = 'Html5Outlined';
var Html5Outlined$1 = /*#__PURE__*/React.forwardRef(Html5Outlined);

// This icon file is generated automatically.
var Html5TwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z", "fill": primaryColor } }] }; }, "name": "html5", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var Html5TwoTone = function Html5TwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: Html5TwoTone$2
  }));
};

Html5TwoTone.displayName = 'Html5TwoTone';
var Html5TwoTone$1 = /*#__PURE__*/React.forwardRef(Html5TwoTone);

// This icon file is generated automatically.
var IdcardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 01-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 01-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z" } }] }, "name": "idcard", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var IdcardFilled = function IdcardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: IdcardFilled$2
  }));
};

IdcardFilled.displayName = 'IdcardFilled';
var IdcardFilled$1 = /*#__PURE__*/React.forwardRef(IdcardFilled);

// This icon file is generated automatically.
var IdcardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z" } }] }, "name": "idcard", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var IdcardOutlined = function IdcardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: IdcardOutlined$2
  }));
};

IdcardOutlined.displayName = 'IdcardOutlined';
var IdcardOutlined$1 = /*#__PURE__*/React.forwardRef(IdcardOutlined);

// This icon file is generated automatically.
var IdcardTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 01-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M321.3 463a51.7 52 0 10103.4 0 51.7 52 0 10-103.4 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z", "fill": primaryColor } }] }; }, "name": "idcard", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var IdcardTwoTone = function IdcardTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: IdcardTwoTone$2
  }));
};

IdcardTwoTone.displayName = 'IdcardTwoTone';
var IdcardTwoTone$1 = /*#__PURE__*/React.forwardRef(IdcardTwoTone);

// This icon file is generated automatically.
var IeCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z" } }] }, "name": "ie-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var IeCircleFilled = function IeCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: IeCircleFilled$2
  }));
};

IeCircleFilled.displayName = 'IeCircleFilled';
var IeCircleFilled$1 = /*#__PURE__*/React.forwardRef(IeCircleFilled);

// This icon file is generated automatically.
var IeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z" } }] }, "name": "ie", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var IeOutlined = function IeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: IeOutlined$2
  }));
};

IeOutlined.displayName = 'IeOutlined';
var IeOutlined$1 = /*#__PURE__*/React.forwardRef(IeOutlined);

// This icon file is generated automatically.
var IeSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z" } }] }, "name": "ie-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var IeSquareFilled = function IeSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: IeSquareFilled$2
  }));
};

IeSquareFilled.displayName = 'IeSquareFilled';
var IeSquareFilled$1 = /*#__PURE__*/React.forwardRef(IeSquareFilled);

// This icon file is generated automatically.
var ImportOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zM902 476H588v-76c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-76h314c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "import", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ImportOutlined = function ImportOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ImportOutlined$2
  }));
};

ImportOutlined.displayName = 'ImportOutlined';
var ImportOutlined$1 = /*#__PURE__*/React.forwardRef(ImportOutlined);

// This icon file is generated automatically.
var InboxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0060.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z" } }] }, "name": "inbox", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InboxOutlined = function InboxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InboxOutlined$2
  }));
};

InboxOutlined.displayName = 'InboxOutlined';
var InboxOutlined$1 = /*#__PURE__*/React.forwardRef(InboxOutlined);

// This icon file is generated automatically.
var InfoCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "info-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var InfoCircleFilled = function InfoCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleFilled$2
  }));
};

InfoCircleFilled.displayName = 'InfoCircleFilled';
var InfoCircleFilled$1 = /*#__PURE__*/React.forwardRef(InfoCircleFilled);

// This icon file is generated automatically.
var InfoCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, "name": "info-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleOutlined$2
  }));
};

InfoCircleOutlined.displayName = 'InfoCircleOutlined';
var InfoCircleOutlined$1 = /*#__PURE__*/React.forwardRef(InfoCircleOutlined);

// This icon file is generated automatically.
var InfoCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "info-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var InfoCircleTwoTone = function InfoCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleTwoTone$2
  }));
};

InfoCircleTwoTone.displayName = 'InfoCircleTwoTone';
var InfoCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(InfoCircleTwoTone);

// This icon file is generated automatically.
var InfoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M448 224a64 64 0 10128 0 64 64 0 10-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z" } }] }, "name": "info", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InfoOutlined = function InfoOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InfoOutlined$2
  }));
};

InfoOutlined.displayName = 'InfoOutlined';
var InfoOutlined$1 = /*#__PURE__*/React.forwardRef(InfoOutlined);

// This icon file is generated automatically.
var InsertRowAboveOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M878.7 336H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V368c.1-17.7-14.8-32-33.2-32zM360 792H184V632h176v160zm0-224H184V408h176v160zm240 224H424V632h176v160zm0-224H424V408h176v160zm240 224H664V632h176v160zm0-224H664V408h176v160zm64-408H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z" } }] }, "name": "insert-row-above", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InsertRowAboveOutlined = function InsertRowAboveOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowAboveOutlined$2
  }));
};

InsertRowAboveOutlined.displayName = 'InsertRowAboveOutlined';
var InsertRowAboveOutlined$1 = /*#__PURE__*/React.forwardRef(InsertRowAboveOutlined);

// This icon file is generated automatically.
var InsertRowBelowOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M904 768H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-25.3-608H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V192c.1-17.7-14.8-32-33.2-32zM360 616H184V456h176v160zm0-224H184V232h176v160zm240 224H424V456h176v160zm0-224H424V232h176v160zm240 224H664V456h176v160zm0-224H664V232h176v160z" } }] }, "name": "insert-row-below", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InsertRowBelowOutlined = function InsertRowBelowOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowBelowOutlined$2
  }));
};

InsertRowBelowOutlined.displayName = 'InsertRowBelowOutlined';
var InsertRowBelowOutlined$1 = /*#__PURE__*/React.forwardRef(InsertRowBelowOutlined);

// This icon file is generated automatically.
var InsertRowLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M248 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zm584 0H368c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM568 840H408V664h160v176zm0-240H408V424h160v176zm0-240H408V184h160v176zm224 480H632V664h160v176zm0-240H632V424h160v176zm0-240H632V184h160v176z" } }] }, "name": "insert-row-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InsertRowLeftOutlined = function InsertRowLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowLeftOutlined$2
  }));
};

InsertRowLeftOutlined.displayName = 'InsertRowLeftOutlined';
var InsertRowLeftOutlined$1 = /*#__PURE__*/React.forwardRef(InsertRowLeftOutlined);

// This icon file is generated automatically.
var InsertRowRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M856 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zm-200 0H192c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM392 840H232V664h160v176zm0-240H232V424h160v176zm0-240H232V184h160v176zm224 480H456V664h160v176zm0-240H456V424h160v176zm0-240H456V184h160v176z" } }] }, "name": "insert-row-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InsertRowRightOutlined = function InsertRowRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowRightOutlined$2
  }));
};

InsertRowRightOutlined.displayName = 'InsertRowRightOutlined';
var InsertRowRightOutlined$1 = /*#__PURE__*/React.forwardRef(InsertRowRightOutlined);

// This icon file is generated automatically.
var InstagramFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 01-47.9 47.9z" } }] }, "name": "instagram", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var InstagramFilled = function InstagramFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InstagramFilled$2
  }));
};

InstagramFilled.displayName = 'InstagramFilled';
var InstagramFilled$1 = /*#__PURE__*/React.forwardRef(InstagramFilled);

// This icon file is generated automatically.
var InstagramOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 00-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z" } }] }, "name": "instagram", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InstagramOutlined = function InstagramOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InstagramOutlined$2
  }));
};

InstagramOutlined.displayName = 'InstagramOutlined';
var InstagramOutlined$1 = /*#__PURE__*/React.forwardRef(InstagramOutlined);

// This icon file is generated automatically.
var InsuranceFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 01-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 01-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 01-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 01-8.9-1.4L430 605.7a6 6 0 011.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z" } }] }, "name": "insurance", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var InsuranceFilled = function InsuranceFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InsuranceFilled$2
  }));
};

InsuranceFilled.displayName = 'InsuranceFilled';
var InsuranceFilled$1 = /*#__PURE__*/React.forwardRef(InsuranceFilled);

// This icon file is generated automatically.
var InsuranceOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M441.6 306.8L403 288.6a6.1 6.1 0 00-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 00-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0033.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 00-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z" } }] }, "name": "insurance", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InsuranceOutlined = function InsuranceOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InsuranceOutlined$2
  }));
};

InsuranceOutlined.displayName = 'InsuranceOutlined';
var InsuranceOutlined$1 = /*#__PURE__*/React.forwardRef(InsuranceOutlined);

// This icon file is generated automatically.
var InsuranceTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M521.9 358.8h97.9v41.6h-97.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 01-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 01-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 01-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 01-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 011.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 00-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0033.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 00-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z", "fill": primaryColor } }] }; }, "name": "insurance", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var InsuranceTwoTone = function InsuranceTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InsuranceTwoTone$2
  }));
};

InsuranceTwoTone.displayName = 'InsuranceTwoTone';
var InsuranceTwoTone$1 = /*#__PURE__*/React.forwardRef(InsuranceTwoTone);

// This icon file is generated automatically.
var InteractionFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z" } }] }, "name": "interaction", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var InteractionFilled = function InteractionFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InteractionFilled$2
  }));
};

InteractionFilled.displayName = 'InteractionFilled';
var InteractionFilled$1 = /*#__PURE__*/React.forwardRef(InteractionFilled);

// This icon file is generated automatically.
var InteractionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z" } }] }, "name": "interaction", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var InteractionOutlined = function InteractionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InteractionOutlined$2
  }));
};

InteractionOutlined.displayName = 'InteractionOutlined';
var InteractionOutlined$1 = /*#__PURE__*/React.forwardRef(InteractionOutlined);

// This icon file is generated automatically.
var InteractionTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z", "fill": primaryColor } }] }; }, "name": "interaction", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var InteractionTwoTone = function InteractionTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: InteractionTwoTone$2
  }));
};

InteractionTwoTone.displayName = 'InteractionTwoTone';
var InteractionTwoTone$1 = /*#__PURE__*/React.forwardRef(InteractionTwoTone);

// This icon file is generated automatically.
var IssuesCloseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 00-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0026 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 01-49.8 62.2A355.92 355.92 0 01651.1 840a355 355 0 01-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 01-113.3-76.3A353.06 353.06 0 01184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 01138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 00892 694z" } }] }, "name": "issues-close", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var IssuesCloseOutlined = function IssuesCloseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: IssuesCloseOutlined$2
  }));
};

IssuesCloseOutlined.displayName = 'IssuesCloseOutlined';
var IssuesCloseOutlined$1 = /*#__PURE__*/React.forwardRef(IssuesCloseOutlined);

// This icon file is generated automatically.
var ItalicOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" } }] }, "name": "italic", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ItalicOutlined = function ItalicOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ItalicOutlined$2
  }));
};

ItalicOutlined.displayName = 'ItalicOutlined';
var ItalicOutlined$1 = /*#__PURE__*/React.forwardRef(ItalicOutlined);

// This icon file is generated automatically.
var KeyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 00-11.4 0l-39.8 39.8a8.15 8.15 0 000 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 00-11.4 0l-39.8 39.8a8.15 8.15 0 000 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 000 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 00608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z" } }] }, "name": "key", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var KeyOutlined = function KeyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: KeyOutlined$2
  }));
};

KeyOutlined.displayName = 'KeyOutlined';
var KeyOutlined$1 = /*#__PURE__*/React.forwardRef(KeyOutlined);

// This icon file is generated automatically.
var LaptopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z" } }] }, "name": "laptop", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LaptopOutlined = function LaptopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LaptopOutlined$2
  }));
};

LaptopOutlined.displayName = 'LaptopOutlined';
var LaptopOutlined$1 = /*#__PURE__*/React.forwardRef(LaptopOutlined);

// This icon file is generated automatically.
var LayoutFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z" } }] }, "name": "layout", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LayoutFilled = function LayoutFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LayoutFilled$2
  }));
};

LayoutFilled.displayName = 'LayoutFilled';
var LayoutFilled$1 = /*#__PURE__*/React.forwardRef(LayoutFilled);

// This icon file is generated automatically.
var LayoutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z" } }] }, "name": "layout", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LayoutOutlined = function LayoutOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LayoutOutlined$2
  }));
};

LayoutOutlined.displayName = 'LayoutOutlined';
var LayoutOutlined$1 = /*#__PURE__*/React.forwardRef(LayoutOutlined);

// This icon file is generated automatically.
var LayoutTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z", "fill": primaryColor } }] }; }, "name": "layout", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var LayoutTwoTone = function LayoutTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LayoutTwoTone$2
  }));
};

LayoutTwoTone.displayName = 'LayoutTwoTone';
var LayoutTwoTone$1 = /*#__PURE__*/React.forwardRef(LayoutTwoTone);

// This icon file is generated automatically.
var LeftCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178a8 8 0 0112.7 6.5v46.8z" } }] }, "name": "left-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LeftCircleFilled = function LeftCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleFilled$2
  }));
};

LeftCircleFilled.displayName = 'LeftCircleFilled';
var LeftCircleFilled$1 = /*#__PURE__*/React.forwardRef(LeftCircleFilled);

// This icon file is generated automatically.
var LeftCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M603.3 327.5l-246 178a7.95 7.95 0 000 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "left-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LeftCircleOutlined = function LeftCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleOutlined$2
  }));
};

LeftCircleOutlined.displayName = 'LeftCircleOutlined';
var LeftCircleOutlined$1 = /*#__PURE__*/React.forwardRef(LeftCircleOutlined);

// This icon file is generated automatically.
var LeftCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M603.3 327.5l-246 178a7.95 7.95 0 000 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z", "fill": primaryColor } }] }; }, "name": "left-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var LeftCircleTwoTone = function LeftCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LeftCircleTwoTone$2
  }));
};

LeftCircleTwoTone.displayName = 'LeftCircleTwoTone';
var LeftCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(LeftCircleTwoTone);

// This icon file is generated automatically.
var LeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, "name": "left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LeftOutlined = function LeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LeftOutlined$2
  }));
};

LeftOutlined.displayName = 'LeftOutlined';
var LeftOutlined$1 = /*#__PURE__*/React.forwardRef(LeftOutlined);

// This icon file is generated automatically.
var LeftSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 010-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z" } }] }, "name": "left-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LeftSquareFilled = function LeftSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareFilled$2
  }));
};

LeftSquareFilled.displayName = 'LeftSquareFilled';
var LeftSquareFilled$1 = /*#__PURE__*/React.forwardRef(LeftSquareFilled);

// This icon file is generated automatically.
var LeftSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 000 13z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "left-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LeftSquareOutlined = function LeftSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareOutlined$2
  }));
};

LeftSquareOutlined.displayName = 'LeftSquareOutlined';
var LeftSquareOutlined$1 = /*#__PURE__*/React.forwardRef(LeftSquareOutlined);

// This icon file is generated automatically.
var LeftSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 010-12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 000 12.9z", "fill": primaryColor } }] }; }, "name": "left-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var LeftSquareTwoTone = function LeftSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareTwoTone$2
  }));
};

LeftSquareTwoTone.displayName = 'LeftSquareTwoTone';
var LeftSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(LeftSquareTwoTone);

// This icon file is generated automatically.
var LikeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z" } }] }, "name": "like", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LikeFilled = function LikeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LikeFilled$2
  }));
};

LikeFilled.displayName = 'LikeFilled';
var LikeFilled$1 = /*#__PURE__*/React.forwardRef(LikeFilled);

// This icon file is generated automatically.
var LikeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 00-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 00471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0142.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z" } }] }, "name": "like", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LikeOutlined = function LikeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LikeOutlined$2
  }));
};

LikeOutlined.displayName = 'LikeOutlined';
var LikeOutlined$1 = /*#__PURE__*/React.forwardRef(LikeOutlined);

// This icon file is generated automatically.
var LikeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0033.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0019.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0019.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0019.6-43c0-19.1-11-37.5-28.8-48.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 00-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 00-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 016.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 016.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0142.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z", "fill": primaryColor } }] }; }, "name": "like", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var LikeTwoTone = function LikeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LikeTwoTone$2
  }));
};

LikeTwoTone.displayName = 'LikeTwoTone';
var LikeTwoTone$1 = /*#__PURE__*/React.forwardRef(LikeTwoTone);

// This icon file is generated automatically.
var LineChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 00-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 00-11.3 0L266.3 586.7a8.03 8.03 0 000 11.3l39.5 39.7z" } }] }, "name": "line-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LineChartOutlined = function LineChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LineChartOutlined$2
  }));
};

LineChartOutlined.displayName = 'LineChartOutlined';
var LineChartOutlined$1 = /*#__PURE__*/React.forwardRef(LineChartOutlined);

// This icon file is generated automatically.
var LineHeightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 00-11.3 0L713.6 306.3a7.23 7.23 0 005.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 00-5.6-11.7z" } }] }, "name": "line-height", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LineHeightOutlined = function LineHeightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LineHeightOutlined$2
  }));
};

LineHeightOutlined.displayName = 'LineHeightOutlined';
var LineHeightOutlined$1 = /*#__PURE__*/React.forwardRef(LineHeightOutlined);

// This icon file is generated automatically.
var LineOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "line", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LineOutlined = function LineOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LineOutlined$2
  }));
};

LineOutlined.displayName = 'LineOutlined';
var LineOutlined$1 = /*#__PURE__*/React.forwardRef(LineOutlined);

// This icon file is generated automatically.
var LinkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z" } }] }, "name": "link", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LinkOutlined = function LinkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LinkOutlined$2
  }));
};

LinkOutlined.displayName = 'LinkOutlined';
var LinkOutlined$1 = /*#__PURE__*/React.forwardRef(LinkOutlined);

// This icon file is generated automatically.
var LinkedinFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1168.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z" } }] }, "name": "linkedin", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LinkedinFilled = function LinkedinFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LinkedinFilled$2
  }));
};

LinkedinFilled.displayName = 'LinkedinFilled';
var LinkedinFilled$1 = /*#__PURE__*/React.forwardRef(LinkedinFilled);

// This icon file is generated automatically.
var LinkedinOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 10-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z" } }] }, "name": "linkedin", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LinkedinOutlined = function LinkedinOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LinkedinOutlined$2
  }));
};

LinkedinOutlined.displayName = 'LinkedinOutlined';
var LinkedinOutlined$1 = /*#__PURE__*/React.forwardRef(LinkedinOutlined);

// This icon file is generated automatically.
var Loading3QuartersOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z" } }] }, "name": "loading-3-quarters", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var Loading3QuartersOutlined = function Loading3QuartersOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: Loading3QuartersOutlined$2
  }));
};

Loading3QuartersOutlined.displayName = 'Loading3QuartersOutlined';
var Loading3QuartersOutlined$1 = /*#__PURE__*/React.forwardRef(Loading3QuartersOutlined);

// This icon file is generated automatically.
var LoadingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, "name": "loading", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LoadingOutlined = function LoadingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LoadingOutlined$2
  }));
};

LoadingOutlined.displayName = 'LoadingOutlined';
var LoadingOutlined$1 = /*#__PURE__*/React.forwardRef(LoadingOutlined);

// This icon file is generated automatically.
var LockFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1156 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z" } }] }, "name": "lock", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var LockFilled = function LockFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LockFilled$2
  }));
};

LockFilled.displayName = 'LockFilled';
var LockFilled$1 = /*#__PURE__*/React.forwardRef(LockFilled);

// This icon file is generated automatically.
var LockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" } }] }, "name": "lock", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LockOutlined = function LockOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LockOutlined$2
  }));
};

LockOutlined.displayName = 'LockOutlined';
var LockOutlined$1 = /*#__PURE__*/React.forwardRef(LockOutlined);

// This icon file is generated automatically.
var LockTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0128 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0128-87z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z", "fill": primaryColor } }] }; }, "name": "lock", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var LockTwoTone = function LockTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LockTwoTone$2
  }));
};

LockTwoTone.displayName = 'LockTwoTone';
var LockTwoTone$1 = /*#__PURE__*/React.forwardRef(LockTwoTone);

// This icon file is generated automatically.
var LoginOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 01520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 01270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 010 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z" } }] }, "name": "login", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LoginOutlined = function LoginOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LoginOutlined$2
  }));
};

LoginOutlined.displayName = 'LoginOutlined';
var LoginOutlined$1 = /*#__PURE__*/React.forwardRef(LoginOutlined);

// This icon file is generated automatically.
var LogoutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 01-112.7 75.9A352.8 352.8 0 01512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 01-112.7-75.9 353.28 353.28 0 01-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 000-12.6z" } }] }, "name": "logout", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var LogoutOutlined = function LogoutOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: LogoutOutlined$2
  }));
};

LogoutOutlined.displayName = 'LogoutOutlined';
var LogoutOutlined$1 = /*#__PURE__*/React.forwardRef(LogoutOutlined);

// This icon file is generated automatically.
var MacCommandFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M624 672a48.01 48.01 0 0096 0c0-26.5-21.5-48-48-48h-48v48zm96-320a48.01 48.01 0 00-96 0v48h48c26.5 0 48-21.5 48-48z" } }, { "tag": "path", "attrs": { "d": "M928 64H96c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM672 560c61.9 0 112 50.1 112 112s-50.1 112-112 112-112-50.1-112-112v-48h-96v48c0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112h48v-96h-48c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112v48h96v-48c0-61.9 50.1-112 112-112s112 50.1 112 112-50.1 112-112 112h-48v96h48z" } }, { "tag": "path", "attrs": { "d": "M464 464h96v96h-96zM352 304a48.01 48.01 0 000 96h48v-48c0-26.5-21.5-48-48-48zm-48 368a48.01 48.01 0 0096 0v-48h-48c-26.5 0-48 21.5-48 48z" } }] }, "name": "mac-command", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MacCommandFilled = function MacCommandFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MacCommandFilled$2
  }));
};

MacCommandFilled.displayName = 'MacCommandFilled';
var MacCommandFilled$1 = /*#__PURE__*/React.forwardRef(MacCommandFilled);

// This icon file is generated automatically.
var MacCommandOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }, { "tag": "path", "attrs": { "d": "M370.8 554.4c-54.6 0-98.8 44.2-98.8 98.8s44.2 98.8 98.8 98.8 98.8-44.2 98.8-98.8v-42.4h84.7v42.4c0 54.6 44.2 98.8 98.8 98.8s98.8-44.2 98.8-98.8-44.2-98.8-98.8-98.8h-42.4v-84.7h42.4c54.6 0 98.8-44.2 98.8-98.8 0-54.6-44.2-98.8-98.8-98.8s-98.8 44.2-98.8 98.8v42.4h-84.7v-42.4c0-54.6-44.2-98.8-98.8-98.8S272 316.2 272 370.8s44.2 98.8 98.8 98.8h42.4v84.7h-42.4zm42.4 98.8c0 23.4-19 42.4-42.4 42.4s-42.4-19-42.4-42.4 19-42.4 42.4-42.4h42.4v42.4zm197.6-282.4c0-23.4 19-42.4 42.4-42.4s42.4 19 42.4 42.4-19 42.4-42.4 42.4h-42.4v-42.4zm0 240h42.4c23.4 0 42.4 19 42.4 42.4s-19 42.4-42.4 42.4-42.4-19-42.4-42.4v-42.4zM469.6 469.6h84.7v84.7h-84.7v-84.7zm-98.8-56.4c-23.4 0-42.4-19-42.4-42.4s19-42.4 42.4-42.4 42.4 19 42.4 42.4v42.4h-42.4z" } }] }, "name": "mac-command", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MacCommandOutlined = function MacCommandOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MacCommandOutlined$2
  }));
};

MacCommandOutlined.displayName = 'MacCommandOutlined';
var MacCommandOutlined$1 = /*#__PURE__*/React.forwardRef(MacCommandOutlined);

// This icon file is generated automatically.
var MailFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 01194 256h648.8a7.2 7.2 0 014.4 12.9z" } }] }, "name": "mail", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MailFilled = function MailFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MailFilled$2
  }));
};

MailFilled.displayName = 'MailFilled';
var MailFilled$1 = /*#__PURE__*/React.forwardRef(MailFilled);

// This icon file is generated automatically.
var MailOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z" } }] }, "name": "mail", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MailOutlined = function MailOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MailOutlined$2
  }));
};

MailOutlined.displayName = 'MailOutlined';
var MailOutlined$1 = /*#__PURE__*/React.forwardRef(MailOutlined);

// This icon file is generated automatically.
var MailTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 01-68.7 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z", "fill": primaryColor } }] }; }, "name": "mail", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MailTwoTone = function MailTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MailTwoTone$2
  }));
};

MailTwoTone.displayName = 'MailTwoTone';
var MailTwoTone$1 = /*#__PURE__*/React.forwardRef(MailTwoTone);

// This icon file is generated automatically.
var ManOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z" } }] }, "name": "man", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ManOutlined = function ManOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ManOutlined$2
  }));
};

ManOutlined.displayName = 'ManOutlined';
var ManOutlined$1 = /*#__PURE__*/React.forwardRef(ManOutlined);

// This icon file is generated automatically.
var MedicineBoxFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z" } }] }, "name": "medicine-box", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MedicineBoxFilled = function MedicineBoxFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxFilled$2
  }));
};

MedicineBoxFilled.displayName = 'MedicineBoxFilled';
var MedicineBoxFilled$1 = /*#__PURE__*/React.forwardRef(MedicineBoxFilled);

// This icon file is generated automatically.
var MedicineBoxOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "medicine-box", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MedicineBoxOutlined = function MedicineBoxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxOutlined$2
  }));
};

MedicineBoxOutlined.displayName = 'MedicineBoxOutlined';
var MedicineBoxOutlined$1 = /*#__PURE__*/React.forwardRef(MedicineBoxOutlined);

// This icon file is generated automatically.
var MedicineBoxTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M839.2 278.1a32 32 0 00-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 00-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z", "fill": primaryColor } }] }; }, "name": "medicine-box", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MedicineBoxTwoTone = function MedicineBoxTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxTwoTone$2
  }));
};

MedicineBoxTwoTone.displayName = 'MedicineBoxTwoTone';
var MedicineBoxTwoTone$1 = /*#__PURE__*/React.forwardRef(MedicineBoxTwoTone);

// This icon file is generated automatically.
var MediumCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 007-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z" } }] }, "name": "medium-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MediumCircleFilled = function MediumCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MediumCircleFilled$2
  }));
};

MediumCircleFilled.displayName = 'MediumCircleFilled';
var MediumCircleFilled$1 = /*#__PURE__*/React.forwardRef(MediumCircleFilled);

// This icon file is generated automatically.
var MediumOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 01-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 016.8-17.2z" } }] }, "name": "medium", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MediumOutlined = function MediumOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MediumOutlined$2
  }));
};

MediumOutlined.displayName = 'MediumOutlined';
var MediumOutlined$1 = /*#__PURE__*/React.forwardRef(MediumOutlined);

// This icon file is generated automatically.
var MediumSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 007-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z" } }] }, "name": "medium-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MediumSquareFilled = function MediumSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MediumSquareFilled$2
  }));
};

MediumSquareFilled.displayName = 'MediumSquareFilled';
var MediumSquareFilled$1 = /*#__PURE__*/React.forwardRef(MediumSquareFilled);

// This icon file is generated automatically.
var MediumWorkmarkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 01-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0134.61 21.67v-56.19a6.99 6.99 0 00-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 00-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0019.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 00-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 01-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 00-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0019.35-12.2v-80.85a7.65 7.65 0 00-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 00-21.19 11.64 99.68 99.68 0 012.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 002.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 00-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0144.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 002.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 002.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 002.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 002.96-17.78V457.97A19.71 19.71 0 0024 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 00-2.72 6.8v139.37a6.5 6.5 0 002.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0040.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z" } }] }, "name": "medium-workmark", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MediumWorkmarkOutlined = function MediumWorkmarkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MediumWorkmarkOutlined$2
  }));
};

MediumWorkmarkOutlined.displayName = 'MediumWorkmarkOutlined';
var MediumWorkmarkOutlined$1 = /*#__PURE__*/React.forwardRef(MediumWorkmarkOutlined);

// This icon file is generated automatically.
var MehFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "meh", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MehFilled = function MehFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MehFilled$2
  }));
};

MehFilled.displayName = 'MehFilled';
var MehFilled$1 = /*#__PURE__*/React.forwardRef(MehFilled);

// This icon file is generated automatically.
var MehOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "meh", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MehOutlined = function MehOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MehOutlined$2
  }));
};

MehOutlined.displayName = 'MehOutlined';
var MehOutlined$1 = /*#__PURE__*/React.forwardRef(MehOutlined);

// This icon file is generated automatically.
var MehTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "meh", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MehTwoTone = function MehTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MehTwoTone$2
  }));
};

MehTwoTone.displayName = 'MehTwoTone';
var MehTwoTone$1 = /*#__PURE__*/React.forwardRef(MehTwoTone);

// This icon file is generated automatically.
var MenuFoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 000 13.8z" } }] }, "name": "menu-fold", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MenuFoldOutlined = function MenuFoldOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MenuFoldOutlined$2
  }));
};

MenuFoldOutlined.displayName = 'MenuFoldOutlined';
var MenuFoldOutlined$1 = /*#__PURE__*/React.forwardRef(MenuFoldOutlined);

// This icon file is generated automatically.
var MenuOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" } }] }, "name": "menu", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MenuOutlined = function MenuOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MenuOutlined$2
  }));
};

MenuOutlined.displayName = 'MenuOutlined';
var MenuOutlined$1 = /*#__PURE__*/React.forwardRef(MenuOutlined);

// This icon file is generated automatically.
var MenuUnfoldOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 000-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0014.4 7z" } }] }, "name": "menu-unfold", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MenuUnfoldOutlined = function MenuUnfoldOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MenuUnfoldOutlined$2
  }));
};

MenuUnfoldOutlined.displayName = 'MenuUnfoldOutlined';
var MenuUnfoldOutlined$1 = /*#__PURE__*/React.forwardRef(MenuUnfoldOutlined);

// This icon file is generated automatically.
var MergeCellsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M482.2 508.4L331.3 389c-3-2.4-7.3-.2-7.3 3.6V478H184V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H144c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H184V546h140v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4a4.5 4.5 0 000-7.2zM880 116H596c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H700v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4a4.52 4.52 0 000 7.1l151 119.5c2.9 2.3 7.3.2 7.3-3.6V546h140v294H636V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z" } }] }, "name": "merge-cells", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MergeCellsOutlined = function MergeCellsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MergeCellsOutlined$2
  }));
};

MergeCellsOutlined.displayName = 'MergeCellsOutlined';
var MergeCellsOutlined$1 = /*#__PURE__*/React.forwardRef(MergeCellsOutlined);

// This icon file is generated automatically.
var MessageFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.3 338.4a447.57 447.57 0 00-96.1-143.3 443.09 443.09 0 00-143-96.3A443.91 443.91 0 00512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 00-141.7 96.5 445 445 0 00-95 142.8A449.89 449.89 0 0065 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 00199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 00827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z" } }] }, "name": "message", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MessageFilled = function MessageFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MessageFilled$2
  }));
};

MessageFilled.displayName = 'MessageFilled';
var MessageFilled$1 = /*#__PURE__*/React.forwardRef(MessageFilled);

// This icon file is generated automatically.
var MessageOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 512a48 48 0 1096 0 48 48 0 10-96 0zm200 0a48 48 0 1096 0 48 48 0 10-96 0zm-400 0a48 48 0 1096 0 48 48 0 10-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" } }] }, "name": "message", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MessageOutlined = function MessageOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MessageOutlined$2
  }));
};

MessageOutlined.displayName = 'MessageOutlined';
var MessageOutlined$1 = /*#__PURE__*/React.forwardRef(MessageOutlined);

// This icon file is generated automatically.
var MessageTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M775.3 248.9a369.62 369.62 0 00-119-80A370.2 370.2 0 00512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 00-80-119zM312 560a48.01 48.01 0 010-96 48.01 48.01 0 010 96zm200 0a48.01 48.01 0 010-96 48.01 48.01 0 010 96zm200 0a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M664 512a48 48 0 1096 0 48 48 0 10-96 0zm-400 0a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M464 512a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "message", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MessageTwoTone = function MessageTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MessageTwoTone$2
  }));
};

MessageTwoTone.displayName = 'MessageTwoTone';
var MessageTwoTone$1 = /*#__PURE__*/React.forwardRef(MessageTwoTone);

// This icon file is generated automatically.
var MinusCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z" } }] }, "name": "minus-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MinusCircleFilled = function MinusCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleFilled$2
  }));
};

MinusCircleFilled.displayName = 'MinusCircleFilled';
var MinusCircleFilled$1 = /*#__PURE__*/React.forwardRef(MinusCircleFilled);

// This icon file is generated automatically.
var MinusCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "minus-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MinusCircleOutlined = function MinusCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleOutlined$2
  }));
};

MinusCircleOutlined.displayName = 'MinusCircleOutlined';
var MinusCircleOutlined$1 = /*#__PURE__*/React.forwardRef(MinusCircleOutlined);

// This icon file is generated automatically.
var MinusCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "minus-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MinusCircleTwoTone = function MinusCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleTwoTone$2
  }));
};

MinusCircleTwoTone.displayName = 'MinusCircleTwoTone';
var MinusCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(MinusCircleTwoTone);

// This icon file is generated automatically.
var MinusOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "minus", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MinusOutlined = function MinusOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MinusOutlined$2
  }));
};

MinusOutlined.displayName = 'MinusOutlined';
var MinusOutlined$1 = /*#__PURE__*/React.forwardRef(MinusOutlined);

// This icon file is generated automatically.
var MinusSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z" } }] }, "name": "minus-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MinusSquareFilled = function MinusSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareFilled$2
  }));
};

MinusSquareFilled.displayName = 'MinusSquareFilled';
var MinusSquareFilled$1 = /*#__PURE__*/React.forwardRef(MinusSquareFilled);

// This icon file is generated automatically.
var MinusSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "minus-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareOutlined$2
  }));
};

MinusSquareOutlined.displayName = 'MinusSquareOutlined';
var MinusSquareOutlined$1 = /*#__PURE__*/React.forwardRef(MinusSquareOutlined);

// This icon file is generated automatically.
var MinusSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "minus-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MinusSquareTwoTone = function MinusSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareTwoTone$2
  }));
};

MinusSquareTwoTone.displayName = 'MinusSquareTwoTone';
var MinusSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(MinusSquareTwoTone);

// This icon file is generated automatically.
var MobileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" } }] }, "name": "mobile", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MobileFilled = function MobileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MobileFilled$2
  }));
};

MobileFilled.displayName = 'MobileFilled';
var MobileFilled$1 = /*#__PURE__*/React.forwardRef(MobileFilled);

// This icon file is generated automatically.
var MobileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "mobile", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MobileOutlined = function MobileOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MobileOutlined$2
  }));
};

MobileOutlined.displayName = 'MobileOutlined';
var MobileOutlined$1 = /*#__PURE__*/React.forwardRef(MobileOutlined);

// This icon file is generated automatically.
var MobileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 786a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "mobile", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MobileTwoTone = function MobileTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MobileTwoTone$2
  }));
};

MobileTwoTone.displayName = 'MobileTwoTone';
var MobileTwoTone$1 = /*#__PURE__*/React.forwardRef(MobileTwoTone);

// This icon file is generated automatically.
var MoneyCollectFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.5 699.7a8 8 0 00-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 017.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z" } }] }, "name": "money-collect", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var MoneyCollectFilled = function MoneyCollectFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectFilled$2
  }));
};

MoneyCollectFilled.displayName = 'MoneyCollectFilled';
var MoneyCollectFilled$1 = /*#__PURE__*/React.forwardRef(MoneyCollectFilled);

// This icon file is generated automatically.
var MoneyCollectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M911.5 700.7a8 8 0 00-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z" } }] }, "name": "money-collect", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MoneyCollectOutlined = function MoneyCollectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectOutlined$2
  }));
};

MoneyCollectOutlined.displayName = 'MoneyCollectOutlined';
var MoneyCollectOutlined$1 = /*#__PURE__*/React.forwardRef(MoneyCollectOutlined);

// This icon file is generated automatically.
var MoneyCollectTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 017.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M911.5 700.7a8 8 0 00-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z", "fill": primaryColor } }] }; }, "name": "money-collect", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var MoneyCollectTwoTone = function MoneyCollectTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectTwoTone$2
  }));
};

MoneyCollectTwoTone.displayName = 'MoneyCollectTwoTone';
var MoneyCollectTwoTone$1 = /*#__PURE__*/React.forwardRef(MoneyCollectTwoTone);

// This icon file is generated automatically.
var MonitorOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 00-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 00-11.2-1.4l-37.9 29.7a7.97 7.97 0 00-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 000 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z" } }] }, "name": "monitor", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MonitorOutlined = function MonitorOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MonitorOutlined$2
  }));
};

MonitorOutlined.displayName = 'MonitorOutlined';
var MonitorOutlined$1 = /*#__PURE__*/React.forwardRef(MonitorOutlined);

// This icon file is generated automatically.
var MoreOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M456 231a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "more", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var MoreOutlined = function MoreOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: MoreOutlined$2
  }));
};

MoreOutlined.displayName = 'MoreOutlined';
var MoreOutlined$1 = /*#__PURE__*/React.forwardRef(MoreOutlined);

// This icon file is generated automatically.
var NodeCollapseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM451.7 313.7l172.5 136.2c6.3 5.1 15.8.5 15.8-7.7V344h264c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H640v-98.2c0-8.1-9.4-12.8-15.8-7.7L451.7 298.3a9.9 9.9 0 000 15.4z" } }] }, "name": "node-collapse", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var NodeCollapseOutlined = function NodeCollapseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: NodeCollapseOutlined$2
  }));
};

NodeCollapseOutlined.displayName = 'NodeCollapseOutlined';
var NodeCollapseOutlined$1 = /*#__PURE__*/React.forwardRef(NodeCollapseOutlined);

// This icon file is generated automatically.
var NodeExpandOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM456 344h264v98.2c0 8.1 9.5 12.8 15.8 7.7l172.5-136.2c5-3.9 5-11.4 0-15.3L735.8 162.1c-6.4-5.1-15.8-.5-15.8 7.7V268H456c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8z" } }] }, "name": "node-expand", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var NodeExpandOutlined = function NodeExpandOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: NodeExpandOutlined$2
  }));
};

NodeExpandOutlined.displayName = 'NodeExpandOutlined';
var NodeExpandOutlined$1 = /*#__PURE__*/React.forwardRef(NodeExpandOutlined);

// This icon file is generated automatically.
var NodeIndexOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M843.5 737.4c-12.4-75.2-79.2-129.1-155.3-125.4S550.9 676 546 752c-153.5-4.8-208-40.7-199.1-113.7 3.3-27.3 19.8-41.9 50.1-49 18.4-4.3 38.8-4.9 57.3-3.2 1.7.2 3.5.3 5.2.5 11.3 2.7 22.8 5 34.3 6.8 34.1 5.6 68.8 8.4 101.8 6.6 92.8-5 156-45.9 159.2-132.7 3.1-84.1-54.7-143.7-147.9-183.6-29.9-12.8-61.6-22.7-93.3-30.2-14.3-3.4-26.3-5.7-35.2-7.2-7.9-75.9-71.5-133.8-147.8-134.4-76.3-.6-140.9 56.1-150.1 131.9s40 146.3 114.2 163.9c74.2 17.6 149.9-23.3 175.7-95.1 9.4 1.7 18.7 3.6 28 5.8 28.2 6.6 56.4 15.4 82.4 26.6 70.7 30.2 109.3 70.1 107.5 119.9-1.6 44.6-33.6 65.2-96.2 68.6-27.5 1.5-57.6-.9-87.3-5.8-8.3-1.4-15.9-2.8-22.6-4.3-3.9-.8-6.6-1.5-7.8-1.8l-3.1-.6c-2.2-.3-5.9-.8-10.7-1.3-25-2.3-52.1-1.5-78.5 4.6-55.2 12.9-93.9 47.2-101.1 105.8-15.7 126.2 78.6 184.7 276 188.9 29.1 70.4 106.4 107.9 179.6 87 73.3-20.9 119.3-93.4 106.9-168.6zM329.1 345.2a83.3 83.3 0 11.01-166.61 83.3 83.3 0 01-.01 166.61zM695.6 845a83.3 83.3 0 11.01-166.61A83.3 83.3 0 01695.6 845z" } }] }, "name": "node-index", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var NodeIndexOutlined = function NodeIndexOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: NodeIndexOutlined$2
  }));
};

NodeIndexOutlined.displayName = 'NodeIndexOutlined';
var NodeIndexOutlined$1 = /*#__PURE__*/React.forwardRef(NodeIndexOutlined);

// This icon file is generated automatically.
var NotificationFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z" } }] }, "name": "notification", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var NotificationFilled = function NotificationFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: NotificationFilled$2
  }));
};

NotificationFilled.displayName = 'NotificationFilled';
var NotificationFilled$1 = /*#__PURE__*/React.forwardRef(NotificationFilled);

// This icon file is generated automatically.
var NotificationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z" } }] }, "name": "notification", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var NotificationOutlined = function NotificationOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: NotificationOutlined$2
  }));
};

NotificationOutlined.displayName = 'NotificationOutlined';
var NotificationOutlined$1 = /*#__PURE__*/React.forwardRef(NotificationOutlined);

// This icon file is generated automatically.
var NotificationTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z", "fill": primaryColor } }] }; }, "name": "notification", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var NotificationTwoTone = function NotificationTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: NotificationTwoTone$2
  }));
};

NotificationTwoTone.displayName = 'NotificationTwoTone';
var NotificationTwoTone$1 = /*#__PURE__*/React.forwardRef(NotificationTwoTone);

// This icon file is generated automatically.
var NumberOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z" } }] }, "name": "number", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var NumberOutlined = function NumberOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: NumberOutlined$2
  }));
};

NumberOutlined.displayName = 'NumberOutlined';
var NumberOutlined$1 = /*#__PURE__*/React.forwardRef(NumberOutlined);

// This icon file is generated automatically.
var OneToOneOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M316 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8zm196-50c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39zm0-140c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }, { "tag": "path", "attrs": { "d": "M648 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8z" } }] }, "name": "one-to-one", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var OneToOneOutlined = function OneToOneOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: OneToOneOutlined$2
  }));
};

OneToOneOutlined.displayName = 'OneToOneOutlined';
var OneToOneOutlined$1 = /*#__PURE__*/React.forwardRef(OneToOneOutlined);

// This icon file is generated automatically.
var OrderedListOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 00-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 002.1-5.4V432c0-2.2-1.8-4-4-4z" } }] }, "name": "ordered-list", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var OrderedListOutlined = function OrderedListOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: OrderedListOutlined$2
  }));
};

OrderedListOutlined.displayName = 'OrderedListOutlined';
var OrderedListOutlined$1 = /*#__PURE__*/React.forwardRef(OrderedListOutlined);

// This icon file is generated automatically.
var PaperClipOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, "name": "paper-clip", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PaperClipOutlined = function PaperClipOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PaperClipOutlined$2
  }));
};

PaperClipOutlined.displayName = 'PaperClipOutlined';
var PaperClipOutlined$1 = /*#__PURE__*/React.forwardRef(PaperClipOutlined);

// This icon file is generated automatically.
var PartitionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M640.6 429.8h257.1c7.9 0 14.3-6.4 14.3-14.3V158.3c0-7.9-6.4-14.3-14.3-14.3H640.6c-7.9 0-14.3 6.4-14.3 14.3v92.9H490.6c-3.9 0-7.1 3.2-7.1 7.1v221.5h-85.7v-96.5c0-7.9-6.4-14.3-14.3-14.3H126.3c-7.9 0-14.3 6.4-14.3 14.3v257.2c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3V544h85.7v221.5c0 3.9 3.2 7.1 7.1 7.1h135.7v92.9c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3v-257c0-7.9-6.4-14.3-14.3-14.3h-257c-7.9 0-14.3 6.4-14.3 14.3v100h-78.6v-393h78.6v100c0 7.9 6.4 14.3 14.3 14.3zm53.5-217.9h150V362h-150V211.9zM329.9 587h-150V437h150v150zm364.2 75.1h150v150.1h-150V662.1z" } }] }, "name": "partition", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PartitionOutlined = function PartitionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PartitionOutlined$2
  }));
};

PartitionOutlined.displayName = 'PartitionOutlined';
var PartitionOutlined$1 = /*#__PURE__*/React.forwardRef(PartitionOutlined);

// This icon file is generated automatically.
var PauseCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z" } }] }, "name": "pause-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PauseCircleFilled = function PauseCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleFilled$2
  }));
};

PauseCircleFilled.displayName = 'PauseCircleFilled';
var PauseCircleFilled$1 = /*#__PURE__*/React.forwardRef(PauseCircleFilled);

// This icon file is generated automatically.
var PauseCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z" } }] }, "name": "pause-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PauseCircleOutlined = function PauseCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleOutlined$2
  }));
};

PauseCircleOutlined.displayName = 'PauseCircleOutlined';
var PauseCircleOutlined$1 = /*#__PURE__*/React.forwardRef(PauseCircleOutlined);

// This icon file is generated automatically.
var PauseCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "pause-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PauseCircleTwoTone = function PauseCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleTwoTone$2
  }));
};

PauseCircleTwoTone.displayName = 'PauseCircleTwoTone';
var PauseCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(PauseCircleTwoTone);

// This icon file is generated automatically.
var PauseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z" } }] }, "name": "pause", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PauseOutlined = function PauseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PauseOutlined$2
  }));
};

PauseOutlined.displayName = 'PauseOutlined';
var PauseOutlined$1 = /*#__PURE__*/React.forwardRef(PauseOutlined);

// This icon file is generated automatically.
var PayCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 017-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 017.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z" } }] }, "name": "pay-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PayCircleFilled = function PayCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PayCircleFilled$2
  }));
};

PayCircleFilled.displayName = 'PayCircleFilled';
var PayCircleFilled$1 = /*#__PURE__*/React.forwardRef(PayCircleFilled);

// This icon file is generated automatically.
var PayCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 00-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z" } }] }, "name": "pay-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PayCircleOutlined = function PayCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PayCircleOutlined$2
  }));
};

PayCircleOutlined.displayName = 'PayCircleOutlined';
var PayCircleOutlined$1 = /*#__PURE__*/React.forwardRef(PayCircleOutlined);

// This icon file is generated automatically.
var PercentageOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M855.7 210.8l-42.4-42.4a8.03 8.03 0 00-11.3 0L168.3 801.9a8.03 8.03 0 000 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z" } }] }, "name": "percentage", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PercentageOutlined = function PercentageOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PercentageOutlined$2
  }));
};

PercentageOutlined.displayName = 'PercentageOutlined';
var PercentageOutlined$1 = /*#__PURE__*/React.forwardRef(PercentageOutlined);

// This icon file is generated automatically.
var PhoneFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885.6 230.2L779.1 123.8a80.83 80.83 0 00-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 00-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 01553.1 553 395.34 395.34 0 01437 633.8L353.2 550a80.83 80.83 0 00-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 00-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z" } }] }, "name": "phone", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PhoneFilled = function PhoneFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PhoneFilled$2
  }));
};

PhoneFilled.displayName = 'PhoneFilled';
var PhoneFilled$1 = /*#__PURE__*/React.forwardRef(PhoneFilled);

// This icon file is generated automatically.
var PhoneOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z" } }] }, "name": "phone", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PhoneOutlined = function PhoneOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PhoneOutlined$2
  }));
};

PhoneOutlined.displayName = 'PhoneOutlined';
var PhoneOutlined$1 = /*#__PURE__*/React.forwardRef(PhoneOutlined);

// This icon file is generated automatically.
var PhoneTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 01438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z", "fill": primaryColor } }] }; }, "name": "phone", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PhoneTwoTone = function PhoneTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PhoneTwoTone$2
  }));
};

PhoneTwoTone.displayName = 'PhoneTwoTone';
var PhoneTwoTone$1 = /*#__PURE__*/React.forwardRef(PhoneTwoTone);

// This icon file is generated automatically.
var PicCenterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z" } }] }, "name": "pic-center", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PicCenterOutlined = function PicCenterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PicCenterOutlined$2
  }));
};

PicCenterOutlined.displayName = 'PicCenterOutlined';
var PicCenterOutlined$1 = /*#__PURE__*/React.forwardRef(PicCenterOutlined);

// This icon file is generated automatically.
var PicLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "pic-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PicLeftOutlined = function PicLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PicLeftOutlined$2
  }));
};

PicLeftOutlined.displayName = 'PicLeftOutlined';
var PicLeftOutlined$1 = /*#__PURE__*/React.forwardRef(PicLeftOutlined);

// This icon file is generated automatically.
var PicRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "pic-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PicRightOutlined = function PicRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PicRightOutlined$2
  }));
};

PicRightOutlined.displayName = 'PicRightOutlined';
var PicRightOutlined$1 = /*#__PURE__*/React.forwardRef(PicRightOutlined);

// This icon file is generated automatically.
var PictureFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 01-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z" } }] }, "name": "picture", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PictureFilled = function PictureFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PictureFilled$2
  }));
};

PictureFilled.displayName = 'PictureFilled';
var PictureFilled$1 = /*#__PURE__*/React.forwardRef(PictureFilled);

// This icon file is generated automatically.
var PictureOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z" } }] }, "name": "picture", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PictureOutlined = function PictureOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PictureOutlined$2
  }));
};

PictureOutlined.displayName = 'PictureOutlined';
var PictureOutlined$1 = /*#__PURE__*/React.forwardRef(PictureOutlined);

// This icon file is generated automatically.
var PictureTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", "fill": primaryColor } }] }; }, "name": "picture", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PictureTwoTone = function PictureTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PictureTwoTone$2
  }));
};

PictureTwoTone.displayName = 'PictureTwoTone';
var PictureTwoTone$1 = /*#__PURE__*/React.forwardRef(PictureTwoTone);

// This icon file is generated automatically.
var PieChartFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 00-282.5 117 397.47 397.47 0 00-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 00155.6 31.5 398.57 398.57 0 00282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0031.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 00588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z" } }] }, "name": "pie-chart", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PieChartFilled = function PieChartFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PieChartFilled$2
  }));
};

PieChartFilled.displayName = 'PieChartFilled';
var PieChartFilled$1 = /*#__PURE__*/React.forwardRef(PieChartFilled);

// This icon file is generated automatically.
var PieChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 00-282.8 117.1 398.19 398.19 0 00-85.7 127.1A397.61 397.61 0 0072 552a398.46 398.46 0 00117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 00472 952a398.46 398.46 0 00282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 00872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 01470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 00589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 01166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z" } }] }, "name": "pie-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PieChartOutlined = function PieChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PieChartOutlined$2
  }));
};

PieChartOutlined.displayName = 'PieChartOutlined';
var PieChartOutlined$1 = /*#__PURE__*/React.forwardRef(PieChartOutlined);

// This icon file is generated automatically.
var PieChartTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 01-85.7-127.1A397.12 397.12 0 0172 552.2v.2a398.57 398.57 0 00117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 00471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 00-166.4-89.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 00-282.8 117.1 398.19 398.19 0 00-85.7 127.1A397.61 397.61 0 0072 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 00472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 00872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 01470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 00589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 00-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 004.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 01166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z", "fill": primaryColor } }] }; }, "name": "pie-chart", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PieChartTwoTone = function PieChartTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PieChartTwoTone$2
  }));
};

PieChartTwoTone.displayName = 'PieChartTwoTone';
var PieChartTwoTone$1 = /*#__PURE__*/React.forwardRef(PieChartTwoTone);

// This icon file is generated automatically.
var PlayCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 01-12.7-6.5V353.7a8 8 0 0112.7-6.5L656.1 506a7.9 7.9 0 010 12.9z" } }] }, "name": "play-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PlayCircleFilled = function PlayCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleFilled$2
  }));
};

PlayCircleFilled.displayName = 'PlayCircleFilled';
var PlayCircleFilled$1 = /*#__PURE__*/React.forwardRef(PlayCircleFilled);

// This icon file is generated automatically.
var PlayCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M719.4 499.1l-296.1-215A15.9 15.9 0 00398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 000-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z" } }] }, "name": "play-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlayCircleOutlined = function PlayCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleOutlined$2
  }));
};

PlayCircleOutlined.displayName = 'PlayCircleOutlined';
var PlayCircleOutlined$1 = /*#__PURE__*/React.forwardRef(PlayCircleOutlined);

// This icon file is generated automatically.
var PlayCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 01-12.7-6.5V353a8 8 0 0112.7-6.5l218.4 158.8a7.9 7.9 0 010 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M676.1 505.3L457.7 346.5A8 8 0 00445 353v317.6a8.02 8.02 0 0012.7 6.5l218.4-158.9a7.9 7.9 0 000-12.9z", "fill": primaryColor } }] }; }, "name": "play-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PlayCircleTwoTone = function PlayCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleTwoTone$2
  }));
};

PlayCircleTwoTone.displayName = 'PlayCircleTwoTone';
var PlayCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(PlayCircleTwoTone);

// This icon file is generated automatically.
var PlaySquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 010 17.6z" } }] }, "name": "play-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PlaySquareFilled = function PlaySquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareFilled$2
  }));
};

PlaySquareFilled.displayName = 'PlaySquareFilled';
var PlaySquareFilled$1 = /*#__PURE__*/React.forwardRef(PlaySquareFilled);

// This icon file is generated automatically.
var PlaySquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M442.3 677.6l199.4-156.7a11.3 11.3 0 000-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "play-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlaySquareOutlined = function PlaySquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareOutlined$2
  }));
};

PlaySquareOutlined.displayName = 'PlaySquareOutlined';
var PlaySquareOutlined$1 = /*#__PURE__*/React.forwardRef(PlaySquareOutlined);

// This icon file is generated automatically.
var PlaySquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 010 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M442.3 677.6l199.4-156.8a11.2 11.2 0 000-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z", "fill": primaryColor } }] }; }, "name": "play-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PlaySquareTwoTone = function PlaySquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlaySquareTwoTone$2
  }));
};

PlaySquareTwoTone.displayName = 'PlaySquareTwoTone';
var PlaySquareTwoTone$1 = /*#__PURE__*/React.forwardRef(PlaySquareTwoTone);

// This icon file is generated automatically.
var PlusCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" } }] }, "name": "plus-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PlusCircleFilled = function PlusCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleFilled$2
  }));
};

PlusCircleFilled.displayName = 'PlusCircleFilled';
var PlusCircleFilled$1 = /*#__PURE__*/React.forwardRef(PlusCircleFilled);

// This icon file is generated automatically.
var PlusCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "plus-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlusCircleOutlined = function PlusCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleOutlined$2
  }));
};

PlusCircleOutlined.displayName = 'PlusCircleOutlined';
var PlusCircleOutlined$1 = /*#__PURE__*/React.forwardRef(PlusCircleOutlined);

// This icon file is generated automatically.
var PlusCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "plus-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PlusCircleTwoTone = function PlusCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleTwoTone$2
  }));
};

PlusCircleTwoTone.displayName = 'PlusCircleTwoTone';
var PlusCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(PlusCircleTwoTone);

// This icon file is generated automatically.
var PlusOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { "tag": "path", "attrs": { "d": "M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z" } }] }, "name": "plus", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlusOutlined = function PlusOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlusOutlined$2
  }));
};

PlusOutlined.displayName = 'PlusOutlined';
var PlusOutlined$1 = /*#__PURE__*/React.forwardRef(PlusOutlined);

// This icon file is generated automatically.
var PlusSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" } }] }, "name": "plus-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PlusSquareFilled = function PlusSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlusSquareFilled$2
  }));
};

PlusSquareFilled.displayName = 'PlusSquareFilled';
var PlusSquareFilled$1 = /*#__PURE__*/React.forwardRef(PlusSquareFilled);

// This icon file is generated automatically.
var PlusSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "plus-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PlusSquareOutlined = function PlusSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlusSquareOutlined$2
  }));
};

PlusSquareOutlined.displayName = 'PlusSquareOutlined';
var PlusSquareOutlined$1 = /*#__PURE__*/React.forwardRef(PlusSquareOutlined);

// This icon file is generated automatically.
var PlusSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "plus-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PlusSquareTwoTone = function PlusSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PlusSquareTwoTone$2
  }));
};

PlusSquareTwoTone.displayName = 'PlusSquareTwoTone';
var PlusSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(PlusSquareTwoTone);

// This icon file is generated automatically.
var PoundCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 01-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z" } }] }, "name": "pound-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PoundCircleFilled = function PoundCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleFilled$2
  }));
};

PoundCircleFilled.displayName = 'PoundCircleFilled';
var PoundCircleFilled$1 = /*#__PURE__*/React.forwardRef(PoundCircleFilled);

// This icon file is generated automatically.
var PoundCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z" } }] }, "name": "pound-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PoundCircleOutlined = function PoundCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleOutlined$2
  }));
};

PoundCircleOutlined.displayName = 'PoundCircleOutlined';
var PoundCircleOutlined$1 = /*#__PURE__*/React.forwardRef(PoundCircleOutlined);

// This icon file is generated automatically.
var PoundCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 01-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0010.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "pound-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PoundCircleTwoTone = function PoundCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleTwoTone$2
  }));
};

PoundCircleTwoTone.displayName = 'PoundCircleTwoTone';
var PoundCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(PoundCircleTwoTone);

// This icon file is generated automatically.
var PoundOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z" } }] }, "name": "pound", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PoundOutlined = function PoundOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PoundOutlined$2
  }));
};

PoundOutlined.displayName = 'PoundOutlined';
var PoundOutlined$1 = /*#__PURE__*/React.forwardRef(PoundOutlined);

// This icon file is generated automatically.
var PoweroffOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M705.6 124.9a8 8 0 00-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0162.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0127.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 01-76.3 113.3 353.06 353.06 0 01-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 01-113.2-76.4A355.92 355.92 0 01184 650.4a355 355 0 01-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z" } }] }, "name": "poweroff", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PoweroffOutlined = function PoweroffOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PoweroffOutlined$2
  }));
};

PoweroffOutlined.displayName = 'PoweroffOutlined';
var PoweroffOutlined$1 = /*#__PURE__*/React.forwardRef(PoweroffOutlined);

// This icon file is generated automatically.
var PrinterFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z" } }] }, "name": "printer", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PrinterFilled = function PrinterFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PrinterFilled$2
  }));
};

PrinterFilled.displayName = 'PrinterFilled';
var PrinterFilled$1 = /*#__PURE__*/React.forwardRef(PrinterFilled);

// This icon file is generated automatically.
var PrinterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z" } }] }, "name": "printer", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PrinterOutlined = function PrinterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PrinterOutlined$2
  }));
};

PrinterOutlined.displayName = 'PrinterOutlined';
var PrinterOutlined$1 = /*#__PURE__*/React.forwardRef(PrinterOutlined);

// This icon file is generated automatically.
var PrinterTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "printer", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PrinterTwoTone = function PrinterTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PrinterTwoTone$2
  }));
};

PrinterTwoTone.displayName = 'PrinterTwoTone';
var PrinterTwoTone$1 = /*#__PURE__*/React.forwardRef(PrinterTwoTone);

// This icon file is generated automatically.
var ProfileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z" } }] }, "name": "profile", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ProfileFilled = function ProfileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ProfileFilled$2
  }));
};

ProfileFilled.displayName = 'ProfileFilled';
var ProfileFilled$1 = /*#__PURE__*/React.forwardRef(ProfileFilled);

// This icon file is generated automatically.
var ProfileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0zm0 144a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "profile", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ProfileOutlined = function ProfileOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ProfileOutlined$2
  }));
};

ProfileOutlined.displayName = 'ProfileOutlined';
var ProfileOutlined$1 = /*#__PURE__*/React.forwardRef(ProfileOutlined);

// This icon file is generated automatically.
var ProfileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M340 656a40 40 0 1080 0 40 40 0 10-80 0zm0-144a40 40 0 1080 0 40 40 0 10-80 0zm0-144a40 40 0 1080 0 40 40 0 10-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "profile", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ProfileTwoTone = function ProfileTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ProfileTwoTone$2
  }));
};

ProfileTwoTone.displayName = 'ProfileTwoTone';
var ProfileTwoTone$1 = /*#__PURE__*/React.forwardRef(ProfileTwoTone);

// This icon file is generated automatically.
var ProjectFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z" } }] }, "name": "project", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ProjectFilled = function ProjectFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ProjectFilled$2
  }));
};

ProjectFilled.displayName = 'ProjectFilled';
var ProjectFilled$1 = /*#__PURE__*/React.forwardRef(ProjectFilled);

// This icon file is generated automatically.
var ProjectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "project", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ProjectOutlined = function ProjectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ProjectOutlined$2
  }));
};

ProjectOutlined.displayName = 'ProjectOutlined';
var ProjectOutlined$1 = /*#__PURE__*/React.forwardRef(ProjectOutlined);

// This icon file is generated automatically.
var ProjectTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "project", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ProjectTwoTone = function ProjectTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ProjectTwoTone$2
  }));
};

ProjectTwoTone.displayName = 'ProjectTwoTone';
var ProjectTwoTone$1 = /*#__PURE__*/React.forwardRef(ProjectTwoTone);

// This icon file is generated automatically.
var PropertySafetyFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 018.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z" } }] }, "name": "property-safety", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PropertySafetyFilled = function PropertySafetyFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyFilled$2
  }));
};

PropertySafetyFilled.displayName = 'PropertySafetyFilled';
var PropertySafetyFilled$1 = /*#__PURE__*/React.forwardRef(PropertySafetyFilled);

// This icon file is generated automatically.
var PropertySafetyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 00-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 00-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z" } }] }, "name": "property-safety", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PropertySafetyOutlined = function PropertySafetyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyOutlined$2
  }));
};

PropertySafetyOutlined.displayName = 'PropertySafetyOutlined';
var PropertySafetyOutlined$1 = /*#__PURE__*/React.forwardRef(PropertySafetyOutlined);

// This icon file is generated automatically.
var PropertySafetyTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 018.9-5.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M438.9 323.5a9.88 9.88 0 00-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 00-8.9 5.5l-73.2 144.3-72.9-144.3z", "fill": primaryColor } }] }; }, "name": "property-safety", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PropertySafetyTwoTone = function PropertySafetyTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyTwoTone$2
  }));
};

PropertySafetyTwoTone.displayName = 'PropertySafetyTwoTone';
var PropertySafetyTwoTone$1 = /*#__PURE__*/React.forwardRef(PropertySafetyTwoTone);

// This icon file is generated automatically.
var PullRequestOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 010-96 48.01 48.01 0 010 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm96 600a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0z" } }] }, "name": "pull-request", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PullRequestOutlined = function PullRequestOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PullRequestOutlined$2
  }));
};

PullRequestOutlined.displayName = 'PullRequestOutlined';
var PullRequestOutlined$1 = /*#__PURE__*/React.forwardRef(PullRequestOutlined);

// This icon file is generated automatically.
var PushpinFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z" } }] }, "name": "pushpin", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var PushpinFilled = function PushpinFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PushpinFilled$2
  }));
};

PushpinFilled.displayName = 'PushpinFilled';
var PushpinFilled$1 = /*#__PURE__*/React.forwardRef(PushpinFilled);

// This icon file is generated automatically.
var PushpinOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 00-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 01-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z" } }] }, "name": "pushpin", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var PushpinOutlined = function PushpinOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PushpinOutlined$2
  }));
};

PushpinOutlined.displayName = 'PushpinOutlined';
var PushpinOutlined$1 = /*#__PURE__*/React.forwardRef(PushpinOutlined);

// This icon file is generated automatically.
var PushpinTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0030.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 00-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 01-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z", "fill": primaryColor } }] }; }, "name": "pushpin", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var PushpinTwoTone = function PushpinTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: PushpinTwoTone$2
  }));
};

PushpinTwoTone.displayName = 'PushpinTwoTone';
var PushpinTwoTone$1 = /*#__PURE__*/React.forwardRef(PushpinTwoTone);

// This icon file is generated automatically.
var QqCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z" } }] }, "name": "qq-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var QqCircleFilled = function QqCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: QqCircleFilled$2
  }));
};

QqCircleFilled.displayName = 'QqCircleFilled';
var QqCircleFilled$1 = /*#__PURE__*/React.forwardRef(QqCircleFilled);

// This icon file is generated automatically.
var QqOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z" } }] }, "name": "qq", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var QqOutlined = function QqOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: QqOutlined$2
  }));
};

QqOutlined.displayName = 'QqOutlined';
var QqOutlined$1 = /*#__PURE__*/React.forwardRef(QqOutlined);

// This icon file is generated automatically.
var QqSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z" } }] }, "name": "qq-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var QqSquareFilled = function QqSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: QqSquareFilled$2
  }));
};

QqSquareFilled.displayName = 'QqSquareFilled';
var QqSquareFilled$1 = /*#__PURE__*/React.forwardRef(QqSquareFilled);

// This icon file is generated automatically.
var QrcodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "qrcode", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var QrcodeOutlined = function QrcodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: QrcodeOutlined$2
  }));
};

QrcodeOutlined.displayName = 'QrcodeOutlined';
var QrcodeOutlined$1 = /*#__PURE__*/React.forwardRef(QrcodeOutlined);

// This icon file is generated automatically.
var QuestionCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 00-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z" } }] }, "name": "question-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var QuestionCircleFilled = function QuestionCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleFilled$2
  }));
};

QuestionCircleFilled.displayName = 'QuestionCircleFilled';
var QuestionCircleFilled$1 = /*#__PURE__*/React.forwardRef(QuestionCircleFilled);

// This icon file is generated automatically.
var QuestionCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "question-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleOutlined$2
  }));
};

QuestionCircleOutlined.displayName = 'QuestionCircleOutlined';
var QuestionCircleOutlined$1 = /*#__PURE__*/React.forwardRef(QuestionCircleOutlined);

// This icon file is generated automatically.
var QuestionCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 00-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 732a40 40 0 1080 0 40 40 0 10-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z", "fill": primaryColor } }] }; }, "name": "question-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var QuestionCircleTwoTone = function QuestionCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleTwoTone$2
  }));
};

QuestionCircleTwoTone.displayName = 'QuestionCircleTwoTone';
var QuestionCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(QuestionCircleTwoTone);

// This icon file is generated automatically.
var QuestionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 00-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z" } }] }, "name": "question", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var QuestionOutlined = function QuestionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: QuestionOutlined$2
  }));
};

QuestionOutlined.displayName = 'QuestionOutlined';
var QuestionOutlined$1 = /*#__PURE__*/React.forwardRef(QuestionOutlined);

// This icon file is generated automatically.
var RadarChartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926.8 397.1l-396-288a31.81 31.81 0 00-37.6 0l-396 288a31.99 31.99 0 00-11.6 35.8l151.3 466a32 32 0 0030.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z" } }] }, "name": "radar-chart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadarChartOutlined = function RadarChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RadarChartOutlined$2
  }));
};

RadarChartOutlined.displayName = 'RadarChartOutlined';
var RadarChartOutlined$1 = /*#__PURE__*/React.forwardRef(RadarChartOutlined);

// This icon file is generated automatically.
var RadiusBottomleftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "radius-bottomleft", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadiusBottomleftOutlined = function RadiusBottomleftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RadiusBottomleftOutlined$2
  }));
};

RadiusBottomleftOutlined.displayName = 'RadiusBottomleftOutlined';
var RadiusBottomleftOutlined$1 = /*#__PURE__*/React.forwardRef(RadiusBottomleftOutlined);

// This icon file is generated automatically.
var RadiusBottomrightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z" } }] }, "name": "radius-bottomright", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadiusBottomrightOutlined = function RadiusBottomrightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RadiusBottomrightOutlined$2
  }));
};

RadiusBottomrightOutlined.displayName = 'RadiusBottomrightOutlined';
var RadiusBottomrightOutlined$1 = /*#__PURE__*/React.forwardRef(RadiusBottomrightOutlined);

// This icon file is generated automatically.
var RadiusSettingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z" } }] }, "name": "radius-setting", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadiusSettingOutlined = function RadiusSettingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RadiusSettingOutlined$2
  }));
};

RadiusSettingOutlined.displayName = 'RadiusSettingOutlined';
var RadiusSettingOutlined$1 = /*#__PURE__*/React.forwardRef(RadiusSettingOutlined);

// This icon file is generated automatically.
var RadiusUpleftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "radius-upleft", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadiusUpleftOutlined = function RadiusUpleftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RadiusUpleftOutlined$2
  }));
};

RadiusUpleftOutlined.displayName = 'RadiusUpleftOutlined';
var RadiusUpleftOutlined$1 = /*#__PURE__*/React.forwardRef(RadiusUpleftOutlined);

// This icon file is generated automatically.
var RadiusUprightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z" } }] }, "name": "radius-upright", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RadiusUprightOutlined = function RadiusUprightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RadiusUprightOutlined$2
  }));
};

RadiusUprightOutlined.displayName = 'RadiusUprightOutlined';
var RadiusUprightOutlined$1 = /*#__PURE__*/React.forwardRef(RadiusUprightOutlined);

// This icon file is generated automatically.
var ReadFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 00324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z" } }] }, "name": "read", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ReadFilled = function ReadFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ReadFilled$2
  }));
};

ReadFilled.displayName = 'ReadFilled';
var ReadFilled$1 = /*#__PURE__*/React.forwardRef(ReadFilled);

// This icon file is generated automatically.
var ReadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 00324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z" } }] }, "name": "read", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ReadOutlined = function ReadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ReadOutlined$2
  }));
};

ReadOutlined.displayName = 'ReadOutlined';
var ReadOutlined$1 = /*#__PURE__*/React.forwardRef(ReadOutlined);

// This icon file is generated automatically.
var ReconciliationFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z" } }] }, "name": "reconciliation", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ReconciliationFilled = function ReconciliationFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationFilled$2
  }));
};

ReconciliationFilled.displayName = 'ReconciliationFilled';
var ReconciliationFilled$1 = /*#__PURE__*/React.forwardRef(ReconciliationFilled);

// This icon file is generated automatically.
var ReconciliationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z" } }] }, "name": "reconciliation", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ReconciliationOutlined = function ReconciliationOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationOutlined$2
  }));
};

ReconciliationOutlined.displayName = 'ReconciliationOutlined';
var ReconciliationOutlined$1 = /*#__PURE__*/React.forwardRef(ReconciliationOutlined);

// This icon file is generated automatically.
var ReconciliationTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M642 657a34 34 0 1068 0 34 34 0 10-68 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z", "fill": primaryColor } }] }; }, "name": "reconciliation", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ReconciliationTwoTone = function ReconciliationTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ReconciliationTwoTone$2
  }));
};

ReconciliationTwoTone.displayName = 'ReconciliationTwoTone';
var ReconciliationTwoTone$1 = /*#__PURE__*/React.forwardRef(ReconciliationTwoTone);

// This icon file is generated automatically.
var RedEnvelopeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 017.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z" } }] }, "name": "red-envelope", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RedEnvelopeFilled = function RedEnvelopeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RedEnvelopeFilled$2
  }));
};

RedEnvelopeFilled.displayName = 'RedEnvelopeFilled';
var RedEnvelopeFilled$1 = /*#__PURE__*/React.forwardRef(RedEnvelopeFilled);

// This icon file is generated automatically.
var RedEnvelopeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M440.6 462.6a8.38 8.38 0 00-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 00-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 00-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z" } }] }, "name": "red-envelope", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RedEnvelopeOutlined = function RedEnvelopeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RedEnvelopeOutlined$2
  }));
};

RedEnvelopeOutlined.displayName = 'RedEnvelopeOutlined';
var RedEnvelopeOutlined$1 = /*#__PURE__*/React.forwardRef(RedEnvelopeOutlined);

// This icon file is generated automatically.
var RedEnvelopeTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 01-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 017.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 013.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 017.5-4.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M440.6 462.6a8.38 8.38 0 00-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 00-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 00-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z", "fill": primaryColor } }] }; }, "name": "red-envelope", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var RedEnvelopeTwoTone = function RedEnvelopeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RedEnvelopeTwoTone$2
  }));
};

RedEnvelopeTwoTone.displayName = 'RedEnvelopeTwoTone';
var RedEnvelopeTwoTone$1 = /*#__PURE__*/React.forwardRef(RedEnvelopeTwoTone);

// This icon file is generated automatically.
var RedditCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M584 548a36 36 0 1072 0 36 36 0 10-72 0zm144-108a35.9 35.9 0 00-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 00728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 01296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 01101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 00-30.1-3.6zM296 440a35.98 35.98 0 00-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 00296 440zm72 108a36 36 0 1072 0 36 36 0 10-72 0z" } }] }, "name": "reddit-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RedditCircleFilled = function RedditCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RedditCircleFilled$2
  }));
};

RedditCircleFilled.displayName = 'RedditCircleFilled';
var RedditCircleFilled$1 = /*#__PURE__*/React.forwardRef(RedditCircleFilled);

// This icon file is generated automatically.
var RedditOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 568a56 56 0 10112 0 56 56 0 10-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 10-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 00-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 00176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 110 63 31.5 31.5 0 010-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0150.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 01-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "reddit", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RedditOutlined = function RedditOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RedditOutlined$2
  }));
};

RedditOutlined.displayName = 'RedditOutlined';
var RedditOutlined$1 = /*#__PURE__*/React.forwardRef(RedditOutlined);

// This icon file is generated automatically.
var RedditSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M296 440a35.98 35.98 0 00-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 00296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 00-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 01296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 01101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1072 0 36 36 0 10-72 0zm144-108a35.9 35.9 0 00-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 00728 440zM368 548a36 36 0 1072 0 36 36 0 10-72 0z" } }] }, "name": "reddit-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RedditSquareFilled = function RedditSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RedditSquareFilled$2
  }));
};

RedditSquareFilled.displayName = 'RedditSquareFilled';
var RedditSquareFilled$1 = /*#__PURE__*/React.forwardRef(RedditSquareFilled);

// This icon file is generated automatically.
var RedoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 00-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z" } }] }, "name": "redo", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RedoOutlined = function RedoOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RedoOutlined$2
  }));
};

RedoOutlined.displayName = 'RedoOutlined';
var RedoOutlined$1 = /*#__PURE__*/React.forwardRef(RedoOutlined);

// This icon file is generated automatically.
var ReloadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z" } }] }, "name": "reload", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ReloadOutlined = function ReloadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ReloadOutlined$2
  }));
};

ReloadOutlined.displayName = 'ReloadOutlined';
var ReloadOutlined$1 = /*#__PURE__*/React.forwardRef(ReloadOutlined);

// This icon file is generated automatically.
var RestFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 10160 0 80 80 0 10-160 0z" } }] }, "name": "rest", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RestFilled = function RestFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RestFilled$2
  }));
};

RestFilled.displayName = 'RestFilled';
var RestFilled$1 = /*#__PURE__*/React.forwardRef(RestFilled);

// This icon file is generated automatically.
var RestOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z" } }, { "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z" } }] }, "name": "rest", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RestOutlined = function RestOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RestOutlined$2
  }));
};

RestOutlined.displayName = 'RestOutlined';
var RestOutlined$1 = /*#__PURE__*/React.forwardRef(RestOutlined);

// This icon file is generated automatically.
var RestTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0031.9 29.3h429.2a32 32 0 0031.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z", "fill": primaryColor } }] }; }, "name": "rest", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var RestTwoTone = function RestTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RestTwoTone$2
  }));
};

RestTwoTone.displayName = 'RestTwoTone';
var RestTwoTone$1 = /*#__PURE__*/React.forwardRef(RestTwoTone);

// This icon file is generated automatically.
var RetweetOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0011.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 00-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 00-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z" } }] }, "name": "retweet", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RetweetOutlined = function RetweetOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RetweetOutlined$2
  }));
};

RetweetOutlined.displayName = 'RetweetOutlined';
var RetweetOutlined$1 = /*#__PURE__*/React.forwardRef(RetweetOutlined);

// This icon file is generated automatically.
var RightCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z" } }] }, "name": "right-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RightCircleFilled = function RightCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleFilled$2
  }));
};

RightCircleFilled.displayName = 'RightCircleFilled';
var RightCircleFilled$1 = /*#__PURE__*/React.forwardRef(RightCircleFilled);

// This icon file is generated automatically.
var RightCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M666.7 505.5l-246-178A8 8 0 00408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "right-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RightCircleOutlined = function RightCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleOutlined$2
  }));
};

RightCircleOutlined.displayName = 'RightCircleOutlined';
var RightCircleOutlined$1 = /*#__PURE__*/React.forwardRef(RightCircleOutlined);

// This icon file is generated automatically.
var RightCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z", "fill": primaryColor } }] }; }, "name": "right-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var RightCircleTwoTone = function RightCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleTwoTone$2
  }));
};

RightCircleTwoTone.displayName = 'RightCircleTwoTone';
var RightCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(RightCircleTwoTone);

// This icon file is generated automatically.
var RightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RightOutlined = function RightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RightOutlined$2
  }));
};

RightOutlined.displayName = 'RightOutlined';
var RightOutlined$1 = /*#__PURE__*/React.forwardRef(RightOutlined);

// This icon file is generated automatically.
var RightSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z" } }] }, "name": "right-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RightSquareFilled = function RightSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareFilled$2
  }));
};

RightSquareFilled.displayName = 'RightSquareFilled';
var RightSquareFilled$1 = /*#__PURE__*/React.forwardRef(RightSquareFilled);

// This icon file is generated automatically.
var RightSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "right-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RightSquareOutlined = function RightSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareOutlined$2
  }));
};

RightSquareOutlined.displayName = 'RightSquareOutlined';
var RightSquareOutlined$1 = /*#__PURE__*/React.forwardRef(RightSquareOutlined);

// This icon file is generated automatically.
var RightSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z", "fill": primaryColor } }] }; }, "name": "right-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var RightSquareTwoTone = function RightSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareTwoTone$2
  }));
};

RightSquareTwoTone.displayName = 'RightSquareTwoTone';
var RightSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(RightSquareTwoTone);

// This icon file is generated automatically.
var RiseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 000 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0013.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z" } }] }, "name": "rise", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RiseOutlined = function RiseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RiseOutlined$2
  }));
};

RiseOutlined.displayName = 'RiseOutlined';
var RiseOutlined$1 = /*#__PURE__*/React.forwardRef(RiseOutlined);

// This icon file is generated automatically.
var RobotFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM300 328c0-33.1 26.9-60 60-60s60 26.9 60 60-26.9 60-60 60-60-26.9-60-60zm372 248c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-60c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v60zm-8-188c-33.1 0-60-26.9-60-60s26.9-60 60-60 60 26.9 60 60-26.9 60-60 60zm135 476H225c-13.8 0-25 14.3-25 32v56c0 4.4 2.8 8 6.2 8h611.5c3.4 0 6.2-3.6 6.2-8v-56c.1-17.7-11.1-32-24.9-32z" } }] }, "name": "robot", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RobotFilled = function RobotFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RobotFilled$2
  }));
};

RobotFilled.displayName = 'RobotFilled';
var RobotFilled$1 = /*#__PURE__*/React.forwardRef(RobotFilled);

// This icon file is generated automatically.
var RobotOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M300 328a60 60 0 10120 0 60 60 0 10-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 10120 0 60 60 0 10-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "robot", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RobotOutlined = function RobotOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RobotOutlined$2
  }));
};

RobotOutlined.displayName = 'RobotOutlined';
var RobotOutlined$1 = /*#__PURE__*/React.forwardRef(RobotOutlined);

// This icon file is generated automatically.
var RocketFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 010 96 48.01 48.01 0 010-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z" } }] }, "name": "rocket", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var RocketFilled = function RocketFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RocketFilled$2
  }));
};

RocketFilled.displayName = 'RocketFilled';
var RocketFilled$1 = /*#__PURE__*/React.forwardRef(RocketFilled);

// This icon file is generated automatically.
var RocketOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0162.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1096 0 48 48 0 10-96 0z" } }] }, "name": "rocket", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RocketOutlined = function RocketOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RocketOutlined$2
  }));
};

RocketOutlined.displayName = 'RocketOutlined';
var RocketOutlined$1 = /*#__PURE__*/React.forwardRef(RocketOutlined);

// This icon file is generated automatically.
var RocketTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 00-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 00-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0043.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0043.1-30.5 97.52 97.52 0 0021.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 01-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0162.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M464 400a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "rocket", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var RocketTwoTone = function RocketTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RocketTwoTone$2
  }));
};

RocketTwoTone.displayName = 'RocketTwoTone';
var RocketTwoTone$1 = /*#__PURE__*/React.forwardRef(RocketTwoTone);

// This icon file is generated automatically.
var RollbackOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 000 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z" } }] }, "name": "rollback", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RollbackOutlined = function RollbackOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RollbackOutlined$2
  }));
};

RollbackOutlined.displayName = 'RollbackOutlined';
var RollbackOutlined$1 = /*#__PURE__*/React.forwardRef(RollbackOutlined);

// This icon file is generated automatically.
var RotateLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" } }, { "tag": "path", "attrs": { "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" } }] }, "name": "rotate-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RotateLeftOutlined = function RotateLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RotateLeftOutlined$2
  }));
};

RotateLeftOutlined.displayName = 'RotateLeftOutlined';
var RotateLeftOutlined$1 = /*#__PURE__*/React.forwardRef(RotateLeftOutlined);

// This icon file is generated automatically.
var RotateRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" } }, { "tag": "path", "attrs": { "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" } }] }, "name": "rotate-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var RotateRightOutlined = function RotateRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: RotateRightOutlined$2
  }));
};

RotateRightOutlined.displayName = 'RotateRightOutlined';
var RotateRightOutlined$1 = /*#__PURE__*/React.forwardRef(RotateRightOutlined);

// This icon file is generated automatically.
var SafetyCertificateFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z" } }] }, "name": "safety-certificate", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SafetyCertificateFilled = function SafetyCertificateFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateFilled$2
  }));
};

SafetyCertificateFilled.displayName = 'SafetyCertificateFilled';
var SafetyCertificateFilled$1 = /*#__PURE__*/React.forwardRef(SafetyCertificateFilled);

// This icon file is generated automatically.
var SafetyCertificateOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z" } }] }, "name": "safety-certificate", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SafetyCertificateOutlined = function SafetyCertificateOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateOutlined$2
  }));
};

SafetyCertificateOutlined.displayName = 'SafetyCertificateOutlined';
var SafetyCertificateOutlined$1 = /*#__PURE__*/React.forwardRef(SafetyCertificateOutlined);

// This icon file is generated automatically.
var SafetyCertificateTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 01-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z", "fill": primaryColor } }] }; }, "name": "safety-certificate", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SafetyCertificateTwoTone = function SafetyCertificateTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateTwoTone$2
  }));
};

SafetyCertificateTwoTone.displayName = 'SafetyCertificateTwoTone';
var SafetyCertificateTwoTone$1 = /*#__PURE__*/React.forwardRef(SafetyCertificateTwoTone);

// This icon file is generated automatically.
var SafetyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z" } }, { "tag": "path", "attrs": { "d": "M378.4 475.1a35.91 35.91 0 00-50.9 0 35.91 35.91 0 000 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0048.1 0L730.6 434a33.98 33.98 0 000-48.1l-2.8-2.8a33.98 33.98 0 00-48.1 0L483 579.7 378.4 475.1z" } }] }, "name": "safety", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SafetyOutlined = function SafetyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SafetyOutlined$2
  }));
};

SafetyOutlined.displayName = 'SafetyOutlined';
var SafetyOutlined$1 = /*#__PURE__*/React.forwardRef(SafetyOutlined);

// This icon file is generated automatically.
var SaveFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z" } }] }, "name": "save", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SaveFilled = function SaveFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SaveFilled$2
  }));
};

SaveFilled.displayName = 'SaveFilled';
var SaveFilled$1 = /*#__PURE__*/React.forwardRef(SaveFilled);

// This icon file is generated automatically.
var SaveOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z" } }] }, "name": "save", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SaveOutlined = function SaveOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SaveOutlined$2
  }));
};

SaveOutlined.displayName = 'SaveOutlined';
var SaveOutlined$1 = /*#__PURE__*/React.forwardRef(SaveOutlined);

// This icon file is generated automatically.
var SaveTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 00-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z", "fill": primaryColor } }] }; }, "name": "save", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SaveTwoTone = function SaveTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SaveTwoTone$2
  }));
};

SaveTwoTone.displayName = 'SaveTwoTone';
var SaveTwoTone$1 = /*#__PURE__*/React.forwardRef(SaveTwoTone);

// This icon file is generated automatically.
var ScanOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "scan", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ScanOutlined = function ScanOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ScanOutlined$2
  }));
};

ScanOutlined.displayName = 'ScanOutlined';
var ScanOutlined$1 = /*#__PURE__*/React.forwardRef(ScanOutlined);

// This icon file is generated automatically.
var ScheduleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 01-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z" } }] }, "name": "schedule", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ScheduleFilled = function ScheduleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleFilled$2
  }));
};

ScheduleFilled.displayName = 'ScheduleFilled';
var ScheduleFilled$1 = /*#__PURE__*/React.forwardRef(ScheduleFilled);

// This icon file is generated automatically.
var ScheduleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0025.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z" } }] }, "name": "schedule", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ScheduleOutlined = function ScheduleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleOutlined$2
  }));
};

ScheduleOutlined.displayName = 'ScheduleOutlined';
var ScheduleOutlined$1 = /*#__PURE__*/React.forwardRef(ScheduleOutlined);

// This icon file is generated automatically.
var ScheduleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 01-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0025.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }] }; }, "name": "schedule", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ScheduleTwoTone = function ScheduleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleTwoTone$2
  }));
};

ScheduleTwoTone.displayName = 'ScheduleTwoTone';
var ScheduleTwoTone$1 = /*#__PURE__*/React.forwardRef(ScheduleTwoTone);

// This icon file is generated automatically.
var ScissorOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 00288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z" } }] }, "name": "scissor", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ScissorOutlined = function ScissorOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ScissorOutlined$2
  }));
};

ScissorOutlined.displayName = 'ScissorOutlined';
var ScissorOutlined$1 = /*#__PURE__*/React.forwardRef(ScissorOutlined);

// This icon file is generated automatically.
var SearchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SearchOutlined = function SearchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SearchOutlined$2
  }));
};

SearchOutlined.displayName = 'SearchOutlined';
var SearchOutlined$1 = /*#__PURE__*/React.forwardRef(SearchOutlined);

// This icon file is generated automatically.
var SecurityScanFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 01-11.3 0l-34-34a8.03 8.03 0 010-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 10113.27-113.28 80.1 80.1 0 10-113.27 113.28z" } }] }, "name": "security-scan", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SecurityScanFilled = function SecurityScanFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SecurityScanFilled$2
  }));
};

SecurityScanFilled.displayName = 'SecurityScanFilled';
var SecurityScanFilled$1 = /*#__PURE__*/React.forwardRef(SecurityScanFilled);

// This icon file is generated automatically.
var SecurityScanOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 000 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z" } }] }, "name": "security-scan", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SecurityScanOutlined = function SecurityScanOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SecurityScanOutlined$2
  }));
};

SecurityScanOutlined.displayName = 'SecurityScanOutlined';
var SecurityScanOutlined$1 = /*#__PURE__*/React.forwardRef(SecurityScanOutlined);

// This icon file is generated automatically.
var SecurityScanTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M460.7 451.1a80.1 80.1 0 10160.2 0 80.1 80.1 0 10-160.2 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 01-11.3 0l-34-34a8.03 8.03 0 010-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M418.8 527.8l-77.5 77.5a8.03 8.03 0 000 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 01113.3 0 80.1 80.1 0 010 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z", "fill": primaryColor } }] }; }, "name": "security-scan", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SecurityScanTwoTone = function SecurityScanTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SecurityScanTwoTone$2
  }));
};

SecurityScanTwoTone.displayName = 'SecurityScanTwoTone';
var SecurityScanTwoTone$1 = /*#__PURE__*/React.forwardRef(SecurityScanTwoTone);

// This icon file is generated automatically.
var SelectOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 00-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z" } }] }, "name": "select", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SelectOutlined = function SelectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SelectOutlined$2
  }));
};

SelectOutlined.displayName = 'SelectOutlined';
var SelectOutlined$1 = /*#__PURE__*/React.forwardRef(SelectOutlined);

// This icon file is generated automatically.
var SendOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2a15.99 15.99 0 00-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-.9 3.7-.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 .7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-.8 4.2-2.6 5-5 1.4-4.2-.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z" } }] }, "name": "send", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SendOutlined = function SendOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SendOutlined$2
  }));
};

SendOutlined.displayName = 'SendOutlined';
var SendOutlined$1 = /*#__PURE__*/React.forwardRef(SendOutlined);

// This icon file is generated automatically.
var SettingFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 00-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 009.3-35.2l-.9-2.6a442.5 442.5 0 00-79.6-137.7l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.3a353.44 353.44 0 00-98.9 57.3l-81.8-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a445.93 445.93 0 00-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0025.8 25.7l2.7.5a448.27 448.27 0 00158.8 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z" } }] }, "name": "setting", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SettingFilled = function SettingFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SettingFilled$2
  }));
};

SettingFilled.displayName = 'SettingFilled';
var SettingFilled$1 = /*#__PURE__*/React.forwardRef(SettingFilled);

// This icon file is generated automatically.
var SettingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z" } }] }, "name": "setting", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SettingOutlined = function SettingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SettingOutlined$2
  }));
};

SettingOutlined.displayName = 'SettingOutlined';
var SettingOutlined$1 = /*#__PURE__*/React.forwardRef(SettingOutlined);

// This icon file is generated automatically.
var SettingTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 00-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 01-79.7 137.9l-1.8 2.1a32 32 0 01-35.1 9.5l-81.3-28.9a350 350 0 01-99.7 57.6l-15.7 85a32.05 32.05 0 01-25.8 25.7l-2.7.5a445.2 445.2 0 01-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M594.1 952.2a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 00-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6a32.09 32.09 0 007.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z", "fill": primaryColor } }] }; }, "name": "setting", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SettingTwoTone = function SettingTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SettingTwoTone$2
  }));
};

SettingTwoTone.displayName = 'SettingTwoTone';
var SettingTwoTone$1 = /*#__PURE__*/React.forwardRef(SettingTwoTone);

// This icon file is generated automatically.
var ShakeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M324 666a48 48 0 1096 0 48 48 0 10-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 000 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0011.2 0L373.7 164a7.9 7.9 0 000-11.2l-38.4-38.4a7.9 7.9 0 00-11.2 0L114.3 323.9a7.9 7.9 0 000 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 00-11.2 0L650.3 860.1a7.9 7.9 0 000 11.2l38.4 38.4a7.9 7.9 0 0011.2 0L909.7 700a7.9 7.9 0 000-11.2l-38.3-38.5z" } }] }, "name": "shake", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShakeOutlined = function ShakeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ShakeOutlined$2
  }));
};

ShakeOutlined.displayName = 'ShakeOutlined';
var ShakeOutlined$1 = /*#__PURE__*/React.forwardRef(ShakeOutlined);

// This icon file is generated automatically.
var ShareAltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 000-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z" } }] }, "name": "share-alt", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShareAltOutlined = function ShareAltOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ShareAltOutlined$2
  }));
};

ShareAltOutlined.displayName = 'ShareAltOutlined';
var ShareAltOutlined$1 = /*#__PURE__*/React.forwardRef(ShareAltOutlined);

// This icon file is generated automatically.
var ShopFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z" } }] }, "name": "shop", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ShopFilled = function ShopFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ShopFilled$2
  }));
};

ShopFilled.displayName = 'ShopFilled';
var ShopFilled$1 = /*#__PURE__*/React.forwardRef(ShopFilled);

// This icon file is generated automatically.
var ShopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z" } }] }, "name": "shop", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShopOutlined = function ShopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ShopOutlined$2
  }));
};

ShopOutlined.displayName = 'ShopOutlined';
var ShopOutlined$1 = /*#__PURE__*/React.forwardRef(ShopOutlined);

// This icon file is generated automatically.
var ShopTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z", "fill": primaryColor } }] }; }, "name": "shop", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ShopTwoTone = function ShopTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ShopTwoTone$2
  }));
};

ShopTwoTone.displayName = 'ShopTwoTone';
var ShopTwoTone$1 = /*#__PURE__*/React.forwardRef(ShopTwoTone);

// This icon file is generated automatically.
var ShoppingCartOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 00-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 100 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 00-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 00-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 00-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 00-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 01-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 01-31.6 31.6z" } }] }, "name": "shopping-cart", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShoppingCartOutlined = function ShoppingCartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingCartOutlined$2
  }));
};

ShoppingCartOutlined.displayName = 'ShoppingCartOutlined';
var ShoppingCartOutlined$1 = /*#__PURE__*/React.forwardRef(ShoppingCartOutlined);

// This icon file is generated automatically.
var ShoppingFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z" } }] }, "name": "shopping", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ShoppingFilled = function ShoppingFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingFilled$2
  }));
};

ShoppingFilled.displayName = 'ShoppingFilled';
var ShoppingFilled$1 = /*#__PURE__*/React.forwardRef(ShoppingFilled);

// This icon file is generated automatically.
var ShoppingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z" } }] }, "name": "shopping", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShoppingOutlined = function ShoppingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingOutlined$2
  }));
};

ShoppingOutlined.displayName = 'ShoppingOutlined';
var ShoppingOutlined$1 = /*#__PURE__*/React.forwardRef(ShoppingOutlined);

// This icon file is generated automatically.
var ShoppingTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z", "fill": primaryColor } }] }; }, "name": "shopping", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ShoppingTwoTone = function ShoppingTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingTwoTone$2
  }));
};

ShoppingTwoTone.displayName = 'ShoppingTwoTone';
var ShoppingTwoTone$1 = /*#__PURE__*/React.forwardRef(ShoppingTwoTone);

// This icon file is generated automatically.
var ShrinkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M881.7 187.4l-45.1-45.1a8.03 8.03 0 00-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L447.9 585a7.9 7.9 0 00-8.9-8.9z" } }] }, "name": "shrink", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ShrinkOutlined = function ShrinkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ShrinkOutlined$2
  }));
};

ShrinkOutlined.displayName = 'ShrinkOutlined';
var ShrinkOutlined$1 = /*#__PURE__*/React.forwardRef(ShrinkOutlined);

// This icon file is generated automatically.
var SignalFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M584 352H440c-17.7 0-32 14.3-32 32v544c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32zM892 64H748c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM276 640H132c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V672c0-17.7-14.3-32-32-32z" } }] }, "name": "signal", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SignalFilled = function SignalFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SignalFilled$2
  }));
};

SignalFilled.displayName = 'SignalFilled';
var SignalFilled$1 = /*#__PURE__*/React.forwardRef(SignalFilled);

// This icon file is generated automatically.
var SisternodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M672 432c-120.3 0-219.9 88.5-237.3 204H320c-15.5 0-28-12.5-28-28V244h291c14.2 35.2 48.7 60 89 60 53 0 96-43 96-96s-43-96-96-96c-40.3 0-74.8 24.8-89 60H112v72h108v364c0 55.2 44.8 100 100 100h114.7c17.4 115.5 117 204 237.3 204 132.5 0 240-107.5 240-240S804.5 432 672 432zm128 266c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z" } }] }, "name": "sisternode", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SisternodeOutlined = function SisternodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SisternodeOutlined$2
  }));
};

SisternodeOutlined.displayName = 'SisternodeOutlined';
var SisternodeOutlined$1 = /*#__PURE__*/React.forwardRef(SisternodeOutlined);

// This icon file is generated automatically.
var SketchCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 01-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 010 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z" } }] }, "name": "sketch-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SketchCircleFilled = function SketchCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SketchCircleFilled$2
  }));
};

SketchCircleFilled.displayName = 'SketchCircleFilled';
var SketchCircleFilled$1 = /*#__PURE__*/React.forwardRef(SketchCircleFilled);

// This icon file is generated automatically.
var SketchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M925.6 405.1l-203-253.7a6.5 6.5 0 00-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 00.2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 00.2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z" } }] }, "name": "sketch", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SketchOutlined = function SketchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SketchOutlined$2
  }));
};

SketchOutlined.displayName = 'SketchOutlined';
var SketchOutlined$1 = /*#__PURE__*/React.forwardRef(SketchOutlined);

// This icon file is generated automatically.
var SketchSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 01-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 010 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z" } }] }, "name": "sketch-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SketchSquareFilled = function SketchSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SketchSquareFilled$2
  }));
};

SketchSquareFilled.displayName = 'SketchSquareFilled';
var SketchSquareFilled$1 = /*#__PURE__*/React.forwardRef(SketchSquareFilled);

// This icon file is generated automatically.
var SkinFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44z" } }] }, "name": "skin", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SkinFilled = function SkinFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SkinFilled$2
  }));
};

SkinFilled.displayName = 'SkinFilled';
var SkinFilled$1 = /*#__PURE__*/React.forwardRef(SkinFilled);

// This icon file is generated automatically.
var SkinOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z" } }] }, "name": "skin", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SkinOutlined = function SkinOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SkinOutlined$2
  }));
};

SkinOutlined.displayName = 'SkinOutlined';
var SkinOutlined$1 = /*#__PURE__*/React.forwardRef(SkinOutlined);

// This icon file is generated automatically.
var SkinTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 00-37-29.3H154a44 44 0 00-44 44v252a44 44 0 0044 44h75v388a44 44 0 0044 44h478a44 44 0 0044-44V466h75a44 44 0 0044-44V170a44 44 0 00-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z", "fill": primaryColor } }] }; }, "name": "skin", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SkinTwoTone = function SkinTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SkinTwoTone$2
  }));
};

SkinTwoTone.displayName = 'SkinTwoTone';
var SkinTwoTone$1 = /*#__PURE__*/React.forwardRef(SkinTwoTone);

// This icon file is generated automatically.
var SkypeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 00-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 00335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 00112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z" } }] }, "name": "skype", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SkypeFilled = function SkypeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SkypeFilled$2
  }));
};

SkypeFilled.displayName = 'SkypeFilled';
var SkypeFilled$1 = /*#__PURE__*/React.forwardRef(SkypeFilled);

// This icon file is generated automatically.
var SkypeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 00-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 00335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 00112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 01-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 01-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0171.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z" } }] }, "name": "skype", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SkypeOutlined = function SkypeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SkypeOutlined$2
  }));
};

SkypeOutlined.displayName = 'SkypeOutlined';
var SkypeOutlined$1 = /*#__PURE__*/React.forwardRef(SkypeOutlined);

// This icon file is generated automatically.
var SlackCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] }, "name": "slack-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SlackCircleFilled = function SlackCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SlackCircleFilled$2
  }));
};

SlackCircleFilled.displayName = 'SlackCircleFilled';
var SlackCircleFilled$1 = /*#__PURE__*/React.forwardRef(SlackCircleFilled);

// This icon file is generated automatically.
var SlackOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3a76.92 76.92 0 00-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0054.3 22.5c42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z" } }] }, "name": "slack", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SlackOutlined = function SlackOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SlackOutlined$2
  }));
};

SlackOutlined.displayName = 'SlackOutlined';
var SlackOutlined$1 = /*#__PURE__*/React.forwardRef(SlackOutlined);

// This icon file is generated automatically.
var SlackSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] }, "name": "slack-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SlackSquareFilled = function SlackSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SlackSquareFilled$2
  }));
};

SlackSquareFilled.displayName = 'SlackSquareFilled';
var SlackSquareFilled$1 = /*#__PURE__*/React.forwardRef(SlackSquareFilled);

// This icon file is generated automatically.
var SlackSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0150.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 01-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z" } }] }, "name": "slack-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SlackSquareOutlined = function SlackSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SlackSquareOutlined$2
  }));
};

SlackSquareOutlined.displayName = 'SlackSquareOutlined';
var SlackSquareOutlined$1 = /*#__PURE__*/React.forwardRef(SlackSquareOutlined);

// This icon file is generated automatically.
var SlidersFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z" } }] }, "name": "sliders", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SlidersFilled = function SlidersFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SlidersFilled$2
  }));
};

SlidersFilled.displayName = 'SlidersFilled';
var SlidersFilled$1 = /*#__PURE__*/React.forwardRef(SlidersFilled);

// This icon file is generated automatically.
var SlidersOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 01-3 3h-74a3 3 0 01-3-3v-74a3 3 0 013-3h74a3 3 0 013 3v74z" } }] }, "name": "sliders", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SlidersOutlined = function SlidersOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SlidersOutlined$2
  }));
};

SlidersOutlined.displayName = 'SlidersOutlined';
var SlidersOutlined$1 = /*#__PURE__*/React.forwardRef(SlidersOutlined);

// This icon file is generated automatically.
var SlidersTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M180 292h80v440h-80zm369 180h-74a3 3 0 00-3 3v74a3 3 0 003 3h74a3 3 0 003-3v-74a3 3 0 00-3-3zm215-108h80v296h-80z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 01-3 3h-74a3 3 0 01-3-3v-74a3 3 0 013-3h74a3 3 0 013 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z", "fill": primaryColor } }] }; }, "name": "sliders", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SlidersTwoTone = function SlidersTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SlidersTwoTone$2
  }));
};

SlidersTwoTone.displayName = 'SlidersTwoTone';
var SlidersTwoTone$1 = /*#__PURE__*/React.forwardRef(SlidersTwoTone);

// This icon file is generated automatically.
var SmallDashOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z" } }] }, "name": "small-dash", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SmallDashOutlined = function SmallDashOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SmallDashOutlined$2
  }));
};

SmallDashOutlined.displayName = 'SmallDashOutlined';
var SmallDashOutlined$1 = /*#__PURE__*/React.forwardRef(SmallDashOutlined);

// This icon file is generated automatically.
var SmileFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 018-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 018 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "smile", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SmileFilled = function SmileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SmileFilled$2
  }));
};

SmileFilled.displayName = 'SmileFilled';
var SmileFilled$1 = /*#__PURE__*/React.forwardRef(SmileFilled);

// This icon file is generated automatically.
var SmileOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm352 0a48 48 0 1096 0 48 48 0 10-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 01248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 01249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 01775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 01775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 00-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 00-8-8.4z" } }] }, "name": "smile", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SmileOutlined = function SmileOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SmileOutlined$2
  }));
};

SmileOutlined.displayName = 'SmileOutlined';
var SmileOutlined$1 = /*#__PURE__*/React.forwardRef(SmileOutlined);

// This icon file is generated automatically.
var SmileTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0196 0 48.01 48.01 0 01-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 018-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 018 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 010-96 48.01 48.01 0 010 96z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M288 421a48 48 0 1096 0 48 48 0 10-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 00-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 00-8-8.4zm-24-112a48 48 0 1096 0 48 48 0 10-96 0z", "fill": primaryColor } }] }; }, "name": "smile", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SmileTwoTone = function SmileTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SmileTwoTone$2
  }));
};

SmileTwoTone.displayName = 'SmileTwoTone';
var SmileTwoTone$1 = /*#__PURE__*/React.forwardRef(SmileTwoTone);

// This icon file is generated automatically.
var SnippetsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z" } }] }, "name": "snippets", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SnippetsFilled = function SnippetsFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsFilled$2
  }));
};

SnippetsFilled.displayName = 'SnippetsFilled';
var SnippetsFilled$1 = /*#__PURE__*/React.forwardRef(SnippetsFilled);

// This icon file is generated automatically.
var SnippetsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z" } }] }, "name": "snippets", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SnippetsOutlined = function SnippetsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsOutlined$2
  }));
};

SnippetsOutlined.displayName = 'SnippetsOutlined';
var SnippetsOutlined$1 = /*#__PURE__*/React.forwardRef(SnippetsOutlined);

// This icon file is generated automatically.
var SnippetsTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z", "fill": primaryColor } }] }; }, "name": "snippets", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SnippetsTwoTone = function SnippetsTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsTwoTone$2
  }));
};

SnippetsTwoTone.displayName = 'SnippetsTwoTone';
var SnippetsTwoTone$1 = /*#__PURE__*/React.forwardRef(SnippetsTwoTone);

// This icon file is generated automatically.
var SolutionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z" } }] }, "name": "solution", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SolutionOutlined = function SolutionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SolutionOutlined$2
  }));
};

SolutionOutlined.displayName = 'SolutionOutlined';
var SolutionOutlined$1 = /*#__PURE__*/React.forwardRef(SolutionOutlined);

// This icon file is generated automatically.
var SortAscendingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.6 433.8L749 150.5a9.24 9.24 0 00-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 00-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 00-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0012.6 0l112-141.9c4.1-5.2.4-13-6.3-13z" } }] }, "name": "sort-ascending", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SortAscendingOutlined = function SortAscendingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SortAscendingOutlined$2
  }));
};

SortAscendingOutlined.displayName = 'SortAscendingOutlined';
var SortAscendingOutlined$1 = /*#__PURE__*/React.forwardRef(SortAscendingOutlined);

// This icon file is generated automatically.
var SortDescendingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M839.6 433.8L749 150.5a9.24 9.24 0 00-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 00-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 00-9.2-9.3zM310.3 167.1a8 8 0 00-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z" } }] }, "name": "sort-descending", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SortDescendingOutlined = function SortDescendingOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SortDescendingOutlined$2
  }));
};

SortDescendingOutlined.displayName = 'SortDescendingOutlined';
var SortDescendingOutlined$1 = /*#__PURE__*/React.forwardRef(SortDescendingOutlined);

// This icon file is generated automatically.
var SoundFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z" } }] }, "name": "sound", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SoundFilled = function SoundFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SoundFilled$2
  }));
};

SoundFilled.displayName = 'SoundFilled';
var SoundFilled$1 = /*#__PURE__*/React.forwardRef(SoundFilled);

// This icon file is generated automatically.
var SoundOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344z" } }] }, "name": "sound", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SoundOutlined = function SoundOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SoundOutlined$2
  }));
};

SoundOutlined.displayName = 'SoundOutlined';
var SoundOutlined$1 = /*#__PURE__*/React.forwardRef(SoundOutlined);

// This icon file is generated automatically.
var SoundTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 00-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0021.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0021.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 00-21.7-5.9L746 287.8a15.99 15.99 0 00-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z", "fill": primaryColor } }] }; }, "name": "sound", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SoundTwoTone = function SoundTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SoundTwoTone$2
  }));
};

SoundTwoTone.displayName = 'SoundTwoTone';
var SoundTwoTone$1 = /*#__PURE__*/React.forwardRef(SoundTwoTone);

// This icon file is generated automatically.
var SplitCellsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M938.2 508.4L787.3 389c-3-2.4-7.3-.2-7.3 3.6V478H636V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H596c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H636V546h144v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4a4.5 4.5 0 000-7.2zM428 116H144c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H244v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4a4.52 4.52 0 000 7.1l151 119.5c2.9 2.3 7.3.2 7.3-3.6V546h144v294H184V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z" } }] }, "name": "split-cells", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SplitCellsOutlined = function SplitCellsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SplitCellsOutlined$2
  }));
};

SplitCellsOutlined.displayName = 'SplitCellsOutlined';
var SplitCellsOutlined$1 = /*#__PURE__*/React.forwardRef(SplitCellsOutlined);

// This icon file is generated automatically.
var StarFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] }, "name": "star", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var StarFilled = function StarFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StarFilled$2
  }));
};

StarFilled.displayName = 'StarFilled';
var StarFilled$1 = /*#__PURE__*/React.forwardRef(StarFilled);

// This icon file is generated automatically.
var StarOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z" } }] }, "name": "star", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StarOutlined = function StarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StarOutlined$2
  }));
};

StarOutlined.displayName = 'StarOutlined';
var StarOutlined$1 = /*#__PURE__*/React.forwardRef(StarOutlined);

// This icon file is generated automatically.
var StarTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0046.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z", "fill": primaryColor } }] }; }, "name": "star", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var StarTwoTone = function StarTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StarTwoTone$2
  }));
};

StarTwoTone.displayName = 'StarTwoTone';
var StarTwoTone$1 = /*#__PURE__*/React.forwardRef(StarTwoTone);

// This icon file is generated automatically.
var StepBackwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 000 33.9M330 864h-64a8 8 0 01-8-8V168a8 8 0 018-8h64a8 8 0 018 8v688a8 8 0 01-8 8" } }] }, "name": "step-backward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var StepBackwardFilled = function StepBackwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StepBackwardFilled$2
  }));
};

StepBackwardFilled.displayName = 'StepBackwardFilled';
var StepBackwardFilled$1 = /*#__PURE__*/React.forwardRef(StepBackwardFilled);

// This icon file is generated automatically.
var StepBackwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 000 33.9M330 864h-64a8 8 0 01-8-8V168a8 8 0 018-8h64a8 8 0 018 8v688a8 8 0 01-8 8" } }] }, "name": "step-backward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StepBackwardOutlined = function StepBackwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StepBackwardOutlined$2
  }));
};

StepBackwardOutlined.displayName = 'StepBackwardOutlined';
var StepBackwardOutlined$1 = /*#__PURE__*/React.forwardRef(StepBackwardOutlined);

// This icon file is generated automatically.
var StepForwardFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 010 33.9M694 864h64a8 8 0 008-8V168a8 8 0 00-8-8h-64a8 8 0 00-8 8v688a8 8 0 008 8" } }] }, "name": "step-forward", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var StepForwardFilled = function StepForwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StepForwardFilled$2
  }));
};

StepForwardFilled.displayName = 'StepForwardFilled';
var StepForwardFilled$1 = /*#__PURE__*/React.forwardRef(StepForwardFilled);

// This icon file is generated automatically.
var StepForwardOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 010 33.9M694 864h64a8 8 0 008-8V168a8 8 0 00-8-8h-64a8 8 0 00-8 8v688a8 8 0 008 8" } }] }, "name": "step-forward", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StepForwardOutlined = function StepForwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StepForwardOutlined$2
  }));
};

StepForwardOutlined.displayName = 'StepForwardOutlined';
var StepForwardOutlined$1 = /*#__PURE__*/React.forwardRef(StepForwardOutlined);

// This icon file is generated automatically.
var StockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0045.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 00-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 00-45.2 0L165.7 610.5a7.94 7.94 0 000 11.3z" } }] }, "name": "stock", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StockOutlined = function StockOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StockOutlined$2
  }));
};

StockOutlined.displayName = 'StockOutlined';
var StockOutlined$1 = /*#__PURE__*/React.forwardRef(StockOutlined);

// This icon file is generated automatically.
var StopFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z" } }] }, "name": "stop", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var StopFilled = function StopFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StopFilled$2
  }));
};

StopFilled.displayName = 'StopFilled';
var StopFilled$1 = /*#__PURE__*/React.forwardRef(StopFilled);

// This icon file is generated automatically.
var StopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z" } }] }, "name": "stop", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StopOutlined = function StopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StopOutlined$2
  }));
};

StopOutlined.displayName = 'StopOutlined';
var StopOutlined$1 = /*#__PURE__*/React.forwardRef(StopOutlined);

// This icon file is generated automatically.
var StopTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z", "fill": secondaryColor } }] }; }, "name": "stop", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var StopTwoTone = function StopTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StopTwoTone$2
  }));
};

StopTwoTone.displayName = 'StopTwoTone';
var StopTwoTone$1 = /*#__PURE__*/React.forwardRef(StopTwoTone);

// This icon file is generated automatically.
var StrikethroughOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 00-8-7.9z" } }] }, "name": "strikethrough", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var StrikethroughOutlined = function StrikethroughOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: StrikethroughOutlined$2
  }));
};

StrikethroughOutlined.displayName = 'StrikethroughOutlined';
var StrikethroughOutlined$1 = /*#__PURE__*/React.forwardRef(StrikethroughOutlined);

// This icon file is generated automatically.
var SubnodeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M688 240c-138 0-252 102.8-269.6 236H249a95.92 95.92 0 00-89-60c-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h169.3C436 681.2 550 784 688 784c150.2 0 272-121.8 272-272S838.2 240 688 240zm128 298c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z" } }] }, "name": "subnode", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SubnodeOutlined = function SubnodeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SubnodeOutlined$2
  }));
};

SubnodeOutlined.displayName = 'SubnodeOutlined';
var SubnodeOutlined$1 = /*#__PURE__*/React.forwardRef(SubnodeOutlined);

// This icon file is generated automatically.
var SwapLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "swap-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SwapLeftOutlined = function SwapLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SwapLeftOutlined$2
  }));
};

SwapLeftOutlined.displayName = 'SwapLeftOutlined';
var SwapLeftOutlined$1 = /*#__PURE__*/React.forwardRef(SwapLeftOutlined);

// This icon file is generated automatically.
var SwapOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, "name": "swap", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SwapOutlined = function SwapOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SwapOutlined$2
  }));
};

SwapOutlined.displayName = 'SwapOutlined';
var SwapOutlined$1 = /*#__PURE__*/React.forwardRef(SwapOutlined);

// This icon file is generated automatically.
var SwapRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, "name": "swap-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SwapRightOutlined = function SwapRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SwapRightOutlined$2
  }));
};

SwapRightOutlined.displayName = 'SwapRightOutlined';
var SwapRightOutlined$1 = /*#__PURE__*/React.forwardRef(SwapRightOutlined);

// This icon file is generated automatically.
var SwitcherFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z" } }] }, "name": "switcher", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var SwitcherFilled = function SwitcherFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherFilled$2
  }));
};

SwitcherFilled.displayName = 'SwitcherFilled';
var SwitcherFilled$1 = /*#__PURE__*/React.forwardRef(SwitcherFilled);

// This icon file is generated automatically.
var SwitcherOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z" } }] }, "name": "switcher", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SwitcherOutlined = function SwitcherOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherOutlined$2
  }));
};

SwitcherOutlined.displayName = 'SwitcherOutlined';
var SwitcherOutlined$1 = /*#__PURE__*/React.forwardRef(SwitcherOutlined);

// This icon file is generated automatically.
var SwitcherTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M184 840h528V312H184v528zm116-290h296v64H300v-64z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M300 550h296v64H300z", "fill": primaryColor } }] }; }, "name": "switcher", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var SwitcherTwoTone = function SwitcherTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherTwoTone$2
  }));
};

SwitcherTwoTone.displayName = 'SwitcherTwoTone';
var SwitcherTwoTone$1 = /*#__PURE__*/React.forwardRef(SwitcherTwoTone);

// This icon file is generated automatically.
var SyncOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 01755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 01512.1 856a342.24 342.24 0 01-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 00-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 00-8-8.2z" } }] }, "name": "sync", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var SyncOutlined = function SyncOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: SyncOutlined$2
  }));
};

SyncOutlined.displayName = 'SyncOutlined';
var SyncOutlined$1 = /*#__PURE__*/React.forwardRef(SyncOutlined);

// This icon file is generated automatically.
var TableOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z" } }] }, "name": "table", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TableOutlined = function TableOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TableOutlined$2
  }));
};

TableOutlined.displayName = 'TableOutlined';
var TableOutlined$1 = /*#__PURE__*/React.forwardRef(TableOutlined);

// This icon file is generated automatically.
var TabletFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" } }] }, "name": "tablet", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TabletFilled = function TabletFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TabletFilled$2
  }));
};

TabletFilled.displayName = 'TabletFilled';
var TabletFilled$1 = /*#__PURE__*/React.forwardRef(TabletFilled);

// This icon file is generated automatically.
var TabletOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "tablet", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TabletOutlined = function TabletOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TabletOutlined$2
  }));
};

TabletOutlined.displayName = 'TabletOutlined';
var TabletOutlined$1 = /*#__PURE__*/React.forwardRef(TabletOutlined);

// This icon file is generated automatically.
var TabletTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M472 784a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }] }; }, "name": "tablet", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var TabletTwoTone = function TabletTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TabletTwoTone$2
  }));
};

TabletTwoTone.displayName = 'TabletTwoTone';
var TabletTwoTone$1 = /*#__PURE__*/React.forwardRef(TabletTwoTone);

// This icon file is generated automatically.
var TagFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z" } }] }, "name": "tag", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TagFilled = function TagFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TagFilled$2
  }));
};

TagFilled.displayName = 'TagFilled';
var TagFilled$1 = /*#__PURE__*/React.forwardRef(TagFilled);

// This icon file is generated automatically.
var TagOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z" } }] }, "name": "tag", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TagOutlined = function TagOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TagOutlined$2
  }));
};

TagOutlined.displayName = 'TagOutlined';
var TagOutlined$1 = /*#__PURE__*/React.forwardRef(TagOutlined);

// This icon file is generated automatically.
var TagTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8a9.9 9.9 0 007.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z", "fill": primaryColor } }] }; }, "name": "tag", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var TagTwoTone = function TagTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TagTwoTone$2
  }));
};

TagTwoTone.displayName = 'TagTwoTone';
var TagTwoTone$1 = /*#__PURE__*/React.forwardRef(TagTwoTone);

// This icon file is generated automatically.
var TagsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z" } }] }, "name": "tags", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TagsFilled = function TagsFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TagsFilled$2
  }));
};

TagsFilled.displayName = 'TagsFilled';
var TagsFilled$1 = /*#__PURE__*/React.forwardRef(TagsFilled);

// This icon file is generated automatically.
var TagsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1067.88-67.89 48 48 0 10-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z" } }] }, "name": "tags", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TagsOutlined = function TagsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TagsOutlined$2
  }));
};

TagsOutlined.displayName = 'TagsOutlined';
var TagsOutlined$1 = /*#__PURE__*/React.forwardRef(TagsOutlined);

// This icon file is generated automatically.
var TagsTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0133.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0112.4 46.4 47.81 47.81 0 01-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 01-12.4-46.4z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 010-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M889.7 539.8l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0033.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 00-46.4-12.4 47.81 47.81 0 00-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0046.4 12.4z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z", "fill": primaryColor } }] }; }, "name": "tags", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var TagsTwoTone = function TagsTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TagsTwoTone$2
  }));
};

TagsTwoTone.displayName = 'TagsTwoTone';
var TagsTwoTone$1 = /*#__PURE__*/React.forwardRef(TagsTwoTone);

// This icon file is generated automatically.
var TaobaoCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] }, "name": "taobao-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TaobaoCircleFilled = function TaobaoCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoCircleFilled$2
  }));
};

TaobaoCircleFilled.displayName = 'TaobaoCircleFilled';
var TaobaoCircleFilled$1 = /*#__PURE__*/React.forwardRef(TaobaoCircleFilled);

// This icon file is generated automatically.
var TaobaoCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] }, "name": "taobao-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TaobaoCircleOutlined = function TaobaoCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoCircleOutlined$2
  }));
};

TaobaoCircleOutlined.displayName = 'TaobaoCircleOutlined';
var TaobaoCircleOutlined$1 = /*#__PURE__*/React.forwardRef(TaobaoCircleOutlined);

// This icon file is generated automatically.
var TaobaoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M168.5 273.7a68.7 68.7 0 10137.4 0 68.7 68.7 0 10-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z" } }] }, "name": "taobao", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TaobaoOutlined = function TaobaoOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoOutlined$2
  }));
};

TaobaoOutlined.displayName = 'TaobaoOutlined';
var TaobaoOutlined$1 = /*#__PURE__*/React.forwardRef(TaobaoOutlined);

// This icon file is generated automatically.
var TaobaoSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 110-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z" } }] }, "name": "taobao-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TaobaoSquareFilled = function TaobaoSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoSquareFilled$2
  }));
};

TaobaoSquareFilled.displayName = 'TaobaoSquareFilled';
var TaobaoSquareFilled$1 = /*#__PURE__*/React.forwardRef(TaobaoSquareFilled);

// This icon file is generated automatically.
var TeamOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824.2 699.9a301.55 301.55 0 00-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 01612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 008-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 01612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z" } }] }, "name": "team", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TeamOutlined = function TeamOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TeamOutlined$2
  }));
};

TeamOutlined.displayName = 'TeamOutlined';
var TeamOutlined$1 = /*#__PURE__*/React.forwardRef(TeamOutlined);

// This icon file is generated automatically.
var ThunderboltFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z" } }] }, "name": "thunderbolt", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ThunderboltFilled = function ThunderboltFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltFilled$2
  }));
};

ThunderboltFilled.displayName = 'ThunderboltFilled';
var ThunderboltFilled$1 = /*#__PURE__*/React.forwardRef(ThunderboltFilled);

// This icon file is generated automatically.
var ThunderboltOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z" } }] }, "name": "thunderbolt", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ThunderboltOutlined = function ThunderboltOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltOutlined$2
  }));
};

ThunderboltOutlined.displayName = 'ThunderboltOutlined';
var ThunderboltOutlined$1 = /*#__PURE__*/React.forwardRef(ThunderboltOutlined);

// This icon file is generated automatically.
var ThunderboltTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z", "fill": primaryColor } }] }; }, "name": "thunderbolt", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ThunderboltTwoTone = function ThunderboltTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltTwoTone$2
  }));
};

ThunderboltTwoTone.displayName = 'ThunderboltTwoTone';
var ThunderboltTwoTone$1 = /*#__PURE__*/React.forwardRef(ThunderboltTwoTone);

// This icon file is generated automatically.
var ToTopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z" } }] }, "name": "to-top", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ToTopOutlined = function ToTopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ToTopOutlined$2
  }));
};

ToTopOutlined.displayName = 'ToTopOutlined';
var ToTopOutlined$1 = /*#__PURE__*/React.forwardRef(ToTopOutlined);

// This icon file is generated automatically.
var ToolFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 00419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z" } }] }, "name": "tool", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ToolFilled = function ToolFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ToolFilled$2
  }));
};

ToolFilled.displayName = 'ToolFilled';
var ToolFilled$1 = /*#__PURE__*/React.forwardRef(ToolFilled);

// This icon file is generated automatically.
var ToolOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 01144-53.5L537 318.9a32.05 32.05 0 000 45.3l124.5 124.5a32.05 32.05 0 0045.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z" } }] }, "name": "tool", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ToolOutlined = function ToolOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ToolOutlined$2
  }));
};

ToolOutlined.displayName = 'ToolOutlined';
var ToolOutlined$1 = /*#__PURE__*/React.forwardRef(ToolOutlined);

// This icon file is generated automatically.
var ToolTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M706.8 488.7a32.05 32.05 0 01-45.3 0L537 364.2a32.05 32.05 0 010-45.3l132.9-132.8a184.2 184.2 0 00-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 01144-53.5L537 318.9a32.05 32.05 0 000 45.3l124.5 124.5a32.05 32.05 0 0045.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z", "fill": primaryColor } }] }; }, "name": "tool", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var ToolTwoTone = function ToolTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ToolTwoTone$2
  }));
};

ToolTwoTone.displayName = 'ToolTwoTone';
var ToolTwoTone$1 = /*#__PURE__*/React.forwardRef(ToolTwoTone);

// This icon file is generated automatically.
var TrademarkCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z" } }] }, "name": "trademark-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TrademarkCircleFilled = function TrademarkCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleFilled$2
  }));
};

TrademarkCircleFilled.displayName = 'TrademarkCircleFilled';
var TrademarkCircleFilled$1 = /*#__PURE__*/React.forwardRef(TrademarkCircleFilled);

// This icon file is generated automatically.
var TrademarkCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 007.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z" } }] }, "name": "trademark-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TrademarkCircleOutlined = function TrademarkCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleOutlined$2
  }));
};

TrademarkCircleOutlined.displayName = 'TrademarkCircleOutlined';
var TrademarkCircleOutlined$1 = /*#__PURE__*/React.forwardRef(TrademarkCircleOutlined);

// This icon file is generated automatically.
var TrademarkCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z", "fill": primaryColor } }] }; }, "name": "trademark-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var TrademarkCircleTwoTone = function TrademarkCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleTwoTone$2
  }));
};

TrademarkCircleTwoTone.displayName = 'TrademarkCircleTwoTone';
var TrademarkCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(TrademarkCircleTwoTone);

// This icon file is generated automatically.
var TrademarkOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 007.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z" } }] }, "name": "trademark", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TrademarkOutlined = function TrademarkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkOutlined$2
  }));
};

TrademarkOutlined.displayName = 'TrademarkOutlined';
var TrademarkOutlined$1 = /*#__PURE__*/React.forwardRef(TrademarkOutlined);

// This icon file is generated automatically.
var TransactionOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 00-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 01103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 003 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 008 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 01-103.5 242.4 352.57 352.57 0 01-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 01-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 00-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 00-8-8.2z" } }] }, "name": "transaction", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TransactionOutlined = function TransactionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TransactionOutlined$2
  }));
};

TransactionOutlined.displayName = 'TransactionOutlined';
var TransactionOutlined$1 = /*#__PURE__*/React.forwardRef(TransactionOutlined);

// This icon file is generated automatically.
var TranslationOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M140 188h584v164h76V144c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h544v-76H140V188z" } }, { "tag": "path", "attrs": { "d": "M414.3 256h-60.6c-3.4 0-6.4 2.2-7.6 5.4L219 629.4c-.3.8-.4 1.7-.4 2.6 0 4.4 3.6 8 8 8h55.1c3.4 0 6.4-2.2 7.6-5.4L322 540h196.2L422 261.4a8.42 8.42 0 00-7.7-5.4zm12.4 228h-85.5L384 360.2 426.7 484zM936 528H800v-93c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v93H592c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h136v152c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V752h136c13.3 0 24-10.7 24-24V552c0-13.3-10.7-24-24-24zM728 680h-88v-80h88v80zm160 0h-88v-80h88v80z" } }] }, "name": "translation", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TranslationOutlined = function TranslationOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TranslationOutlined$2
  }));
};

TranslationOutlined.displayName = 'TranslationOutlined';
var TranslationOutlined$1 = /*#__PURE__*/React.forwardRef(TranslationOutlined);

// This icon file is generated automatically.
var TrophyFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z" } }] }, "name": "trophy", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TrophyFilled = function TrophyFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TrophyFilled$2
  }));
};

TrophyFilled.displayName = 'TrophyFilled';
var TrophyFilled$1 = /*#__PURE__*/React.forwardRef(TrophyFilled);

// This icon file is generated automatically.
var TrophyOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM184 352V232h64v207.6a91.99 91.99 0 01-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z" } }] }, "name": "trophy", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TrophyOutlined = function TrophyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TrophyOutlined$2
  }));
};

TrophyOutlined.displayName = 'TrophyOutlined';
var TrophyOutlined$1 = /*#__PURE__*/React.forwardRef(TrophyOutlined);

// This icon file is generated automatically.
var TrophyTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM248 439.6a91.99 91.99 0 01-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z", "fill": primaryColor } }] }; }, "name": "trophy", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var TrophyTwoTone = function TrophyTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TrophyTwoTone$2
  }));
};

TrophyTwoTone.displayName = 'TrophyTwoTone';
var TrophyTwoTone$1 = /*#__PURE__*/React.forwardRef(TrophyTwoTone);

// This icon file is generated automatically.
var TwitterCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 01-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 01-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 00229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z" } }] }, "name": "twitter-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TwitterCircleFilled = function TwitterCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TwitterCircleFilled$2
  }));
};

TwitterCircleFilled.displayName = 'TwitterCircleFilled';
var TwitterCircleFilled$1 = /*#__PURE__*/React.forwardRef(TwitterCircleFilled);

// This icon file is generated automatically.
var TwitterOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0075-94 336.64 336.64 0 01-108.2 41.2A170.1 170.1 0 00672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 00-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 01-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 01-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z" } }] }, "name": "twitter", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var TwitterOutlined = function TwitterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TwitterOutlined$2
  }));
};

TwitterOutlined.displayName = 'TwitterOutlined';
var TwitterOutlined$1 = /*#__PURE__*/React.forwardRef(TwitterOutlined);

// This icon file is generated automatically.
var TwitterSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 01-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 01-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 00229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z" } }] }, "name": "twitter-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var TwitterSquareFilled = function TwitterSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: TwitterSquareFilled$2
  }));
};

TwitterSquareFilled.displayName = 'TwitterSquareFilled';
var TwitterSquareFilled$1 = /*#__PURE__*/React.forwardRef(TwitterSquareFilled);

// This icon file is generated automatically.
var UnderlineOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z" } }] }, "name": "underline", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UnderlineOutlined = function UnderlineOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UnderlineOutlined$2
  }));
};

UnderlineOutlined.displayName = 'UnderlineOutlined';
var UnderlineOutlined$1 = /*#__PURE__*/React.forwardRef(UnderlineOutlined);

// This icon file is generated automatically.
var UndoOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 00-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 00-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z" } }] }, "name": "undo", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UndoOutlined = function UndoOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UndoOutlined$2
  }));
};

UndoOutlined.displayName = 'UndoOutlined';
var UndoOutlined$1 = /*#__PURE__*/React.forwardRef(UndoOutlined);

// This icon file is generated automatically.
var UngroupOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M736 550H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16zm-56 136H344v-64h336v64zm208 130c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zM736 266H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16zm-56 136H344v-64h336v64zm208-194c39.8 0 72-32.2 72-72s-32.2-72-72-72-72 32.2-72 72 32.2 72 72 72zm0-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 64c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0 656c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z" } }] }, "name": "ungroup", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UngroupOutlined = function UngroupOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UngroupOutlined$2
  }));
};

UngroupOutlined.displayName = 'UngroupOutlined';
var UngroupOutlined$1 = /*#__PURE__*/React.forwardRef(UngroupOutlined);

// This icon file is generated automatically.
var UnlockFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1156 0z" } }] }, "name": "unlock", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var UnlockFilled = function UnlockFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UnlockFilled$2
  }));
};

UnlockFilled.displayName = 'UnlockFilled';
var UnlockFilled$1 = /*#__PURE__*/React.forwardRef(UnlockFilled);

// This icon file is generated automatically.
var UnlockOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" } }] }, "name": "unlock", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UnlockOutlined = function UnlockOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UnlockOutlined$2
  }));
};

UnlockOutlined.displayName = 'UnlockOutlined';
var UnlockOutlined$1 = /*#__PURE__*/React.forwardRef(UnlockOutlined);

// This icon file is generated automatically.
var UnlockTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0128 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0128-87z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z", "fill": primaryColor } }] }; }, "name": "unlock", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var UnlockTwoTone = function UnlockTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UnlockTwoTone$2
  }));
};

UnlockTwoTone.displayName = 'UnlockTwoTone';
var UnlockTwoTone$1 = /*#__PURE__*/React.forwardRef(UnlockTwoTone);

// This icon file is generated automatically.
var UnorderedListOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "unordered-list", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UnorderedListOutlined = function UnorderedListOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UnorderedListOutlined$2
  }));
};

UnorderedListOutlined.displayName = 'UnorderedListOutlined';
var UnorderedListOutlined$1 = /*#__PURE__*/React.forwardRef(UnorderedListOutlined);

// This icon file is generated automatically.
var UpCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z" } }] }, "name": "up-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var UpCircleFilled = function UpCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleFilled$2
  }));
};

UpCircleFilled.displayName = 'UpCircleFilled';
var UpCircleFilled$1 = /*#__PURE__*/React.forwardRef(UpCircleFilled);

// This icon file is generated automatically.
var UpCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M518.5 360.3a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "up-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UpCircleOutlined = function UpCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleOutlined$2
  }));
};

UpCircleOutlined.displayName = 'UpCircleOutlined';
var UpCircleOutlined$1 = /*#__PURE__*/React.forwardRef(UpCircleOutlined);

// This icon file is generated automatically.
var UpCircleTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M518.4 360.3a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z", "fill": primaryColor } }] }; }, "name": "up-circle", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var UpCircleTwoTone = function UpCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleTwoTone$2
  }));
};

UpCircleTwoTone.displayName = 'UpCircleTwoTone';
var UpCircleTwoTone$1 = /*#__PURE__*/React.forwardRef(UpCircleTwoTone);

// This icon file is generated automatically.
var UpOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, "name": "up", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UpOutlined = function UpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UpOutlined$2
  }));
};

UpOutlined.displayName = 'UpOutlined';
var UpOutlined$1 = /*#__PURE__*/React.forwardRef(UpOutlined);

// This icon file is generated automatically.
var UpSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z" } }] }, "name": "up-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var UpSquareFilled = function UpSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareFilled$2
  }));
};

UpSquareFilled.displayName = 'UpSquareFilled';
var UpSquareFilled$1 = /*#__PURE__*/React.forwardRef(UpSquareFilled);

// This icon file is generated automatically.
var UpSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 00-12.9 0l-178 246A7.96 7.96 0 00334 624z" } }, { "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, "name": "up-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UpSquareOutlined = function UpSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareOutlined$2
  }));
};

UpSquareOutlined.displayName = 'UpSquareOutlined';
var UpSquareOutlined$1 = /*#__PURE__*/React.forwardRef(UpSquareOutlined);

// This icon file is generated automatically.
var UpSquareTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 00-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z", "fill": primaryColor } }] }; }, "name": "up-square", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var UpSquareTwoTone = function UpSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareTwoTone$2
  }));
};

UpSquareTwoTone.displayName = 'UpSquareTwoTone';
var UpSquareTwoTone$1 = /*#__PURE__*/React.forwardRef(UpSquareTwoTone);

// This icon file is generated automatically.
var UploadOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, "name": "upload", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UploadOutlined = function UploadOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UploadOutlined$2
  }));
};

UploadOutlined.displayName = 'UploadOutlined';
var UploadOutlined$1 = /*#__PURE__*/React.forwardRef(UploadOutlined);

// This icon file is generated automatically.
var UsbFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] }, "name": "usb", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var UsbFilled = function UsbFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UsbFilled$2
  }));
};

UsbFilled.displayName = 'UsbFilled';
var UsbFilled$1 = /*#__PURE__*/React.forwardRef(UsbFilled);

// This icon file is generated automatically.
var UsbOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }] }, "name": "usb", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UsbOutlined = function UsbOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UsbOutlined$2
  }));
};

UsbOutlined.displayName = 'UsbOutlined';
var UsbOutlined$1 = /*#__PURE__*/React.forwardRef(UsbOutlined);

// This icon file is generated automatically.
var UsbTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z", "fill": primaryColor } }] }; }, "name": "usb", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var UsbTwoTone = function UsbTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UsbTwoTone$2
  }));
};

UsbTwoTone.displayName = 'UsbTwoTone';
var UsbTwoTone$1 = /*#__PURE__*/React.forwardRef(UsbTwoTone);

// This icon file is generated automatically.
var UserAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 888.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "user-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UserAddOutlined = function UserAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UserAddOutlined$2
  }));
};

UserAddOutlined.displayName = 'UserAddOutlined';
var UserAddOutlined$1 = /*#__PURE__*/React.forwardRef(UserAddOutlined);

// This icon file is generated automatically.
var UserDeleteOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 901.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z" } }] }, "name": "user-delete", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UserDeleteOutlined = function UserDeleteOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UserDeleteOutlined$2
  }));
};

UserDeleteOutlined.displayName = 'UserDeleteOutlined';
var UserDeleteOutlined$1 = /*#__PURE__*/React.forwardRef(UserDeleteOutlined);

// This icon file is generated automatically.
var UserOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" } }] }, "name": "user", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UserOutlined = function UserOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UserOutlined$2
  }));
};

UserOutlined.displayName = 'UserOutlined';
var UserOutlined$1 = /*#__PURE__*/React.forwardRef(UserOutlined);

// This icon file is generated automatically.
var UserSwitchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M759 335c0-137-111-248-248-248S263 198 263 335c0 82.8 40.6 156.2 103 201.2-.4.2-.7.3-.9.4-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00136 874.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C356 614.2 431 583 511 583c137 0 248-111 248-248zM511 507c-95 0-172-77-172-172s77-172 172-172 172 77 172 172-77 172-172 172zm105 221h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H703.5l47.2-60.1a8.1 8.1 0 001.7-4.9c0-4.4-3.6-8-8-8h-72.6c-4.9 0-9.5 2.3-12.6 6.1l-68.5 87.1c-4.4 5.6-6.8 12.6-6.8 19.8.1 17.7 14.4 32 32.1 32zm240 64H592c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h176.5l-47.2 60.1a8.1 8.1 0 00-1.7 4.9c0 4.4 3.6 8 8 8h72.6c4.9 0 9.5-2.3 12.6-6.1l68.5-87.1c4.4-5.6 6.8-12.6 6.8-19.8-.1-17.7-14.4-32-32.1-32z" } }] }, "name": "user-switch", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UserSwitchOutlined = function UserSwitchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UserSwitchOutlined$2
  }));
};

UserSwitchOutlined.displayName = 'UserSwitchOutlined';
var UserSwitchOutlined$1 = /*#__PURE__*/React.forwardRef(UserSwitchOutlined);

// This icon file is generated automatically.
var UsergroupAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z" } }] }, "name": "usergroup-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UsergroupAddOutlined = function UsergroupAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UsergroupAddOutlined$2
  }));
};

UsergroupAddOutlined.displayName = 'UsergroupAddOutlined';
var UsergroupAddOutlined$1 = /*#__PURE__*/React.forwardRef(UsergroupAddOutlined);

// This icon file is generated automatically.
var UsergroupDeleteOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z" } }] }, "name": "usergroup-delete", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var UsergroupDeleteOutlined = function UsergroupDeleteOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: UsergroupDeleteOutlined$2
  }));
};

UsergroupDeleteOutlined.displayName = 'UsergroupDeleteOutlined';
var UsergroupDeleteOutlined$1 = /*#__PURE__*/React.forwardRef(UsergroupDeleteOutlined);

// This icon file is generated automatically.
var VerifiedOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M447.8 588.8l-7.3-32.5c-.2-1-.6-1.9-1.1-2.7a7.94 7.94 0 00-11.1-2.2L405 567V411c0-4.4-3.6-8-8-8h-81c-4.4 0-8 3.6-8 8v36c0 4.4 3.6 8 8 8h37v192.4a8 8 0 0012.7 6.5l79-56.8c2.6-1.9 3.8-5.1 3.1-8.3zm-56.7-216.6l.2.2c3.2 3 8.3 2.8 11.3-.5l24.1-26.2a8.1 8.1 0 00-.3-11.2l-53.7-52.1a8 8 0 00-11.2.1l-24.7 24.7c-3.1 3.1-3.1 8.2.1 11.3l54.2 53.7z" } }, { "tag": "path", "attrs": { "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z" } }, { "tag": "path", "attrs": { "d": "M452 297v36c0 4.4 3.6 8 8 8h108v274h-38V405c0-4.4-3.6-8-8-8h-35c-4.4 0-8 3.6-8 8v210h-31c-4.4 0-8 3.6-8 8v37c0 4.4 3.6 8 8 8h244c4.4 0 8-3.6 8-8v-37c0-4.4-3.6-8-8-8h-72V493h58c4.4 0 8-3.6 8-8v-35c0-4.4-3.6-8-8-8h-58V341h63c4.4 0 8-3.6 8-8v-36c0-4.4-3.6-8-8-8H460c-4.4 0-8 3.6-8 8z" } }] }, "name": "verified", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerifiedOutlined = function VerifiedOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: VerifiedOutlined$2
  }));
};

VerifiedOutlined.displayName = 'VerifiedOutlined';
var VerifiedOutlined$1 = /*#__PURE__*/React.forwardRef(VerifiedOutlined);

// This icon file is generated automatically.
var VerticalAlignBottomOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z" } }] }, "name": "vertical-align-bottom", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerticalAlignBottomOutlined = function VerticalAlignBottomOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignBottomOutlined$2
  }));
};

VerticalAlignBottomOutlined.displayName = 'VerticalAlignBottomOutlined';
var VerticalAlignBottomOutlined$1 = /*#__PURE__*/React.forwardRef(VerticalAlignBottomOutlined);

// This icon file is generated automatically.
var VerticalAlignMiddleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 00-11.3 0L405.6 752.3a7.23 7.23 0 005.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z" } }] }, "name": "vertical-align-middle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerticalAlignMiddleOutlined = function VerticalAlignMiddleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignMiddleOutlined$2
  }));
};

VerticalAlignMiddleOutlined.displayName = 'VerticalAlignMiddleOutlined';
var VerticalAlignMiddleOutlined$1 = /*#__PURE__*/React.forwardRef(VerticalAlignMiddleOutlined);

// This icon file is generated automatically.
var VerticalAlignTopOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z" } }] }, "name": "vertical-align-top", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerticalAlignTopOutlined = function VerticalAlignTopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignTopOutlined$2
  }));
};

VerticalAlignTopOutlined.displayName = 'VerticalAlignTopOutlined';
var VerticalAlignTopOutlined$1 = /*#__PURE__*/React.forwardRef(VerticalAlignTopOutlined);

// This icon file is generated automatically.
var VerticalLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 00254 164z" } }] }, "name": "vertical-left", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerticalLeftOutlined = function VerticalLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: VerticalLeftOutlined$2
  }));
};

VerticalLeftOutlined.displayName = 'VerticalLeftOutlined';
var VerticalLeftOutlined$1 = /*#__PURE__*/React.forwardRef(VerticalLeftOutlined);

// This icon file is generated automatically.
var VerticalRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z" } }] }, "name": "vertical-right", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VerticalRightOutlined = function VerticalRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: VerticalRightOutlined$2
  }));
};

VerticalRightOutlined.displayName = 'VerticalRightOutlined';
var VerticalRightOutlined$1 = /*#__PURE__*/React.forwardRef(VerticalRightOutlined);

// This icon file is generated automatically.
var VideoCameraAddOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M368 724H252V608c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v116H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h116v116c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V788h116c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" } }, { "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v352h72V232h576v560H448v72h272c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM888 625l-104-59.8V458.9L888 399v226z" } }, { "tag": "path", "attrs": { "d": "M320 360c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112z" } }] }, "name": "video-camera-add", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VideoCameraAddOutlined = function VideoCameraAddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraAddOutlined$2
  }));
};

VideoCameraAddOutlined.displayName = 'VideoCameraAddOutlined';
var VideoCameraAddOutlined$1 = /*#__PURE__*/React.forwardRef(VideoCameraAddOutlined);

// This icon file is generated automatically.
var VideoCameraFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z" } }] }, "name": "video-camera", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var VideoCameraFilled = function VideoCameraFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraFilled$2
  }));
};

VideoCameraFilled.displayName = 'VideoCameraFilled';
var VideoCameraFilled$1 = /*#__PURE__*/React.forwardRef(VideoCameraFilled);

// This icon file is generated automatically.
var VideoCameraOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }] }, "name": "video-camera", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var VideoCameraOutlined = function VideoCameraOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraOutlined$2
  }));
};

VideoCameraOutlined.displayName = 'VideoCameraOutlined';
var VideoCameraOutlined$1 = /*#__PURE__*/React.forwardRef(VideoCameraOutlined);

// This icon file is generated automatically.
var VideoCameraTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z", "fill": primaryColor } }] }; }, "name": "video-camera", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var VideoCameraTwoTone = function VideoCameraTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraTwoTone$2
  }));
};

VideoCameraTwoTone.displayName = 'VideoCameraTwoTone';
var VideoCameraTwoTone$1 = /*#__PURE__*/React.forwardRef(VideoCameraTwoTone);

// This icon file is generated automatically.
var WalletFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "wallet", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WalletFilled = function WalletFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WalletFilled$2
  }));
};

WalletFilled.displayName = 'WalletFilled';
var WalletFilled$1 = /*#__PURE__*/React.forwardRef(WalletFilled);

// This icon file is generated automatically.
var WalletOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, "name": "wallet", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WalletOutlined = function WalletOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WalletOutlined$2
  }));
};

WalletOutlined.displayName = 'WalletOutlined';
var WalletOutlined$1 = /*#__PURE__*/React.forwardRef(WalletOutlined);

// This icon file is generated automatically.
var WalletTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M580 512a40 40 0 1080 0 40 40 0 10-80 0z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z", "fill": secondaryColor } }] }; }, "name": "wallet", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var WalletTwoTone = function WalletTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WalletTwoTone$2
  }));
};

WalletTwoTone.displayName = 'WalletTwoTone';
var WalletTwoTone$1 = /*#__PURE__*/React.forwardRef(WalletTwoTone);

// This icon file is generated automatically.
var WarningFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "warning", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WarningFilled = function WarningFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WarningFilled$2
  }));
};

WarningFilled.displayName = 'WarningFilled';
var WarningFilled$1 = /*#__PURE__*/React.forwardRef(WarningFilled);

// This icon file is generated automatically.
var WarningOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z" } }] }, "name": "warning", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WarningOutlined = function WarningOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WarningOutlined$2
  }));
};

WarningOutlined.displayName = 'WarningOutlined';
var WarningOutlined$1 = /*#__PURE__*/React.forwardRef(WarningOutlined);

// This icon file is generated automatically.
var WarningTwoTone$2 = { "icon": function render(primaryColor, secondaryColor) { return { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z", "fill": primaryColor } }, { "tag": "path", "attrs": { "d": "M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 01-96 0 48.01 48.01 0 0196 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z", "fill": secondaryColor } }, { "tag": "path", "attrs": { "d": "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z", "fill": primaryColor } }] }; }, "name": "warning", "theme": "twotone" };

// GENERATE BY ./scripts/generate.ts

var WarningTwoTone = function WarningTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WarningTwoTone$2
  }));
};

WarningTwoTone.displayName = 'WarningTwoTone';
var WarningTwoTone$1 = /*#__PURE__*/React.forwardRef(WarningTwoTone);

// This icon file is generated automatically.
var WechatFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 006.4-2.6 9 9 0 002.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 01-36 35.9z" } }] }, "name": "wechat", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WechatFilled = function WechatFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WechatFilled$2
  }));
};

WechatFilled.displayName = 'WechatFilled';
var WechatFilled$1 = /*#__PURE__*/React.forwardRef(WechatFilled);

// This icon file is generated automatically.
var WechatOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 019.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 006.4-2.6 9 9 0 002.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 01-36 35.9z" } }] }, "name": "wechat", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WechatOutlined = function WechatOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WechatOutlined$2
  }));
};

WechatOutlined.displayName = 'WechatOutlined';
var WechatOutlined$1 = /*#__PURE__*/React.forwardRef(WechatOutlined);

// This icon file is generated automatically.
var WeiboCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WeiboCircleFilled = function WeiboCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WeiboCircleFilled$2
  }));
};

WeiboCircleFilled.displayName = 'WeiboCircleFilled';
var WeiboCircleFilled$1 = /*#__PURE__*/React.forwardRef(WeiboCircleFilled);

// This icon file is generated automatically.
var WeiboCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-circle", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WeiboCircleOutlined = function WeiboCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WeiboCircleOutlined$2
  }));
};

WeiboCircleOutlined.displayName = 'WeiboCircleOutlined';
var WeiboCircleOutlined$1 = /*#__PURE__*/React.forwardRef(WeiboCircleOutlined);

// This icon file is generated automatically.
var WeiboOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 00-106-34.3 28.45 28.45 0 00-21.9 33.8 28.39 28.39 0 0033.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0111.3 53.3 28.45 28.45 0 0018.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 00-25.4 39.3 33.12 33.12 0 0039.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z" } }] }, "name": "weibo", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WeiboOutlined = function WeiboOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WeiboOutlined$2
  }));
};

WeiboOutlined.displayName = 'WeiboOutlined';
var WeiboOutlined$1 = /*#__PURE__*/React.forwardRef(WeiboOutlined);

// This icon file is generated automatically.
var WeiboSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WeiboSquareFilled = function WeiboSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WeiboSquareFilled$2
  }));
};

WeiboSquareFilled.displayName = 'WeiboSquareFilled';
var WeiboSquareFilled$1 = /*#__PURE__*/React.forwardRef(WeiboSquareFilled);

// This icon file is generated automatically.
var WeiboSquareOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 00-7.2-34.1 34.68 34.68 0 00-33.1-10.7 18.24 18.24 0 01-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 01-22.9 11.7 18.18 18.18 0 01-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 01-26.6 13.7 21.19 21.19 0 01-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 00-98.9-32.1 21.14 21.14 0 01-25.1-16.3 21.07 21.07 0 0116.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z" } }] }, "name": "weibo-square", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WeiboSquareOutlined = function WeiboSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WeiboSquareOutlined$2
  }));
};

WeiboSquareOutlined.displayName = 'WeiboSquareOutlined';
var WeiboSquareOutlined$1 = /*#__PURE__*/React.forwardRef(WeiboSquareOutlined);

// This icon file is generated automatically.
var WhatsAppOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M713.5 599.9c-10.9-5.6-65.2-32.2-75.3-35.8-10.1-3.8-17.5-5.6-24.8 5.6-7.4 11.1-28.4 35.8-35 43.3-6.4 7.4-12.9 8.3-23.8 2.8-64.8-32.4-107.3-57.8-150-131.1-11.3-19.5 11.3-18.1 32.4-60.2 3.6-7.4 1.8-13.7-1-19.3-2.8-5.6-24.8-59.8-34-81.9-8.9-21.5-18.1-18.5-24.8-18.9-6.4-.4-13.7-.4-21.1-.4-7.4 0-19.3 2.8-29.4 13.7-10.1 11.1-38.6 37.8-38.6 92s39.5 106.7 44.9 114.1c5.6 7.4 77.7 118.6 188.4 166.5 70 30.2 97.4 32.8 132.4 27.6 21.3-3.2 65.2-26.6 74.3-52.5 9.1-25.8 9.1-47.9 6.4-52.5-2.7-4.9-10.1-7.7-21-13z" } }, { "tag": "path", "attrs": { "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" } }] }, "name": "whats-app", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WhatsAppOutlined = function WhatsAppOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WhatsAppOutlined$2
  }));
};

WhatsAppOutlined.displayName = 'WhatsAppOutlined';
var WhatsAppOutlined$1 = /*#__PURE__*/React.forwardRef(WhatsAppOutlined);

// This icon file is generated automatically.
var WifiOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 00-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 00-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 00-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 10128 0 64 64 0 10-128 0z" } }] }, "name": "wifi", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WifiOutlined = function WifiOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WifiOutlined$2
  }));
};

WifiOutlined.displayName = 'WifiOutlined';
var WifiOutlined$1 = /*#__PURE__*/React.forwardRef(WifiOutlined);

// This icon file is generated automatically.
var WindowsFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z" } }] }, "name": "windows", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var WindowsFilled = function WindowsFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WindowsFilled$2
  }));
};

WindowsFilled.displayName = 'WindowsFilled';
var WindowsFilled$1 = /*#__PURE__*/React.forwardRef(WindowsFilled);

// This icon file is generated automatically.
var WindowsOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z" } }] }, "name": "windows", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WindowsOutlined = function WindowsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WindowsOutlined$2
  }));
};

WindowsOutlined.displayName = 'WindowsOutlined';
var WindowsOutlined$1 = /*#__PURE__*/React.forwardRef(WindowsOutlined);

// This icon file is generated automatically.
var WomanOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z" } }] }, "name": "woman", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var WomanOutlined = function WomanOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: WomanOutlined$2
  }));
};

WomanOutlined.displayName = 'WomanOutlined';
var WomanOutlined$1 = /*#__PURE__*/React.forwardRef(WomanOutlined);

// This icon file is generated automatically.
var YahooFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z" } }] }, "name": "yahoo", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var YahooFilled = function YahooFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: YahooFilled$2
  }));
};

YahooFilled.displayName = 'YahooFilled';
var YahooFilled$1 = /*#__PURE__*/React.forwardRef(YahooFilled);

// This icon file is generated automatically.
var YahooOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z" } }] }, "name": "yahoo", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var YahooOutlined = function YahooOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: YahooOutlined$2
  }));
};

YahooOutlined.displayName = 'YahooOutlined';
var YahooOutlined$1 = /*#__PURE__*/React.forwardRef(YahooOutlined);

// This icon file is generated automatically.
var YoutubeFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M941.3 296.1a112.3 112.3 0 00-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0082.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z" } }] }, "name": "youtube", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var YoutubeFilled = function YoutubeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: YoutubeFilled$2
  }));
};

YoutubeFilled.displayName = 'YoutubeFilled';
var YoutubeFilled$1 = /*#__PURE__*/React.forwardRef(YoutubeFilled);

// This icon file is generated automatically.
var YoutubeOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 00-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0082.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z" } }] }, "name": "youtube", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var YoutubeOutlined = function YoutubeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: YoutubeOutlined$2
  }));
};

YoutubeOutlined.displayName = 'YoutubeOutlined';
var YoutubeOutlined$1 = /*#__PURE__*/React.forwardRef(YoutubeOutlined);

// This icon file is generated automatically.
var YuqueFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z" } }] }, "name": "yuque", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var YuqueFilled = function YuqueFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: YuqueFilled$2
  }));
};

YuqueFilled.displayName = 'YuqueFilled';
var YuqueFilled$1 = /*#__PURE__*/React.forwardRef(YuqueFilled);

// This icon file is generated automatically.
var YuqueOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z" } }] }, "name": "yuque", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var YuqueOutlined = function YuqueOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: YuqueOutlined$2
  }));
};

YuqueOutlined.displayName = 'YuqueOutlined';
var YuqueOutlined$1 = /*#__PURE__*/React.forwardRef(YuqueOutlined);

// This icon file is generated automatically.
var ZhihuCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z" } }] }, "name": "zhihu-circle", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ZhihuCircleFilled = function ZhihuCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ZhihuCircleFilled$2
  }));
};

ZhihuCircleFilled.displayName = 'ZhihuCircleFilled';
var ZhihuCircleFilled$1 = /*#__PURE__*/React.forwardRef(ZhihuCircleFilled);

// This icon file is generated automatically.
var ZhihuOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z" } }] }, "name": "zhihu", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ZhihuOutlined = function ZhihuOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ZhihuOutlined$2
  }));
};

ZhihuOutlined.displayName = 'ZhihuOutlined';
var ZhihuOutlined$1 = /*#__PURE__*/React.forwardRef(ZhihuOutlined);

// This icon file is generated automatically.
var ZhihuSquareFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z" } }] }, "name": "zhihu-square", "theme": "filled" };

// GENERATE BY ./scripts/generate.ts

var ZhihuSquareFilled = function ZhihuSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ZhihuSquareFilled$2
  }));
};

ZhihuSquareFilled.displayName = 'ZhihuSquareFilled';
var ZhihuSquareFilled$1 = /*#__PURE__*/React.forwardRef(ZhihuSquareFilled);

// This icon file is generated automatically.
var ZoomInOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-in", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ZoomInOutlined = function ZoomInOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ZoomInOutlined$2
  }));
};

ZoomInOutlined.displayName = 'ZoomInOutlined';
var ZoomInOutlined$1 = /*#__PURE__*/React.forwardRef(ZoomInOutlined);

// This icon file is generated automatically.
var ZoomOutOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, "name": "zoom-out", "theme": "outlined" };

// GENERATE BY ./scripts/generate.ts

var ZoomOutOutlined = function ZoomOutOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(Icon$3, Object.assign({}, props, {
    ref: ref,
    icon: ZoomOutOutlined$2
  }));
};

ZoomOutOutlined.displayName = 'ZoomOutOutlined';
var ZoomOutOutlined$1 = /*#__PURE__*/React.forwardRef(ZoomOutOutlined);

// GENERATE BY ./scripts/generate.ts

var allIcons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AccountBookFilled: AccountBookFilled$1,
  AccountBookOutlined: AccountBookOutlined$1,
  AccountBookTwoTone: AccountBookTwoTone$1,
  AimOutlined: AimOutlined$1,
  AlertFilled: AlertFilled$1,
  AlertOutlined: AlertOutlined$1,
  AlertTwoTone: AlertTwoTone$1,
  AlibabaOutlined: AlibabaOutlined$1,
  AlignCenterOutlined: AlignCenterOutlined$1,
  AlignLeftOutlined: AlignLeftOutlined$1,
  AlignRightOutlined: AlignRightOutlined$1,
  AlipayCircleFilled: AlipayCircleFilled$1,
  AlipayCircleOutlined: AlipayCircleOutlined$1,
  AlipayOutlined: AlipayOutlined$1,
  AlipaySquareFilled: AlipaySquareFilled$1,
  AliwangwangFilled: AliwangwangFilled$1,
  AliwangwangOutlined: AliwangwangOutlined$1,
  AliyunOutlined: AliyunOutlined$1,
  AmazonCircleFilled: AmazonCircleFilled$1,
  AmazonOutlined: AmazonOutlined$1,
  AmazonSquareFilled: AmazonSquareFilled$1,
  AndroidFilled: AndroidFilled$1,
  AndroidOutlined: AndroidOutlined$1,
  AntCloudOutlined: AntCloudOutlined$1,
  AntDesignOutlined: AntDesignOutlined$1,
  ApartmentOutlined: ApartmentOutlined$1,
  ApiFilled: ApiFilled$1,
  ApiOutlined: ApiOutlined$1,
  ApiTwoTone: ApiTwoTone$1,
  AppleFilled: AppleFilled$1,
  AppleOutlined: AppleOutlined$1,
  AppstoreAddOutlined: AppstoreAddOutlined$1,
  AppstoreFilled: AppstoreFilled$1,
  AppstoreOutlined: AppstoreOutlined$1,
  AppstoreTwoTone: AppstoreTwoTone$1,
  AreaChartOutlined: AreaChartOutlined$1,
  ArrowDownOutlined: ArrowDownOutlined$1,
  ArrowLeftOutlined: ArrowLeftOutlined$1,
  ArrowRightOutlined: ArrowRightOutlined$1,
  ArrowUpOutlined: ArrowUpOutlined$1,
  ArrowsAltOutlined: ArrowsAltOutlined$1,
  AudioFilled: AudioFilled$1,
  AudioMutedOutlined: AudioMutedOutlined$1,
  AudioOutlined: AudioOutlined$1,
  AudioTwoTone: AudioTwoTone$1,
  AuditOutlined: AuditOutlined$1,
  BackwardFilled: BackwardFilled$1,
  BackwardOutlined: BackwardOutlined$1,
  BankFilled: BankFilled$1,
  BankOutlined: BankOutlined$1,
  BankTwoTone: BankTwoTone$1,
  BarChartOutlined: BarChartOutlined$1,
  BarcodeOutlined: BarcodeOutlined$1,
  BarsOutlined: BarsOutlined$1,
  BehanceCircleFilled: BehanceCircleFilled$1,
  BehanceOutlined: BehanceOutlined$1,
  BehanceSquareFilled: BehanceSquareFilled$1,
  BehanceSquareOutlined: BehanceSquareOutlined$1,
  BellFilled: BellFilled$1,
  BellOutlined: BellOutlined$1,
  BellTwoTone: BellTwoTone$1,
  BgColorsOutlined: BgColorsOutlined$1,
  BlockOutlined: BlockOutlined$1,
  BoldOutlined: BoldOutlined$1,
  BookFilled: BookFilled$1,
  BookOutlined: BookOutlined$1,
  BookTwoTone: BookTwoTone$1,
  BorderBottomOutlined: BorderBottomOutlined$1,
  BorderHorizontalOutlined: BorderHorizontalOutlined$1,
  BorderInnerOutlined: BorderInnerOutlined$1,
  BorderLeftOutlined: BorderLeftOutlined$1,
  BorderOuterOutlined: BorderOuterOutlined$1,
  BorderOutlined: BorderOutlined$1,
  BorderRightOutlined: BorderRightOutlined$1,
  BorderTopOutlined: BorderTopOutlined$1,
  BorderVerticleOutlined: BorderVerticleOutlined$1,
  BorderlessTableOutlined: BorderlessTableOutlined$1,
  BoxPlotFilled: BoxPlotFilled$1,
  BoxPlotOutlined: BoxPlotOutlined$1,
  BoxPlotTwoTone: BoxPlotTwoTone$1,
  BranchesOutlined: BranchesOutlined$1,
  BugFilled: BugFilled$1,
  BugOutlined: BugOutlined$1,
  BugTwoTone: BugTwoTone$1,
  BuildFilled: BuildFilled$1,
  BuildOutlined: BuildOutlined$1,
  BuildTwoTone: BuildTwoTone$1,
  BulbFilled: BulbFilled$1,
  BulbOutlined: BulbOutlined$1,
  BulbTwoTone: BulbTwoTone$1,
  CalculatorFilled: CalculatorFilled$1,
  CalculatorOutlined: CalculatorOutlined$1,
  CalculatorTwoTone: CalculatorTwoTone$1,
  CalendarFilled: CalendarFilled$1,
  CalendarOutlined: CalendarOutlined$1,
  CalendarTwoTone: CalendarTwoTone$1,
  CameraFilled: CameraFilled$1,
  CameraOutlined: CameraOutlined$1,
  CameraTwoTone: CameraTwoTone$1,
  CarFilled: CarFilled$1,
  CarOutlined: CarOutlined$1,
  CarTwoTone: CarTwoTone$1,
  CaretDownFilled: CaretDownFilled$1,
  CaretDownOutlined: CaretDownOutlined$1,
  CaretLeftFilled: CaretLeftFilled$1,
  CaretLeftOutlined: CaretLeftOutlined$1,
  CaretRightFilled: CaretRightFilled$1,
  CaretRightOutlined: CaretRightOutlined$1,
  CaretUpFilled: CaretUpFilled$1,
  CaretUpOutlined: CaretUpOutlined$1,
  CarryOutFilled: CarryOutFilled$1,
  CarryOutOutlined: CarryOutOutlined$1,
  CarryOutTwoTone: CarryOutTwoTone$1,
  CheckCircleFilled: CheckCircleFilled$1,
  CheckCircleOutlined: CheckCircleOutlined$1,
  CheckCircleTwoTone: CheckCircleTwoTone$1,
  CheckOutlined: CheckOutlined$1,
  CheckSquareFilled: CheckSquareFilled$1,
  CheckSquareOutlined: CheckSquareOutlined$1,
  CheckSquareTwoTone: CheckSquareTwoTone$1,
  ChromeFilled: ChromeFilled$1,
  ChromeOutlined: ChromeOutlined$1,
  CiCircleFilled: CiCircleFilled$1,
  CiCircleOutlined: CiCircleOutlined$1,
  CiCircleTwoTone: CiCircleTwoTone$1,
  CiOutlined: CiOutlined$1,
  CiTwoTone: CiTwoTone$1,
  ClearOutlined: ClearOutlined$1,
  ClockCircleFilled: ClockCircleFilled$1,
  ClockCircleOutlined: ClockCircleOutlined$1,
  ClockCircleTwoTone: ClockCircleTwoTone$1,
  CloseCircleFilled: CloseCircleFilled$1,
  CloseCircleOutlined: CloseCircleOutlined$1,
  CloseCircleTwoTone: CloseCircleTwoTone$1,
  CloseOutlined: CloseOutlined$1,
  CloseSquareFilled: CloseSquareFilled$1,
  CloseSquareOutlined: CloseSquareOutlined$1,
  CloseSquareTwoTone: CloseSquareTwoTone$1,
  CloudDownloadOutlined: CloudDownloadOutlined$1,
  CloudFilled: CloudFilled$1,
  CloudOutlined: CloudOutlined$1,
  CloudServerOutlined: CloudServerOutlined$1,
  CloudSyncOutlined: CloudSyncOutlined$1,
  CloudTwoTone: CloudTwoTone$1,
  CloudUploadOutlined: CloudUploadOutlined$1,
  ClusterOutlined: ClusterOutlined$1,
  CodeFilled: CodeFilled$1,
  CodeOutlined: CodeOutlined$1,
  CodeSandboxCircleFilled: CodeSandboxCircleFilled$1,
  CodeSandboxOutlined: CodeSandboxOutlined$1,
  CodeSandboxSquareFilled: CodeSandboxSquareFilled$1,
  CodeTwoTone: CodeTwoTone$1,
  CodepenCircleFilled: CodepenCircleFilled$1,
  CodepenCircleOutlined: CodepenCircleOutlined$1,
  CodepenOutlined: CodepenOutlined$1,
  CodepenSquareFilled: CodepenSquareFilled$1,
  CoffeeOutlined: CoffeeOutlined$1,
  ColumnHeightOutlined: ColumnHeightOutlined$1,
  ColumnWidthOutlined: ColumnWidthOutlined$1,
  CommentOutlined: CommentOutlined$1,
  CompassFilled: CompassFilled$1,
  CompassOutlined: CompassOutlined$1,
  CompassTwoTone: CompassTwoTone$1,
  CompressOutlined: CompressOutlined$1,
  ConsoleSqlOutlined: ConsoleSqlOutlined$1,
  ContactsFilled: ContactsFilled$1,
  ContactsOutlined: ContactsOutlined$1,
  ContactsTwoTone: ContactsTwoTone$1,
  ContainerFilled: ContainerFilled$1,
  ContainerOutlined: ContainerOutlined$1,
  ContainerTwoTone: ContainerTwoTone$1,
  ControlFilled: ControlFilled$1,
  ControlOutlined: ControlOutlined$1,
  ControlTwoTone: ControlTwoTone$1,
  CopyFilled: CopyFilled$1,
  CopyOutlined: CopyOutlined$1,
  CopyTwoTone: CopyTwoTone$1,
  CopyrightCircleFilled: CopyrightCircleFilled$1,
  CopyrightCircleOutlined: CopyrightCircleOutlined$1,
  CopyrightCircleTwoTone: CopyrightCircleTwoTone$1,
  CopyrightOutlined: CopyrightOutlined$1,
  CopyrightTwoTone: CopyrightTwoTone$1,
  CreditCardFilled: CreditCardFilled$1,
  CreditCardOutlined: CreditCardOutlined$1,
  CreditCardTwoTone: CreditCardTwoTone$1,
  CrownFilled: CrownFilled$1,
  CrownOutlined: CrownOutlined$1,
  CrownTwoTone: CrownTwoTone$1,
  CustomerServiceFilled: CustomerServiceFilled$1,
  CustomerServiceOutlined: CustomerServiceOutlined$1,
  CustomerServiceTwoTone: CustomerServiceTwoTone$1,
  DashOutlined: DashOutlined$1,
  DashboardFilled: DashboardFilled$1,
  DashboardOutlined: DashboardOutlined$1,
  DashboardTwoTone: DashboardTwoTone$1,
  DatabaseFilled: DatabaseFilled$1,
  DatabaseOutlined: DatabaseOutlined$1,
  DatabaseTwoTone: DatabaseTwoTone$1,
  DeleteColumnOutlined: DeleteColumnOutlined$1,
  DeleteFilled: DeleteFilled$1,
  DeleteOutlined: DeleteOutlined$1,
  DeleteRowOutlined: DeleteRowOutlined$1,
  DeleteTwoTone: DeleteTwoTone$1,
  DeliveredProcedureOutlined: DeliveredProcedureOutlined$1,
  DeploymentUnitOutlined: DeploymentUnitOutlined$1,
  DesktopOutlined: DesktopOutlined$1,
  DiffFilled: DiffFilled$1,
  DiffOutlined: DiffOutlined$1,
  DiffTwoTone: DiffTwoTone$1,
  DingdingOutlined: DingdingOutlined$1,
  DingtalkCircleFilled: DingtalkCircleFilled$1,
  DingtalkOutlined: DingtalkOutlined$1,
  DingtalkSquareFilled: DingtalkSquareFilled$1,
  DisconnectOutlined: DisconnectOutlined$1,
  DislikeFilled: DislikeFilled$1,
  DislikeOutlined: DislikeOutlined$1,
  DislikeTwoTone: DislikeTwoTone$1,
  DollarCircleFilled: DollarCircleFilled$1,
  DollarCircleOutlined: DollarCircleOutlined$1,
  DollarCircleTwoTone: DollarCircleTwoTone$1,
  DollarOutlined: DollarOutlined$1,
  DollarTwoTone: DollarTwoTone$1,
  DotChartOutlined: DotChartOutlined$1,
  DoubleLeftOutlined: DoubleLeftOutlined$1,
  DoubleRightOutlined: DoubleRightOutlined$1,
  DownCircleFilled: DownCircleFilled$1,
  DownCircleOutlined: DownCircleOutlined$1,
  DownCircleTwoTone: DownCircleTwoTone$1,
  DownOutlined: DownOutlined$1,
  DownSquareFilled: DownSquareFilled$1,
  DownSquareOutlined: DownSquareOutlined$1,
  DownSquareTwoTone: DownSquareTwoTone$1,
  DownloadOutlined: DownloadOutlined$1,
  DragOutlined: DragOutlined$1,
  DribbbleCircleFilled: DribbbleCircleFilled$1,
  DribbbleOutlined: DribbbleOutlined$1,
  DribbbleSquareFilled: DribbbleSquareFilled$1,
  DribbbleSquareOutlined: DribbbleSquareOutlined$1,
  DropboxCircleFilled: DropboxCircleFilled$1,
  DropboxOutlined: DropboxOutlined$1,
  DropboxSquareFilled: DropboxSquareFilled$1,
  EditFilled: EditFilled$1,
  EditOutlined: EditOutlined$1,
  EditTwoTone: EditTwoTone$1,
  EllipsisOutlined: EllipsisOutlined$1,
  EnterOutlined: EnterOutlined$1,
  EnvironmentFilled: EnvironmentFilled$1,
  EnvironmentOutlined: EnvironmentOutlined$1,
  EnvironmentTwoTone: EnvironmentTwoTone$1,
  EuroCircleFilled: EuroCircleFilled$1,
  EuroCircleOutlined: EuroCircleOutlined$1,
  EuroCircleTwoTone: EuroCircleTwoTone$1,
  EuroOutlined: EuroOutlined$1,
  EuroTwoTone: EuroTwoTone$1,
  ExceptionOutlined: ExceptionOutlined$1,
  ExclamationCircleFilled: ExclamationCircleFilled$1,
  ExclamationCircleOutlined: ExclamationCircleOutlined$1,
  ExclamationCircleTwoTone: ExclamationCircleTwoTone$1,
  ExclamationOutlined: ExclamationOutlined$1,
  ExpandAltOutlined: ExpandAltOutlined$1,
  ExpandOutlined: ExpandOutlined$1,
  ExperimentFilled: ExperimentFilled$1,
  ExperimentOutlined: ExperimentOutlined$1,
  ExperimentTwoTone: ExperimentTwoTone$1,
  ExportOutlined: ExportOutlined$1,
  EyeFilled: EyeFilled$1,
  EyeInvisibleFilled: EyeInvisibleFilled$1,
  EyeInvisibleOutlined: EyeInvisibleOutlined$1,
  EyeInvisibleTwoTone: EyeInvisibleTwoTone$1,
  EyeOutlined: EyeOutlined$1,
  EyeTwoTone: EyeTwoTone$1,
  FacebookFilled: FacebookFilled$1,
  FacebookOutlined: FacebookOutlined$1,
  FallOutlined: FallOutlined$1,
  FastBackwardFilled: FastBackwardFilled$1,
  FastBackwardOutlined: FastBackwardOutlined$1,
  FastForwardFilled: FastForwardFilled$1,
  FastForwardOutlined: FastForwardOutlined$1,
  FieldBinaryOutlined: FieldBinaryOutlined$1,
  FieldNumberOutlined: FieldNumberOutlined$1,
  FieldStringOutlined: FieldStringOutlined$1,
  FieldTimeOutlined: FieldTimeOutlined$1,
  FileAddFilled: FileAddFilled$1,
  FileAddOutlined: FileAddOutlined$1,
  FileAddTwoTone: FileAddTwoTone$1,
  FileDoneOutlined: FileDoneOutlined$1,
  FileExcelFilled: FileExcelFilled$1,
  FileExcelOutlined: FileExcelOutlined$1,
  FileExcelTwoTone: FileExcelTwoTone$1,
  FileExclamationFilled: FileExclamationFilled$1,
  FileExclamationOutlined: FileExclamationOutlined$1,
  FileExclamationTwoTone: FileExclamationTwoTone$1,
  FileFilled: FileFilled$1,
  FileGifOutlined: FileGifOutlined$1,
  FileImageFilled: FileImageFilled$1,
  FileImageOutlined: FileImageOutlined$1,
  FileImageTwoTone: FileImageTwoTone$1,
  FileJpgOutlined: FileJpgOutlined$1,
  FileMarkdownFilled: FileMarkdownFilled$1,
  FileMarkdownOutlined: FileMarkdownOutlined$1,
  FileMarkdownTwoTone: FileMarkdownTwoTone$1,
  FileOutlined: FileOutlined$1,
  FilePdfFilled: FilePdfFilled$1,
  FilePdfOutlined: FilePdfOutlined$1,
  FilePdfTwoTone: FilePdfTwoTone$1,
  FilePptFilled: FilePptFilled$1,
  FilePptOutlined: FilePptOutlined$1,
  FilePptTwoTone: FilePptTwoTone$1,
  FileProtectOutlined: FileProtectOutlined$1,
  FileSearchOutlined: FileSearchOutlined$1,
  FileSyncOutlined: FileSyncOutlined$1,
  FileTextFilled: FileTextFilled$1,
  FileTextOutlined: FileTextOutlined$1,
  FileTextTwoTone: FileTextTwoTone$1,
  FileTwoTone: FileTwoTone$1,
  FileUnknownFilled: FileUnknownFilled$1,
  FileUnknownOutlined: FileUnknownOutlined$1,
  FileUnknownTwoTone: FileUnknownTwoTone$1,
  FileWordFilled: FileWordFilled$1,
  FileWordOutlined: FileWordOutlined$1,
  FileWordTwoTone: FileWordTwoTone$1,
  FileZipFilled: FileZipFilled$1,
  FileZipOutlined: FileZipOutlined$1,
  FileZipTwoTone: FileZipTwoTone$1,
  FilterFilled: FilterFilled$1,
  FilterOutlined: FilterOutlined$1,
  FilterTwoTone: FilterTwoTone$1,
  FireFilled: FireFilled$1,
  FireOutlined: FireOutlined$1,
  FireTwoTone: FireTwoTone$1,
  FlagFilled: FlagFilled$1,
  FlagOutlined: FlagOutlined$1,
  FlagTwoTone: FlagTwoTone$1,
  FolderAddFilled: FolderAddFilled$1,
  FolderAddOutlined: FolderAddOutlined$1,
  FolderAddTwoTone: FolderAddTwoTone$1,
  FolderFilled: FolderFilled$1,
  FolderOpenFilled: FolderOpenFilled$1,
  FolderOpenOutlined: FolderOpenOutlined$1,
  FolderOpenTwoTone: FolderOpenTwoTone$1,
  FolderOutlined: FolderOutlined$1,
  FolderTwoTone: FolderTwoTone$1,
  FolderViewOutlined: FolderViewOutlined$1,
  FontColorsOutlined: FontColorsOutlined$1,
  FontSizeOutlined: FontSizeOutlined$1,
  ForkOutlined: ForkOutlined$1,
  FormOutlined: FormOutlined$1,
  FormatPainterFilled: FormatPainterFilled$1,
  FormatPainterOutlined: FormatPainterOutlined$1,
  ForwardFilled: ForwardFilled$1,
  ForwardOutlined: ForwardOutlined$1,
  FrownFilled: FrownFilled$1,
  FrownOutlined: FrownOutlined$1,
  FrownTwoTone: FrownTwoTone$1,
  FullscreenExitOutlined: FullscreenExitOutlined$1,
  FullscreenOutlined: FullscreenOutlined$1,
  FunctionOutlined: FunctionOutlined$1,
  FundFilled: FundFilled$1,
  FundOutlined: FundOutlined$1,
  FundProjectionScreenOutlined: FundProjectionScreenOutlined$1,
  FundTwoTone: FundTwoTone$1,
  FundViewOutlined: FundViewOutlined$1,
  FunnelPlotFilled: FunnelPlotFilled$1,
  FunnelPlotOutlined: FunnelPlotOutlined$1,
  FunnelPlotTwoTone: FunnelPlotTwoTone$1,
  GatewayOutlined: GatewayOutlined$1,
  GifOutlined: GifOutlined$1,
  GiftFilled: GiftFilled$1,
  GiftOutlined: GiftOutlined$1,
  GiftTwoTone: GiftTwoTone$1,
  GithubFilled: GithubFilled$1,
  GithubOutlined: GithubOutlined$1,
  GitlabFilled: GitlabFilled$1,
  GitlabOutlined: GitlabOutlined$1,
  GlobalOutlined: GlobalOutlined$1,
  GoldFilled: GoldFilled$1,
  GoldOutlined: GoldOutlined$1,
  GoldTwoTone: GoldTwoTone$1,
  GoldenFilled: GoldenFilled$1,
  GoogleCircleFilled: GoogleCircleFilled$1,
  GoogleOutlined: GoogleOutlined$1,
  GooglePlusCircleFilled: GooglePlusCircleFilled$1,
  GooglePlusOutlined: GooglePlusOutlined$1,
  GooglePlusSquareFilled: GooglePlusSquareFilled$1,
  GoogleSquareFilled: GoogleSquareFilled$1,
  GroupOutlined: GroupOutlined$1,
  HddFilled: HddFilled$1,
  HddOutlined: HddOutlined$1,
  HddTwoTone: HddTwoTone$1,
  HeartFilled: HeartFilled$1,
  HeartOutlined: HeartOutlined$1,
  HeartTwoTone: HeartTwoTone$1,
  HeatMapOutlined: HeatMapOutlined$1,
  HighlightFilled: HighlightFilled$1,
  HighlightOutlined: HighlightOutlined$1,
  HighlightTwoTone: HighlightTwoTone$1,
  HistoryOutlined: HistoryOutlined$1,
  HomeFilled: HomeFilled$1,
  HomeOutlined: HomeOutlined$1,
  HomeTwoTone: HomeTwoTone$1,
  HourglassFilled: HourglassFilled$1,
  HourglassOutlined: HourglassOutlined$1,
  HourglassTwoTone: HourglassTwoTone$1,
  Html5Filled: Html5Filled$1,
  Html5Outlined: Html5Outlined$1,
  Html5TwoTone: Html5TwoTone$1,
  IdcardFilled: IdcardFilled$1,
  IdcardOutlined: IdcardOutlined$1,
  IdcardTwoTone: IdcardTwoTone$1,
  IeCircleFilled: IeCircleFilled$1,
  IeOutlined: IeOutlined$1,
  IeSquareFilled: IeSquareFilled$1,
  ImportOutlined: ImportOutlined$1,
  InboxOutlined: InboxOutlined$1,
  InfoCircleFilled: InfoCircleFilled$1,
  InfoCircleOutlined: InfoCircleOutlined$1,
  InfoCircleTwoTone: InfoCircleTwoTone$1,
  InfoOutlined: InfoOutlined$1,
  InsertRowAboveOutlined: InsertRowAboveOutlined$1,
  InsertRowBelowOutlined: InsertRowBelowOutlined$1,
  InsertRowLeftOutlined: InsertRowLeftOutlined$1,
  InsertRowRightOutlined: InsertRowRightOutlined$1,
  InstagramFilled: InstagramFilled$1,
  InstagramOutlined: InstagramOutlined$1,
  InsuranceFilled: InsuranceFilled$1,
  InsuranceOutlined: InsuranceOutlined$1,
  InsuranceTwoTone: InsuranceTwoTone$1,
  InteractionFilled: InteractionFilled$1,
  InteractionOutlined: InteractionOutlined$1,
  InteractionTwoTone: InteractionTwoTone$1,
  IssuesCloseOutlined: IssuesCloseOutlined$1,
  ItalicOutlined: ItalicOutlined$1,
  KeyOutlined: KeyOutlined$1,
  LaptopOutlined: LaptopOutlined$1,
  LayoutFilled: LayoutFilled$1,
  LayoutOutlined: LayoutOutlined$1,
  LayoutTwoTone: LayoutTwoTone$1,
  LeftCircleFilled: LeftCircleFilled$1,
  LeftCircleOutlined: LeftCircleOutlined$1,
  LeftCircleTwoTone: LeftCircleTwoTone$1,
  LeftOutlined: LeftOutlined$1,
  LeftSquareFilled: LeftSquareFilled$1,
  LeftSquareOutlined: LeftSquareOutlined$1,
  LeftSquareTwoTone: LeftSquareTwoTone$1,
  LikeFilled: LikeFilled$1,
  LikeOutlined: LikeOutlined$1,
  LikeTwoTone: LikeTwoTone$1,
  LineChartOutlined: LineChartOutlined$1,
  LineHeightOutlined: LineHeightOutlined$1,
  LineOutlined: LineOutlined$1,
  LinkOutlined: LinkOutlined$1,
  LinkedinFilled: LinkedinFilled$1,
  LinkedinOutlined: LinkedinOutlined$1,
  Loading3QuartersOutlined: Loading3QuartersOutlined$1,
  LoadingOutlined: LoadingOutlined$1,
  LockFilled: LockFilled$1,
  LockOutlined: LockOutlined$1,
  LockTwoTone: LockTwoTone$1,
  LoginOutlined: LoginOutlined$1,
  LogoutOutlined: LogoutOutlined$1,
  MacCommandFilled: MacCommandFilled$1,
  MacCommandOutlined: MacCommandOutlined$1,
  MailFilled: MailFilled$1,
  MailOutlined: MailOutlined$1,
  MailTwoTone: MailTwoTone$1,
  ManOutlined: ManOutlined$1,
  MedicineBoxFilled: MedicineBoxFilled$1,
  MedicineBoxOutlined: MedicineBoxOutlined$1,
  MedicineBoxTwoTone: MedicineBoxTwoTone$1,
  MediumCircleFilled: MediumCircleFilled$1,
  MediumOutlined: MediumOutlined$1,
  MediumSquareFilled: MediumSquareFilled$1,
  MediumWorkmarkOutlined: MediumWorkmarkOutlined$1,
  MehFilled: MehFilled$1,
  MehOutlined: MehOutlined$1,
  MehTwoTone: MehTwoTone$1,
  MenuFoldOutlined: MenuFoldOutlined$1,
  MenuOutlined: MenuOutlined$1,
  MenuUnfoldOutlined: MenuUnfoldOutlined$1,
  MergeCellsOutlined: MergeCellsOutlined$1,
  MessageFilled: MessageFilled$1,
  MessageOutlined: MessageOutlined$1,
  MessageTwoTone: MessageTwoTone$1,
  MinusCircleFilled: MinusCircleFilled$1,
  MinusCircleOutlined: MinusCircleOutlined$1,
  MinusCircleTwoTone: MinusCircleTwoTone$1,
  MinusOutlined: MinusOutlined$1,
  MinusSquareFilled: MinusSquareFilled$1,
  MinusSquareOutlined: MinusSquareOutlined$1,
  MinusSquareTwoTone: MinusSquareTwoTone$1,
  MobileFilled: MobileFilled$1,
  MobileOutlined: MobileOutlined$1,
  MobileTwoTone: MobileTwoTone$1,
  MoneyCollectFilled: MoneyCollectFilled$1,
  MoneyCollectOutlined: MoneyCollectOutlined$1,
  MoneyCollectTwoTone: MoneyCollectTwoTone$1,
  MonitorOutlined: MonitorOutlined$1,
  MoreOutlined: MoreOutlined$1,
  NodeCollapseOutlined: NodeCollapseOutlined$1,
  NodeExpandOutlined: NodeExpandOutlined$1,
  NodeIndexOutlined: NodeIndexOutlined$1,
  NotificationFilled: NotificationFilled$1,
  NotificationOutlined: NotificationOutlined$1,
  NotificationTwoTone: NotificationTwoTone$1,
  NumberOutlined: NumberOutlined$1,
  OneToOneOutlined: OneToOneOutlined$1,
  OrderedListOutlined: OrderedListOutlined$1,
  PaperClipOutlined: PaperClipOutlined$1,
  PartitionOutlined: PartitionOutlined$1,
  PauseCircleFilled: PauseCircleFilled$1,
  PauseCircleOutlined: PauseCircleOutlined$1,
  PauseCircleTwoTone: PauseCircleTwoTone$1,
  PauseOutlined: PauseOutlined$1,
  PayCircleFilled: PayCircleFilled$1,
  PayCircleOutlined: PayCircleOutlined$1,
  PercentageOutlined: PercentageOutlined$1,
  PhoneFilled: PhoneFilled$1,
  PhoneOutlined: PhoneOutlined$1,
  PhoneTwoTone: PhoneTwoTone$1,
  PicCenterOutlined: PicCenterOutlined$1,
  PicLeftOutlined: PicLeftOutlined$1,
  PicRightOutlined: PicRightOutlined$1,
  PictureFilled: PictureFilled$1,
  PictureOutlined: PictureOutlined$1,
  PictureTwoTone: PictureTwoTone$1,
  PieChartFilled: PieChartFilled$1,
  PieChartOutlined: PieChartOutlined$1,
  PieChartTwoTone: PieChartTwoTone$1,
  PlayCircleFilled: PlayCircleFilled$1,
  PlayCircleOutlined: PlayCircleOutlined$1,
  PlayCircleTwoTone: PlayCircleTwoTone$1,
  PlaySquareFilled: PlaySquareFilled$1,
  PlaySquareOutlined: PlaySquareOutlined$1,
  PlaySquareTwoTone: PlaySquareTwoTone$1,
  PlusCircleFilled: PlusCircleFilled$1,
  PlusCircleOutlined: PlusCircleOutlined$1,
  PlusCircleTwoTone: PlusCircleTwoTone$1,
  PlusOutlined: PlusOutlined$1,
  PlusSquareFilled: PlusSquareFilled$1,
  PlusSquareOutlined: PlusSquareOutlined$1,
  PlusSquareTwoTone: PlusSquareTwoTone$1,
  PoundCircleFilled: PoundCircleFilled$1,
  PoundCircleOutlined: PoundCircleOutlined$1,
  PoundCircleTwoTone: PoundCircleTwoTone$1,
  PoundOutlined: PoundOutlined$1,
  PoweroffOutlined: PoweroffOutlined$1,
  PrinterFilled: PrinterFilled$1,
  PrinterOutlined: PrinterOutlined$1,
  PrinterTwoTone: PrinterTwoTone$1,
  ProfileFilled: ProfileFilled$1,
  ProfileOutlined: ProfileOutlined$1,
  ProfileTwoTone: ProfileTwoTone$1,
  ProjectFilled: ProjectFilled$1,
  ProjectOutlined: ProjectOutlined$1,
  ProjectTwoTone: ProjectTwoTone$1,
  PropertySafetyFilled: PropertySafetyFilled$1,
  PropertySafetyOutlined: PropertySafetyOutlined$1,
  PropertySafetyTwoTone: PropertySafetyTwoTone$1,
  PullRequestOutlined: PullRequestOutlined$1,
  PushpinFilled: PushpinFilled$1,
  PushpinOutlined: PushpinOutlined$1,
  PushpinTwoTone: PushpinTwoTone$1,
  QqCircleFilled: QqCircleFilled$1,
  QqOutlined: QqOutlined$1,
  QqSquareFilled: QqSquareFilled$1,
  QrcodeOutlined: QrcodeOutlined$1,
  QuestionCircleFilled: QuestionCircleFilled$1,
  QuestionCircleOutlined: QuestionCircleOutlined$1,
  QuestionCircleTwoTone: QuestionCircleTwoTone$1,
  QuestionOutlined: QuestionOutlined$1,
  RadarChartOutlined: RadarChartOutlined$1,
  RadiusBottomleftOutlined: RadiusBottomleftOutlined$1,
  RadiusBottomrightOutlined: RadiusBottomrightOutlined$1,
  RadiusSettingOutlined: RadiusSettingOutlined$1,
  RadiusUpleftOutlined: RadiusUpleftOutlined$1,
  RadiusUprightOutlined: RadiusUprightOutlined$1,
  ReadFilled: ReadFilled$1,
  ReadOutlined: ReadOutlined$1,
  ReconciliationFilled: ReconciliationFilled$1,
  ReconciliationOutlined: ReconciliationOutlined$1,
  ReconciliationTwoTone: ReconciliationTwoTone$1,
  RedEnvelopeFilled: RedEnvelopeFilled$1,
  RedEnvelopeOutlined: RedEnvelopeOutlined$1,
  RedEnvelopeTwoTone: RedEnvelopeTwoTone$1,
  RedditCircleFilled: RedditCircleFilled$1,
  RedditOutlined: RedditOutlined$1,
  RedditSquareFilled: RedditSquareFilled$1,
  RedoOutlined: RedoOutlined$1,
  ReloadOutlined: ReloadOutlined$1,
  RestFilled: RestFilled$1,
  RestOutlined: RestOutlined$1,
  RestTwoTone: RestTwoTone$1,
  RetweetOutlined: RetweetOutlined$1,
  RightCircleFilled: RightCircleFilled$1,
  RightCircleOutlined: RightCircleOutlined$1,
  RightCircleTwoTone: RightCircleTwoTone$1,
  RightOutlined: RightOutlined$1,
  RightSquareFilled: RightSquareFilled$1,
  RightSquareOutlined: RightSquareOutlined$1,
  RightSquareTwoTone: RightSquareTwoTone$1,
  RiseOutlined: RiseOutlined$1,
  RobotFilled: RobotFilled$1,
  RobotOutlined: RobotOutlined$1,
  RocketFilled: RocketFilled$1,
  RocketOutlined: RocketOutlined$1,
  RocketTwoTone: RocketTwoTone$1,
  RollbackOutlined: RollbackOutlined$1,
  RotateLeftOutlined: RotateLeftOutlined$1,
  RotateRightOutlined: RotateRightOutlined$1,
  SafetyCertificateFilled: SafetyCertificateFilled$1,
  SafetyCertificateOutlined: SafetyCertificateOutlined$1,
  SafetyCertificateTwoTone: SafetyCertificateTwoTone$1,
  SafetyOutlined: SafetyOutlined$1,
  SaveFilled: SaveFilled$1,
  SaveOutlined: SaveOutlined$1,
  SaveTwoTone: SaveTwoTone$1,
  ScanOutlined: ScanOutlined$1,
  ScheduleFilled: ScheduleFilled$1,
  ScheduleOutlined: ScheduleOutlined$1,
  ScheduleTwoTone: ScheduleTwoTone$1,
  ScissorOutlined: ScissorOutlined$1,
  SearchOutlined: SearchOutlined$1,
  SecurityScanFilled: SecurityScanFilled$1,
  SecurityScanOutlined: SecurityScanOutlined$1,
  SecurityScanTwoTone: SecurityScanTwoTone$1,
  SelectOutlined: SelectOutlined$1,
  SendOutlined: SendOutlined$1,
  SettingFilled: SettingFilled$1,
  SettingOutlined: SettingOutlined$1,
  SettingTwoTone: SettingTwoTone$1,
  ShakeOutlined: ShakeOutlined$1,
  ShareAltOutlined: ShareAltOutlined$1,
  ShopFilled: ShopFilled$1,
  ShopOutlined: ShopOutlined$1,
  ShopTwoTone: ShopTwoTone$1,
  ShoppingCartOutlined: ShoppingCartOutlined$1,
  ShoppingFilled: ShoppingFilled$1,
  ShoppingOutlined: ShoppingOutlined$1,
  ShoppingTwoTone: ShoppingTwoTone$1,
  ShrinkOutlined: ShrinkOutlined$1,
  SignalFilled: SignalFilled$1,
  SisternodeOutlined: SisternodeOutlined$1,
  SketchCircleFilled: SketchCircleFilled$1,
  SketchOutlined: SketchOutlined$1,
  SketchSquareFilled: SketchSquareFilled$1,
  SkinFilled: SkinFilled$1,
  SkinOutlined: SkinOutlined$1,
  SkinTwoTone: SkinTwoTone$1,
  SkypeFilled: SkypeFilled$1,
  SkypeOutlined: SkypeOutlined$1,
  SlackCircleFilled: SlackCircleFilled$1,
  SlackOutlined: SlackOutlined$1,
  SlackSquareFilled: SlackSquareFilled$1,
  SlackSquareOutlined: SlackSquareOutlined$1,
  SlidersFilled: SlidersFilled$1,
  SlidersOutlined: SlidersOutlined$1,
  SlidersTwoTone: SlidersTwoTone$1,
  SmallDashOutlined: SmallDashOutlined$1,
  SmileFilled: SmileFilled$1,
  SmileOutlined: SmileOutlined$1,
  SmileTwoTone: SmileTwoTone$1,
  SnippetsFilled: SnippetsFilled$1,
  SnippetsOutlined: SnippetsOutlined$1,
  SnippetsTwoTone: SnippetsTwoTone$1,
  SolutionOutlined: SolutionOutlined$1,
  SortAscendingOutlined: SortAscendingOutlined$1,
  SortDescendingOutlined: SortDescendingOutlined$1,
  SoundFilled: SoundFilled$1,
  SoundOutlined: SoundOutlined$1,
  SoundTwoTone: SoundTwoTone$1,
  SplitCellsOutlined: SplitCellsOutlined$1,
  StarFilled: StarFilled$1,
  StarOutlined: StarOutlined$1,
  StarTwoTone: StarTwoTone$1,
  StepBackwardFilled: StepBackwardFilled$1,
  StepBackwardOutlined: StepBackwardOutlined$1,
  StepForwardFilled: StepForwardFilled$1,
  StepForwardOutlined: StepForwardOutlined$1,
  StockOutlined: StockOutlined$1,
  StopFilled: StopFilled$1,
  StopOutlined: StopOutlined$1,
  StopTwoTone: StopTwoTone$1,
  StrikethroughOutlined: StrikethroughOutlined$1,
  SubnodeOutlined: SubnodeOutlined$1,
  SwapLeftOutlined: SwapLeftOutlined$1,
  SwapOutlined: SwapOutlined$1,
  SwapRightOutlined: SwapRightOutlined$1,
  SwitcherFilled: SwitcherFilled$1,
  SwitcherOutlined: SwitcherOutlined$1,
  SwitcherTwoTone: SwitcherTwoTone$1,
  SyncOutlined: SyncOutlined$1,
  TableOutlined: TableOutlined$1,
  TabletFilled: TabletFilled$1,
  TabletOutlined: TabletOutlined$1,
  TabletTwoTone: TabletTwoTone$1,
  TagFilled: TagFilled$1,
  TagOutlined: TagOutlined$1,
  TagTwoTone: TagTwoTone$1,
  TagsFilled: TagsFilled$1,
  TagsOutlined: TagsOutlined$1,
  TagsTwoTone: TagsTwoTone$1,
  TaobaoCircleFilled: TaobaoCircleFilled$1,
  TaobaoCircleOutlined: TaobaoCircleOutlined$1,
  TaobaoOutlined: TaobaoOutlined$1,
  TaobaoSquareFilled: TaobaoSquareFilled$1,
  TeamOutlined: TeamOutlined$1,
  ThunderboltFilled: ThunderboltFilled$1,
  ThunderboltOutlined: ThunderboltOutlined$1,
  ThunderboltTwoTone: ThunderboltTwoTone$1,
  ToTopOutlined: ToTopOutlined$1,
  ToolFilled: ToolFilled$1,
  ToolOutlined: ToolOutlined$1,
  ToolTwoTone: ToolTwoTone$1,
  TrademarkCircleFilled: TrademarkCircleFilled$1,
  TrademarkCircleOutlined: TrademarkCircleOutlined$1,
  TrademarkCircleTwoTone: TrademarkCircleTwoTone$1,
  TrademarkOutlined: TrademarkOutlined$1,
  TransactionOutlined: TransactionOutlined$1,
  TranslationOutlined: TranslationOutlined$1,
  TrophyFilled: TrophyFilled$1,
  TrophyOutlined: TrophyOutlined$1,
  TrophyTwoTone: TrophyTwoTone$1,
  TwitterCircleFilled: TwitterCircleFilled$1,
  TwitterOutlined: TwitterOutlined$1,
  TwitterSquareFilled: TwitterSquareFilled$1,
  UnderlineOutlined: UnderlineOutlined$1,
  UndoOutlined: UndoOutlined$1,
  UngroupOutlined: UngroupOutlined$1,
  UnlockFilled: UnlockFilled$1,
  UnlockOutlined: UnlockOutlined$1,
  UnlockTwoTone: UnlockTwoTone$1,
  UnorderedListOutlined: UnorderedListOutlined$1,
  UpCircleFilled: UpCircleFilled$1,
  UpCircleOutlined: UpCircleOutlined$1,
  UpCircleTwoTone: UpCircleTwoTone$1,
  UpOutlined: UpOutlined$1,
  UpSquareFilled: UpSquareFilled$1,
  UpSquareOutlined: UpSquareOutlined$1,
  UpSquareTwoTone: UpSquareTwoTone$1,
  UploadOutlined: UploadOutlined$1,
  UsbFilled: UsbFilled$1,
  UsbOutlined: UsbOutlined$1,
  UsbTwoTone: UsbTwoTone$1,
  UserAddOutlined: UserAddOutlined$1,
  UserDeleteOutlined: UserDeleteOutlined$1,
  UserOutlined: UserOutlined$1,
  UserSwitchOutlined: UserSwitchOutlined$1,
  UsergroupAddOutlined: UsergroupAddOutlined$1,
  UsergroupDeleteOutlined: UsergroupDeleteOutlined$1,
  VerifiedOutlined: VerifiedOutlined$1,
  VerticalAlignBottomOutlined: VerticalAlignBottomOutlined$1,
  VerticalAlignMiddleOutlined: VerticalAlignMiddleOutlined$1,
  VerticalAlignTopOutlined: VerticalAlignTopOutlined$1,
  VerticalLeftOutlined: VerticalLeftOutlined$1,
  VerticalRightOutlined: VerticalRightOutlined$1,
  VideoCameraAddOutlined: VideoCameraAddOutlined$1,
  VideoCameraFilled: VideoCameraFilled$1,
  VideoCameraOutlined: VideoCameraOutlined$1,
  VideoCameraTwoTone: VideoCameraTwoTone$1,
  WalletFilled: WalletFilled$1,
  WalletOutlined: WalletOutlined$1,
  WalletTwoTone: WalletTwoTone$1,
  WarningFilled: WarningFilled$1,
  WarningOutlined: WarningOutlined$1,
  WarningTwoTone: WarningTwoTone$1,
  WechatFilled: WechatFilled$1,
  WechatOutlined: WechatOutlined$1,
  WeiboCircleFilled: WeiboCircleFilled$1,
  WeiboCircleOutlined: WeiboCircleOutlined$1,
  WeiboOutlined: WeiboOutlined$1,
  WeiboSquareFilled: WeiboSquareFilled$1,
  WeiboSquareOutlined: WeiboSquareOutlined$1,
  WhatsAppOutlined: WhatsAppOutlined$1,
  WifiOutlined: WifiOutlined$1,
  WindowsFilled: WindowsFilled$1,
  WindowsOutlined: WindowsOutlined$1,
  WomanOutlined: WomanOutlined$1,
  YahooFilled: YahooFilled$1,
  YahooOutlined: YahooOutlined$1,
  YoutubeFilled: YoutubeFilled$1,
  YoutubeOutlined: YoutubeOutlined$1,
  YuqueFilled: YuqueFilled$1,
  YuqueOutlined: YuqueOutlined$1,
  ZhihuCircleFilled: ZhihuCircleFilled$1,
  ZhihuOutlined: ZhihuOutlined$1,
  ZhihuSquareFilled: ZhihuSquareFilled$1,
  ZoomInOutlined: ZoomInOutlined$1,
  ZoomOutOutlined: ZoomOutOutlined$1
});

var Icon$2 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
      Component = props.component,
      viewBox = props.viewBox,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      children = props.children,
      restProps = _objectWithoutProperties(props, ["className", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children"]);

  warning$2(Boolean(Component || children), 'Should have `component` prop or `children`.');
  useInsertStyles();
  var classString = classNames('anticon', className);
  var svgClassString = classNames({
    'anticon-spin': !!spin
  });
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var innerSvgProps = _objectSpread2(_objectSpread2({}, svgBaseProps), {}, {
    className: svgClassString,
    style: svgStyle,
    viewBox: viewBox
  });

  if (!viewBox) {
    delete innerSvgProps.viewBox;
  } // component > children


  var renderInnerNode = function renderInnerNode() {
    if (Component) {
      return /*#__PURE__*/React.createElement(Component, Object.assign({}, innerSvgProps), children);
    }

    if (children) {
      warning$2(Boolean(viewBox) || React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children) && React.Children.only(children).type === 'use', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return /*#__PURE__*/React.createElement("svg", Object.assign({}, innerSvgProps, {
        viewBox: viewBox
      }), children);
    }

    return null;
  };

  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  return /*#__PURE__*/React.createElement("span", Object.assign({
    role: "img"
  }, restProps, {
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString
  }), renderInnerNode());
});
Icon$2.displayName = 'AntdIcon';

var customCache = new Set();

function isValidCustomScriptUrl(scriptUrl) {
  return Boolean(typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl));
}

function createScriptUrlElements(scriptUrls) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currentScriptUrl = scriptUrls[index];

  if (isValidCustomScriptUrl(currentScriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', currentScriptUrl);
    script.setAttribute('data-namespace', currentScriptUrl);

    if (scriptUrls.length > index + 1) {
      script.onload = function () {
        createScriptUrlElements(scriptUrls, index + 1);
      };

      script.onerror = function () {
        createScriptUrlElements(scriptUrls, index + 1);
      };
    }

    customCache.add(currentScriptUrl);
    document.body.appendChild(script);
  }
}

function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scriptUrl = options.scriptUrl,
      _options$extraCommonP = options.extraCommonProps,
      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */

  if (scriptUrl && typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function') {
    if (Array.isArray(scriptUrl)) {
      // 因为iconfont资源会把svg插入before，所以前加载相同type会覆盖后加载，为了数组覆盖顺序，倒叙插入
      createScriptUrlElements(scriptUrl.reverse());
    } else {
      createScriptUrlElements([scriptUrl]);
    }
  }

  var Iconfont = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var type = props.type,
        children = props.children,
        restProps = _objectWithoutProperties(props, ["type", "children"]); // children > type


    var content = null;

    if (props.type) {
      content = /*#__PURE__*/React.createElement("use", {
        xlinkHref: "#".concat(type)
      });
    }

    if (children) {
      content = children;
    }

    return /*#__PURE__*/React.createElement(Icon$2, Object.assign({}, extraCommonProps, restProps, {
      ref: ref
    }), content);
  });
  Iconfont.displayName = 'Iconfont';
  return Iconfont;
}

var InputBox = function InputBox(props) {
  var placeholder = props.placeholder,
      value = props.value,
      onTextChange = props.onTextChange;
  value ? /*#__PURE__*/React__default.createElement(CloseCircleOutlined$1, {
    onClick: props.emitEmpty,
    style: {
      cursor: 'pointer'
    }
  }) : null;
  return /*#__PURE__*/React__default.createElement(_Input, {
    placeholder: placeholder && placeholder,
    value: value,
    onChange: onTextChange,
    allowClear: props.suffix,
    style: props.style ? props.style : {}
  });
};

InputBox.defaultProps = {
  onTextChange: function onTextChange() {},
  value: 'Text input',
  placeholder: 'placeholder'
};

var SearchButton = function SearchButton(props) {
  var searchClick = props.searchClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "search-input-bar-view"
  }, /*#__PURE__*/React__default.createElement(SearchOutlined$1, {
    className: "search-button-input-icon",
    onClick: function onClick() {
      return searchClick && searchClick();
    }
  }));
};

SearchButton.defaultProps = {
  searchClick: function searchClick() {}
};

var AntdTextArea = _Input.TextArea;

var TextArea = function TextArea(_ref) {
  var placeholder = _ref.placeholder,
      text = _ref.text,
      handleChange = _ref.handleChange,
      limit = _ref.limit,
      resize = _ref.resize;

  function handleType(e) {
    var value = e.target.value;
    limit ? handleChange(value.substring(0, limit)) : handleChange(value);
  }

  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(AntdTextArea, {
    className: classNames({
      'disable-resize': !resize
    }),
    placeholder: placeholder,
    value: limit ? text.substring(0, limit) : text,
    onChange: handleType
  }), limit && /*#__PURE__*/React__default.createElement("div", {
    className: classNames('limit-progress', {
      error: text.length >= limit
    })
  }, text.length, "/", limit));
};

TextArea.defaultProps = {
  limit: null,
  placeholder: '',
  resize: false
};

var DefaultTag = function DefaultTag(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: props.tagIconName ? "tag-container withTagIcon ".concat(props.tagType, " ").concat(props.readOnly ? 'readonly' : '') : "tag-container ".concat(props.tagType === 'type' ? props.content.toLowerCase() : props.tagType, " ").concat(props.readOnly ? 'readonly' : ''),
    onClick: function onClick() {
      return props.handleOnClick(props.content, props.tagTypeDisplayName);
    }
  }, props.tagIconName && /*#__PURE__*/React__default.createElement("span", {
    className: "tag-icon"
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    name: props.tagIconName,
    size: "16"
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "tag-content"
  }, props.content));
};

DefaultTag.defaultProps = {
  content: '',
  tagType: '',
  tagIconName: '',
  tagTypeDisplayName: '',
  readOnly: false,
  handleOnClick: function handleOnClick() {}
};

var FilterTag = function FilterTag(props) {
  var tagType = props.tagType,
      tagValue = props.tagValue;
  var tagTypeDetails;

  switch (tagType) {
    case 'type':
      tagTypeDetails = tagValue.toLowerCase();
      break;

    case 'resolution':
      tagTypeDetails = 'resolution';
      break;

    case 'format':
      tagTypeDetails = 'stereoType';
      break;

    case 'aspect':
      tagTypeDetails = 'aspectRatio';
      break;

    case 'language':
      tagTypeDetails = 'language';
      break;

    case 'subtitle':
      tagTypeDetails = 'subtitleLanguage';
      break;

    case 'audio':
      tagTypeDetails = 'audioFormats';
      break;

    case 'captions':
      tagTypeDetails = 'closedCaptions';
      break;

    case 'tag':
      tagTypeDetails = 'mappedTags';
      break;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "tag-container filter-container ".concat(tagTypeDetails),
    onClick: props.handleOnClick
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "tag-content"
  }, props.content), /*#__PURE__*/React__default.createElement("span", {
    className: "filter-close"
  }, "x"));
};

FilterTag.defaultProps = {
  content: '',
  tagType: '',
  tagValue: '',
  handleOnClick: function handleOnClick() {}
};

var appliance_column={serialNumber:"Serial No",theatres:"Theatres",chain:"Chain",bandwidth:"Bandwidth",publicIp:"Public IP",osversion:"OS Version",downloadStatus:"Download Status",status:"Status"};var theatre_select_modal={precise_match_not_found:"A precise match for these theatres could not be found.",duplicate:"duplicate",invalid_file_message:"Invalid File. There is no Theatre name or ID",theatre:"Theatre",row:"row",Row:"Row",without_name_id:"without name and ID",was:"was",ignored:"ignored",matched:"matched",theatre_already_selected:"This theatre is already selected in the list.",id:"ID",ids:"IDs",screen:"Screen",view:"View",hide:"Hide",are:"are",that:"that",the:"the"};var kdm_statuses={emailed:"Emailed",generated:"Available",failed:"Failed",inprogress:"In Progress",success:"Available",unavailable:"Unavailable",expired:"Expired",expiring:"Expiring"};var theatres_select_page={csv_template_text:"CSV Columns: Screen ID, Theatre ID, Name, City, State, Country, Area, Chain Name"};var users_table={columns:{name:"Name",email:"Email",roles:"Roles",hasAccessTo:"Has Access To",lastUpdatedOn:"Last Updated On",lastUpdatedBy:"Last Updated By"},status:{inactive:"Deactivated User",invited:"Invited User",noAccess:"No Access"},add_access:{modal_title:"Add Access",name:"Name",email:"Email",group:"Group",role:"Role",add_another_role:"+ Add another role",add:"Add",cancel:"Cancel",group_added:"Group added to the user",error:"Error while adding group"},update_access:{modal_title:"Update Access",group_updated:"Group has been updated for the user",update:"Update",error:"Error while updating group"}};var groups_table={columns:{group:"Group",theatres:"Theatres",users:"Users",lastUpdatedOn:"Last Updated On",lastUpdatedBy:"Last Updated By"}};var groups_detail_theatre_table={columns:{theatre:"Theatre",chain:"Chain",location:"Location",screens:"Screens"}};var filterPanel={heading:"Filter By",clear:"Clear",clearAll:"Clear All",noRecordsfound:"No records found",filterTagResultsLabel:"Results for"};var work_orders={current:"Active Work Orders",past:"Archive Work Orders",search_hint_text:"Search or Filter by work order no, booking ref, composition name, partner name",no_work_orders:"No %{workOrderItemsType} work orders found",booking_reference:"Booking Reference",deliver_by:"Deliver By",company_details:"Company Details",copy_shipping_status:"Copy/Shipping Status",download:"Download",filter:"FILTERS",filter_tag_labels:{booking:"Booking",workorder:"Work Order",partner:"Partner",composition:"Composition"},status:{assigned:"Assigned",ready_to_process:"Ready to process",in_process:"In Process",fulfilled:"Fulfilled",cancelled:"Cancelled",download_in_progress:"Download in progress",download_failed:"Download failed",duplication_in_progress:"Copy in progress",shipment_pending:"Pending shipment",shipment_completed:"Completed",update_shipping_details:"Delivery date has passed. Please update shipping details.",shipments_pending_cancellation:"Shipments pending cancellation"},work_order:{work_order:"WO Number",delivery_type:"Delivery Type",booking:"Booking",copy_status:"Copy Status",shipped:"%{shipped} Shipped",shipment_pending:"%{shipment_pending} Pending",deliveries:"Deliveries",deliver_on:"Deliver before",copied:"Copied",cancelled:"Cancelled",shipping_status:"Shipping Status",action_required:"Action Required/Status",status:{assigned:"Assigned",ready_to_process:"Ready to process",in_process:"In Process",fulfilled:"Fulfilled",cancelled:"Cancelled",download_in_progress:"Download in progress",download_failed:"Download failed",duplication_in_progress:"Copy in progress",shipment_pending:"Pending shipment",shipment_completed:"Completed",update_shipping_details:"Update shipping details",shipments_pending_cancellation:"Shipments pending cancellation"},value:"Nett Amount",view:"View",download:"Download",update:"Update",dcp_transfer_status_label:"Select DCP Transfer Status",dcp_transfer_status:{started:"DCP transfer started",completed:"DCP transfer completed",not_started:"DCP transfer not started"},dcp_download_status_details:"Download Details",dcp_download_status:{not_started:"Download Yet to Start",queued:"Download Queued",in_progress:"Downloading %{downloadPercentage} %",completed:"Downloaded",failed:"Download Failed",pending:"Download Scheduled",error:"Error Fetching Download Status",downloading_unarchiving:"Downloading - Unarchiving",downloading_archived:"Downloading - Archived",downloading_stalled:"Downloading - Stalled"},delivery_types:{HARD_DRIVE:"Hard Drive",SATELLITE:"Satellite",INTERNET:"Internet"},total_drives:"%{totalDrives} drives",content_size:"Content Size: ",copy_in_progress:"%{copy_in_progress} In Progress",copy_pending:"%{copy_pending} Pending",shipment_status:"Shipment Status: ",pending_cancellation:"%{pending_cancellation} Pending Cancellation",shipment_cancelled:"%{shipment_cancelled} Cancelled"},errors:{update_dcp_upload_status_in_server:"DCP upload status could not updated",load:"Could not load work orders",load_dcp_transfer_statuses:"Could not load dcp transfer statuses",download_start:"Unable to start download"}};var shipments={saved:"Shipping details updated",address:"Address",deliver_instructions:"Delivery Instructions",deliver_by:"Deliver By",ship_by:"Ship By",shipping_info:"Shipping Information",dispatched:"Shipped",drive_copy:"Drive Copy",dispatched_status_shipped:"%{totalShipped} drive(s) shipped of ",dispatched_status_total:"%{totalDrives} drives",print_label:"Print Hard Drive Label",workorder:"Work Order",shipment:"Delivery",shipping_type:"Select courier type",reference:"Enter tracking number",comments:"Comments",return_shipment:"Return",shipping:"Shipping",update:"Update",download_shipping_information:"Download shipment information",upload_shipping_information:"Upload shipment information",status:{pending:"Pending",dispatched:"Shipped",cancelled:"Cancelled",pending_cancellation:"Pending Cancellation"},errors:{fetch:"Error while fetching shipments",upload_invalid_workorder_title:"Error while importing shipments Excel",upload_invalid_workorder_message:"Invalid work order number found in Excel",invalid_courier_type:"Invalid courier type"}};var duplication={select_drive_type:"Please select the drive type you want to use for this work order of %{totalDrives} drives",appliance_not_found:"No appliances found",total_copied:"%{totalCopied} drive(s) copied and ",total_drives:"%{totalDrives} drives",executing:"Copy Started",start_copying:"Start Copying",inserted_drives:"%{insertedDrives} drive(s) inserted.",remaining_drives:" Insert %{possibleRemainingDriveCount} more drive(s).",redirection_message:"This appliance is busy in duplicating work order ",fetch_details_message:"Fetching details. Please wait...",check_status_message:"Please check the status",dcp_copy_modal_title:"Compositions",cpls_empty_message:"Drive does not have any content",stages:{pending:"Copy Pending",queued:"Copy Queued",started:"Copy Started",executing:"Copy Started",preparing:"Preparing to copy",formatting:"Step 1 of 3: Formatting drives",duplicating:"Step 2 of 3: Copying content to drives",verifying:"Step 3 of 3: Verifying",completed:"Copy Completed",failed:"Copy Failed",mount_points_preparation_failed:"Drive not found"},errors:{start_duplication:"Could not start duplication",appliance_offline:"Appliance %{serialNo} is offline",appliance_not_founf:"Appliance %{serialNo} not found",drive_in_use:"Drive %{bayNo} is already in use",no_drives_inserted:"No drives inserted",dcp_not_found_in_appliance:"No suitable DCPs found for CPL %{cplName}",dcp_not_found_in_store:"DCP is not found in store",drive_not_enough_space:"Not enough space in Drive %{bayNo}"}};var bay={status:{available:"Drive Inserted",queued:"Copy Queued",busy:"Drive Inserted",empty:"Insert Drive",inserted:"Drive Inserted",copying:"Copying...",copy_complete:"Copy Complete. Eject Drive",error:"Drive Error",eject:"Eject drive",executing:"Copy started",failed:"Copy failed"},status_text:{executing:"Copy started",formatting:"Formatting drive...",preparing:"Preparing to copy...",duplicating:"Copying content...",verifying:"Verifying...",succeeded:"Copy Complete. Eject Drive",failed:"Drive Error. Copy Failed",duplication_failed:"Copy Failed",verification_failed:"Verification Failed",format_failed:"Formatting Failed",mount_points_preparation_failed:"Drive not found",partitioning_failed:"Formatting Failed.",duplication_interrupted:"Duplication Interrupted",drive_in_use:"Drive is in use",slow_drive:"Copying Content; Slow Drive Detected."},name:{"1":"Bay","2":"Port"}};var appliance_download={status:{pending:"Download Pending",not_started:"Download not started",queued:"Download Queued",in_progress:"Downloading...",completed:"Download Completed",failed:"Download Failed",error:"Some error in getting download status",downloading_unarchiving:"Downloading - Unarchiving",downloading_archived:"Downloading - Archived",downloading_stalled:"Downloading - Stalled"},errors:{start_download:"Could not start download"}};var download="Download";var enLocale = {appliance_column:appliance_column,theatre_select_modal:theatre_select_modal,kdm_statuses:kdm_statuses,theatres_select_page:theatres_select_page,users_table:users_table,groups_table:groups_table,groups_detail_theatre_table:groups_detail_theatre_table,filterPanel:filterPanel,work_orders:work_orders,shipments:shipments,duplication:duplication,bay:bay,appliance_download:appliance_download,download:download};

var templateOptions = {
  interpolate: /%{(.+?)}/,
  replacement: '%{o.$1}',
  variable: 'o'
};

var memoizedMessage = _$1.memoize(function (message) {
  message = message.replace(templateOptions.interpolate, templateOptions.replacement);
  return _$1.template(message, templateOptions);
});

I18n.translations.en = enLocale;

I18n.interpolate = function (message, options) {
  options = this.prepareOptions(options);
  return memoizedMessage(message)(options);
};

var ClearTag = function ClearTag(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'tag-container filter-container clear',
    onClick: props.handleOnClick
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "tag-content"
  }, props.content));
};

ClearTag.defaultProps = {
  content: I18n.t('filterPanel.clear'),
  handleOnClick: function handleOnClick() {}
};

var FilterTags = function FilterTags(_ref) {
  var filterTagList = _ref.filterTagList,
      handleClearAll = _ref.handleClearAll;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "filter-results-container"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "filter-results-label"
  }, I18n.t('filterPanel.filterTagResultsLabel')), filterTagList.map(function (tagListItems) {
    return tagListItems.selectedList.map(function (filter) {
      return /*#__PURE__*/React__default.createElement(FilterTag, {
        content: ["".concat(filter.type, ": ").concat(filter.label), filter.subLabel].filter(Boolean).join(', '),
        filterTagValue: filter,
        handleOnClick: function handleOnClick() {
          tagListItems.handleClear(filter);
        }
      });
    });
  }), /*#__PURE__*/React__default.createElement(ClearTag, {
    handleOnClick: handleClearAll
  }));
};

var SuccessMessage = function SuccessMessage(msg) {
  var $timer = setTimeout(function () {
    clearTimeout($timer);
    $timer = null;

    _message.success(msg, 5);
  }, 0);
};

var ErrorMessage = function ErrorMessage(msg) {
  var $timer = setTimeout(function () {
    clearTimeout($timer);
    $timer = null;

    _message.error(msg, 5);
  }, 0);
};

var EmptyHandler = function EmptyHandler() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "empty-handler"
  }, /*#__PURE__*/React__default.createElement("span", null, "-"));
};

var CursorPagination = function CursorPagination(_ref) {
  var handlePrevious = _ref.handlePrevious,
      handleNext = _ref.handleNext,
      shoudlDisablePrevious = _ref.shoudlDisablePrevious,
      shouldDisableNext = _ref.shouldDisableNext,
      currentPage = _ref.currentPage;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "cursor-pagination"
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handlePrevious,
    className: classNames({
      disabled: shoudlDisablePrevious
    })
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    name: "ChevronLeft",
    size: "24"
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "current-page"
  }, currentPage), /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    onClick: handleNext,
    className: classNames({
      disabled: shouldDisableNext
    })
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    name: "ChevronRight",
    size: "24"
  })));
};

var TablePagination = function TablePagination(props) {
  return /*#__PURE__*/React__default.createElement(TablePagination$1, props);
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

/* global define */

var pluralize = createCommonjsModule(function (module, exports) {
(function (root, pluralize) {
  /* istanbul ignore else */
  if (typeof commonjsRequire === 'function' && 'object' === 'object' && 'object' === 'object') {
    // Node.
    module.exports = pluralize();
  } else {
    // Browser global.
    root.pluralize = pluralize();
  }
})(commonjsGlobal, function () {
  // Rule storage - pluralize and singularize need to be run sequentially,
  // while other rules can be optimized using an object for instant lookups.
  var pluralRules = [];
  var singularRules = [];
  var uncountables = {};
  var irregularPlurals = {};
  var irregularSingles = {};

  /**
   * Title case a string.
   *
   * @param  {string} str
   * @return {string}
   */
  function toTitleCase (str) {
    return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
  }

  /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */
  function sanitizeRule (rule) {
    if (typeof rule === 'string') {
      return new RegExp('^' + rule + '$', 'i');
    }

    return rule;
  }

  /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */
  function restoreCase (word, token) {
    // Upper cased words. E.g. "HELLO".
    if (word === word.toUpperCase()) {
      return token.toUpperCase();
    }

    // Title cased words. E.g. "Title".
    if (word[0] === word[0].toUpperCase()) {
      return toTitleCase(token);
    }

    // Lower cased words. E.g. "test".
    return token.toLowerCase();
  }

  /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */
  function interpolate (str, args) {
    return str.replace(/\$(\d{1,2})/g, function (match, index) {
      return args[index] || '';
    });
  }

  /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {String}   token
   * @param  {String}   word
   * @param  {Array}    collection
   * @return {String}
   */
  function sanitizeWord (token, word, collection) {
    // Empty string or doesn't need fixing.
    if (!token.length || uncountables.hasOwnProperty(token)) {
      return word;
    }

    var len = collection.length;

    // Iterate over the sanitization rules and use the first one to match.
    while (len--) {
      var rule = collection[len];

      // If the rule passes, return the replacement.
      if (rule[0].test(word)) {
        return word.replace(rule[0], function (match, index, word) {
          var result = interpolate(rule[1], arguments);

          if (match === '') {
            return restoreCase(word[index - 1], result);
          }

          return restoreCase(match, result);
        });
      }
    }

    return word;
  }

  /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */
  function replaceWord (replaceMap, keepMap, rules) {
    return function (word) {
      // Get the correct token and case restoration functions.
      var token = word.toLowerCase();

      // Check against the keep object map.
      if (keepMap.hasOwnProperty(token)) {
        return restoreCase(word, token);
      }

      // Check against the replacement map for a direct word replacement.
      if (replaceMap.hasOwnProperty(token)) {
        return restoreCase(word, replaceMap[token]);
      }

      // Run all the rules against the word.
      return sanitizeWord(token, word, rules);
    };
  }

  /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {String}  word
   * @param  {Number}  count
   * @param  {Boolean} inclusive
   * @return {String}
   */
  function pluralize (word, count, inclusive) {
    var pluralized = count === 1
      ? pluralize.singular(word) : pluralize.plural(word);

    return (inclusive ? count + ' ' : '') + pluralized;
  }

  /**
   * Pluralize a word.
   *
   * @type {Function}
   */
  pluralize.plural = replaceWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Singularize a word.
   *
   * @type {Function}
   */
  pluralize.singular = replaceWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addPluralRule = function (rule, replacement) {
    pluralRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addSingularRule = function (rule, replacement) {
    singularRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */
  pluralize.addUncountableRule = function (word) {
    if (typeof word === 'string') {
      uncountables[word.toLowerCase()] = true;
      return;
    }

    // Set singular and plural references for the word.
    pluralize.addPluralRule(word, '$0');
    pluralize.addSingularRule(word, '$0');
  };

  /**
   * Add an irregular word definition.
   *
   * @param {String} single
   * @param {String} plural
   */
  pluralize.addIrregularRule = function (single, plural) {
    plural = plural.toLowerCase();
    single = single.toLowerCase();

    irregularSingles[single] = plural;
    irregularPlurals[plural] = single;
  };

  /**
   * Irregular rules.
   */
  [
    // Pronouns.
    ['I', 'we'],
    ['me', 'us'],
    ['he', 'they'],
    ['she', 'they'],
    ['them', 'them'],
    ['myself', 'ourselves'],
    ['yourself', 'yourselves'],
    ['itself', 'themselves'],
    ['herself', 'themselves'],
    ['himself', 'themselves'],
    ['themself', 'themselves'],
    ['is', 'are'],
    ['this', 'these'],
    ['that', 'those'],
    // Words ending in with a consonant and `o`.
    ['echo', 'echoes'],
    ['dingo', 'dingoes'],
    ['volcano', 'volcanoes'],
    ['tornado', 'tornadoes'],
    ['torpedo', 'torpedoes'],
    // Ends with `us`.
    ['genus', 'genera'],
    ['viscus', 'viscera'],
    // Ends with `ma`.
    ['stigma', 'stigmata'],
    ['stoma', 'stomata'],
    ['dogma', 'dogmata'],
    ['lemma', 'lemmata'],
    ['schema', 'schemata'],
    ['anathema', 'anathemata'],
    // Other irregular rules.
    ['ox', 'oxen'],
    ['axe', 'axes'],
    ['die', 'dice'],
    ['yes', 'yeses'],
    ['foot', 'feet'],
    ['eave', 'eaves'],
    ['goose', 'geese'],
    ['tooth', 'teeth'],
    ['quiz', 'quizzes'],
    ['human', 'humans'],
    ['proof', 'proofs'],
    ['carve', 'carves'],
    ['valve', 'valves'],
    ['thief', 'thieves'],
    ['genie', 'genies'],
    ['groove', 'grooves'],
    ['pickaxe', 'pickaxes'],
    ['whiskey', 'whiskies']
  ].forEach(function (rule) {
    return pluralize.addIrregularRule(rule[0], rule[1]);
  });

  /**
   * Pluralization rules.
   */
  [
    [/s?$/i, 's'],
    [/([^aeiou]ese)$/i, '$1'],
    [/(ax|test)is$/i, '$1es'],
    [/(alias|[^aou]us|tlas|gas|ris)$/i, '$1es'],
    [/(e[mn]u)s?$/i, '$1s'],
    [/([^l]ias|[aeiou]las|[emjzr]as|[iu]am)$/i, '$1'],
    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
    [/(seraph|cherub)(?:im)?$/i, '$1im'],
    [/(her|at|gr)o$/i, '$1oes'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
    [/sis$/i, 'ses'],
    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
    [/([^aeiouy]|qu)y$/i, '$1ies'],
    [/([^ch][ieo][ln])ey$/i, '$1ies'],
    [/(x|ch|ss|sh|zz)$/i, '$1es'],
    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
    [/(m|l)(?:ice|ouse)$/i, '$1ice'],
    [/(pe)(?:rson|ople)$/i, '$1ople'],
    [/(child)(?:ren)?$/i, '$1ren'],
    [/eaux$/i, '$0'],
    [/m[ae]n$/i, 'men'],
    ['thou', 'you']
  ].forEach(function (rule) {
    return pluralize.addPluralRule(rule[0], rule[1]);
  });

  /**
   * Singularization rules.
   */
  [
    [/s$/i, ''],
    [/(ss)$/i, '$1'],
    [/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)(?:sis|ses)$/i, '$1sis'],
    [/(^analy)(?:sis|ses)$/i, '$1sis'],
    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
    [/([^aeiouy]|qu)ies$/i, '$1y'],
    [/(^[pl]|zomb|^(?:neck)?t|[aeo][lt]|cut)ies$/i, '$1ie'],
    [/(\b(?:mon|smil))ies$/i, '$1ey'],
    [/(m|l)ice$/i, '$1ouse'],
    [/(seraph|cherub)im$/i, '$1'],
    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|tlas|gas|(?:her|at|gr)o|ris)(?:es)?$/i, '$1'],
    [/(e[mn]u)s?$/i, '$1'],
    [/(movie|twelve)s$/i, '$1'],
    [/(cris|test|diagnos)(?:is|es)$/i, '$1is'],
    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
    [/(alumn|alg|vertebr)ae$/i, '$1a'],
    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
    [/(matr|append)ices$/i, '$1ix'],
    [/(pe)(rson|ople)$/i, '$1rson'],
    [/(child)ren$/i, '$1'],
    [/(eau)x?$/i, '$1'],
    [/men$/i, 'man']
  ].forEach(function (rule) {
    return pluralize.addSingularRule(rule[0], rule[1]);
  });

  /**
   * Uncountable rules.
   */
  [
    // Singular words with no plurals.
    'advice',
    'agenda',
    'bison',
    'bream',
    'buffalo',
    'carp',
    'chassis',
    'cod',
    'cooperation',
    'corps',
    'digestion',
    'debris',
    'diabetes',
    'energy',
    'equipment',
    'elk',
    'excretion',
    'expertise',
    'flounder',
    'gallows',
    'garbage',
    'graffiti',
    'headquarters',
    'health',
    'herpes',
    'highjinks',
    'homework',
    'information',
    'jeans',
    'justice',
    'kudos',
    'labour',
    'machinery',
    'mackerel',
    'media',
    'mews',
    'moose',
    'news',
    'pike',
    'plankton',
    'pliers',
    'pollution',
    'premises',
    'rain',
    'rice',
    'salmon',
    'scissors',
    'series',
    'sewage',
    'shambles',
    'shrimp',
    'species',
    'staff',
    'swine',
    'trout',
    'tuna',
    'whiting',
    'wildebeest',
    'wildlife',
    'you',
    // Regexes.
    /pox$/i, // "chickpox", "smallpox"
    /ois$/i,
    /deer$/i, // "deer", "reindeer"
    /fish$/i, // "fish", "blowfish", "angelfish"
    /sheep$/i,
    /measles$/i,
    /[^aeiou]ese$/i // "chinese", "japanese"
  ].forEach(pluralize.addUncountableRule);

  return pluralize;
});
});

var TheatreDefaultInfo = function TheatreDefaultInfo(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      viewMatchedRows = _useState2[0],
      setView = _useState2[1];

  var renderScreenId = function renderScreenId(screenId) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "id-text"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "sub-heading"
    }, "".concat(I18n.t('theatre_select_modal.screen'), " ").concat(pluralize(I18n.t('theatre_select_modal.ids'), screenId.length))), screenId.map(function (screen, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: index
      }, screen);
    }));
  };

  var renderDuplicateRows = function renderDuplicateRows(duplicate) {
    var duplicateTheatres = 0;
    var duplicateTheatreNames = duplicate.name ? duplicate.name.length : 0;
    var duplicateTheatreId = duplicate.id ? duplicate.id.length : 0;
    duplicateTheatres = duplicateTheatreNames + duplicateTheatreId;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, duplicate.screen_id ? /*#__PURE__*/React__default.createElement("div", {
      className: "id-text"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "sub-heading"
    }, "Following ".concat(duplicate.screen_id.length > 1 ? duplicate.screen_id.length : "", " ").concat(I18n.t('theatre_select_modal.duplicate'), " ").concat(pluralize(I18n.t('theatre_select_modal.row'), duplicate.screen_id.length), " ").concat(I18n.t('theatre_select_modal.that'), " ").concat(I18n.t('theatre_select_modal.matched'), " ").concat(I18n.t('theatre_select_modal.the'), " screen ").concat(pluralize(I18n.t('theatre_select_modal.are'), duplicate.screen_id.length), " ").concat(I18n.t('theatre_select_modal.ignored'))), duplicate.screen_id.map(function (screen, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: index
      }, screen);
    })) : null, duplicateTheatres ? /*#__PURE__*/React__default.createElement("div", {
      className: "id-text"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "sub-heading"
    }, "Following ".concat(duplicateTheatres > 1 ? duplicateTheatres : "", " ").concat(I18n.t('theatre_select_modal.duplicate'), " ").concat(pluralize(I18n.t('theatre_select_modal.row'), duplicateTheatres), " ").concat(I18n.t('theatre_select_modal.that'), " ").concat(I18n.t('theatre_select_modal.matched'), " ").concat(I18n.t('theatre_select_modal.the'), " theatre ").concat(pluralize(I18n.t('theatre_select_modal.are'), duplicateTheatres), " ").concat(I18n.t('theatre_select_modal.ignored'))), duplicate.name && duplicate.name.map(function (name, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: index
      }, name);
    }), duplicate.id && duplicate.id.map(function (id, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: index
      }, id);
    })) : null);
  };

  var renderTheatreSelectInfo = function renderTheatreSelectInfo(props) {
    var id = props.id,
        screen_id = props.screen_id,
        name = props.name,
        duplicate = props.duplicate,
        matchedRows = props.matchedRows,
        unMatched = props.unMatched,
        duplicateRows = props.duplicateRows;
    var theatreName;
    var theatreId = null;
    var screenId = null;
    var rowsMatched = null;

    if (matchedRows == 1 || unMatched) {
      if (name && name.length) {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: name[0]
        });

        if (screen_id && screen_id.length) {
          screenId = renderScreenId(screen_id);

          if (id && id.length) {
            theatreId = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
              className: "id-text sub-heading"
            }, "".concat(I18n.t('theatre_select_modal.theatre'), " ").concat(pluralize(I18n.t('theatre_select_modal.ids'), id.length))), id.map(function (id, index) {
              return /*#__PURE__*/React__default.createElement("div", {
                className: "id-text",
                key: index
              }, id);
            }));
          }
        }
      } else if (screen_id && screen_id.length) {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: "".concat(I18n.t('theatre_select_modal.screen'), " ").concat(pluralize(I18n.t('theatre_select_modal.ids'), screen_id.length), ": ").concat(screen_id[0])
        });

        if (id && id.length) {
          theatreId = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
            className: "id-text sub-heading"
          }, "".concat(I18n.t('theatre_select_modal.theatre'), " ").concat(pluralize(I18n.t('theatre_select_modal.ids'), id.length))), id.map(function (id, index) {
            return /*#__PURE__*/React__default.createElement("div", {
              className: "id-text",
              key: index
            }, id);
          }));
        }
      } else {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: "".concat(I18n.t('theatre_select_modal.theatre'), " ").concat(pluralize(I18n.t('theatre_select_modal.ids'), id.length), ": ").concat(id[0])
        });
      }
    } else {
      if (name && name.length) {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: name[0]
        });
      } else if (screen_id && screen_id.length) {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: "".concat(I18n.t('theatre_select_modal.screen'), " ").concat(I18n.t('theatre_select_modal.id'), ": ").concat(screen_id[0])
        });
      } else {
        theatreName = /*#__PURE__*/React__default.createElement(TheatreName, {
          name: "".concat(I18n.t('theatre_select_modal.theatre'), " ").concat(I18n.t('theatre_select_modal.id'), ": ").concat(id[0])
        });
      }

      rowsMatched = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-details margin-chevron",
        onClick: function onClick() {
          return setView(!viewMatchedRows);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: viewMatchedRows ? 'ChevronDown' : 'ChevronRight',
        color: "blue",
        size: "16"
      }), /*#__PURE__*/React__default.createElement("div", null, "".concat(pluralize(I18n.t('theatre_select_modal.Row'), matchedRows, true), " ").concat(I18n.t('theatre_select_modal.matched')))), viewMatchedRows ? screen_id ? renderScreenId(screen_id) : id ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "id-text sub-heading"
      }, "".concat(I18n.t('theatre_select_modal.theatre'), " ").concat(pluralize(I18n.t('theatre_select_modal.ids'), id.length), ":")), id.map(function (id, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "id-text",
          key: index
        }, id);
      })) : null : null, viewMatchedRows ? duplicateRows ? renderDuplicateRows(duplicate) : null : null);
    }

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, theatreName, props.address ? /*#__PURE__*/React__default.createElement(TheatreAddress, {
      address: props.address
    }) : null, screenId, theatreId, rowsMatched);
  };

  var renderTheatreinfo = function renderTheatreinfo(props) {
    var hasWireTap = props.hasWireTap;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "theatrename-wiretapicon-wrapper"
    }, /*#__PURE__*/React__default.createElement(TheatreName, {
      name: props.name,
      capitalize: true
    }), hasWireTap ? /*#__PURE__*/React__default.createElement("div", {
      className: "wire-tap-icon"
    }, /*#__PURE__*/React__default.createElement("div", {
      "data-tip": true,
      "data-for": "wiretapicon"
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "WireTap",
      color: "primary",
      size: 16
    })), /*#__PURE__*/React__default.createElement(ReactTooltip, {
      class: "react-tooltip-custom",
      id: "wiretapicon",
      place: "top",
      type: "dark",
      effect: "solid",
      offset: {
        top: 4
      }
    }, "Powered by WireTAP")) : null), /*#__PURE__*/React__default.createElement(TheatreAddress, {
      address: props.address
    }));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "theatre-info__default"
  }, props.theatreSelect ? renderTheatreSelectInfo(props) : renderTheatreinfo(props));
};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$1 = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsAstral$1 = '[' + rsAstralRange$1 + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboMarksRange$1 + rsComboSymbolsRange$1 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$1 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$1 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$1 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1,
    rsSymbol$1 = '(?:' + [rsNonAstral$1 + rsCombo$1 + '?', rsCombo$1, rsRegional$1, rsSurrPair$1, rsAstral$1].join('|') + ')';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$1, 'g');

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode$1 = RegExp(rsFitz$1 + '(?=' + rsFitz$1 + ')|' + rsSymbol$1 + rsSeq$1, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode$1 = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboMarksRange$1 + rsComboSymbolsRange$1 + rsVarRange$1 + ']');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray$1(string) {
  return string.split('');
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$1(string) {
  return reHasUnicode$1.test(string);
}

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray$1(string)
    : asciiToArray$1(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode$1) || [];
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var Symbol$2 = root$1.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol$1(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice$1(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$2(string);

    var strSymbols = hasUnicode$1(string)
      ? stringToArray$1(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice$1(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString$1(value);
}

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase$1 = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst$1(toString$2(string).toLowerCase());
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString$2(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst$1 = createCaseFirst$1('toUpperCase');

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString$2(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

var lodash_camelcase = camelCase$1;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString$1(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

var lodash_upperfirst = upperFirst;

/* eslint-disable no-console */
var warned = {};
function warning$1(valid, message) {
  // Support uglify
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    console.error("Warning: ".concat(message));
  }
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning$1, valid, message);
}
/* eslint-enable */

var warning = (function (valid, component, message) {
  warningOnce(valid, "[antd-compatible: ".concat(component, "] ").concat(message));
});

var fillTester = /-fill$/;
var outlineTester = /-o$/;
var twoToneTester = /-twotone$/;
function getThemeFromTypeName(type) {
  var result = null;

  if (fillTester.test(type)) {
    result = 'filled';
  } else if (outlineTester.test(type)) {
    result = 'outlined';
  } else if (twoToneTester.test(type)) {
    result = 'twoTone';
  }

  return result;
}
function removeTypeTheme(type) {
  return type.replace(fillTester, '').replace(outlineTester, '').replace(twoToneTester, '');
}
var themeMap = {
  filled: 'filled',
  outlined: 'outlined',
  twoTone: 'twoTone'
};
function withThemeSuffix(type, theme) {
  var result = lodash_upperfirst(lodash_camelcase(type));
  var realTheme = lodash_upperfirst(themeMap[theme]);

  if (theme !== 'outlined' && !realTheme) {
    warning(false, 'Icon', "This icon '".concat(type, "' has unknown theme '").concat(theme, "'"));
  }

  return result + realTheme;
} // For alias or compatibility

function alias(type) {
  var newType = type;

  switch (type) {
    case 'cross':
      newType = 'close';
      break;
    // https://github.com/ant-design/ant-design/issues/13007

    case 'interation':
      newType = 'interaction';
      break;
    // https://github.com/ant-design/ant-design/issues/16810

    case 'canlendar':
      newType = 'calendar';
      break;
    // https://github.com/ant-design/ant-design/issues/17448

    case 'colum-height':
      newType = 'column-height';
      break;
  }

  warning(newType === type, 'Icon', "Icon '".concat(type, "' was a typo and is now deprecated, please use '").concat(newType, "' instead."));
  return newType;
}

var upgradeMessage = (function (component) {
  return warning(false, component, "The legacy component has been deprecated, and ant design 4.0 now released! Please follow https://ant.design/components/".concat(component.toLowerCase()).concat(component === 'Mention' ? 's' : '', " to upgrade."));
});

var iconsMap = allIcons;

var LegacyTypeIcon = function LegacyTypeIcon(props) {
  var type = props.type,
      theme = props.theme;

  if (theme) {
    var themeInName = getThemeFromTypeName(type);
    warning(!themeInName || theme === themeInName, 'Icon', "The icon name '".concat(type, "' already specify a theme '").concat(themeInName, "',") + " the 'theme' prop '".concat(theme, "' will be ignored."));
  }

  var computedType = withThemeSuffix(removeTypeTheme(alias(type)), theme || 'outlined');
  var targetIconComponent = iconsMap[computedType];
  warning(targetIconComponent, 'Icon', "The icon name '".concat(type, "'").concat(theme ? "with ".concat(theme) : '', " doesn't exist, please check it at https://ant.design/components/icon"));
  return targetIconComponent ? React__default.createElement(targetIconComponent, props) : null;
};

var Icon$1 = function Icon(props) {
  var type = props.type,
      component = props.component,
      children = props.children;
  upgradeMessage('Icon');
  warning(Boolean(type || component || children), 'Icon', 'Should have `type` prop or `component` prop or `children`.');

  if (component || children) {
    return React__default.createElement(Icon$2, Object.assign({}, props));
  }

  if (typeof type === 'string') {
    return React__default.createElement(LegacyTypeIcon, Object.assign({}, props, {
      type: type
    }));
  }

  return React__default.createElement(Icon$2, null);
};

Icon$1.createFromIconfontCN = create;
Icon$1.getTwoToneColor = getTwoToneColor;
Icon$1.setTwoToneColor = setTwoToneColor;

var Icon = function Icon(props) {
  return /*#__PURE__*/React__default.createElement("button", {
    className: "icon-btn",
    onClick: props.callbackAction
  }, /*#__PURE__*/React__default.createElement(Icon$1, {
    type: props.iconName
  }));
};

Icon.defaultProps = {
  iconName: 'close',
  callbackAction: function callbackAction() {}
};

var TheatreDefaultMeta = function TheatreDefaultMeta(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "theatre-meta__default"
  }, props.price && /*#__PURE__*/React__default.createElement(TheatrePrice, {
    price: props.price
  }), props.containsDeleteButton && /*#__PURE__*/React__default.createElement(Icon, {
    iconName: "close",
    callbackAction: props.deleteAction
  }));
};

var TextLinks = function TextLinks(props) {
  return /*#__PURE__*/React__default.createElement("span", {
    className: props.size ? "text-with-icon__link ".concat(props.size) : 'text-with-icon__link'
  }, props.content);
};

TextLinks.defaultProps = {
  size: 'large'
};

var TextWithIconLinks = function TextWithIconLinks(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: props.size ? "text-with-icon ".concat(props.size) : 'text-with-icon'
  }, props.iconName && /*#__PURE__*/React__default.createElement("div", {
    className: "text-with-icon__icon"
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    name: props.iconName,
    color: "blue"
  })), /*#__PURE__*/React__default.createElement("span", {
    className: props.size ? "text-with-icon__link ".concat(props.size) : 'text-with-icon__link'
  }, props.content));
};

TextWithIconLinks.defaultProps = {
  size: 'large'
};

var SearchBox = function SearchBox(props) {
  var value = props.value,
      _onTextChange = props.onTextChange,
      placeholder = props.placeholder,
      suffix = props.suffix,
      _emitEmpty = props.emitEmpty,
      _searchClick = props.searchClick,
      searchButton = props.searchButton,
      error = props.error,
      style = props.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "qw-search"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "qw-search-input-box"
  }, /*#__PURE__*/React__default.createElement(InputBox, {
    value: value,
    onTextChange: function onTextChange(e) {
      return _onTextChange && _onTextChange(e);
    },
    placeholder: placeholder,
    suffix: suffix,
    style: style || {},
    emitEmpty: function emitEmpty() {
      return _emitEmpty && _emitEmpty();
    }
  }), searchButton && /*#__PURE__*/React__default.createElement(SearchButton, {
    searchClick: function searchClick() {
      return _searchClick && _searchClick();
    }
  })), error && /*#__PURE__*/React__default.createElement("div", {
    className: "search-input-error"
  }, error));
};

SearchBox.defaultProps = {
  value: 'input',
  error: 'error',
  suffix: true,
  placeholder: 'placeholder',
  searchButton: true
};

var TabBar = function TabBar(props) {
  var list = props.list,
      _onChange = props.onChange,
      selectedTab = props.selectedTab;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tab-bar-chip-list"
  }, list.map(function (item) {
    return /*#__PURE__*/React__default.createElement(TabItem, {
      name: item.name,
      id: item.id,
      key: item.id,
      item: item,
      selectedTab: selectedTab,
      onChange: function onChange(item) {
        return _onChange && _onChange(item);
      }
    });
  }));
};

TabBar.defaultProps = {
  list: [{
    id: "tab".concat(1),
    name: 'Theatres',
    type: 'theatres'
  }, {
    id: "tab".concat(2),
    name: 'Lists',
    type: 'lists'
  }, {
    id: "tab".concat(3),
    name: 'Festivals',
    type: 'festivals'
  }],
  selectedTab: 'theatres'
};

var errorValues = {
  screen_errors: {
    not_ply_device: 'Screen does not have a playback device',
    is_not_active: 'Screen does not have an active device',
    has_no_certificate: 'Screen does not have a device certificate',
    non_dci: 'Screen does not have a dci complaints',
    screen_inactive: 'Inactive Screen'
  }
};

var ScreensList = function ScreensList(props) {
  var list = props.list,
      handleAddScreen = props.handleAddScreen,
      theatreIndex = props.theatreIndex,
      theatre = props.theatre,
      theatresInBooking = props.theatresInBooking,
      editListView = props.editListView,
      listType = props.listType;
      props.pricingModel;
      props.dcpPrice;
      var shouldShowPrice = props.shouldShowPrice;

  function getDeviceErrorMessages(deviceErrors) {
    if (deviceErrors) {
      return deviceErrors.map(function (error) {
        return /*#__PURE__*/React__default.createElement("span", {
          className: "block"
        }, errorValues.screen_errors[error.toLowerCase()]);
      });
    }
  }

  return /*#__PURE__*/React__default.createElement("div", null, list && list.map(function (screen, index) {
    var theatreInBooking = _.findIndex(theatresInBooking, function (th) {
      return th.id === theatre.id;
    });

    var screenInBooking = -1;

    if (theatreInBooking >= 0) {
      screenInBooking = _.findIndex(theatresInBooking[theatreInBooking].screens, function (sc) {
        if (editListView) {
          return sc.id === screen.id && sc.isInList;
        }

        return sc.id === screen.id && sc.selected;
      });
    }

    return /*#__PURE__*/React__default.createElement("div", {
      className: "theatre-card-list-view",
      key: "".concat(screen.id + index, "screen-list"),
      onClick: function onClick() {
        return handleAddScreen && handleAddScreen(index, theatreIndex, screen, theatre, screenInBooking >= 0);
      }
    }, /*#__PURE__*/React__default.createElement(Label, {
      text: screen.name
    }), (screen && screen.deviceErrors && screen.deviceErrors.length || !screen.isActive) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
      "data-tip": true,
      "data-for": screen.id,
      className: "screen-error-icon"
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "AssestError"
    })), /*#__PURE__*/React__default.createElement(ReactTooltip, {
      class: "react-tooltip-custom",
      id: screen.id,
      place: "top",
      type: "dark",
      effect: "solid"
    }, !screen.isActive ? /*#__PURE__*/React__default.createElement("span", null, "Inactive Screen") : getDeviceErrorMessages(screen.deviceErrors))), /*#__PURE__*/React__default.createElement("div", {
      className: "theatre-card-list-view-options"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: 'theatre-card-list-view-checkbox'
    }, listType == 'lists' && !screen.isInList && /*#__PURE__*/React__default.createElement("div", null, screenInBooking >= 0 ? /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "SquareFilled"
    }) : /*#__PURE__*/React__default.createElement(AppIcon, {
      name: "SquareEmpty"
    })), shouldShowPrice ? "" : (listType != 'lists' || listType == 'lists' && screen.isInList) && /*#__PURE__*/React__default.createElement(Checkbox, {
      value: screenInBooking >= 0
    }))));
  }));
};

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray$1(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate$1(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$1(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray$1(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$1 = {
  isArray: isArray$1,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate$1,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$1.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$1.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$1.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$1.forEach(val, function parseValue(v) {
        if (utils$1.isDate(v)) {
          v = v.toISOString();
        } else if (utils$1.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils$1.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils$1.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils$1.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

var cookies = (
  utils$1.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$1.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$1.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$1.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$1.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$1.trim(line.substr(0, i)).toLowerCase();
    val = utils$1.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var isURLSameOrigin = (
  utils$1.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$1.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils$1.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$1.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$1.isUndefined(headers) && utils$1.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils$1.isFormData(data) ||
      utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$1.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils$1.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils$1.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$1.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$1.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults_1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge(target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$1.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$1.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils$1.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils$1.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$1.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$1.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils$1.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils$1.forEach(otherKeys, mergeDeepProperties);

  return config;
};

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios;

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken$2(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken$2.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken$2.source = function source() {
  var cancel;
  var token = new CancelToken$2(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken$2;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios_1.prototype, context);

  // Copy context to instance
  utils$1.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults_1);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios_1;

// Factory for creating new instances
axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

var axios_1 = axios$1;

// Allow use of default import syntax in TypeScript
var _default = axios$1;
axios_1.default = _default;

var axios = axios_1;

function _createSuper$H(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$H(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$H() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// const cancelAllPendingRequest = async (cb) => {
//     await source.cancel()
//     source = CancelToken.source()
//     cb()
// }

var SearchMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchMenu, _React$Component);

  var _super = _createSuper$H(SearchMenu);

  function SearchMenu(props) {
    var _this;

    _classCallCheck(this, SearchMenu);

    _this = _super.call(this, props);
    _this.state = {
      searchInput: '',
      lists: null,
      loading: true
    };
    _this.hostUrl = _this.props.hostUrl;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.clickList = _this.clickList.bind(_assertThisInitialized(_this));
    _this.getTheatresList = _.debounce(_this.getTheatresList, 800);
    return _this;
  }

  _createClass(SearchMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hostUrl = this.hostUrl;

      if (hostUrl) {
        this.getTheatresList();
      } else {
        this.setState({
          loading: false
        });
      }
    }
  }, {
    key: "getTheatresList",
    value: function getTheatresList() {
      var _this2 = this;

      var hostUrl = this.hostUrl;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(this.props.accessToken)
        }
      };
      var searchInput = this.state.searchInput;
      axios.get("".concat(hostUrl, "/v1/theatres/lists?q=").concat(searchInput.trim(), "&offset=0&ps=5&sortBy=accessed_on|desc"), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          _this2.setState({
            list: response.data.theatreLists,
            loading: false
          });
        }
      }).catch(function (error) {
        console.log(error);

        _this2.setState({
          error: true
        });
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var _this3 = this;

      this.setState({
        searchInput: e.target.value,
        loading: true
      }, function () {
        return _this3.getTheatresList();
      });
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this4 = this;

      var _this$state = this.state,
          list = _this$state.list,
          loading = _this$state.loading;

      if (list && list.length > 0) {
        return list.map(function (list) {
          return /*#__PURE__*/React__default.createElement("div", {
            key: list.id,
            disabled: _this4.state.loading,
            onClick: function onClick() {
              return !loading ? _this4.clickList(list) : '';
            },
            className: "theatre-list-view-item"
          }, list.name);
        });
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-view-empty"
      }, "No results found");
    }
  }, {
    key: "clickList",
    value: function clickList(list) {
      this.props.handleAddNewItem(list);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          searchInput = _this$state2.searchInput,
          loading = _this$state2.loading;
          _this$state2.list;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-selection-view"
      }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "input-search-container"
      }, /*#__PURE__*/React__default.createElement(InputBox, {
        placeholder: "Search for list",
        onTextChange: this.handleChange,
        value: searchInput,
        style: {
          height: 35
        }
      })), loading ? /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-render-view-loader"
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      })) : /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-render-view"
      }, this.renderList()), /*#__PURE__*/React__default.createElement("div", {
        className: "add-new-list-select-modal",
        onClick: this.props.addNewList
      }, "+ Create List")));
    }
  }]);

  return SearchMenu;
}(React__default.Component);

var DeleteModal = function DeleteModal(props) {
  var heading = props.heading,
      content = props.content,
      deleteText = props.deleteText,
      cancelText = props.cancelText,
      cancelFunction = props.cancelFunction,
      deleteFunction = props.deleteFunction,
      listPosting = props.listPosting;
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'delete-modal-overlay'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "delete-modal-layout"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "delete-modal-header"
  }, heading), /*#__PURE__*/React__default.createElement("div", {
    className: "delete-modal-content"
  }, content), /*#__PURE__*/React__default.createElement("div", {
    className: "delete-modal-footer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "cancel-button-view",
    onClick: function onClick() {
      return cancelFunction();
    }
  }, /*#__PURE__*/React__default.createElement(_Button, {
    type: "link"
  }, cancelText)), /*#__PURE__*/React__default.createElement("div", {
    className: "submit-button-view"
  }, /*#__PURE__*/React__default.createElement(_Button, {
    className: 'submit-button-confirm-text',
    loading: listPosting,
    onClick: function onClick() {
      return deleteFunction();
    }
  }, deleteText)))));
};

function _createSuper$G(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$G(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$G() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SelectedHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectedHeader, _React$Component);

  var _super = _createSuper$G(SelectedHeader);

  function SelectedHeader(props) {
    var _this;

    _classCallCheck(this, SelectedHeader);

    _this = _super.call(this, props);
    _this.state = {
      showList: false,
      showOptions: false,
      isOpenDeleteModal: false
    };
    _this.openList = _this.openList.bind(_assertThisInitialized(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    _this.addToItem = _this.addToItem.bind(_assertThisInitialized(_this));
    _this.confirmClearList = _this.confirmClearList.bind(_assertThisInitialized(_this));
    _this.handleModalClose = _this.handleModalClose.bind(_assertThisInitialized(_this));
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SelectedHeader, [{
    key: "openList",
    value: function openList() {
      this.setState({
        showList: !this.state.showList,
        showOptions: false
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      var _this2 = this;

      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.setState({
          showList: false
        }, function () {
          return _this2.forceUpdate();
        });
      }

      if (this.wrapperOptionRef && !this.wrapperOptionRef.contains(event.target)) {
        if (!event.target.closest('.theatre-selection-dropdown')) {
          this.setState({
            showOptions: false
          }, function () {
            return _this2.forceUpdate();
          });
        }
      }

      if (this.modalWrapperRef && !this.modalWrapperRef.contains(event.target)) {
        this.setState({
          isOpenDeleteModal: false
        });
      }
    }
  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      if (node) {
        this.wrapperRef = node;
      }
    }
  }, {
    key: "setWrapperOptionRef",
    value: function setWrapperOptionRef(node) {
      if (node) {
        this.wrapperOptionRef = node;
      }
    }
  }, {
    key: "setModalWrapperRef",
    value: function setModalWrapperRef(node) {
      if (node) {
        this.modalWrapperRef = node;
      }
    }
  }, {
    key: "handleAddToNewItem",
    value: function handleAddToNewItem() {
      this.setState({
        showList: false
      });
      this.props.handleAddToNewItem();
    }
  }, {
    key: "addToItem",
    value: function addToItem(list) {
      this.props.addToItem(list);
      this.setState({
        showList: !this.state.showList
      });
    }
  }, {
    key: "addNewList",
    value: function addNewList() {
      var _this3 = this;

      this.setState({
        showList: !this.state.showList
      }, function () {
        return _this3.props.handleAddToNewItem();
      });
    }
  }, {
    key: "confirmClearList",
    value: function confirmClearList() {
      this.setState({
        showOptions: false,
        isOpenDeleteModal: true
      });
    }
  }, {
    key: "openOptions",
    value: function openOptions() {
      this.setState({
        showOptions: !this.state.showOptions
      });
    }
  }, {
    key: "changeView",
    value: function changeView() {
      this.props.onChangeView();
    }
  }, {
    key: "handleModalClose",
    value: function handleModalClose() {
      this.setState({
        isOpenDeleteModal: false
      });
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      this.props.clearTheatreList();
      this.setState({
        isOpenDeleteModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          title = _this$props.title,
          areTheatresSelected = _this$props.areTheatresSelected;
          _this$props.addToList;
          var hasList = _this$props.hasList;
      var _this$state = this.state,
          showList = _this$state.showList,
          showOptions = _this$state.showOptions,
          isOpenDeleteModal = _this$state.isOpenDeleteModal;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-selected-view-header"
      }, /*#__PURE__*/React__default.createElement(HeaderText, {
        text: title
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-options"
      }, areTheatresSelected && /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-add-to-list"
      }, hasList && /*#__PURE__*/React__default.createElement("div", {
        className: "option-button-view"
      }, /*#__PURE__*/React__default.createElement(_Button, {
        type: "link",
        onClick: this.openList
      }, "Add to List")), /*#__PURE__*/React__default.createElement("div", {
        className: "option-button-view"
      }, /*#__PURE__*/React__default.createElement(_Button, {
        type: "link",
        onClick: this.confirmClearList
      }, "Clear")), showList && /*#__PURE__*/React__default.createElement("div", {
        className: "add-to-list-search-menu",
        ref: function ref(node) {
          return _this4.setWrapperRef(node);
        }
      }, /*#__PURE__*/React__default.createElement(SearchMenu, {
        hostUrl: this.props.hostUrl,
        accessToken: this.props.accessToken,
        handleAddNewItem: this.addToItem,
        addNewList: function addNewList() {
          return _this4.addNewList();
        }
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-back-button"
      }, /*#__PURE__*/React__default.createElement(SelectButton, {
        clickEvent: function clickEvent() {
          return _this4.changeView();
        },
        text: "Back"
      }), areTheatresSelected && /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-selection-dropdown",
        onClick: function onClick() {
          return _this4.openOptions();
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-back-button-bullet"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-back-button-bullet"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "selected-view-back-button-bullet"
      })), showOptions && /*#__PURE__*/React__default.createElement("div", {
        id: "more-selection-options",
        className: "selected-view-options",
        ref: function ref(node) {
          return _this4.setWrapperOptionRef(node);
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return _this4.openList();
        }
      }, "Add To List"), /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return _this4.confirmClearList();
        }
      }, "Clear")))), isOpenDeleteModal && /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(node) {
          return _this4.setModalWrapperRef(node);
        }
      }, /*#__PURE__*/React__default.createElement(DeleteModal, {
        deleteFunction: this.handleClear,
        cancelFunction: this.handleModalClose,
        heading: "Clear theatre selection",
        content: "Are you sure you want to clear the selection?",
        cancelText: "No, Keep the selection",
        deleteText: "Yes, Clear"
      })));
    }
  }]);

  return SelectedHeader;
}(React__default.Component);

function _createSuper$F(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$F(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$F() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaultTabs = /*#__PURE__*/function (_Component) {
  _inherits(DefaultTabs, _Component);

  var _super = _createSuper$F(DefaultTabs);

  function DefaultTabs(props) {
    var _this;

    _classCallCheck(this, DefaultTabs);

    _this = _super.call(this, props);
    _this.state = {
      selectedTab: _this.props.selectedTab
    };
    return _this;
  }

  _createClass(DefaultTabs, [{
    key: "handleTabChange",
    value: function handleTabChange(tab) {
      this.setState({
        selectedTab: tab
      });
      this.props.onTabChange(tab);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectedTab = this.state.selectedTab;
      var tabsDetail = this.props.tabsDetail;
      return /*#__PURE__*/React__default.createElement("ul", {
        className: "tabs-list"
      }, tabsDetail.map(function (tab, index) {
        return /*#__PURE__*/React__default.createElement("li", {
          className: selectedTab === tab.tabId ? 'tab-item active' : 'tab-item',
          onClick: function onClick() {
            return _this2.handleTabChange(tab.tabId);
          },
          key: tab.tabId
        }, /*#__PURE__*/React__default.createElement("span", {
          title: tab.tabName
        }, tab.tabName));
      }));
    }
  }]);

  return DefaultTabs;
}(Component);

function _createSuper$E(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$E(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$E() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaultTable = /*#__PURE__*/function (_Component) {
  _inherits(DefaultTable, _Component);

  var _super = _createSuper$E(DefaultTable);

  function DefaultTable() {
    _classCallCheck(this, DefaultTable);

    return _super.apply(this, arguments);
  }

  _createClass(DefaultTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columns = _this$props.columns,
          rows = _this$props.rows,
          fetchingData = _this$props.fetchingData;
      return /*#__PURE__*/React__default.createElement(_Table, {
        columns: columns,
        dataSource: rows,
        size: "middle",
        bordered: true,
        pagination: false,
        locale: {
          emptyText: fetchingData ? '' : 'No Data Found'
        },
        loading: fetchingData,
        scroll: {
          x: 1024
        }
      });
    }
  }]);

  return DefaultTable;
}(Component);

function _createSuper$D(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$D(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$D() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SaveTagModal = /*#__PURE__*/function (_Component) {
  _inherits(SaveTagModal, _Component);

  var _super = _createSuper$D(SaveTagModal);

  function SaveTagModal(props) {
    var _this;

    _classCallCheck(this, SaveTagModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (event) {
      _this.setState(_defineProperty({}, event.target.name, event.target.value));
    });

    _defineProperty(_assertThisInitialized(_this), "handleSave", function () {
      _this.props.handleSubmit(_this.state.tagName);
    });

    _this.state = {
      tagName: _this.props.tagName
    };
    return _this;
  }

  _createClass(SaveTagModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.input.focus();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          title = _this$props.title,
          visible = _this$props.visible,
          loading = _this$props.loading,
          submitBtnName = _this$props.submitBtnName,
          hasErrorMessage = _this$props.hasErrorMessage;
      var tagName = this.state.tagName;
      return /*#__PURE__*/React__default.createElement(_Modal, {
        title: title,
        wrapClassName: "vertical-center-modal modal-medium",
        visible: visible,
        onCancel: this.props.handleCancel,
        footer: [/*#__PURE__*/React__default.createElement(_Button, {
          key: "back",
          size: "large",
          onClick: this.props.handleCancel,
          disabled: loading,
          className: "cancel-btn"
        }, "Cancel"), /*#__PURE__*/React__default.createElement(_Button, {
          key: "submit",
          type: "primary",
          size: "large",
          loading: loading,
          onClick: this.handleSave,
          disabled: tagName.length > 50 || tagName.length < 1
        }, submitBtnName)]
      }, /*#__PURE__*/React__default.createElement(InputLabel, {
        content: "Tag Name"
      }), /*#__PURE__*/React__default.createElement(_Input, {
        size: "large",
        placeholder: "Enter Tag Name",
        value: tagName,
        name: "tagName",
        onChange: this.handleInputChange,
        autoComplete: "off",
        ref: function ref(node) {
          return _this3.input = node;
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "input-meta__data"
      }, hasErrorMessage && /*#__PURE__*/React__default.createElement(HelpText, {
        isErrorMessage: true,
        content: hasErrorMessage
      }), tagName.length > 50 && /*#__PURE__*/React__default.createElement(HelpText, {
        isErrorMessage: true,
        content: "Tag name should be less than 50 characters"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "character-count"
      }, tagName.length, "/50")));
    }
  }]);

  return SaveTagModal;
}(Component);

SaveTagModal.defaultProps = {
  title: "Create Modal",
  tagName: "",
  loading: false,
  submitBtnName: "Submit",
  visible: false,
  hasErrorMessage: "",
  handleSubmit: function handleSubmit() {},
  handleCancel: function handleCancel() {}
};

function _createSuper$C(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$C(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$C() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Option$1 = _Select.Option;

var TagsDropdownMenu = /*#__PURE__*/function (_Component) {
  _inherits(TagsDropdownMenu, _Component);

  var _super = _createSuper$C(TagsDropdownMenu);

  function TagsDropdownMenu(props) {
    var _this;

    _classCallCheck(this, TagsDropdownMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      _this.setState({
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSaveTags", function () {
      var tagsListData = _this.props.tagsListData;
      var tagsTobeSaved = [];

      if (tagsListData.companyTags) {
        tagsTobeSaved = _this.state.value.map(function (tagname) {
          return tagsListData.companyTags.find(function (tag) {
            return tag.name === tagname;
          }).id;
        });
      }

      _this.props.saveMappedTags(tagsTobeSaved);
    });

    _this.state = {
      value: _this.props.cplTags.map(function (tag) {
        return tag.name;
      }),
      menuItems: []
    };
    _this.setWrapperRef = _this.setWrapperRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TagsDropdownMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.tagsListData.fetchingData && this.props.tagsListData.companyTags) {
        var tagsList = this.props.tagsListData.companyTags.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        var menuItems = tagsList.map(function (tag) {
          return {
            text: "".concat(tag.name),
            value: tag.name
          };
        });
        this.setState({
          menuItems: menuItems
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isEdit = _this$props.isEdit,
          tagsListData = _this$props.tagsListData,
          mappingTagsStatus = _this$props.mappingTagsStatus;
      var _this$state = this.state,
          value = _this$state.value,
          menuItems = _this$state.menuItems;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-menu__tags"
      }, value.length < 1 && /*#__PURE__*/React__default.createElement("div", {
        className: "search-icon"
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "search",
        size: "20"
      })), /*#__PURE__*/React__default.createElement(_Select, {
        autoFocus: true,
        mode: "multiple",
        className: "tags-select",
        placeholder: "Search & Add Tags",
        value: value,
        showAction: ['focus', 'click'],
        onChange: this.handleChange,
        getPopupContainer: function getPopupContainer() {
          return document.getElementById('tags-dropdown');
        },
        filterOption: function filterOption(inputValue, option) {
          return option.props.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
        },
        notFoundContent: tagsListData.fetchingData ? /*#__PURE__*/React__default.createElement(_Spin, {
          size: "small"
        }) : /*#__PURE__*/React__default.createElement("div", {
          className: "empty-tags__message"
        }, "No Tags Found. Click", ' ', /*#__PURE__*/React__default.createElement("span", {
          className: "empty-tag__click ",
          onClick: this.props.manageTags
        }, "here"), ' ', "to create one")
      }, menuItems.map(function (item) {
        return /*#__PURE__*/React__default.createElement(Option$1, {
          key: item.text,
          value: item.value
        }, item.text);
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-menu__tagslist",
        id: "tags-dropdown",
        ref: this.setWrapperRef
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-menu__tagsfooter"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "btn-container"
      }, /*#__PURE__*/React__default.createElement(_Button, {
        key: "manage",
        size: "small",
        disabled: mappingTagsStatus,
        className: "link-btn",
        onClick: this.props.manageTags
      }, "Manage")), /*#__PURE__*/React__default.createElement("div", {
        className: "btn-container"
      }, /*#__PURE__*/React__default.createElement(_Button, {
        key: "manage",
        size: "small",
        disabled: mappingTagsStatus,
        className: "cancel-btn",
        onClick: this.props.closeDropdownMenu
      }, "Cancel"), /*#__PURE__*/React__default.createElement(_Button, {
        key: "update",
        type: "primary",
        size: "small",
        disabled: !isEdit && value.length < 1,
        loading: mappingTagsStatus,
        onClick: this.handleSaveTags
      }, isEdit ? 'Update' : 'Add'))));
    }
  }]);

  return TagsDropdownMenu;
}(Component);

TagsDropdownMenu.defaultProps = {
  isEdit: false,
  tagsListData: {},
  cplTags: [],
  saveMappedTags: function saveMappedTags() {},
  manageTags: function manageTags() {}
};

function _createSuper$B(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$B(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$B() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MapTagsDropdown = /*#__PURE__*/function (_Component) {
  _inherits(MapTagsDropdown, _Component);

  var _super = _createSuper$B(MapTagsDropdown);

  function MapTagsDropdown() {
    var _this;

    _classCallCheck(this, MapTagsDropdown);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleVisibleChange", function (flag) {
      _this.setState({
        visible: flag
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeDropdownMenu", function () {
      _this.setState({
        visible: false
      });
    });

    _this.state = {
      visible: false
    };
    return _this;
  }

  _createClass(MapTagsDropdown, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.mappingTagsStatus === true && nextProps.mappingTagsStatus === false && this.state.visible === true) {
        this.setState({
          visible: false
        });
      }
    }
  }, {
    key: "renderDropdownOptions",
    value: function renderDropdownOptions() {
      if (this.state.visible) {
        return /*#__PURE__*/React__default.createElement(TagsDropdownMenu, {
          isEdit: this.props.isEdit,
          closeDropdownMenu: this.closeDropdownMenu,
          tagsListData: this.props.tagsListData,
          cplTags: this.props.cplTags,
          saveMappedTags: this.props.saveMappedTags,
          manageTags: this.props.manageTags,
          mappingTagsStatus: this.props.mappingTagsStatus
        });
      } else {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "empty-menu"
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isEdit = _this$props.isEdit,
          inlineDropdown = _this$props.inlineDropdown,
          compositionType = _this$props.compositionType;
      return /*#__PURE__*/React__default.createElement(_Dropdown, {
        overlay: this.renderDropdownOptions(),
        trigger: ["click"],
        onVisibleChange: this.handleVisibleChange,
        visible: this.state.visible
      }, /*#__PURE__*/React__default.createElement("div", {
        className: inlineDropdown ? "map-tags__dropdown__layout inline-dropdown" : "map-tags__dropdown__layout"
      }, isEdit ? /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "edit",
        size: "16"
      }) : /*#__PURE__*/React__default.createElement("i", {
        className: "add-tag"
      }, "+ ", !compositionType && /*#__PURE__*/React__default.createElement("span", {
        className: "add-text"
      }, "Add Tags"))));
    }
  }]);

  return MapTagsDropdown;
}(Component);

MapTagsDropdown.defaultProps = {
  isEdit: false,
  tagsListData: {},
  cplTags: [],
  saveMappedTags: function saveMappedTags() {},
  manageTags: function manageTags() {},
  compositionType: ''
};

function _createSuper$A(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$A(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$A() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CompositionCardTags = /*#__PURE__*/function (_Component) {
  _inherits(CompositionCardTags, _Component);

  var _super = _createSuper$A(CompositionCardTags);

  function CompositionCardTags() {
    var _this;

    _classCallCheck(this, CompositionCardTags);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (value, type) {
      if (type !== "ratings" && !_this.props.readOnly) {
        if (_this.props.removeFilterTag) {
          _this.props.removeFilterTag(_this.props.filterPosition);
        } else {
          var tag = type.trim() + ": " + value.trim();

          _this.props.filterBytags(tag);
        }
      }
    });

    return _this;
  }

  _createClass(CompositionCardTags, [{
    key: "renderTag",
    value: function renderTag(tagName, tagValue, id) {
      var _this2 = this;

      var _this$props = this.props,
          readOnly = _this$props.readOnly,
          canMapTags = _this$props.canMapTags,
          tagsListData = _this$props.tagsListData,
          mappingTagsStatus = _this$props.mappingTagsStatus;

      switch (tagName) {
        case "type":
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(DefaultTag, {
              content: tagValue,
              tagType: tagName,
              tagTypeDisplayName: "type",
              readOnly: readOnly,
              handleOnClick: this.handleOnClick,
              key: id
            });
          }

          break;

        case "resolution":
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(DefaultTag, {
              content: tagValue,
              tagType: tagName,
              tagTypeDisplayName: "resolution",
              readOnly: readOnly,
              handleOnClick: this.handleOnClick,
              key: id
            });
          }

          break;

        case "stereoType":
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(DefaultTag, {
              content: tagValue,
              tagType: tagName,
              tagTypeDisplayName: "format",
              readOnly: readOnly,
              handleOnClick: this.handleOnClick,
              key: id
            });
          }

          break;

        case "aspectRatio":
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(DefaultTag, {
              content: tagValue,
              tagType: tagName,
              tagTypeDisplayName: "aspect",
              readOnly: readOnly,
              handleOnClick: this.handleOnClick,
              key: id
            });
          }

          break;

        case "language":
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(DefaultTag, {
              content: tagValue,
              tagType: tagName,
              tagTypeDisplayName: "language",
              readOnly: readOnly,
              handleOnClick: this.handleOnClick,
              tagIconName: "audio",
              key: id
            });
          }

          break;

        case "subtitleLanguage":
          if (tagValue) {
            return /*#__PURE__*/React__default.createElement(DefaultTag, {
              content: tagValue,
              tagType: tagName,
              tagTypeDisplayName: "subtitle",
              readOnly: readOnly,
              handleOnClick: this.handleOnClick,
              tagIconName: "subtitle",
              key: id
            });
          }

          break;

        case "audioFormats":
          if (tagValue && tagValue.length > 0) {
            var _listOfTags = tagValue.map(function (item, index) {
              return /*#__PURE__*/React__default.createElement(DefaultTag, {
                content: item,
                tagType: tagName,
                tagTypeDisplayName: "audio",
                readOnly: readOnly,
                handleOnClick: _this2.handleOnClick,
                key: index
              });
            });

            return _listOfTags;
          }

          break;

        case "closedCaptions":
          if (tagValue && tagValue.length > 0) {
            var _listOfTags2 = tagValue.map(function (item, index) {
              return /*#__PURE__*/React__default.createElement(DefaultTag, {
                content: item,
                tagType: tagName,
                tagTypeDisplayName: "captions",
                readOnly: readOnly,
                handleOnClick: _this2.handleOnClick,
                tagIconName: "captions",
                key: index
              });
            });

            return _listOfTags2;
          }

          break;

        case "mappedTags":
          var listOfTags = [];

          if (tagValue && tagValue.length > 0) {
            var cplTags = tagValue.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            });
            listOfTags = cplTags.map(function (item, index) {
              return /*#__PURE__*/React__default.createElement(DefaultTag, {
                content: item.name,
                tagType: tagName,
                tagTypeDisplayName: "tag",
                readOnly: readOnly,
                handleOnClick: _this2.handleOnClick,
                key: index
              });
            });

            if (canMapTags) {
              listOfTags.push( /*#__PURE__*/React__default.createElement(MapTagsDropdown, {
                isEdit: true,
                tagsListData: tagsListData,
                saveMappedTags: this.props.saveMappedTags,
                manageTags: this.props.manageTags,
                key: "maptags",
                cplTags: cplTags,
                mappingTagsStatus: mappingTagsStatus,
                compositionType: this.props.composition.type
              }));
            }

            return listOfTags;
          } else if (canMapTags) {
            listOfTags.push( /*#__PURE__*/React__default.createElement(MapTagsDropdown, {
              isEdit: false,
              tagsListData: tagsListData,
              saveMappedTags: this.props.saveMappedTags,
              manageTags: this.props.manageTags,
              key: "maptags",
              mappingTagsStatus: mappingTagsStatus,
              compositionType: this.props.composition.type
            }));
            return listOfTags;
          }

          break;

        case "ratings":
          var ratings = tagValue;

          if (ratings && ratings.length > 0) {
            if (ratings.length === 1) {
              return /*#__PURE__*/React__default.createElement("div", {
                className: "tag-container withTagIcon no-cursor"
              }, /*#__PURE__*/React__default.createElement("span", {
                className: "tag-icon"
              }, /*#__PURE__*/React__default.createElement(AppIcon, {
                name: "certifications",
                size: "16"
              })), /*#__PURE__*/React__default.createElement("span", {
                className: "tag-content"
              }, this._renderRating(ratings[0].name)));
            } else {
              return this.renderRatingsMenu(ratings.sort());
            }
          }

          break;
      }
    }
  }, {
    key: "_renderRating",
    value: function _renderRating(name) {
      return name ? name : "None";
    }
  }, {
    key: "renderAgencyAndRating",
    value: function renderAgencyAndRating(rating) {
      var value;

      if (rating.agency && rating.agency.name) {
        value = "".concat(rating.agency.name, ", ").concat(this._renderRating(rating.name));
      } else {
        value = "Unknown agency".concat(", ", this._renderRating(rating.name));
      }

      return value;
    }
  }, {
    key: "renderRatingsSubmenu",
    value: function renderRatingsSubmenu(ratings) {
      var _this3 = this;

      return /*#__PURE__*/React__default.createElement(_Menu, {
        className: "ratings-dropdown"
      }, ratings.map(function (rating, index) {
        return /*#__PURE__*/React__default.createElement(_Menu.Item, {
          key: index
        }, _this3.renderAgencyAndRating(rating));
      }));
    }
  }, {
    key: "renderRatingsMenu",
    value: function renderRatingsMenu(ratings) {
      return /*#__PURE__*/React__default.createElement(_Dropdown, {
        overlay: this.renderRatingsSubmenu(ratings),
        trigger: ["click"]
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "tag-container withTagIcon"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "tag-icon"
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "certifications",
        size: "16"
      })), /*#__PURE__*/React__default.createElement("span", {
        className: "tag-content"
      }, this._renderRating(ratings[0].name) + " ...")));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var composition = this.props.composition;
      var tagsDetails = {
        type: composition.type,
        resolution: composition.resolution,
        stereoType: composition.stereoType,
        aspectRatio: composition.aspectRatio,
        audioFormats: composition.audioFormats,
        language: composition.language,
        subtitleLanguage: composition.subtitleLanguage,
        closedCaptions: composition.closedCaptions,
        ratings: composition.ratings,
        mappedTags: composition.tags
      };
      return /*#__PURE__*/React__default.createElement("div", {
        className: "tags-container"
      }, Object.keys(tagsDetails).map(function (tag, id) {
        return _this4.renderTag(tag, tagsDetails[tag], id);
      }));
    }
  }]);

  return CompositionCardTags;
}(Component);

CompositionCardTags.defaultProps = {
  filterBytags: function filterBytags() {},
  canMapTags: false,
  tagsListData: {},
  saveMappedTags: function saveMappedTags() {},
  manageTags: function manageTags() {},
  mappingTagsStatus: false
};

var moment = createCommonjsModule(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
});

function formatDuration(duration) {
  var formatted = moment.utc(moment.duration(parseFloat(duration), 's').asMilliseconds()).format('HH:mm:ss');

  if (formatted.length === 5) {
    formatted = "00:".concat(formatted);
  }

  if (formatted.length === 2) {
    formatted = "00:00:".concat(formatted);
  }

  return formatted;
}
function formatDateTime(momentObj) {
  return momentObj.format('DD MMM YYYY hh:mm A');
}

var MARKERS = ['FFEC', 'FFMC'];
var KDMStatuses = {
  success: 'success',
  emailed: 'emailed',
  inprogress: 'inprogress',
  failed: 'failed',
  generated: 'generated',
  unavailable: 'unavailable',
  inProgress: 'inProgress',
  expired: 'expired',
  expiring: 'expiring'
};
var IngestStatuses = {
  pendingingest: 'PendingIngest',
  ingestinprogress: 'IngestInProgress',
  ingestfailed: 'IngestFailed',
  ingestcancelled: 'IngestCancelled',
  ingested: 'Ingested'
};
var IngestStatusValues = {
  pendingingest: 'Pending Ingest',
  ingestinprogress: 'Ingest in Progress',
  ingestfailed: 'Ingest Failed',
  ingestcancelled: 'Ingest Cancelled',
  ingested: 'Ingested'
};
var ShipmentStatusValues = {
  Pending: 'Pending',
  InfoReceived: 'In Transit',
  InTransit: 'In Transit',
  OutForDelivery: 'Out For Delivery',
  AttemptFail: 'Delivery Attempt Failed',
  Delivered: 'Delivered',
  Exception: 'Delivery Exception',
  Expired: 'Expired'
};
var ShipmentStatuses = {
  Pending: 'Pending',
  InfoReceived: 'InfoReceived',
  InTransit: 'InTransit',
  OutForDelivery: 'OutForDelivery',
  AttemptFail: 'AttemptFail',
  Delivered: 'Delivered',
  Exception: 'Exception',
  Expired: 'Expired'
};
var DCPStatuses = {
  dispatched: 'dispatched',
  executing: 'executing',
  queued: 'queued',
  failed: 'failed',
  error: 'error',
  succeeded: 'succeeded',
  cancelled: 'cancelled',
  scheduled: 'scheduled',
  downloading: 'downloading',
  downloaded: 'downloaded',
  expired: 'expired',
  pending: 'pending',
  delivered: 'delivered',
  pending_cancellation: 'pending_cancellation',
  unarchiving: 'unarchiving',
  archived: 'archived',
  stalled: 'stalled'
};
var DCPStatusValues = {
  downloaded: 'Downloaded',
  pending: 'Pending',
  cancelled: 'Cancelled',
  dispatched: 'Shipped',
  pending_cancellation: 'Pending Cancellation',
  queued: 'Queued',
  failed: 'Failed',
  error: 'Failed',
  succeeded: 'Succeeded',
  executing: 'Downloading...',
  scheduled: 'Scheduled for Download',
  downloading: 'Downloading...',
  expired: 'Failed',
  intransit: 'In Transit',
  outfordelivery: 'Out For Delivery',
  attemptfail: 'Delivery AttemptFail',
  delivered: 'Delivered',
  exception: 'Delivery Exception',
  unarchiving: 'Unarchiving',
  archived: 'Archived',
  stalled: 'Stalled'
};
var ApplianceColumn = {
  serialNo: 'Serial No',
  theatres: 'Theatres',
  chain: 'Chain',
  bandwidth: 'Bandwidth',
  publicIP: 'Public IP',
  osVersion: 'OS Version',
  downloadStatus: 'Download Status',
  status: 'Status'
};
var MatchedBy = {
  screenId: 'Screen ID',
  theatreDetails: 'Theatre Details',
  theatreId: 'Theatre ID'
};
var WorkOrderStatuses = {
  ASSIGNED: 'assigned',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled'
};
var WorkOrderStatusLabel = {
  assigned: 'Assigned',
  approved: 'Approved',
  rejected: 'Rejected',
  cancelled: 'Cancelled'
};
var DcpUploadStatuses = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  NOT_STARTED: 'not_started'
};
var DcpTransferStatuses = {
  STARTED: 'started',
  COMPLETED: 'completed'
};
var WorkOrderItemsFilterValues = {
  ARCHIVE: 'archive',
  ACTIVE: 'active',
  CURRENT: 'current',
  PAST: 'past'
};
var WorkOrderItemsFilterTagKeys = {
  BOOKING: 'booking',
  PARTNER: 'partner',
  WORK_ORDER: 'workorder',
  COMPOSITION: 'composition'
};
var DcpTransferStatusOptions = [{
  name: 'Started',
  type: DcpTransferStatuses.STARTED
}, {
  name: 'Completed',
  type: DcpTransferStatuses.COMPLETED
}];
var PartnerTypeKeys = {
  MANUAL: 'Manual',
  OFFLINE: 'Offline'
};
var PartnerTypes = {
  MANUAL: 'Manual',
  OFFLINE: 'Offline',
  ONLINE: 'Online'
};
var DcpDownloadStatuses = {
  NOT_STARTED: 'not_started',
  QUEUED: 'queued',
  IN_PROGRESS: 'in_progress',
  DOWNLOADING: 'downloading',
  COMPLETED: 'completed',
  FAILED: 'failed',
  DOWNLOADED: 'downloaded',
  EXPIRED: 'expired',
  SCHEDULED: 'scheduled',
  PENDING: 'pending',
  ERROR: 'error',
  UNARCHIVING: 'unarchiving',
  ARCHIVED: 'archived',
  STALLED: 'stalled'
};
var ShippingStatus = {
  PENDING: 'pending',
  DISPATCHED: 'dispatched',
  CANCELLED: 'cancelled',
  PENDING_CANCELLATION: 'pending_cancellation',
  REJECTED: 'rejected'
};
var FilterLabels = {
  chain: 'Chain',
  ipAddress: 'IP Address',
  theatre: 'Theatre',
  city: 'City',
  province: 'Province',
  country: 'Country',
  serialNumber: 'Serial Number',
  osVersion: 'OS Version',
  status: 'Appliance Status'
};
var FilterTypes = {
  chain: 'chain',
  ipAddress: 'ipAddress',
  theatre: 'theatre',
  city: 'city',
  province: 'province',
  country: 'country',
  serialNumber: 'serialNumber',
  osVersion: 'osVersion',
  status: 'status'
};
var ComponentTypes = {
  list: 'List',
  multiselect: 'MultiSelect'
};
var WorkOrderTagList = {
  BOOKING: 'booking',
  PARTNER: 'partner',
  WORK_ORDER: 'workorder',
  COMPOSITION: 'composition'
};
var WorkOrderDeliveryType = {
  HARD_DRIVE: 'HARD_DRIVE',
  SATELLITE: 'SATELLITE',
  INTERNET: 'INTERNET'
};
var WorkOrderDeliveryLabel = {
  HARD_DRIVE: 'Hard Drive',
  SATELLITE: 'Satellite',
  INTERNET: 'Internet'
};
var WorkOrderTypes = {
  CURRENT: 'current',
  PAST: 'past'
};

var enums = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MARKERS: MARKERS,
  KDMStatuses: KDMStatuses,
  IngestStatuses: IngestStatuses,
  IngestStatusValues: IngestStatusValues,
  ShipmentStatusValues: ShipmentStatusValues,
  ShipmentStatuses: ShipmentStatuses,
  DCPStatuses: DCPStatuses,
  DCPStatusValues: DCPStatusValues,
  ApplianceColumn: ApplianceColumn,
  MatchedBy: MatchedBy,
  WorkOrderStatuses: WorkOrderStatuses,
  WorkOrderStatusLabel: WorkOrderStatusLabel,
  DcpUploadStatuses: DcpUploadStatuses,
  DcpTransferStatuses: DcpTransferStatuses,
  WorkOrderItemsFilterValues: WorkOrderItemsFilterValues,
  WorkOrderItemsFilterTagKeys: WorkOrderItemsFilterTagKeys,
  DcpTransferStatusOptions: DcpTransferStatusOptions,
  PartnerTypeKeys: PartnerTypeKeys,
  PartnerTypes: PartnerTypes,
  DcpDownloadStatuses: DcpDownloadStatuses,
  ShippingStatus: ShippingStatus,
  FilterLabels: FilterLabels,
  FilterTypes: FilterTypes,
  ComponentTypes: ComponentTypes,
  WorkOrderTagList: WorkOrderTagList,
  WorkOrderDeliveryType: WorkOrderDeliveryType,
  WorkOrderDeliveryLabel: WorkOrderDeliveryLabel,
  WorkOrderTypes: WorkOrderTypes
});

function _createSuper$z(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$z(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$z() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var cplTypes = {
  "tran'l": 'Transitional',
  advert: 'Advertisement'
};

var CompositionInfoModal = /*#__PURE__*/function (_Component) {
  _inherits(CompositionInfoModal, _Component);

  var _super = _createSuper$z(CompositionInfoModal);

  function CompositionInfoModal(props) {
    _classCallCheck(this, CompositionInfoModal);

    return _super.call(this, props);
  }

  _createClass(CompositionInfoModal, [{
    key: "renderRatings",
    value: function renderRatings() {
      var composition = this.props.composition;
      var nodes = composition.ratings.map(function (rating) {
        if (rating.agency && rating.agency.name) {
          return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
            title: rating.agency.uri
          }, rating.agency.name), ' ', rating.country.code, ' ', ",", rating.name);
        }

        if (rating.agency && rating.agency.uri) {
          return /*#__PURE__*/React__default.createElement("div", {
            title: rating.agency.uri
          }, "Unknown agency,", rating.name);
        }
      });
      return nodes;
    }
  }, {
    key: "renderAudioFormat",
    value: function renderAudioFormat() {
      var composition = this.props.composition;
      var format = '';

      if (composition.audioFormats.indexOf('Atmos') !== -1) {
        format = 'Atmos';
      } else {
        format = composition.audioFormats.join(', ');
      }

      format = composition.hearingImpaired ? format.concat(', HI') : format;
      format = composition.visuallyImpaired ? format.concat(', VI') : format;
      return /*#__PURE__*/React__default.createElement("span", null, format);
    }
  }, {
    key: "renderMarkers",
    value: function renderMarkers() {
      var _this$props$compositi = this.props.composition,
          _this$props$compositi2 = _this$props$compositi.markers,
          markers = _this$props$compositi2 === void 0 ? [] : _this$props$compositi2,
          duration = _this$props$compositi.duration;
      var nodes = [];
      var markerNodes = [];
      var processedMarkers = [];

      if (markers) {
        MARKERS.map(function (marker) {
          var data = markers.filter(function (markerItem) {
            return markerItem.label == marker;
          })[0];

          if (data) {
            markerNodes.push( /*#__PURE__*/React__default.createElement("div", {
              className: "modal-block__description",
              key: marker
            }, marker, ' ', "-", formatDuration(data.value), ' ', "(-", formatDuration(parseFloat(duration) - parseInt(data.value)), ")"));
            processedMarkers.push(marker);
          }
        });
        nodes.push(markerNodes);
      }

      if (!markerNodes.length) {
        nodes.push( /*#__PURE__*/React__default.createElement("div", {
          className: "modal-block__description no-mg",
          key: "none"
        }, "None"));
      }

      if ((!nodes.length || MARKERS.length != processedMarkers.length) && this.props.showAddMarker && this.props.addMarkerRender) {
        nodes.push( /*#__PURE__*/React__default.createElement("div", {
          className: "composition-modal-info-overview"
        }, this.props.addMarkerRender));
      }

      return nodes;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          visible = _this$props.visible,
          composition = _this$props.composition,
          modalClassName = _this$props.modalClassName;
      var nullDefault;
      var compositionTags;

      if (composition) {
        nullDefault = composition.type ? 'None' : 'Unknown';
        compositionTags = {
          tags: composition.tags
        };
      }

      return /*#__PURE__*/React__default.createElement(_Modal, {
        title: "Composition Details",
        wrapClassName: classNames('vertical-center-modal modal-large', modalClassName),
        visible: visible,
        onCancel: this.props.handleCancel,
        footer: null
      }, composition && /*#__PURE__*/React__default.createElement("div", {
        className: "compositoinDetails"
      }, composition.name && /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block fullwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__header"
      }, composition.name), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, composition.id))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Duration"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.duration ? formatDuration(composition.duration) : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Type"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.type ? cplTypes[composition.type.toLowerCase()] || composition.type : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Format"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.stereoType ? composition.stereoType : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Aspect Ratio"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.aspectRatio ? composition.aspectRatio : nullDefault))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Frame Rate"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.frameRate ? composition.frameRate : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "CPL Format"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.cplFormat ? composition.cplFormat === 'smpte' ? composition.cplFormat.toUpperCase() : composition.cplFormat : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Spoken Language"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.language ? composition.language : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Subtitle Language"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.subtitleLanguage ? composition.subtitleLanguage : nullDefault))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Closed Captions"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.closedCaptions && composition.closedCaptions.length > 0 ? composition.closedCaptions.join(', ') : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Main Captions"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.mainCaption ? composition.mainCaption : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Closed Subtitles"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.closedSubtitles && composition.closedSubtitles.length > 0 ? composition.closedSubtitles.join(', ') : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "CPL Metadata"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.hasMetadata ? 'Yes' : 'No'))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Ratings"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.ratings && composition.ratings.length > 0 ? this.renderRatings() : nullDefault))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block fullwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "CPL Markers"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__markers"
      }, this.renderMarkers()))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block fullwidth sm-pd__b"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title sm-mg__b"
      }, "Tags"), compositionTags.tags && compositionTags.tags.length > 0 ? /*#__PURE__*/React__default.createElement(CompositionCardTags, {
        composition: compositionTags,
        readOnly: true
      }) : /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, nullDefault))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block fullwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__link"
      }, "Data from Composition name based on the", ' ', /*#__PURE__*/React__default.createElement("a", {
        target: "_blank",
        href: "http://isdcf.com/dcnc/"
      }, "Digital Cinema Naming Convention")))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Resolution"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.resolution ? composition.resolution : nullDefault)), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Audio Format"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, composition.audioFormats && composition.audioFormats.length > 0 ? this.renderAudioFormat() : nullDefault)))));
    }
  }]);

  return CompositionInfoModal;
}(Component);

CompositionInfoModal.defaultProps = {
  visible: false,
  handleCancel: function handleCancel() {},
  showAddMarker: false
};

function _createSuper$y(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$y(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$y() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CommonModal = /*#__PURE__*/function (_React$Component) {
  _inherits(CommonModal, _React$Component);

  var _super = _createSuper$y(CommonModal);

  function CommonModal() {
    _classCallCheck(this, CommonModal);

    return _super.apply(this, arguments);
  }

  _createClass(CommonModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(_Modal, {
        width: this.props.width,
        visible: this.props.visible,
        wrapClassName: this.props.wrapClassName,
        title: this.props.title,
        onCancel: this.props.onCancel,
        afterClose: this.props.afterClose,
        footer: this.props.footer,
        closable: this.props.closable,
        style: this.props.style,
        bodyStyle: this.props.bodyStyle
      }, this.props.children);
    }
  }]);

  return CommonModal;
}(React__default.Component);

function showKdmValidity(kdmSummary) {
  if (kdmSummary) {
    var statuses = Object.keys(kdmSummary.statuses);

    if (statuses.find(function (k) {
      return k.toLowerCase() === KDMStatuses.inprogress;
    })) {
      return statuses.length > 1;
    }

    return true;
  }

  return false;
}

function getTheatreKdmSummaryStatus(theatre, kdmStatus, kdmIngestStatus) {
  var kdmGenerationCompleted = true;
  var kdmIssuedScreenCount = 0;
  var kdmSummaryStatus = theatre.kdmSummary ? theatre.kdmSummary.statuses : [];
  var kdmIngestSummaryStatus = theatre.kdmSummary ? theatre.kdmSummary.ingest : {};
  [KDMStatuses.success, KDMStatuses.generated, KDMStatuses.emailed].forEach(function (key) {
    if (kdmSummaryStatus[key]) {
      kdmIssuedScreenCount += kdmSummaryStatus[key];
    }
  });

  switch (true) {
    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.failed) && kdmSummaryStatus[KDMStatuses.failed] > 0:
      if (kdmStatus[KDMStatuses.failed]) {
        kdmStatus[KDMStatuses.failed] += 1;
      } else {
        kdmStatus[KDMStatuses.failed] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.unavailable) && kdmSummaryStatus[KDMStatuses.unavailable] > 0:
      if (kdmStatus[KDMStatuses.unavailable]) {
        kdmStatus[KDMStatuses.unavailable] += 1;
      } else {
        kdmStatus[KDMStatuses.unavailable] = 1;
      }

      break;

    case _.isEmpty(kdmSummaryStatus):
      if (kdmStatus[KDMStatuses.unavailable]) {
        kdmStatus[KDMStatuses.unavailable] += 1;
      } else {
        kdmStatus[KDMStatuses.unavailable] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.expiring) && kdmSummaryStatus[KDMStatuses.expiring] > 0:
      if (kdmStatus[KDMStatuses.expiring]) {
        kdmStatus[KDMStatuses.expiring] += 1;
      } else {
        kdmStatus[KDMStatuses.expiring] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.emailed) && kdmSummaryStatus[KDMStatuses.emailed] > 0:
      if (kdmStatus[KDMStatuses.emailed]) {
        kdmStatus[KDMStatuses.emailed] += 1;
      } else {
        kdmStatus[KDMStatuses.emailed] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.success) && kdmSummaryStatus[KDMStatuses.success] > 0 || kdmSummaryStatus.hasOwnProperty(KDMStatuses.generated) && kdmSummaryStatus[KDMStatuses.generated] > 0 || kdmSummaryStatus.hasOwnProperty('GENERATED') && kdmSummaryStatus.GENERATED > 0:
      if (kdmStatus[KDMStatuses.success]) {
        kdmStatus[KDMStatuses.success] += 1;
      } else {
        kdmStatus[KDMStatuses.success] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.inProgress) && kdmSummaryStatus[KDMStatuses.inProgress] > 0:
      if (kdmStatus[KDMStatuses.inProgress]) {
        kdmStatus[KDMStatuses.inProgress] += 1;
      } else {
        kdmStatus[KDMStatuses.inProgress] = 1;
      }

      break;

    case kdmSummaryStatus.hasOwnProperty(KDMStatuses.expired) && kdmSummaryStatus[KDMStatuses.expired] > 0:
      if (kdmStatus[KDMStatuses.expired]) {
        kdmStatus[KDMStatuses.expired] += 1;
      } else {
        kdmStatus[KDMStatuses.expired] = 1;
      }

      break;

    default:
      kdmStatus[KDMStatuses.unavailable] = 1;
  }

  if (kdmIngestSummaryStatus) {
    if (kdmIngestSummaryStatus.Ingested) {
      if (kdmIngestStatus[IngestStatuses.ingested]) {
        kdmIngestStatus[IngestStatuses.ingested] += 1;
      } else {
        kdmIngestStatus[IngestStatuses.ingested] = 1;
      }
    } else if (kdmIngestSummaryStatus.IngestCancelled) {
      if (kdmIngestStatus[IngestStatuses.ingestcancelled]) {
        kdmIngestStatus[IngestStatuses.ingestcancelled] += 1;
      } else {
        kdmIngestStatus[IngestStatuses.ingestcancelled] = 1;
      }
    } else if (kdmIngestSummaryStatus.IngestFailed) {
      if (kdmIngestStatus[IngestStatuses.ingestfailed]) {
        kdmIngestStatus[IngestStatuses.ingestfailed] += 1;
      } else {
        kdmIngestStatus[IngestStatuses.ingestfailed] = 1;
      }
    } else if (kdmIngestSummaryStatus.IngestInProgress) {
      if (kdmIngestStatus[IngestStatuses.ingestinprogress]) {
        kdmIngestStatus[IngestStatuses.ingestinprogress] += 1;
      } else {
        kdmIngestStatus[IngestStatuses.ingestinprogress] = 1;
      }
    } else if (kdmIngestSummaryStatus.PendingIngest) {
      if (kdmIngestStatus[IngestStatuses.pendingingest]) {
        kdmIngestStatus[IngestStatuses.pendingingest] += 1;
      } else {
        kdmIngestStatus[IngestStatuses.pendingingest] = 1;
      }
    }
  }

  if (kdmIssuedScreenCount && !!kdmStatus[KDMStatuses.inprogress]) {
    kdmGenerationCompleted = false;
  }

  return kdmGenerationCompleted;
}

function getKDMSummaryData(props) {
  var theatres = props.composition.theatres;
  var kdmStatus = {};
  var kdmIngestStatus = {};
  var kdmGenerationCompleted = true;
  var kdmValidity = {
    validFrom: '',
    validTill: '',
    timezone: '',
    isMultiple: false
  };
  theatres.forEach(function (theatre) {
    var kdmSummary = theatre.kdmSummary,
        timezone = theatre.timezone;

    var _ref = kdmSummary || {},
        validFrom = _ref.validFrom,
        validTill = _ref.validTill;

    var showValidity = showKdmValidity(kdmSummary);

    if (showValidity && validFrom && validTill && !kdmValidity.isMultiple) {
      if (!kdmValidity.validFrom && !kdmValidity.validTill) {
        kdmValidity = {
          validFrom: validFrom,
          validTill: validTill,
          timezone: timezone,
          isMultiple: false
        };
      } else {
        var curValidFrom = momentTZ.tz(validFrom, timezone);
        var curValidTill = momentTZ.tz(validTill, timezone);
        var kdmValidFrom = momentTZ.tz(kdmValidity.validFrom, kdmValidity.timezone);
        var kdmValidTill = momentTZ.tz(kdmValidity.validTill, kdmValidity.timezone);

        if (!_.isEqual(curValidFrom, kdmValidFrom) || !_.isEqual(curValidTill, kdmValidTill)) {
          kdmValidity = {
            validFrom: '',
            validTill: '',
            timezone: '',
            isMultiple: true
          };
        }
      }
    } else if (showValidity && !kdmValidity.isMultiple) {
      kdmValidity = {
        validFrom: '',
        validTill: '',
        timezone: '',
        isMultiple: true
      };
    }

    var theatreKdmGenerationComplete = getTheatreKdmSummaryStatus(theatre, kdmStatus, kdmIngestStatus);

    if (kdmGenerationCompleted && !theatreKdmGenerationComplete) {
      kdmGenerationCompleted = theatreKdmGenerationComplete;
    }
  });
  return {
    kdmStatus: kdmStatus,
    kdmIngestStatus: kdmIngestStatus,
    kdmGenerationCompleted: kdmGenerationCompleted,
    showKdmDownloadOption: theatres.length === 1 ? kdmGenerationCompleted : false,
    kdmValidity: kdmValidity
  };
}

function ingestStatusSummary$1(kdmIngestStatus) {
  var ingestSummary = [];
  var ingestCount = 100;

  for (var ingetStatus in kdmIngestStatus) {
    ingestSummary.push( /*#__PURE__*/React__default.createElement("div", {
      key: ingestCount,
      className: "kdm-summary__status kdm-ingest__status ".concat(ingetStatus.toLowerCase())
    }, ingestCount > 100 && /*#__PURE__*/React__default.createElement("span", {
      className: "status-meta__txt"
    }, "\u2022"), /*#__PURE__*/React__default.createElement("span", {
      className: "status-meta__count"
    }, kdmIngestStatus[ingetStatus]), IngestStatusValues[ingetStatus.toLowerCase()]));
    ingestCount += 1;
  }

  return ingestSummary;
}

function renderKDMStatusSummary(kdmStatus, kdmValidity, kdmIngestStatus) {
  var statusSummary = [];
  var current = 1;

  if (kdmStatus[KDMStatuses.inprogress]) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
      key: current,
      className: "kdm-summary__status inprogress"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "status-meta__count"
    }, kdmStatus[KDMStatuses.inprogress]), I18n.t('kdm_statuses.inprogress')));
    current += 1;
  }

  for (var status in kdmStatus) {
    if (status !== KDMStatuses.inprogress) {
      statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
        key: current,
        className: "kdm-summary__status ".concat(status.toLowerCase())
      }, current > 1 && /*#__PURE__*/React__default.createElement("span", {
        className: "status-meta__txt"
      }, "\u2022"), /*#__PURE__*/React__default.createElement("span", {
        className: "status-meta__count"
      }, kdmStatus[status]), I18n.t("kdm_statuses.".concat(status.toLowerCase()))));
      current += 1;
    }
  }

  if (kdmIngestStatus) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
      className: "ingest__status",
      key: current
    }, ingestStatusSummary$1(kdmIngestStatus)));
    current += 1;
  }

  var timezone = kdmValidity.timezone,
      validFrom = kdmValidity.validFrom,
      validTill = kdmValidity.validTill,
      isMultiple = kdmValidity.isMultiple;

  if (validFrom && validTill) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
      key: current,
      className: "validity__status"
    }, formatDateTime(momentTZ.tz(validFrom, timezone)), /*#__PURE__*/React__default.createElement("span", {
      className: "to-division"
    }, "to"), formatDateTime(momentTZ.tz(validTill, timezone))));
  } else if (isMultiple) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
      key: current,
      className: "validity__status"
    }, "Multiple Validities"));
  }

  return statusSummary;
}

function getDcpStatus(_ref) {
  var subDetail = _ref.subDetail,
      type = _ref.type;
  var status = subDetail || (type ? type.toLowerCase() : DCPStatuses.pending);

  switch (status) {
    case DCPStatuses.error:
    case DCPStatuses.expired:
      status = DCPStatuses.failed;
      break;

    case DCPStatuses.pending_cancellation:
      status = DCPStatuses.pending;
      break;
  }

  return status;
}

function getDcpShipmentStatus(dcpInfo) {
  var _dcpInfo$shippingDeta = dcpInfo.shippingDetails;
  _dcpInfo$shippingDeta = _dcpInfo$shippingDeta === void 0 ? {} : _dcpInfo$shippingDeta;
  var _dcpInfo$shippingDeta2 = _dcpInfo$shippingDeta.trackingInfo;
  _dcpInfo$shippingDeta2 = _dcpInfo$shippingDeta2 === void 0 ? {} : _dcpInfo$shippingDeta2;
  var status = _dcpInfo$shippingDeta2.status;

  switch (status) {
    case ShipmentStatuses.InfoReceived:
      return ShipmentStatuses.InTransit;

    case ShipmentStatuses.Pending:
      return DCPStatuses.dispatched;

    default:
      return status || DCPStatuses.dispatched;
  }
}

function getCplInfo(theatres) {
  var theatreCount = 0;
  var isDcpBooking = false;
  var isKdmBooking = false;
  var dcpStatus = {};
  var dcpIngestStatus = {};
  theatres.forEach(function (t) {
    theatreCount += 1;

    if (!_.isEmpty(t.kdmSummary)) {
      isKdmBooking = true;
    }

    if (t.dcp && !_.isEmpty(t.dcp)) {
      isDcpBooking = true;
      var status = getDcpStatus(t.dcp.status);

      if (status === DCPStatuses.dispatched) {
        status = getDcpShipmentStatus(t.dcp.details).toLowerCase();
      }

      if (dcpStatus[status]) {
        dcpStatus[status] += 1;
      } else {
        dcpStatus[status] = 1;
      }
    }

    if (t.dcpIngestSummary && t.dcpIngestSummary.statuses && !_.isEmpty(t.dcpIngestSummary.statuses)) {
      var dcpIngestSummaryStatus = t.dcpIngestSummary.statuses;

      if (dcpIngestSummaryStatus) {
        if (dcpIngestSummaryStatus.IngestFailed) {
          if (dcpIngestStatus[IngestStatuses.ingestfailed]) {
            dcpIngestStatus[IngestStatuses.ingestfailed] += 1;
          } else {
            dcpIngestStatus[IngestStatuses.ingestfailed] = 1;
          }
        } else if (dcpIngestSummaryStatus.IngestInProgress) {
          if (dcpIngestStatus[IngestStatuses.ingestinprogress]) {
            dcpIngestStatus[IngestStatuses.ingestinprogress] += 1;
          } else {
            dcpIngestStatus[IngestStatuses.ingestinprogress] = 1;
          }
        } else if (dcpIngestSummaryStatus.PendingIngest) {
          if (dcpIngestStatus[IngestStatuses.pendingingest]) {
            dcpIngestStatus[IngestStatuses.pendingingest] += 1;
          } else {
            dcpIngestStatus[IngestStatuses.pendingingest] = 1;
          }
        } else if (dcpIngestSummaryStatus.Ingested) {
          if (dcpIngestStatus[IngestStatuses.ingested]) {
            dcpIngestStatus[IngestStatuses.ingested] += 1;
          } else {
            dcpIngestStatus[IngestStatuses.ingested] = 1;
          }
        } else if (dcpIngestSummaryStatus.IngestCancelled) {
          if (dcpIngestStatus[IngestStatuses.ingestcancelled]) {
            dcpIngestStatus[IngestStatuses.ingestcancelled] += 1;
          } else {
            dcpIngestStatus[IngestStatuses.ingestcancelled] = 1;
          }
        }
      }
    }
  });
  return {
    isDcpBooking: isDcpBooking,
    isKdmBooking: isKdmBooking,
    theatreCount: theatreCount,
    dcpStatus: dcpStatus,
    dcpIngestStatus: dcpIngestStatus
  };
}

function ingestStatusSummary(dcpIngestStatus) {
  var ingestSummary = [];
  var ingestCount = 100;

  for (var ingestStatus in dcpIngestStatus) {
    ingestSummary.push( /*#__PURE__*/React__default.createElement("div", {
      key: ingestCount,
      className: "dcp-summary__status dcp-ingest__status ".concat(ingestStatus.toLowerCase())
    }, ingestCount > 100 && /*#__PURE__*/React__default.createElement("span", {
      className: "status-meta__txt"
    }, "\u2022"), /*#__PURE__*/React__default.createElement("span", {
      className: "status-meta__count"
    }, dcpIngestStatus[ingestStatus]), IngestStatusValues[ingestStatus.toLowerCase()]));
    ingestCount += 1;
  }

  return ingestSummary;
}

function renderDCPStatusSummary(DCPStatus, dcpIngestStatus) {
  var statusSummary = [];
  var current = 1;

  for (var status in DCPStatus) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("span", {
      key: current,
      className: "dcp-summary__status ".concat(status.toLowerCase())
    }, current > 1 && /*#__PURE__*/React__default.createElement("span", null, "\xA0\u2022\xA0"), DCPStatus[status], "\xA0", DCPStatusValues[status]));
    current += 1;
  }

  if (dcpIngestStatus) {
    statusSummary.push( /*#__PURE__*/React__default.createElement("div", {
      className: "ingest__status",
      key: current
    }, ingestStatusSummary(dcpIngestStatus)));
    current += 1;
  }

  return statusSummary;
}
function renderIngestStatusSummary(dcpIngestStatus) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "ingest__status dcp_ingest__status"
  }, ingestStatusSummary(dcpIngestStatus));
}

var Status = function Status(props) {
  return /*#__PURE__*/React__default.createElement("div", null, props.status ? /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("span", {
    className: "qw-online-status qw-status"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "online-status qw-online"
  }, "Online")) : /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("span", {
    className: "qw-offline-status qw-status"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "online-status qw-offline"
  }, "Offline")));
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$x(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$x(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$x() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Option = _Select.Option;

var SearchFilter = /*#__PURE__*/function (_Component) {
  _inherits(SearchFilter, _Component);

  var _super = _createSuper$x(SearchFilter);

  function SearchFilter(props) {
    var _this;

    _classCallCheck(this, SearchFilter);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getUniqueSelectedList", function () {
      var _this$state = _this.state,
          _this$state$selectedL = _this$state.selectedList,
          selectedList = _this$state$selectedL === void 0 ? [] : _this$state$selectedL,
          _this$state$selectedL2 = _this$state.selectedListFromSearch,
          selectedListFromSearch = _this$state$selectedL2 === void 0 ? [] : _this$state$selectedL2;

      var uniqueSelection = _$1.uniqBy(selectedListFromSearch.concat(selectedList), 'key');

      return _$1.isEmpty(uniqueSelection) ? null : uniqueSelection;
    });

    _this.state = {
      searchValue: false,
      selectedListFromSearch: [],
      selectedList: [],
      showContent: true,
      searchList: [],
      isFreshSearch: true
    };
    _this.timer = null;
    _this.onSearch = _$1.debounce(_this.onSearch.bind(_assertThisInitialized(_this)), 400);
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_this));
    _this.clearSearch = _this.clearSearch.bind(_assertThisInitialized(_this));
    _this.handleListSelect = _this.handleListSelect.bind(_assertThisInitialized(_this));
    _this.handleListDeselect = _this.handleListDeselect.bind(_assertThisInitialized(_this));
    _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchFilter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.clearAll !== this.props.clearAll) {
        this.handleClear();
      }

      if (prevProps.selectedList !== this.props.selectedList) {
        if (this.props.selectedList !== this.state.selectedList) {
          this.setState({
            selectedList: this.props.selectedList,
            selectedListFromSearch: this.props.selectedList
          });
        }
      }

      if (prevProps.searchList !== this.props.searchList) {
        this.setState({
          searchList: this.props.searchList
        });
      }
    }
  }, {
    key: "handleClear",
    value: function handleClear(e) {
      var _this2 = this;

      e && e.stopPropagation();
      this.setState({
        selectedListFromSearch: [],
        selectedList: []
      }, function () {
        return _this2.props.onSelectDeselect && _this2.props.onSelectDeselect(true, 0, {
          type: _this2.props.type,
          clear: true
        });
      });
    }
  }, {
    key: "handleListSelect",
    value: function handleListSelect(value) {
      var _this3 = this;

      var _this$state2 = this.state,
          selectedListFromSearch = _this$state2.selectedListFromSearch,
          selectedList = _this$state2.selectedList;

      var selectedValue = _$1.cloneDeep(value);

      if (Array.isArray(value.label)) {
        selectedValue.label = value.label[0].props.children;
        selectedValue.subLabel = value.label[1].props.children;
      }

      this.setState({
        selectedListFromSearch: [].concat(_toConsumableArray(selectedListFromSearch), [Object.assign({}, _objectSpread$3(_objectSpread$3({}, selectedValue), {}, {
          type: this.props.type
        }))]),
        selectedList: [].concat(_toConsumableArray(selectedList), [_objectSpread$3(_objectSpread$3({}, selectedValue), {}, {
          type: this.props.type
        })])
      }, function () {
        return _this3.props.onSelectDeselect && _this3.props.onSelectDeselect(true, 0, _this3.getUniqueSelectedList());
      });
    }
  }, {
    key: "handleListDeselect",
    value: function handleListDeselect(value) {
      var _this4 = this;

      var _this$state3 = this.state,
          selectedListFromSearch = _this$state3.selectedListFromSearch,
          selectedList = _this$state3.selectedList;
      this.setState({
        selectedListFromSearch: selectedListFromSearch.filter(function (s) {
          return s.key !== value.key;
        }),
        selectedList: selectedList.filter(function (s) {
          return s.key !== value.key;
        })
      }, function () {
        return _this4.props.onSelectDeselect && _this4.props.onSelectDeselect(true, 0, _this4.getUniqueSelectedList());
      });
    }
  }, {
    key: "handleCheckboxClick",
    value: function handleCheckboxClick(value, e) {
      var _this5 = this;

      if (e.target.checked) {
        this.setState({
          selectedListFromSearch: [].concat(_toConsumableArray(this.state.selectedListFromSearch), [value]),
          selectedList: [].concat(_toConsumableArray(this.state.selectedList), [value])
        }, function () {
          return _this5.props.onSelectDeselect && _this5.props.onSelectDeselect(true, 0, _this5.getUniqueSelectedList());
        });
      } else {
        this.setState({
          selectedListFromSearch: this.state.selectedListFromSearch.filter(function (s) {
            return s.key !== value.key;
          }),
          selectedList: this.state.selectedList.filter(function (s) {
            return s.key !== value.key;
          })
        }, function () {
          if (_$1.isEmpty(_this5.state.selectedList)) {
            _this5.props.onSelectDeselect && _this5.props.onSelectDeselect(true, 0, {
              type: _this5.props.type,
              clear: true
            });
          } else {
            _this5.props.onSelectDeselect && _this5.props.onSelectDeselect(true, 0, _this5.getUniqueSelectedList());
          }
        });
      }
    }
  }, {
    key: "handleCollapse",
    value: function handleCollapse() {
      this.setState({
        showContent: !this.state.showContent
      });
    }
  }, {
    key: "onSearch",
    value: function onSearch(value) {
      if (value) {
        this.props.onSearch(value);
        this.setState({
          searchValue: true,
          isFreshSearch: false
        });
      } else {
        this.setState({
          searchValue: false,
          isFreshSearch: false
        });
      }
    }
  }, {
    key: "clearSearch",
    value: function clearSearch() {
      this.setState({
        searchValue: false
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.setState({
        searchValue: false,
        searchList: [],
        isFreshSearch: true
      });
    }
  }, {
    key: "getSelectedListCurrentType",
    value: function getSelectedListCurrentType(selectedList) {
      var _this6 = this;

      return selectedList.filter(function (item) {
        return item.type === _this6.props.type;
      });
    }
  }, {
    key: "renderSearchList",
    value: function renderSearchList() {
      var _this7 = this;

      var _this$state4 = this.state,
          _this$state4$selected = _this$state4.selectedList,
          selectedList = _this$state4$selected === void 0 ? [] : _this$state4$selected,
          _this$state4$selected2 = _this$state4.selectedListFromSearch,
          selectedListFromSearch = _this$state4$selected2 === void 0 ? [] : _this$state4$selected2;
      var _this$props = this.props,
          _this$props$recentLis = _this$props.recentList,
          recentList = _this$props$recentLis === void 0 ? [] : _this$props$recentLis,
          isFetching = _this$props.isFetching;

      var listData = _$1.uniqBy(this.getSelectedListCurrentType(selectedListFromSearch).concat(recentList.concat(this.getSelectedListCurrentType(selectedList))), 'key');

      if (isFetching) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "loader"
        }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
          spin: true
        }));
      }

      return listData.map(function (data, idx) {
        var isChecked = !!_this7.getSelectedListCurrentType(selectedList).find(function (s) {
          return s.key === data.key;
        });
        return /*#__PURE__*/React__default.createElement("div", {
          key: idx,
          className: classNames('checkbox', {
            checked: isChecked
          })
        }, /*#__PURE__*/React__default.createElement(_Checkbox, {
          checked: isChecked,
          onChange: _this7.handleCheckboxClick.bind(_this7, data)
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null, data.label), data.subLabel && /*#__PURE__*/React__default.createElement("div", {
          className: "secondary-label"
        }, data.subLabel))));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$props2 = this.props,
          title = _this$props2.title,
          placeholder = _this$props2.placeholder,
          isSearching = _this$props2.isSearching,
          setShowClearAll = _this$props2.setShowClearAll,
          showClearAll = _this$props2.showClearAll,
          dropDownPlaceholder = _this$props2.dropDownPlaceholder;
      var _this$state5 = this.state,
          searchValue = _this$state5.searchValue,
          _this$state5$selected = _this$state5.selectedList,
          selectedList = _this$state5$selected === void 0 ? [] : _this$state5$selected,
          _this$state5$selected2 = _this$state5.selectedListFromSearch,
          selectedListFromSearch = _this$state5$selected2 === void 0 ? [] : _this$state5$selected2,
          _this$state5$searchLi = _this$state5.searchList,
          searchList = _this$state5$searchLi === void 0 ? [] : _this$state5$searchLi,
          showContent = _this$state5.showContent,
          isFreshSearch = _this$state5.isFreshSearch;

      if (selectedList.length !== 0 || selectedListFromSearch.length !== 0) {
        if (!showClearAll) {
          setShowClearAll(true);
        }
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "search-filter",
        ref: "searchFilter"
      }, /*#__PURE__*/React__default.createElement(_Row, {
        className: "search-filter-header",
        onClick: this.handleCollapse
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 16,
        className: "heading"
      }, title, !_$1.isEmpty(this.getSelectedListCurrentType(selectedList)) && "(".concat(this.getSelectedListCurrentType(selectedList).length, ")"), !_$1.isEmpty(this.getSelectedListCurrentType(selectedList)) && /*#__PURE__*/React__default.createElement("span", {
        className: "clear",
        onClick: this.handleClear
      }, I18n.t('filterPanel.clear'))), /*#__PURE__*/React__default.createElement(_Col, {
        span: 8,
        className: "arrow"
      }, showContent ? /*#__PURE__*/React__default.createElement(UpOutlined$1, null) : /*#__PURE__*/React__default.createElement(DownOutlined$1, null))), /*#__PURE__*/React__default.createElement("div", {
        className: classNames('search-filter-content', {
          visible: showContent
        })
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "search-filter-field"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "search-icon"
      }, searchValue ? /*#__PURE__*/React__default.createElement(CloseOutlined$1, {
        onClick: this.clearSearch
      }) : /*#__PURE__*/React__default.createElement(SearchOutlined$1, null)), /*#__PURE__*/React__default.createElement(_Select, {
        ref: "searchFilter",
        mode: "multiple",
        value: this.getSelectedListCurrentType(selectedList),
        placeholder: placeholder,
        filterOption: false,
        labelInValue: true,
        onSearch: this.onSearch,
        onSelect: this.handleListSelect,
        onDeselect: this.handleListDeselect,
        onBlur: this.onBlur,
        style: {
          width: '100%'
        },
        getPopupContainer: function getPopupContainer() {
          return _this8.refs.searchFilter;
        },
        notFoundContent: isSearching ? /*#__PURE__*/React__default.createElement("div", {
          className: "spinner"
        }, /*#__PURE__*/React__default.createElement(_Spin, null)) : _$1.isEmpty(searchList) && isFreshSearch ? dropDownPlaceholder : I18n.t('filterPanel.noRecordsfound')
      }, searchList.map(function (data) {
        return /*#__PURE__*/React__default.createElement(Option, {
          key: data.key
        }, /*#__PURE__*/React__default.createElement("div", null, data.label), data.subLabel && /*#__PURE__*/React__default.createElement("div", {
          className: "secondary-label"
        }, data.subLabel));
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "search-filter-list"
      }, this.renderSearchList())));
    }
  }]);

  return SearchFilter;
}(Component);

function _createSuper$w(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$w(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$w() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CheckboxFilter = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxFilter, _Component);

  var _super = _createSuper$w(CheckboxFilter);

  function CheckboxFilter(props) {
    var _this;

    _classCallCheck(this, CheckboxFilter);

    _this = _super.call(this, props);
    _this.state = {
      selectedList: [],
      showContent: true
    };
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CheckboxFilter, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.clearAll !== this.props.clearAll) {
        this.handleClear();
      }

      if (prevProps.selectedList !== this.props.selectedList) {
        if (this.props.selectedList !== this.state.selectedList) {
          this.setState({
            selectedList: this.props.selectedList
          });
        }
      }
    }
  }, {
    key: "handleClear",
    value: function handleClear(e) {
      var _this2 = this;

      e && e.stopPropagation();
      this.setState({
        selectedList: []
      }, function () {
        return _this2.props.onSelectDeselect && _this2.props.onSelectDeselect(true, 0, {
          type: _this2.props.type,
          clear: true
        });
      });
    }
  }, {
    key: "handleCollapse",
    value: function handleCollapse() {
      this.setState({
        showContent: !this.state.showContent
      });
    }
  }, {
    key: "handleCheckboxClick",
    value: function handleCheckboxClick(value, e) {
      var _this3 = this;

      if (e.target.checked) {
        this.setState({
          selectedList: [].concat(_toConsumableArray(this.state.selectedList), [value])
        }, function () {
          return _this3.props.onSelectDeselect && _this3.props.onSelectDeselect(true, 0, _this3.state.selectedList);
        });
      } else {
        this.setState({
          selectedList: this.state.selectedList.filter(function (s) {
            return s.key !== value.key;
          })
        }, function () {
          if (_$1.isEmpty(_this3.state.selectedList)) {
            _this3.props.onSelectDeselect && _this3.props.onSelectDeselect(true, 0, {
              type: _this3.props.type,
              clear: true
            });
          } else {
            _this3.props.onSelectDeselect && _this3.props.onSelectDeselect(true, 0, _this3.state.selectedList);
          }
        });
      }
    }
  }, {
    key: "getSelectedListCurrentType",
    value: function getSelectedListCurrentType(selectedList) {
      var _this4 = this;

      return selectedList.filter(function (item) {
        return item.type === _this4.props.type;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props = this.props,
          title = _this$props.title,
          _this$props$filterLis = _this$props.filterList,
          filterList = _this$props$filterLis === void 0 ? [] : _this$props$filterLis,
          showClearAll = _this$props.showClearAll,
          setShowClearAll = _this$props.setShowClearAll,
          isFetching = _this$props.isFetching;
      var _this$state = this.state,
          showContent = _this$state.showContent,
          selectedList = _this$state.selectedList;

      if (selectedList.length !== 0) {
        if (!showClearAll) {
          setShowClearAll(true);
        }
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "search-filter",
        ref: "searchFilter"
      }, /*#__PURE__*/React__default.createElement(_Row, {
        className: "search-filter-header",
        onClick: this.handleCollapse
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 16,
        className: "heading"
      }, title, !_$1.isEmpty(this.getSelectedListCurrentType(selectedList)) && "(".concat(this.getSelectedListCurrentType(selectedList).length, ")"), !_$1.isEmpty(this.getSelectedListCurrentType(selectedList)) && /*#__PURE__*/React__default.createElement("span", {
        className: "clear",
        onClick: this.handleClear
      }, I18n.t('filterPanel.clear'))), /*#__PURE__*/React__default.createElement(_Col, {
        span: 8,
        className: "arrow"
      }, showContent ? /*#__PURE__*/React__default.createElement(UpOutlined$1, null) : /*#__PURE__*/React__default.createElement(DownOutlined$1, null))), /*#__PURE__*/React__default.createElement("div", {
        className: classNames('search-filter-content', {
          visible: showContent
        })
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "search-filter-list"
      }, isFetching ? /*#__PURE__*/React__default.createElement("div", {
        className: "loader"
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        spin: true
      })) : filterList.map(function (filter, idx) {
        var isChecked = !!selectedList.find(function (s) {
          return s.key === filter.key;
        });
        return /*#__PURE__*/React__default.createElement("div", {
          key: idx,
          className: classNames('checkbox', {
            checked: isChecked
          })
        }, /*#__PURE__*/React__default.createElement(_Checkbox, {
          checked: isChecked,
          onChange: _this5.handleCheckboxClick.bind(_this5, filter)
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null, filter.label), filter.subLabel && /*#__PURE__*/React__default.createElement("div", {
          className: "secondary-label"
        }, filter.subLabel))));
      }))));
    }
  }]);

  return CheckboxFilter;
}(Component);

var BreadCrumbs = function BreadCrumbs(props) {
  var breadCrumbsItems = props.breadCrumbsItems;
  return /*#__PURE__*/React__default.createElement(_Breadcrumb, {
    className: "breadcrumb",
    separator: ">"
  }, breadCrumbsItems.map(function (breadCrumbItem) {
    return breadCrumbItem;
  }));
};

var PageDefaultHeader = function PageDefaultHeader(_ref) {
  var content = _ref.content,
      type = _ref.type,
      buttons = _ref.buttons,
      tabsDetail = _ref.tabsDetail,
      selectedTab = _ref.selectedTab,
      onTabChange = _ref.onTabChange,
      breadCrumbItems = _ref.breadCrumbItems,
      noCapitalize = _ref.noCapitalize;

  switch (type) {
    case 'buttons':
      {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "page-header__buttons"
        }, breadCrumbItems ? /*#__PURE__*/React__default.createElement("div", {
          className: "breadcrumbs_outer",
          style: {
            width: '100%'
          }
        }, /*#__PURE__*/React__default.createElement(BreadCrumbs, {
          breadCrumbsItems: breadCrumbItems
        })) : null, /*#__PURE__*/React__default.createElement(PageHeading, {
          content: content,
          noCapitalize: noCapitalize
        }), /*#__PURE__*/React__default.createElement("div", {
          className: "buttons-wrapper"
        }, buttons && buttons.map(function (button) {
          if (button.type === 'primary') {
            return /*#__PURE__*/React__default.createElement(PrimaryButton, _extends({
              key: button.btnName
            }, button));
          }

          if (button.type === 'secondary') {
            return /*#__PURE__*/React__default.createElement(SecondaryButton, _extends({
              key: button.btnName
            }, button));
          }
        })));
      }

    case 'tabs':
      {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "page-header__tabs"
        }, /*#__PURE__*/React__default.createElement(PageHeading, {
          content: content
        }), /*#__PURE__*/React__default.createElement("div", {
          className: "tabs-list-layout"
        }, /*#__PURE__*/React__default.createElement(DefaultTabs, {
          tabsDetail: tabsDetail,
          selectedTab: selectedTab,
          onTabChange: onTabChange
        })));
      }

    default:
      return /*#__PURE__*/React__default.createElement("div", {
        className: "page-header__default"
      }, /*#__PURE__*/React__default.createElement(PageHeading, {
        content: content
      }));
  }
};

var HeaderWithTabs = function HeaderWithTabs(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "page-header__tabs"
  }, /*#__PURE__*/React__default.createElement(PageHeading, {
    content: props.content
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "tabs-list-layout"
  }, /*#__PURE__*/React__default.createElement(DefaultTabs, {
    tabsDetail: props.tabsDetail,
    selectedTab: props.selectedTab,
    onTabChange: props.onTabChange
  })));
};

var TheatreDefaultCard = function TheatreDefaultCard(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: props.isUnServiced ? 'theatre-card__default unserviced' : 'theatre-card__default'
  }, /*#__PURE__*/React__default.createElement(TheatreDefaultInfo, {
    name: props.name,
    address: props.address,
    id: props.id,
    screen_id: props.screen_id,
    theatreSelect: props.theatreSelect,
    unMatched: props.unMatched,
    duplicate: props.duplicate,
    matchedRows: props.matchedRows,
    duplicateRows: props.duplicateRows,
    hasWireTap: props.hasWireTap
  }), props.isUnServiced ? /*#__PURE__*/React__default.createElement(TheatreDefaultMeta, {
    containsDeleteButton: props.isUnServiced,
    deleteAction: props.deleteAction
  }) : /*#__PURE__*/React__default.createElement(TheatreDefaultMeta, {
    price: props.price
  }));
};

function _createSuper$v(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$v(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$v() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ListCard = /*#__PURE__*/function (_React$Component) {
  _inherits(ListCard, _React$Component);

  var _super = _createSuper$v(ListCard);

  function ListCard(props) {
    var _this;

    _classCallCheck(this, ListCard);

    _this = _super.call(this);
    _this.state = {
      expand: false,
      checked: false,
      selected: false,
      notSelected: true,
      partialSelected: false
    };
    return _this;
  }

  _createClass(ListCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.hasScreenNotInList(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps, newState) {
      this.hasScreenNotInList(newProps);
    }
  }, {
    key: "hasScreenNotInList",
    value: function hasScreenNotInList(props) {
      var theatreList = props.theatreList;
          props.selected;
          var theatresInBooking = props.theatresInBooking;
      var fullySelected = 0;
      var totalTheatreCount = theatreList && theatreList.theatres && theatreList.theatres.length;

      if (theatreList && theatreList.theatres) {
        theatreList.theatres.forEach(function (item) {
          theatresInBooking && theatresInBooking.forEach(function (child) {
            if (item.id == child.id) {
              fullySelected += 1;
            }
          });
        });
      }

      if (fullySelected === totalTheatreCount) {
        this.setState({
          selected: true,
          notSelected: false,
          partialSelected: false
        });
      } else if (!fullySelected) {
        this.setState({
          selected: false,
          notSelected: true,
          partialSelected: false
        });
      } else {
        this.setState({
          selected: false,
          notSelected: false,
          partialSelected: true
        });
      }
    }
  }, {
    key: "expandCard",
    value: function expandCard(e) {
      e.stopPropagation();
      this.setState({
        expand: !this.state.expand
      });

      if (this.props.onToggle) {
        this.props.onToggle();
      }
    }
  }, {
    key: "onCheck",
    value: function onCheck(e) {
      e.stopPropagation();

      if (this.props.handleAddListToBooking) {
        this.setState({
          checked: !this.state.checked
        });
        this.props.handleAddListToBooking();
      }
    }
  }, {
    key: "renderIconsForTheatreInList",
    value: function renderIconsForTheatreInList() {
      var _this$state = this.state,
          selected = _this$state.selected,
          notSelected = _this$state.notSelected;
          _this$state.partialSelected;

      if (selected) {
        return /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "SelectedFull"
        });
      }

      if (notSelected) {
        return /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "SelectedEmpty"
        });
      }

      return /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "SelectedPartial"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          name = _this$props.name,
          theatreCount = _this$props.theatreCount,
          renderEditView = _this$props.renderEditView,
          expandInfo = _this$props.expandInfo;
      var _this$state2 = this.state;
          _this$state2.expand;
          _this$state2.checked;
          _this$state2.partialSelected;
          _this$state2.fullySelected;
          _this$state2.notSelected;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-card-overview"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-card-description",
        onClick: function onClick(e) {
          return _this2.onCheck(e);
        }
      }, expandInfo ? /*#__PURE__*/React__default.createElement("div", {
        style: {
          height: '24px'
        },
        onClick: function onClick(e) {
          return _this2.expandCard(e);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "ChevronDown"
      })) : /*#__PURE__*/React__default.createElement("div", {
        style: {
          height: '24px'
        },
        onClick: function onClick(e) {
          return _this2.expandCard(e);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "ChevronRight"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-card-details-view"
      }, /*#__PURE__*/React__default.createElement(Title, {
        text: name
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "list-card-mobile-description"
      }, /*#__PURE__*/React__default.createElement(Description, {
        text: theatreCount
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-card-select-view"
      }, theatreCount && /*#__PURE__*/React__default.createElement("div", {
        className: "list-card-count-theatre-count"
      }, /*#__PURE__*/React__default.createElement(Description, {
        text: theatreCount
      })), renderEditView && /*#__PURE__*/React__default.createElement("div", null, renderEditView), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-card-click-icon"
      }, this.renderIconsForTheatreInList()))), children && /*#__PURE__*/React__default.createElement("div", null, this.props.children));
    }
  }]);

  return ListCard;
}(React__default.Component);
ListCard.defaultProps = {
  theatreCount: '5 theatres',
  name: 'List name'
};

var camelize = function(obj) {
    if (typeof obj === 'string') return camelCase(obj);
    return walk(obj);
};

function walk (obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (isDate(obj) || isRegex(obj)) return obj;
    if (isArray(obj)) return map(obj, walk);
    return reduce(objectKeys(obj), function (acc, key) {
        var camel = camelCase(key);
        acc[camel] = walk(obj[key]);
        return acc;
    }, {});
}

function camelCase(str) {
    return str.replace(/[_.-](\w|$)/g, function (_,x) {
        return x.toUpperCase();
    });
}

var isArray = Array.isArray || function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
};

var isDate = function (obj) {
    return Object.prototype.toString.call(obj) === '[object Date]';
};

var isRegex = function (obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var has = Object.prototype.hasOwnProperty;
var objectKeys = Object.keys || function (obj) {
    var keys = [];
    for (var key in obj) {
        if (has.call(obj, key)) keys.push(key);
    }
    return keys;
};

function map (xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        res.push(f(xs[i], i));
    }
    return res;
}

function reduce (xs, f, acc) {
    if (xs.reduce) return xs.reduce(f, acc);
    for (var i = 0; i < xs.length; i++) {
        acc = f(acc, xs[i], i);
    }
    return acc;
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function frameTheatreAddress(theatre) {
  var address = [];

  if (!_$1.isEmpty(theatre.city)) {
    address.push(theatre.city.name);
  }

  if (!_$1.isEmpty(theatre.province)) {
    address.push(theatre.province.name);
  }

  if (!_$1.isEmpty(theatre.country)) {
    address.push(theatre.country.name);
  }

  return address.join(', ');
}
function calculateKdmPrice(theatre, pricingModel) {
  if (!theatre || !pricingModel || theatre.isPublic === undefined) {
    return 0.0.toFixed(2);
  }

  var theatreAmount = 0;
  pricingModel.items.forEach(function (_ref) {
    var theatreId = _ref.theatreId,
        netAmount = _ref.netAmount;

    if (theatreId === theatre.id) {
      theatreAmount += netAmount;
    }
  });
  return (theatreAmount / 100).toFixed(2);
}
function getKdmDcpPrice(theatre, pricingModel) {
  var dcpDeliveryPrice = theatre.dcpPrice ? theatre.dcpPrice / 100 : 0;
  var kdmPriceForTheatre = parseFloat(calculateKdmPrice(theatre, pricingModel));
  var totalPriceForTheatre = dcpDeliveryPrice + kdmPriceForTheatre;
  return Number(totalPriceForTheatre).toFixed(2);
}
function processTheatre(theatre) {
  var theatreConflict = false;
  var screens = [];

  _$1.each(theatre.auditoriums, function (auditorium) {
    var deviceErrors = [];

    var validDevices = _$1.filter(auditorium.devices, function (device) {
      return device.code == 'PLY';
    });

    if (validDevices.length) {
      validDevices.map(function (device) {
        return deviceErrors = deviceErrors.concat(checkDeviceErrors(camelize(device)));
      });
    } else {
      deviceErrors.push('NOT_PLY_DEVICE');
    }

    var player = _$1.find(auditorium.devices, function (device) {
      return isValidPlaybackDevice_(camelize(device));
    });

    var conflict = _$1.find(auditorium.devices, function (device) {
      return device.code == 'PLY' && device.conflict == true;
    });

    if (conflict) {
      theatreConflict = true;
    }

    screens.push({
      id: auditorium.uuid,
      number: auditorium.number,
      name: auditorium.name,
      hasMediaBlock: !!(!auditorium.devices.length || player),
      conflict: !!conflict,
      deviceErrors: _$1.uniq(deviceErrors),
      isActive: auditorium.is_active,
      selected: auditorium.selected ? auditorium.selected : false
    });
  });

  var address = theatre.address;
  var processedTheatre = {
    id: theatre.uuid,
    name: theatre.name,
    timezone: theatre.timezone,
    address: camelize(address),
    conflict: theatreConflict,
    isPublic: !theatre.is_private,
    screens: screens,
    alternate_names: theatre.alternate_names,
    wiretaps: theatre.wiretaps,
    matched_on: theatre.matched_on
  };
  return processedTheatre;
}

function isValidPlaybackDevice_(device) {
  return true;
}

function checkDeviceErrors(device) {
  var deviceErrors = [];
  device.isActive == false ? deviceErrors.push('IS_NOT_ACTIVE') : null;
  device.hasCertificate == false ? deviceErrors.push('HAS_NO_CERTIFICATE') : null;
  return deviceErrors;
}

function processTheatreRequestData(request) {
  var formattedRequest = {
    name: request.name ? [request.name] : [],
    address: {
      city: request.city,
      state: request.state,
      country: request.country
    },
    id: request.id ? [request.id] : [],
    screen_id: request.screen_id ? [request.screen_id] : []
  };
  return formattedRequest;
}
function processTheatres(theatres) {
  var processedTheatres = [];

  _$1.each(theatres, function (theatre) {
    if (theatre.request) {
      theatre.request = processTheatreRequestData(theatre.request);
      theatre.record = processTheatre(theatre.record);
    }

    processedTheatres.push(theatre);
  });

  return processedTheatres;
}
function formatAddress(address) {
  var formattedAddress = [];

  if (address.city) {
    formattedAddress.push(address.city);
  }

  if (address.state) {
    formattedAddress.push(address.state);
  }

  if (address.country) {
    formattedAddress.push(address.country);
  }

  return formattedAddress.join(', ');
}
function combineTheatreRows(theatres) {
  var combinedRows = [];
  var index;

  for (index = 0; index < theatres.length; index++) {
    var theatreIndex = _$1.findIndex(combinedRows, function (theatre) {
      return theatre.record.id === theatres[index].record.id;
    });

    if (theatreIndex >= 0) {
      var processedTheatre = _$1.cloneDeep(combinedRows[theatreIndex]);

      if (theatres[index].record.matched_on === MatchedBy.screenId) {
        if (processedTheatre.record.matched_on === MatchedBy.screenId) {
          var duplicateScreenId = processedTheatre.matchedColumn.screen_id.includes(theatres[index].request.screen_id[0]);

          if (!duplicateScreenId) {
            for (var iteration = 0; iteration < processedTheatre.record.screens.length; iteration++) {
              if (processedTheatre.record.screens[iteration].selected && theatres[index].record.screens[iteration].selected) {
                duplicateScreenId = true;
                break;
              }

              processedTheatre.record.screens[iteration].selected = processedTheatre.record.screens[iteration].selected || theatres[index].record.screens[iteration].selected;
            }

            if (duplicateScreenId) {
              processedTheatre.duplicate = _objectSpread$2(_objectSpread$2({}, processedTheatre.duplicate), {}, {
                screen_id: processedTheatre.duplicate.screen_id ? processedTheatre.duplicate.screen_id.concat(theatres[index].request.screen_id) : [theatres[index].request.screen_id]
              });
              processedTheatre.duplicateRows += 1;
            } else {
              processedTheatre.matchedColumn.screen_id = processedTheatre.matchedColumn.screen_id.concat(theatres[index].request.screen_id);
            }

            processedTheatre.matchedRows += 1;
          } else {
            processedTheatre.duplicate = _objectSpread$2(_objectSpread$2({}, processedTheatre.duplicate), {}, {
              screen_id: processedTheatre.duplicate.screen_id ? processedTheatre.duplicate.screen_id.concat(theatres[index].request.screen_id) : [theatres[index].request.screen_id]
            });
            processedTheatre.duplicateRows += 1;
            processedTheatre.matchedRows += 1;
          }
        } else {
          if (processedTheatre.record.matched_on === MatchedBy.theatreId) {
            processedTheatre.duplicate = _objectSpread$2(_objectSpread$2({}, processedTheatre.duplicate), {}, {
              id: processedTheatre.duplicate.id ? processedTheatre.matchedColumn.id.concat(processedTheatre.duplicate.id) : processedTheatre.matchedColumn.id
            });
          } else {
            processedTheatre.duplicate = _objectSpread$2(_objectSpread$2({}, processedTheatre.duplicate), {}, {
              name: processedTheatre.duplicate.name ? processedTheatre.matchedColumn.name.concat(processedTheatre.duplicate.name) : processedTheatre.matchedColumn.name
            });
          }

          processedTheatre.matchedColumn = {
            name: theatres[index].request.name,
            screen_id: theatres[index].request.screen_id
          };
          processedTheatre.record.screens = _toConsumableArray(theatres[index].record.screens);
          processedTheatre.record.matched_on = MatchedBy.screenId;
          processedTheatre.duplicateRows += 1;
          processedTheatre.matchedRows += 1;
        }
      } else {
        if (theatres[index].record.matched_on === MatchedBy.theatreId) {
          processedTheatre.duplicate = _objectSpread$2(_objectSpread$2({}, processedTheatre.duplicate), {}, {
            id: processedTheatre.duplicate.id ? processedTheatre.duplicate.id.concat(theatres[index].request.id) : [theatres[index].request.id]
          });
        } else if (theatres[index].record.matched_on === MatchedBy.theatreDetails) {
          processedTheatre.duplicate = _objectSpread$2(_objectSpread$2({}, processedTheatre.duplicate), {}, {
            name: processedTheatre.duplicate.name ? processedTheatre.duplicate.name.concat(theatres[index].request.name) : [theatres[index].request.name]
          });
        }

        processedTheatre.matchedRows += 1;
        processedTheatre.duplicateRows += 1;
      }

      combinedRows[theatreIndex] = _$1.cloneDeep(processedTheatre);
    } else {
      var theatre = {
        matchedColumn: {},
        duplicate: {},
        record: _$1.cloneDeep(theatres[index].record),
        matchedRows: 1,
        duplicateRows: 0
      };

      if (theatre.record.matched_on !== MatchedBy.screenId) {
        theatre.record.screens = theatre.record.screens.map(function (screen) {
          screen.selected = true;
          return screen;
        });
      }

      if (theatre.record.matched_on === MatchedBy.screenId) {
        theatre.matchedColumn = {
          name: theatres[index].request.name,
          screen_id: theatres[index].request.screen_id
        };
      } else if (theatre.record.matched_on === MatchedBy.theatreDetails) {
        theatre.matchedColumn = {
          name: theatres[index].request.name,
          address: theatres[index].request.address
        };
      } else if (theatre.record.matched_on === MatchedBy.theatreId) {
        theatre.matchedColumn = {
          name: theatres[index].request.name,
          id: theatres[index].request.id
        };
      }

      combinedRows.push(theatre);
    }
  }

  return combinedRows;
}

function _createSuper$u(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$u(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$u() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TheatreInfoModal = /*#__PURE__*/function (_React$Component) {
  _inherits(TheatreInfoModal, _React$Component);

  var _super = _createSuper$u(TheatreInfoModal);

  function TheatreInfoModal(props) {
    var _this;

    _classCallCheck(this, TheatreInfoModal);

    _this = _super.call(this, props);
    _this.state = {
      expand: false
    };
    _this.handleExpand = _this.handleExpand.bind(_assertThisInitialized(_this));
    _this.closeExpand = _this.closeExpand.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TheatreInfoModal, [{
    key: "handleExpand",
    value: function handleExpand() {
      this.setState({
        expand: true
      });
    }
  }, {
    key: "closeExpand",
    value: function closeExpand() {
      this.setState({
        expand: false
      });
    }
  }, {
    key: "renderAllAlternateNames",
    value: function renderAllAlternateNames() {
      var alternate_names = this.props.theatre.alternate_names;
      return alternate_names && alternate_names.map(function (name, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "alternate_names",
          key: index
        }, name);
      });
    }
  }, {
    key: "renderPartialAlternateNames",
    value: function renderPartialAlternateNames() {
      var sliceValue = 3;
      var alternate_names = this.props.theatre.alternate_names;
      return /*#__PURE__*/React__default.createElement("div", null, alternate_names && alternate_names.slice(0, sliceValue).map(function (name, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "alternate_names",
          key: index
        }, name);
      }), alternate_names.length > 3 ? /*#__PURE__*/React__default.createElement("div", {
        className: "light-blue cursor-pointer view_more",
        onClick: this.handleExpand
      }, "View More") : null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theatre = _this$props.theatre,
          handleCancel = _this$props.handleCancel,
          open = _this$props.open,
          showWireTapIcon = _this$props.showWireTapIcon;
      return /*#__PURE__*/React__default.createElement(_Modal, {
        visible: open,
        wrapClassName: "vertical-center-modal",
        title: "Theatre Details",
        onCancel: handleCancel,
        afterClose: this.closeExpand,
        footer: null
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block halfwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Theatre Name "), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block_description"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "mg-btm-small"
      }, theatre.name, showWireTapIcon && theatre && theatre.wiretaps && theatre.wiretaps.length > 0 && /*#__PURE__*/React__default.createElement("div", {
        "data-tip": true,
        "data-for": "wiretapicon",
        className: "wiretap-badge"
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "WireTap",
        color: "primary",
        size: 16
      }), /*#__PURE__*/React__default.createElement(ReactTooltip, {
        class: "react-tooltip-custom",
        id: "wiretapicon",
        place: "top",
        type: "dark",
        effect: "solid",
        offset: {
          top: 4
        }
      }, "Powered by WireTAP")))), /*#__PURE__*/React__default.createElement(Description, {
        text: theatre && theatre.address && (theatre.address.area ? "".concat(theatre.address.area, ", ") : "") + (theatre.address.city ? "".concat(theatre.address.city, ", ") : "") + (theatre.address.state ? "".concat(theatre.address.state, ", ") : "") + (theatre.address.country ? "".concat(theatre.address.country) : "")
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block halfwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Address"), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, theatre && theatre.address && (theatre.address.street ? "".concat(theatre.address.street, ",") : ""), /*#__PURE__*/React__default.createElement("br", null), ' ', theatre && theatre.address && (theatre.address.city ? "".concat(theatre.address.city, " ") : "") + (theatre.address.postalCode ? "".concat(theatre.address.postalCode) : "")))), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-blocks__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block fullwidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__title"
      }, "Alternate Names "), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-block__description"
      }, theatre && theatre.alternate_names && (theatre.alternate_names.length > 0 ? this.state.expand ? this.renderAllAlternateNames() : this.renderPartialAlternateNames() : "-")))));
    }
  }]);

  return TheatreInfoModal;
}(React__default.Component);

function _createSuper$t(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$t(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$t() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TheatreCard = /*#__PURE__*/function (_React$Component) {
  _inherits(TheatreCard, _React$Component);

  var _super = _createSuper$t(TheatreCard);

  function TheatreCard(props) {
    var _this;

    _classCallCheck(this, TheatreCard);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      _this.setState({
        modalvisible: false
      });
    });

    _this.state = {
      expand: false,
      modalvisible: false
    };
    _this.expandCard = _this.expandCard.bind(_assertThisInitialized(_this));
    _this.checkBox = _this.checkBox.bind(_assertThisInitialized(_this));
    _this.openTheatreInfo = _this.openTheatreInfo.bind(_assertThisInitialized(_this));
    _this.handleCancel = _this.handleCancel.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TheatreCard, [{
    key: "expandCard",
    value: function expandCard(e) {
      e.stopPropagation();
      this.setState({
        expand: !this.state.expand
      });
    }
  }, {
    key: "checkBox",
    value: function checkBox(e) {
      e.stopPropagation();
      var _this$props = this.props;
          _this$props.selected;
          _this$props.index;
          var theatre = _this$props.theatre,
          handleAddTheatre = _this$props.handleAddTheatre;
          _this$props.type;
          _this$props.edit;
      console.log('checkBox theatre', theatre);
      handleAddTheatre && handleAddTheatre(theatre);
    }
  }, {
    key: "openTheatreInfo",
    value: function openTheatreInfo(e) {
      e.stopPropagation();
      this.setState({
        modalvisible: true
      });
    }
  }, {
    key: "renderIconsForTheatreInList",
    value: function renderIconsForTheatreInList() {
      var _this$props2 = this.props,
          theatre = _this$props2.theatre,
          selected = _this$props2.selected;
          _this$props2.listView;
          _this$props2.type;
          var mode = _this$props2.mode;

      if (mode === 'exhibitor') {
        if (selected) {
          return /*#__PURE__*/React__default.createElement(AppIcon, {
            name: "SelectedFull"
          });
        }

        return /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "SelectedEmpty"
        });
      }

      if (selected) {
        if (this.props.getSelectedScreenCount(selected, theatre) < (theatre.screens && theatre.screens.length)) {
          _.findIndex(theatre.screens, function (screen) {
            return screen.isInList === true;
          });

          return /*#__PURE__*/React__default.createElement(AppIcon, {
            name: "SelectedPartial"
          });
        }

        _.findIndex(theatre.screens, function (screen) {
          return screen.isInList === true;
        });

        return /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "SelectedFull"
        });
      }

      return /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "SelectedEmpty"
      });
    }
  }, {
    key: "isSelectedTheatreScreenNotInList",
    value: function isSelectedTheatreScreenNotInList() {
      var _this$props3 = this.props,
          theatre = _this$props3.theatre,
          selected = _this$props3.selected,
          theatresInBooking = _this$props3.theatresInBooking;
      var screenNotInList = false;

      var theatreIndex = _.findIndex(theatresInBooking, function (th) {
        return th.id === theatre.id;
      });

      if (selected) {
        _.forEach(theatresInBooking[theatreIndex].screens, function (sc) {
          if (sc.selected && sc.hasOwnProperty('isInList') && !sc.isInList) {
            screenNotInList = true;
          }
        });
      }

      return screenNotInList;
    }
  }, {
    key: "renderErrorIcon",
    value: function renderErrorIcon() {
      var theatre = this.props.theatre;
      var totaldeviceErrors = 0;

      if (theatre) {
        _.forEach(theatre.screens, function (screen) {
          screen.deviceErrors.length ? totaldeviceErrors++ : null;
        });
      }

      if (totaldeviceErrors > 0 || !this.isTheatreAddressValid(theatre && theatre.address)) {
        return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
          "data-tip": true,
          "data-for": theatre.id,
          className: "theatre-card-error-icon"
        }, /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "AssestError"
        })), /*#__PURE__*/React__default.createElement(ReactTooltip, {
          class: "react-tooltip-custom",
          id: theatre && theatre.id,
          place: "top",
          type: "dark",
          effect: "solid"
        }, /*#__PURE__*/React__default.createElement("span", null, "Some screens have missing device information")));
      }
    }
  }, {
    key: "isTheatreAddressValid",
    value: function isTheatreAddressValid(theatreAddress) {
      if (theatreAddress) {
        return theatreAddress && !_.isEmpty(theatreAddress.country);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var expand = this.state.expand;
      var _this$props4 = this.props,
          theatre = _this$props4.theatre,
          getSelectedScreenCount = _this$props4.getSelectedScreenCount,
          selected = _this$props4.selected,
          handleAddScreen = _this$props4.handleAddScreen,
          index = _this$props4.index,
          theatresInBooking = _this$props4.theatresInBooking;
          _this$props4.removeTheatresFromBooking;
          var listView = _this$props4.listView,
          editListView = _this$props4.editListView,
          type = _this$props4.type,
          edit = _this$props4.edit,
          pricingModel = _this$props4.pricingModel,
          shouldShowPrice = _this$props4.shouldShowPrice,
          theatreMatchedId = _this$props4.theatreMatchedId,
          removeTheatre = _this$props4.removeTheatre,
          handleRemoveTheatre = _this$props4.handleRemoveTheatre,
          showTheatreInfo = _this$props4.showTheatreInfo,
          shouldShowExpand = _this$props4.shouldShowExpand,
          showWireTapIcon = _this$props4.showWireTapIcon;
      var totalCount;
      var selectView = ['theatre-card-select-view'];
      var theatreInfoIcon = ['theatre-info'];

      if (theatre) {
        totalCount = theatre.screens && theatre.screens.length;
      }

      if (!removeTheatre && !showTheatreInfo) {
        selectView.push('mg-left');
      } else if (!removeTheatre) {
        theatreInfoIcon.push('mg-left');
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-item-card-overview"
      }, this.props.showTheatreInfo ? /*#__PURE__*/React__default.createElement(TheatreInfoModal, {
        open: this.state.modalvisible,
        handleCancel: this.handleCancel,
        theatre: theatre,
        showWireTapIcon: showWireTapIcon
      }) : null, theatre && theatre.name && /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-item-card-description",
        onClick: this.checkBox
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-header"
      }, shouldShowExpand && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, expand ? /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick(e) {
          return _this2.expandCard(e);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "ChevronDown"
      })) : /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick(e) {
          return _this2.expandCard(e);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "ChevronRight"
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-details-view"
      }, /*#__PURE__*/React__default.createElement(TheatreName, {
        name: theatre && theatre.name ? theatre.name : ''
      })), showWireTapIcon ? theatre && theatre.wiretaps && theatre.wiretaps.length > 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "wire-tap-icon"
      }, /*#__PURE__*/React__default.createElement("div", {
        "data-tip": true,
        "data-for": "wiretapicon"
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "WireTap",
        color: 'primary',
        size: 16
      })), /*#__PURE__*/React__default.createElement(ReactTooltip, {
        class: "react-tooltip-custom",
        id: "wiretapicon",
        place: "top",
        type: "dark",
        effect: "solid",
        offset: {
          top: 4
        }
      }, "Powered by WireTAP")) : null, this.renderErrorIcon(), removeTheatre ? /*#__PURE__*/React__default.createElement(CloseOutlined$1, {
        onClick: function onClick(e) {
          return handleRemoveTheatre(e);
        }
      }) : null, this.props.showTheatreInfo ? /*#__PURE__*/React__default.createElement("div", {
        className: theatreInfoIcon.join(' '),
        onClick: function onClick(e) {
          return _this2.openTheatreInfo(e);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "InfoCircle"
      })) : null, shouldShowPrice ? /*#__PURE__*/React__default.createElement("div", {
        className: selectView.join(' ')
      }, theatre.dcpPrice !== null ? /*#__PURE__*/React__default.createElement("span", {
        className: pricingModel ? 'theatre-dcp-price' : 'theatre-dcp-kdm-dcp'
      }, /*#__PURE__*/React__default.createElement("div", null, (theatre.dcpPrice / 100).toFixed(2))) : '', pricingModel ? /*#__PURE__*/React__default.createElement("span", {
        className: "theatre-kdm-price"
      }, /*#__PURE__*/React__default.createElement("div", null, calculateKdmPrice(theatre, pricingModel))) : '', /*#__PURE__*/React__default.createElement("span", null, (pricingModel || theatre.dcpPrice !== null || theatre.dcpPrice !== undefined) && /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-select-view-cursor theatre-total-price"
      }, getKdmDcpPrice(theatre, pricingModel)))) : /*#__PURE__*/React__default.createElement("div", {
        className: selectView.join(' ')
      }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-select-view-cursor"
      }, this.renderIconsForTheatreInList())))), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-footer",
        style: !shouldShowExpand ? {
          paddingLeft: '8px'
        } : {}
      }, theatre && theatre.address && /*#__PURE__*/React__default.createElement(TheatreAddress, {
        address: "".concat(theatre.address.city && "".concat(theatre.address.city, ","), "\n                                 ").concat(theatre.address.state && "".concat(theatre.address.state, ","), "\n                                 ").concat(theatre.address.country && theatre.address.country)
      }), totalCount && getSelectedScreenCount && /*#__PURE__*/React__default.createElement("div", {
        className: "screens-count"
      }, /*#__PURE__*/React__default.createElement(Description, {
        text: "".concat(getSelectedScreenCount(selected, theatre), "/").concat(totalCount)
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "screen-txt"
      }, "Screens")), theatreMatchedId && theatreMatchedId.id && /*#__PURE__*/React__default.createElement(TheatreId, {
        domain: theatreMatchedId.domain,
        id: theatreMatchedId.id
      }))), expand && /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-item-card-list"
      }, shouldShowPrice && (pricingModel || theatre.dcpPrice !== null || theatre.dcpPrice !== undefined) ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-list-view"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "qw-label-text"
      }, "DCP Price: USD", ' ', theatre.dcpPrice ? (theatre.dcpPrice / 100).toFixed(2) : '0.00')), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-card-list-view"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "qw-label-text"
      }, "KDM Price: USD ", calculateKdmPrice(theatre, pricingModel)))) : '', /*#__PURE__*/React__default.createElement(ScreensList, {
        list: theatre && theatre.screens,
        handleAddScreen: handleAddScreen,
        pricingModel: pricingModel,
        dcpPrice: theatre.dcpPrice,
        listType: type,
        theatre: theatre,
        theatreIndex: index,
        theatresInBooking: theatresInBooking,
        listView: listView,
        editListView: editListView,
        edit: edit,
        shouldShowPrice: shouldShowPrice
      })));
    }
  }]);

  return TheatreCard;
}(React__default.Component);
TheatreCard.defaultProps = {
  shouldShowExpand: true
};

function TertiaryButton(props) {
  var style = props.style,
      clickEvent = props.clickEvent,
      btnName = props.btnName;
  return /*#__PURE__*/React__default.createElement("button", {
    className: "btn-default tertiary-btn",
    onClick: clickEvent,
    style: style || {}
  }, btnName);
}

TertiaryButton.defaultProps = {
  style: {}
};

var _excluded$2 = ["percent", "showInfo"];

var ProgressBar = function ProgressBar(props) {
  var percent = props.percent,
      showInfo = props.showInfo,
      otherProps = _objectWithoutProperties(props, _excluded$2);

  return /*#__PURE__*/React__default.createElement(_Progress, _extends({
    percent: percent,
    status: "active",
    showInfo: showInfo
  }, otherProps));
};

ProgressBar.defaultProps = {
  percent: 0,
  showInfo: false
};

var antIcon = /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
  style: {
    fontSize: 24
  },
  spin: true
});

var SearchBar = function SearchBar(props) {
  var value = props.value,
      placeholder = props.placeholder,
      size = props.size,
      style = props.style,
      onSearch = props.onSearch,
      onChange = props.onChange,
      getPopupContainer = props.getPopupContainer,
      notFoundContent = props.notFoundContent,
      notFoundMessage = props.notFoundMessage;
  return /*#__PURE__*/React__default.createElement(_Select, {
    showSearch: true,
    allowClear: true,
    value: value,
    placeholder: placeholder,
    style: style,
    size: size,
    defaultActiveFirstOption: false,
    suffixIcon: /*#__PURE__*/React__default.createElement(SearchOutlined$1, null),
    filterOption: false,
    onSearch: onSearch,
    onChange: onChange,
    getPopupContainer: getPopupContainer,
    notFoundContent: notFoundContent ? /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, notFoundMessage ? notFoundMessage : /*#__PURE__*/React__default.createElement(_Spin, {
      indicator: antIcon,
      size: "small"
    })) : null
  }, props.children);
};

SearchBar.defaultProps = {
  value: undefined,
  placeholder: '',
  notFoundContent: false,
  onSearch: function onSearch() {},
  onChange: function onChange() {},
  getPopupContainer: function getPopupContainer() {},
  size: 'default'
};

function _createSuper$s(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$s(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$s() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CancelToken$1 = axios.CancelToken;
var cancel$1;

var TheatreSearch = /*#__PURE__*/function (_Component) {
  _inherits(TheatreSearch, _Component);

  var _super = _createSuper$s(TheatreSearch);

  function TheatreSearch(props) {
    var _this;

    _classCallCheck(this, TheatreSearch);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleRemoveTheatre", function (e) {
      var selectedTheatre = _this.state.selectedTheatre;
      var removeSearchedTheatre = _this.props.removeSearchedTheatre;
      e.stopPropagation();
      removeSearchedTheatre(selectedTheatre);

      _this.setState({
        theatreSelected: false,
        selectedTheatre: {},
        duplicateTheatre: false,
        options: [],
        searchValue: undefined
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      if (value) {
        var _this$props = _this.props,
            theatresInBooking = _this$props.theatresInBooking,
            handleAddTheatre = _this$props.handleAddTheatre;
        var searchedTheatres = _this.state.searchedTheatres;

        var selectedTheatre = _$1.find(searchedTheatres, function (theatre) {
          return theatre.id === value;
        });

        var itemIndex = _$1.findIndex(theatresInBooking, function (th) {
          return th.id === selectedTheatre.id;
        }) >= 0;

        if (itemIndex) {
          _this.setState({
            duplicateTheatre: true,
            searchValue: selectedTheatre.name
          });
        } else {
          selectedTheatre.screens = selectedTheatre.screens.map(function (screen) {
            if (screen.hasMediaBlock) {
              screen.selected = true;
            }

            return screen;
          });
          handleAddTheatre(selectedTheatre, true);

          _this.setState({
            selectedTheatre: selectedTheatre,
            theatreSelected: true
          });
        }
      } else {
        _this.setState({
          duplicateTheatre: false,
          options: [],
          searchValue: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (value) {
      var _this$props2 = _this.props,
          hostUrl = _this$props2.hostUrl,
          account = _this$props2.account,
          accessToken = _this$props2.accessToken;
      var _this$state = _this.state,
          offset = _this$state.offset,
          ps = _this$state.ps;

      _this.setState({
        duplicateTheatre: false,
        notFoundMessage: null
      });

      if (value.length >= 3) {
        if (cancel$1 !== undefined) {
          cancel$1();
        }

        var config = {
          headers: {
            Authorization: "Bearer ".concat(accessToken)
          },
          cancelToken: new CancelToken$1(function executor(c) {
            cancel$1 = c;
          })
        };
        var spec = 'spec=dci&';

        if (account.user.enableNonDCITheatreSearch) {
          spec = '';
        }

        _this.setState({
          options: [],
          notFoundContent: true
        });

        axios.get("".concat(hostUrl, "/v1/theatres/search?").concat(spec, "offset=").concat(offset, "&ps=").concat(ps, "&q=").concat(value), config).then(function (response) {
          var Option = _Select.Option;

          if (response.data.theatres.length) {
            var options = response.data.theatres.map(function (theatre, index) {
              return /*#__PURE__*/React__default.createElement(Option, {
                key: index,
                value: theatre.id
              }, /*#__PURE__*/React__default.createElement(TheatreName, {
                name: theatre.name
              }), /*#__PURE__*/React__default.createElement(TheatreAddress, {
                address: formatAddress(theatre.address)
              }));
            });

            _this.setState({
              options: options,
              notFoundContent: false,
              searchedTheatres: response.data.theatres
            });
          } else {
            _this.setState({
              notFoundMessage: 'No theatres found'
            });
          }
        }).catch(function (error) {
          if (!axios.isCancel(error)) {
            handleAppError(error, 'Error in Getting Theatre');
          }
        });
      } else {
        _this.setState({
          options: []
        });
      }
    });

    _this.state = {
      offset: 0,
      ps: 5,
      options: [],
      notFoundContent: false,
      theatreSelected: false,
      selectedTheatre: {},
      searchedTheatres: [],
      duplicateTheatre: false,
      searchValue: undefined,
      notFoundMessage: null
    };
    return _this;
  }

  _createClass(TheatreSearch, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          selectedTheatre = _this$state2.selectedTheatre,
          notFoundContent = _this$state2.notFoundContent,
          options = _this$state2.options,
          duplicateTheatre = _this$state2.duplicateTheatre,
          searchValue = _this$state2.searchValue,
          notFoundMessage = _this$state2.notFoundMessage,
          theatreSelected = _this$state2.theatreSelected;
      var _this$props3 = this.props,
          getSelectedScreenCount = _this$props3.getSelectedScreenCount,
          theatresInBooking = _this$props3.theatresInBooking,
          handleAddScreen = _this$props3.handleAddScreen,
          handleAddTheatre = _this$props3.handleAddTheatre,
          id = _this$props3.id;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, theatreSelected ? /*#__PURE__*/React__default.createElement(TheatreCard, {
        theatre: selectedTheatre,
        showTheatreInfo: true,
        showWireTapIcon: true,
        removeTheatre: true,
        handleRemoveTheatre: this.handleRemoveTheatre,
        index: selectedTheatre.id,
        selected: _$1.findIndex(theatresInBooking, function (th) {
          return th.id === selectedTheatre.id;
        }) >= 0,
        getSelectedScreenCount: getSelectedScreenCount,
        theatresInBooking: theatresInBooking,
        handleAddTheatre: handleAddTheatre,
        handleAddScreen: handleAddScreen
      }) : /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-search-modal"
      }, /*#__PURE__*/React__default.createElement("div", {
        id: 'theatre-search' + id,
        className: "theatre-search-outer"
      }, /*#__PURE__*/React__default.createElement(SearchBar, {
        value: searchValue,
        placeholder: 'Search and Select Theatre',
        style: {
          width: '365px'
        },
        onSearch: this.onSearch,
        onChange: this.onChange,
        size: 'small',
        getPopupContainer: function getPopupContainer() {
          return document.getElementById('theatre-search' + id);
        },
        notFoundContent: notFoundContent,
        notFoundMessage: notFoundMessage
      }, options)), duplicateTheatre ? /*#__PURE__*/React__default.createElement("div", {
        className: "duplicate-theatre-warning"
      }, I18n.t('theatre_select_modal.theatre_already_selected')) : null));
    }
  }]);

  return TheatreSearch;
}(Component);

function _createSuper$r(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$r(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$r() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TheatreSelectModal = /*#__PURE__*/function (_React$Component) {
  _inherits(TheatreSelectModal, _React$Component);

  var _super = _createSuper$r(TheatreSelectModal);

  function TheatreSelectModal(props) {
    var _this;

    _classCallCheck(this, TheatreSelectModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "removeSearchedTheatre", function (theatre) {
      var theatresInBooking = _this.state.theatresInBooking;
      var tempList = theatresInBooking;

      var theatreIndex = _$1.findIndex(theatresInBooking, function (th) {
        return th.id === theatre.id;
      });

      if (theatreIndex > -1) {
        tempList.splice(theatreIndex, 1);
      }

      _this.setState({
        theatresInBooking: tempList
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedScreenCount", function (selected, theatre) {
      var theatresInBooking = _this.state.theatresInBooking;
      var selectedScreensCount = 0;
      var theatreIndex;

      if (theatresInBooking) {
        theatreIndex = _$1.findIndex(theatresInBooking, function (th) {
          return th.id === theatre.id;
        });
      }

      if (selected) {
        selectedScreensCount = _$1.filter(theatresInBooking[theatreIndex].screens, function (sc) {
          return sc.selected;
        }).length;
      }

      return selectedScreensCount;
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddTheatre", function (theatre) {
      var oldTheatre = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var theatreToProcess = _$1.cloneDeep(theatre);

      theatreToProcess.screensToProcess = _$1.filter(theatreToProcess.screens, function (screen) {
        return screen.hasMediaBlock;
      });
      theatreToProcess.screensToProcess = _$1.map(theatreToProcess.screensToProcess, 'id');

      _this.addTheatreToBooking([theatreToProcess], oldTheatre);
    });

    _defineProperty(_assertThisInitialized(_this), "addTheatreToBooking", function (list) {
      var oldTheatre = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var tempList = _$1.cloneDeep(_this.state.theatresInBooking);

      var theatreList = list[0];
      var itemIndex = tempList.findIndex(function (item) {
        return item.id === theatreList.id;
      });
      theatreList.screens.map(function (item) {
        item['selected'] = true;
      });

      if (itemIndex > -1 && !oldTheatre) {
        tempList.splice(itemIndex, 1);
      } else if (!(itemIndex > -1) && oldTheatre || !oldTheatre) {
        tempList.push(theatreList);
      }

      _this.setState({
        theatresInBooking: tempList
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddScreen", function (index, theatreIndex, screen, theatre, selected) {
      _this.handleScreenBooking(theatreIndex, index, selected, theatre, screen);
    });

    _defineProperty(_assertThisInitialized(_this), "handleScreenBooking", function (selectionIndex, screenIndex, selected, theatre, screen) {
      var tempList = _this.state.theatresInBooking;

      var theatreIndex = _$1.findIndex(tempList, function (th) {
        return th.id == theatre.id;
      });

      if (!_$1.isEmpty(tempList) && theatreIndex >= 0 && tempList[theatreIndex]) {
        tempList[theatreIndex].screens[screenIndex].selected = !selected;
        var hasSelected;
        tempList[theatreIndex].screens.forEach(function (item) {
          if (item.selected) {
            hasSelected = true;
          }
        });

        if (hasSelected) {
          _this.setState({
            theatresInBooking: tempList
          });
        } else {
          tempList.splice(theatreIndex, 1);

          _this.setState({
            theatresInBooking: tempList
          });
        }
      } else {
        var _tempList = _this.state.theatresInBooking;
        var tempScreen = theatre;
        tempScreen && tempScreen.screens.map(function (item) {
          if (item.id == screen.id) {
            item['selected'] = true;
          } else {
            item['selected'] = false;
          }
        });

        _tempList.push(tempScreen);

        _this.setState({
          theatresInBooking: _tempList
        });
      }
    });

    _this.state = {
      matchedTheatres: [],
      unmatchedTheatres: [],
      theatresInBooking: _this.props.theatresBookingByFile ? _this.props.theatresBookingByFile : []
    };
    _this.addTheatreToBooking = _this.addTheatreToBooking.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TheatreSelectModal, [{
    key: "renderUnMatchedThetares",
    value: function renderUnMatchedThetares() {
      var _this2 = this;

      var _this$props = this.props,
          unmatchedTheatres = _this$props.unmatchedTheatres,
          hostUrl = _this$props.hostUrl,
          account = _this$props.account,
          accessToken = _this$props.accessToken;
      var theatresInBooking = this.state.theatresInBooking;
      var ignoredTheatres = 0;
      var uniqueUnmatchedTheatres = unmatchedTheatres.filter(function (theatre) {
        if (theatre.request.name.length || theatre.request.id.length || theatre.request.screen_id.length) {
          return theatre;
        }
      });
      ignoredTheatres = unmatchedTheatres.length - uniqueUnmatchedTheatres.length;
      return uniqueUnmatchedTheatres.length !== 0 || ignoredTheatres !== 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatres-found-heading "
      }, /*#__PURE__*/React__default.createElement(_Row, null, /*#__PURE__*/React__default.createElement(_Col, {
        span: 24
      }, uniqueUnmatchedTheatres.length !== 0 ? /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-count text-capitalize"
      }, "".concat(uniqueUnmatchedTheatres.length, " ").concat(pluralize(I18n.t('theatre_select_modal.theatre'), uniqueUnmatchedTheatres.length), " Not Found")) : null, /*#__PURE__*/React__default.createElement("div", {
        className: "warning-text"
      }, uniqueUnmatchedTheatres.length !== 0 ? "".concat(I18n.t('theatre_select_modal.precise_match_not_found')) : null, ' ', ignoredTheatres !== 0 ? "".concat(ignoredTheatres, " ").concat(pluralize(I18n.t('theatre_select_modal.row'), ignoredTheatres), " ").concat(I18n.t('theatre_select_modal.without_name_id'), " ").concat(pluralize(I18n.t('theatre_select_modal.was'), ignoredTheatres), " ").concat(I18n.t('theatre_select_modal.ignored')) : null)))), /*#__PURE__*/React__default.createElement("div", {
        className: "unmatched-theatres-scroll"
      }, uniqueUnmatchedTheatres.map(function (theatre, index) {
        return /*#__PURE__*/React__default.createElement(_Row, {
          key: index
        }, /*#__PURE__*/React__default.createElement(_Col, {
          span: 12
        }, /*#__PURE__*/React__default.createElement(TheatreDefaultCard, {
          key: index,
          name: theatre.request.name,
          address: formatAddress(theatre.request.address),
          id: theatre.request.id,
          screen_id: theatre.request.screen_id,
          theatreSelect: true,
          unMatched: true
        })), /*#__PURE__*/React__default.createElement(_Col, {
          span: 12
        }, /*#__PURE__*/React__default.createElement(TheatreSearch, {
          id: index,
          hostUrl: hostUrl,
          account: account,
          accessToken: accessToken,
          getSelectedScreenCount: _this2.getSelectedScreenCount,
          theatresInBooking: theatresInBooking,
          handleAddTheatre: _this2.handleAddTheatre,
          handleAddScreen: _this2.handleAddScreen,
          removeSearchedTheatre: _this2.removeSearchedTheatre
        })));
      }))) : null;
    }
  }, {
    key: "renderMatchedTheatres",
    value: function renderMatchedTheatres() {
      var _this3 = this;

      var matchedTheatres = this.props.matchedTheatres;
      var duplicateCount = 0;
      matchedTheatres.forEach(function (theatre) {
        duplicateCount = duplicateCount + theatre.duplicateRows;
      });
      return matchedTheatres.length != 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatres-found-heading"
      }, /*#__PURE__*/React__default.createElement(_Row, null, /*#__PURE__*/React__default.createElement(_Col, {
        span: 24
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-count text-capitalize"
      }, "".concat(matchedTheatres.length, " ").concat(pluralize(I18n.t('theatre_select_modal.theatre'), matchedTheatres.length), " ").concat(I18n.t('theatre_select_modal.matched'))), duplicateCount != 0 ? /*#__PURE__*/React__default.createElement("div", {
        className: "warning-text"
      }, "".concat(duplicateCount, " ").concat(I18n.t('theatre_select_modal.duplicate'), " ").concat(pluralize(I18n.t('theatre_select_modal.row'), duplicateCount), " ").concat(pluralize(I18n.t('theatre_select_modal.was'), duplicateCount), " ").concat(I18n.t('theatre_select_modal.ignored'))) : null))), /*#__PURE__*/React__default.createElement("div", {
        className: "matched-theatres-scroll"
      }, matchedTheatres.map(function (theatre, index) {
        return /*#__PURE__*/React__default.createElement(_Row, {
          key: index
        }, /*#__PURE__*/React__default.createElement(_Col, {
          span: 12
        }, /*#__PURE__*/React__default.createElement(TheatreDefaultCard, {
          key: index,
          name: theatre.matchedColumn.name,
          address: formatAddress(theatre.matchedColumn.address ? theatre.matchedColumn.address : {}),
          id: theatre.matchedColumn.id,
          screen_id: theatre.matchedColumn.screen_id,
          theatreSelect: true,
          duplicate: theatre.duplicate,
          matchedRows: theatre.matchedRows,
          duplicateRows: theatre.duplicateRows
        })), /*#__PURE__*/React__default.createElement(_Col, {
          span: 12
        }, /*#__PURE__*/React__default.createElement(TheatreCard, {
          theatre: theatre.record,
          showTheatreInfo: true,
          showWireTapIcon: true,
          index: index,
          key: theatre.record.id + index,
          theatreMatchedId: theatre.matched_id,
          selected: _$1.findIndex(_this3.state.theatresInBooking, function (th) {
            return th.id === theatre.record.id;
          }) >= 0,
          getSelectedScreenCount: _this3.getSelectedScreenCount,
          theatresInBooking: _this3.state.theatresInBooking,
          handleAddTheatre: _this3.handleAddTheatre,
          handleAddScreen: _this3.handleAddScreen
        })));
      }))) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var theatresInBooking = this.state.theatresInBooking;
      var _this$props2 = this.props,
          visible = _this$props2.visible,
          onCancel = _this$props2.onCancel,
          addTheatresToBooking = _this$props2.addTheatresToBooking;
      return /*#__PURE__*/React__default.createElement(_Modal, {
        visible: visible,
        wrapClassName: 'theatre-upload-modal',
        title: 'Select Theatres',
        onCancel: onCancel,
        afterClose: null,
        footer: [/*#__PURE__*/React__default.createElement("div", {
          key: "canel-button",
          className: "theatre-modal-cancel",
          onClick: onCancel
        }, "Cancel"), /*#__PURE__*/React__default.createElement(PrimaryButton, {
          key: "select_button",
          disabled: theatresInBooking.length === 0 ? true : false,
          btnName: "Select ".concat(theatresInBooking.length, " ").concat(pluralize(I18n.t('theatre_select_modal.theatre'), theatresInBooking.length)),
          callbackAction: function callbackAction() {
            return addTheatresToBooking(theatresInBooking);
          }
        })]
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-select-modal"
      }, this.renderUnMatchedThetares(), this.renderMatchedTheatres()));
    }
  }]);

  return TheatreSelectModal;
}(React__default.Component);

function _createSuper$q(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$q(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$q() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MODE$1 = 'selected';
var HEIGHT_OFFSET_FROM_VIEW_BOTTOM$2 = 270; // In pixels

var Theatres = /*#__PURE__*/function (_React$Component) {
  _inherits(Theatres, _React$Component);

  var _super = _createSuper$q(Theatres);

  function Theatres(props) {
    var _this;

    _classCallCheck(this, Theatres);

    _this = _super.call(this, props);
    _this.state = {
      expandInfo: {
        index: 0,
        status: false
      },
      cachedSearchedName: props.searchedTheatreName,
      updatedOn: null
    };
    _this.handleRemoveTheatresFromBooking = _this.handleRemoveTheatresFromBooking.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Theatres, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var searchedTheatreName = nextProps.searchedTheatreName;
          nextProps.editListView;

      if (searchedTheatreName && this.state.cachedSearchedName !== searchedTheatreName) {
        this.setState({
          expandInfo: {
            index: 0,
            status: false
          },
          cachedSearchedName: searchedTheatreName
        });
      }

      this.setState({
        updatedOn: Date.now()
      });
    }
  }, {
    key: "toggleTheatreExpand",
    value: function toggleTheatreExpand(index) {
      var expandInfo = {};

      if (index === this.state.expandInfo.index) {
        expandInfo = {
          index: index,
          status: !this.state.expandInfo.status
        };
      } else {
        expandInfo = {
          index: index,
          status: true
        };
      }

      this.setState({
        expandInfo: expandInfo
      });
    }
  }, {
    key: "getExpandTheatreToggleStatus",
    value: function getExpandTheatreToggleStatus(index) {
      if (index === this.state.expandInfo.index) {
        return this.state.expandInfo.status;
      }

      return false;
    }
  }, {
    key: "handleRemoveTheatresFromBooking",
    value: function handleRemoveTheatresFromBooking(position, theatres) {
      var expandInfo = this.state.expandInfo;

      var totalScreensWithConflict = _$1.reduce(theatres[0].screens, function (sum, screen) {
        if (!screen.hasMediaBlock) {
          sum += 1;
        }

        return sum;
      }, 0);

      var shouldRemoveAllScreens = theatres[0].screens.length === totalScreensWithConflict + theatres[0].screensToProcess.length;

      if (shouldRemoveAllScreens && this.props.selectMode === MODE$1) {
        if (position === this.state.expandInfo.index) {
          expandInfo.index = -1;
        } else if (position < this.state.expandInfo.index) {
          expandInfo.index--;
        }
      }

      this.setState({
        expandInfo: expandInfo
      });
      this.props.addTheatreForBooking(theatres);
    }
  }, {
    key: "getSelectedScreenCount",
    value: function getSelectedScreenCount(selected, theatre) {
      var _this$props = this.props,
          theatresInBooking = _this$props.theatresInBooking,
          editListView = _this$props.editListView;
      var selectedScreensCount = 0;
      var theatreIndex;

      if (theatresInBooking) {
        theatreIndex = _$1.findIndex(theatresInBooking, function (th) {
          return th.id === theatre.id;
        });
      }

      if (selected) {
        selectedScreensCount = _$1.filter(theatresInBooking[theatreIndex].screens, function (sc) {
          return sc.selected;
        }).length;
      }

      if (editListView) {
        selectedScreensCount = theatresInBooking[theatreIndex] ? _$1.filter(theatresInBooking[theatreIndex].screens, function (sc) {
          return sc.isInList;
        }).length : 0;
      }

      return selectedScreensCount;
    }
  }, {
    key: "handleAddTheatre",
    value: function handleAddTheatre(theatre, selected, index) {
      var _this$props2 = this.props,
          listView = _this$props2.listView,
          mode = _this$props2.mode;

      if (mode === 'exhibitor') {
        this.props.addTheatreForBooking([theatre]);
      } else {
        var theatreToProcess = _$1.cloneDeep(theatre);

        if (listView) {
          theatreToProcess.screensToProcess = _$1.filter(theatreToProcess.screens, function (screen) {
            return screen.isInList;
          });
          theatreToProcess.screensToProcess = _$1.map(theatreToProcess.screensToProcess, function (screen) {
            return screen.id;
          });
        } else {
          theatreToProcess.screensToProcess = _$1.filter(theatreToProcess.screens, function (screen) {
            return screen.hasMediaBlock;
          });
          theatreToProcess.screensToProcess = _$1.map(theatreToProcess.screensToProcess, 'id');
        }

        this.props.addTheatreForBooking([theatreToProcess]);
      }
    }
  }, {
    key: "handleAddScreen",
    value: function handleAddScreen(index, theatreIndex, screen, theatre, selected) {
      this.props.handleScreenBooking(theatreIndex, index, selected, theatre, screen);
    }
  }, {
    key: "_renderTheatresList",
    value: function _renderTheatresList() {
      var _this2 = this;

      var _this$props3 = this.props,
          theatres = _this$props3.theatres;
          _this$props3.addTheatreForBooking;
          var theatresInBooking = _this$props3.theatresInBooking,
          listView = _this$props3.listView,
          editListView = _this$props3.editListView,
          tabType = _this$props3.tabType,
          edit = _this$props3.edit,
          mode = _this$props3.mode;
      return (theatres || []).map(function (theatre, index) {
        var _React$createElement;

        var selected = false;

        if (mode === 'exhibitor') {
          selected = _$1.findIndex(theatresInBooking, function (th) {
            return th.uuid === theatre.uuid;
          }) >= 0;
        } else if (!edit) {
          selected = _$1.findIndex(theatresInBooking, function (th) {
            return th.id === theatre.id;
          }) >= 0;
        } else {
          var screenInTheatreListCount = 0;
          theatre && theatre.screens && theatre.screens.forEach(function (item) {
            if (item.isInList) {
              screenInTheatreListCount += 1;
            }
          });

          if (screenInTheatreListCount) {
            selected = true;
          }
        }

        return /*#__PURE__*/React__default.createElement(TheatreCard, (_React$createElement = {
          showTheatreInfo: _this2.props.showTheatreInfo,
          showWireTapIcon: _this2.props.showWireTapIcon,
          index: index,
          updatedOn: _this2.state.updatedOn,
          theatre: theatre,
          key: mode === 'exhibitor' ? theatre.uuid + index : theatre.id + index,
          selected: selected,
          editListView: editListView,
          theatresInBooking: theatresInBooking,
          getSelectedScreenCount: _this2.getSelectedScreenCount.bind(_this2),
          handleAddTheatre: _this2.handleAddTheatre.bind(_this2),
          handleAddScreen: _this2.handleAddScreen.bind(_this2),
          toggleExpand: _this2.toggleTheatreExpand,
          expand: _this2.getExpandTheatreToggleStatus(index)
        }, _defineProperty(_React$createElement, "selected", selected), _defineProperty(_React$createElement, "listView", listView), _defineProperty(_React$createElement, "type", tabType), _defineProperty(_React$createElement, "edit", edit), _defineProperty(_React$createElement, "shouldShowPrice", false), _defineProperty(_React$createElement, "mode", mode), _defineProperty(_React$createElement, "shouldShowExpand", mode !== 'exhibitor'), _React$createElement));
      });
    }
  }, {
    key: "renderNoTheatresFoundMessage",
    value: function renderNoTheatresFoundMessage() {
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          textAlign: 'center'
        },
        className: "no-theatres"
      }, "No theatres found");
    }
  }, {
    key: "renderSearchInProgress",
    value: function renderSearchInProgress() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-loader",
        style: {
          height: "".concat(window.innerHeight - HEIGHT_OFFSET_FROM_VIEW_BOTTOM$2, "px")
        }
      }, /*#__PURE__*/React__default.createElement("div", null, this.props.isLoading && /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      })));
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      }));
    }
  }, {
    key: "renderInfiniteTheatresList",
    value: function renderInfiniteTheatresList() {
      var hasMoreLoading = this.props.hasMoreLoading;
      return /*#__PURE__*/React__default.createElement("div", null, this._renderTheatresList(), hasMoreLoading && this.renderLoading());
    }
  }, {
    key: "renderTheatresList",
    value: function renderTheatresList() {
      var _this$props4 = this.props;
          _this$props4.isLoading;
          var hasMoreLoading = _this$props4.hasMoreLoading;

      if (this.props.forSearchResults) {
        return /*#__PURE__*/React__default.createElement("div", null, this.renderInfiniteTheatresList());
      }

      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: 'relative'
        }
      }, this._renderTheatresList(), hasMoreLoading && /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: 'absolute'
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          theatres = _this$props5.theatres,
          searchedTheatreName = _this$props5.searchedTheatreName,
          isLoading = _this$props5.isLoading;

      if (!theatres || theatres.length === 0) {
        if (!isLoading && !searchedTheatreName) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "theatres-empty-state"
          }, "Search and Select Theatres");
        }

        if (!isLoading && searchedTheatreName && searchedTheatreName.length > 2) {
          return this.renderNoTheatresFoundMessage();
        }

        if (searchedTheatreName && searchedTheatreName.length > 2) {
          return this.renderSearchInProgress();
        }

        return /*#__PURE__*/React__default.createElement("div", {
          className: "theatres-empty-state"
        }, "Search and Select Theatres");
      }

      return this.renderTheatresList();
    }
  }]);

  return Theatres;
}(React__default.Component);

function _createSuper$p(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$p(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$p() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MIN_SEARCH_TEXT_LEN = 2;
var CancelToken = axios.CancelToken;
var cancel;

var TheatresViewPage = /*#__PURE__*/function (_React$Component) {
  _inherits(TheatresViewPage, _React$Component);

  var _super = _createSuper$p(TheatresViewPage);

  function TheatresViewPage(props) {
    var _this;

    _classCallCheck(this, TheatresViewPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "addTheatresToBookings", function (list) {
      _this.props.addTheatresToBooking(list);

      _this.closeTheatreSelectModal();
    });

    _this.state = {
      searchText: '',
      offset: 0,
      ps: 10,
      error: false,
      isLoading: false,
      hasMoreTheatres: false,
      hasMoreLoading: false,
      visible: false,
      percent: 0,
      theatreSelectModalVisible: false,
      matchedTheatres: [],
      theatresBookingByFile: [],
      unmatchedTheatres: []
    };
    _this.emitEmpty = _this.emitEmpty.bind(_assertThisInitialized(_this));
    _this.searchInput = _this.searchInput.bind(_assertThisInitialized(_this));
    _this.theatreListScroll = _this.theatreListScroll.bind(_assertThisInitialized(_this));
    _this.getTheatres = _this.getTheatres.bind(_assertThisInitialized(_this));
    _this.getTheatres = _$1.debounce(_this.getTheatres, 1000);
    _this.uploadCsvModal = _this.uploadCsvModal.bind(_assertThisInitialized(_this));
    _this.cancelCsvUpload = _this.cancelCsvUpload.bind(_assertThisInitialized(_this));
    _this.uploadFile = _this.uploadFile.bind(_assertThisInitialized(_this));
    _this.closeTheatreSelectModal = _this.closeTheatreSelectModal.bind(_assertThisInitialized(_this));
    _this.cancelFileUpload = _this.cancelFileUpload.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TheatresViewPage, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.getElementById('theatres-list-overview-scroll').removeEventListener('scroll', this.theatreListScroll);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // var elmnt = document.getElementById("layout-content-scroll");
      // if(elmnt){
      //   elmnt.scrollTop = 0
      // }
      if (document.getElementById('theatres-list-overview-scroll')) {
        document.getElementById('theatres-list-overview-scroll').addEventListener('scroll', this.theatreListScroll, true);
      }
    }
  }, {
    key: "closeTheatreSelectModal",
    value: function closeTheatreSelectModal() {
      this.setState({
        theatreSelectModalVisible: false
      });
    }
  }, {
    key: "cancelFileUpload",
    value: function cancelFileUpload() {
      cancel();
      this.setState({
        percent: 0,
        visible: false
      });
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(e) {
      var _this2 = this;

      this.setState({
        visible: true
      });
      var _this$props = this.props,
          accessToken = _this$props.accessToken,
          theatreUrl = _this$props.theatreUrl,
          showAppBusy = _this$props.showAppBusy,
          handleAppError = _this$props.handleAppError;
      var form = new FormData();
      form.append('file', new Blob([e.target.files[0]], {
        type: 'text/csv'
      }));
      var config = {
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        },
        onUploadProgress: function onUploadProgress(progressEvent) {
          var loaded = progressEvent.loaded,
              total = progressEvent.total;
          var percent = Math.floor(loaded * 100 / total);
          console.log(percent);

          _this2.setState({
            percent: percent
          });

          if (percent === 100) {
            _this2.cancelCsvUpload();

            showAppBusy(true);
          }
        },
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        })
      };
      axios.post("".concat(theatreUrl, "/v1/facility/search"), form, config).then(function (response) {
        _this2.setState({
          percent: 0
        });

        var theatres = _$1.sortBy(response.data, ['order']);

        var unmatchedTheatres = theatres.filter(function (theatre) {
          return theatre.matched === false;
        });
        var matchedTheatres = theatres.filter(function (theatre) {
          return theatre.matched === true;
        });
        matchedTheatres = processTheatres(matchedTheatres);
        matchedTheatres = combineTheatreRows(matchedTheatres);
        var theatresForBooking = matchedTheatres.map(function (theatre) {
          return theatre.record;
        });
        theatresForBooking = _$1.uniqBy(theatresForBooking, function (theatre) {
          return theatre.id;
        });
        unmatchedTheatres = unmatchedTheatres.map(function (theatre) {
          theatre.request = processTheatreRequestData(theatre.request);
          return theatre;
        });
        var uniqueUnmatchedTheatres = unmatchedTheatres.filter(function (theatre) {
          if (theatre.request.name.length || theatre.request.id.length || theatre.request.screen_id.length) {
            return theatre;
          }
        });
        showAppBusy(false);

        if (matchedTheatres.length !== 0 || uniqueUnmatchedTheatres.length !== 0) {
          _this2.setState({
            unmatchedTheatres: unmatchedTheatres,
            matchedTheatres: matchedTheatres,
            theatresBookingByFile: theatresForBooking
          });

          _this2.setState({
            theatreSelectModalVisible: true
          });
        } else {
          ErrorMessage(I18n.t('theatre_select_modal.invalid_file_message'));
        }
      }).catch(function (error) {
        showAppBusy(false);

        if (!axios.isCancel(error)) {
          handleAppError(error, 'Invalid File', error.response.data.message);
        }
      });
      document.getElementById('csvupload').value = '';
    }
  }, {
    key: "cancelCsvUpload",
    value: function cancelCsvUpload() {
      this.setState({
        visible: false
      });
    }
  }, {
    key: "uploadCsvModal",
    value: function uploadCsvModal() {
      document.getElementById('csvupload').click();
    }
  }, {
    key: "theatreListScroll",
    value: function theatreListScroll() {
      var _this3 = this;

      var hasMoreLoading = this.state.hasMoreLoading;
      var scrollElem = document.getElementById('theatres-list-overview-scroll');

      if (Math.ceil(scrollElem.scrollHeight - scrollElem.scrollTop) == scrollElem.clientHeight) {
        if (this.state.hasMoreTheatres && !hasMoreLoading) {
          this.setState({
            offset: this.state.offset + 10,
            hasMoreLoading: true
          }, function () {
            return _this3.loadMoreTheatres();
          });
        }
      }
    }
  }, {
    key: "searchTheatreResults",
    value: function searchTheatreResults() {
      var _this4 = this;

      var searchText = this.state.searchText;

      if (searchText.length > 2) {
        this.setState({
          isLoading: true,
          offset: 0
        }, function () {
          return _this4.getTheatres();
        }); // cancelAllPendingRequest(() => {
        //   this.setState({isLoading: true}, () => this.getTheatres())
        // })
      } else {
        this.setState({
          theatresList: [],
          isLoading: false
        }); // source.cancel('Operation canceled by the user.');
      }
    }
  }, {
    key: "shouldTheatresSectionBeVisible",
    value: function shouldTheatresSectionBeVisible() {
      var searchText = this.state.searchText;
      return searchText && searchText.length > MIN_SEARCH_TEXT_LEN;
    }
  }, {
    key: "shouldAddTheatreSectionBeHidden",
    value: function shouldAddTheatreSectionBeHidden() {
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          theatresList = _this$state.theatresList;
      return isLoading && theatresList && theatresList.length === 0;
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var _this5 = this;

      this.setState({
        searchText: e.target.value,
        theatresList: []
      }, function () {
        return _this5.searchTheatres();
      });
    }
  }, {
    key: "searchTheatres",
    value: function searchTheatres() {
      var searchText = this.state.searchText;

      if (searchText.length > 2) {
        this.searchTheatreResults();
      }
    }
  }, {
    key: "emitEmpty",
    value: function emitEmpty() {
      var _this6 = this;

      this.setState({
        offset: 0,
        searchText: ''
      }, function () {
        return _this6.searchTheatreResults();
      });
    }
  }, {
    key: "searchInput",
    value: function searchInput() {
      this.searchTheatreResults();
    }
  }, {
    key: "getTheatres",
    value: function getTheatres() {
      var _this7 = this;

      var _this$props2 = this.props,
          hostUrl = _this$props2.hostUrl,
          accessToken = _this$props2.accessToken,
          account = _this$props2.account,
          theatreSearchUrl = _this$props2.theatreSearchUrl,
          mode = _this$props2.mode;
      var _this$state2 = this.state,
          searchText = _this$state2.searchText,
          offset = _this$state2.offset,
          ps = _this$state2.ps;
          _this$state2.isLoading;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      };

      if (mode === 'exhibitor') {
        axios.get("".concat(hostUrl, "/").concat(theatreSearchUrl, "?offset=").concat(offset, "&ps=").concat(ps, "&q=").concat(searchText), config).then(function (response) {
          if (response.status >= 200 && response.status <= 300) {
            if (searchText.length) {
              _this7.setState({
                theatresList: response.data.facilities,
                isLoading: false,
                hasMoreTheatres: response.data.hasMoreTheatres
              });
            }
          }
        }).catch(function (error) {});
      } else {
        var spec = 'spec=dci&';

        if (account && account.user.enableNonDCITheatreSearch) {
          spec = '';
        }

        axios.get("".concat(hostUrl, "/").concat(theatreSearchUrl, "?").concat(spec, "offset=").concat(offset, "&ps=").concat(ps, "&q=").concat(searchText), config).then(function (response) {
          if (response.status >= 200 && response.status <= 300) {
            if (searchText.length) {
              _this7.setState({
                theatresList: response.data.theatres,
                isLoading: false,
                hasMoreTheatres: response.data.hasMoreTheatres
              });
            }
          }
        }).catch(function (error) {});
      }
    }
  }, {
    key: "loadMoreTheatres",
    value: function loadMoreTheatres() {
      var _this8 = this;

      var _this$props3 = this.props,
          hostUrl = _this$props3.hostUrl,
          accessToken = _this$props3.accessToken,
          account = _this$props3.account;
      var _this$state3 = this.state,
          searchText = _this$state3.searchText,
          offset = _this$state3.offset,
          ps = _this$state3.ps;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      };
      var spec = 'spec=dci&';

      if (account.user.enableNonDCITheatreSearch) {
        spec = '';
      }

      axios.get("".concat(hostUrl, "/v1/theatres/search?").concat(spec, "offset=").concat(offset, "&ps=").concat(ps, "&q=").concat(searchText), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          _this8.setState({
            theatresList: [].concat(_toConsumableArray(_this8.state.theatresList), _toConsumableArray(response.data.theatres)),
            hasMoreTheatres: response.data.hasMoreTheatres,
            hasMoreLoading: false
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      var _this$props4 = this.props;
          _this$props4.theatres;
          _this$props4.addTheatreForBooking;
          var theatresInBooking = _this$props4.theatresInBooking;
          _this$props4.addTheatre;
          var tabType = _this$props4.tabType,
          hostUrl = _this$props4.hostUrl,
          account = _this$props4.account,
          accessToken = _this$props4.accessToken,
          shouldShowUploadCSV = _this$props4.shouldShowUploadCSV,
          mode = _this$props4.mode;
      var _this$state4 = this.state,
          searchText = _this$state4.searchText,
          isLoading = _this$state4.isLoading,
          theatresList = _this$state4.theatresList,
          hasMoreLoading = _this$state4.hasMoreLoading,
          theatreSelectModalVisible = _this$state4.theatreSelectModalVisible,
          unmatchedTheatres = _this$state4.unmatchedTheatres,
          matchedTheatres = _this$state4.matchedTheatres,
          theatresBookingByFile = _this$state4.theatresBookingByFile,
          percent = _this$state4.percent,
          visible = _this$state4.visible;
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-search-header"
      }, /*#__PURE__*/React__default.createElement(SearchBox, {
        value: searchText,
        emitEmpty: this.emitEmpty,
        suffix: true,
        error: false,
        searchButton: true,
        placeholder: "Search for theatres",
        searchClick: this.searchInput.bind(this),
        onTextChange: this.handleChange.bind(this)
      }), shouldShowUploadCSV && /*#__PURE__*/React__default.createElement("div", {
        className: "csvupload-button"
      }, /*#__PURE__*/React__default.createElement("input", {
        type: "file",
        id: "csvupload",
        accept: ".csv",
        hidden: true,
        onChange: this.uploadFile
      }), /*#__PURE__*/React__default.createElement(TertiaryButton, {
        btnName: "Select using CSV",
        clickEvent: this.uploadCsvModal,
        style: {
          margin: '0px 8px',
          display: 'inline',
          color: ''
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        "data-tip": true,
        "data-for": "csv"
      }, /*#__PURE__*/React__default.createElement(IconButton, {
        icon: /*#__PURE__*/React__default.createElement(AppIcon, {
          name: "InfoCircle",
          color: "black"
        })
      })), /*#__PURE__*/React__default.createElement(ReactTooltip, {
        class: "react-tooltip-custom",
        id: "csv",
        place: "top",
        type: "dark",
        effect: "solid"
      }, I18n.t('theatres_select_page.csv_template_text'))), /*#__PURE__*/React__default.createElement(CommonModal, {
        visible: visible,
        wrapClassName: "vertical-center-modal modal-medium ",
        title: null,
        onCancel: null,
        afterClose: null,
        closable: false,
        footer: null
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "uploading-csv"
      }, "Uploading CSV"), /*#__PURE__*/React__default.createElement(ProgressBar, {
        percent: percent,
        showInfo: false
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "cancel-upload",
        onClick: this.cancelFileUpload
      }, "Cancel")), theatreSelectModalVisible ? /*#__PURE__*/React__default.createElement(TheatreSelectModal, {
        visible: theatreSelectModalVisible,
        onCancel: this.closeTheatreSelectModal,
        unmatchedTheatres: unmatchedTheatres,
        matchedTheatres: matchedTheatres,
        theatresBookingByFile: theatresBookingByFile,
        addTheatresToBooking: this.addTheatresToBookings.bind(this),
        hostUrl: hostUrl,
        accessToken: accessToken,
        account: account
      }) : null), /*#__PURE__*/React__default.createElement("div", {
        id: "theatres-list-overview-scroll",
        className: classNames('theatre-selection-card-scroll-view', {
          hiddens: !this.shouldTheatresSectionBeVisible()
        })
      }, /*#__PURE__*/React__default.createElement(Theatres, {
        showTheatreInfo: true,
        showWireTapIcon: mode != 'exhibitor',
        theatres: theatresList,
        isLoading: isLoading,
        addTheatreForBooking: function addTheatreForBooking(list) {
          return _this9.props.addTheatreToBooking(list);
        },
        handleScreenBooking: function handleScreenBooking(theatreIndex, screenIndex, selected, theatre, screen) {
          return _this9.props.handleScreenBooking(theatreIndex, screenIndex, selected, theatre, screen);
        },
        hasMoreLoading: hasMoreLoading,
        tabType: tabType,
        searchedTheatreName: searchText,
        forSearchResults: true,
        theatresInBooking: theatresInBooking,
        mode: mode
      })));
    }
  }]);

  return TheatresViewPage;
}(React__default.Component);
TheatresViewPage.defaultProps = {
  shouldShowUploadCSV: true
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime_1 = createCommonjsModule(function (module) {
var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var regenerator = runtime_1;

// History related constants

var PENDING_APPROVAL = 'pending approval';
var QUEUED = 'queued';
var SUCCESS = 'success';
var FAILED = 'failed'; // List type

var FESTIVALS = 'festivals';
var THEATRE_LISTS = 'theatreLists'; // CPL/DKDM file identifier
var COMPLETELY_SELECTED = 2;
var PARTIALLY_SELECTED = 1;
var NOT_SELECTED = 0; // Assign Rights DKDM TREX States

function _createSuper$o(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$o(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$o() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TheatreList = /*#__PURE__*/function (_React$Component) {
  _inherits(TheatreList, _React$Component);

  var _super = _createSuper$o(TheatreList);

  function TheatreList(props) {
    var _this;

    _classCallCheck(this, TheatreList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getListArray", function (type) {
      _this.props.listType;
      var _this$props = _this.props,
          hostUrl = _this$props.hostUrl,
          accessToken = _this$props.accessToken,
          theatreList = _this$props.theatreList;
      var config = {
        headers: {
          Authorization: "Bearer " + accessToken
        }
      };
      axios.get("".concat(hostUrl, "/v1/theatrelists/").concat(theatreList.id), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          this.setState({
            theatreListValue: response.data.theatres,
            theatreLoading: false
          });

          if (type) {
            this.proceedToBooking();
            this.props.fetchingFunction(false);
          }
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        console.log(error);
      }.bind(_assertThisInitialized(_this)));
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddListToBooking", function () {
      var _this$props2 = _this.props;
          _this$props2.theatreList;
          _this$props2.selected;
          var listViewFetching = _this$props2.listViewFetching;
      var theatreListValue = _this.state.theatreListValue;

      if (!theatreListValue.length) {
        if (!listViewFetching) {
          _this.props.fetchingFunction(true);

          _this.getListArray('select');
        }
      } else {
        _this.proceedToBooking();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "proceedToBooking", function () {
      var _this$props3 = _this.props;
          _this$props3.theatreList;
          _this$props3.selected;

      var theatresToProcess = _this.getTheatresToProcess();

      _this.props.addTheatreForBooking(theatresToProcess);
    });

    _this.state = {
      hasScreenNotInList: false,
      deleteConfirmation: false,
      hover: false,
      theatreListValue: [],
      theatreLoading: false
    };
    return _this;
  }

  _createClass(TheatreList, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps, newState) {
      this.setState({
        hasScreenNotInList: this.hasScreenNotInList(newProps)
      });
    }
  }, {
    key: "hasScreenNotInList",
    value: function hasScreenNotInList(props) {
      var theatreList = props.theatreList,
          selected = props.selected,
          theatresInBooking = props.theatresInBooking;
      var screenNotInList = false;
      selected != NOT_SELECTED && theatreList.theatres.forEach(function (theatre) {
        var theatreIndex = _$1.findIndex(theatresInBooking, function (th) {
          return th.id === theatre.id;
        });

        theatreIndex >= 0 && theatresInBooking[theatreIndex].screens.forEach(function (sc) {
          if (sc.selected && sc.hasOwnProperty('isInList') && !sc.isInList) {
            screenNotInList = true;
          }
        });
      });
      return screenNotInList;
    }
  }, {
    key: "toggleExpand",
    value: function toggleExpand() {
      var theatreListValue = this.state.theatreListValue;
      this.props.toggleExpand(this.props.index);

      if (!theatreListValue.length) {
        this.setState({
          theatreLoading: true
        });
        this.getListArray();
      }
    }
  }, {
    key: "handleEditList",
    value: function handleEditList(e) {
      var theatreList = this.props.theatreList;
      e.stopPropagation();
      this.props.handleEditList(theatreList.id);
    }
  }, {
    key: "getTheatresToProcess",
    value: function getTheatresToProcess() {
      var theatreList = this.props.theatreList;
      var theatreListValue = this.state.theatreListValue;

      var theatresToProcess = _$1.filter(theatreListValue, function (theatre) {
        var mediaBlockCount = 0;

        _$1.forEach(theatre.screens, function (screen) {
          !screen.hasMediaBlock ? mediaBlockCount++ : null;
        });

        return mediaBlockCount !== theatre.screens.length;
      });

      theatresToProcess = theatresToProcess.map(function (th) {
        th.list = theatreList.id;
        th.screensToProcess = _$1.filter(th.screens, function (screen) {
          return screen.isInList;
        });
        th.screensToProcess = _$1.map(th.screensToProcess, function (screen) {
          if (screen.hasMediaBlock) {
            return screen.id;
          } else {
            return null;
          }
        });
        th.screensToProcess = _$1.compact(th.screensToProcess);
        return th;
      });
      return theatresToProcess;
    }
  }, {
    key: "getTheatreCount",
    value: function getTheatreCount() {
      var theatreList = this.props.theatreList;
      return theatreList.theatres.length;
    }
  }, {
    key: "renderTheatreCounts",
    value: function renderTheatreCounts() {
      var tCount = this.getTheatreCount();
      var countStr = (tCount || 0) + ' ' + pluralize('Theatre', tCount || 0);

      if (countStr) {
        return countStr;
      }
    }
  }, {
    key: "renderEditList",
    value: function renderEditList() {
      var theatreList = this.props.theatreList;
      this.state && theatreList.id === this.state.deleteConfirmation;
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          cursor: 'pointer',
          paddingLeft: 8,
          display: "flex"
        },
        onClick: this.handleEditList.bind(this)
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: 'ListEdit'
      }));
    }
  }, {
    key: "renderTheatres",
    value: function renderTheatres() {
      var _this$props4 = this.props,
          tabType = _this$props4.tabType,
          handleScreenBooking = _this$props4.handleScreenBooking;
      var _this$state = this.state,
          theatreListValue = _this$state.theatreListValue,
          theatreLoading = _this$state.theatreLoading;

      if (this.props.expand) {
        if (!theatreLoading) {
          return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Theatres, {
            showTheatreInfo: true,
            theatres: theatreListValue,
            addTheatreForBooking: this.props.addTheatreForBooking,
            removeTheatresFromBooking: this.props.removeTheatresFromBooking,
            theatresInBooking: this.props.theatresInBooking,
            listView: true,
            tabType: tabType,
            handleScreenBooking: handleScreenBooking
          }));
        } else {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "theatre-list-view-loader"
          }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
            style: {
              fontSize: 24,
              color: '#084782'
            },
            spin: true
          }));
        }
      } else {
        return /*#__PURE__*/React__default.createElement("div", null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          type = _this$props5.type,
          theatreList = _this$props5.theatreList;
      return /*#__PURE__*/React__default.createElement(ListCard, {
        name: theatreList && theatreList.name,
        theatreCount: this.renderTheatreCounts(),
        selected: this.props.selected,
        expandInfo: this.props.expand,
        theatreList: this.props.theatreList,
        theatresInBooking: this.props.theatresInBooking,
        partiallySelected: this.props.partiallySelected,
        handleAddListToBooking: this.handleAddListToBooking.bind(this),
        renderEditView: type === THEATRE_LISTS && this.renderEditList(),
        onToggle: function onToggle() {
          return _this2.toggleExpand();
        }
      }, /*#__PURE__*/React__default.createElement("div", null, this.renderTheatres()));
    }
  }]);

  return TheatreList;
}(React__default.Component);

function _createSuper$n(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$n(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var HEIGHT_OFFSET_FROM_VIEW_BOTTOM$1 = 120; // In pixels

var TheatreLists = /*#__PURE__*/function (_React$Component) {
  _inherits(TheatreLists, _React$Component);

  var _super = _createSuper$n(TheatreLists);

  function TheatreLists(props) {
    var _this;

    _classCallCheck(this, TheatreLists);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleListExpand", function (index, addListToBooking, operation) {
      _this.props.type;
      var expandInfo = {};

      if (!addListToBooking) {
        if (index === _this.state.expandInfo.index) {
          expandInfo = {
            index: index,
            status: !_this.state.expandInfo.status
          };
        } else {
          expandInfo = {
            index: index,
            status: !addListToBooking
          };
        }

        _this.setState({
          expandInfo: expandInfo
        });
      }
    });

    _this.state = {
      expandInfo: {
        index: 0,
        status: false
      }
    };
    return _this;
  }

  _createClass(TheatreLists, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps, nextState) {
      if (_$1.isEmpty(nextProps.theatreLists)) {
        this.setState({
          expandInfo: {
            index: 0,
            status: false
          }
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadTheatreLists ? this.props.loadTheatreLists() : null;
    }
  }, {
    key: "getExpandListToggleStatus",
    value: function getExpandListToggleStatus(index) {
      if (this.props.appError) {
        this.state.expandInfo.status = false;
      }

      if (index === this.state.expandInfo.index) {
        return this.state.expandInfo.status;
      } else {
        return false;
      }
    }
  }, {
    key: "_renderTheatreLists",
    value: function _renderTheatreLists() {
      var _this2 = this;

      var _this$props = this.props,
          theatreLists = _this$props.theatreLists,
          theatresInBooking = _this$props.theatresInBooking,
          addTheatreForBooking = _this$props.addTheatreForBooking,
          removeTheatresFromBooking = _this$props.removeTheatresFromBooking,
          handleEditList = _this$props.handleEditList,
          deleteList = _this$props.deleteList,
          tabType = _this$props.tabType,
          hostUrl = _this$props.hostUrl,
          accessToken = _this$props.accessToken,
          fetchingFunction = _this$props.fetchingFunction,
          listViewFetching = _this$props.listViewFetching,
          handleScreenBooking = _this$props.handleScreenBooking;
      return (theatreLists || []).map(function (theatreList, index) {
        var theatreIds = _$1.map(theatreList.theatres, 'id');

        var selected = NOT_SELECTED;
        var partiallySelectedCount = 0; // Proceed to check whether this theatre list is in the booking list only if this theatre has screens info
        // i.e it should have been expanded to get the screens list

        if (theatreList.hasInfo) {
          var selectedTheatresInList = _$1.filter(theatresInBooking, function (th) {
            var thisTheatre = _$1.find(theatreList.theatres, function (theatre) {
              return theatre.id === th.id;
            });

            var screensToProcess = null;

            if (thisTheatre) {
              screensToProcess = _$1.filter(thisTheatre.screens, function (screen) {
                return screen.isInList;
              });
            } //Iterate through the booking state to add the isInList property
            //if the screen does not have the key


            if (screensToProcess && screensToProcess.length > 0) {
              th.screens = th.screens.map(function (sc) {
                var isInList = _$1.findIndex(screensToProcess, function (scToProcess) {
                  return scToProcess.id === sc.id;
                });

                sc['isInList'] = isInList > -1;
                return sc;
              });
            }

            var screensInBooking = th.screens.filter(function (screen) {
              return screen.selected;
            });

            if (thisTheatre && !_$1.isEmpty(_$1.difference(_$1.map(screensToProcess, 'id'), _$1.map(screensInBooking, 'id')))) {
              partiallySelectedCount += 1;
            }

            return thisTheatre;
          });

          if (selectedTheatresInList.length === theatreIds.length && selectedTheatresInList.length > 0 && partiallySelectedCount === 0) {
            selected = COMPLETELY_SELECTED;
          } else if (selectedTheatresInList.length > 0 && selectedTheatresInList.length < theatreIds.length || partiallySelectedCount > 0) {
            selected = PARTIALLY_SELECTED;
          }
        }

        return /*#__PURE__*/React__default.createElement(TheatreList, {
          key: theatreList.id + 'theatre-list',
          index: index,
          listViewFetching: listViewFetching,
          selected: selected,
          partiallySelected: partiallySelectedCount,
          theatreList: theatreList,
          type: _this2.props.type,
          listType: _this2.props.listType,
          theatresInBooking: theatresInBooking,
          toggleExpand: _this2.toggleListExpand,
          expand: _this2.getExpandListToggleStatus(index),
          addTheatreForBooking: addTheatreForBooking,
          handleEditList: handleEditList,
          deleteList: deleteList,
          tabType: tabType,
          removeTheatresFromBooking: removeTheatresFromBooking,
          hostUrl: hostUrl,
          accessToken: accessToken,
          fetchingFunction: fetchingFunction,
          handleScreenBooking: handleScreenBooking
        });
      });
    }
  }, {
    key: "renderNoListsFoundMessage",
    value: function renderNoListsFoundMessage() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "empty-list-text"
      }, "No lists found");
    }
  }, {
    key: "renderSearchInProgress",
    value: function renderSearchInProgress(isLoading) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-loader",
        style: {
          height: window.innerHeight - HEIGHT_OFFSET_FROM_VIEW_BOTTOM$1 + 'px'
        }
      }, /*#__PURE__*/React__default.createElement("div", null, isLoading && /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      })));
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 24
        },
        spin: true
      }));
    }
  }, {
    key: "renderTheatreLists",
    value: function renderTheatreLists() {
      var _this$props2 = this.props,
          isLoading = _this$props2.isLoading,
          type = _this$props2.type,
          fetchMoreLoading = _this$props2.fetchMoreLoading;

      if (type === 'festivals') {
        return /*#__PURE__*/React__default.createElement("div", {
          style: {
            height: window.innerHeight - HEIGHT_OFFSET_FROM_VIEW_BOTTOM$1,
            overflowY: 'scroll'
          }
        }, this._renderTheatreLists(), isLoading && this.renderLoading());
      } else {
        return /*#__PURE__*/React__default.createElement("div", null, this._renderTheatreLists(), fetchMoreLoading && this.renderLoading());
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          theatreLists = _this$props3.theatreLists,
          isLoading = _this$props3.isLoading;

      if (!theatreLists || theatreLists.length === 0) {
        if (!isLoading) {
          return this.renderNoListsFoundMessage();
        } else {
          return this.renderSearchInProgress(isLoading);
        }
      } else {
        return this.renderTheatreLists();
      }
    }
  }]);

  return TheatreLists;
}(React__default.Component);

function _createSuper$m(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var initialState = {
  listName: '',
  theatreList: [],
  listObject: null,
  theatresInBooking: []
};

var EditTheatreList = /*#__PURE__*/function (_React$Component) {
  _inherits(EditTheatreList, _React$Component);

  var _super = _createSuper$m(EditTheatreList);

  function EditTheatreList(props) {
    var _this;

    _classCallCheck(this, EditTheatreList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "addTheatreToList", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(item) {
        var tempTheatre, screenInTheatreListCount, theatreList, theatresInBooking, theatreIndex;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tempTheatre = item[0];
                screenInTheatreListCount = 0;
                tempTheatre.screens.forEach(function (item) {
                  if (item.isInList) {
                    screenInTheatreListCount += 1;
                  }
                });

                if (screenInTheatreListCount) {
                  tempTheatre.screens.forEach(function (item) {
                    return item['isInList'] = false;
                  });
                } else {
                  tempTheatre.screens.forEach(function (item) {
                    return item['isInList'] = true;
                  });
                }

                theatreList = _this.state.theatreList.map(function (theatre) {
                  if (theatre.id === tempTheatre.id) {
                    return tempTheatre;
                  } else {
                    return theatre;
                  }
                });
                theatresInBooking = _this.state.theatresInBooking.map(function (theatre) {
                  if (theatre.id === tempTheatre.id) {
                    return tempTheatre;
                  } else {
                    return theatre;
                  }
                });
                theatreIndex = _this.state.theatresInBooking.findIndex(function (item) {
                  return item.id === tempTheatre.id;
                });

                if (theatreIndex > -1) {
                  theatresInBooking.splice(theatreIndex, 1);
                } else {
                  theatresInBooking.push(tempTheatre);
                }

                _this.setState({
                  theatreList: theatreList,
                  theatresInBooking: theatresInBooking
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "updateTheatreScreenToList", function (theatreIndex, screenIndex, isInList, theatre, screen) {
      var theatreList = _$1.cloneDeep(_this.state.theatreList);

      var theatresInBooking = _$1.cloneDeep(_this.state.theatresInBooking);

      if (_$1.isEmpty(theatresInBooking)) {
        theatresInBooking.push(theatreList[theatreIndex]);
      }

      if (theatreList && theatreList[theatreIndex]) {
        theatreList[theatreIndex].screens[screenIndex].isInList = !isInList;
      }

      if (theatresInBooking && theatresInBooking[theatreIndex]) {
        theatresInBooking[theatreIndex].screens[screenIndex].isInList = !isInList;
      }

      var isScreenInTheatreList = 0;
      theatresInBooking && theatresInBooking[theatreIndex] && theatresInBooking[theatreIndex].screens.forEach(function (item) {
        if (item.isInList) {
          isScreenInTheatreList += 1;
        }
      });

      if (!isScreenInTheatreList) {
        theatresInBooking.splice(theatreIndex, 1);
      }

      _this.setState({
        theatreList: theatreList,
        theatresInBooking: theatresInBooking
      });
    });

    _defineProperty(_assertThisInitialized(_this), "editList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.props.editTheatreList(_this.state);

            case 2:
              _this.setState(initialState);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    var list = _this.props.list;
    _this.state = {
      listName: list && list.name,
      theatreList: list && list.theatres,
      listObject: list,
      theatresInBooking: list && list.theatres
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.addTheatreToList = _this.addTheatreToList.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(EditTheatreList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!_$1.isEqual(this.props.list, prevProps.list)) {
        var list = this.props.list;
        this.setState({
          listName: list && list.name,
          theatreList: list && list.theatres,
          listObject: list,
          theatresInBooking: list && list.theatres
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        listName: e.target.value
      });
    }
  }, {
    key: "renderLoader",
    value: function renderLoader() {
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 24
        },
        spin: true
      }));
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this$props = this.props,
          list = _this$props.list;
          _this$props.handleScreenBooking;

      _$1.compact(list.theatres.map(function (theatre) {
        var screensInList = theatre.screens && theatre.screens.filter(function (screen) {
          return screen.isInList;
        });
        return screensInList && screensInList.length > 0 ? theatre : null;
      }));

      var _this$state = this.state,
          listName = _this$state.listName,
          theatreList = _this$state.theatreList;
          _this$state.theatresInBooking; // (list.errors && list.errors['name']) ? list.errors['name'].self && I18n.t('errors.create_list.name') : ''

      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SearchBox, {
        value: listName,
        suffix: false,
        searchButton: false,
        error: false,
        style: {
          height: 35
        },
        placeholder: "Enter Name of List",
        onTextChange: this.handleChange
      }), /*#__PURE__*/React__default.createElement("div", {
        style: {
          maxHeight: 300,
          overflow: 'auto'
        }
      }, /*#__PURE__*/React__default.createElement(Theatres, {
        editListView: true,
        edit: true,
        theatres: theatreList,
        theatresInBooking: theatreList,
        addTheatreForBooking: this.addTheatreToList,
        handleScreenBooking: this.updateTheatreScreenToList
      })));
    }
  }, {
    key: "renderActionButtons",
    value: function renderActionButtons() {
      var _this2 = this;

      var _this$props2 = this.props,
          list = _this$props2.list,
          cancel = _this$props2.cancel,
          deleteList = _this$props2.deleteList;
      var _this$state2 = this.state,
          theatreList = _this$state2.theatreList,
          listName = _this$state2.listName; // let disabled = (list && list.errors && list.errors.name.self) ? true : false

      var isAtleastOneScreenInList = false;
      theatreList && theatreList.every(function (theatre) {
        return theatre.screens.every(function (screen) {
          if (screen.isInList) {
            isAtleastOneScreenInList = true;
            return false;
          }

          return true;
        });
      });
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '8px 0px 0px'
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: 'delete-text',
        onClick: function onClick() {
          return deleteList(list);
        }
      }, "Delete"), /*#__PURE__*/React__default.createElement(SecondaryButton, {
        btnName: 'Cancel',
        callbackAction: function callbackAction() {
          return cancel();
        },
        style: {
          margin: '0px 8px'
        }
      }), /*#__PURE__*/React__default.createElement(PrimaryButton, {
        disabled: listName && !listName.length || !isAtleastOneScreenInList,
        btnName: 'Save',
        callbackAction: function callbackAction() {
          return _this2.editList();
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var list = this.props.list;
      return /*#__PURE__*/React__default.createElement("div", null, !list ? /*#__PURE__*/React__default.createElement("div", {
        style: {
          height: 75,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, this.renderLoader()) : /*#__PURE__*/React__default.createElement("div", null, list && this.renderList(), this.renderActionButtons()));
    }
  }]);

  return EditTheatreList;
}(React__default.Component);

function _createSuper$l(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$l(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$l() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditTheatreListModal = /*#__PURE__*/function (_React$Component) {
  _inherits(EditTheatreListModal, _React$Component);

  var _super = _createSuper$l(EditTheatreListModal);

  function EditTheatreListModal(props) {
    var _this;

    _classCallCheck(this, EditTheatreListModal);

    _this = _super.call(this, props);
    _this.state = {
      open: _this.props.open
    };
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(EditTheatreListModal, [{
    key: "handleOpen",
    value: function handleOpen() {
      this.props.handleEditOpen();
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.props.resetTheatreList();
    }
  }, {
    key: "showEditTheatreListModal",
    value: function showEditTheatreListModal(theatreList) {
      this.setState({
        theatreList: theatreList
      });
      this.handleOpen();
    }
  }, {
    key: "handleSaveList",
    value: function handleSaveList() {
      this.props.handleEditOpen();
      this.props.saveList();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props;
          _this$props.theatreList;
          var theatreLists = _this$props.theatreLists;
          _this$props.saveList;
          var updateTheatreListName = _this$props.updateTheatreListName,
          addTheatreToList = _this$props.addTheatreToList,
          editTheatreList = _this$props.editTheatreList,
          handleScreenBooking = _this$props.handleScreenBooking;
      return /*#__PURE__*/React__default.createElement(_Modal, {
        title: "Edit Theatre List",
        wrapClassName: "vertical-center-modal",
        visible: this.props.open,
        footer: null,
        onCancel: this.props.handleEditOpen,
        width: 600
      }, /*#__PURE__*/React__default.createElement(EditTheatreList, {
        list: theatreLists,
        saveList: this.handleSaveList.bind(this),
        cancel: this.props.handleEditOpen,
        updateListName: updateTheatreListName,
        addTheatreToList: addTheatreToList,
        deleteList: this.props.deleteList,
        editTheatreList: editTheatreList,
        handleScreenBooking: handleScreenBooking
      }));
    }
  }]);

  return EditTheatreListModal;
}(React__default.Component);

function _createSuper$k(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$k(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// let source = CancelToken.source()

var ListsViewPage = /*#__PURE__*/function (_React$Component) {
  _inherits(ListsViewPage, _React$Component);

  var _super = _createSuper$k(ListsViewPage);

  function ListsViewPage(props) {
    var _this;

    _classCallCheck(this, ListsViewPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getLists", function () {
      var _this$state = _this.state,
          offset = _this$state.offset,
          ps = _this$state.ps;
      var _this$props = _this.props,
          hostUrl = _this$props.hostUrl,
          accessToken = _this$props.accessToken;
      var config = {
        headers: {
          Authorization: "Bearer " + accessToken
        }
      };
      axios.get("".concat(hostUrl, "/v1/theatres/lists?offset=").concat(offset, "&ps=").concat(ps, "&sortBy=accessed_on|desc"), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          this.setState({
            listArray: response.data.theatreLists,
            totalList: response.data.totalCount,
            loading: false
          });
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        console.log(error);
      }.bind(_assertThisInitialized(_this)));
    });

    _defineProperty(_assertThisInitialized(_this), "fetchMoreList", function () {
      var _this$state2 = _this.state,
          offset = _this$state2.offset,
          ps = _this$state2.ps;
      var _this$props2 = _this.props,
          hostUrl = _this$props2.hostUrl,
          accessToken = _this$props2.accessToken;
      var config = {
        headers: {
          Authorization: "Bearer " + accessToken
        }
      };
      axios.get("".concat(hostUrl, "/v1/theatres/lists?offset=").concat(offset, "&ps=").concat(ps, "&sortBy=accessed_on|desc"), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          var tempArray = [].concat(_toConsumableArray(this.state.listArray), _toConsumableArray(response.data.theatreLists));
          this.setState({
            listArray: tempArray,
            totalList: response.data.totalCount,
            fetchMoreLoading: false
          });
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        console.log(error);
      }.bind(_assertThisInitialized(_this)));
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditOpen", function () {
      _this.setState({
        editOpen: false,
        editListTheatres: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditList", function (theatreList) {
      _this.setState({
        editOpen: true
      }, function () {
        return _this.fetchListTheatres(theatreList);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchListTheatres", function (theatreList) {
      var _this$props3 = _this.props,
          hostUrl = _this$props3.hostUrl,
          accessToken = _this$props3.accessToken;
      var config = {
        headers: {
          Authorization: "Bearer " + accessToken
        }
      };

      _this.setState({
        editListTheatres: null
      });

      axios.get("".concat(hostUrl, "/v1/theatrelists/").concat(theatreList), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          this.setState({
            editListTheatres: response.data
          });
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        console.log(error);
      }.bind(_assertThisInitialized(_this)));
    });

    _defineProperty(_assertThisInitialized(_this), "editTheatreList", function (state) {
      var listName = state.listName;
          state.listObject;
          var theatresInBooking = state.theatresInBooking;
      var data = state.listObject;
      var selectedTheatres = theatresInBooking && theatresInBooking.map(function (item) {
        var screens = item.screens.filter(function (screen) {
          return screen.isInList;
        });
        return {
          id: item.id,
          screens: screens.map(function (screen) {
            return screen.id;
          })
        };
      });
      data["name"] = listName;
      data["theatres"] = selectedTheatres;

      _this.setState({
        editOpen: false,
        loading: true,
        listArray: [],
        offset: 0
      }, function () {
        return _this.updateTheatreList(data);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateTheatreList", function (data) {
      var _this$props4 = _this.props,
          hostUrl = _this$props4.hostUrl,
          accessToken = _this$props4.accessToken;
      var config = {
        headers: {
          Authorization: "Bearer " + accessToken
        }
      };
      axios.put("".concat(hostUrl, "/v1/theatrelists/").concat(data.id), data, config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          SuccessMessage("Theatres list updated");
          this.getLists();
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        if (error.status == 400) {
          ErrorMessage(error.data.message);
        }

        this.getLists();
      }.bind(_assertThisInitialized(_this)));
    });

    _defineProperty(_assertThisInitialized(_this), "deleteListItem", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var deleteID;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              deleteID = _this.state.deleteID;
              _context.next = 3;
              return _this.props.deteteTheatreList(deleteID, _this.handleDeleteClose);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.state = {
      deleteModal: false,
      editModal: false,
      disableView: false,
      offset: 0,
      ps: 10,
      loading: true,
      totalList: null,
      listArray: [],
      fetchMoreLoading: false,
      editListTheatres: null,
      editingLoader: false
    };
    _this.theatreListScroll = _this.theatreListScroll.bind(_assertThisInitialized(_this));
    _this.handleDeleteClose = _this.handleDeleteClose.bind(_assertThisInitialized(_this));
    _this.deleteListItem = _this.deleteListItem.bind(_assertThisInitialized(_this));
    _this.editTheatreList = _this.editTheatreList.bind(_assertThisInitialized(_this));
    _this.clickedOutside = _this.clickedOutside.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ListsViewPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.clickedOutside);

      if (document.getElementById("theatres-screen-lists-overview-scroll")) {
        document.getElementById("theatres-screen-lists-overview-scroll").addEventListener("scroll", this.theatreListScroll, true);
      }

      this.getLists();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // source.cancel('Operation canceled by the user.');
      document.getElementById("theatres-screen-lists-overview-scroll").removeEventListener("scroll", this.theatreListScroll);
      document.removeEventListener('mousedown', this.clickedOutside, true);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps, newState) {
      var _this2 = this;

      var refetchListView = newProps.refetchListView,
          listRefetching = newProps.listRefetching;

      if (refetchListView) {
        listRefetching(false);
        this.setState({
          listArray: [],
          offset: 0,
          loading: true
        }, function () {
          return _this2.getLists();
        });
      }
    }
  }, {
    key: "clickedOutside",
    value: function clickedOutside(event) {
      if (this.wrapperModalRef && !this.wrapperModalRef.contains(event.target)) {
        this.setState({
          deleteModal: false
        });
      }
    }
  }, {
    key: "setWrapperModalRef",
    value: function setWrapperModalRef(node) {
      if (node) {
        this.wrapperModalRef = node;
      }
    }
  }, {
    key: "theatreListScroll",
    value: function theatreListScroll() {
      var _this3 = this;

      var _this$state3 = this.state,
          loading = _this$state3.loading,
          totalList = _this$state3.totalList,
          listArray = _this$state3.listArray,
          fetchMoreLoading = _this$state3.fetchMoreLoading;

      if (!loading) {
        var scrollElem = document.getElementById("theatres-screen-lists-overview-scroll");

        if (scrollElem) {
          if (Math.ceil(scrollElem.scrollHeight - scrollElem.scrollTop) == scrollElem.clientHeight) {
            if (listArray.length < totalList && !fetchMoreLoading) {
              this.setState({
                offset: this.state.offset + 10,
                fetchMoreLoading: true
              }, function () {
                return _this3.fetchMoreList();
              });
            }
          }
        }
      }
    }
  }, {
    key: "deleteList",
    value: function deleteList(list) {
      this.setState({
        deleteID: list.id,
        deleteModal: true,
        editOpen: false
      });
    }
  }, {
    key: "handleDeleteClose",
    value: function handleDeleteClose() {
      this.setState({
        deleteModal: false
      });
    }
  }, {
    key: "renderEditTheatreListModal",
    value: function renderEditTheatreListModal() {
      var _this4 = this;

      var _this$props5 = this.props,
          updateTheatreListName = _this$props5.updateTheatreListName,
          theatreList = _this$props5.theatreList,
          resetTheatreList = _this$props5.resetTheatreList,
          saveList = _this$props5.saveList,
          addTheatreToList = _this$props5.addTheatreToList,
          removeTheatreFromList = _this$props5.removeTheatreFromList,
          editModal = _this$props5.editModal,
          handleScreenBooking = _this$props5.handleScreenBooking;
      var editListTheatres = this.state.editListTheatres;
      return /*#__PURE__*/React__default.createElement(EditTheatreListModal, {
        theatreList: theatreList,
        theatreLists: editListTheatres,
        open: this.state.editOpen,
        saveList: saveList,
        editModal: editModal,
        addTheatreToList: addTheatreToList,
        editTheatreList: this.editTheatreList,
        removeTheatreFromList: removeTheatreFromList,
        resetTheatreList: resetTheatreList,
        deleteList: this.deleteList.bind(this),
        handleEditOpen: function handleEditOpen() {
          return _this4.handleEditOpen();
        },
        updateTheatreListName: updateTheatreListName,
        handleScreenBooking: handleScreenBooking
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props6 = this.props;
          _this$props6.theatreLists;
          var theatresInBooking = _this$props6.theatresInBooking,
          addTheatreForBooking = _this$props6.addTheatreForBooking,
          removeTheatresFromBooking = _this$props6.removeTheatresFromBooking,
          deleteList = _this$props6.deleteList,
          tabType = _this$props6.tabType,
          hostUrl = _this$props6.hostUrl,
          accessToken = _this$props6.accessToken,
          fetchingFunction = _this$props6.fetchingFunction,
          listViewFetching = _this$props6.listViewFetching,
          handleScreenBooking = _this$props6.handleScreenBooking,
          listPosting = _this$props6.listPosting;
      var _this$state4 = this.state,
          deleteModal = _this$state4.deleteModal,
          loading = _this$state4.loading,
          listArray = _this$state4.listArray,
          fetchMoreLoading = _this$state4.fetchMoreLoading;
      return /*#__PURE__*/React__default.createElement("div", {
        id: "theatres-screen-lists-overview-scroll",
        className: "theatre-selection-card-list-scroll-view"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatres-list-container"
      }, /*#__PURE__*/React__default.createElement(TheatreLists, {
        theatreLists: listArray,
        isLoading: loading,
        fetchMoreLoading: fetchMoreLoading,
        listType: "theatre_lists",
        type: THEATRE_LISTS,
        hostUrl: hostUrl,
        fetchingFunction: fetchingFunction,
        accessToken: accessToken,
        loadTheatreLists: this.props.loadTheatreLists,
        expandList: this.props.expandList,
        theatresInBooking: theatresInBooking,
        addTheatreForBooking: addTheatreForBooking,
        handleEditList: this.handleEditList.bind(this),
        deleteList: deleteList,
        tabType: tabType,
        listViewFetching: listViewFetching,
        removeTheatresFromBooking: removeTheatresFromBooking,
        appError: this.props.appError,
        handleScreenBooking: handleScreenBooking
      })), this.renderEditTheatreListModal(), deleteModal && /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(node) {
          return _this5.setWrapperModalRef(node);
        }
      }, /*#__PURE__*/React__default.createElement(DeleteModal, {
        deleteFunction: this.deleteListItem,
        cancelFunction: this.handleDeleteClose,
        heading: "Delete List",
        content: "Are you sure you want to delete this list?",
        cancelText: 'No, Keep the list',
        deleteText: 'Yes, Delete',
        listPosting: listPosting
      })));
    }
  }]);

  return ListsViewPage;
}(React__default.Component);

function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FestivalsView = /*#__PURE__*/function (_React$Component) {
  _inherits(FestivalsView, _React$Component);

  var _super = _createSuper$j(FestivalsView);

  function FestivalsView(props) {
    var _this;

    _classCallCheck(this, FestivalsView);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchFestivals", function () {
      var _this$state = _this.state;
          _this$state.offset;
          _this$state.ps;
      var _this$props = _this.props,
          hostUrl = _this$props.hostUrl,
          accessToken = _this$props.accessToken;
      var config = {
        headers: {
          Authorization: "Bearer " + accessToken
        }
      };
      axios.get("".concat(hostUrl, "/v1/theatres/lists?tag=Festivals"), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          this.setState({
            festivalArray: response.data.theatreLists,
            loading: false
          });
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        console.log(error);
      }.bind(_assertThisInitialized(_this)));
    });

    _this.state = {
      loading: true,
      festivalArray: []
    };
    return _this;
  }

  _createClass(FestivalsView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchFestivals();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props;
          _this$props2.festivals;
          _this$props2.loadingFestivals;
          var theatresInBooking = _this$props2.theatresInBooking;
          _this$props2.expandFestivals;
          var addTheatreForBooking = _this$props2.addTheatreForBooking;
          _this$props2.removeTheatresFromBooking;
          var tabType = _this$props2.tabType,
          accessToken = _this$props2.accessToken,
          hostUrl = _this$props2.hostUrl,
          fetchingFunction = _this$props2.fetchingFunction,
          handleScreenBooking = _this$props2.handleScreenBooking;
      var _this$state2 = this.state,
          loading = _this$state2.loading,
          festivalArray = _this$state2.festivalArray;
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          padding: '0px 16px'
        },
        className: "festival-list-container"
      }, /*#__PURE__*/React__default.createElement(TheatreLists, {
        isLoading: loading,
        theatreLists: festivalArray,
        type: FESTIVALS,
        expandList: this.props.expandList,
        tabType: tabType,
        listType: 'festivals_lists',
        accessToken: accessToken,
        hostUrl: hostUrl,
        theatresInBooking: theatresInBooking,
        fetchingFunction: fetchingFunction,
        addTheatreForBooking: addTheatreForBooking,
        handleScreenBooking: handleScreenBooking
      }));
    }
  }]);

  return FestivalsView;
}(React__default.Component);

function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CreateList = /*#__PURE__*/function (_React$Component) {
  _inherits(CreateList, _React$Component);

  var _super = _createSuper$i(CreateList);

  function CreateList(props) {
    var _this;

    _classCallCheck(this, CreateList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSave", function () {
      _this.props.createNewList(_this.state.listName);
    });

    _this.state = {
      listName: _this.props.listName
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CreateList, [{
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        listName: e.target.value
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2._input.focus();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          visible = _this$props.visible,
          loading = _this$props.loading,
          errors = _this$props.errors;
      var listName = this.state.listName;
      return /*#__PURE__*/React__default.createElement(_Modal, {
        title: "Add to New List",
        wrapClassName: "vertical-center-modal modal-medium",
        visible: visible,
        onCancel: this.props.handleClose,
        footer: [/*#__PURE__*/React__default.createElement(_Button, {
          key: "back",
          size: "large",
          onClick: this.props.handleClose,
          disabled: loading,
          className: "cancel-btn"
        }, "Cancel"), /*#__PURE__*/React__default.createElement(_Button, {
          key: "submit",
          type: "primary",
          size: "large",
          loading: loading,
          onClick: this.handleSave,
          disabled: listName.length < 1
        }, "Create")]
      }, /*#__PURE__*/React__default.createElement(InputLabel, {
        content: "List Name"
      }), /*#__PURE__*/React__default.createElement(_Input, {
        ref: function ref(c) {
          return _this3._input = c;
        },
        size: "large",
        placeholder: "Enter Name of New List",
        value: listName,
        onChange: this.handleChange,
        autoComplete: "off",
        onPressEnter: this.handleSave
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "input-meta__data"
      }, errors && /*#__PURE__*/React__default.createElement(HelpText, {
        isErrorMessage: true,
        content: errors
      })));
    }
  }]);

  return CreateList;
}(React__default.Component);

function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// import 'antd/dist/antd.less';
var CreateListModal = /*#__PURE__*/function (_React$Component) {
  _inherits(CreateListModal, _React$Component);

  var _super = _createSuper$h(CreateListModal);

  function CreateListModal(props) {
    var _this;

    _classCallCheck(this, CreateListModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var listPosting = _this.props.listPosting;

      if (!listPosting) {
        _this.props.closeAddToNewList();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createNewList", function (name) {
      _this.props.createTheatreList(name);
    });

    return _this;
  }

  _createClass(CreateListModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          listError = _this$props.listError,
          open = _this$props.open,
          listPosting = _this$props.listPosting;
      return /*#__PURE__*/React__default.createElement(CreateList, {
        listName: "",
        visible: open,
        loading: listPosting,
        errors: listError,
        handleClose: this.handleClose,
        createNewList: this.createNewList
      });
    }
  }]);

  return CreateListModal;
}(React__default.Component);

function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var HEIGHT_OFFSET_FROM_VIEW_BOTTOM = 170; // In pixels

var MODE = 'selected';

var SelectedTheatres = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectedTheatres, _React$Component);

  var _super = _createSuper$g(SelectedTheatres);

  function SelectedTheatres(props) {
    var _this;

    _classCallCheck(this, SelectedTheatres);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleAddToNewList", function () {
      _this.props.createListModalOpen(true);
    });

    _defineProperty(_assertThisInitialized(_this), "closeAddToNewList", function () {
      _this.props.createListModalOpen(false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddToTheatreList", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(list) {
        var _this$props, theatres, selectedTheatres;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, theatres = _this$props.theatres;
                selectedTheatres = theatres;
                _context.next = 4;
                return selectedTheatres.forEach(function (selectedTheatre) {
                  var theatreIndex = _$1.findIndex(list.theatres, function (th) {
                    return th.id == selectedTheatre.id;
                  });

                  if (theatreIndex != -1 && list.theatres[theatreIndex].screens) {
                    selectedTheatre.screens.forEach(function (screen) {
                      if (screen.selected && !_$1.find(list.theatres[theatreIndex].screens, function (sc) {
                        return sc === screen.id;
                      })) {
                        list.theatres[theatreIndex].screens.push(screen.id);
                      }
                    });
                  } else if (theatreIndex == -1) {
                    var object = {
                      id: selectedTheatre.id
                    };

                    var screens = _$1.filter(selectedTheatre.screens, 'selected');

                    screens = screens.map(function (screen) {
                      return screen.id;
                    });

                    if (screens.length != selectedTheatre.screens.length) {
                      object.screens = screens;
                    }

                    list.theatres.push(object);
                  }
                });

              case 4:
                _this.updateTheatreLists(list);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "updateTheatreLists", function (list) {
      var _this$props2 = _this.props,
          hostUrl = _this$props2.hostUrl;
          _this$props2.accessToken;
          var listRefetching = _this$props2.listRefetching;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(_this.props.accessToken)
        }
      };

      _this.setState({
        loading: true
      });

      axios.put("".concat(hostUrl, "/v1/theatrelists/").concat(list.id), list, config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          _this.setState({
            loading: false
          });

          listRefetching(true);
          SuccessMessage('List updated');
        }
      }).catch(function (error) {
        this.setState({
          loading: false
        });
        console.log(error);
      }.bind(_assertThisInitialized(_this)));
    });

    _this.state = {
      createModal: false,
      loading: false
    };
    return _this;
  }

  _createClass(SelectedTheatres, [{
    key: "renderLoader",
    value: function renderLoader() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-list-loader",
        style: {
          height: "".concat(window.innerHeight - HEIGHT_OFFSET_FROM_VIEW_BOTTOM, "px")
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      }));
    }
  }, {
    key: "renderCreateListModal",
    value: function renderCreateListModal() {
      this.props.createListModal;
      return /*#__PURE__*/React__default.createElement(CreateListModal, {
        open: this.props.createListModal,
        newListName: this.props.newListName,
        closeAddToNewList: this.closeAddToNewList,
        errors: this.props.errors,
        createNewList: this.props.createNewList,
        updateListName: this.props.updateListName,
        resetValidation: this.props.resetValidation,
        createTheatreList: this.props.createTheatreList,
        listPosting: this.props.listPosting,
        listError: this.props.listError
      });
    }
  }, {
    key: "areTheatresSelected",
    value: function areTheatresSelected() {
      if (this.props.theatres) {
        return this.props.theatres.length > 0;
      }
    }
  }, {
    key: "renderTitleSection",
    value: function renderTitleSection() {
      var _this2 = this;

      var _this$props3 = this.props,
          hostUrl = _this$props3.hostUrl,
          accessToken = _this$props3.accessToken,
          mode = _this$props3.mode;
      return /*#__PURE__*/React__default.createElement(SelectedHeader, {
        title: "Selected Theatres",
        areTheatresSelected: this.areTheatresSelected(),
        addToItem: function addToItem(list) {
          return _this2.handleAddToTheatreList(list);
        },
        onChangeView: this.props.onChangeView,
        handleAddToNewItem: this.handleAddToNewList,
        hostUrl: hostUrl,
        accessToken: accessToken,
        clearTheatreList: this.props.clearTheatreList,
        hasList: mode !== 'exhibitor'
      });
    }
  }, {
    key: "renderNoTheatresSelectedSection",
    value: function renderNoTheatresSelectedSection() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-selected-center-view"
      }, "No theatres are selected");
    }
  }, {
    key: "renderSelectedTheatresSection",
    value: function renderSelectedTheatresSection() {
      var listViewFetching = this.props.listViewFetching;

      if (listViewFetching || this.state.loading) {
        return this.renderLoader();
      }

      if (this.areTheatresSelected()) {
        return this._renderSelectedTheatresSection();
      }

      return this.renderNoTheatresSelectedSection();
    }
  }, {
    key: "_renderSelectedTheatresSection",
    value: function _renderSelectedTheatresSection() {
      var _this$props4 = this.props,
          theatres = _this$props4.theatres,
          addTheatreForBooking = _this$props4.addTheatreForBooking;
          _this$props4.removeTheatresFromBooking;
          var handleScreenBooking = _this$props4.handleScreenBooking,
          mode = _this$props4.mode;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatres-list",
        style: {
          height: "".concat(window.innerHeight - HEIGHT_OFFSET_FROM_VIEW_BOTTOM, "px"),
          overflow: 'scroll',
          padding: '0px 12px'
        }
      }, /*#__PURE__*/React__default.createElement(Theatres, {
        showTheatreInfo: true,
        selectMode: MODE,
        showWireTapIcon: mode != 'exhibitor',
        theatres: theatres,
        addTheatreForBooking: addTheatreForBooking,
        handleScreenBooking: handleScreenBooking,
        theatresInBooking: theatres,
        tabType: "selected",
        mode: mode
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "selected-theatre-container"
      }, this.renderTitleSection(), this.renderSelectedTheatresSection(), this.props.createListModal && this.renderCreateListModal());
    }
  }]);

  return SelectedTheatres;
}(React__default.Component);

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditTagModal = /*#__PURE__*/function (_Component) {
  _inherits(EditTagModal, _Component);

  var _super = _createSuper$f(EditTagModal);

  function EditTagModal() {
    var _this;

    _classCallCheck(this, EditTagModal);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "showModal", function () {
      _this.setState({
        visible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCreate", function (tagName) {
      var tagDetails = {
        name: tagName,
        id: _this.props.rowData.id
      };

      _this.setState({
        loading: true
      });

      _this.props.saveTagDetails(tagDetails, "edit");
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      _this.setState({
        visible: false,
        loading: false,
        errorMessage: ""
      });
    });

    _this.state = {
      visible: false,
      loading: false,
      errorMessage: ""
    };
    return _this;
  }

  _createClass(EditTagModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.tagDetailsSavingStatus === true && nextProps.tagDetailsSavingStatus === false && this.state.loading === true) {
        if (!nextProps.errorWhileSavingTags) {
          this.setState({
            visible: false,
            errorMessage: ""
          });
        } else if (this.state.visible) {
          this.setState({
            errorMessage: this.props.errorWhileSavingTags
          });
        }

        this.setState({
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var rowData = this.props.rowData;
      var _this$state = this.state,
          visible = _this$state.visible,
          loading = _this$state.loading,
          errorMessage = _this$state.errorMessage;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "tag-creation__layout"
      }, /*#__PURE__*/React__default.createElement("span", {
        onClick: this.showModal
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "edit",
        size: "24"
      })), visible && /*#__PURE__*/React__default.createElement(SaveTagModal, {
        title: "Edit Tag",
        tagName: rowData.name,
        submitBtnName: "Save",
        visible: visible,
        handleSubmit: this.handleCreate,
        handleCancel: this.handleCancel,
        loading: loading,
        hasErrorMessage: errorMessage
      }));
    }
  }]);

  return EditTagModal;
}(Component);

EditTagModal.defaultProps = {
  tagDetailsSavingStatus: false,
  errorWhileSavingTags: "",
  saveTagDetails: function saveTagDetails() {},
  rowData: {}
};

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TagsTable = /*#__PURE__*/function (_Component) {
  _inherits(TagsTable, _Component);

  var _super = _createSuper$e(TagsTable);

  function TagsTable(props) {
    var _this;

    _classCallCheck(this, TagsTable);

    _this = _super.call(this, props);
    _this.state = {
      columns: [{
        title: 'Tag Name',
        dataIndex: 'name',
        key: 'name',
        width: '40%'
      }, {
        title: 'Last Updated On',
        dataIndex: 'updatedOn',
        key: 'updatedOn',
        render: function render(updated) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "table-data__txt"
          }, /*#__PURE__*/React__default.createElement("div", null, momentTZ(updated).format('D MMM YYYY')), /*#__PURE__*/React__default.createElement("div", {
            className: "table-data__hlpTxt"
          }, momentTZ(updated).format('h:mm A')));
        }
      }, {
        title: 'Last Updated By',
        dataIndex: 'updatedBy',
        key: 'updatedBy',
        render: function render(updatedby) {
          return /*#__PURE__*/React__default.createElement("div", null, updatedby || 'Qube Wire');
        }
      }, {
        title: 'Created On',
        dataIndex: 'createdOn',
        key: 'createdOn',
        render: function render(created) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "table-data__txt"
          }, /*#__PURE__*/React__default.createElement("div", null, momentTZ(created).format('D MMM YYYY')), /*#__PURE__*/React__default.createElement("div", {
            className: "table-data__hlpTxt"
          }, momentTZ(created).format('h:mm A')));
        }
      }, {
        title: 'Created By',
        dataIndex: 'createdBy',
        key: 'createdBy',
        render: function render(createdby) {
          return /*#__PURE__*/React__default.createElement("div", null, createdby || 'Qube Wire');
        }
      }].concat(_toConsumableArray(_this.props.canEdit ? [{
        title: '',
        dataIndex: 'edit',
        key: 'edit',
        render: function render(text, record) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "icon-centered"
          }, /*#__PURE__*/React__default.createElement(EditTagModal, {
            rowData: record,
            tagDetailsSavingStatus: _this.props.tagDetailsSavingStatus,
            errorWhileSavingTags: _this.props.errorWhileSavingTags,
            saveTagDetails: _this.props.saveTagDetails
          }));
        }
      }] : []))
    };
    return _this;
  }

  _createClass(TagsTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rows = _this$props.rows,
          fetchingData = _this$props.fetchingData;
      var columns = this.state.columns;
      return /*#__PURE__*/React__default.createElement(DefaultTable, {
        columns: columns,
        rows: rows,
        fetchingData: fetchingData
      });
    }
  }]);

  return TagsTable;
}(Component);

TagsTable.defaultProps = {
  tagDetailsSavingStatus: false,
  errorWhileSavingTags: '',
  saveTagDetails: function saveTagDetails() {}
};

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CreateTagModal = /*#__PURE__*/function (_Component) {
  _inherits(CreateTagModal, _Component);

  var _super = _createSuper$d(CreateTagModal);

  function CreateTagModal() {
    var _this;

    _classCallCheck(this, CreateTagModal);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "showModal", function () {
      _this.setState({
        visible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCreate", function (tagName) {
      _this.setState({
        loading: true
      });

      _this.props.saveTagDetails(tagName, "create");
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      _this.setState({
        visible: false,
        loading: false,
        errorMessage: ""
      });
    });

    _this.state = {
      visible: false,
      loading: false,
      errorMessage: ""
    };
    return _this;
  }

  _createClass(CreateTagModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.tagDetailsSavingStatus === true && nextProps.tagDetailsSavingStatus === false && this.state.loading === true) {
        if (!nextProps.errorWhileSavingTags) {
          this.setState({
            visible: false,
            errorMessage: ""
          });
        } else if (this.state.visible) {
          this.setState({
            errorMessage: this.props.errorWhileSavingTags
          });
        }

        this.setState({
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          visible = _this$state.visible,
          loading = _this$state.loading,
          errorMessage = _this$state.errorMessage;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "tag-creation__layout"
      }, /*#__PURE__*/React__default.createElement(PrimaryButton, {
        btnName: "Create Tag",
        callbackAction: this.showModal
      }), visible && /*#__PURE__*/React__default.createElement(SaveTagModal, {
        title: "Create Tag",
        tagName: "",
        submitBtnName: "Create",
        visible: visible,
        handleSubmit: this.handleCreate,
        handleCancel: this.handleCancel,
        loading: loading,
        hasErrorMessage: errorMessage
      }));
    }
  }]);

  return CreateTagModal;
}(Component);

CreateTagModal.defaultProps = {
  tagDetailsSavingStatus: false,
  errorWhileSavingTags: "",
  saveTagDetails: function saveTagDetails() {}
};

function bandwidthCalculator(bytes) {
  var bytesData = bytes;

  if (bytesData >= 1024 * 1024 * 1024) {
    bytesData = "".concat((bytesData / (1024 * 1024 * 1024)).toFixed(2), " Gbps");
  } else if (bytesData >= 1024 * 1024) {
    bytesData = "".concat((bytesData / (1024 * 1024)).toFixed(2), " Mbps");
  } else if (bytesData >= 1024) {
    bytesData = "".concat((bytesData / 1024).toFixed(2), " Kbps");
  } else {
    bytesData = "".concat(bytesData.toFixed(2), " bps");
  }

  return bytesData;
}

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TableLoading = /*#__PURE__*/function (_Component) {
  _inherits(TableLoading, _Component);

  var _super = _createSuper$c(TableLoading);

  function TableLoading() {
    _classCallCheck(this, TableLoading);

    return _super.apply(this, arguments);
  }

  _createClass(TableLoading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columns = _this$props.columns,
          rowsCount = _this$props.rowsCount;
      var modifiedColumns = columns.map(function (column) {
        if (!column.id && !column.accessor) {
          throw new Error("Either id or accessor should be provided at Column ".concat(column.Header));
        }

        return {
          id: column.id || column.accessor,
          Header: column.Header,
          accessor: function accessor() {
            return /*#__PURE__*/React__default.createElement("span", {
              className: "cell"
            });
          },
          width: column.width,
          sortable: column.sortable,
          resizable: column.resizable
        };
      });
      var data = Array(rowsCount).fill({});
      return /*#__PURE__*/React__default.createElement("div", {
        className: "table-loading"
      }, /*#__PURE__*/React__default.createElement(Table, {
        columns: modifiedColumns,
        data: data,
        headerClassName: ""
      }));
    }
  }]);

  return TableLoading;
}(Component);
TableLoading.defaultProps = {
  rowsCount: 10
};

var _excluded$1 = ["appliances", "loading", "columns", "emptyDataMessage"];

var ApplianceTable = function ApplianceTable(_ref) {
  var appliances = _ref.appliances,
      loading = _ref.loading,
      columns = _ref.columns,
      emptyDataMessage = _ref.emptyDataMessage;
      _objectWithoutProperties(_ref, _excluded$1);

  var formatTheatreAddress = function formatTheatreAddress(details) {
    var formattedAddress = [];
    var city = details.city,
        province = details.province,
        country = details.country;

    if (city) {
      formattedAddress.push(city.displayName ? city.displayName : city.name);
    }

    if (province) {
      formattedAddress.push(province.displayName ? province.displayName : province.name);
    }

    if (country) {
      formattedAddress.push(country.displayName ? country.displayName : country.name);
    }

    return formattedAddress.join(', ');
  };

  var defaultColumns = [{
    Header: I18n.t('appliance_column.serialNumber'),
    accessor: 'serial',
    key: 'serial',
    Cell: function Cell(_ref2) {
      var value = _ref2.value;
          _ref2.original;

      if (value) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "serial-number"
        }, value);
      } else return /*#__PURE__*/React__default.createElement("div", {
        className: "serial-number"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }, {
    Header: I18n.t('appliance_column.theatres'),
    accessor: 'mappedTo',
    key: 'theatres',
    minWidth: 200,
    Cell: function Cell(_ref3) {
      var value = _ref3.value;
          _ref3.original;
      return /*#__PURE__*/React__default.createElement("div", null, value.map(function (facility) {
        return !_$1.isEmpty(facility) && !_$1.isEmpty(facility.name) ? /*#__PURE__*/React__default.createElement("div", {
          className: "theatres-info"
        }, /*#__PURE__*/React__default.createElement(TheatreName, {
          name: facility.displayName ? facility.displayName : facility.name,
          rowKey: function rowKey(facility) {
            return facility.id;
          }
        }), _$1.isEmpty(facility.details.city) || _$1.isEmpty(facility.details.province) || _$1.isEmpty(facility.details.country) ? /*#__PURE__*/React__default.createElement("div", {
          className: "theatres-info"
        }, /*#__PURE__*/React__default.createElement(EmptyHandler, null)) : /*#__PURE__*/React__default.createElement(TheatreAddress, {
          address: formatTheatreAddress(facility.details)
        })) : /*#__PURE__*/React__default.createElement("div", {
          className: "theatres-info"
        }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
      }));
    }
  }, {
    Header: I18n.t('appliance_column.chain'),
    accessor: 'mappedTo',
    key: 'chain',
    Cell: function Cell(_ref4) {
      var value = _ref4.value;

      if (value) {
        return /*#__PURE__*/React__default.createElement("div", null, value.map(function (facilities) {
          return !_$1.isEmpty(facilities) && !_$1.isEmpty(facilities.details.chain) ? /*#__PURE__*/React__default.createElement("div", {
            className: "chain-info"
          }, /*#__PURE__*/React__default.createElement(TheatreName, {
            name: facilities.details.chain.displayName ? facilities.details.chain.displayName : facilities.details.chain.name,
            rowKey: function rowKey(facilities) {
              return facilities.id;
            }
          })) : /*#__PURE__*/React__default.createElement("div", {
            className: "chain-info"
          }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
        }));
      } else {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "chain-info"
        }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
      }
    }
  }, {
    Header: I18n.t('appliance_column.bandwidth'),
    accessor: 'bandwidthInMbps',
    key: 'bandwidthInMbps',
    Cell: function Cell(_ref5) {
      var value = _ref5.value;
      if (value) return /*#__PURE__*/React__default.createElement("div", {
        className: "bandwidth"
      }, bandwidthCalculator(value * 1024 * 1024));else return /*#__PURE__*/React__default.createElement("div", {
        className: "bandwidth"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }, {
    Header: I18n.t('appliance_column.publicIp'),
    accessor: 'publicIp',
    key: 'publicIp',
    Cell: function Cell(_ref6) {
      var value = _ref6.value;
      if (value) return /*#__PURE__*/React__default.createElement("div", {
        className: "public-ip"
      }, value);else return /*#__PURE__*/React__default.createElement("div", {
        className: "public-ip"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }, {
    Header: I18n.t('appliance_column.osversion'),
    accessor: 'softwareVersion',
    key: 'softwareVersion',
    Cell: function Cell(_ref7) {
      var value = _ref7.value;
      if (value) return /*#__PURE__*/React__default.createElement("div", {
        className: "os-version"
      }, value);else return /*#__PURE__*/React__default.createElement("div", {
        className: "os-version"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }, {
    Header: I18n.t('appliance_column.downloadStatus'),
    accessor: 'downloadRate',
    key: 'downloadRate',
    Cell: function Cell(_ref8) {
      var value = _ref8.value;
      if (value) return /*#__PURE__*/React__default.createElement("div", {
        className: "download-speed"
      }, /*#__PURE__*/React__default.createElement("div", null, "Downloading at ", bandwidthCalculator(value * 8)));else return /*#__PURE__*/React__default.createElement("div", {
        className: "download-speed"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }, {
    Header: I18n.t('appliance_column.status'),
    accessor: 'isOnline',
    key: 'isOnline',
    Cell: function Cell(_ref9) {
      var value = _ref9.value;

      if (typeof value === 'boolean') {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "online"
        }, /*#__PURE__*/React__default.createElement(Status, {
          status: value
        }));
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "online"
      }, /*#__PURE__*/React__default.createElement(EmptyHandler, null));
    }
  }];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "applianceTable"
  }, /*#__PURE__*/React__default.createElement(Table, {
    sortable: false,
    loading: loading,
    data: appliances,
    columns: columns ? defaultColumns.filter(function (column) {
      return columns.includes(column.key);
    }) : defaultColumns,
    emptyDataMessage: emptyDataMessage,
    LoadingComponent: /*#__PURE__*/React__default.createElement(TableLoading, {
      columns: columns ? defaultColumns.filter(function (column) {
        return columns.includes(column.key);
      }) : defaultColumns
    })
  }));
};
ApplianceTable.defaultProps = {
  emptyDataMessage: {
    heading: 'No WireTAPs Available',
    body: ''
  }
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Searchbar = function Searchbar(_ref) {
  var searchValue = _ref.searchValue,
      clearSearch = _ref.clearSearch,
      placeholder = _ref.placeholder,
      isSearching = _ref.isSearching,
      searchList = _ref.searchList,
      isFreshSearch = _ref.isFreshSearch,
      dropDownPlaceholder = _ref.dropDownPlaceholder,
      showArrow = _ref.showArrow,
      onChange = _ref.onChange,
      defaultValue = _ref.defaultValue;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "search-field"
  }, !showArrow && /*#__PURE__*/React__default.createElement("div", {
    className: "search-icon"
  }, searchValue ? /*#__PURE__*/React__default.createElement(CloseOutlined$1, {
    onClick: clearSearch
  }) : /*#__PURE__*/React__default.createElement(SearchOutlined$1, null)), /*#__PURE__*/React__default.createElement(_Select, {
    mode: "multiple",
    defaultValue: defaultValue,
    placeholder: placeholder,
    labelInValue: true,
    showArrow: showArrow,
    onChange: onChange,
    style: {
      width: '100%'
    },
    options: searchList,
    notFoundContent: isSearching ? /*#__PURE__*/React__default.createElement("div", {
      className: "spinner"
    }, /*#__PURE__*/React__default.createElement(_Spin, null)) : _.isEmpty(searchList) && isFreshSearch ? dropDownPlaceholder : I18n.t('filterPanel.noRecordsfound')
  }));
};

var AddUsersToGroupModal = function AddUsersToGroupModal(_ref2) {
  var visible = _ref2.visible,
      handleClose = _ref2.handleClose,
      user = _ref2.user,
      groupPlaceholder = _ref2.groupPlaceholder,
      rolePlaceholder = _ref2.rolePlaceholder,
      accessToken = _ref2.accessToken,
      theatreAclUrl = _ref2.theatreAclUrl,
      defaultGroupValues = _ref2.defaultGroupValues,
      defaultRoleValues = _ref2.defaultRoleValues,
      fetchUsers = _ref2.fetchUsers,
      currentOffset = _ref2.currentOffset,
      setIsOpen = _ref2.setIsOpen;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      selectFieldsCount = _useState2[0],
      setSelectFieldsCount = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      selectData = _useState4[0],
      setSelectData = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      allGroups = _useState6[0],
      setAllGroups = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedGroups = _useState8[0],
      setSelectedGroups = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isSaving = _useState10[0],
      setIsSaving = _useState10[1];

  var handleAddAnotherSelectField = function handleAddAnotherSelectField() {
    setSelectFieldsCount(selectFieldsCount + 1);
  };

  var isEdit = function isEdit(user) {
    var _user$roles;

    var edit = false;
    user === null || user === void 0 ? void 0 : (_user$roles = user.roles) === null || _user$roles === void 0 ? void 0 : _user$roles.forEach(function (role) {
      var _role$groups;

      if (role !== null && role !== void 0 && (_role$groups = role.groups) !== null && _role$groups !== void 0 && _role$groups.length) {
        edit = true;
      }
    });
    return edit;
  };

  useEffect(function () {
    var data = {};
    var groupData = {};

    if (isEdit(user)) {
      defaultRoleValues.forEach(function (role, index) {
        data = _objectSpread$1(_objectSpread$1({}, data), {}, _defineProperty({}, index, _objectSpread$1(_objectSpread$1({}, data && data[index]), {}, {
          role: role
        })));
      });
      defaultGroupValues.forEach(function (group, index) {
        data = _objectSpread$1(_objectSpread$1({}, data), {}, _defineProperty({}, index, _objectSpread$1(_objectSpread$1({}, data && data[index]), {}, {
          group: group
        })));
      });
    }

    defaultGroupValues.forEach(function (group, index) {
      groupData = _objectSpread$1(_objectSpread$1({}, groupData), {}, _defineProperty({}, index, _objectSpread$1(_objectSpread$1({}, groupData && groupData[index]), {}, {
        group: group === null || group === void 0 ? void 0 : group.map(function (o) {
          return o.value;
        })
      })));
    });
    setSelectData(data);
    setSelectedGroups(groupData);
  }, [defaultGroupValues, defaultRoleValues]);

  var onSelectChange = function onSelectChange(index, name, option) {
    if (name === 'group') {
      var _data = _objectSpread$1(_objectSpread$1({}, selectedGroups), {}, _defineProperty({}, index, _objectSpread$1(_objectSpread$1({}, selectedGroups && selectedGroups[index]), {}, {
        group: option.map(function (o) {
          return o.value;
        })
      })));

      setSelectedGroups(_data);
    }

    var data = _objectSpread$1(_objectSpread$1({}, selectData), {}, _defineProperty({}, index, _objectSpread$1(_objectSpread$1({}, selectData && selectData[index]), {}, _defineProperty({}, name, option))));

    setSelectData(data);
  };

  useEffect(function () {
    if (visible) {
      setSelectFieldsCount(1);
      var config = {
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      };
      axios.get("".concat(theatreAclUrl, "/v1/groups?ps=50&offset=0"), config).then(function (response) {
        setAllGroups(response.data.groups.map(function (group) {
          return {
            label: group.name,
            value: group.id,
            id: group.id
          };
        }));
      });
    }
  }, [visible]);

  var handleAdd = function handleAdd() {
    var data = Object.keys(selectData).map(function (key) {
      return {
        groups: selectData[key].group.map(function (group) {
          return {
            id: group.value,
            roles: selectData[key].role.map(function (role) {
              return role.value;
            })
          };
        })
      };
    });
    setIsSaving(true);

    if (isEdit(user)) {
      var _data$map;

      axios.create({
        baseURL: theatreAclUrl,
        headers: {
          Authorization: "Bearer ".concat(accessToken),
          'If-Match': user.version
        }
      }).put("".concat(theatreAclUrl, "/v1/groups/user"), {
        userId: user.Id,
        groups: (_data$map = data.map(function (d) {
          return d.groups;
        })) === null || _data$map === void 0 ? void 0 : _data$map.flat()
      }).then(function () {
        SuccessMessage(I18n.t('users_table.update_access.group_updated'));
        fetchUsers(currentOffset);
        setIsOpen(false);
        setIsSaving(false);
      }).catch(function () {
        ErrorMessage(I18n.t('users_table.update_access.error'));
        setIsSaving(false);
      });
    } else {
      var _data$map2;

      axios.create({
        baseURL: theatreAclUrl,
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      }).post("".concat(theatreAclUrl, "/v1/groups/user"), {
        userId: user.Id,
        groups: (_data$map2 = data.map(function (d) {
          return d.groups;
        })) === null || _data$map2 === void 0 ? void 0 : _data$map2.flat()
      }).then(function () {
        SuccessMessage(I18n.t('users_table.add_access.group_added'));
        fetchUsers(currentOffset);
        setIsOpen(false);
        setIsSaving(false);
      }).catch(function () {
        ErrorMessage(I18n.t('users_table.add_access.error'));
        setIsSaving(false);
      });
    }
  };

  var filteredGroupsList = function filteredGroupsList(index) {
    return allGroups === null || allGroups === void 0 ? void 0 : allGroups.filter(function (group) {
      var groupIds = [];
      Object.keys(selectedGroups).forEach(function (key) {
        if (parseInt(key) !== index) {
          groupIds.push(selectedGroups[key].group);
        }
      });
      return !(groupIds !== null && groupIds !== void 0 && groupIds.flat().includes(group.value));
    });
  };

  var rolesList = function rolesList() {
    var _user$roles2;

    return user === null || user === void 0 ? void 0 : (_user$roles2 = user.roles) === null || _user$roles2 === void 0 ? void 0 : _user$roles2.map(function (role) {
      return {
        label: role === null || role === void 0 ? void 0 : role.name,
        value: role === null || role === void 0 ? void 0 : role.code
      };
    });
  };

  var isDisabled = function isDisabled() {
    var disabled = true;

    var data = _.cloneDeep(selectData);

    if (isEdit(user)) {
      if (data) {
        for (var key in data) {
          if (!_.isEmpty(data[key].group) && !_.isEmpty(data[key].role) || _.isEmpty(data[key].group) && _.isEmpty(data[key].role)) {
            disabled = false;
          } else {
            disabled = true;
            return disabled;
          }
        }
      }
    } else {
      var emptyRows = 0;

      if (data) {
        for (var _key in data) {
          if (!_.isEmpty(data[_key].group) && !_.isEmpty(data[_key].role)) {
            disabled = false;
          } else if (_.isEmpty(data[_key].group) && _.isEmpty(data[_key].role)) {
            emptyRows++;
          } else {
            disabled = true;
            return disabled;
          }
        }

        if (emptyRows === data.length) {
          disabled = true;
        }
      }
    }

    return disabled;
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "add-users-to-groups-modal-container"
  }, /*#__PURE__*/React__default.createElement(_Modal, {
    destroyOnClose: true,
    visible: visible,
    wrapClassName: "vertical-center-modal",
    title: isEdit(user) ? I18n.t('users_table.update_access.modal_title') : I18n.t('users_table.add_access.modal_title'),
    onCancel: handleClose,
    afterClose: null,
    closable: true,
    footer: [/*#__PURE__*/React__default.createElement(_Button, {
      key: "back",
      onClick: handleClose,
      disabled: isSaving,
      className: "cancel-btn"
    }, I18n.t('users_table.add_access.cancel')), /*#__PURE__*/React__default.createElement(_Button, {
      key: "submit",
      type: "primary",
      loading: isSaving,
      onClick: handleAdd,
      disabled: isDisabled()
    }, isEdit(user) ? I18n.t('users_table.update_access.update') : I18n.t('users_table.add_access.add'))],
    width: 500
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "add-users-to-groups-modal"
  }, /*#__PURE__*/React__default.createElement(_Row, {
    gutter: [16, 16]
  }, /*#__PURE__*/React__default.createElement(_Col, {
    span: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "title"
  }, I18n.t('users_table.add_access.name')), /*#__PURE__*/React__default.createElement("div", null, user === null || user === void 0 ? void 0 : user.name)), /*#__PURE__*/React__default.createElement(_Col, {
    span: 12
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "title"
  }, I18n.t('users_table.add_access.email')), /*#__PURE__*/React__default.createElement("div", null, user === null || user === void 0 ? void 0 : user.email))), !isEdit(user) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Array(selectFieldsCount).fill(null).map(function (_, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "select",
      key: index
    }, /*#__PURE__*/React__default.createElement(_Row, {
      gutter: [16, 16]
    }, /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, I18n.t('users_table.add_access.group')), /*#__PURE__*/React__default.createElement(Searchbar, {
      defaultValue: [],
      onChange: function onChange(option) {
        return onSelectChange(index, 'group', option);
      },
      searchList: filteredGroupsList(index),
      placeholder: groupPlaceholder
    })), /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, I18n.t('users_table.add_access.role')), /*#__PURE__*/React__default.createElement(Searchbar, {
      defaultValue: [],
      onChange: function onChange(option) {
        return onSelectChange(index, 'role', option);
      },
      placeholder: rolePlaceholder,
      searchList: rolesList(),
      showArrow: true
    }))));
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, defaultRoleValues.map(function (role, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "select",
      key: index
    }, /*#__PURE__*/React__default.createElement(_Row, {
      gutter: [16, 16]
    }, /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, I18n.t('users_table.add_access.group')), /*#__PURE__*/React__default.createElement(Searchbar, {
      key: JSON.stringify(defaultGroupValues[index]),
      onChange: function onChange(option) {
        return onSelectChange(index, 'group', option);
      },
      defaultValue: defaultGroupValues[index],
      searchList: filteredGroupsList(index),
      placeholder: groupPlaceholder
    })), /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, I18n.t('users_table.add_access.role')), /*#__PURE__*/React__default.createElement(Searchbar, {
      key: JSON.stringify(defaultRoleValues[index]),
      onChange: function onChange(option) {
        return onSelectChange(index, 'role', option);
      },
      defaultValue: defaultRoleValues[index],
      placeholder: rolePlaceholder,
      searchList: rolesList(),
      showArrow: true
    }))));
  }), Array(selectFieldsCount - 1).fill(null).map(function (_, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "select",
      key: index
    }, /*#__PURE__*/React__default.createElement(_Row, {
      gutter: [16, 16]
    }, /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, I18n.t('users_table.add_access.group')), /*#__PURE__*/React__default.createElement(Searchbar, {
      defaultValue: [],
      onChange: function onChange(option) {
        return onSelectChange(defaultRoleValues.length + index, 'group', option);
      },
      searchList: filteredGroupsList(defaultRoleValues.length + index),
      placeholder: groupPlaceholder
    })), /*#__PURE__*/React__default.createElement(_Col, {
      span: 12
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "title"
    }, I18n.t('users_table.add_access.role')), /*#__PURE__*/React__default.createElement(Searchbar, {
      defaultValue: [],
      onChange: function onChange(option) {
        return onSelectChange(defaultRoleValues.length + index, 'role', option);
      },
      placeholder: rolePlaceholder,
      searchList: rolesList(),
      showArrow: true
    }))));
  })), /*#__PURE__*/React__default.createElement("a", {
    className: "add-role-button",
    onClick: handleAddAnotherSelectField
  }, I18n.t('users_table.add_access.add_another_role')))));
};

var MultipleData = function MultipleData(props) {
  var data = props.data,
      limit = props.limit,
      renderFunction = props.renderFunction;
  var hiddenContent = data.length - limit;

  var handleOnClick = function handleOnClick() {
    props.callback();
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.viewMore ? data.map(function (content) {
    return renderFunction(content);
  }) : data.slice(0, limit).map(function (content) {
    return renderFunction(content);
  }), hiddenContent > 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: "view_more_link",
    onClick: handleOnClick
  }, props.viewMore ? "Collapse" : "".concat(hiddenContent, " More")) : null);
};

var UsersTable = function UsersTable(_ref) {
  var users = _ref.users,
      loading = _ref.loading,
      offset = _ref.offset,
      ps = _ref.ps,
      hasMore = _ref.hasMore,
      fetchUsers = _ref.fetchUsers,
      accessToken = _ref.accessToken,
      theatreAclUrl = _ref.theatreAclUrl,
      isCinemasAdmin = _ref.isCinemasAdmin;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      user = _useState4[0],
      setUser = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      expand = _useState6[0],
      setExpand = _useState6[1];

  useEffect(function () {
    var expandData = [];

    if (users) {
      expandData = users === null || users === void 0 ? void 0 : users.map(function (userData) {
        var _userData$roles;

        return {
          userid: userData.Id,
          roles: (_userData$roles = userData.roles) === null || _userData$roles === void 0 ? void 0 : _userData$roles.map(function (role) {
            return {
              id: role.id,
              expanded: false
            };
          })
        };
      });
    }

    setExpand(expandData);
  }, [users]);

  var isAdmin = function isAdmin(user) {
    var _user$roles;

    return user === null || user === void 0 ? void 0 : (_user$roles = user.roles) === null || _user$roles === void 0 ? void 0 : _user$roles.filter(function (role) {
      return role.code.toLowerCase() === 'admin';
    }).length;
  };

  var renderGroupsData = function renderGroupsData(group) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "table-data__txt",
      key: group.id
    }, /*#__PURE__*/React__default.createElement("span", null, group.name), /*#__PURE__*/React__default.createElement("span", {
      className: "table-data__hlpTxt"
    }, "".concat(group.theatreCount, " Theatres")));
  };

  var ifGroupExapnded = function ifGroupExapnded(original, roleid) {
    var _expand$index, _expand$index$roles, _expand$index2, _expand$index2$roles$;

    var index = expand.findIndex(function (data) {
      return data.userid === original.Id;
    });
    var roleIndex = (_expand$index = expand[index]) === null || _expand$index === void 0 ? void 0 : (_expand$index$roles = _expand$index.roles) === null || _expand$index$roles === void 0 ? void 0 : _expand$index$roles.findIndex(function (data) {
      return data.id === roleid;
    });
    return (_expand$index2 = expand[index]) === null || _expand$index2 === void 0 ? void 0 : (_expand$index2$roles$ = _expand$index2.roles[roleIndex]) === null || _expand$index2$roles$ === void 0 ? void 0 : _expand$index2$roles$.expanded;
  };

  var setExpandData = function setExpandData(original, roleid) {
    var _expand$index3, _expand$index3$roles, _newExpandData$index;

    var index = expand.findIndex(function (data) {
      return data.userid === original.Id;
    });
    var roleIndex = (_expand$index3 = expand[index]) === null || _expand$index3 === void 0 ? void 0 : (_expand$index3$roles = _expand$index3.roles) === null || _expand$index3$roles === void 0 ? void 0 : _expand$index3$roles.findIndex(function (data) {
      return data.id === roleid;
    });

    var newExpandData = _toConsumableArray(expand);

    if ((_newExpandData$index = newExpandData[index]) !== null && _newExpandData$index !== void 0 && _newExpandData$index.roles[roleIndex]) {
      var _newExpandData$index2, _newExpandData$index3;

      newExpandData[index].roles[roleIndex].expanded = !((_newExpandData$index2 = newExpandData[index]) !== null && _newExpandData$index2 !== void 0 && (_newExpandData$index3 = _newExpandData$index2.roles[roleIndex]) !== null && _newExpandData$index3 !== void 0 && _newExpandData$index3.expanded);
    }

    setExpand(_toConsumableArray(newExpandData));
  };

  var columns = [{
    Header: I18n.t('users_table.columns.name'),
    accessor: 'name',
    Cell: function Cell(_ref2) {
      var value = _ref2.value,
          original = _ref2.original;

      if (original.status !== 'active') {
        var renderStatus = original.status !== '' ? "(".concat(I18n.t("users_table.status.".concat(original.status)), ")") : '';
        return /*#__PURE__*/React__default.createElement("div", {
          className: "".concat(original.status)
        }, value ? "".concat(value, " ").concat(original.lastName ? original.lastName : '', " ").concat(renderStatus) : "- ".concat(renderStatus));
      }

      return /*#__PURE__*/React__default.createElement("div", null, value, " ", original.lastName);
    }
  }, {
    Header: I18n.t('users_table.columns.email'),
    accessor: 'email'
  }, {
    id: 'roles',
    Header: I18n.t('users_table.columns.roles'),
    accessor: function accessor(d) {
      var _d$roles;

      return d === null || d === void 0 ? void 0 : (_d$roles = d.roles) === null || _d$roles === void 0 ? void 0 : _d$roles.map(function (role) {
        return role.name;
      });
    },
    Cell: function Cell(_ref3) {
      var value = _ref3.value,
          original = _ref3.original;

      if (!value || !value.length) {
        return /*#__PURE__*/React__default.createElement("div", null, I18n.t('users_table.status.noAccess'));
      }

      if (isAdmin(original)) {
        return /*#__PURE__*/React__default.createElement("div", null, "Admin");
      }

      return original.roles.map(function (role) {
        var _role$groups, _role$groups2, _role$groups3;

        return /*#__PURE__*/React__default.createElement("div", {
          key: role.id,
          className: "role"
        }, /*#__PURE__*/React__default.createElement("span", null, role.name), ifGroupExapnded(original, role.id) ? role === null || role === void 0 ? void 0 : (_role$groups = role.groups) === null || _role$groups === void 0 ? void 0 : _role$groups.map(function () {
          return /*#__PURE__*/React__default.createElement("br", null);
        }) : role === null || role === void 0 ? void 0 : (_role$groups2 = role.groups) === null || _role$groups2 === void 0 ? void 0 : _role$groups2.slice(0, 3).map(function () {
          return /*#__PURE__*/React__default.createElement("br", null);
        }), (role === null || role === void 0 ? void 0 : (_role$groups3 = role.groups) === null || _role$groups3 === void 0 ? void 0 : _role$groups3.length) > 3 ? /*#__PURE__*/React__default.createElement("br", null) : null);
      });
    }
  }, {
    id: 'hasAccessTo',
    Header: I18n.t('users_table.columns.hasAccessTo'),
    Cell: function Cell(_ref4) {
      var _original$roles;

      var original = _ref4.original;

      if (!(original !== null && original !== void 0 && original.roles)) {
        return /*#__PURE__*/React__default.createElement("div", null, "-");
      }

      if (isAdmin(original)) {
        return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("i", null, "All Theatres"));
      }

      var count = 0;
      return original === null || original === void 0 ? void 0 : (_original$roles = original.roles) === null || _original$roles === void 0 ? void 0 : _original$roles.map(function (role) {
        if (!role.groups || !role.groups.length) {
          if (isCinemasAdmin || count) {
            return null;
          }

          count += 1;
          return /*#__PURE__*/React__default.createElement("div", {
            className: "role",
            onClick: function onClick() {
              return handleMapUserClick(original);
            }
          }, /*#__PURE__*/React__default.createElement("a", null, "Add Group"));
        }

        return /*#__PURE__*/React__default.createElement("div", {
          key: role.id,
          className: "role"
        }, /*#__PURE__*/React__default.createElement(MultipleData, {
          data: role.groups,
          limit: 3,
          renderFunction: renderGroupsData,
          callback: function callback() {
            return setExpandData(original, role.id);
          },
          viewMore: ifGroupExapnded(original, role.id)
        }));
      });
    }
  }, {
    Header: I18n.t('users_table.columns.lastUpdatedOn'),
    accessor: 'updatedOn',
    defaultSortMethod: function defaultSortMethod(a, b) {
      return moment(a).unix() - moment(b).unix();
    },
    Cell: function Cell(_ref5) {
      var value = _ref5.value;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "table-data__txt"
      }, /*#__PURE__*/React__default.createElement("span", null, value && moment(value).format('D MMM YYYY')), /*#__PURE__*/React__default.createElement("span", {
        className: "table-data__hlpTxt"
      }, value && moment(value).format('h:mm A')));
    }
  }, _defineProperty({
    id: 'updatedBy',
    Header: I18n.t('users_table.columns.lastUpdatedBy'),
    accessor: 'updatedBy'
  }, "accessor", function accessor(d) {
    return d.updatedBy.name;
  }), {
    id: 'edit',
    Header: '',
    Cell: function Cell(_ref7) {
      var original = _ref7.original;
      return /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return handleMapUserClick(original);
        },
        className: classNames({
          edit: true,
          disabled: isAdmin(original) || !(original !== null && original !== void 0 && original.roles)
        })
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "edit"
      }));
    },
    minWidth: 40
  }];
  var shoudlDisablePrevious = offset === 0;
  var shouldDisableNext = !hasMore;

  var handleClickNext = function handleClickNext() {
    if (!shouldDisableNext) {
      fetchUsers(offset + ps);
    }
  };

  var handleClickPrevious = function handleClickPrevious() {
    if (!shoudlDisablePrevious) {
      fetchUsers(offset - ps);
    }
  };

  var handleMapUserClick = function handleMapUserClick(user) {
    if (isAdmin(user) || !(user !== null && user !== void 0 && user.roles)) {
      return;
    }

    setUser(user);
    setIsOpen(true);
  };

  var currentPage = offset / ps + 1;

  var getDefaultValues = function getDefaultValues() {
    var _user$roles2;

    var defaultGroupValues = [];
    var defaultRoleValues = [];
    var groupsWithRoles = [];
    user === null || user === void 0 ? void 0 : (_user$roles2 = user.roles) === null || _user$roles2 === void 0 ? void 0 : _user$roles2.forEach(function (role) {
      var _role$groups4;

      role === null || role === void 0 ? void 0 : (_role$groups4 = role.groups) === null || _role$groups4 === void 0 ? void 0 : _role$groups4.forEach(function (group) {
        var groupWithRole = {
          groups: [{
            label: group.name,
            value: group.id,
            id: group.id
          }],
          roles: [{
            label: role.name,
            value: role.code
          }]
        };
        groupsWithRoles.push(groupWithRole);
      });
    });
    groupsWithRoles.forEach(function (groupWithRole, index) {
      if (groupWithRole !== null) {
        for (var i = index + 1; i < groupsWithRoles.length; i++) {
          if (groupsWithRoles[i] !== null && groupWithRole.groups[0].id === groupsWithRoles[i].groups[0].id) {
            groupWithRole.roles = [].concat(_toConsumableArray(groupWithRole.roles), _toConsumableArray(groupsWithRoles[i].roles));
            groupsWithRoles[i] = null;
          }
        }
      }
    });
    groupsWithRoles = groupsWithRoles.filter(function (groupWithRole) {
      return groupWithRole !== null;
    });
    groupsWithRoles.forEach(function (groupWithRole, index) {
      if (groupWithRole !== null) {
        for (var i = index + 1; i < groupsWithRoles.length; i++) {
          if (groupsWithRoles[i] !== null && JSON.stringify(groupWithRole.roles) === JSON.stringify(groupsWithRoles[i].roles)) {
            groupWithRole.groups = [].concat(_toConsumableArray(groupWithRole.groups), _toConsumableArray(groupsWithRoles[i].groups));
            groupsWithRoles[i] = null;
          }
        }
      }
    });
    groupsWithRoles = groupsWithRoles.filter(function (groupWithRole) {
      return groupWithRole !== null;
    });
    groupsWithRoles.forEach(function (groupWithRole) {
      defaultGroupValues.push(groupWithRole.groups);
      defaultRoleValues.push(groupWithRole.roles);
    });
    return {
      groups: defaultGroupValues,
      roles: defaultRoleValues
    };
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "usersTable"
  }, /*#__PURE__*/React__default.createElement(CursorPagination, {
    handleNext: handleClickNext,
    handlePrevious: handleClickPrevious,
    shoudlDisablePrevious: shoudlDisablePrevious,
    shouldDisableNext: shouldDisableNext,
    currentPage: currentPage
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Table, {
    manual: false,
    striped: true,
    data: users,
    columns: isCinemasAdmin ? columns.filter(function (column) {
      return column.id !== 'edit';
    }) : columns,
    loading: loading,
    LoadingComponent: /*#__PURE__*/React__default.createElement(TableLoading, {
      columns: columns
    })
  })), /*#__PURE__*/React__default.createElement(CursorPagination, {
    handleNext: handleClickNext,
    handlePrevious: handleClickPrevious,
    shoudlDisablePrevious: shoudlDisablePrevious,
    shouldDisableNext: shouldDisableNext,
    currentPage: currentPage
  }), /*#__PURE__*/React__default.createElement(AddUsersToGroupModal, {
    visible: isOpen,
    handleClose: function handleClose() {
      return setIsOpen(false);
    },
    user: user,
    theatreAclUrl: theatreAclUrl,
    accessToken: accessToken,
    defaultGroupValues: getDefaultValues().groups,
    defaultRoleValues: getDefaultValues().roles,
    fetchUsers: fetchUsers,
    setIsOpen: setIsOpen,
    currentOffset: offset
  }));
};

var GroupsTable = function GroupsTable(_ref) {
  var groups = _ref.groups,
      loading = _ref.loading,
      offset = _ref.offset,
      ps = _ref.ps,
      hasMore = _ref.hasMore,
      fetchGroups = _ref.fetchGroups,
      handleGroupClick = _ref.handleGroupClick;
  var columns = [{
    Header: I18n.t('groups_table.columns.group'),
    accessor: 'name'
  }, {
    Header: I18n.t('groups_table.columns.theatres'),
    accessor: 'theatreCount'
  }, {
    Header: I18n.t('groups_table.columns.users'),
    accessor: 'userCount'
  }, {
    Header: I18n.t('groups_table.columns.lastUpdatedOn'),
    accessor: 'updatedAt',
    defaultSortMethod: function defaultSortMethod(a, b) {
      return moment(a).unix() - moment(b).unix();
    },
    Cell: function Cell(_ref2) {
      var value = _ref2.value;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "table-data__txt"
      }, /*#__PURE__*/React__default.createElement("div", null, value && moment(value).format('D MMM YYYY')), /*#__PURE__*/React__default.createElement("div", {
        className: "table-data__hlpTxt"
      }, value && moment(value).format('h:mm A')));
    }
  }, {
    id: 'updatedBy',
    Header: I18n.t('groups_table.columns.lastUpdatedBy'),
    accessor: function accessor(d) {
      return "".concat(d.updatedBy.name, " ").concat(d.updatedBy.lastName);
    }
  }, {
    id: 'action',
    Header: '',
    Cell: function Cell(_ref3) {
      var original = _ref3.original;
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          textAlign: 'center',
          cursor: 'pointer'
        },
        onClick: handleGroupClick === null || handleGroupClick === void 0 ? void 0 : handleGroupClick.bind(null, original.id)
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "InfoCircle"
      }));
    },
    minWidth: 30
  }];
  var shoudlDisablePrevious = offset === 0;
  var shouldDisableNext = !hasMore;

  var handleClickNext = function handleClickNext() {
    if (!shouldDisableNext) {
      fetchGroups(offset + ps);
    }
  };

  var handleClickPrevious = function handleClickPrevious() {
    if (!shoudlDisablePrevious) {
      fetchGroups(offset - ps);
    }
  };

  var currentPage = offset === 0 ? 1 : ps / offset + 1;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "usersTable"
  }, /*#__PURE__*/React__default.createElement(CursorPagination, {
    handleNext: handleClickNext,
    handlePrevious: handleClickPrevious,
    shoudlDisablePrevious: shoudlDisablePrevious,
    shouldDisableNext: shouldDisableNext,
    currentPage: currentPage
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Table, {
    manual: false,
    striped: true,
    data: groups,
    columns: columns,
    loading: loading,
    LoadingComponent: /*#__PURE__*/React__default.createElement(TableLoading, {
      columns: columns
    })
  })), /*#__PURE__*/React__default.createElement(CursorPagination, {
    handleNext: handleClickNext,
    handlePrevious: handleClickPrevious,
    shoudlDisablePrevious: shoudlDisablePrevious,
    shouldDisableNext: shouldDisableNext,
    currentPage: currentPage
  }));
};

var GroupsDetailTheatreTable = function GroupsDetailTheatreTable(_ref) {
  var theatres = _ref.theatres,
      loading = _ref.loading;
  var columns = [{
    Header: I18n.t('groups_detail_theatre_table.columns.theatre'),
    accessor: 'name'
  }, {
    Header: I18n.t('groups_detail_theatre_table.columns.chain'),
    id: 'chain',
    accessor: function accessor(d) {
      var _d$chain;

      return d === null || d === void 0 ? void 0 : (_d$chain = d.chain) === null || _d$chain === void 0 ? void 0 : _d$chain.display_name;
    }
  }, {
    Header: I18n.t('groups_detail_theatre_table.columns.location'),
    accessor: function accessor(d) {
      return d === null || d === void 0 ? void 0 : d.address;
    },
    id: 'address',
    Cell: function Cell(_ref2) {
      var value = _ref2.value;
      return /*#__PURE__*/React__default.createElement("div", null, formatAddress(value));
    }
  }, {
    Header: I18n.t('groups_detail_theatre_table.columns.screens'),
    accessor: 'screen_count'
  }];
  return /*#__PURE__*/React__default.createElement("div", {
    className: "usersTable"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Table, {
    manual: false,
    striped: true,
    data: theatres,
    columns: columns,
    loading: loading,
    LoadingComponent: /*#__PURE__*/React__default.createElement(TableLoading, {
      columns: columns
    })
  })));
};

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FilterPanel = /*#__PURE__*/function (_Component) {
  _inherits(FilterPanel, _Component);

  var _super = _createSuper$b(FilterPanel);

  function FilterPanel(props) {
    var _this;

    _classCallCheck(this, FilterPanel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "clearAllFilters", function (e) {
      e.stopPropagation();

      _this.toggleClearAll();
    });

    _defineProperty(_assertThisInitialized(_this), "toggleClearAll", function () {
      _this.setState({
        clearAll: !_this.state.clearAll
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setShowClearAll", function (value) {
      _this.setState({
        showClearAll: value
      });
    });

    _this.state = {
      showFiltersList: props.filters.map(function (f) {
        return f.type;
      }),
      showClearAll: false,
      clearAll: false
    };
    return _this;
  }

  _createClass(FilterPanel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.clearAll !== this.props.clearAll) {
        if (this.props.clearAll !== this.state.clearAll) {
          this.setState({
            clearAll: this.props.clearAll
          });
        }
      }

      var previousSelectedFilters = prevProps.filters.map(function (filter) {
        return filter.selectedList;
      });
      var currentSelectedFilters = this.props.filters.map(function (filter) {
        return filter.selectedList;
      });

      if (!_$1.isEqual(previousSelectedFilters.flat(), currentSelectedFilters.flat())) {
        if (currentSelectedFilters.flat().length === 0) {
          this.setShowClearAll(false);
        }
      }
    }
  }, {
    key: "isShowingAllFilters",
    value: function isShowingAllFilters() {
      return this.props.filters.length === this.state.showFiltersList.length;
    }
  }, {
    key: "onShowHideFilter",
    value: function onShowHideFilter(type, bShow) {
      var showFiltersList = _$1.cloneDeep(this.state.showFiltersList);

      if (bShow) {
        showFiltersList.push(type);
      } else {
        showFiltersList = showFiltersList.filter(function (s) {
          return s !== type;
        });
      }

      this.setState({
        showFiltersList: showFiltersList
      });
    }
  }, {
    key: "handleShowHideFilters",
    value: function handleShowHideFilters(e) {
      e.stopPropagation();
      var showFiltersList = this.isShowingAllFilters() ? [] : this.props.filters.map(function (f) {
        return f.type;
      });
      this.setState({
        showFiltersList: showFiltersList
      });
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.props.closeFilter(false);
    }
  }, {
    key: "renderFilterByType",
    value: function renderFilterByType(filter) {
      var filterItem = null;
      var _this$state = this.state,
          clearAll = _this$state.clearAll,
          showClearAll = _this$state.showClearAll;

      if (filter.isSearchable) {
        filterItem = /*#__PURE__*/React__default.createElement(SearchFilter, {
          title: filter.title,
          placeholder: filter.placeholder,
          dropDownPlaceholder: filter.dropDownPlaceholder,
          type: filter.type,
          recentList: filter.recentList,
          onSearch: filter.onSearch,
          searchList: filter.searchList,
          selectedList: filter.selectedList,
          clearAll: clearAll,
          showClearAll: showClearAll,
          setShowClearAll: this.setShowClearAll,
          onSelectDeselect: filter.onSelectDeselect,
          isSearching: filter.isSearching,
          isFetching: filter.isFetching
        });
      } else {
        filterItem = /*#__PURE__*/React__default.createElement(CheckboxFilter, {
          title: filter.title,
          type: filter.type,
          filterList: filter.filterList,
          selectedList: filter.selectedList,
          clearAll: clearAll,
          showClearAll: showClearAll,
          setShowClearAll: this.setShowClearAll,
          onSelectDeselect: filter.onSelectDeselect,
          isFetching: filter.isFetching
        });
      }

      return filterItem;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          filters = _this$props.filters,
          toggleShowFilter = _this$props.toggleShowFilter,
          showCloseIcon = _this$props.showCloseIcon;
      var showClearAll = this.state.showClearAll;
      return /*#__PURE__*/React__default.createElement("div", {
        className: 'filter-panel'
      }, /*#__PURE__*/React__default.createElement(_Row, {
        className: "filter-panel-header"
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 22
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "heading"
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "Filter"
      }), /*#__PURE__*/React__default.createElement("span", null, I18n.t('filterPanel.heading')), showClearAll && /*#__PURE__*/React__default.createElement("span", {
        className: "clear",
        onClick: this.clearAllFilters
      }, I18n.t('filterPanel.clearAll')))), showCloseIcon && /*#__PURE__*/React__default.createElement(_Col, {
        span: 2,
        className: "close",
        onClick: toggleShowFilter
      }, /*#__PURE__*/React__default.createElement(CloseOutlined$1, null))), /*#__PURE__*/React__default.createElement("div", {
        className: "filter-panel-content"
      }, filters && filters.map(function (filter, idx) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: idx,
          className: "filter-panel-item"
        }, _this2.renderFilterByType(filter));
      })));
    }
  }]);

  return FilterPanel;
}(Component);

var QubeIcons = Icons;

var config = {
  // Default type of number
  // Available options: 'number' (default), 'BigNumber', or 'Fraction'
  number: 'BigNumber',
  // Number of significant digits for BigNumbers
  precision: 20
};

var _create = create$1({
  addDependencies: addDependencies,
  divideDependencies: divideDependencies,
  bignumberDependencies: bignumberDependencies,
  multiplyDependencies: multiplyDependencies
}, config);
    _create.add;
    var divide = _create.divide,
    bignumber = _create.bignumber;
    _create.multiply;

var bytesInGb = bignumber('1073741824'); // 1GB in bytes (1024 x 1024 x 1024)

var bytesInKb = bignumber('1024');
var formatDataBytes = function formatDataBytes(totalSize) {
  if (!isNumber$1(totalSize)) return null;
  if (totalSize === 0) return '0 bytes';
  var assetTotalSizeInGb = divide(bignumber(totalSize), bytesInGb);
  var totalSizeUnit;

  if (assetTotalSizeInGb >= bignumber(1)) {
    totalSizeUnit = 'GB';
  } else if (assetTotalSizeInGb * bytesInKb >= bignumber(1)) {
    assetTotalSizeInGb *= 1024;
    totalSizeUnit = 'MB';
  } else {
    assetTotalSizeInGb = assetTotalSizeInGb * 1024 * 1024;
    totalSizeUnit = 'KB';
  }

  assetTotalSizeInGb = assetTotalSizeInGb.toFixed(2);
  return "".concat(+assetTotalSizeInGb.toString(), " ").concat(totalSizeUnit);
};

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Composition = /*#__PURE__*/function (_Component) {
  _inherits(Composition, _Component);

  var _super = _createSuper$a(Composition);

  function Composition(props) {
    var _this;

    _classCallCheck(this, Composition);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChangeDcpTransferStatus", function (newValue) {
      var _this$props = _this.props,
          workOrderNo = _this$props.workOrderNo,
          composition = _this$props.composition;
      _this.state.dcpTransferStatus = newValue && newValue.value;

      _this.props.onChangeDcpTransferStatus(workOrderNo, composition.composition, _this.state.dcpTransferStatus);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDcpTransferStatusUpdate", function () {
      var _this$props2 = _this.props,
          workOrderNo = _this$props2.workOrderNo,
          composition = _this$props2.composition;

      if (composition.dcpTransferStatus) {
        _this.props.onUpdateDcpTransferStatusInServer(workOrderNo, composition.composition);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilterByComposition", function (filterKey, value) {
      if (_this.props.onFilterSelect && _this.props.enableFilters) _this.props.onFilterSelect(filterKey, value);
    });

    _defineProperty(_assertThisInitialized(_this), "onDcpDownloadsStatusClick", function () {
      var _this$props3 = _this.props,
          dcpDownloadsDetails = _this$props3.composition.dcpDownloadsDetails,
          onDcpDownloadsStatusClick = _this$props3.onDcpDownloadsStatusClick;
      onDcpDownloadsStatusClick(dcpDownloadsDetails);
    });

    _defineProperty(_assertThisInitialized(_this), "showDcpDownloadsStatusMessage", function () {
      var _this$props4 = _this.props,
          dcpDownloadsDetails = _this$props4.composition.dcpDownloadsDetails,
          appliances = _this$props4.appliances;
      var queued = 0,
          inProgress = 0,
          downloaded = 0,
          failed = 0,
          pending = 0,
          error = 0,
          unarchiving = 0,
          archived = 0,
          stalled = 0;
      (dcpDownloadsDetails || []).forEach(function (dcpDownloadDetails) {
        switch (dcpDownloadDetails.status) {
          case DcpDownloadStatuses.QUEUED:
            queued++;
            break;

          case DcpDownloadStatuses.IN_PROGRESS:
          case DcpDownloadStatuses.DOWNLOADING:
            inProgress++;
            break;

          case DcpDownloadStatuses.COMPLETED:
          case DcpDownloadStatuses.DOWNLOADED:
            downloaded++;
            break;

          case DcpDownloadStatuses.FAILED:
          case DcpDownloadStatuses.EXPIRED:
            failed++;
            break;

          case DcpDownloadStatuses.SCHEDULED:
            pending++;
            break;

          case DcpDownloadStatuses.ERROR:
            error++;
            break;

          case DcpDownloadStatuses.UNARCHIVING:
            unarchiving++;
            break;

          case DcpDownloadStatuses.ARCHIVED:
            archived++;
            break;

          case DcpDownloadStatuses.STALLED:
            stalled++;
            break;
        }
      });
      var doesPartnerHaveMultipleAppliances = appliances.length > 1;
      var statusMessages = [{
        message: doesPartnerHaveMultipleAppliances ? "".concat(queued, " Queued") : 'Queued',
        count: queued
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(inProgress, " Downloading") : 'Downloading...',
        count: inProgress
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(downloaded, " Downloaded") : 'Downloaded',
        count: downloaded
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(failed, " Failed") : 'Failed',
        count: failed
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(pending, " Pending") : 'Pending',
        count: pending
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(error, " Errors") : 'Error in getting download status',
        count: error
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(unarchiving, " Unarchiving") : 'Unarchiving',
        count: unarchiving
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(archived, " Archived") : 'Archived',
        count: archived
      }, {
        message: doesPartnerHaveMultipleAppliances ? "".concat(stalled, " Stalled") : 'Stalled',
        count: stalled
      }];
      statusMessages = statusMessages.filter(function (statusMessage) {
        return statusMessage.count;
      });
      var consolidatedStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.not_started');

      if (!isEmpty(statusMessages)) {
        consolidatedStatusMessage = statusMessages.map(function (statusMessage) {
          return statusMessage.message;
        }).join(', ');
      }

      return consolidatedStatusMessage;
    });

    _defineProperty(_assertThisInitialized(_this), "renderDcpDownloadsStatus", function () {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "col dcp-download-status"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "cursor-pointer",
        onClick: function onClick() {
          return _this.onDcpDownloadsStatusClick();
        }
      }, _this.showDcpDownloadsStatusMessage()));
    });

    _defineProperty(_assertThisInitialized(_this), "renderDcpTransferDownloadStatus", function () {
      var _this$props5 = _this.props,
          showDcpTransferSelection = _this$props5.showDcpTransferSelection,
          appliances = _this$props5.appliances;
      if (!isEmpty(appliances)) return _this.renderDcpDownloadsStatus();
      if (showDcpTransferSelection) return _this.renderDcpTransferStatusSelection();
      return /*#__PURE__*/React__default.createElement("div", {
        className: "col dcp-transfer-status"
      }, _this.getDcpTransferStatus());
    });

    _defineProperty(_assertThisInitialized(_this), "getDcpTransferStatus", function () {
      var composition = _this.props.composition;

      switch (composition.dcpTransferStatus) {
        case DcpTransferStatuses.STARTED:
          return I18n.t('work_orders.work_order.dcp_transfer_status.started');

        case DcpTransferStatuses.COMPLETED:
          return I18n.t('work_orders.work_order.dcp_transfer_status.completed');

        default:
          return I18n.t('work_orders.work_order.dcp_transfer_status.not_started');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderDcpTransferStatusSelection", function () {
      var _this$props6 = _this.props,
          composition = _this$props6.composition;
          _this$props6.dcpTransferStatuses;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "col-12 dcp-transfer-selection"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col col-8 px1 blue"
      }, /*#__PURE__*/React__default.createElement(DropDown, {
        callbackAction: _this.onChangeDcpTransferStatus,
        placeholder: I18n.t('work_orders.work_order.dcp_transfer_status_label'),
        value: composition.dcpTransferStatus,
        list: DcpTransferStatusOptions
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "col col-4 px1"
      }, /*#__PURE__*/React__default.createElement(BaseButton, {
        buttonType: BUTTON_TYPE.PRIMARY,
        buttonSize: SIZE.REGULAR,
        onClick: _this.handleDcpTransferStatusUpdate,
        className: "update-button",
        buttonText: I18n.t('work_orders.work_order.update')
      })));
    });

    _this.state = {
      dcpTransferStatus: props.composition.dcpTransferStatus
    };
    return _this;
  }

  _createClass(Composition, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        dcpTransferStatus: nextProps.composition.dcpTransferStatus
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props7 = this.props,
          containerClassName = _this$props7.containerClassName,
          composition = _this$props7.composition;
          _this$props7.onFilterSelect;
          var enableFilters = _this$props7.enableFilters;
      var sizeList = composition.assets.filter(function (asset) {
        return asset.type !== 'assetmap' && asset.type !== 'pkl';
      }).map(function (asset) {
        return parseInt(asset.size);
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames('clearfix', 'composition-item-container', containerClassName)
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames('col col-7 text-ellipsis composition-name', {
          'filter clickable': enableFilters
        }),
        title: composition.cplName,
        onClick: function onClick() {
          return _this2.handleFilterByComposition(WorkOrderItemsFilterTagKeys.COMPOSITION, composition.cplName);
        }
      }, composition.cplName), /*#__PURE__*/React__default.createElement("div", {
        className: classNames('col col-3 composition-size')
      }, formatDataBytes(sum(sizeList))), /*#__PURE__*/React__default.createElement("div", {
        className: classNames('col col-2 composition-download')
      }, this.renderDcpTransferDownloadStatus()));
    }
  }]);

  return Composition;
}(Component);

var cookie = new Cookies();
var get$1 = function get(key) {
  return cookie.get(key);
};

var getCookieKey = function getCookieKey(workOrderNo) {
  return "".concat(workOrderNo, "_DUPLICATION_STATE_INFO");
};

var get = function get(workOrderNo) {
  return get$1(getCookieKey(workOrderNo));
};

var defaultWorkOrderStatusState = {
  displayStatus: I18n.t('work_orders.status.assigned'),
  actualStatus: WorkOrderStatuses.APPROVED,
  overallCplsDcpUploadStatus: DcpUploadStatuses.NOT_STARTED,
  overallCplsDcpDownloadStatus: DcpDownloadStatuses.NOT_STARTED,
  overallCplsDcpTransferStatus: null,
  enableDcpTransferStatusComponent: false
};
var APPROVED = WorkOrderStatuses.APPROVED;
var _enums$DcpDownloadSta = DcpDownloadStatuses,
    COMPLETED = _enums$DcpDownloadSta.COMPLETED,
    IN_PROGRESS = _enums$DcpDownloadSta.IN_PROGRESS;

var getStatusLabel = function getStatusLabel(status) {
  return I18n.t("work_orders.status.".concat(status));
};

var getWorkOrderStatus = function getWorkOrderStatus(label, value, dcpDownloadStatus, dcpTransferStatus, enableDcpTransferStatusComponent) {
  return {
    displayStatus: label,
    actualStatus: value,
    overallCplsDcpDownloadStatus: dcpDownloadStatus,
    overallCplsDcpTransferStatus: dcpTransferStatus,
    enableDcpTransferStatusComponent: enableDcpTransferStatusComponent
  };
};

var partnerWorkOrderStatusStates = {
  partnerWithoutAppliance: [getWorkOrderStatus(getStatusLabel('ready_to_process'), APPROVED, null, null, true), getWorkOrderStatus(getStatusLabel('in_process'), APPROVED, null, DcpTransferStatuses.STARTED, true), getWorkOrderStatus(getStatusLabel('shipment_pending'), APPROVED, null, DcpTransferStatuses.COMPLETED, true)],
  partnerWithAppliance: [getWorkOrderStatus(getStatusLabel('download_in_progress'), APPROVED, IN_PROGRESS, null, false), getWorkOrderStatus(getStatusLabel('ready_to_process'), APPROVED, COMPLETED, null, false)]
};

var isWorkOrderDuplicationInProgress = function isWorkOrderDuplicationInProgress(workOrderNo) {
  var duplicationStateInfo = get(workOrderNo);
  return !(isEmpty(duplicationStateInfo) || isEmpty(duplicationStateInfo.status));
};
/**
 * this is a Function that depends on paramters passed
 *
 * it will return WorkOrderStatus state
 *
 * which contains display status ,actual status and other overall statuses
 * @function getWorkOrderStatusState
 * @param appliances
 * @param {Workorder}
 * @param {overallWorkOrderStatus}
 * @param isWorkOrderDatePast:boolean
 * @returns {WorkOrderStatusState}
 */


var getWorkOrderStatusState = function getWorkOrderStatusState(appliances, workOrder, overallWorkOrderCplsStatus, isWorkOrderDatePast) {
  var _workOrderStatusState;

  var workOrderStatusState = {};
  var workOrderNo = workOrder.workOrderNo,
      totalCopied = workOrder.totalCopied,
      totalShipped = workOrder.totalShipped,
      totalDrives = workOrder.totalDrives;
  var dispatchedDrives = workOrder.shipments.filter(function (s) {
    return s.status === ShippingStatus.DISPATCHED;
  });
  var cancelledDrives = workOrder.shipments.filter(function (s) {
    return s.status === ShippingStatus.CANCELLED;
  });
  var pendingCancellationDrives = workOrder.shipments.filter(function (s) {
    return s.status === ShippingStatus.PENDING_CANCELLATION;
  });

  if ([WorkOrderStatuses.CANCELLED, WorkOrderStatuses.REJECTED].includes(workOrder.status) || every(workOrder.shipments, {
    status: ShippingStatus.CANCELLED
  }) || every(workOrder.shipments, {
    status: ShippingStatus.REJECTED
  })) {
    workOrderStatusState.displayStatus = I18n.t('work_orders.status.cancelled');
    return workOrderStatusState;
  }

  if (!isEmpty(appliances) && overallWorkOrderCplsStatus.dcpDownloadStatus === DcpDownloadStatuses.FAILED) {
    workOrderStatusState.displayStatus = I18n.t('work_orders.status.download_failed');
    return workOrderStatusState;
  }

  if (pendingCancellationDrives.length > 0) {
    if (dispatchedDrives.length + cancelledDrives.length + pendingCancellationDrives.length === workOrder.shipments.length) {
      workOrderStatusState.displayStatus = I18n.t('work_orders.status.shipments_pending_cancellation');
      return workOrderStatusState;
    }

    if (!isWorkOrderDatePast && dispatchedDrives.length + cancelledDrives.length + pendingCancellationDrives.length < workOrder.shipments.length) {
      workOrderStatusState.displayStatus = [I18n.t('work_orders.status.update_shipping_details'), I18n.t('work_orders.status.shipments_pending_cancellation')].join(', ');
      return workOrderStatusState;
    }
  }

  if (isWorkOrderDatePast) {
    workOrderStatusState.displayStatus = I18n.t('work_orders.status.update_shipping_details');
    return workOrderStatusState;
  }

  if (totalShipped > 0) {
    workOrderStatusState.displayStatus = I18n.t('work_orders.status.shipment_pending');

    if (dispatchedDrives.length + cancelledDrives.length === totalDrives) {
      workOrderStatusState.displayStatus = I18n.t('work_orders.status.shipment_completed');
    }
  } else if (totalCopied > 0 || isWorkOrderDuplicationInProgress(workOrderNo)) {
    workOrderStatusState = {
      displayStatus: I18n.t('work_orders.status.duplication_in_progress'),
      actualStatus: workOrder.status,
      overallCplsDcpUploadStatus: DcpUploadStatuses.COMPLETED,
      overallCplsDcpDownloadStatus: DcpDownloadStatuses.COMPLETED,
      overallCplsDcpTransferStatus: null,
      enableDcpTransferStatusComponent: false
    };

    if (totalCopied === totalDrives) {
      workOrderStatusState.displayStatus = I18n.t('work_orders.status.shipment_pending');
    }
  } else {
    var partnerWithoutAppliance = partnerWorkOrderStatusStates.partnerWithoutAppliance,
        partnerWithAppliance = partnerWorkOrderStatusStates.partnerWithAppliance;
    var actualPartnerWithoutApplianceStatus = {
      actualStatus: workOrder.status,
      overallCplsDcpTransferStatus: overallWorkOrderCplsStatus.dcpTransferStatus
    };
    var actualPartnerWithApplianceStatus = {
      actualStatus: workOrder.status,
      overallCplsDcpTransferStatus: overallWorkOrderCplsStatus.dcpTransferStatus,
      overallCplsDcpDownloadStatus: overallWorkOrderCplsStatus.dcpDownloadStatus
    };

    if (isEmpty(appliances)) {
      var workOrderStatus = find(partnerWithoutAppliance, actualPartnerWithoutApplianceStatus);
      if (!isEmpty(workOrderStatus)) workOrderStatusState = workOrderStatus;
    } else {
      var _workOrderStatus = find(partnerWithAppliance, actualPartnerWithApplianceStatus);

      if (!isEmpty(_workOrderStatus)) workOrderStatusState = _workOrderStatus;
    }
  }

  return (_workOrderStatusState = workOrderStatusState) !== null && _workOrderStatusState !== void 0 ? _workOrderStatusState : defaultWorkOrderStatusState;
};

/**
 * This is a pure function acts based on the parameter passed (composition).
 *
 * Based on compositions available, the DCP download details are gathered and grouped based on the serial number.
 *
 * For each appliances, based on the DCP download status the count for each status are incremented.
 *
 * For those appliances whose count values are more than zero the dcpDownloadStatus value gets updated according to status available in enums.
 *
 * Finally thus based on the count, each of the appliances will have the values under below format.
 *
 * ```typescript
 *  const data = {
 *    [serialNumber]: {dcpDownloadStatus: value}
 *  }
 * ```
 *
 * @param { Array<Composition>}
 * @returns { dcpDownloadStatusByApplianceSerialNo }
 */

var getDcpDownloadStatusByApplianceSerialNo = function getDcpDownloadStatusByApplianceSerialNo(compositions) {
  var dcpDownloadDetailsAcrossCpls = [];
  var firstCplWithDcpDownloadsDetails = compositions.find(function (c) {
    return c.dcpDownloadsDetails.length > 0;
  });
  var serialNos = firstCplWithDcpDownloadsDetails ? map$1(firstCplWithDcpDownloadsDetails.dcpDownloadsDetails, 'serialNo') : [];
  var DcpDownloadStatuses$1 = DcpDownloadStatuses;
  var dcpDownloadStatusByApplianceSerialNo = {};
  compositions.forEach(function (composition) {
    if (isEmpty(composition.dcpDownloadsDetails)) {
      serialNos.forEach(function (serialNo) {
        dcpDownloadDetailsAcrossCpls.push({
          status: DcpDownloadStatuses$1.NOT_STARTED,
          serialNo: serialNo
        });
      });
    } else {
      composition.dcpDownloadsDetails.forEach(function (dcpDownloadDetails) {
        dcpDownloadDetailsAcrossCpls.push(dcpDownloadDetails);
      });
    }
  });
  var dcpDownloadNotStartedCount = 0;
  var dcpDownloadCompletedCount = 0;
  var dcpDownloadFailedCount = 0;
  var dcpDownloadPending = 0;
  var dcpDownloadError = 0;
  var dcpDownloadUnarchiving = 0;
  var dcpDownloadArchived = 0;
  var dcpDownloadStalled = 0;
  var groupedDcpDownloadDetailsByApplianceSerialNo = groupBy(dcpDownloadDetailsAcrossCpls, function (dcpDownloadDetails) {
    return dcpDownloadDetails.serialNo;
  });
  forEach$1(groupedDcpDownloadDetailsByApplianceSerialNo, function (dcpDownloadsDetails, serialNo) {
    dcpDownloadNotStartedCount = 0;
    dcpDownloadCompletedCount = 0;
    dcpDownloadFailedCount = 0;
    dcpDownloadPending = 0;
    dcpDownloadError = 0;
    dcpDownloadUnarchiving = 0;
    dcpDownloadArchived = 0;
    dcpDownloadStalled = 0;
    dcpDownloadsDetails.forEach(function (dcpDownloadDetails) {
      switch (dcpDownloadDetails && dcpDownloadDetails.status) {
        case DcpDownloadStatuses$1.NOT_STARTED:
          dcpDownloadNotStartedCount += 1;
          break;

        case DcpDownloadStatuses$1.QUEUED:
          break;

        case DcpDownloadStatuses$1.IN_PROGRESS:
          break;

        case DcpDownloadStatuses$1.COMPLETED:
          dcpDownloadCompletedCount += 1;
          break;

        case DcpDownloadStatuses$1.FAILED:
          dcpDownloadFailedCount += 1;
          break;

        case DcpDownloadStatuses$1.DOWNLOADED:
          dcpDownloadCompletedCount += 1;
          break;

        case DcpDownloadStatuses$1.DOWNLOADING:
          break;

        case DcpDownloadStatuses$1.EXPIRED:
          dcpDownloadFailedCount += 1;
          break;

        case DcpDownloadStatuses$1.SCHEDULED:
          dcpDownloadPending += 1;
          break;

        case DcpDownloadStatuses$1.ERROR:
          dcpDownloadError += 1;
          break;

        case DcpDownloadStatuses$1.UNARCHIVING:
          dcpDownloadUnarchiving += 1;
          break;

        case DcpDownloadStatuses$1.ARCHIVED:
          dcpDownloadArchived += 1;
          break;

        case DcpDownloadStatuses$1.STALLED:
          dcpDownloadStalled += 1;
          break;
      }
    });
    dcpDownloadStatusByApplianceSerialNo[serialNo] = {};
    var dcpDownloadsDetailsLen = dcpDownloadsDetails.length;

    if (dcpDownloadFailedCount > 0) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.FAILED;
    } else if (dcpDownloadNotStartedCount === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.NOT_STARTED;
    } else if (dcpDownloadCompletedCount === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.COMPLETED;
    } else if (dcpDownloadPending === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.PENDING;
    } else if (dcpDownloadError === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.ERROR;
    } else if (dcpDownloadUnarchiving === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.UNARCHIVING;
    } else if (dcpDownloadArchived === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.ARCHIVED;
    } else if (dcpDownloadStalled === dcpDownloadsDetailsLen) {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.STALLED;
    } else {
      dcpDownloadStatusByApplianceSerialNo[serialNo].dcpDownloadStatus = DcpDownloadStatuses$1.IN_PROGRESS;
    }
  });
  return dcpDownloadStatusByApplianceSerialNo;
};
/**
 * This is a pure function that acts based on the parameter (compositions)
 *
 * We receive a array of compositions were we have an DCP upload status object
 *
 * Based on the status we will update the count of in_progress and completed data
 *
 * The status is purely related with DCP upload.
 *
 * Finally we receive the in progress count and completed count
 *
 * @external
 * @param {Array<Composition>}
 * @return {DcpUploadStatesCount}
 *
 * ```typescript
 * DcpUploadStatesCount = {
 *    dcpUploadInProgressCount: 0,
 *    dcpUploadCompletedCount: 0
 * }
 * ```
 */

var getDcpUploadStatesCount = function getDcpUploadStatesCount(compositions) {
  var dcpUploadInProgressCount = 0;
  var dcpUploadCompletedCount = 0;
  compositions.forEach(function (composition) {
    switch (composition.dcpUploadStatus) {
      case DcpUploadStatuses.IN_PROGRESS:
        dcpUploadInProgressCount += 1;
        break;

      case DcpUploadStatuses.COMPLETED:
        dcpUploadCompletedCount += 1;
        break;
    }
  });
  return {
    dcpUploadInProgressCount: dcpUploadInProgressCount,
    dcpUploadCompletedCount: dcpUploadCompletedCount
  };
};
/**
 * This is a pure function that solely depends on the parameters passed.
 *
 * This function updates the dcpUploadStatus as completed or in_progress based on the number of cpl and dcpUploadStatesCount.
 *
 * @external
 * @param {OverallWorkOrderCplsStatus} overallWorkOrderCplsStatus
 * @param {number} cplsLength
 * @param {DcpUploadStatesCount} dcpUploadStatesCount
 * @return {OverallWorkOrderCplsStatus}  {OverallWorkOrderCplsStatus}
 *
 *```typescript
 * const output = {
 *    dcpUploadStatus: 'in_progress', // Updates the status based on the count
 *    dcpDownloadStatus: 'downloading',
 *    dcpTransferStatus: 'completed';
 * }
 * ```
 */


var updateDcpUploadStatusInOverallWorkOrderCplsStatus = function updateDcpUploadStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, cplsLength, dcpUploadStatesCount) {
  var dcpUploadInProgressCount = dcpUploadStatesCount.dcpUploadInProgressCount,
      dcpUploadCompletedCount = dcpUploadStatesCount.dcpUploadCompletedCount;

  if (dcpUploadInProgressCount > 0) {
    overallWorkOrderCplsStatus.dcpUploadStatus = DcpUploadStatuses.IN_PROGRESS;
  } else if (dcpUploadCompletedCount === cplsLength) {
    overallWorkOrderCplsStatus.dcpUploadStatus = DcpUploadStatuses.COMPLETED;
  }

  return overallWorkOrderCplsStatus;
};
/**
 * This is a pure function that acts based on the composition parameter.
 *
 * Based on the dcpTransferStatus available in the composition the status count are updated
 *
 * The status is purely related with DCP upload.
 *
 * Finally we receive the DCP transfer started count and completed count
 *
 * @external
 * @param {Array<Composition>} compositions
 * @return {DcpTransferStatesCount} DcpTransferStatesCount
 *
 * ```typescript
 * const output = {
 *    cpTransferStartedCount: number,
 *    dcpTransferCompletedCount: number,
 * }
 * ```
 *
 */


var getDcpTransferStatesCount = function getDcpTransferStatesCount(compositions) {
  var dcpTransferStartedCount = 0;
  var dcpTransferCompletedCount = 0;
  compositions.forEach(function (composition) {
    switch (composition.dcpTransferStatus) {
      case DcpTransferStatuses.STARTED:
        dcpTransferStartedCount += 1;
        break;

      case DcpTransferStatuses.COMPLETED:
        dcpTransferCompletedCount += 1;
        break;
    }
  });
  return {
    dcpTransferStartedCount: dcpTransferStartedCount,
    dcpTransferCompletedCount: dcpTransferCompletedCount
  };
};
/**
 * This is the pure function that solely depends on the parameters passed.
 *
 * This function updates the dcpTransferStatus as completed or started based on the number of cpl and dcpTransferStatesCount
 *
 * @external
 * @param {OverallWorkOrderCplsStatus} overallWorkOrderCplsStatus
 * @param {number} cplsLength
 * @param {DcpTransferStatesCount} dcpTransferStatesCount
 * @return {OverallWorkOrderCplsStatus}  {OverallWorkOrderCplsStatus}
 *
 * ```typescript
 * const output = {
 *    dcpUploadStatus: 'in_progress',
 *    dcpDownloadStatus: 'downloading',
 *    dcpTransferStatus: 'completed',// Updates the status based on the count
 * }
 */


var updateDcpTransferStatusInOverallWorkOrderCplsStatus = function updateDcpTransferStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, cplsLength, dcpTransferStatesCount) {
  var dcpTransferStartedCount = dcpTransferStatesCount.dcpTransferStartedCount,
      dcpTransferCompletedCount = dcpTransferStatesCount.dcpTransferCompletedCount;
  var DcpTransferStatuses$1 = DcpTransferStatuses;

  if (dcpTransferStartedCount > 0) {
    overallWorkOrderCplsStatus.dcpTransferStatus = DcpTransferStatuses$1.STARTED;
  } else if (dcpTransferCompletedCount > 0) {
    if (dcpTransferCompletedCount === cplsLength) {
      overallWorkOrderCplsStatus.dcpTransferStatus = DcpTransferStatuses$1.COMPLETED;
    } else {
      overallWorkOrderCplsStatus.dcpTransferStatus = DcpTransferStatuses$1.STARTED;
    }
  }

  return overallWorkOrderCplsStatus;
};
/**
 * This is a pure function acts based on the parameter
 *
 * It uses the previously computed @param {dcpDownloadStatusByApplianceSerialNo}
 *
 * For each appliances, based the DCP download details status the count for each status are incremented
 *
 * For those appliances whose values are more than zero the dcpDownloadStatus value gets updated according to status available in enums
 *
 * This is the pure function that solely depends on the parameters passed
 *
 * This function updates the dcpDownloadStatus as either one of the status based on the number of DcpDownloadStatusByApplianceSerialNo
 *
 * @external
 * @param {OverallWorkOrderCplsStatus} overallWorkOrderCplsStatus
 * @param {DcpDownloadStatusByApplianceSerialNo} dcpDownloadStatusByApplianceSerialNo
 * @return {OverallWorkOrderCplsStatus} OverallWorkOrderCplsStatus
 *
 * ```typescript
 * const output = {
 *    dcpUploadStatus: 'in_progress',
 *    dcpDownloadStatus: 'downloading', // Updates the status based on the count
 *    dcpTransferStatus: 'completed',
 * }
 * ```
 *
 */


var updateDcpDownloadStatusInOverallWorkOrderCplsStatus = function updateDcpDownloadStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, dcpDownloadStatusByApplianceSerialNo) {
  var dcpDownloadNotStartedCount = 0;
  var dcpDownloadCompletedCount = 0;
  var dcpDownloadFailedCount = 0;
  var dcpDownloadPending = 0;
  var dcpDownloadError = 0;
  var DcpDownloadStatuses$1 = DcpDownloadStatuses;
  forEach$1(dcpDownloadStatusByApplianceSerialNo, function (item) {
    switch (item && item.dcpDownloadStatus) {
      case DcpDownloadStatuses$1.NOT_STARTED:
        dcpDownloadNotStartedCount += 1;
        break;

      case DcpDownloadStatuses$1.QUEUED:
        break;

      case DcpDownloadStatuses$1.IN_PROGRESS:
        break;

      case DcpDownloadStatuses$1.COMPLETED:
        dcpDownloadCompletedCount += 1;
        break;

      case DcpDownloadStatuses$1.DOWNLOADED:
        dcpDownloadCompletedCount += 1;
        break;

      case DcpDownloadStatuses$1.FAILED:
        dcpDownloadFailedCount += 1;
        break;

      case DcpDownloadStatuses$1.EXPIRED:
        dcpDownloadFailedCount += 1;
        break;

      case DcpDownloadStatuses$1.SCHEDULED:
        dcpDownloadPending += 1;
        break;

      case DcpDownloadStatuses$1.ERROR:
        dcpDownloadError += 1;
        break;
    }
  });
  var dcpDownloadStatusByApplianceSerialNoLen = keys(dcpDownloadStatusByApplianceSerialNo).length;

  if (dcpDownloadCompletedCount > 0) {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.COMPLETED;
  } else if (dcpDownloadNotStartedCount === dcpDownloadStatusByApplianceSerialNoLen) {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.NOT_STARTED;
  } else if (dcpDownloadFailedCount === dcpDownloadStatusByApplianceSerialNoLen) {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.FAILED;
  } else if (dcpDownloadPending === dcpDownloadStatusByApplianceSerialNoLen) {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.PENDING;
  } else if (dcpDownloadError === dcpDownloadStatusByApplianceSerialNoLen) {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.ERROR;
  } else {
    overallWorkOrderCplsStatus.dcpDownloadStatus = DcpDownloadStatuses$1.IN_PROGRESS;
  }

  return overallWorkOrderCplsStatus;
};
/**
 * This the main function that returns the overall Download, Upload, Transfer Status based on the compositions parameter.
 *
 * This function uses the all above functions to compute the values,
 *
 * The function works totally based on the the DCP download and upload details that is available
 * under each compositions
 *
 * ```typescript
 *  const output = {
 *    dcpUploadStatus: 'in_progress',
 *    dcpDownloadStatus: 'downloading',
 *    dcpTransferStatus: 'completed';
 *  }
 * ```
 *
 * @external
 * @param {Array<Composition>} compositions
 * @return {OverallWorkOrderCplsStatus} OverallWorkOrderCplsStatus
 */


var getOverallWorkOrderCplsStatus = function getOverallWorkOrderCplsStatus(compositions) {
  var overallWorkOrderCplsStatus = {
    dcpUploadStatus: null,
    dcpDownloadStatus: null,
    dcpTransferStatus: null
  };
  var cplsLength = compositions.length;
  /**
   * A local scoped variable that holds count values
   * @returns {object} dcpUploadStatesCount
   *
   * ```typescript
   * const data = {
   *    dcpUploadInProgressCount: 0,
   *    dcpUploadCompletedCount: 0
   * }
   * ```
   */

  var dcpUploadStatesCount = getDcpUploadStatesCount(compositions);
  /**
   * A local scoped variable with count values
   * @param {object} overallWorkOrderCplsStatus the DCP upload, download, transfer status
   * @param {number} cplsLength number of compositions
   * @param {number} dcpUploadStatesCount is the local scoped variable with count
   * values as said above
   * @returns {null}
   */

  overallWorkOrderCplsStatus = updateDcpUploadStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, cplsLength, dcpUploadStatesCount);
  /**
   * A local scoped variable that collected the DCP download status based on the serial number
   */

  var dcpDownloadStatusByApplianceSerialNo = getDcpDownloadStatusByApplianceSerialNo(compositions);
  /**
   * A local scoped variable that updates the dcp download status
   */

  overallWorkOrderCplsStatus = updateDcpDownloadStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, dcpDownloadStatusByApplianceSerialNo);
  /**
   * A local scoped variable that stores the dcp transfer count
   */

  var dcpTransferStatesCount = getDcpTransferStatesCount(compositions);
  /**
   * A local scoped variable that updates the dcp transfer status
   */

  overallWorkOrderCplsStatus = updateDcpTransferStatusInOverallWorkOrderCplsStatus(overallWorkOrderCplsStatus, cplsLength, dcpTransferStatesCount);
  return overallWorkOrderCplsStatus;
};

var WorkOrderCplStatus = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getDcpDownloadStatusByApplianceSerialNo: getDcpDownloadStatusByApplianceSerialNo,
  getOverallWorkOrderCplsStatus: getOverallWorkOrderCplsStatus
});

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DriveIcon = QubeIcons.DriveIcon,
    ApplianceIcon = QubeIcons.ApplianceIcon,
    InfoFilledIcon = QubeIcons.InfoFilledIcon,
    DownloadIcon = QubeIcons.DownloadIcon,
    AlertFilledIcon = QubeIcons.AlertFilledIcon;
    QubeIcons.ViewIcon;
    QubeIcons.ConfirmIcon; // Predefined set of work order status inferred from WorkOrderStatusState function

var infoStatuses = ['Assigned', 'Ready to process', 'In Process', 'Fulfilled', 'Download in progress', 'Copy in progress', 'Cancelled', 'Shipments pending cancellation'];
var failedActionMsgList = ['Download failed', 'Pending shipment', 'Delivery date has passed. Please update shipping details.', 'Delivery date has passed. Please update shipping details, Shipments pending cancellation'];

var WorkOrderCard = /*#__PURE__*/function (_Component) {
  _inherits(WorkOrderCard, _Component);

  var _super = _createSuper$9(WorkOrderCard);

  function WorkOrderCard() {
    var _this;

    _classCallCheck(this, WorkOrderCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      workOrderStatusState: null
    });

    _defineProperty(_assertThisInitialized(_this), "setWorkOrderStatusState", function (workOrder) {
      var appliances = _this.getAppliances();

      var overallWorkOrderCplsStatus = getOverallWorkOrderCplsStatus(workOrder.compositions);
      var workOrderStatusState = getWorkOrderStatusState(appliances, workOrder, overallWorkOrderCplsStatus, _this.isPastDate(workOrder));

      _this.setState({
        workOrderStatusState: workOrderStatusState
      });
    });

    _defineProperty(_assertThisInitialized(_this), "shouldShowCopyStatus", function () {
      var _this$props = _this.props,
          isAdminPortal = _this$props.isAdminPortal,
          showCopyStatus = _this$props.showCopyStatus;
      if (!showCopyStatus) return false;

      if (isAdminPortal) {
        var partner = _this.getPartnerByWorkOrderOrg();

        if (partner) {
          return partner.type === PartnerTypes.OFFLINE && partner.appliances.length > 0;
        } else {
          return false;
        }
      } else {
        return _this.props.shouldShowCopyStatus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getPartnerByWorkOrderOrg", function () {
      var _this$props2 = _this.props,
          workOrder = _this$props2.workOrder,
          partners = _this$props2.partners;
      return partners.find(function (partner) {
        return partner.orgId === workOrder.org;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getProgressPercent", function (actual, total) {
      var value = parseInt(actual) / parseInt(total);
      return value * 100;
    });

    _defineProperty(_assertThisInitialized(_this), "getCancelledShipmentDrives", function (workOrder) {
      return workOrder.shipments.filter(function (shipment) {
        return shipment.status === ShippingStatus.CANCELLED;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getWorkOrderStatus", function () {
      var _this$props$workOrder3;

      var workOrderStatusState = _this.state.workOrderStatusState;
      var workOrderStatus = workOrderStatusState === null || workOrderStatusState === void 0 ? void 0 : workOrderStatusState.displayStatus;

      if (!(workOrderStatusState !== null && workOrderStatusState !== void 0 && workOrderStatusState.displayStatus)) {
        var _this$props$workOrder;

        if ((_this$props$workOrder = _this.props.workOrder) !== null && _this$props$workOrder !== void 0 && _this$props$workOrder.status) {
          var _this$props$workOrder2;

          return /*#__PURE__*/React__default.createElement("span", {
            className: "work-order-status progress custom-status"
          }, (_this$props$workOrder2 = _this.props.workOrder) === null || _this$props$workOrder2 === void 0 ? void 0 : _this$props$workOrder2.status);
        }

        return null;
      }

      if (workOrderStatus === 'Completed') return /*#__PURE__*/React__default.createElement("span", {
        className: "work-order-status completed"
      }, workOrderStatus);
      if (workOrderStatus === 'Cancelled') return /*#__PURE__*/React__default.createElement("span", {
        className: "work-order-status cancelled"
      }, workOrderStatus);
      if (workOrderStatus === 'Assigned') return /*#__PURE__*/React__default.createElement("span", {
        className: "work-order-status assigned"
      }, workOrderStatus);
      if (infoStatuses.includes(workOrderStatus)) return /*#__PURE__*/React__default.createElement("span", {
        className: "work-order-status progress"
      }, workOrderStatus);
      return /*#__PURE__*/React__default.createElement("span", {
        className: "work-order-status progress custom-status"
      }, (_this$props$workOrder3 = _this.props.workOrder) === null || _this$props$workOrder3 === void 0 ? void 0 : _this$props$workOrder3.status);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePageFilters", function (type, data) {
      var partnerData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var _this$props3 = _this.props,
          onFilterSelect = _this$props3.onFilterSelect,
          enableFilters = _this$props3.enableFilters;
      if (!enableFilters) return null;
      if (onFilterSelect) onFilterSelect(type, data, partnerData);
    });

    _defineProperty(_assertThisInitialized(_this), "renderWorkOrderIcon", function () {
      var _this$props$workOrder4 = _this.props.workOrder,
          shipments = _this$props$workOrder4.shipments,
          workOrderNo = _this$props$workOrder4.workOrderNo;
      var deliveryType = shipments[0].deliveryType;

      switch (deliveryType) {
        case WorkOrderDeliveryType.INTERNET:
          return /*#__PURE__*/React__default.createElement(ApplianceIcon, {
            "data-tip": true,
            "data-for": "".concat(workOrderNo, "-icon")
          });

        case WorkOrderDeliveryType.HARD_DRIVE:
        default:
          return /*#__PURE__*/React__default.createElement(DriveIcon, {
            "data-tip": true,
            "data-for": "".concat(workOrderNo, "-icon")
          });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderWorkOrderInfo", function () {
      var _this$props4 = _this.props,
          workOrder = _this$props4.workOrder,
          enableFilters = _this$props4.enableFilters;
      workOrder.shipments[0].deliveryType;
      _this.state.workOrderStatusState;

      var showCopyStatus = _this.shouldShowCopyStatus();

      return /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-top-info"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames('work-order-number', {
          'no-filter': !enableFilters
        }),
        onClick: function onClick() {
          return _this.handlePageFilters(WorkOrderTagList.WORK_ORDER, workOrder.workOrderNo);
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "Work Order:"), workOrder.workOrderNo), /*#__PURE__*/React__default.createElement("div", {
        className: "status-container"
      }, _this.getWorkOrderStatus()), showCopyStatus && workOrder.totalCopied > 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "copy-status-container"
      }, workOrder.totalCopied, "\xA0", I18n.t('work_orders.work_order.copied'))), workOrder.orgName && workOrder.orgLocation && /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-company-info"
      }, _this.renderWorkOrderCompanyInfo()), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-price-info"
      }, workOrder.bookingNo && /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-booking-info"
      }, _this.renderWorkOrderBookingInfo()), workOrder.netAmount && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, workOrder.bookingNo && /*#__PURE__*/React__default.createElement("span", {
        className: "separator"
      }, "\u2022"), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-price"
      }, "USD $", workOrder.netAmount))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderWorkOrderBookingInfo", function () {
      var _this$props5 = _this.props,
          workOrder = _this$props5.workOrder,
          enableFilters = _this$props5.enableFilters;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames('work-order-booking-number', {
          'no-filter': !enableFilters
        }),
        onClick: function onClick() {
          return _this.handlePageFilters(WorkOrderTagList.BOOKING, workOrder.bookingNo);
        }
      }, /*#__PURE__*/React__default.createElement("span", null, "Booking:"), workOrder.bookingNo);
    });

    _defineProperty(_assertThisInitialized(_this), "renderWorkOrderCompanyInfo", function () {
      var _this$props6 = _this.props,
          workOrder = _this$props6.workOrder,
          enableFilters = _this$props6.enableFilters;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-company-details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-company-top-info"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames('work-order-company-name', {
          'no-filter': !enableFilters
        }),
        onClick: function onClick() {
          return _this.handlePageFilters(WorkOrderTagList.PARTNER, workOrder.org, workOrder.orgName);
        }
      }, workOrder.orgName), /*#__PURE__*/React__default.createElement("span", {
        className: "separator"
      }, "\u2022"), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-company-location"
      }, "".concat(workOrder.orgLocation.city, ", ").concat(workOrder.orgLocation.province, ", ").concat(workOrder.orgLocation.country, " "))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderWorkOrderDeliveryInfo", function () {
      var _this$props7 = _this.props,
          workOrder = _this$props7.workOrder;
          _this$props7.isAdminPortal;

      var cancelledShipmentDrives = _this.getCancelledShipmentDrives(workOrder);

      return /*#__PURE__*/React__default.createElement("div", {
        className: "col-12 delivery-details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-shipping-status"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "clearfix text-section"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames('col', {
          'col-6': cancelledShipmentDrives.length > 0,
          'col-4': cancelledShipmentDrives.length === 0
        })
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "status-text"
      }, workOrder.totalShipped, "/", workOrder.totalDrives, "\xA0", I18n.t('work_orders.work_order.deliveries')), cancelledShipmentDrives.length > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "status-text"
      }, ", \xA0", cancelledShipmentDrives.length, "\xA0", I18n.t('work_orders.work_order.cancelled'))), /*#__PURE__*/React__default.createElement("div", {
        className: classNames('col deliverOn', {
          'col-6': cancelledShipmentDrives.length > 0,
          'col-8': cancelledShipmentDrives.length === 0
        })
      }, workOrder.deliverOn && /*#__PURE__*/React__default.createElement("span", {
        className: "delivery-date"
      }, I18n.t('work_orders.work_order.deliver_on'), /*#__PURE__*/React__default.createElement("span", {
        className: "status-text"
      }, momentTZ.tz(moment(workOrder.deliverOn).add(1, 'seconds'), 'Asia/Kolkata').format('DD MMM YYYY'))))), /*#__PURE__*/React__default.createElement(ProgressBar, {
        percent: _this.getProgressPercent(workOrder.totalShipped, workOrder.totalDrives),
        status: "success"
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderViewAction", function () {
      return /*#__PURE__*/React__default.createElement(BaseButton, {
        buttonType: BUTTON_TYPE.PRIMARY,
        buttonSize: SIZE.REGULAR,
        onClick: _this.props.onClickViewButton,
        className: "view-button",
        buttonText: I18n.t('work_orders.work_order.view')
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderActionMenuItems", function () {
      var _this$props8 = _this.props;
          _this$props8.showViewButton;
          var onTriggerDownload = _this$props8.onTriggerDownload,
          workOrderNo = _this$props8.workOrder.workOrderNo;
          _this$props8.onClickViewButton;
      return /*#__PURE__*/React__default.createElement(ActionMenu, {
        iconList: [{
          toolTipClass: 'actionMenuTooltip',
          toolTip: 'More Actions',
          iconName: 'MoreHorizontalIcon',
          dropdown: [{
            text: I18n.t('work_orders.work_order.download'),
            onClick: function onClick() {
              return onTriggerDownload(workOrderNo);
            },
            hideMenuItem: false,
            icon: /*#__PURE__*/React__default.createElement(DownloadIcon, null)
          }]
        }]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderDownloadAction", function () {
      var _this$props9 = _this.props,
          onTriggerDownload = _this$props9.onTriggerDownload,
          workOrderNo = _this$props9.workOrder.workOrderNo;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BaseButton, {
        "data-tip": true,
        "data-for": "".concat(workOrderNo, "-download"),
        buttonType: BUTTON_TYPE.PRIMARY,
        buttonSize: SIZE.REGULAR,
        iconName: "DownloadIcon",
        onClick: onTriggerDownload(workOrderNo),
        className: "download-button"
      }), /*#__PURE__*/React__default.createElement(ReactTooltip, {
        class: "react-tooltip-custom",
        id: "".concat(workOrderNo, "-download"),
        place: "top",
        type: "dark",
        effect: "solid"
      }, "Download"));
    });

    _defineProperty(_assertThisInitialized(_this), "isPastDate", function (workOrder) {
      return _this.props.isPastDate(workOrder);
    });

    _defineProperty(_assertThisInitialized(_this), "getAppliances", function () {
      var _this$props10 = _this.props,
          isAdminPortal = _this$props10.isAdminPortal,
          _this$props10$account = _this$props10.account.user.appliances,
          appliances = _this$props10$account === void 0 ? [] : _this$props10$account;

      if (isAdminPortal) {
        var partner = _this.getPartnerByWorkOrderOrg();

        if (partner) return partner.appliances;
      }

      return appliances;
    });

    _defineProperty(_assertThisInitialized(_this), "renderCompositionList", function () {
      var _this$props11 = _this.props,
          enableFilters = _this$props11.enableFilters;
          _this$props11.isAdminPortal;
          var workOrder = _this$props11.workOrder,
          dcpTransferStatuses = _this$props11.dcpTransferStatuses,
          onChangeDcpTransferStatus = _this$props11.onChangeDcpTransferStatus,
          onUpdateDcpTransferStatusInServer = _this$props11.onUpdateDcpTransferStatusInServer,
          account = _this$props11.account,
          onFilterSelect = _this$props11.onFilterSelect,
          onDcpDownloadsStatusClick = _this$props11.onDcpDownloadsStatusClick;
      var workOrderStatusState = _this.state.workOrderStatusState;
      var enableDcpTransferStatusComponent = workOrderStatusState && workOrderStatusState.enableDcpTransferStatusComponent;
      return workOrder.compositions.map(function (composition, index) {
        return /*#__PURE__*/React__default.createElement(Composition, {
          enableFilters: enableFilters,
          account: account,
          workOrderNo: workOrder.workOrderNo,
          composition: composition,
          dcpTransferStatuses: dcpTransferStatuses,
          onChangeDcpTransferStatus: onChangeDcpTransferStatus,
          enableDcpTransferStatusComponent: enableDcpTransferStatusComponent,
          onUpdateDcpTransferStatusInServer: onUpdateDcpTransferStatusInServer,
          onFilterSelect: onFilterSelect,
          appliances: _this.getAppliances(),
          onDcpDownloadsStatusClick: onDcpDownloadsStatusClick
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAlertIconByStatus", function (status) {
      if (failedActionMsgList.includes(status)) return /*#__PURE__*/React__default.createElement(AlertFilledIcon, null); // By default return Info Icon

      return /*#__PURE__*/React__default.createElement(InfoFilledIcon, null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderActionRequired", function () {
      var workOrderStatusState = _this.state.workOrderStatusState;
      var _this$props12 = _this.props;
          _this$props12.showViewButton;
          var workOrder = _this$props12.workOrder;
          _this$props12.showDownload;

      var isPastDate = _this.isPastDate(workOrder);

      if (!workOrderStatusState || !failedActionMsgList.includes(workOrderStatusState === null || workOrderStatusState === void 0 ? void 0 : workOrderStatusState.displayStatus)) return null;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames('wo-card-action-required')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames(lowerCase(workOrderStatusState === null || workOrderStatusState === void 0 ? void 0 : workOrderStatusState.displayStatus).split(' ').join('_'), {
          'past-work-order-status-text': isPastDate
        })
      }, (workOrderStatusState === null || workOrderStatusState === void 0 ? void 0 : workOrderStatusState.displayStatus) && _this.getAlertIconByStatus(workOrderStatusState.displayStatus), /*#__PURE__*/React__default.createElement("span", null, (workOrderStatusState === null || workOrderStatusState === void 0 ? void 0 : workOrderStatusState.displayStatus) && workOrderStatusState.displayStatus)));
    });

    return _this;
  }

  _createClass(WorkOrderCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var workOrder = this.props.workOrder;
      this.setWorkOrderStatusState(workOrder);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var workOrder = nextProps.workOrder;

      if (workOrder.overallWorkOrderStatusChangedInServer) {
        this.setWorkOrderStatusState(workOrder);
        this.props.setOverallWorkOrderStatusUpdatedInServer(workOrder.workOrderNo, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props13 = this.props,
          showViewButton = _this$props13.showViewButton,
          workOrder = _this$props13.workOrder,
          showDownload = _this$props13.showDownload;
      this.state.workOrderStatusState;
      var isPastDate = this.isPastDate(workOrder);
      var _this$props$workOrder5 = this.props.workOrder,
          shipments = _this$props$workOrder5.shipments,
          workOrderNo = _this$props$workOrder5.workOrderNo;
      var deliveryType = shipments[0].deliveryType;
      return /*#__PURE__*/React__default.createElement("div", {
        id: workOrderNo,
        className: classNames('wo-card-container', {
          'past-order-card': isPastDate
        })
      }, this.renderActionRequired(), /*#__PURE__*/React__default.createElement("div", {
        className: "wo-card-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-icon"
      }, /*#__PURE__*/React__default.createElement(ReactTooltip, {
        class: "react-tooltip-custom",
        id: "".concat(workOrderNo, "-icon"),
        place: "top",
        type: "dark",
        effect: "solid"
      }, WorkOrderDeliveryLabel[deliveryType]), this.renderWorkOrderIcon()), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-info-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col-5 work-order-info"
      }, this.renderWorkOrderInfo()), /*#__PURE__*/React__default.createElement("div", {
        className: "col-5 work-order-delivery-info"
      }, this.renderWorkOrderDeliveryInfo()), /*#__PURE__*/React__default.createElement("div", {
        className: "col-2 action-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-view-action"
      }, showViewButton && this.renderViewAction()), /*#__PURE__*/React__default.createElement("div", {
        className: "action-item-list"
      }, showDownload && this.renderActionMenuItems())))), /*#__PURE__*/React__default.createElement("div", {
        className: "composition-details"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "composition-list"
      }, this.renderCompositionList()))));
    }
  }]);

  return WorkOrderCard;
}(Component);
WorkOrderCard.defaultProps = {
  onFilterSelect: null,
  showDownload: true,
  showCopyStatus: false,
  showViewButton: false,
  enableFilters: true
};

var TheatreLayout = function TheatreLayout(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "theatre-selection-card"
  }, props.children);
};

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var KDMTableContentItem = /*#__PURE__*/function (_Component) {
  _inherits(KDMTableContentItem, _Component);

  var _super = _createSuper$8(KDMTableContentItem);

  function KDMTableContentItem() {
    _classCallCheck(this, KDMTableContentItem);

    return _super.apply(this, arguments);
  }

  _createClass(KDMTableContentItem, [{
    key: "getKDMStatusDetails",
    value: function getKDMStatusDetails() {
      var theatre = this.props.theatre;
      var kdmScreens = theatre.screens && theatre.screens.filter(function (s) {
        return s.isKdmIssued;
      });
      var KDMStatus = theatre.kdms && theatre.kdms.map(function (kdm) {
        var id = kdm.id,
            validFrom = kdm.validFrom,
            validTill = kdm.validTill,
            _kdm$device = kdm.device,
            serial = _kdm$device.serial,
            manufacturer = _kdm$device.manufacturer,
            model = _kdm$device.model,
            screen = _kdm$device.screen,
            _kdm$status = kdm.status,
            type = _kdm$status.type,
            detail = _kdm$status.detail,
            subDetail = _kdm$status.subDetail,
            deliveryStatus = kdm.deliveryStatus;
        var statusType = type;
        var statusDetail = detail;
        var statusSubDetail = subDetail;
        var ingestStatus = '';

        if (type === KDMStatuses.emailed && !_$1.isEmpty(deliveryStatus) && !_$1.isEmpty(deliveryStatus.emails)) {
          statusDetail = deliveryStatus.emails.map(function (email) {
            return email.to;
          }).join(', ');
          statusSubDetail = '';
        }

        if (!_$1.isEmpty(deliveryStatus) && deliveryStatus.ingest && !_$1.isEmpty(deliveryStatus.ingest)) {
          ingestStatus = deliveryStatus.ingest.status;
        }

        return {
          model: model,
          serial: serial,
          manufacturer: manufacturer,
          kdmId: id,
          validFrom: validFrom,
          validTill: validTill,
          statusType: statusType,
          statusDetail: statusDetail,
          statusSubDetail: statusSubDetail,
          screenName: screen.name,
          screenId: screen.id,
          deliveryStatus: deliveryStatus,
          ingestStatus: ingestStatus
        };
      });
      kdmScreens && kdmScreens.forEach(function (s) {
        if (_$1.isEmpty(KDMStatus.find(function (d) {
          return d.screenId === s.id;
        }))) {
          KDMStatus.push({
            screenName: s.name,
            screenId: s.id,
            statusType: KDMStatuses.inprogress
          });
        }
      });
      return KDMStatus;
    }
  }, {
    key: "getStatusDetail",
    value: function getStatusDetail(statusType, statusDetail) {
      switch (statusType.toLowerCase()) {
        case KDMStatuses.emailed:
          return "to ".concat(statusDetail);

        case KDMStatuses.success:
          return null;

        default:
          return statusDetail;
      }
    }
  }, {
    key: "getDeviceInformation",
    value: function getDeviceInformation(deviceInfo) {
      var info = [];

      if (deviceInfo.manufacturer) {
        info.push(deviceInfo.manufacturer);
      }

      if (deviceInfo.model) {
        info.push(deviceInfo.model);
      }

      if (deviceInfo.serial) {
        info.push(deviceInfo.serial);
      }

      return info.join('::');
    }
  }, {
    key: "getDetail",
    value: function getDetail(KDMStatusDetails) {
      var _this = this;

      var timezone = this.props.theatre.timezone;
      return _$1.sortBy(KDMStatusDetails, ['screenName']).map(function (info, idx) {
        var subDetail = _this.getStatusDetail(info.statusType, info.statusDetail);

        return /*#__PURE__*/React__default.createElement(_Row, {
          key: idx,
          className: "kdm-table-content-detail qw-mt-x-small qw-pb-x-small qw-border-bottom"
        }, /*#__PURE__*/React__default.createElement(_Col, {
          span: 8,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "screen-name qw-font-size-small qw-color-text-body qw-line-height-small"
        }, info.screenName ? info.screenName : 'Standby Server'), /*#__PURE__*/React__default.createElement("p", {
          className: "screen-info qw-font-size-xx-small qw-color-text-body qw-line-height-xx-small"
        }, _this.getDeviceInformation(info))), /*#__PURE__*/React__default.createElement(_Col, {
          span: 7,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "kdm-details-status"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "kdm-summary__status ".concat(info.statusType.toLowerCase())
        }, I18n.t("kdm_statuses.".concat(info.statusType.toLowerCase()))), info.ingestStatus && /*#__PURE__*/React__default.createElement("p", {
          className: "kdm-summary__status ".concat(info.ingestStatus.toLowerCase())
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "status-meta__txt"
        }, "\u2022"), IngestStatusValues[info.ingestStatus.toLowerCase()])), /*#__PURE__*/React__default.createElement("p", {
          className: "status-detail qw-font-size-xx-small qw-color-text-body qw-line-height-xx-small qw-truncate qw-pr-x-small",
          title: subDetail
        }, subDetail)), /*#__PURE__*/React__default.createElement(_Col, {
          span: 9,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "validity qw-font-size-small qw-color-text-body qw-line-height-small"
        }, info.validFrom && info.validTill ? "".concat(formatDateTime(momentTZ.tz(info.validFrom, timezone)), " to ").concat(formatDateTime(momentTZ.tz(info.validTill, timezone))) : null)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var KDMStatusDetails = this.getKDMStatusDetails();
      return /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-table-content"
      }, this.getDetail(KDMStatusDetails));
    }
  }]);

  return KDMTableContentItem;
}(Component);

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var KDMInfo = /*#__PURE__*/function (_Component) {
  _inherits(KDMInfo, _Component);

  var _super = _createSuper$7(KDMInfo);

  function KDMInfo(props) {
    var _this;

    _classCallCheck(this, KDMInfo);

    _this = _super.call(this, props);
    _this.state = {
      sendKDMEmail: '',
      sendKDMEmailError: '',
      sendEmail: false,
      sendKDMEmailSuccess: ''
    };
    return _this;
  }

  _createClass(KDMInfo, [{
    key: "getBasicInfo",
    value: function getBasicInfo() {
      return /*#__PURE__*/React__default.createElement(_Row, null, /*#__PURE__*/React__default.createElement("p", {
        className: "composition-name-label qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "Composition Name"), /*#__PURE__*/React__default.createElement("p", {
        className: "composition-name qw-font-size-body qw-color-text-body qw-line-height-body qw-break-word qw-white-space-normal"
      }, this.props.composition.name));
    }
  }, {
    key: "getKDMTableHeader",
    value: function getKDMTableHeader() {
      return /*#__PURE__*/React__default.createElement(_Row, {
        className: "kdm-table-header qw-bold qw-mt-x-small qw-border-bottom qw-font-size-small qw-py-x-small qw-color-text-secondary-heading qw-font-weight-bold qw-line-height-small"
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 8,
        className: "qw-px-x-small"
      }, "Screen"), /*#__PURE__*/React__default.createElement(_Col, {
        span: 7,
        className: "qw-px-x-small"
      }, "Status"), /*#__PURE__*/React__default.createElement(_Col, {
        span: 9,
        className: "qw-px-x-small"
      }, "Validity"));
    }
  }, {
    key: "getKDMTableContent",
    value: function getKDMTableContent() {
      var _this$props = this.props,
          composition = _this$props.composition,
          theatre = _this$props.theatre;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-table-content-wrapper overflow-scroll"
      }, /*#__PURE__*/React__default.createElement(KDMTableContentItem, {
        theatre: theatre,
        composition: composition
      }));
    }
  }, {
    key: "getTheatreInfo",
    value: function getTheatreInfo() {
      var theatre = this.props.theatre;
      var totalScreenCount = !_$1.isEmpty(theatre.screens) ? theatre.screens.length : 0;
      var kdmScreenCount = !_$1.isEmpty(theatre.screens) ? theatre.screens.filter(function (s) {
        return s.isKdmIssued;
      }).length : 0;
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "Theatre"), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-body qw-color-text-body qw-line-height-body qw-break-word qw-white-space-normal"
      }, theatre.name), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-xx-small qw-line-height-xx-small"
      }, frameTheatreAddress(theatre)), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-xx-small qw-line-height-xx-small"
      }, "".concat(kdmScreenCount, "/").concat(totalScreenCount, " Screens")));
    }
  }, {
    key: "getKDMDeliveryEmail",
    value: function getKDMDeliveryEmail() {
      var kdmDeliveryMethods = this.props.theatre.kdmDeliveryMethods;
      var kdmDeliveryEmail = kdmDeliveryMethods && kdmDeliveryMethods.filter(function (method) {
        return method.type === 'Email';
      }).map(function (method) {
        return method.email;
      }).join(', ');
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "KDM Delivery Email"), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-body qw-color-text-body qw-line-height-body qw-break-word qw-white-space-normal"
      }, _$1.isEmpty(kdmDeliveryEmail) ? 'None' : kdmDeliveryEmail));
    }
  }, {
    key: "validateSendEmail",
    value: function validateSendEmail() {
      var sendKDMEmail = this.state.sendKDMEmail;

      if (_$1.isEmpty(sendKDMEmail.replace(/ /g, ''))) {
        this.setState({
          sendKDMEmailError: 'Atleast one email is required'
        });
        return false;
      }

      var emails = sendKDMEmail.replace(/ /g, '').split(',');
      var invalidEmails = emails.filter(function (email) {
        return !validator.isEmail(email);
      });

      if (invalidEmails.length) {
        this.setState({
          sendKDMEmailError: 'Invalid Email'.concat(" - ", invalidEmails.join(', '), " ")
        });
        return false;
      }

      return true;
    }
  }, {
    key: "sendKDMEmail",
    value: function sendKDMEmail() {
      var _this2 = this;

      this.setState({
        sendKDMEmailError: '',
        sendKDMEmailSuccess: ''
      });

      if (this.validateSendEmail()) {
        this.setState({
          sendEmail: true
        });
        var payload = {};
        var _this$props2 = this.props,
            _this$props2$composit = _this$props2.composition,
            compositionName = _this$props2$composit.name,
            compositionId = _this$props2$composit.id,
            theatre = _this$props2.theatre;
        payload.facility_id = theatre.id;
        payload.composition_names = [compositionName];
        payload.composition_ids = [compositionId];
        payload.earliest_kdm_validity = _$1.minBy(theatre.kdms, 'validFrom').validFrom;
        payload.latest_kdm_validity = _$1.minBy(theatre.kdms, 'validTill').validTill;
        payload.kdms = {};
        payload.email_addresses = {
          to: this.state.sendKDMEmail.replace(/ /g, '').split(',')
        };
        this.props.sendKDMEmail([compositionId], [theatre.id], payload, function (status) {
          _this2.setState({
            sendEmail: false,
            sendKDMEmailError: !status ? 'Error in sending KDM Email' : '',
            sendKDMEmailSuccess: status ? 'KDM Email\'s sent' : ''
          });
        });
      }
    }
  }, {
    key: "onChangeSendKDMEmail",
    value: function onChangeSendKDMEmail(e) {
      this.setState({
        sendKDMEmail: e.target.value,
        sendKDMEmailError: '',
        sendKDMEmailSuccess: ''
      });
    }
  }, {
    key: "hideKDMEmail",
    value: function hideKDMEmail(kdmGenerationCompleted, theatre, user) {
      return user.info.role_in_product.code === 'device manager' || !kdmGenerationCompleted || !theatre.kdms.find(function (kdm) {
        return [KDMStatuses.success, KDMStatuses.generated].includes(kdm.status.type.toLowerCase());
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          downloadKDMS = _this$props3.downloadKDMS,
          theatre = _this$props3.theatre;
      var _this$state = this.state,
          sendEmail = _this$state.sendEmail,
          sendKDMEmail = _this$state.sendKDMEmail,
          sendKDMEmailSuccess = _this$state.sendKDMEmailSuccess,
          sendKDMEmailError = _this$state.sendKDMEmailError;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-info"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "info-details-header"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-name-header-modal"
      }, this.getTheatreInfo()), /*#__PURE__*/React__default.createElement("div", {
        className: "composition-name-header-modal"
      }, this.getBasicInfo())), /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-delivery-info-modal"
      }, this.getKDMDeliveryEmail()), /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-option-modal"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-overview-modal"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-input-modal"
      }, /*#__PURE__*/React__default.createElement(_Input, {
        className: !_$1.isEmpty(sendKDMEmailError) ? 'qw-border-error' : '',
        value: sendKDMEmail,
        placeholder: "Enter Email Addresses",
        onChange: function onChange(e) {
          return _this3.onChangeSendKDMEmail(e);
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-status-modal"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-xx-small qw-line-height-xx-small qw-color-text-red qw-mt-xx-small"
      }, sendKDMEmailError), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-xx-small qw-line-height-xx-small qw-color-text-green qw-mt-xx-small"
      }, sendKDMEmailSuccess))), /*#__PURE__*/React__default.createElement("div", {
        className: "email-option-button-view"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-option"
      }, /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return _this3.sendKDMEmail();
        },
        className: "qw-cursor-pointer qw-flex qw-align-middle qw-justify-center"
      }, sendEmail ? /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "loader"
      }) : /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "email"
      }), /*#__PURE__*/React__default.createElement("p", {
        className: "email inline-block qw-font-size-small qw-line-height-small qw-mt-xx-small"
      }, "Email")))))), /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-option-view-modal"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-email-option"
      }, /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick() {
          return _this3.sendKDMEmail();
        },
        className: "qw-cursor-pointer qw-flex qw-align-middle qw-justify-center"
      }, sendEmail ? /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "loader"
      }) : /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "email"
      }), /*#__PURE__*/React__default.createElement("p", {
        className: "email inline-block qw-font-size-small qw-line-height-small qw-mt-xx-small"
      }, "Email")))), /*#__PURE__*/React__default.createElement("div", {
        className: "kdm-download-option"
      }, /*#__PURE__*/React__default.createElement("span", {
        onClick: function onClick() {
          return downloadKDMS(theatre.id);
        }
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        name: "download"
      }), /*#__PURE__*/React__default.createElement("p", {
        className: "download-summary inline-block qw-font-size-small qw-line-height-small qw-mt-xx-small"
      }, "Download"))))), /*#__PURE__*/React__default.createElement("div", null, this.getKDMTableHeader(), this.getKDMTableContent()));
    }
  }]);

  return KDMInfo;
}(Component);

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DCPTableContentItem = /*#__PURE__*/function (_Component) {
  _inherits(DCPTableContentItem, _Component);

  var _super = _createSuper$6(DCPTableContentItem);

  function DCPTableContentItem() {
    _classCallCheck(this, DCPTableContentItem);

    return _super.apply(this, arguments);
  }

  _createClass(DCPTableContentItem, [{
    key: "getDCPIngestStatus",
    value: function getDCPIngestStatus() {
      var theatre = this.props.theatre;
      var dcpAutoIngestStatus = theatre.dcpIngestDetails && theatre.dcpIngestDetails.map(function (dcpIngest) {
        var updatedAt = dcpIngest.updatedAt,
            _dcpIngest$device = dcpIngest.device,
            serial = _dcpIngest$device.serial,
            manufacturer = _dcpIngest$device.manufacturer,
            model = _dcpIngest$device.model,
            screen = _dcpIngest$device.screen,
            status = dcpIngest.status,
            completionPercentage = dcpIngest.completionPercentage;
        var ingestStatus = status;
        return {
          model: model,
          serial: serial,
          manufacturer: manufacturer,
          updatedAt: updatedAt,
          screenName: screen.name,
          screenId: screen.id,
          ingestStatus: ingestStatus,
          completionPercentage: completionPercentage
        };
      });
      return dcpAutoIngestStatus;
    }
  }, {
    key: "getDeviceInformation",
    value: function getDeviceInformation(deviceInfo) {
      var info = [];

      if (deviceInfo.manufacturer) {
        info.push(deviceInfo.manufacturer);
      }

      if (deviceInfo.model) {
        info.push(deviceInfo.model);
      }

      if (deviceInfo.serial) {
        info.push(deviceInfo.serial);
      }

      return info.join('::');
    }
  }, {
    key: "getDetail",
    value: function getDetail(dcpIngetStatus) {
      var _this = this;

      var timezone = this.props.theatre.timezone;
      return _$1.sortBy(dcpIngetStatus, ['screenName']).map(function (info, idx) {
        return /*#__PURE__*/React__default.createElement(_Row, {
          key: idx,
          className: "dcp-table-content-detail qw-mt-x-small qw-pb-x-small qw-border-bottom"
        }, /*#__PURE__*/React__default.createElement(_Col, {
          span: 8,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "screen-name qw-font-size-small qw-color-text-body qw-line-height-small"
        }, info.screenName ? info.screenName : 'Standby Server'), /*#__PURE__*/React__default.createElement("p", {
          className: "screen-info qw-font-size-xx-small qw-color-text-body qw-line-height-xx-small"
        }, _this.getDeviceInformation(info))), /*#__PURE__*/React__default.createElement(_Col, {
          span: 7,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "dcp-details-status"
        }, info.ingestStatus && /*#__PURE__*/React__default.createElement("p", {
          className: "dcp-summary__status ".concat(info.ingestStatus.toLowerCase())
        }, IngestStatusValues[info.ingestStatus.toLowerCase()]))), /*#__PURE__*/React__default.createElement(_Col, {
          span: 9,
          className: "qw-px-x-small"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "validity qw-font-size-small qw-color-text-body qw-line-height-small"
        }, info.ingestStatus && info.ingestStatus.toLowerCase() === 'ingested' && info.updatedAt && "Ingested on ".concat(formatDateTime(momentTZ.tz(info.updatedAt, timezone))), info.ingestStatus && info.ingestStatus.toLowerCase() === 'ingestinprogress' && info.completionPercentage && "Ingesting... ".concat(Math.round(info.completionPercentage * 100) / 100, "%"), info.ingestStatus && !info.updatedAt && !info.completionPercentage && '-')));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var dcpIngetStatus = this.getDCPIngestStatus();
      return /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-table-content"
      }, this.getDetail(dcpIngetStatus));
    }
  }]);

  return DCPTableContentItem;
}(Component);

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DCPInfo = /*#__PURE__*/function (_Component) {
  _inherits(DCPInfo, _Component);

  var _super = _createSuper$5(DCPInfo);

  function DCPInfo() {
    _classCallCheck(this, DCPInfo);

    return _super.apply(this, arguments);
  }

  _createClass(DCPInfo, [{
    key: "getBasicInfo",
    value: function getBasicInfo() {
      var _this$props = this.props,
          name = _this$props.composition.name,
          theatre = _this$props.theatre;
      var _theatre$dcp$details$ = theatre.dcp.details.shippingDetails;
      _theatre$dcp$details$ = _theatre$dcp$details$ === void 0 ? {} : _theatre$dcp$details$;
      var trackingId = _theatre$dcp$details$.trackingId,
          trackingName = _theatre$dcp$details$.name;
      var totalScreenCount = !_$1.isEmpty(theatre.screens) ? theatre.screens.length : 0;
      var ingestScreenCount = !_$1.isEmpty(theatre.screens) ? theatre.screens.filter(function (s) {
        return s.isDcpAutoIngest;
      }).length : 0;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-info-details qw-mb-large"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-theatre-info-status"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-name"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "Theatre"), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-body qw-color-text-body qw-line-height-body qw-white-space-normal"
      }, theatre.name), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-color-text-body qw-line-height-small qw-white-space-normal"
      }, frameTheatreAddress(theatre)), ingestScreenCount > 0 && /*#__PURE__*/React__default.createElement("p", {
        className: "dcp-ingest-meta"
      }, "Auto Inget in ".concat(ingestScreenCount, "/").concat(totalScreenCount, " Screens"))), /*#__PURE__*/React__default.createElement("div", {
        className: "tracking-info"
      }, trackingId && trackingName && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "Tracking Info"), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-body qw-color-text-body qw-line-height-body qw-white-space-normal"
      }, trackingName, " \u2022", trackingId)))), /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-info-composition-name qw-mb-large"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-small qw-line-height-small qw-color-text-secondary-heading qw-bold"
      }, "Composition Name"), /*#__PURE__*/React__default.createElement("p", {
        className: "qw-font-size-body qw-color-text-body qw-line-height-body qw-white-space-normal"
      }, name)));
    }
  }, {
    key: "renderShipmentStatuses",
    value: function renderShipmentStatuses(status) {
      var className = classNames('status-tag qw-mb-xxx-small', {
        'qw-warning': ShipmentStatuses.Pending === status,
        'qw-error': [ShipmentStatuses.AttemptFail, ShipmentStatuses.Exception].includes(status),
        'qw-success': ShipmentStatuses.Delivered === status,
        'qw-pending': [ShipmentStatuses.InfoReceived, ShipmentStatuses.InTransit, ShipmentStatuses.OutForDelivery].includes(status),
        'qw-waiting': ShipmentStatuses.Expired === status
      });
      return /*#__PURE__*/React__default.createElement(_Tag, {
        className: className
      }, ShipmentStatusValues[status.toLowerCase()]);
    }
  }, {
    key: "renderTimeline",
    value: function renderTimeline() {
      var _this = this;

      var _this$props$theatre$d = this.props.theatre.dcp.details.shippingDetails;
      _this$props$theatre$d = _this$props$theatre$d === void 0 ? {} : _this$props$theatre$d;
      var _this$props$theatre$d2 = _this$props$theatre$d.trackingInfo;
      _this$props$theatre$d2 = _this$props$theatre$d2 === void 0 ? {} : _this$props$theatre$d2;
      var _this$props$theatre$d3 = _this$props$theatre$d2.checkpoints,
          checkpoints = _this$props$theatre$d3 === void 0 ? [] : _this$props$theatre$d3;

      if (_$1.isEmpty(checkpoints)) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "qw-timeline"
      }, _$1.orderBy(checkpoints, ['checkpointTime'], ['desc']).map(function (checkpoint, idx) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: idx,
          className: classNames('qw-timeline-item', {
            current: !idx
          })
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "qw-timeline-left qw-font-size-small qw-line-height-small"
        }, /*#__PURE__*/React__default.createElement("p", {
          className: "qw-color-text-heading qw-mb-xx-small"
        }, _this.convertCheckPointDate(checkpoint.checkpointTime, _this.props.theatre.timezone)), /*#__PURE__*/React__default.createElement("p", {
          className: "qw-color-text-secondary-body"
        }, _this.convertCheckPointTime(checkpoint.checkpointTime, _this.props.theatre.timezone))), /*#__PURE__*/React__default.createElement("div", {
          className: "qw-timeline-right"
        }, _this.renderShipmentStatuses(checkpoint.tag), checkpoint.message && /*#__PURE__*/React__default.createElement("p", {
          className: "qw-color-grey-1"
        }, checkpoint.message)));
      }));
    }
  }, {
    key: "convertCheckPointDate",
    value: function convertCheckPointDate(checkpointTime, timezone) {
      if (momentTZ(checkpointTime, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid()) {
        return momentTZ(checkpointTime).tz(timezone).format('DD MMM YYYY');
      }

      var date = checkpointTime.includes('T') ? checkpointTime.split('T')[0] : checkpointTime;
      return momentTZ(date).endOf('day').format('DD MMM YYYY');
    }
  }, {
    key: "convertCheckPointTime",
    value: function convertCheckPointTime(checkpointTime, timezone) {
      if (momentTZ(checkpointTime, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid()) {
        return momentTZ(checkpointTime).tz(timezone).format('hh:mmA');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          composition = _this$props2.composition,
          theatre = _this$props2.theatre;
      !_$1.isEmpty(theatre.screens) ? theatre.screens.filter(function (s) {
        return s.isDcpAutoIngest;
      }).length : 0;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-info qw-mt-x-small"
      }, this.getBasicInfo(), this.renderTimeline(), /*#__PURE__*/React__default.createElement("div", {
        className: "ingest-status-container"
      }, /*#__PURE__*/React__default.createElement(_Row, {
        className: "ingest-table-header"
      }, /*#__PURE__*/React__default.createElement(_Col, {
        span: 8,
        className: "qw-px-x-small"
      }, "Screen"), /*#__PURE__*/React__default.createElement(_Col, {
        span: 7,
        className: "qw-px-x-small"
      }, "Status"), /*#__PURE__*/React__default.createElement(_Col, {
        span: 9,
        className: "qw-px-x-small"
      }, "Details")), /*#__PURE__*/React__default.createElement("div", {
        className: "dcp-table-content-wrapper"
      }, /*#__PURE__*/React__default.createElement(DCPTableContentItem, {
        theatre: theatre,
        composition: composition
      }))));
    }
  }]);

  return DCPInfo;
}(Component);

function getSelectedScreensCount(theatres) {
  var selectedScreensCount = 0;

  if (!theatres) {
    return selectedScreensCount;
  }

  theatres.forEach(function (theatre) {
    selectedScreensCount += _$1.filter(theatre.screens, function (sc) {
      return sc.selected;
    }).length;
  });
  return selectedScreensCount;
}

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TheatreSelection = /*#__PURE__*/function (_React$Component) {
  _inherits(TheatreSelection, _React$Component);

  var _super = _createSuper$4(TheatreSelection);

  function TheatreSelection(props) {
    var _this;

    _classCallCheck(this, TheatreSelection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchingFunction", function (value) {
      _this.setState({
        listViewFetching: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "refetchLoading", function (value) {
      _this.setState({
        layoutLoading: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createListModalOpen", function (value) {
      _this.setState({
        listError: null,
        createListModal: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "listRefetching", function (value) {
      _this.setState({
        refetchListView: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateAppComponent", function () {
      var selectedBookingList = _this.state.selectedBookingList;

      if (_this.props.selectedTheatresBooking) {
        _this.props.selectedTheatresBooking(selectedBookingList);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addTheatreToBooking", function (list) {
      console.log('list addTheatreToBooking', list);
      var tempList = _this.state.selectedBookingList;
      var theatreList = list[0];
      var itemIndex;

      if (_this.props.mode === 'exhibitor') {
        itemIndex = tempList.findIndex(function (item) {
          return item.uuid === theatreList.uuid;
        });
        theatreList.auditoriums && theatreList.auditoriums.map(function (item) {
          item.selected = true;
        });
      } else {
        itemIndex = tempList.findIndex(function (item) {
          return item.id === theatreList.id;
        });
        theatreList.screens && theatreList.screens.map(function (item) {
          item.selected = true;
        });
      }

      if (itemIndex > -1) {
        tempList.splice(itemIndex, 1);
      } else {
        tempList.push(theatreList);
      }

      _this.setState({
        selectedBookingList: tempList
      }, function () {
        return _this.updateAppComponent();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addTheatresToBookingByCsv", function (list) {
      var tempList = _this.state.selectedBookingList;
      var theatreList = list;
      var tempIndex;

      if (tempList.length) {
        theatreList.forEach(function (item) {
          tempList.forEach(function (theatre) {
            if (theatre.id === item.id) {
              tempIndex = _$1.findIndex(tempList, function (theatre) {
                return theatre.id == item.id;
              });
              tempList.splice(tempIndex, 1);
            }
          });
        });
        theatreList.forEach(function (theatre) {
          return tempList.push(theatre);
        });
      } else {
        theatreList.forEach(function (theatre) {
          return tempList.push(theatre);
        });
      }

      _this.setState({
        selectedBookingList: tempList
      });

      _this.updateAppComponent();
    });

    _defineProperty(_assertThisInitialized(_this), "handleScreenBooking", function (selectionIndex, screenIndex, selected, theatre, screen) {
      var tempList = _this.state.selectedBookingList;

      var theatreIndex = _$1.findIndex(tempList, function (th) {
        return th.id == theatre.id;
      });

      if (!_$1.isEmpty(tempList) && theatreIndex >= 0 && tempList[theatreIndex]) {
        tempList[theatreIndex].screens[screenIndex].selected = !selected;
        var hasSelected;
        tempList[theatreIndex].screens.forEach(function (item) {
          if (item.selected) {
            hasSelected = true;
          }
        });

        if (hasSelected) {
          _this.setState({
            selectedBookingList: tempList
          }, function () {
            return _this.updateAppComponent();
          });
        } else {
          tempList.splice(theatreIndex, 1);

          _this.setState({
            selectedBookingList: tempList
          }, function () {
            return _this.updateAppComponent();
          });
        }
      } else {
        var _tempList = _this.state.selectedBookingList;
        var tempScreen = theatre;
        tempScreen && tempScreen.screens.map(function (item) {
          if (item.id == screen.id) {
            item.selected = true;
          } else {
            item.selected = false;
          }
        });

        _tempList.push(tempScreen);

        _this.setState({
          selectedBookingList: _tempList
        }, function () {
          return _this.updateAppComponent();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddListToBooking", function (list) {
      var selectedBookingList = _this.state.selectedBookingList;
      var theatreList = list;

      if (selectedBookingList.length) {
        theatreList.forEach(function (item) {
          item.screens.forEach(function (item) {
            item.isInList && (item.selected = true);
          });
        });
        var contains = [];
        var addList = true;
        selectedBookingList.map(function (item) {
          theatreList.map(function (list) {
            if (item.id === list.id) {
              contains.push(list.id);
            }
          });
        });

        if (contains.length) {
          addList = false;
        }

        if (addList) {
          theatreList.map(function (item) {
            selectedBookingList.push(item);
          });

          _this.setState({
            selectedBookingList: selectedBookingList
          }, function () {
            return _this.updateAppComponent();
          });
        } else {
          theatreList.map(function (item, index) {
            selectedBookingList.map(function (list) {
              if (item.id === list.id) {
                var itemIndex = selectedBookingList.findIndex(function (item) {
                  return item.id === list.id;
                });

                if (itemIndex > -1) {
                  selectedBookingList.splice(itemIndex, 1);
                }
              }
            });
          });

          _this.setState({
            selectedBookingList: selectedBookingList
          }, function () {
            return _this.updateAppComponent();
          });
        }
      } else {
        theatreList.forEach(function (item) {
          item.screens.forEach(function (item) {
            item.isInList && (item.selected = true);
          });
        });
        theatreList.map(function (item) {
          selectedBookingList.push(item);
        });

        _this.setState({
          selectedBookingList: selectedBookingList
        }, function () {
          return _this.updateAppComponent();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createTheatreList", function (name) {
      var selectedBookingList = _this.state.selectedBookingList;
      var data = {};
      data.name = name;
      data.isPublic = false;
      data.theatres = selectedBookingList.map(function (theatre) {
        var obj = {};
        obj.id = theatre.id;
        var screens = theatre.screens.map(function (screen) {
          if (screen.selected) {
            return screen.id;
          }
        });
        screens = _$1.compact(screens);

        if (screens.length != theatre.screens.length) {
          obj.screens = screens;
        }

        return obj;
      });

      _this.setState({
        listPosting: true,
        listError: null
      }, function () {
        return _this.postCreateList(data);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "postCreateList", function (data) {
      var _this$props = _this.props,
          hostUrl = _this$props.hostUrl,
          accessToken = _this$props.accessToken;
      _this.state.currentTab;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      };
      axios.post("".concat(hostUrl, "/v1/theatrelists"), data, config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          this.listRefetching(true);
          this.setState({
            createListModal: false,
            listPosting: false
          });
          SuccessMessage('Theatres list created');
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        this.setState({
          listError: 'Theatre list name already exists',
          listPosting: false
        });
      }.bind(_assertThisInitialized(_this)));
    });

    _defineProperty(_assertThisInitialized(_this), "deteteTheatreList", function (listId, closeModal) {
      var _this$props2 = _this.props,
          hostUrl = _this$props2.hostUrl,
          accessToken = _this$props2.accessToken;
      _this.state.currentTab;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      };

      _this.setState({
        listPosting: true,
        listError: null
      });

      axios.delete("".concat(hostUrl, "/v1/theatrelists/").concat(listId), config).then(function (response) {
        if (response.status >= 200 && response.status <= 300) {
          SuccessMessage('Theatres list deleted');
          closeModal();
          this.listRefetching(true);
          this.setState({
            listPosting: false,
            listError: null
          });
        }
      }.bind(_assertThisInitialized(_this))).catch(function (error) {
        this.setState({
          listPosting: false
        });
        closeModal();
        ErrorMessage(error.data.message);
      }.bind(_assertThisInitialized(_this)));
    });

    _this.state = {
      currentTab: 'theatres',
      showMobileView: false,
      selectedBookingList: _this.props.theatresInBooking ? _this.props.theatresInBooking : [],
      listViewFetching: false,
      refetchListView: false,
      listPosting: false,
      listError: null,
      createListModal: false,
      layoutLoading: false
    };
    _this.changeTab = _this.changeTab.bind(_assertThisInitialized(_this));
    _this.updateDimensions = _this.updateDimensions.bind(_assertThisInitialized(_this));
    _this.fetchingFunction = _this.fetchingFunction.bind(_assertThisInitialized(_this));
    _this.deteteTheatreList = _this.deteteTheatreList.bind(_assertThisInitialized(_this));
    _this.clearTheatreList = _this.clearTheatreList.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TheatreSelection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateDimensions, true);
      this.updateDimensions();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.theatresInBooking !== this.props.theatresInBooking) {
        this.setState({
          selectedBookingList: this.props.theatresInBooking
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.actions) {
        this.props.actions.resetTheatres();
      }

      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions() {
      var mediaSizeValue = window.matchMedia('(max-width: 990px)');
      this.setState({
        showMobileView: mediaSizeValue.matches
      });
    }
  }, {
    key: "changeTab",
    value: function changeTab(item) {
      this.setState({
        currentTab: item.type
      });
    }
  }, {
    key: "onSelectDropDown",
    value: function onSelectDropDown(item) {
      this.setState({
        currentTab: item
      });
    }
  }, {
    key: "clearTheatreList",
    value: function clearTheatreList() {
      var _this2 = this;

      this.setState({
        selectedBookingList: []
      }, function () {
        return _this2.updateAppComponent();
      });
    }
  }, {
    key: "renderTabContent",
    value: function renderTabContent() {
      var _this$props3 = this.props,
          accessToken = _this$props3.accessToken,
          app = _this$props3.app,
          hostUrl = _this$props3.hostUrl,
          account = _this$props3.account,
          showAppBusy = _this$props3.showAppBusy,
          handleAppError = _this$props3.handleAppError,
          theatreUrl = _this$props3.theatreUrl,
          shouldShowUploadCSV = _this$props3.shouldShowUploadCSV,
          theatreSearchUrl = _this$props3.theatreSearchUrl,
          mode = _this$props3.mode;
      var _this$state = this.state,
          currentTab = _this$state.currentTab,
          selectedBookingList = _this$state.selectedBookingList,
          listViewFetching = _this$state.listViewFetching,
          refetchListView = _this$state.refetchListView,
          listPosting = _this$state.listPosting;
          _this$state.listError;

      if (currentTab === 'theatres') {
        return /*#__PURE__*/React__default.createElement(TheatresViewPage, {
          tabType: currentTab,
          hostUrl: hostUrl,
          theatreSearchUrl: theatreSearchUrl,
          accessToken: accessToken,
          theatresInBooking: selectedBookingList,
          addTheatreToBooking: this.addTheatreToBooking.bind(this),
          handleScreenBooking: this.handleScreenBooking.bind(this),
          addTheatre: function addTheatre() {
            return actions.pushPath('/theatres/add');
          },
          addTheatresToBooking: this.addTheatresToBookingByCsv,
          showAppBusy: showAppBusy,
          handleAppError: handleAppError,
          theatreUrl: theatreUrl,
          account: account,
          shouldShowUploadCSV: shouldShowUploadCSV,
          mode: mode
        });
      }

      if (this.state.currentTab === 'lists') {
        return /*#__PURE__*/React__default.createElement(ListsViewPage, {
          hostUrl: hostUrl,
          accessToken: accessToken,
          tabType: currentTab,
          theatresInBooking: selectedBookingList,
          addTheatreForBooking: this.handleAddListToBooking.bind(this),
          handleScreenBooking: this.handleScreenBooking.bind(this),
          fetchingFunction: this.fetchingFunction,
          listViewFetching: listViewFetching,
          refetchListView: refetchListView,
          deteteTheatreList: this.deteteTheatreList,
          listPosting: listPosting,
          appError: app && app.error,
          listRefetching: this.listRefetching
        });
      }

      if (this.state.currentTab === 'festivals') {
        return /*#__PURE__*/React__default.createElement(FestivalsView, {
          hostUrl: hostUrl,
          accessToken: accessToken,
          tabType: currentTab,
          theatresInBooking: selectedBookingList,
          addTheatreForBooking: this.handleAddListToBooking.bind(this),
          fetchingFunction: this.fetchingFunction,
          handleScreenBooking: this.handleScreenBooking.bind(this)
        });
      }
    }
  }, {
    key: "mobileSummaryButtonText",
    value: function mobileSummaryButtonText(selectedTheatres) {
      return selectedTheatres.length ? "".concat(selectedTheatres.length, " (").concat(getSelectedScreensCount(selectedTheatres), ")") : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props;
          _this$props4.actions;
          _this$props4.booking;
          var tabMenu = _this$props4.tabMenu;
          _this$props4.theatreLists;
          var hostUrl = _this$props4.hostUrl,
          accessToken = _this$props4.accessToken,
          showTheatreSelectionView = _this$props4.showTheatreSelectionView,
          setShowTheatreSelectionView = _this$props4.setShowTheatreSelectionView,
          title = _this$props4.title,
          mode = _this$props4.mode;
      var _this$state2 = this.state,
          currentTab = _this$state2.currentTab;
          _this$state2.searchText;
          _this$state2.selectionView;
          var showMobileView = _this$state2.showMobileView,
          selectedBookingList = _this$state2.selectedBookingList,
          listViewFetching = _this$state2.listViewFetching,
          listPosting = _this$state2.listPosting,
          listError = _this$state2.listError,
          createListModal = _this$state2.createListModal,
          layoutLoading = _this$state2.layoutLoading;

      if (showMobileView) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "theatres-page-overview-layout"
        }, showTheatreSelectionView ? /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-page-selection-side"
        }, layoutLoading && /*#__PURE__*/React__default.createElement("div", {
          style: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundColor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
          style: {
            fontSize: 32,
            color: '#084782'
          },
          spin: true
        })), /*#__PURE__*/React__default.createElement(TheatreLayout, null, /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-selection-card-overview"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-selection-card-tab-view-mobile"
        }, tabMenu.length ? /*#__PURE__*/React__default.createElement(DropDown, {
          placeholder: "Select Option",
          list: tabMenu,
          value: currentTab,
          width: "100px",
          onSelectDropDown: function onSelectDropDown(i) {
            return _this3.onSelectDropDown(i);
          }
        }) : /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-search-header title"
        }, /*#__PURE__*/React__default.createElement(HeaderText, {
          text: title
        })), /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-selection-card-tab-view-button"
        }, /*#__PURE__*/React__default.createElement(SelectButton, {
          clickEvent: function clickEvent() {
            return setShowTheatreSelectionView(!showTheatreSelectionView);
          },
          text: this.mobileSummaryButtonText(selectedBookingList),
          type: "theatre"
        }))), /*#__PURE__*/React__default.createElement("div", null, this.renderTabContent())))) : /*#__PURE__*/React__default.createElement("div", {
          className: "theatre-page-selection-side"
        }, layoutLoading && /*#__PURE__*/React__default.createElement("div", {
          style: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundColor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }
        }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
          style: {
            fontSize: 32,
            color: '#084782'
          },
          spin: true
        })), /*#__PURE__*/React__default.createElement(TheatreLayout, null, /*#__PURE__*/React__default.createElement(SelectedTheatres, {
          hostUrl: hostUrl,
          accessToken: accessToken,
          theatres: selectedBookingList,
          addTheatreForBooking: this.addTheatreToBooking.bind(this),
          handleScreenBooking: this.handleScreenBooking.bind(this),
          listViewFetching: listViewFetching,
          createTheatreList: this.createTheatreList,
          listPosting: listPosting,
          listError: listError,
          createListModal: createListModal,
          clearTheatreList: this.clearTheatreList,
          onChangeView: function onChangeView() {
            return setShowTheatreSelectionView(!showTheatreSelectionView);
          },
          createListModalOpen: this.createListModalOpen.bind(this),
          refetchLoading: this.refetchLoading.bind(this),
          listRefetching: this.listRefetching,
          mode: mode
        }))));
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "theatres-page-overview-layout"
      }, layoutLoading && /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/React__default.createElement(LoadingOutlined$1, {
        style: {
          fontSize: 32,
          color: '#084782'
        },
        spin: true
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-page-desktop-view"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-page-selection-side"
      }, /*#__PURE__*/React__default.createElement(TheatreLayout, null, /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-selection-card-overview"
      }, tabMenu.length ? /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-selection-card-tab-view"
      }, /*#__PURE__*/React__default.createElement(TabBar, {
        list: tabMenu,
        selectedTab: currentTab,
        onChange: this.changeTab.bind(this)
      })) : /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-search-header title"
      }, /*#__PURE__*/React__default.createElement(HeaderText, {
        text: title
      })), /*#__PURE__*/React__default.createElement("div", null, this.renderTabContent())))), /*#__PURE__*/React__default.createElement("div", {
        className: "theatre-page-selection-side"
      }, /*#__PURE__*/React__default.createElement(TheatreLayout, null, /*#__PURE__*/React__default.createElement(SelectedTheatres, {
        hostUrl: hostUrl,
        accessToken: accessToken,
        theatres: selectedBookingList,
        addTheatreForBooking: this.addTheatreToBooking.bind(this),
        handleScreenBooking: this.handleScreenBooking.bind(this),
        listViewFetching: listViewFetching,
        createTheatreList: this.createTheatreList,
        listPosting: listPosting,
        listError: listError,
        createListModal: createListModal,
        clearTheatreList: this.clearTheatreList,
        createListModalOpen: this.createListModalOpen.bind(this),
        refetchLoading: this.refetchLoading.bind(this),
        listRefetching: this.listRefetching,
        mode: mode
      })))));
    }
  }]);

  return TheatreSelection;
}(React__default.Component);
TheatreSelection.defaultProps = {
  tabMenu: [],
  title: 'Search & Select Theatres',
  theatreSearchUrl: 'v1/theatres/search',
  mode: 'non-exhibitor'
};

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ManageTags = /*#__PURE__*/function (_Component) {
  _inherits(ManageTags, _Component);

  var _super = _createSuper$3(ManageTags);

  function ManageTags() {
    _classCallCheck(this, ManageTags);

    return _super.apply(this, arguments);
  }

  _createClass(ManageTags, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rows = _this$props.rows,
          canEdit = _this$props.canEdit,
          fetchingData = _this$props.fetchingData,
          tagDetailsSavingStatus = _this$props.tagDetailsSavingStatus,
          errorWhileSavingTags = _this$props.errorWhileSavingTags;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "manage-tags__container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "manage-tags__header"
      }, /*#__PURE__*/React__default.createElement(SectionHeading, {
        content: "Composition Tags",
        size: "large"
      }), canEdit && /*#__PURE__*/React__default.createElement(CreateTagModal, {
        tagDetailsSavingStatus: tagDetailsSavingStatus,
        errorWhileSavingTags: errorWhileSavingTags,
        saveTagDetails: this.props.saveTagDetails
      })), /*#__PURE__*/React__default.createElement(TagsTable, {
        rows: rows,
        canEdit: canEdit,
        fetchingData: fetchingData,
        tagDetailsSavingStatus: tagDetailsSavingStatus,
        errorWhileSavingTags: errorWhileSavingTags,
        saveTagDetails: this.props.saveTagDetails
      }));
    }
  }]);

  return ManageTags;
}(Component);

ManageTags.defaultProps = {
  tagDetailsSavingStatus: false,
  errorWhileSavingTags: '',
  saveTagDetails: function saveTagDetails() {}
};

var utils = createCommonjsModule(function (module, exports) {
exports.__esModule = true;
exports.joinClassNames = void 0;
exports.joinClassNames = function () {
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classNames[_i] = arguments[_i];
    }
    return classNames.filter(function (c) { return c; }).join(' ');
};
});

var TextRow_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;


var TextRow = function (_a) {
    var className = _a.className, maxHeight = _a.maxHeight, color = _a.color, _b = _a.lineSpacing, lineSpacing = _b === void 0 ? '0.7em' : _b, style = _a.style;
    var defaultStyles = {
        maxHeight: maxHeight,
        width: '100%',
        height: '1em',
        backgroundColor: color,
        marginTop: lineSpacing
    };
    return (React__default.createElement("div", { className: utils.joinClassNames('text-row', className), style: __assign(__assign({}, defaultStyles), style) }));
};
exports["default"] = TextRow;
});

var RoundShape_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;


var RoundShape = function (_a) {
    var className = _a.className, style = _a.style, color = _a.color;
    var defaultStyles = {
        backgroundColor: color,
        borderRadius: '500rem',
        width: '100%',
        height: '100%'
    };
    return (React__default.createElement("div", { className: utils.joinClassNames('round-shape', className), style: __assign(__assign({}, defaultStyles), style) }));
};
exports["default"] = RoundShape;
});

var RectShape_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;


var RectShape = function (_a) {
    var className = _a.className, style = _a.style, color = _a.color;
    var defaultStyle = {
        backgroundColor: color,
        width: '100%',
        height: '100%',
        marginRight: 10
    };
    return (React__default.createElement("div", { className: utils.joinClassNames('rect-shape', className), style: __assign(__assign({}, defaultStyle), style) }));
};
exports["default"] = RectShape;
});

var TextBlock_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;



var defaultStyles = {
    width: '100%'
};
var defaultWidths = [97, 100, 94, 90, 98, 95, 98, 40];
var TextBlock = function (_a) {
    var rows = _a.rows, lineSpacing = _a.lineSpacing, color = _a.color, style = _a.style, className = _a.className, _b = _a.widths, widths = _b === void 0 ? defaultWidths : _b;
    var getRowStyle = function (i) {
        return {
            maxHeight: 100 / (rows * 2 - 1) + "%",
            width: widths[(i + widths.length) % widths.length] + "%"
        };
    };
    return (React__default.createElement("div", { className: utils.joinClassNames('text-block', className), style: __assign(__assign({}, defaultStyles), style) }, Array.apply(null, Array(rows)).map(function (_, i) { return (React__default.createElement(TextRow_1["default"], { color: color, style: getRowStyle(i), lineSpacing: i !== 0 ? lineSpacing : 0, key: i })); })));
};
exports["default"] = TextBlock;
});

var MediaBlock_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;




var defaultStyles = {
    display: 'flex'
};
var MediaBlock = function (_a) {
    var className = _a.className, style = _a.style, color = _a.color, rows = _a.rows;
    return (React__default.createElement("div", { className: utils.joinClassNames('media-block', className), style: __assign(__assign({}, defaultStyles), style) },
        React__default.createElement(RoundShape_1["default"], { color: color, style: { minHeight: 55, width: 55, minWidth: 55, marginRight: 10 } }),
        React__default.createElement(TextBlock_1["default"], { color: color, rows: rows })));
};
exports["default"] = MediaBlock;
});

var placeholders = createCommonjsModule(function (module, exports) {
exports.__esModule = true;
exports.media = exports.text = exports.rect = exports.round = exports.textRow = exports.MediaBlock = exports.TextBlock = exports.RectShape = exports.RoundShape = exports.TextRow = void 0;

exports.TextRow = TextRow_1["default"];

exports.RoundShape = RoundShape_1["default"];

exports.RectShape = RectShape_1["default"];

exports.TextBlock = TextBlock_1["default"];

exports.MediaBlock = MediaBlock_1["default"];
exports.textRow = TextRow_1["default"];
exports.round = RoundShape_1["default"];
exports.rect = RectShape_1["default"];
exports.text = TextBlock_1["default"];
exports.media = MediaBlock_1["default"];
});

var WorkOrderCardLoader = function WorkOrderCardLoader() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "panelLoader"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    color: "#cfdce6",
    style: {
      width: '70%',
      height: 30
    }
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    color: "#cfdce6",
    style: {
      width: '20%',
      height: 30
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '60%',
      height: 20
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    style: {
      width: '20%',
      height: 20
    },
    color: "#cfdce6"
  }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
    color: "#cfdce6",
    style: {
      width: '10%',
      height: 20
    }
  })), /*#__PURE__*/React__default.createElement(placeholders.TextRow, {
    color: "#cfdce6",
    style: {
      width: '80%'
    }
  }));
};

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DcpDownloadsDetailsDialog = /*#__PURE__*/function (_Component) {
  _inherits(DcpDownloadsDetailsDialog, _Component);

  var _super = _createSuper$2(DcpDownloadsDetailsDialog);

  function DcpDownloadsDetailsDialog(props) {
    var _this;

    _classCallCheck(this, DcpDownloadsDetailsDialog);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      if (_this.props.onCloseDownloadModal) _this.props.onCloseDownloadModal();
    });

    _defineProperty(_assertThisInitialized(_this), "renderDcpDownloadsDetails", function () {
      var dcpDownloadList = _this.state.dcpDownloadList;
      return (dcpDownloadList || []).map(function (dcpDownloadDetails) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "py1"
        }, _this.renderDcpDownloadStatus(dcpDownloadDetails));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderDcpDownloadStatus", function (dcpDownloadDetails) {
      var downloadDcpPercentage = 0;
      var messageColor = 'black';
      var downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.not_started');

      if (dcpDownloadDetails) {
        switch (dcpDownloadDetails.status) {
          case DcpDownloadStatuses.QUEUED:
            downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.queued');
            break;

          case DcpDownloadStatuses.SCHEDULED:
            downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.pending');
            break;

          case DcpDownloadStatuses.IN_PROGRESS:
            downloadDcpPercentage = dcpDownloadDetails.progress.toString();
            downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.in_progress', {
              downloadPercentage: downloadDcpPercentage.slice(0, downloadDcpPercentage.indexOf('.') + 3)
            });
            break;

          case DcpDownloadStatuses.DOWNLOADING:
            downloadDcpPercentage = dcpDownloadDetails.progress.toString();
            downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.in_progress', {
              downloadPercentage: downloadDcpPercentage.slice(0, downloadDcpPercentage.indexOf('.') + 3)
            });
            break;

          case DcpDownloadStatuses.COMPLETED:
            messageColor = 'green';
            downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.completed');
            break;

          case DcpDownloadStatuses.DOWNLOADED:
            messageColor = 'green';
            downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.completed');
            break;

          case DcpDownloadStatuses.FAILED:
            messageColor = 'red';
            downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.failed');
            break;

          case DcpDownloadStatuses.ERROR:
            messageColor = 'red';
            downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.error');
            break;

          case DcpDownloadStatuses.UNARCHIVING:
            messageColor = 'yellow';
            downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.downloading_unarchiving');
            break;

          case DcpDownloadStatuses.ARCHIVED:
            messageColor = 'yellow';
            downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.downloading_archived');
            break;

          case DcpDownloadStatuses.STALLED:
            messageColor = 'yellow';
            downloadDcpStatusMessage = I18n.t('work_orders.work_order.dcp_download_status.downloading_stalled');
            break;
        }
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "clearfix"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "col col-3"
      }, dcpDownloadDetails.serialNo), /*#__PURE__*/React__default.createElement("div", {
        className: "col col-9 ".concat(messageColor)
      }, downloadDcpStatusMessage));
    });

    _this.state = {
      visible: false,
      dcpDownloadList: []
    };
    return _this;
  }

  _createClass(DcpDownloadsDetailsDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        visible: this.props.visible,
        dcpDownloadList: this.props.dcpDownloadList
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.visible !== this.props.visible) {
        this.setState({
          visible: this.props.visible,
          dcpDownloadList: this.props.dcpDownloadList
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var visible = this.state.visible;
      var modalClassName = this.props.modalClassName;
      var dialogTitle = I18n.t('work_orders.work_order.dcp_download_status_details');
      return /*#__PURE__*/React__default.createElement(_Modal, {
        title: dialogTitle,
        wrapClassName: classNames('vertical-center-modal modal-large', modalClassName),
        visible: visible,
        onCancel: this.handleCancel,
        footer: null
      }, this.renderDcpDownloadsDetails());
    }
  }]);

  return DcpDownloadsDetailsDialog;
}(Component);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WorkOrderPage = /*#__PURE__*/function (_Component) {
  _inherits(WorkOrderPage, _Component);

  var _super = _createSuper$1(WorkOrderPage);

  function WorkOrderPage() {
    var _this;

    _classCallCheck(this, WorkOrderPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isDownloadModalOpen: false,
      dcpDownloadList: [],
      activeTab: _this.props.activeTab
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabChange", function (tabName) {
      _this.setState({
        activeTab: tabName
      });

      _this.props.onTabChange(tabName);
    });

    _defineProperty(_assertThisInitialized(_this), "onCloseDownloadModal", function () {
      _this.setState({
        isDownloadModalOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDcpDownloadsStatusClick", function (dcpDownloadList) {
      _this.setState({
        dcpDownloadList: dcpDownloadList,
        isDownloadModalOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "shouldShowCopyStatus", function () {
      var _this$props$account$u = _this.props.account.user,
          appliances = _this$props$account$u.appliances,
          partner = _this$props$account$u.partner;
      return !_.isEmpty(appliances) && partner.type === PartnerTypes.OFFLINE;
    });

    _defineProperty(_assertThisInitialized(_this), "isPastDate", function (workOrder) {
      var currentDate = Date.now();
      var currentUnixTime = moment(currentDate).unix();
      var inputDate = moment.utc(workOrder.deliverOn).startOf('day');
      var inputDateUnixTime = moment(inputDate).endOf('day').unix();
      var itemsFilter = _this.props.itemsFilter;
      return itemsFilter === WorkOrderItemsFilterValues.CURRENT && currentUnixTime - inputDateUnixTime > 0;
    });

    _defineProperty(_assertThisInitialized(_this), "getWorkOrderTabs", function () {
      return [{
        id: WorkOrderTypes.CURRENT,
        title: 'Active'
      }, {
        id: WorkOrderTypes.PAST,
        title: 'Past'
      }];
    });

    _defineProperty(_assertThisInitialized(_this), "hasPastWorkOrders", function () {
      var workOrders = _this.props.workOrders;
      return workOrders.some(_this.isPastDate);
    });

    _defineProperty(_assertThisInitialized(_this), "renderWorkOrderList", function () {
      var _this$props = _this.props,
          showCopyStatus = _this$props.showCopyStatus,
          enableFilters = _this$props.enableFilters,
          workOrders = _this$props.workOrders,
          partners = _this$props.partners,
          dcpTransferStatuses = _this$props.dcpTransferStatuses,
          updateDcpTransferStatusInServer = _this$props.updateDcpTransferStatusInServer,
          onView = _this$props.onView,
          account = _this$props.account,
          isAdminPortal = _this$props.isAdminPortal,
          offlinePartnersWithAppliance = _this$props.offlinePartnersWithAppliance,
          onFilterSelect = _this$props.onFilterSelect,
          onTriggerDownload = _this$props.onTriggerDownload,
          itemsFilter = _this$props.itemsFilter,
          changeDcpTransferStatus = _this$props.changeDcpTransferStatus,
          showDcpDownloadsStatusDetails = _this$props.showDcpDownloadsStatusDetails,
          setOverallWorkOrderStatusUpdatedInServer = _this$props.setOverallWorkOrderStatusUpdatedInServer;

      if (workOrders.length === 0) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "h4 center no-work-order"
        }, I18n.t('work_orders.no_work_orders', {
          workOrderItemsType: _this.props.workOrderItemsType
        }));
      }

      return workOrders.map(function (workOrder, index) {
        return /*#__PURE__*/React__default.createElement(WorkOrderCard, {
          key: index,
          index: index,
          partners: partners,
          workOrder: workOrder,
          dcpTransferStatuses: dcpTransferStatuses,
          changeDcpTransferStatus: changeDcpTransferStatus,
          updateDcpTransferStatusInServer: updateDcpTransferStatusInServer,
          setOverallWorkOrderStatusUpdatedInServer: setOverallWorkOrderStatusUpdatedInServer,
          enableFilters: enableFilters,
          onView: onView,
          account: account,
          isAdminPortal: isAdminPortal,
          offlinePartnersWithAppliance: offlinePartnersWithAppliance,
          onFilterSelect: onFilterSelect,
          onTriggerDownload: onTriggerDownload,
          itemsFilter: itemsFilter,
          isPastDate: _this.isPastDate,
          shouldShowCopyStatus: _this.shouldShowCopyStatus,
          showCopyStatus: showCopyStatus,
          showDcpDownloadsStatusDetails: showDcpDownloadsStatusDetails,
          onDcpDownloadsStatusClick: _this.onDcpDownloadsStatusClick
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFilterTags", function () {
      var filterTags = [];

      var _loop = function _loop(key) {
        if (key === WorkOrderItemsFilterTagKeys.COMPOSITION) {
          _this.props.filterTags[key].map(function (value) {
            return filterTags.push({
              id: value,
              name: value,
              type: I18n.t('work_orders.filter_tag_labels')[key],
              filterType: key,
              displayName: value
            });
          });
        } else {
          filterTags.push({
            id: _this.props.filterTags[key],
            name: _this.props.filterTags[key],
            type: I18n.t('work_orders.filter_tag_labels')[key],
            filterType: key,
            displayName: _this.props.filterTags[key]
          });
        }
      };

      for (var key in _this.props.filterTags) {
        _loop(key);
      }

      return /*#__PURE__*/React__default.createElement(FilterChips$1, {
        showResultsCount: false,
        selected: filterTags,
        resultsCount: _this.props.workOrderCount,
        onFilterChange: function onFilterChange(updateFilters) {
          return _this.props.removeFilterTag(updateFilters);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderControls", function () {
      var _this$props2 = _this.props,
          pageSizeList = _this$props2.pageSizeList,
          pageSize = _this$props2.pageSize,
          onPageSizeChange = _this$props2.onPageSizeChange;
          _this$props2.hasMoreData;
      return [{
        id: 'pageSizeControl',
        component: function component() {
          return /*#__PURE__*/React__default.createElement(Selector, {
            onSelect: onPageSizeChange,
            selectedList: [pageSize],
            list: pageSizeList,
            showLabelInButton: false,
            label: 'Show',
            singleSelect: true,
            closeOnSelect: true,
            noSelectedIcon: false,
            defaultIsOpen: false,
            usePortal: false
          });
        }
      }];
    });

    _defineProperty(_assertThisInitialized(_this), "renderTableControls", function () {
      var _this$props3 = _this.props,
          showSearchBar = _this$props3.showSearchBar,
          workOrders = _this$props3.workOrders;
          _this$props3.dataReceived;
          var workOrderCount = _this$props3.workOrderCount,
          pageSize = _this$props3.pageSize,
          currentPage = _this$props3.currentPage,
          pageNeighbors = _this$props3.pageNeighbors,
          searchInputProps = _this$props3.searchInputProps,
          onPageChange = _this$props3.onPageChange,
          filterTags = _this$props3.filterTags,
          onClearSearchText = _this$props3.onClearSearchText,
          simplePagination = _this$props3.simplePagination,
          hasMoreData = _this$props3.hasMoreData;

      var searchInputData = _objectSpread({}, searchInputProps);

      return /*#__PURE__*/React__default.createElement("div", {
        className: "tableControlsWrapper"
      }, /*#__PURE__*/React__default.createElement(TableControls$1, {
        searchBar: showSearchBar,
        pagination: workOrders.length > 0,
        showFilterButton: false,
        columnFilter: false,
        inputWithSelection: false,
        pageSize: pageSize,
        currentPage: currentPage,
        searchType: SEARCH_TAG_TYPES.INPUT_SEARCH,
        totalResults: parseInt(workOrderCount),
        searchInputProps: showSearchBar ? searchInputData : null,
        pageNeighbors: pageNeighbors,
        onRowSizeChange: onPageChange,
        simplePagination: simplePagination,
        hasMoreData: hasMoreData,
        onSearchClear: onClearSearchText,
        controls: _this.renderControls()
      }), !isEmpty$1(filterTags) && /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-filter-chips"
      }, _this.renderFilterTags()));
    });

    _defineProperty(_assertThisInitialized(_this), "renderWorkOrderContainer", function () {
      var _this$props4 = _this.props;
          _this$props4.showSearchBar;
          var workOrders = _this$props4.workOrders,
          dataReceived = _this$props4.dataReceived,
          workOrderCount = _this$props4.workOrderCount,
          pageSize = _this$props4.pageSize,
          currentPage = _this$props4.currentPage,
          pageNeighbors = _this$props4.pageNeighbors;
          _this$props4.searchInputProps;
          var _onPageChange = _this$props4.onPageChange;
          _this$props4.filterTags;
          var simplePagination = _this$props4.simplePagination,
          hasMoreData = _this$props4.hasMoreData;
      if (!dataReceived) return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-table-controls-loader"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        style: {
          width: '60%',
          height: 24
        },
        color: "#cfdce6"
      }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        style: {
          width: '20%',
          height: 24
        },
        color: "#cfdce6"
      }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        color: "#cfdce6",
        style: {
          width: '10%',
          height: 24
        }
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-data-list"
      }, /*#__PURE__*/React__default.createElement(WorkOrderCardLoader, null), /*#__PURE__*/React__default.createElement(WorkOrderCardLoader, null), /*#__PURE__*/React__default.createElement(WorkOrderCardLoader, null), /*#__PURE__*/React__default.createElement(WorkOrderCardLoader, null)), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-footer"
      }, /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        style: {
          width: '70%',
          height: 24
        },
        color: "#cfdce6"
      }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        style: {
          width: '20%',
          height: 24
        },
        color: "#cfdce6"
      }), /*#__PURE__*/React__default.createElement(placeholders.RectShape, {
        color: "#cfdce6",
        style: {
          width: '10%',
          height: 24
        }
      })));
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, _this.renderTableControls(), /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-data-list"
      }, _this.renderWorkOrderList()), workOrders.length > 0 && /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-footer"
      }, /*#__PURE__*/React__default.createElement(TablePagination$1, {
        pageSize: pageSize,
        currentPage: currentPage,
        totalRecords: parseInt(workOrderCount),
        pageNeighbors: pageNeighbors,
        simplePagination: simplePagination,
        hasMoreData: hasMoreData,
        onPageChange: function onPageChange(v) {
          return _onPageChange(currentPage, v);
        }
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderViewSwitchComponent", function () {
      var activeTab = _this.state.activeTab;
      return /*#__PURE__*/React__default.createElement(ViewSwitch, {
        label: "View as",
        buttons: [{
          id: WorkOrderTypes.CURRENT,
          buttonText: 'Current',
          onClick: function onClick() {
            return activeTab !== WorkOrderTypes.CURRENT ? _this.handleTabChange(WorkOrderTypes.CURRENT) : null;
          },
          isActive: activeTab === WorkOrderTypes.CURRENT
        }, {
          id: WorkOrderTypes.PAST,
          buttonText: 'Past',
          onClick: function onClick() {
            return activeTab !== WorkOrderTypes.PAST ? _this.handleTabChange(WorkOrderTypes.PAST) : null;
          },
          isActive: activeTab === WorkOrderTypes.PAST
        }]
      });
    });

    return _this;
  }

  _createClass(WorkOrderPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.activeTab !== this.props.activeTab) {
        this.setState({
          activeTab: this.props.activeTab
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props;
          _this$props5.workOrders;
          var workOrderCount = _this$props5.workOrderCount,
          dataReceived = _this$props5.dataReceived,
          isAdminPortal = _this$props5.isAdminPortal,
          hasMoreData = _this$props5.hasMoreData;
      var _this$state = this.state,
          isDownloadModalOpen = _this$state.isDownloadModalOpen,
          dcpDownloadList = _this$state.dcpDownloadList;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-page"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "work-order-header"
      }, /*#__PURE__*/React__default.createElement(Header$1, {
        name: "Work Orders",
        isPartialLoading: !dataReceived,
        count: workOrderCount,
        renderRightSideComponent: function renderRightSideComponent() {
          return _this2.renderViewSwitchComponent();
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: classNames('work-order-body-container', {
          adminBodyContainer: isAdminPortal,
          noMoreData: !hasMoreData
        })
      }, this.renderWorkOrderContainer()), /*#__PURE__*/React__default.createElement(DcpDownloadsDetailsDialog, {
        visible: isDownloadModalOpen,
        onCloseDownloadModal: this.onCloseDownloadModal,
        dcpDownloadList: dcpDownloadList
      }));
    }
  }]);

  return WorkOrderPage;
}(Component);
WorkOrderPage.defaultProps = {
  showSearchBar: true,
  showViewButton: false,
  enableFilters: true,
  showCopyStatus: true
};

var getUniqueTheatres = function getUniqueTheatres(compositions) {
  var uniqTheatres = [];
  compositions.forEach(function (cpl) {
    var dkdmList = cpl.dkdms || [];
    dkdmList.forEach(function (dkdm) {
      if (dkdm.theatre && dkdm.theatre.length > 0) uniqTheatres.push.apply(uniqTheatres, _toConsumableArray(dkdm.theatre));
      if (dkdm.theatres && dkdm.theatres.length > 0) uniqTheatres.push.apply(uniqTheatres, _toConsumableArray(dkdm.theatres));
    });
  });
  return uniqTheatres;
};

var getCompositionKdmStatus = function getCompositionKdmStatus(compositionData, options) {
  var compositionKdmStatus = {
    successfulScreenCount: 0,
    deliveredScreenCount: 0,
    queuedScreenCount: 0,
    failedScreenCount: 0,
    regeneratedCount: 0,
    pendingApprovalScreenCount: 0
  };
  if (!compositionData) return compositionKdmStatus;
  var cplList = isArray$2(compositionData) ? compositionData : [compositionData];
  var uniqTheatres = getUniqueTheatres(cplList) || [];
  uniqTheatres.forEach(function (theatre) {
    var screens = theatre.screens || [];
    screens.forEach(function (screen) {
      if (screen.status) {
        var regeneratedKdms = theatre.screens.filter(function (theatreScreen) {
          return theatreScreen.kdmRegenerated === true && (!options.skipVisitedCheck ? theatreScreen.visited === false : true) && theatreScreen.id === screen.id;
        });

        if (!isEmpty(regeneratedKdms)) {
          compositionKdmStatus.regeneratedCount += 1;
        }

        switch (screen.status.toLowerCase()) {
          case SUCCESS:
            if (options.deliverToTheatres && !isEmpty(screen.deliveryStatus)) {
              compositionKdmStatus.deliveredScreenCount += 1;
            } else {
              compositionKdmStatus.successfulScreenCount += 1;
            }

            break;

          case PENDING_APPROVAL:
            compositionKdmStatus.pendingApprovalScreenCount += 1;
            break;

          case QUEUED:
            compositionKdmStatus.queuedScreenCount += 1;
            break;

          case FAILED:
            compositionKdmStatus.failedScreenCount += 1;
            break;
        }
      }
    });
  });
  return compositionKdmStatus;
};

/**
 * Class with functions for Parsing Search Queries
 *
 * @class SearchQueryparser
 */
var SearchQueryParser = /*#__PURE__*/function () {
  /**
   * sets the variables in searchquery Parser
   *
   * @param searchQuery:string
   * @param filterTagEnum:string
   * @param processFilterPair :any
   * @param filterRegex :any
   */
  function SearchQueryParser(searchQuery, filterTagEnum, processFilterPair) {
    var filterRegex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : /(\w+:(([a-zA-Z0-9_-]+)|".*?"))/g;

    _classCallCheck(this, SearchQueryParser);

    _defineProperty(this, "searchQuery", void 0);

    _defineProperty(this, "filterTagEnum", void 0);

    _defineProperty(this, "processFilterPair", void 0);

    _defineProperty(this, "filterRegex", void 0);

    _defineProperty(this, "key", void 0);

    _defineProperty(this, "value", void 0);

    this.searchQuery = searchQuery;
    this.filterTagEnum = filterTagEnum;
    this.processFilterPair = processFilterPair;
    this.filterRegex = filterRegex;
  }
  /**
   * Function to sanitize the Search Query by trimming and replacing punctuation marks
   *
   * @returns {string} returns the sanitized search query value
   */


  _createClass(SearchQueryParser, [{
    key: "sanitizeSearchQuery",
    value: function sanitizeSearchQuery() {
      return this.searchQuery.trim().replace(/((\s)+:)/g, ':').replace(/(:(\s)+)/g, ':');
    }
    /**
     * Based on the Search Query the filter tags are seperated and identified
     *
     * @param sanitizedSearchQuery
     * @returns {search:string,filter:object} - returns the filter tags and searchquery removing the filter tags from it
     */

  }, {
    key: "getFiltersFromSearchQuery",
    value: function getFiltersFromSearchQuery(sanitizedSearchQuery) {
      var filterTags = {};
      var filterPair = {
        key: null,
        value: null
      };
      var match = this.filterRegex.exec(sanitizedSearchQuery);

      while (match != null) {
        filterPair = this.getFilterPair(match);
        if (!filterPair) return false;
        var _filterPair = filterPair,
            key = _filterPair.key,
            value = _filterPair.value;
        filterTags = this.processFilterPair ? this.processFilterPair(filterPair, filterTags) : Object.assign(filterTags, _defineProperty({}, key, value));
        match = this.filterRegex.exec(sanitizedSearchQuery);
      }

      return {
        search: this.removeFilterFromSearchQuery(sanitizedSearchQuery),
        filter: filterTags
      };
    }
    /**
     * checks for the given filter if present sends true or false if there is a match
     *
     *
     * @param match
     * @returns {boolean}
     */

  }, {
    key: "getFilterPair",
    value: function getFilterPair(match) {
      var filterTagParts = match[0].split(':');
      return this.validateFilterKey(filterTagParts[0]) ? {
        key: filterTagParts[0],
        value: filterTagParts[1].replace(/"/g, '')
      } : false;
    }
    /**
     * gets the filter key as param and returs the validation
     * @param filterKey
     * @returns {boolean}
     */

  }, {
    key: "validateFilterKey",
    value: function validateFilterKey(filterKey) {
      var _this = this;

      return Object.keys(this.filterTagEnum).map(function (filterKey) {
        return _this.filterTagEnum[filterKey];
      }).includes(filterKey);
    }
    /**
     * Removes the filter from the search query
     *
     * @param searchQuery
     * @returns {string}
     */

  }, {
    key: "removeFilterFromSearchQuery",
    value: function removeFilterFromSearchQuery(searchQuery) {
      return searchQuery.replace(this.filterRegex, '').replace(/\s\s+/g, ' ').trim();
    }
    /**
     *  if the : is present returns the filters if not returns the string
     * @returns {object|string}
     */

  }, {
    key: "execute",
    value: function execute() {
      if (this.searchQuery.includes(':')) {
        return this.getFiltersFromSearchQuery(this.sanitizeSearchQuery());
      } else {
        return {
          search: this.searchQuery
        };
      }
    }
  }]);

  return SearchQueryParser;
}();

var FilterChips = function FilterChips(props) {
  return /*#__PURE__*/React__default.createElement(FilterChips$1, props);
};

var FilterSection = function FilterSection(props) {
  return /*#__PURE__*/React__default.createElement(FilterSection$1, props);
};

var MultiSelectInput = function MultiSelectInput(props) {
  return /*#__PURE__*/React__default.createElement(MultiSelectInput$1, props);
};

MultiSelectInput.defaultProps = {
  customSubTextName: function customSubTextName(item) {
    return FilterLabels[item.type];
  },
  customMenuName: function customMenuName(item) {
    return item.displayName;
  }
};

var TableControls = function TableControls(props) {
  return /*#__PURE__*/React__default.createElement(TableControls$1, props);
};

var RightPanel = function RightPanel(props) {
  return /*#__PURE__*/React__default.createElement(RightPanel$1, props);
};

var _excluded = ["placeholder", "filterType", "label", "componentType", "suggestionList", "selectedItems"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RightFilterPanel = /*#__PURE__*/function (_Component) {
  _inherits(RightFilterPanel, _Component);

  var _super = _createSuper(RightFilterPanel);

  function RightFilterPanel() {
    _classCallCheck(this, RightFilterPanel);

    return _super.apply(this, arguments);
  }

  _createClass(RightFilterPanel, [{
    key: "renderFilterSectionType",
    value: function renderFilterSectionType(componentType) {
      if (componentType === ComponentTypes.list) return FILTER_TAG_TYPES.LIST;else if (componentType === ComponentTypes.multiselect) return FILTER_TAG_TYPES.MULTI_SELECT_SEARCH;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          header = _this$props.header,
          isOpen = _this$props.isOpen,
          showFilterIcon = _this$props.showFilterIcon,
          showClearAll = _this$props.showClearAll,
          onClickClearAll = _this$props.onClickClearAll,
          onClose = _this$props.onClose,
          _this$props$actions = _this$props.actions,
          addItemToFilter = _this$props$actions.addItemToFilter,
          handleQueryChange = _this$props$actions.handleQueryChange,
          removeItemFromFilter = _this$props$actions.removeItemFromFilter,
          resetFilterData = _this$props$actions.resetFilterData,
          clearSearchText = _this$props$actions.clearSearchText,
          handleListFilter = _this$props$actions.handleListFilter,
          filterList = _this$props.filterList;
      return /*#__PURE__*/React__default.createElement(RightPanel, {
        header: header,
        isOpen: isOpen,
        onClose: onClose,
        showFilterIcon: showFilterIcon,
        showClearAll: showClearAll,
        onClickClearAll: onClickClearAll
      }, filterList.map(function (filter) {
        var _extends2;

        var placeholder = filter.placeholder,
            filterType = filter.filterType,
            label = filter.label,
            componentType = filter.componentType,
            suggestionList = filter.suggestionList,
            selectedItems = filter.selectedItems,
            rest = _objectWithoutProperties(filter, _excluded);

        return /*#__PURE__*/React__default.createElement(FilterSection, _extends((_extends2 = {
          resetOnSelect: true,
          tagInputProps: {
            placeholder: placeholder,
            value: ''
          },
          inputValueRenderer: function inputValueRenderer(item) {
            return item.name;
          },
          header: label,
          tagType: filterType,
          filterType: _this.renderFilterSectionType(componentType),
          tagList: suggestionList,
          suggestionList: suggestionList,
          selected: selectedItems,
          onFilterChange: function onFilterChange(item) {
            return handleListFilter(item, filterType);
          },
          onFilterClear: function onFilterClear() {
            return resetFilterData(filterType);
          },
          onItemSelect: function onItemSelect(item) {
            return addItemToFilter(item, filterType);
          },
          onQueryChange: function onQueryChange(text, event) {
            return handleQueryChange(text, filterType, event);
          },
          onRemove: function onRemove(item) {
            return removeItemFromFilter(item, filterType);
          }
        }, _defineProperty(_extends2, "onFilterClear", function onFilterClear() {
          return resetFilterData(filterType);
        }), _defineProperty(_extends2, "onSearchClear", function onSearchClear() {
          return clearSearchText(filterType);
        }), _extends2), rest));
      }));
    }
  }]);

  return RightFilterPanel;
}(Component);

export { AppIcon, ApplianceTable, Checkbox, CheckboxFilter, ClearTag, CompositionCardTags, CompositionInfoModal, CreateTagModal, CursorPagination, DCPInfo, DefaultDatePicker, DefaultRangePicker, DefaultTable, DefaultTabs, DefaultTag, DeleteButton, DeleteModal, Description, DropDown as Dropdown, EditTagModal, EmptyHandler, ErrorMessage, FestivalsView, FilterChips, FilterPanel, FilterSection, FilterTag, FilterTags, GroupsDetailTheatreTable, GroupsTable, Header, HeaderText, HeaderWithTabs, HelpText, IconButton, InputBox, InputLabel, KDMInfo, Label, ListCard, ListsViewPage, ManageTags, MapTagsDropdown, MultiSelectInput, PageDefaultHeader, PageHeading, PrimaryButton, QubeIcons, RightFilterPanel, RightPanel, SaveTagModal, ScreensList, SearchButton, SearchFilter, SearchMenu, SearchBox as Searchbox, SecondaryButton, SectionHeading, SelectButton, SelectText, SelectedHeader, SelectedTheatres, Status, SuccessMessage, TabBar, TabItem, TableControls, TablePagination, TagsDropdownMenu, TagsTable, TextArea, TextLinks, TextWithIconLinks, TheatreAddress, TheatreCard, TheatreDefaultCard, TheatreDefaultInfo, TheatreDefaultMeta, TheatreLayout, TheatreName, TheatrePrice, TheatreSelection, TheatresViewPage, Title, UsersTable, WarnHeading, WorkOrderCard, WorkOrderCplStatus, WorkOrderPage as WorkOrders, bandwidthCalculator, enums, getCompositionKdmStatus, getCplInfo, getKDMSummaryData, renderDCPStatusSummary, renderIngestStatusSummary, renderKDMStatusSummary, SearchQueryParser as searchQueryParser, getWorkOrderStatusState as workOrderStatusState };
//# sourceMappingURL=index.esm.js.map
